/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Binary data encoded using Base64 */
  Base64EncodedBinary: { input: any; output: any; }
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: { input: string; output: string; }
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: { input: string; output: string; }
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: { input: any; output: any; }
  /** A calendar date in YYYY-MM-DD format. */
  Date: { input: any; output: any; }
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) and, if it has a timezone, [RFC
   * 3339](https://datatracker.ietf.org/doc/html/rfc3339) standards. Input values
   * that do not conform to both ISO 8601 and RFC 3339 may be coerced, which may lead
   * to unexpected results.
   */
  Datetime: { input: string; output: string; }
  /** Represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Account = Node & {
  __typename?: 'Account';
  /** Reads and enables pagination through a set of `AccountCreationDepositChannel`. */
  accountCreationDepositChannelsByCreatedAccountId: AccountCreationDepositChannelsConnection;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsByAccountId: AccountFundingEventsConnection;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsByRebalanceCounterpartyId: AccountFundingEventsConnection;
  alias?: Maybe<Scalars['String']['output']>;
  boundRedeemAddress?: Maybe<Scalars['String']['output']>;
  /** Reads a single `Broker` that is related to this `Account`. */
  brokerByAccountId?: Maybe<Broker>;
  /** Reads and enables pagination through a set of `Broker`. */
  brokersByAccountId: BrokersConnection;
  /** Reads and enables pagination through a set of `DelegationActivity`. */
  delegationActivitiesByDelegatorAccountId: DelegationActivitiesConnection;
  /** Reads and enables pagination through a set of `Extrinsic`. */
  extrinsicsBySubmitterId: ExtrinsicsConnection;
  id: Scalars['Int']['output'];
  idHex: Scalars['String']['output'];
  idSs58: Scalars['String']['output'];
  /** Reads a single `LatestDelegationReward` that is related to this `Account`. */
  latestDelegationRewardByDelegatorAccountId?: Maybe<LatestDelegationReward>;
  /** Reads and enables pagination through a set of `LatestDelegationReward`. */
  latestDelegationRewardsByDelegatorAccountId: LatestDelegationRewardsConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosByBorrowerId: LiquidationSwapInfosConnection;
  /** Reads a single `LiquidityProvider` that is related to this `Account`. */
  liquidityProviderByAccountId?: Maybe<LiquidityProvider>;
  /** Reads and enables pagination through a set of `LiquidityProvider`. */
  liquidityProvidersByAccountId: LiquidityProvidersConnection;
  /** Reads and enables pagination through a set of `NetworkParticipantEarningsDaily`. */
  networkParticipantEarningsDailiesByAccountId: NetworkParticipantEarningsDailiesConnection;
  /** Reads and enables pagination through a set of `NetworkParticipantEarningsHourly`. */
  networkParticipantEarningsHourliesByAccountId: NetworkParticipantEarningsHourliesConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OnChainSwapInfo`. */
  onChainSwapInfosByAccountId: OnChainSwapInfosConnection;
  /** Reads and enables pagination through a set of `OperatorAction`. */
  operatorActionsByAccountId: OperatorActionsConnection;
  /** Reads a single `Operator` that is related to this `Account`. */
  operatorByAccountId?: Maybe<Operator>;
  /** Reads and enables pagination through a set of `OperatorEpochDelegation`. */
  operatorEpochDelegationsByDelegatorAccountId: OperatorEpochDelegationsConnection;
  /** Reads and enables pagination through a set of `Operator`. */
  operatorsByAccountId: OperatorsConnection;
  role: AccountRole;
  /** Reads and enables pagination through a set of `SwapChannelBeneficiary`. */
  swapChannelBeneficiariesByAccountId: SwapChannelBeneficiariesConnection;
  /** Reads and enables pagination through a set of `SwapRequestBeneficiary`. */
  swapRequestBeneficiariesByAccountId: SwapRequestBeneficiariesConnection;
  /** Reads a single `Validator` that is related to this `Account`. */
  validatorByAccountId?: Maybe<Validator>;
  /** Reads and enables pagination through a set of `Validator`. */
  validatorsByAccountId: ValidatorsConnection;
};


export type AccountAccountCreationDepositChannelsByCreatedAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCreationDepositChannelCondition>;
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCreationDepositChannelsOrderBy>>;
};


export type AccountAccountFundingEventsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type AccountAccountFundingEventsByRebalanceCounterpartyIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type AccountBrokersByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerCondition>;
  filter?: InputMaybe<BrokerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokersOrderBy>>;
};


export type AccountDelegationActivitiesByDelegatorAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationActivityCondition>;
  filter?: InputMaybe<DelegationActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationActivitiesOrderBy>>;
};


export type AccountExtrinsicsBySubmitterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExtrinsicCondition>;
  filter?: InputMaybe<ExtrinsicFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicsOrderBy>>;
};


export type AccountLatestDelegationRewardsByDelegatorAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LatestDelegationRewardCondition>;
  filter?: InputMaybe<LatestDelegationRewardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LatestDelegationRewardsOrderBy>>;
};


export type AccountLiquidationSwapInfosByBorrowerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type AccountLiquidityProvidersByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderCondition>;
  filter?: InputMaybe<LiquidityProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProvidersOrderBy>>;
};


export type AccountNetworkParticipantEarningsDailiesByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NetworkParticipantEarningsDailyCondition>;
  filter?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NetworkParticipantEarningsDailiesOrderBy>>;
};


export type AccountNetworkParticipantEarningsHourliesByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NetworkParticipantEarningsHourlyCondition>;
  filter?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NetworkParticipantEarningsHourliesOrderBy>>;
};


export type AccountOnChainSwapInfosByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OnChainSwapInfoCondition>;
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OnChainSwapInfosOrderBy>>;
};


export type AccountOperatorActionsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorActionCondition>;
  filter?: InputMaybe<OperatorActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorActionsOrderBy>>;
};


export type AccountOperatorEpochDelegationsByDelegatorAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationCondition>;
  filter?: InputMaybe<OperatorEpochDelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationsOrderBy>>;
};


export type AccountOperatorsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorCondition>;
  filter?: InputMaybe<OperatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorsOrderBy>>;
};


export type AccountSwapChannelBeneficiariesByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelBeneficiaryCondition>;
  filter?: InputMaybe<SwapChannelBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelBeneficiariesOrderBy>>;
};


export type AccountSwapRequestBeneficiariesByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestBeneficiaryCondition>;
  filter?: InputMaybe<SwapRequestBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestBeneficiariesOrderBy>>;
};


export type AccountValidatorsByAccountIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};

export type AccountAggregates = {
  __typename?: 'AccountAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountVarianceSampleAggregates>;
};

export type AccountAverageAggregates = {
  __typename?: 'AccountAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Account` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AccountCondition = {
  /** Checks for equality with the object’s `alias` field. */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `idHex` field. */
  idHex?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `idSs58` field. */
  idSs58?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<AccountRole>;
};

export type AccountCreationDepositChannel = Node & {
  __typename?: 'AccountCreationDepositChannel';
  /** Reads a single `Account` that is related to this `AccountCreationDepositChannel`. */
  accountByCreatedAccountId: Account;
  /** Reads a single `AccountFundingEvent` that is related to this `AccountCreationDepositChannel`. */
  accountFundingEventByAccountCreationDepositChannelId?: Maybe<AccountFundingEvent>;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsByAccountCreationDepositChannelId: AccountFundingEventsConnection;
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `AccountCreationDepositChannel`. */
  blockByIssuedBlockId: Block;
  /** Reads a single `Broker` that is related to this `AccountCreationDepositChannel`. */
  brokerByBrokerId: Broker;
  brokerId: Scalars['Int']['output'];
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['output'];
  createdAccountId: Scalars['Int']['output'];
  depositAddress: Scalars['String']['output'];
  depositChainExpiryBlock: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `AccountCreationDepositChannel`. */
  eventByIssuedEventId: Event;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByAccountCreationDepositChannelId: FailedDepositsConnection;
  id: Scalars['Int']['output'];
  isExpired: Scalars['Boolean']['output'];
  issuedBlockId: Scalars['Int']['output'];
  issuedBlockTimestamp: Scalars['Datetime']['output'];
  issuedEventId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByAccountCreationDepositChannelId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  liquidityDepositsByAccountCreationDepositChannelId: LiquidityDepositsConnection;
  maxBoostFeeBps: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openingFeePaid: Scalars['BigFloat']['output'];
  refundAddress: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByAccountCreationDepositChannelId: SwapRequestsConnection;
};


export type AccountCreationDepositChannelAccountFundingEventsByAccountCreationDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type AccountCreationDepositChannelFailedDepositsByAccountCreationDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type AccountCreationDepositChannelLiquidityBalanceEventsByAccountCreationDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type AccountCreationDepositChannelLiquidityDepositsByAccountCreationDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};


export type AccountCreationDepositChannelSwapRequestsByAccountCreationDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type AccountCreationDepositChannelAggregates = {
  __typename?: 'AccountCreationDepositChannelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountCreationDepositChannelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountCreationDepositChannelDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountCreationDepositChannelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountCreationDepositChannelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountCreationDepositChannelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountCreationDepositChannelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountCreationDepositChannelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountCreationDepositChannelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountCreationDepositChannelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountCreationDepositChannel` object types. */
export type AccountCreationDepositChannelAggregatesFilter = {
  /** Mean average aggregate over matching `AccountCreationDepositChannel` objects. */
  average?: InputMaybe<AccountCreationDepositChannelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountCreationDepositChannel` objects. */
  distinctCount?: InputMaybe<AccountCreationDepositChannelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountCreationDepositChannel` object to be included within the aggregate. */
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Maximum aggregate over matching `AccountCreationDepositChannel` objects. */
  max?: InputMaybe<AccountCreationDepositChannelMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountCreationDepositChannel` objects. */
  min?: InputMaybe<AccountCreationDepositChannelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountCreationDepositChannel` objects. */
  stddevPopulation?: InputMaybe<AccountCreationDepositChannelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountCreationDepositChannel` objects. */
  stddevSample?: InputMaybe<AccountCreationDepositChannelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountCreationDepositChannel` objects. */
  sum?: InputMaybe<AccountCreationDepositChannelSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountCreationDepositChannel` objects. */
  variancePopulation?: InputMaybe<AccountCreationDepositChannelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountCreationDepositChannel` objects. */
  varianceSample?: InputMaybe<AccountCreationDepositChannelVarianceSampleAggregateFilter>;
};

export type AccountCreationDepositChannelAverageAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigFloatFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelAverageAggregates = {
  __typename?: 'AccountCreationDepositChannelAverageAggregates';
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountCreationDepositChannel` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AccountCreationDepositChannelCondition = {
  accountByCreatedAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByIssuedBlockId?: InputMaybe<Scalars['ID']['input']>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `createdAccountId` field. */
  createdAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `depositChainExpiryBlock` field. */
  depositChainExpiryBlock?: InputMaybe<Scalars['BigInt']['input']>;
  eventByIssuedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isExpired` field. */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `issuedBlockTimestamp` field. */
  issuedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundAddress` field. */
  refundAddress?: InputMaybe<Scalars['String']['input']>;
};

export type AccountCreationDepositChannelDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  createdAccountId?: InputMaybe<BigIntFilter>;
  depositAddress?: InputMaybe<BigIntFilter>;
  depositChainExpiryBlock?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isExpired?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedBlockTimestamp?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigIntFilter>;
  refundAddress?: InputMaybe<BigIntFilter>;
};

export type AccountCreationDepositChannelDistinctCountAggregates = {
  __typename?: 'AccountCreationDepositChannelDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAddress across the matching connection */
  depositAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isExpired across the matching connection */
  isExpired?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundAddress across the matching connection */
  refundAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AccountCreationDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type AccountCreationDepositChannelFilter = {
  /** Filter by the object’s `accountByCreatedAccountId` relation. */
  accountByCreatedAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountFundingEventByAccountCreationDepositChannelId` relation. */
  accountFundingEventByAccountCreationDepositChannelId?: InputMaybe<AccountFundingEventFilter>;
  /** A related `accountFundingEventByAccountCreationDepositChannelId` exists. */
  accountFundingEventByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountCreationDepositChannelFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByIssuedBlockId` relation. */
  blockByIssuedBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAccountId` field. */
  createdAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `depositChainExpiryBlock` field. */
  depositChainExpiryBlock?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByIssuedEventId` relation. */
  eventByIssuedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `failedDepositsByAccountCreationDepositChannelId` relation. */
  failedDepositsByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelToManyFailedDepositFilter>;
  /** Some related `failedDepositsByAccountCreationDepositChannelId` exist. */
  failedDepositsByAccountCreationDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isExpired` field. */
  isExpired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `issuedBlockTimestamp` field. */
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityBalanceEventsByAccountCreationDepositChannelId` relation. */
  liquidityBalanceEventsByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelToManyLiquidityBalanceEventFilter>;
  /** Some related `liquidityBalanceEventsByAccountCreationDepositChannelId` exist. */
  liquidityBalanceEventsByAccountCreationDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositsByAccountCreationDepositChannelId` relation. */
  liquidityDepositsByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelToManyLiquidityDepositFilter>;
  /** Some related `liquidityDepositsByAccountCreationDepositChannelId` exist. */
  liquidityDepositsByAccountCreationDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Filter by the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountCreationDepositChannelFilter>>;
  /** Filter by the object’s `refundAddress` field. */
  refundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `swapRequestsByAccountCreationDepositChannelId` relation. */
  swapRequestsByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelToManySwapRequestFilter>;
  /** Some related `swapRequestsByAccountCreationDepositChannelId` exist. */
  swapRequestsByAccountCreationDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `AccountCreationDepositChannel` for usage during aggregation. */
export type AccountCreationDepositChannelGroupBy =
  | 'ASSET'
  | 'BROKER_ID'
  | 'CHAIN'
  | 'CHANNEL_ID'
  | 'CREATED_ACCOUNT_ID'
  | 'DEPOSIT_ADDRESS'
  | 'DEPOSIT_CHAIN_EXPIRY_BLOCK'
  | 'ISSUED_BLOCK_ID'
  | 'ISSUED_BLOCK_TIMESTAMP'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'ISSUED_EVENT_ID'
  | 'IS_EXPIRED'
  | 'MAX_BOOST_FEE_BPS'
  | 'OPENING_FEE_PAID'
  | 'REFUND_ADDRESS';

export type AccountCreationDepositChannelHavingAverageInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingDistinctCountInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `AccountCreationDepositChannel` aggregates. */
export type AccountCreationDepositChannelHavingInput = {
  AND?: InputMaybe<Array<AccountCreationDepositChannelHavingInput>>;
  OR?: InputMaybe<Array<AccountCreationDepositChannelHavingInput>>;
  average?: InputMaybe<AccountCreationDepositChannelHavingAverageInput>;
  distinctCount?: InputMaybe<AccountCreationDepositChannelHavingDistinctCountInput>;
  max?: InputMaybe<AccountCreationDepositChannelHavingMaxInput>;
  min?: InputMaybe<AccountCreationDepositChannelHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountCreationDepositChannelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountCreationDepositChannelHavingStddevSampleInput>;
  sum?: InputMaybe<AccountCreationDepositChannelHavingSumInput>;
  variancePopulation?: InputMaybe<AccountCreationDepositChannelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountCreationDepositChannelHavingVarianceSampleInput>;
};

export type AccountCreationDepositChannelHavingMaxInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingMinInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingStddevPopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingStddevSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingSumInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingVariancePopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelHavingVarianceSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  createdAccountId?: InputMaybe<HavingIntFilter>;
  depositChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountCreationDepositChannelMaxAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  createdAccountId?: InputMaybe<IntFilter>;
  depositChainExpiryBlock?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelMaxAggregates = {
  __typename?: 'AccountCreationDepositChannelMaxAggregates';
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCreationDepositChannelMinAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  createdAccountId?: InputMaybe<IntFilter>;
  depositChainExpiryBlock?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelMinAggregates = {
  __typename?: 'AccountCreationDepositChannelMinAggregates';
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCreationDepositChannelStddevPopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigFloatFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelStddevPopulationAggregates = {
  __typename?: 'AccountCreationDepositChannelStddevPopulationAggregates';
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCreationDepositChannelStddevSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigFloatFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelStddevSampleAggregates = {
  __typename?: 'AccountCreationDepositChannelStddevSampleAggregates';
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCreationDepositChannelSumAggregateFilter = {
  brokerId?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigIntFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelSumAggregates = {
  __typename?: 'AccountCreationDepositChannelSumAggregates';
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of channelId across the matching connection */
  channelId: Scalars['BigFloat']['output'];
  /** Sum of createdAccountId across the matching connection */
  createdAccountId: Scalars['BigInt']['output'];
  /** Sum of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of issuedBlockId across the matching connection */
  issuedBlockId: Scalars['BigInt']['output'];
  /** Sum of issuedEventId across the matching connection */
  issuedEventId: Scalars['BigFloat']['output'];
  /** Sum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of openingFeePaid across the matching connection */
  openingFeePaid: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type AccountCreationDepositChannelToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type AccountCreationDepositChannelToManyLiquidityBalanceEventFilter = {
  /** Aggregates across related `LiquidityBalanceEvent` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityBalanceEventAggregatesFilter>;
  /** Every related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityBalanceEventFilter>;
  /** No related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Some related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityBalanceEventFilter>;
};

/** A filter to be used against many `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type AccountCreationDepositChannelToManyLiquidityDepositFilter = {
  /** Aggregates across related `LiquidityDeposit` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositAggregatesFilter>;
  /** Every related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositFilter>;
  /** No related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositFilter>;
  /** Some related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type AccountCreationDepositChannelToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type AccountCreationDepositChannelVariancePopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigFloatFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelVariancePopulationAggregates = {
  __typename?: 'AccountCreationDepositChannelVariancePopulationAggregates';
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountCreationDepositChannelVarianceSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  createdAccountId?: InputMaybe<BigFloatFilter>;
  depositChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
};

export type AccountCreationDepositChannelVarianceSampleAggregates = {
  __typename?: 'AccountCreationDepositChannelVarianceSampleAggregates';
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of createdAccountId across the matching connection */
  createdAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositChainExpiryBlock across the matching connection */
  depositChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AccountCreationDepositChannel` values. */
export type AccountCreationDepositChannelsConnection = {
  __typename?: 'AccountCreationDepositChannelsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountCreationDepositChannelAggregates>;
  /** A list of edges which contains the `AccountCreationDepositChannel` and cursor to aid in pagination. */
  edges: Array<AccountCreationDepositChannelsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountCreationDepositChannelAggregates>>;
  /** A list of `AccountCreationDepositChannel` objects. */
  nodes: Array<AccountCreationDepositChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountCreationDepositChannel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountCreationDepositChannel` values. */
export type AccountCreationDepositChannelsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountCreationDepositChannelGroupBy>;
  having?: InputMaybe<AccountCreationDepositChannelHavingInput>;
};

/** A `AccountCreationDepositChannel` edge in the connection. */
export type AccountCreationDepositChannelsEdge = {
  __typename?: 'AccountCreationDepositChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountCreationDepositChannel` at the end of the edge. */
  node: AccountCreationDepositChannel;
};

/** Methods to use when ordering `AccountCreationDepositChannel`. */
export type AccountCreationDepositChannelsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'CHANNEL_ID_ASC'
  | 'CHANNEL_ID_DESC'
  | 'CREATED_ACCOUNT_ID_ASC'
  | 'CREATED_ACCOUNT_ID_DESC'
  | 'DEPOSIT_ADDRESS_ASC'
  | 'DEPOSIT_ADDRESS_DESC'
  | 'DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ISSUED_BLOCK_ID_ASC'
  | 'ISSUED_BLOCK_ID_DESC'
  | 'ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ISSUED_EVENT_ID_ASC'
  | 'ISSUED_EVENT_ID_DESC'
  | 'IS_EXPIRED_ASC'
  | 'IS_EXPIRED_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'MAX_BOOST_FEE_BPS_ASC'
  | 'MAX_BOOST_FEE_BPS_DESC'
  | 'NATURAL'
  | 'OPENING_FEE_PAID_ASC'
  | 'OPENING_FEE_PAID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFUND_ADDRESS_ASC'
  | 'REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC';

export type AccountDistinctCountAggregates = {
  __typename?: 'AccountDistinctCountAggregates';
  /** Distinct count of alias across the matching connection */
  alias?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boundRedeemAddress across the matching connection */
  boundRedeemAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idHex across the matching connection */
  idHex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of idSs58 across the matching connection */
  idSs58?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Account` object types. All fields are combined with a logical ‘and.’ */
export type AccountFilter = {
  /** Filter by the object’s `accountCreationDepositChannelsByCreatedAccountId` relation. */
  accountCreationDepositChannelsByCreatedAccountId?: InputMaybe<AccountToManyAccountCreationDepositChannelFilter>;
  /** Some related `accountCreationDepositChannelsByCreatedAccountId` exist. */
  accountCreationDepositChannelsByCreatedAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountFundingEventsByAccountId` relation. */
  accountFundingEventsByAccountId?: InputMaybe<AccountToManyAccountFundingEventFilter>;
  /** Some related `accountFundingEventsByAccountId` exist. */
  accountFundingEventsByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountFundingEventsByRebalanceCounterpartyId` relation. */
  accountFundingEventsByRebalanceCounterpartyId?: InputMaybe<AccountToManyAccountFundingEventFilter>;
  /** Some related `accountFundingEventsByRebalanceCounterpartyId` exist. */
  accountFundingEventsByRebalanceCounterpartyIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `alias` field. */
  alias?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `boundRedeemAddress` field. */
  boundRedeemAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `brokerByAccountId` relation. */
  brokerByAccountId?: InputMaybe<BrokerFilter>;
  /** A related `brokerByAccountId` exists. */
  brokerByAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `delegationActivitiesByDelegatorAccountId` relation. */
  delegationActivitiesByDelegatorAccountId?: InputMaybe<AccountToManyDelegationActivityFilter>;
  /** Some related `delegationActivitiesByDelegatorAccountId` exist. */
  delegationActivitiesByDelegatorAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `extrinsicsBySubmitterId` relation. */
  extrinsicsBySubmitterId?: InputMaybe<AccountToManyExtrinsicFilter>;
  /** Some related `extrinsicsBySubmitterId` exist. */
  extrinsicsBySubmitterIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `idHex` field. */
  idHex?: InputMaybe<StringFilter>;
  /** Filter by the object’s `idSs58` field. */
  idSs58?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestDelegationRewardByDelegatorAccountId` relation. */
  latestDelegationRewardByDelegatorAccountId?: InputMaybe<LatestDelegationRewardFilter>;
  /** A related `latestDelegationRewardByDelegatorAccountId` exists. */
  latestDelegationRewardByDelegatorAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapInfosByBorrowerId` relation. */
  liquidationSwapInfosByBorrowerId?: InputMaybe<AccountToManyLiquidationSwapInfoFilter>;
  /** Some related `liquidationSwapInfosByBorrowerId` exist. */
  liquidationSwapInfosByBorrowerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityProviderByAccountId` relation. */
  liquidityProviderByAccountId?: InputMaybe<LiquidityProviderFilter>;
  /** A related `liquidityProviderByAccountId` exists. */
  liquidityProviderByAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `networkParticipantEarningsDailiesByAccountId` relation. */
  networkParticipantEarningsDailiesByAccountId?: InputMaybe<AccountToManyNetworkParticipantEarningsDailyFilter>;
  /** Some related `networkParticipantEarningsDailiesByAccountId` exist. */
  networkParticipantEarningsDailiesByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `networkParticipantEarningsHourliesByAccountId` relation. */
  networkParticipantEarningsHourliesByAccountId?: InputMaybe<AccountToManyNetworkParticipantEarningsHourlyFilter>;
  /** Some related `networkParticipantEarningsHourliesByAccountId` exist. */
  networkParticipantEarningsHourliesByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `onChainSwapInfosByAccountId` relation. */
  onChainSwapInfosByAccountId?: InputMaybe<AccountToManyOnChainSwapInfoFilter>;
  /** Some related `onChainSwapInfosByAccountId` exist. */
  onChainSwapInfosByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorActionsByAccountId` relation. */
  operatorActionsByAccountId?: InputMaybe<AccountToManyOperatorActionFilter>;
  /** Some related `operatorActionsByAccountId` exist. */
  operatorActionsByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorByAccountId` relation. */
  operatorByAccountId?: InputMaybe<OperatorFilter>;
  /** A related `operatorByAccountId` exists. */
  operatorByAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochDelegationsByDelegatorAccountId` relation. */
  operatorEpochDelegationsByDelegatorAccountId?: InputMaybe<AccountToManyOperatorEpochDelegationFilter>;
  /** Some related `operatorEpochDelegationsByDelegatorAccountId` exist. */
  operatorEpochDelegationsByDelegatorAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<AccountRoleFilter>;
  /** Filter by the object’s `swapChannelBeneficiariesByAccountId` relation. */
  swapChannelBeneficiariesByAccountId?: InputMaybe<AccountToManySwapChannelBeneficiaryFilter>;
  /** Some related `swapChannelBeneficiariesByAccountId` exist. */
  swapChannelBeneficiariesByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestBeneficiariesByAccountId` relation. */
  swapRequestBeneficiariesByAccountId?: InputMaybe<AccountToManySwapRequestBeneficiaryFilter>;
  /** Some related `swapRequestBeneficiariesByAccountId` exist. */
  swapRequestBeneficiariesByAccountIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `validatorByAccountId` relation. */
  validatorByAccountId?: InputMaybe<ValidatorFilter>;
  /** A related `validatorByAccountId` exists. */
  validatorByAccountIdExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccountFundingEvent = Node & {
  __typename?: 'AccountFundingEvent';
  /** Reads a single `Account` that is related to this `AccountFundingEvent`. */
  accountByAccountId: Account;
  /** Reads a single `Account` that is related to this `AccountFundingEvent`. */
  accountByRebalanceCounterpartyId?: Maybe<Account>;
  /** Reads a single `AccountCreationDepositChannel` that is related to this `AccountFundingEvent`. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: Maybe<AccountCreationDepositChannel>;
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  accountId: Scalars['Int']['output'];
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Epoch` that is related to this `AccountFundingEvent`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `AccountFundingEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  fundedFunder?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rebalanceCounterpartyId?: Maybe<Scalars['Int']['output']>;
  redeemedTxHash?: Maybe<Scalars['String']['output']>;
  /** Reads a single `SwapRequest` that is related to this `AccountFundingEvent`. */
  swapRequestBySwapRequestId?: Maybe<SwapRequest>;
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  txHash?: Maybe<Scalars['String']['output']>;
  type: FundingEventType;
  valueUsd: Scalars['BigFloat']['output'];
};

export type AccountFundingEventAggregates = {
  __typename?: 'AccountFundingEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AccountFundingEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AccountFundingEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AccountFundingEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AccountFundingEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AccountFundingEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AccountFundingEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AccountFundingEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AccountFundingEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AccountFundingEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AccountFundingEvent` object types. */
export type AccountFundingEventAggregatesFilter = {
  /** Mean average aggregate over matching `AccountFundingEvent` objects. */
  average?: InputMaybe<AccountFundingEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AccountFundingEvent` objects. */
  distinctCount?: InputMaybe<AccountFundingEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AccountFundingEvent` object to be included within the aggregate. */
  filter?: InputMaybe<AccountFundingEventFilter>;
  /** Maximum aggregate over matching `AccountFundingEvent` objects. */
  max?: InputMaybe<AccountFundingEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `AccountFundingEvent` objects. */
  min?: InputMaybe<AccountFundingEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AccountFundingEvent` objects. */
  stddevPopulation?: InputMaybe<AccountFundingEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AccountFundingEvent` objects. */
  stddevSample?: InputMaybe<AccountFundingEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AccountFundingEvent` objects. */
  sum?: InputMaybe<AccountFundingEventSumAggregateFilter>;
  /** Population variance aggregate over matching `AccountFundingEvent` objects. */
  variancePopulation?: InputMaybe<AccountFundingEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AccountFundingEvent` objects. */
  varianceSample?: InputMaybe<AccountFundingEventVarianceSampleAggregateFilter>;
};

export type AccountFundingEventAverageAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  accountId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventAverageAggregates = {
  __typename?: 'AccountFundingEventAverageAggregates';
  /** Mean average of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AccountFundingEvent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AccountFundingEventCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  accountByRebalanceCounterpartyId?: InputMaybe<Scalars['ID']['input']>;
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fundedFunder` field. */
  fundedFunder?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rebalanceCounterpartyId` field. */
  rebalanceCounterpartyId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `redeemedTxHash` field. */
  redeemedTxHash?: InputMaybe<Scalars['String']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<FundingEventType>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type AccountFundingEventDistinctCountAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  accountId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fundedFunder?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigIntFilter>;
  redeemedTxHash?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  txHash?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type AccountFundingEventDistinctCountAggregates = {
  __typename?: 'AccountFundingEventDistinctCountAggregates';
  /** Distinct count of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fundedFunder across the matching connection */
  fundedFunder?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of redeemedTxHash across the matching connection */
  redeemedTxHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of txHash across the matching connection */
  txHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AccountFundingEvent` object types. All fields are combined with a logical ‘and.’ */
export type AccountFundingEventFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountByRebalanceCounterpartyId` relation. */
  accountByRebalanceCounterpartyId?: InputMaybe<AccountFilter>;
  /** A related `accountByRebalanceCounterpartyId` exists. */
  accountByRebalanceCounterpartyIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelByAccountCreationDepositChannelId` relation. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** A related `accountCreationDepositChannelByAccountCreationDepositChannelId` exists. */
  accountCreationDepositChannelByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AccountFundingEventFilter>>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fundedFunder` field. */
  fundedFunder?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AccountFundingEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AccountFundingEventFilter>>;
  /** Filter by the object’s `rebalanceCounterpartyId` field. */
  rebalanceCounterpartyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `redeemedTxHash` field. */
  redeemedTxHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestBySwapRequestId` exists. */
  swapRequestBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<FundingEventTypeFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `AccountFundingEvent` for usage during aggregation. */
export type AccountFundingEventGroupBy =
  | 'ACCOUNT_ID'
  | 'AMOUNT'
  | 'EPOCH_ID'
  | 'EVENT_ID'
  | 'FUNDED_FUNDER'
  | 'REBALANCE_COUNTERPARTY_ID'
  | 'REDEEMED_TX_HASH'
  | 'TX_HASH'
  | 'TYPE'
  | 'VALUE_USD';

export type AccountFundingEventHavingAverageInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingDistinctCountInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `AccountFundingEvent` aggregates. */
export type AccountFundingEventHavingInput = {
  AND?: InputMaybe<Array<AccountFundingEventHavingInput>>;
  OR?: InputMaybe<Array<AccountFundingEventHavingInput>>;
  average?: InputMaybe<AccountFundingEventHavingAverageInput>;
  distinctCount?: InputMaybe<AccountFundingEventHavingDistinctCountInput>;
  max?: InputMaybe<AccountFundingEventHavingMaxInput>;
  min?: InputMaybe<AccountFundingEventHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountFundingEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountFundingEventHavingStddevSampleInput>;
  sum?: InputMaybe<AccountFundingEventHavingSumInput>;
  variancePopulation?: InputMaybe<AccountFundingEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountFundingEventHavingVarianceSampleInput>;
};

export type AccountFundingEventHavingMaxInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingMinInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingStddevPopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingStddevSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingSumInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingVariancePopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventHavingVarianceSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  accountId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type AccountFundingEventMaxAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  accountId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  rebalanceCounterpartyId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventMaxAggregates = {
  __typename?: 'AccountFundingEventMaxAggregates';
  /** Maximum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountFundingEventMinAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  accountId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  rebalanceCounterpartyId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventMinAggregates = {
  __typename?: 'AccountFundingEventMinAggregates';
  /** Minimum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountFundingEventStddevPopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  accountId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventStddevPopulationAggregates = {
  __typename?: 'AccountFundingEventStddevPopulationAggregates';
  /** Population standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountFundingEventStddevSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  accountId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventStddevSampleAggregates = {
  __typename?: 'AccountFundingEventStddevSampleAggregates';
  /** Sample standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountFundingEventSumAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  accountId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventSumAggregates = {
  __typename?: 'AccountFundingEventSumAggregates';
  /** Sum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId: Scalars['BigInt']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type AccountFundingEventVariancePopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  accountId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventVariancePopulationAggregates = {
  __typename?: 'AccountFundingEventVariancePopulationAggregates';
  /** Population variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountFundingEventVarianceSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  accountId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  rebalanceCounterpartyId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type AccountFundingEventVarianceSampleAggregates = {
  __typename?: 'AccountFundingEventVarianceSampleAggregates';
  /** Sample variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rebalanceCounterpartyId across the matching connection */
  rebalanceCounterpartyId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AccountFundingEvent` values. */
export type AccountFundingEventsConnection = {
  __typename?: 'AccountFundingEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountFundingEventAggregates>;
  /** A list of edges which contains the `AccountFundingEvent` and cursor to aid in pagination. */
  edges: Array<AccountFundingEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountFundingEventAggregates>>;
  /** A list of `AccountFundingEvent` objects. */
  nodes: Array<AccountFundingEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AccountFundingEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AccountFundingEvent` values. */
export type AccountFundingEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountFundingEventGroupBy>;
  having?: InputMaybe<AccountFundingEventHavingInput>;
};

/** A `AccountFundingEvent` edge in the connection. */
export type AccountFundingEventsEdge = {
  __typename?: 'AccountFundingEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AccountFundingEvent` at the end of the edge. */
  node: AccountFundingEvent;
};

/** Methods to use when ordering `AccountFundingEvent`. */
export type AccountFundingEventsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'FUNDED_FUNDER_ASC'
  | 'FUNDED_FUNDER_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REBALANCE_COUNTERPARTY_ID_ASC'
  | 'REBALANCE_COUNTERPARTY_ID_DESC'
  | 'REDEEMED_TX_HASH_ASC'
  | 'REDEEMED_TX_HASH_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC'
  | 'TX_HASH_ASC'
  | 'TX_HASH_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

/** Grouping methods for `Account` for usage during aggregation. */
export type AccountGroupBy =
  | 'ALIAS'
  | 'BOUND_REDEEM_ADDRESS'
  | 'ROLE';

export type AccountHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Account` aggregates. */
export type AccountHavingInput = {
  AND?: InputMaybe<Array<AccountHavingInput>>;
  OR?: InputMaybe<Array<AccountHavingInput>>;
  average?: InputMaybe<AccountHavingAverageInput>;
  distinctCount?: InputMaybe<AccountHavingDistinctCountInput>;
  max?: InputMaybe<AccountHavingMaxInput>;
  min?: InputMaybe<AccountHavingMinInput>;
  stddevPopulation?: InputMaybe<AccountHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AccountHavingStddevSampleInput>;
  sum?: InputMaybe<AccountHavingSumInput>;
  variancePopulation?: InputMaybe<AccountHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AccountHavingVarianceSampleInput>;
};

export type AccountHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type AccountMaxAggregates = {
  __typename?: 'AccountMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountMinAggregates = {
  __typename?: 'AccountMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AccountRole =
  | 'BROKER'
  | 'LIQUIDITY_PROVIDER'
  | 'OPERATOR'
  | 'TRADING_STRATEGY'
  | 'UNREGISTERED'
  | 'VALIDATOR';

/** A filter to be used against AccountRole fields. All fields are combined with a logical ‘and.’ */
export type AccountRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AccountRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AccountRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AccountRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AccountRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AccountRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AccountRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AccountRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AccountRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AccountRole>>;
};

export type AccountStddevPopulationAggregates = {
  __typename?: 'AccountStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountStddevSampleAggregates = {
  __typename?: 'AccountStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountSumAggregates = {
  __typename?: 'AccountSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AccountCreationDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyAccountCreationDepositChannelFilter = {
  /** Aggregates across related `AccountCreationDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<AccountCreationDepositChannelAggregatesFilter>;
  /** Every related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** No related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Some related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCreationDepositChannelFilter>;
};

/** A filter to be used against many `AccountFundingEvent` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyAccountFundingEventFilter = {
  /** Aggregates across related `AccountFundingEvent` match the filter criteria. */
  aggregates?: InputMaybe<AccountFundingEventAggregatesFilter>;
  /** Every related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFundingEventFilter>;
  /** No related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFundingEventFilter>;
  /** Some related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFundingEventFilter>;
};

/** A filter to be used against many `DelegationActivity` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyDelegationActivityFilter = {
  /** Aggregates across related `DelegationActivity` match the filter criteria. */
  aggregates?: InputMaybe<DelegationActivityAggregatesFilter>;
  /** Every related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DelegationActivityFilter>;
  /** No related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DelegationActivityFilter>;
  /** Some related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DelegationActivityFilter>;
};

/** A filter to be used against many `Extrinsic` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyExtrinsicFilter = {
  /** Aggregates across related `Extrinsic` match the filter criteria. */
  aggregates?: InputMaybe<ExtrinsicAggregatesFilter>;
  /** Every related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExtrinsicFilter>;
  /** No related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExtrinsicFilter>;
  /** Some related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExtrinsicFilter>;
};

/** A filter to be used against many `LiquidationSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyLiquidationSwapInfoFilter = {
  /** Aggregates across related `LiquidationSwapInfo` match the filter criteria. */
  aggregates?: InputMaybe<LiquidationSwapInfoAggregatesFilter>;
  /** Every related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidationSwapInfoFilter>;
  /** No related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidationSwapInfoFilter>;
  /** Some related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidationSwapInfoFilter>;
};

/** A filter to be used against many `NetworkParticipantEarningsDaily` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyNetworkParticipantEarningsDailyFilter = {
  /** Aggregates across related `NetworkParticipantEarningsDaily` match the filter criteria. */
  aggregates?: InputMaybe<NetworkParticipantEarningsDailyAggregatesFilter>;
  /** Every related `NetworkParticipantEarningsDaily` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  /** No related `NetworkParticipantEarningsDaily` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  /** Some related `NetworkParticipantEarningsDaily` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
};

/** A filter to be used against many `NetworkParticipantEarningsHourly` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyNetworkParticipantEarningsHourlyFilter = {
  /** Aggregates across related `NetworkParticipantEarningsHourly` match the filter criteria. */
  aggregates?: InputMaybe<NetworkParticipantEarningsHourlyAggregatesFilter>;
  /** Every related `NetworkParticipantEarningsHourly` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  /** No related `NetworkParticipantEarningsHourly` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  /** Some related `NetworkParticipantEarningsHourly` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
};

/** A filter to be used against many `OnChainSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyOnChainSwapInfoFilter = {
  /** Aggregates across related `OnChainSwapInfo` match the filter criteria. */
  aggregates?: InputMaybe<OnChainSwapInfoAggregatesFilter>;
  /** Every related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OnChainSwapInfoFilter>;
  /** No related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OnChainSwapInfoFilter>;
  /** Some related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OnChainSwapInfoFilter>;
};

/** A filter to be used against many `OperatorAction` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyOperatorActionFilter = {
  /** Aggregates across related `OperatorAction` match the filter criteria. */
  aggregates?: InputMaybe<OperatorActionAggregatesFilter>;
  /** Every related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorActionFilter>;
  /** No related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorActionFilter>;
  /** Some related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorActionFilter>;
};

/** A filter to be used against many `OperatorEpochDelegation` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManyOperatorEpochDelegationFilter = {
  /** Aggregates across related `OperatorEpochDelegation` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochDelegationAggregatesFilter>;
  /** Every related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochDelegationFilter>;
  /** No related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochDelegationFilter>;
  /** Some related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochDelegationFilter>;
};

/** A filter to be used against many `SwapChannelBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManySwapChannelBeneficiaryFilter = {
  /** Aggregates across related `SwapChannelBeneficiary` match the filter criteria. */
  aggregates?: InputMaybe<SwapChannelBeneficiaryAggregatesFilter>;
  /** Every related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** No related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** Some related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapChannelBeneficiaryFilter>;
};

/** A filter to be used against many `SwapRequestBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type AccountToManySwapRequestBeneficiaryFilter = {
  /** Aggregates across related `SwapRequestBeneficiary` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestBeneficiaryAggregatesFilter>;
  /** Every related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** No related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** Some related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestBeneficiaryFilter>;
};

export type AccountVariancePopulationAggregates = {
  __typename?: 'AccountVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AccountVarianceSampleAggregates = {
  __typename?: 'AccountVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Account` values. */
export type AccountsConnection = {
  __typename?: 'AccountsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AccountAggregates>;
  /** A list of edges which contains the `Account` and cursor to aid in pagination. */
  edges: Array<AccountsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AccountAggregates>>;
  /** A list of `Account` objects. */
  nodes: Array<Account>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Account` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Account` values. */
export type AccountsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AccountGroupBy>;
  having?: InputMaybe<AccountHavingInput>;
};

/** A `Account` edge in the connection. */
export type AccountsEdge = {
  __typename?: 'AccountsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Account` at the end of the edge. */
  node: Account;
};

/** Methods to use when ordering `Account`. */
export type AccountsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_COUNT_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_COUNT_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_REFUND_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_DISTINCT_COUNT_REFUND_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_CREATED_ACCOUNT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_AVERAGE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_COUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_COUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_FUNDED_FUNDER_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_FUNDED_FUNDER_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MAX_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_MIN_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_SUM_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_AVERAGE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_COUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_COUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_FUNDED_FUNDER_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_FUNDED_FUNDER_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MAX_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_MIN_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_SUM_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_REBALANCE_COUNTERPARTY_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'ALIAS_ASC'
  | 'ALIAS_DESC'
  | 'BOUND_REDEEM_ADDRESS_ASC'
  | 'BOUND_REDEEM_ADDRESS_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_COUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_COUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MAX_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_MIN_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_SUM_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_AVERAGE_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_COUNT_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_COUNT_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_HASH_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_HASH_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SIGNATURE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SIGNATURE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SUCCESS_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_SUCCESS_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_DISTINCT_COUNT_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MAX_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_MIN_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_STDDEV_SAMPLE_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_SUM_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_SUBMITTER_ID_VARIANCE_SAMPLE_VERSION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ID_HEX_ASC'
  | 'ID_HEX_DESC'
  | 'ID_SS58_ASC'
  | 'ID_SS58_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ABORTED_REASON_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ABORTED_REASON_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_BORROWER_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'NATURAL'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_COUNT_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_COUNT_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_DAY_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_DAY_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ROLE_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ROLE_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_DAY_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_DAY_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_DAY_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_DAY_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACTIVE_HOURS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACTIVE_HOURS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_AVG_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_AVG_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_DAILIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_AVERAGE_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_COUNT_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_COUNT_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ROLE_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ROLE_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_TIMESTAMP_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MAX_TIMESTAMP_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_TIMESTAMP_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_MIN_TIMESTAMP_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_POPULATION_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_SUM_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_RATIO_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BLOCK_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BLOCK_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_CUMULATIVE_REWARD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_CUMULATIVE_REWARD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EARNINGS_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_INTERVAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_INTERVAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PRINCIPAL_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PRINCIPAL_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY6H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY24H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY72H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY168H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_PROJECTED_APY720H_DESC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_RATIO_ASC'
  | 'NETWORK_PARTICIPANT_EARNINGS_HOURLIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_RATIO_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_COUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_COUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_ACTION_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_ACTION_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_COUNT_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_COUNT_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MAX_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_MIN_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_AVERAGE_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MAX_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_MIN_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_SUM_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_DELEGATOR_ACCOUNT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_COUNT_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_COUNT_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_COUNT_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_COUNT_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_ACCOUNT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC';

export type ArchiveInfo = {
  __typename?: 'ArchiveInfo';
  lastArchivedBlock?: Maybe<Scalars['Int']['output']>;
};

export type Auction = Node & {
  __typename?: 'Auction';
  /** Reads a single `Block` that is related to this `Auction`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  bond: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type AuctionAggregates = {
  __typename?: 'AuctionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuctionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuctionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuctionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuctionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuctionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuctionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuctionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuctionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuctionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Auction` object types. */
export type AuctionAggregatesFilter = {
  /** Mean average aggregate over matching `Auction` objects. */
  average?: InputMaybe<AuctionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Auction` objects. */
  distinctCount?: InputMaybe<AuctionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Auction` object to be included within the aggregate. */
  filter?: InputMaybe<AuctionFilter>;
  /** Maximum aggregate over matching `Auction` objects. */
  max?: InputMaybe<AuctionMaxAggregateFilter>;
  /** Minimum aggregate over matching `Auction` objects. */
  min?: InputMaybe<AuctionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Auction` objects. */
  stddevPopulation?: InputMaybe<AuctionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Auction` objects. */
  stddevSample?: InputMaybe<AuctionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Auction` objects. */
  sum?: InputMaybe<AuctionSumAggregateFilter>;
  /** Population variance aggregate over matching `Auction` objects. */
  variancePopulation?: InputMaybe<AuctionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Auction` objects. */
  varianceSample?: InputMaybe<AuctionVarianceSampleAggregateFilter>;
};

export type AuctionAverageAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type AuctionAverageAggregates = {
  __typename?: 'AuctionAverageAggregates';
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Auction` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type AuctionCondition = {
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `bond` field. */
  bond?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type AuctionDistinctCountAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  bond?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type AuctionDistinctCountAggregates = {
  __typename?: 'AuctionDistinctCountAggregates';
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bond across the matching connection */
  bond?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Auction` object types. All fields are combined with a logical ‘and.’ */
export type AuctionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuctionFilter>>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `bond` field. */
  bond?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuctionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuctionFilter>>;
};

/** Grouping methods for `Auction` for usage during aggregation. */
export type AuctionGroupBy =
  | 'BLOCK_ID'
  | 'BOND';

export type AuctionHavingAverageInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingDistinctCountInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Auction` aggregates. */
export type AuctionHavingInput = {
  AND?: InputMaybe<Array<AuctionHavingInput>>;
  OR?: InputMaybe<Array<AuctionHavingInput>>;
  average?: InputMaybe<AuctionHavingAverageInput>;
  distinctCount?: InputMaybe<AuctionHavingDistinctCountInput>;
  max?: InputMaybe<AuctionHavingMaxInput>;
  min?: InputMaybe<AuctionHavingMinInput>;
  stddevPopulation?: InputMaybe<AuctionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuctionHavingStddevSampleInput>;
  sum?: InputMaybe<AuctionHavingSumInput>;
  variancePopulation?: InputMaybe<AuctionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuctionHavingVarianceSampleInput>;
};

export type AuctionHavingMaxInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingMinInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevPopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingStddevSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingSumInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVariancePopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionHavingVarianceSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  bond?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type AuctionMaxAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AuctionMaxAggregates = {
  __typename?: 'AuctionMaxAggregates';
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AuctionMinAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
};

export type AuctionMinAggregates = {
  __typename?: 'AuctionMinAggregates';
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type AuctionStddevPopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type AuctionStddevPopulationAggregates = {
  __typename?: 'AuctionStddevPopulationAggregates';
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionStddevSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type AuctionStddevSampleAggregates = {
  __typename?: 'AuctionStddevSampleAggregates';
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionSumAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type AuctionSumAggregates = {
  __typename?: 'AuctionSumAggregates';
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of bond across the matching connection */
  bond: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type AuctionVariancePopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type AuctionVariancePopulationAggregates = {
  __typename?: 'AuctionVariancePopulationAggregates';
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuctionVarianceSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  bond?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type AuctionVarianceSampleAggregates = {
  __typename?: 'AuctionVarianceSampleAggregates';
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Auction` values. */
export type AuctionsConnection = {
  __typename?: 'AuctionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuctionAggregates>;
  /** A list of edges which contains the `Auction` and cursor to aid in pagination. */
  edges: Array<AuctionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuctionAggregates>>;
  /** A list of `Auction` objects. */
  nodes: Array<Auction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Auction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Auction` values. */
export type AuctionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AuctionGroupBy>;
  having?: InputMaybe<AuctionHavingInput>;
};

/** A `Auction` edge in the connection. */
export type AuctionsEdge = {
  __typename?: 'AuctionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Auction` at the end of the edge. */
  node: Auction;
};

/** Methods to use when ordering `Auction`. */
export type AuctionsOrderBy =
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BOND_ASC'
  | 'BOND_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type AuthorityHeartbeat = Node & {
  __typename?: 'AuthorityHeartbeat';
  /** Reads a single `AuthorityMembership` that is related to this `AuthorityHeartbeat`. */
  authorityMembershipByAuthorityMembershipId: AuthorityMembership;
  authorityMembershipId: Scalars['Int']['output'];
  /** Reads a single `Block` that is related to this `AuthorityHeartbeat`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `Epoch` that is related to this `AuthorityHeartbeat`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  id: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
  /** Reads a single `Validator` that is related to this `AuthorityHeartbeat`. */
  validatorByValidatorId: Validator;
  validatorId: Scalars['Int']['output'];
};

export type AuthorityHeartbeatAggregates = {
  __typename?: 'AuthorityHeartbeatAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuthorityHeartbeatAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuthorityHeartbeatDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuthorityHeartbeatMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuthorityHeartbeatMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuthorityHeartbeatStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuthorityHeartbeatStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuthorityHeartbeatSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuthorityHeartbeatVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuthorityHeartbeatVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AuthorityHeartbeat` object types. */
export type AuthorityHeartbeatAggregatesFilter = {
  /** Mean average aggregate over matching `AuthorityHeartbeat` objects. */
  average?: InputMaybe<AuthorityHeartbeatAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AuthorityHeartbeat` objects. */
  distinctCount?: InputMaybe<AuthorityHeartbeatDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuthorityHeartbeat` object to be included within the aggregate. */
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Maximum aggregate over matching `AuthorityHeartbeat` objects. */
  max?: InputMaybe<AuthorityHeartbeatMaxAggregateFilter>;
  /** Minimum aggregate over matching `AuthorityHeartbeat` objects. */
  min?: InputMaybe<AuthorityHeartbeatMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AuthorityHeartbeat` objects. */
  stddevPopulation?: InputMaybe<AuthorityHeartbeatStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AuthorityHeartbeat` objects. */
  stddevSample?: InputMaybe<AuthorityHeartbeatStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AuthorityHeartbeat` objects. */
  sum?: InputMaybe<AuthorityHeartbeatSumAggregateFilter>;
  /** Population variance aggregate over matching `AuthorityHeartbeat` objects. */
  variancePopulation?: InputMaybe<AuthorityHeartbeatVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AuthorityHeartbeat` objects. */
  varianceSample?: InputMaybe<AuthorityHeartbeatVarianceSampleAggregateFilter>;
};

export type AuthorityHeartbeatAverageAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityHeartbeatAverageAggregates = {
  __typename?: 'AuthorityHeartbeatAverageAggregates';
  /** Mean average of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AuthorityHeartbeat` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type AuthorityHeartbeatCondition = {
  authorityMembershipByAuthorityMembershipId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `authorityMembershipId` field. */
  authorityMembershipId?: InputMaybe<Scalars['Int']['input']>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorityHeartbeatDistinctCountAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type AuthorityHeartbeatDistinctCountAggregates = {
  __typename?: 'AuthorityHeartbeatDistinctCountAggregates';
  /** Distinct count of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AuthorityHeartbeat` object types. All fields are combined with a logical ‘and.’ */
export type AuthorityHeartbeatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthorityHeartbeatFilter>>;
  /** Filter by the object’s `authorityMembershipByAuthorityMembershipId` relation. */
  authorityMembershipByAuthorityMembershipId?: InputMaybe<AuthorityMembershipFilter>;
  /** Filter by the object’s `authorityMembershipId` field. */
  authorityMembershipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthorityHeartbeatFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AuthorityHeartbeat` for usage during aggregation. */
export type AuthorityHeartbeatGroupBy =
  | 'AUTHORITY_MEMBERSHIP_ID'
  | 'BLOCK_ID'
  | 'EPOCH_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'VALIDATOR_ID';

export type AuthorityHeartbeatHavingAverageInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingDistinctCountInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AuthorityHeartbeat` aggregates. */
export type AuthorityHeartbeatHavingInput = {
  AND?: InputMaybe<Array<AuthorityHeartbeatHavingInput>>;
  OR?: InputMaybe<Array<AuthorityHeartbeatHavingInput>>;
  average?: InputMaybe<AuthorityHeartbeatHavingAverageInput>;
  distinctCount?: InputMaybe<AuthorityHeartbeatHavingDistinctCountInput>;
  max?: InputMaybe<AuthorityHeartbeatHavingMaxInput>;
  min?: InputMaybe<AuthorityHeartbeatHavingMinInput>;
  stddevPopulation?: InputMaybe<AuthorityHeartbeatHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuthorityHeartbeatHavingStddevSampleInput>;
  sum?: InputMaybe<AuthorityHeartbeatHavingSumInput>;
  variancePopulation?: InputMaybe<AuthorityHeartbeatHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuthorityHeartbeatHavingVarianceSampleInput>;
};

export type AuthorityHeartbeatHavingMaxInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingMinInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingStddevPopulationInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingStddevSampleInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingSumInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingVariancePopulationInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatHavingVarianceSampleInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityHeartbeatMaxAggregateFilter = {
  authorityMembershipId?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type AuthorityHeartbeatMaxAggregates = {
  __typename?: 'AuthorityHeartbeatMaxAggregates';
  /** Maximum of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type AuthorityHeartbeatMinAggregateFilter = {
  authorityMembershipId?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type AuthorityHeartbeatMinAggregates = {
  __typename?: 'AuthorityHeartbeatMinAggregates';
  /** Minimum of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type AuthorityHeartbeatStddevPopulationAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityHeartbeatStddevPopulationAggregates = {
  __typename?: 'AuthorityHeartbeatStddevPopulationAggregates';
  /** Population standard deviation of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityHeartbeatStddevSampleAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityHeartbeatStddevSampleAggregates = {
  __typename?: 'AuthorityHeartbeatStddevSampleAggregates';
  /** Sample standard deviation of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityHeartbeatSumAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type AuthorityHeartbeatSumAggregates = {
  __typename?: 'AuthorityHeartbeatSumAggregates';
  /** Sum of authorityMembershipId across the matching connection */
  authorityMembershipId: Scalars['BigInt']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

export type AuthorityHeartbeatVariancePopulationAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityHeartbeatVariancePopulationAggregates = {
  __typename?: 'AuthorityHeartbeatVariancePopulationAggregates';
  /** Population variance of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityHeartbeatVarianceSampleAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityHeartbeatVarianceSampleAggregates = {
  __typename?: 'AuthorityHeartbeatVarianceSampleAggregates';
  /** Sample variance of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AuthorityHeartbeat` values. */
export type AuthorityHeartbeatsConnection = {
  __typename?: 'AuthorityHeartbeatsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuthorityHeartbeatAggregates>;
  /** A list of edges which contains the `AuthorityHeartbeat` and cursor to aid in pagination. */
  edges: Array<AuthorityHeartbeatsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuthorityHeartbeatAggregates>>;
  /** A list of `AuthorityHeartbeat` objects. */
  nodes: Array<AuthorityHeartbeat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthorityHeartbeat` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AuthorityHeartbeat` values. */
export type AuthorityHeartbeatsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AuthorityHeartbeatGroupBy>;
  having?: InputMaybe<AuthorityHeartbeatHavingInput>;
};

/** A `AuthorityHeartbeat` edge in the connection. */
export type AuthorityHeartbeatsEdge = {
  __typename?: 'AuthorityHeartbeatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuthorityHeartbeat` at the end of the edge. */
  node: AuthorityHeartbeat;
};

/** Methods to use when ordering `AuthorityHeartbeat`. */
export type AuthorityHeartbeatsOrderBy =
  | 'AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

export type AuthorityMembership = Node & {
  __typename?: 'AuthorityMembership';
  /** Reads and enables pagination through a set of `AuthorityHeartbeat`. */
  authorityHeartbeatsByAuthorityMembershipId: AuthorityHeartbeatsConnection;
  balance?: Maybe<Scalars['BigFloat']['output']>;
  bid: Scalars['BigFloat']['output'];
  /** Reads a single `Epoch` that is related to this `AuthorityMembership`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  loss: Scalars['BigFloat']['output'];
  lossValueUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OperatorEpochValidator` that is related to this `AuthorityMembership`. */
  operatorEpochValidatorByAuthorityMembershipId?: Maybe<OperatorEpochValidator>;
  /** Reads and enables pagination through a set of `OperatorEpochValidator`. */
  operatorEpochValidatorsByAuthorityMembershipId: OperatorEpochValidatorsConnection;
  reward: Scalars['BigFloat']['output'];
  rewardValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Validator` that is related to this `AuthorityMembership`. */
  validatorByValidatorId: Validator;
  validatorId: Scalars['Int']['output'];
};


export type AuthorityMembershipAuthorityHeartbeatsByAuthorityMembershipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityHeartbeatCondition>;
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityHeartbeatsOrderBy>>;
};


export type AuthorityMembershipOperatorEpochValidatorsByAuthorityMembershipIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochValidatorCondition>;
  filter?: InputMaybe<OperatorEpochValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochValidatorsOrderBy>>;
};

export type AuthorityMembershipAggregates = {
  __typename?: 'AuthorityMembershipAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<AuthorityMembershipAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<AuthorityMembershipDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<AuthorityMembershipMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<AuthorityMembershipMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<AuthorityMembershipStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<AuthorityMembershipStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<AuthorityMembershipSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<AuthorityMembershipVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<AuthorityMembershipVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `AuthorityMembership` object types. */
export type AuthorityMembershipAggregatesFilter = {
  /** Mean average aggregate over matching `AuthorityMembership` objects. */
  average?: InputMaybe<AuthorityMembershipAverageAggregateFilter>;
  /** Distinct count aggregate over matching `AuthorityMembership` objects. */
  distinctCount?: InputMaybe<AuthorityMembershipDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `AuthorityMembership` object to be included within the aggregate. */
  filter?: InputMaybe<AuthorityMembershipFilter>;
  /** Maximum aggregate over matching `AuthorityMembership` objects. */
  max?: InputMaybe<AuthorityMembershipMaxAggregateFilter>;
  /** Minimum aggregate over matching `AuthorityMembership` objects. */
  min?: InputMaybe<AuthorityMembershipMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `AuthorityMembership` objects. */
  stddevPopulation?: InputMaybe<AuthorityMembershipStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `AuthorityMembership` objects. */
  stddevSample?: InputMaybe<AuthorityMembershipStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `AuthorityMembership` objects. */
  sum?: InputMaybe<AuthorityMembershipSumAggregateFilter>;
  /** Population variance aggregate over matching `AuthorityMembership` objects. */
  variancePopulation?: InputMaybe<AuthorityMembershipVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `AuthorityMembership` objects. */
  varianceSample?: InputMaybe<AuthorityMembershipVarianceSampleAggregateFilter>;
};

export type AuthorityMembershipAverageAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityMembershipAverageAggregates = {
  __typename?: 'AuthorityMembershipAverageAggregates';
  /** Mean average of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `AuthorityMembership` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type AuthorityMembershipCondition = {
  /** Checks for equality with the object’s `balance` field. */
  balance?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `bid` field. */
  bid?: InputMaybe<Scalars['BigFloat']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `loss` field. */
  loss?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lossValueUsd` field. */
  lossValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `reward` field. */
  reward?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rewardValueUsd` field. */
  rewardValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type AuthorityMembershipDistinctCountAggregateFilter = {
  balance?: InputMaybe<BigIntFilter>;
  bid?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  loss?: InputMaybe<BigIntFilter>;
  lossValueUsd?: InputMaybe<BigIntFilter>;
  reward?: InputMaybe<BigIntFilter>;
  rewardValueUsd?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type AuthorityMembershipDistinctCountAggregates = {
  __typename?: 'AuthorityMembershipDistinctCountAggregates';
  /** Distinct count of balance across the matching connection */
  balance?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bid across the matching connection */
  bid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loss across the matching connection */
  loss?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reward across the matching connection */
  reward?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `AuthorityMembership` object types. All fields are combined with a logical ‘and.’ */
export type AuthorityMembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AuthorityMembershipFilter>>;
  /** Filter by the object’s `authorityHeartbeatsByAuthorityMembershipId` relation. */
  authorityHeartbeatsByAuthorityMembershipId?: InputMaybe<AuthorityMembershipToManyAuthorityHeartbeatFilter>;
  /** Some related `authorityHeartbeatsByAuthorityMembershipId` exist. */
  authorityHeartbeatsByAuthorityMembershipIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `balance` field. */
  balance?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `bid` field. */
  bid?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `loss` field. */
  loss?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lossValueUsd` field. */
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AuthorityMembershipFilter>;
  /** Filter by the object’s `operatorEpochValidatorByAuthorityMembershipId` relation. */
  operatorEpochValidatorByAuthorityMembershipId?: InputMaybe<OperatorEpochValidatorFilter>;
  /** A related `operatorEpochValidatorByAuthorityMembershipId` exists. */
  operatorEpochValidatorByAuthorityMembershipIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AuthorityMembershipFilter>>;
  /** Filter by the object’s `reward` field. */
  reward?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rewardValueUsd` field. */
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `AuthorityMembership` for usage during aggregation. */
export type AuthorityMembershipGroupBy =
  | 'BALANCE'
  | 'BID'
  | 'EPOCH_ID'
  | 'LOSS'
  | 'LOSS_VALUE_USD'
  | 'REWARD'
  | 'REWARD_VALUE_USD'
  | 'VALIDATOR_ID';

export type AuthorityMembershipHavingAverageInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingDistinctCountInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `AuthorityMembership` aggregates. */
export type AuthorityMembershipHavingInput = {
  AND?: InputMaybe<Array<AuthorityMembershipHavingInput>>;
  OR?: InputMaybe<Array<AuthorityMembershipHavingInput>>;
  average?: InputMaybe<AuthorityMembershipHavingAverageInput>;
  distinctCount?: InputMaybe<AuthorityMembershipHavingDistinctCountInput>;
  max?: InputMaybe<AuthorityMembershipHavingMaxInput>;
  min?: InputMaybe<AuthorityMembershipHavingMinInput>;
  stddevPopulation?: InputMaybe<AuthorityMembershipHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<AuthorityMembershipHavingStddevSampleInput>;
  sum?: InputMaybe<AuthorityMembershipHavingSumInput>;
  variancePopulation?: InputMaybe<AuthorityMembershipHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<AuthorityMembershipHavingVarianceSampleInput>;
};

export type AuthorityMembershipHavingMaxInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingMinInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingStddevPopulationInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingStddevSampleInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingSumInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingVariancePopulationInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipHavingVarianceSampleInput = {
  balance?: InputMaybe<HavingBigfloatFilter>;
  bid?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  loss?: InputMaybe<HavingBigfloatFilter>;
  lossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type AuthorityMembershipMaxAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type AuthorityMembershipMaxAggregates = {
  __typename?: 'AuthorityMembershipMaxAggregates';
  /** Maximum of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type AuthorityMembershipMinAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type AuthorityMembershipMinAggregates = {
  __typename?: 'AuthorityMembershipMinAggregates';
  /** Minimum of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type AuthorityMembershipStddevPopulationAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityMembershipStddevPopulationAggregates = {
  __typename?: 'AuthorityMembershipStddevPopulationAggregates';
  /** Population standard deviation of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityMembershipStddevSampleAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityMembershipStddevSampleAggregates = {
  __typename?: 'AuthorityMembershipStddevSampleAggregates';
  /** Sample standard deviation of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityMembershipSumAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type AuthorityMembershipSumAggregates = {
  __typename?: 'AuthorityMembershipSumAggregates';
  /** Sum of balance across the matching connection */
  balance: Scalars['BigFloat']['output'];
  /** Sum of bid across the matching connection */
  bid: Scalars['BigFloat']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of loss across the matching connection */
  loss: Scalars['BigFloat']['output'];
  /** Sum of lossValueUsd across the matching connection */
  lossValueUsd: Scalars['BigFloat']['output'];
  /** Sum of reward across the matching connection */
  reward: Scalars['BigFloat']['output'];
  /** Sum of rewardValueUsd across the matching connection */
  rewardValueUsd: Scalars['BigFloat']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AuthorityHeartbeat` object types. All fields are combined with a logical ‘and.’ */
export type AuthorityMembershipToManyAuthorityHeartbeatFilter = {
  /** Aggregates across related `AuthorityHeartbeat` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityHeartbeatAggregatesFilter>;
  /** Every related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityHeartbeatFilter>;
  /** No related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Some related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityHeartbeatFilter>;
};

export type AuthorityMembershipVariancePopulationAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityMembershipVariancePopulationAggregates = {
  __typename?: 'AuthorityMembershipVariancePopulationAggregates';
  /** Population variance of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type AuthorityMembershipVarianceSampleAggregateFilter = {
  balance?: InputMaybe<BigFloatFilter>;
  bid?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  loss?: InputMaybe<BigFloatFilter>;
  lossValueUsd?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type AuthorityMembershipVarianceSampleAggregates = {
  __typename?: 'AuthorityMembershipVarianceSampleAggregates';
  /** Sample variance of balance across the matching connection */
  balance?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of bid across the matching connection */
  bid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loss across the matching connection */
  loss?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lossValueUsd across the matching connection */
  lossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `AuthorityMembership` values. */
export type AuthorityMembershipsConnection = {
  __typename?: 'AuthorityMembershipsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<AuthorityMembershipAggregates>;
  /** A list of edges which contains the `AuthorityMembership` and cursor to aid in pagination. */
  edges: Array<AuthorityMembershipsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<AuthorityMembershipAggregates>>;
  /** A list of `AuthorityMembership` objects. */
  nodes: Array<AuthorityMembership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AuthorityMembership` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `AuthorityMembership` values. */
export type AuthorityMembershipsConnectionGroupedAggregatesArgs = {
  groupBy: Array<AuthorityMembershipGroupBy>;
  having?: InputMaybe<AuthorityMembershipHavingInput>;
};

/** A `AuthorityMembership` edge in the connection. */
export type AuthorityMembershipsEdge = {
  __typename?: 'AuthorityMembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AuthorityMembership` at the end of the edge. */
  node: AuthorityMembership;
};

/** Methods to use when ordering `AuthorityMembership`. */
export type AuthorityMembershipsOrderBy =
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_COUNT_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_COUNT_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_AUTHORITY_MEMBERSHIP_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'BALANCE_ASC'
  | 'BALANCE_DESC'
  | 'BID_ASC'
  | 'BID_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOSS_ASC'
  | 'LOSS_DESC'
  | 'LOSS_VALUE_USD_ASC'
  | 'LOSS_VALUE_USD_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REWARD_ASC'
  | 'REWARD_DESC'
  | 'REWARD_VALUE_USD_ASC'
  | 'REWARD_VALUE_USD_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

/** A filter to be used against Base64EncodedBinary fields. All fields are combined with a logical ‘and.’ */
export type Base64EncodedBinaryFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Base64EncodedBinary']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Base64EncodedBinary']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Base64EncodedBinary']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Base64EncodedBinary']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Base64EncodedBinary']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Base64EncodedBinary']['input']>>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type Block = Node & {
  __typename?: 'Block';
  /** Reads and enables pagination through a set of `AccountCreationDepositChannel`. */
  accountCreationDepositChannelsByIssuedBlockId: AccountCreationDepositChannelsConnection;
  /** Reads and enables pagination through a set of `Auction`. */
  auctionsByBlockId: AuctionsConnection;
  /** Reads and enables pagination through a set of `AuthorityHeartbeat`. */
  authorityHeartbeatsByBlockId: AuthorityHeartbeatsConnection;
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitsByBlockId: BoostNetworkFeeSplitsConnection;
  /** Reads and enables pagination through a set of `BrokerWithdrawal`. */
  brokerWithdrawalsByBlockId: BrokerWithdrawalsConnection;
  /** Reads a single `Epoch` that is related to this `Block`. */
  epochByEndBlockId?: Maybe<Epoch>;
  /** Reads a single `Epoch` that is related to this `Block`. */
  epochByStartBlockId?: Maybe<Epoch>;
  /** Reads and enables pagination through a set of `Epoch`. */
  epochesByEndBlockId: EpochesConnection;
  /** Reads and enables pagination through a set of `Epoch`. */
  epochesByStartBlockId: EpochesConnection;
  /** Reads and enables pagination through a set of `Event`. */
  eventsByBlockId: EventsConnection;
  /** Reads and enables pagination through a set of `Extrinsic`. */
  extrinsicsByBlockId: ExtrinsicsConnection;
  /** Reads and enables pagination through a set of `ForeignChainTracking`. */
  foreignChainTrackingsByStateChainBlockId: ForeignChainTrackingsConnection;
  hash: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByBlockId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityDepositChannel`. */
  liquidityDepositChannelsByIssuedBlockId: LiquidityDepositChannelsConnection;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  liquidityDepositsByBlockId: LiquidityDepositsConnection;
  /** Reads and enables pagination through a set of `LiquidityTransfer`. */
  liquidityTransfersByBlockId: LiquidityTransfersConnection;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByBlockId: LiquidityWithdrawalsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  parentHash: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Penalty`. */
  penaltiesByBlockId: PenaltiesConnection;
  reward: Scalars['BigFloat']['output'];
  rewardValueUsd: Scalars['BigFloat']['output'];
  stateRoot: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `SwapChannel`. */
  swapChannelsByIssuedBlockId: SwapChannelsConnection;
  timestamp: Scalars['Datetime']['output'];
  /** Reads a single `Validator` that is related to this `Block`. */
  validatorByValidatorId?: Maybe<Validator>;
  validatorId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `Validator`. */
  validatorsByLastHeartbeatBlockId: ValidatorsConnection;
};


export type BlockAccountCreationDepositChannelsByIssuedBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCreationDepositChannelCondition>;
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCreationDepositChannelsOrderBy>>;
};


export type BlockAuctionsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionCondition>;
  filter?: InputMaybe<AuctionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionsOrderBy>>;
};


export type BlockAuthorityHeartbeatsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityHeartbeatCondition>;
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityHeartbeatsOrderBy>>;
};


export type BlockBoostNetworkFeeSplitsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


export type BlockBrokerWithdrawalsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerWithdrawalCondition>;
  filter?: InputMaybe<BrokerWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerWithdrawalsOrderBy>>;
};


export type BlockEpochesByEndBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EpochCondition>;
  filter?: InputMaybe<EpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EpochesOrderBy>>;
};


export type BlockEpochesByStartBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EpochCondition>;
  filter?: InputMaybe<EpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EpochesOrderBy>>;
};


export type BlockEventsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type BlockExtrinsicsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExtrinsicCondition>;
  filter?: InputMaybe<ExtrinsicFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicsOrderBy>>;
};


export type BlockForeignChainTrackingsByStateChainBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ForeignChainTrackingCondition>;
  filter?: InputMaybe<ForeignChainTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ForeignChainTrackingsOrderBy>>;
};


export type BlockLiquidityBalanceEventsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type BlockLiquidityDepositChannelsByIssuedBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositChannelCondition>;
  filter?: InputMaybe<LiquidityDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositChannelsOrderBy>>;
};


export type BlockLiquidityDepositsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};


export type BlockLiquidityTransfersByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityTransferCondition>;
  filter?: InputMaybe<LiquidityTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityTransfersOrderBy>>;
};


export type BlockLiquidityWithdrawalsByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


export type BlockPenaltiesByBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PenaltyCondition>;
  filter?: InputMaybe<PenaltyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PenaltiesOrderBy>>;
};


export type BlockSwapChannelsByIssuedBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelCondition>;
  filter?: InputMaybe<SwapChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelsOrderBy>>;
};


export type BlockValidatorsByLastHeartbeatBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};

export type BlockAggregates = {
  __typename?: 'BlockAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BlockAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BlockDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BlockMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BlockMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BlockStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BlockStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BlockSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BlockVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BlockVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Block` object types. */
export type BlockAggregatesFilter = {
  /** Mean average aggregate over matching `Block` objects. */
  average?: InputMaybe<BlockAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Block` objects. */
  distinctCount?: InputMaybe<BlockDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Block` object to be included within the aggregate. */
  filter?: InputMaybe<BlockFilter>;
  /** Maximum aggregate over matching `Block` objects. */
  max?: InputMaybe<BlockMaxAggregateFilter>;
  /** Minimum aggregate over matching `Block` objects. */
  min?: InputMaybe<BlockMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Block` objects. */
  stddevPopulation?: InputMaybe<BlockStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Block` objects. */
  stddevSample?: InputMaybe<BlockStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Block` objects. */
  sum?: InputMaybe<BlockSumAggregateFilter>;
  /** Population variance aggregate over matching `Block` objects. */
  variancePopulation?: InputMaybe<BlockVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Block` objects. */
  varianceSample?: InputMaybe<BlockVarianceSampleAggregateFilter>;
};

export type BlockAverageAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type BlockAverageAggregates = {
  __typename?: 'BlockAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Block` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BlockCondition = {
  /** Checks for equality with the object’s `hash` field. */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `parentHash` field. */
  parentHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `reward` field. */
  reward?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rewardValueUsd` field. */
  rewardValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stateRoot` field. */
  stateRoot?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockCounts = {
  __typename?: 'BlockCounts';
  blockHeight: Scalars['Int']['output'];
  eventsCount: Scalars['Int']['output'];
  extrinsicsCount: Scalars['Int']['output'];
};

export type BlockDetails = {
  __typename?: 'BlockDetails';
  blockHeight: Scalars['Int']['output'];
  events?: Maybe<Array<EventInfo>>;
  eventsCount: Scalars['Int']['output'];
  extrinsics?: Maybe<Array<ExtrinsicInfo>>;
  extrinsicsCount: Scalars['Int']['output'];
};

export type BlockDistinctCountAggregateFilter = {
  hash?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  parentHash?: InputMaybe<BigIntFilter>;
  reward?: InputMaybe<BigIntFilter>;
  rewardValueUsd?: InputMaybe<BigIntFilter>;
  stateRoot?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type BlockDistinctCountAggregates = {
  __typename?: 'BlockDistinctCountAggregates';
  /** Distinct count of hash across the matching connection */
  hash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of parentHash across the matching connection */
  parentHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reward across the matching connection */
  reward?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateRoot across the matching connection */
  stateRoot?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Block` object types. All fields are combined with a logical ‘and.’ */
export type BlockFilter = {
  /** Filter by the object’s `accountCreationDepositChannelsByIssuedBlockId` relation. */
  accountCreationDepositChannelsByIssuedBlockId?: InputMaybe<BlockToManyAccountCreationDepositChannelFilter>;
  /** Some related `accountCreationDepositChannelsByIssuedBlockId` exist. */
  accountCreationDepositChannelsByIssuedBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BlockFilter>>;
  /** Filter by the object’s `auctionsByBlockId` relation. */
  auctionsByBlockId?: InputMaybe<BlockToManyAuctionFilter>;
  /** Some related `auctionsByBlockId` exist. */
  auctionsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `authorityHeartbeatsByBlockId` relation. */
  authorityHeartbeatsByBlockId?: InputMaybe<BlockToManyAuthorityHeartbeatFilter>;
  /** Some related `authorityHeartbeatsByBlockId` exist. */
  authorityHeartbeatsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostNetworkFeeSplitsByBlockId` relation. */
  boostNetworkFeeSplitsByBlockId?: InputMaybe<BlockToManyBoostNetworkFeeSplitFilter>;
  /** Some related `boostNetworkFeeSplitsByBlockId` exist. */
  boostNetworkFeeSplitsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerWithdrawalsByBlockId` relation. */
  brokerWithdrawalsByBlockId?: InputMaybe<BlockToManyBrokerWithdrawalFilter>;
  /** Some related `brokerWithdrawalsByBlockId` exist. */
  brokerWithdrawalsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `epochByEndBlockId` relation. */
  epochByEndBlockId?: InputMaybe<EpochFilter>;
  /** A related `epochByEndBlockId` exists. */
  epochByEndBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `epochByStartBlockId` relation. */
  epochByStartBlockId?: InputMaybe<EpochFilter>;
  /** A related `epochByStartBlockId` exists. */
  epochByStartBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventsByBlockId` relation. */
  eventsByBlockId?: InputMaybe<BlockToManyEventFilter>;
  /** Some related `eventsByBlockId` exist. */
  eventsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `extrinsicsByBlockId` relation. */
  extrinsicsByBlockId?: InputMaybe<BlockToManyExtrinsicFilter>;
  /** Some related `extrinsicsByBlockId` exist. */
  extrinsicsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `foreignChainTrackingsByStateChainBlockId` relation. */
  foreignChainTrackingsByStateChainBlockId?: InputMaybe<BlockToManyForeignChainTrackingFilter>;
  /** Some related `foreignChainTrackingsByStateChainBlockId` exist. */
  foreignChainTrackingsByStateChainBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `hash` field. */
  hash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityBalanceEventsByBlockId` relation. */
  liquidityBalanceEventsByBlockId?: InputMaybe<BlockToManyLiquidityBalanceEventFilter>;
  /** Some related `liquidityBalanceEventsByBlockId` exist. */
  liquidityBalanceEventsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelsByIssuedBlockId` relation. */
  liquidityDepositChannelsByIssuedBlockId?: InputMaybe<BlockToManyLiquidityDepositChannelFilter>;
  /** Some related `liquidityDepositChannelsByIssuedBlockId` exist. */
  liquidityDepositChannelsByIssuedBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositsByBlockId` relation. */
  liquidityDepositsByBlockId?: InputMaybe<BlockToManyLiquidityDepositFilter>;
  /** Some related `liquidityDepositsByBlockId` exist. */
  liquidityDepositsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityTransfersByBlockId` relation. */
  liquidityTransfersByBlockId?: InputMaybe<BlockToManyLiquidityTransferFilter>;
  /** Some related `liquidityTransfersByBlockId` exist. */
  liquidityTransfersByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityWithdrawalsByBlockId` relation. */
  liquidityWithdrawalsByBlockId?: InputMaybe<BlockToManyLiquidityWithdrawalFilter>;
  /** Some related `liquidityWithdrawalsByBlockId` exist. */
  liquidityWithdrawalsByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<BlockFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BlockFilter>>;
  /** Filter by the object’s `parentHash` field. */
  parentHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `penaltiesByBlockId` relation. */
  penaltiesByBlockId?: InputMaybe<BlockToManyPenaltyFilter>;
  /** Some related `penaltiesByBlockId` exist. */
  penaltiesByBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `reward` field. */
  reward?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rewardValueUsd` field. */
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stateRoot` field. */
  stateRoot?: InputMaybe<StringFilter>;
  /** Filter by the object’s `swapChannelsByIssuedBlockId` relation. */
  swapChannelsByIssuedBlockId?: InputMaybe<BlockToManySwapChannelFilter>;
  /** Some related `swapChannelsByIssuedBlockId` exist. */
  swapChannelsByIssuedBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** A related `validatorByValidatorId` exists. */
  validatorByValidatorIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `validatorsByLastHeartbeatBlockId` relation. */
  validatorsByLastHeartbeatBlockId?: InputMaybe<BlockToManyValidatorFilter>;
  /** Some related `validatorsByLastHeartbeatBlockId` exist. */
  validatorsByLastHeartbeatBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Block` for usage during aggregation. */
export type BlockGroupBy =
  | 'PARENT_HASH'
  | 'REWARD'
  | 'REWARD_VALUE_USD'
  | 'STATE_ROOT'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'VALIDATOR_ID';

export type BlockHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Block` aggregates. */
export type BlockHavingInput = {
  AND?: InputMaybe<Array<BlockHavingInput>>;
  OR?: InputMaybe<Array<BlockHavingInput>>;
  average?: InputMaybe<BlockHavingAverageInput>;
  distinctCount?: InputMaybe<BlockHavingDistinctCountInput>;
  max?: InputMaybe<BlockHavingMaxInput>;
  min?: InputMaybe<BlockHavingMinInput>;
  stddevPopulation?: InputMaybe<BlockHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BlockHavingStddevSampleInput>;
  sum?: InputMaybe<BlockHavingSumInput>;
  variancePopulation?: InputMaybe<BlockHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BlockHavingVarianceSampleInput>;
};

export type BlockHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  reward?: InputMaybe<HavingBigfloatFilter>;
  rewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type BlockMaxAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type BlockMaxAggregates = {
  __typename?: 'BlockMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type BlockMinAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type BlockMinAggregates = {
  __typename?: 'BlockMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type BlockStddevPopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type BlockStddevPopulationAggregates = {
  __typename?: 'BlockStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BlockStddevSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type BlockStddevSampleAggregates = {
  __typename?: 'BlockStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BlockSumAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type BlockSumAggregates = {
  __typename?: 'BlockSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of reward across the matching connection */
  reward: Scalars['BigFloat']['output'];
  /** Sum of rewardValueUsd across the matching connection */
  rewardValueUsd: Scalars['BigFloat']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AccountCreationDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyAccountCreationDepositChannelFilter = {
  /** Aggregates across related `AccountCreationDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<AccountCreationDepositChannelAggregatesFilter>;
  /** Every related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** No related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Some related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCreationDepositChannelFilter>;
};

/** A filter to be used against many `Auction` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyAuctionFilter = {
  /** Aggregates across related `Auction` match the filter criteria. */
  aggregates?: InputMaybe<AuctionAggregatesFilter>;
  /** Every related `Auction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuctionFilter>;
  /** No related `Auction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuctionFilter>;
  /** Some related `Auction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuctionFilter>;
};

/** A filter to be used against many `AuthorityHeartbeat` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyAuthorityHeartbeatFilter = {
  /** Aggregates across related `AuthorityHeartbeat` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityHeartbeatAggregatesFilter>;
  /** Every related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityHeartbeatFilter>;
  /** No related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Some related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityHeartbeatFilter>;
};

/** A filter to be used against many `BoostNetworkFeeSplit` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyBoostNetworkFeeSplitFilter = {
  /** Aggregates across related `BoostNetworkFeeSplit` match the filter criteria. */
  aggregates?: InputMaybe<BoostNetworkFeeSplitAggregatesFilter>;
  /** Every related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** No related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** Some related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostNetworkFeeSplitFilter>;
};

/** A filter to be used against many `BrokerWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyBrokerWithdrawalFilter = {
  /** Aggregates across related `BrokerWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<BrokerWithdrawalAggregatesFilter>;
  /** Every related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerWithdrawalFilter>;
  /** No related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerWithdrawalFilter>;
  /** Some related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerWithdrawalFilter>;
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyEventFilter = {
  /** Aggregates across related `Event` match the filter criteria. */
  aggregates?: InputMaybe<EventAggregatesFilter>;
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** A filter to be used against many `Extrinsic` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyExtrinsicFilter = {
  /** Aggregates across related `Extrinsic` match the filter criteria. */
  aggregates?: InputMaybe<ExtrinsicAggregatesFilter>;
  /** Every related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExtrinsicFilter>;
  /** No related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExtrinsicFilter>;
  /** Some related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExtrinsicFilter>;
};

/** A filter to be used against many `ForeignChainTracking` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyForeignChainTrackingFilter = {
  /** Aggregates across related `ForeignChainTracking` match the filter criteria. */
  aggregates?: InputMaybe<ForeignChainTrackingAggregatesFilter>;
  /** Every related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ForeignChainTrackingFilter>;
  /** No related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ForeignChainTrackingFilter>;
  /** Some related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ForeignChainTrackingFilter>;
};

/** A filter to be used against many `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyLiquidityBalanceEventFilter = {
  /** Aggregates across related `LiquidityBalanceEvent` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityBalanceEventAggregatesFilter>;
  /** Every related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityBalanceEventFilter>;
  /** No related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Some related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityBalanceEventFilter>;
};

/** A filter to be used against many `LiquidityDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyLiquidityDepositChannelFilter = {
  /** Aggregates across related `LiquidityDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositChannelAggregatesFilter>;
  /** Every related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositChannelFilter>;
  /** No related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositChannelFilter>;
  /** Some related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositChannelFilter>;
};

/** A filter to be used against many `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyLiquidityDepositFilter = {
  /** Aggregates across related `LiquidityDeposit` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositAggregatesFilter>;
  /** Every related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositFilter>;
  /** No related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositFilter>;
  /** Some related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositFilter>;
};

/** A filter to be used against many `LiquidityTransfer` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyLiquidityTransferFilter = {
  /** Aggregates across related `LiquidityTransfer` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityTransferAggregatesFilter>;
  /** Every related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityTransferFilter>;
  /** No related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityTransferFilter>;
  /** Some related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityTransferFilter>;
};

/** A filter to be used against many `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyLiquidityWithdrawalFilter = {
  /** Aggregates across related `LiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityWithdrawalAggregatesFilter>;
  /** Every related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityWithdrawalFilter>;
  /** No related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Some related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityWithdrawalFilter>;
};

/** A filter to be used against many `Penalty` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyPenaltyFilter = {
  /** Aggregates across related `Penalty` match the filter criteria. */
  aggregates?: InputMaybe<PenaltyAggregatesFilter>;
  /** Every related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PenaltyFilter>;
  /** No related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PenaltyFilter>;
  /** Some related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PenaltyFilter>;
};

/** A filter to be used against many `SwapChannel` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManySwapChannelFilter = {
  /** Aggregates across related `SwapChannel` match the filter criteria. */
  aggregates?: InputMaybe<SwapChannelAggregatesFilter>;
  /** Every related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapChannelFilter>;
  /** No related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapChannelFilter>;
  /** Some related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapChannelFilter>;
};

/** A filter to be used against many `Validator` object types. All fields are combined with a logical ‘and.’ */
export type BlockToManyValidatorFilter = {
  /** Aggregates across related `Validator` match the filter criteria. */
  aggregates?: InputMaybe<ValidatorAggregatesFilter>;
  /** Every related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ValidatorFilter>;
  /** No related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ValidatorFilter>;
  /** Some related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ValidatorFilter>;
};

export type BlockVariancePopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type BlockVariancePopulationAggregates = {
  __typename?: 'BlockVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BlockVarianceSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  reward?: InputMaybe<BigFloatFilter>;
  rewardValueUsd?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type BlockVarianceSampleAggregates = {
  __typename?: 'BlockVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of reward across the matching connection */
  reward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rewardValueUsd across the matching connection */
  rewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Block` values. */
export type BlocksConnection = {
  __typename?: 'BlocksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BlockAggregates>;
  /** A list of edges which contains the `Block` and cursor to aid in pagination. */
  edges: Array<BlocksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BlockAggregates>>;
  /** A list of `Block` objects. */
  nodes: Array<Block>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Block` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Block` values. */
export type BlocksConnectionGroupedAggregatesArgs = {
  groupBy: Array<BlockGroupBy>;
  having?: InputMaybe<BlockHavingInput>;
};

export type BlocksDetails = {
  __typename?: 'BlocksDetails';
  blocks: Array<BlockDetails>;
};

/** A `Block` edge in the connection. */
export type BlocksEdge = {
  __typename?: 'BlocksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Block` at the end of the edge. */
  node: Block;
};

/** Methods to use when ordering `Block`. */
export type BlocksOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_REFUND_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_REFUND_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_COUNT_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_COUNT_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOND_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOND_DESC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUCTIONS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_COUNT_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_COUNT_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_AVERAGE_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_COUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_COUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MAX_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_MIN_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_SUM_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_COUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_COUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_AVERAGE_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_COUNT_ASC'
  | 'EVENTS_BY_BLOCK_ID_COUNT_DESC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MAX_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_MAX_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_MAX_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MAX_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_MIN_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_MIN_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_MIN_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_MIN_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_SUM_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_SUM_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_SUM_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_SUM_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_METADATA_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_METADATA_ID_ASC'
  | 'EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_AVERAGE_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_COUNT_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_COUNT_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_HASH_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_HASH_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SIGNATURE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SIGNATURE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SUCCESS_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_SUCCESS_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_DISTINCT_COUNT_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MAX_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_MIN_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_STDDEV_SAMPLE_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_SUM_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_BLOCK_ID_VARIANCE_SAMPLE_VERSION_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_AVERAGE_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_COUNT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_COUNT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_DISTINCT_COUNT_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MAX_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_MIN_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_POPULATION_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_STDDEV_SAMPLE_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_SUM_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_POPULATION_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_BLOCK_ID_VARIANCE_SAMPLE_STATE_CHAIN_EVENT_ID_DESC'
  | 'HASH_ASC'
  | 'HASH_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_COUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_COUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_COUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_COUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_COUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_COUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BLOCK_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NATURAL'
  | 'PARENT_HASH_ASC'
  | 'PARENT_HASH_DESC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_COUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_COUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_REASON_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_REASON_DESC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MAX_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_MIN_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_SUM_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_BLOCK_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REWARD_ASC'
  | 'REWARD_DESC'
  | 'REWARD_VALUE_USD_ASC'
  | 'REWARD_VALUE_USD_DESC'
  | 'STATE_ROOT_ASC'
  | 'STATE_ROOT_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_COUNT_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_COUNT_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_COUNT_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_CFE_VERSION_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_CFE_VERSION_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MAX_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_MIN_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_SUM_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_LAST_HEARTBEAT_BLOCK_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BoostNetworkFeeSplit = Node & {
  __typename?: 'BoostNetworkFeeSplit';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `BoostNetworkFeeSplit`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  boostedLiquidityDepositId?: Maybe<Scalars['Int']['output']>;
  boostedSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Event` that is related to this `BoostNetworkFeeSplit`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityDeposit` that is related to this `BoostNetworkFeeSplit`. */
  liquidityDepositByBoostedLiquidityDepositId?: Maybe<LiquidityDeposit>;
  networkFeeSwapRequestId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SwapRequest` that is related to this `BoostNetworkFeeSplit`. */
  swapRequestByBoostedSwapRequestId?: Maybe<SwapRequest>;
  /** Reads a single `SwapRequest` that is related to this `BoostNetworkFeeSplit`. */
  swapRequestByNetworkFeeSwapRequestId: SwapRequest;
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitAggregates = {
  __typename?: 'BoostNetworkFeeSplitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BoostNetworkFeeSplitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BoostNetworkFeeSplitDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BoostNetworkFeeSplitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BoostNetworkFeeSplitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BoostNetworkFeeSplitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BoostNetworkFeeSplitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BoostNetworkFeeSplitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BoostNetworkFeeSplitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BoostNetworkFeeSplitVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BoostNetworkFeeSplit` object types. */
export type BoostNetworkFeeSplitAggregatesFilter = {
  /** Mean average aggregate over matching `BoostNetworkFeeSplit` objects. */
  average?: InputMaybe<BoostNetworkFeeSplitAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BoostNetworkFeeSplit` objects. */
  distinctCount?: InputMaybe<BoostNetworkFeeSplitDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BoostNetworkFeeSplit` object to be included within the aggregate. */
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** Maximum aggregate over matching `BoostNetworkFeeSplit` objects. */
  max?: InputMaybe<BoostNetworkFeeSplitMaxAggregateFilter>;
  /** Minimum aggregate over matching `BoostNetworkFeeSplit` objects. */
  min?: InputMaybe<BoostNetworkFeeSplitMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BoostNetworkFeeSplit` objects. */
  stddevPopulation?: InputMaybe<BoostNetworkFeeSplitStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BoostNetworkFeeSplit` objects. */
  stddevSample?: InputMaybe<BoostNetworkFeeSplitStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BoostNetworkFeeSplit` objects. */
  sum?: InputMaybe<BoostNetworkFeeSplitSumAggregateFilter>;
  /** Population variance aggregate over matching `BoostNetworkFeeSplit` objects. */
  variancePopulation?: InputMaybe<BoostNetworkFeeSplitVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BoostNetworkFeeSplit` objects. */
  varianceSample?: InputMaybe<BoostNetworkFeeSplitVarianceSampleAggregateFilter>;
};

export type BoostNetworkFeeSplitAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigFloatFilter>;
  boostedSwapRequestId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitAverageAggregates = {
  __typename?: 'BoostNetworkFeeSplitAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BoostNetworkFeeSplit` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type BoostNetworkFeeSplitCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `boostedLiquidityDepositId` field. */
  boostedLiquidityDepositId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `boostedSwapRequestId` field. */
  boostedSwapRequestId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityDepositByBoostedLiquidityDepositId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `networkFeeSwapRequestId` field. */
  networkFeeSwapRequestId?: InputMaybe<Scalars['Int']['input']>;
  swapRequestByBoostedSwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  swapRequestByNetworkFeeSwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BoostNetworkFeeSplitDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigIntFilter>;
  boostedSwapRequestId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type BoostNetworkFeeSplitDistinctCountAggregates = {
  __typename?: 'BoostNetworkFeeSplitDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BoostNetworkFeeSplit` object types. All fields are combined with a logical ‘and.’ */
export type BoostNetworkFeeSplitFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BoostNetworkFeeSplitFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostedLiquidityDepositId` field. */
  boostedLiquidityDepositId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostedSwapRequestId` field. */
  boostedSwapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityDepositByBoostedLiquidityDepositId` relation. */
  liquidityDepositByBoostedLiquidityDepositId?: InputMaybe<LiquidityDepositFilter>;
  /** A related `liquidityDepositByBoostedLiquidityDepositId` exists. */
  liquidityDepositByBoostedLiquidityDepositIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `networkFeeSwapRequestId` field. */
  networkFeeSwapRequestId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BoostNetworkFeeSplitFilter>>;
  /** Filter by the object’s `swapRequestByBoostedSwapRequestId` relation. */
  swapRequestByBoostedSwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestByBoostedSwapRequestId` exists. */
  swapRequestByBoostedSwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestByNetworkFeeSwapRequestId` relation. */
  swapRequestByNetworkFeeSwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BoostNetworkFeeSplit` for usage during aggregation. */
export type BoostNetworkFeeSplitGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BLOCK_ID'
  | 'EVENT_ID'
  | 'VALUE_USD';

export type BoostNetworkFeeSplitHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BoostNetworkFeeSplit` aggregates. */
export type BoostNetworkFeeSplitHavingInput = {
  AND?: InputMaybe<Array<BoostNetworkFeeSplitHavingInput>>;
  OR?: InputMaybe<Array<BoostNetworkFeeSplitHavingInput>>;
  average?: InputMaybe<BoostNetworkFeeSplitHavingAverageInput>;
  distinctCount?: InputMaybe<BoostNetworkFeeSplitHavingDistinctCountInput>;
  max?: InputMaybe<BoostNetworkFeeSplitHavingMaxInput>;
  min?: InputMaybe<BoostNetworkFeeSplitHavingMinInput>;
  stddevPopulation?: InputMaybe<BoostNetworkFeeSplitHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BoostNetworkFeeSplitHavingStddevSampleInput>;
  sum?: InputMaybe<BoostNetworkFeeSplitHavingSumInput>;
  variancePopulation?: InputMaybe<BoostNetworkFeeSplitHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BoostNetworkFeeSplitHavingVarianceSampleInput>;
};

export type BoostNetworkFeeSplitHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<HavingIntFilter>;
  boostedSwapRequestId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BoostNetworkFeeSplitMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  boostedLiquidityDepositId?: InputMaybe<IntFilter>;
  boostedSwapRequestId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  networkFeeSwapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitMaxAggregates = {
  __typename?: 'BoostNetworkFeeSplitMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  boostedLiquidityDepositId?: InputMaybe<IntFilter>;
  boostedSwapRequestId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  networkFeeSwapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitMinAggregates = {
  __typename?: 'BoostNetworkFeeSplitMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigFloatFilter>;
  boostedSwapRequestId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitStddevPopulationAggregates = {
  __typename?: 'BoostNetworkFeeSplitStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigFloatFilter>;
  boostedSwapRequestId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitStddevSampleAggregates = {
  __typename?: 'BoostNetworkFeeSplitStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigIntFilter>;
  boostedSwapRequestId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitSumAggregates = {
  __typename?: 'BoostNetworkFeeSplitSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId: Scalars['BigInt']['output'];
  /** Sum of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type BoostNetworkFeeSplitVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigFloatFilter>;
  boostedSwapRequestId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitVariancePopulationAggregates = {
  __typename?: 'BoostNetworkFeeSplitVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BoostNetworkFeeSplitVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  boostedLiquidityDepositId?: InputMaybe<BigFloatFilter>;
  boostedSwapRequestId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  networkFeeSwapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BoostNetworkFeeSplitVarianceSampleAggregates = {
  __typename?: 'BoostNetworkFeeSplitVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostedLiquidityDepositId across the matching connection */
  boostedLiquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of boostedSwapRequestId across the matching connection */
  boostedSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeeSwapRequestId across the matching connection */
  networkFeeSwapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BoostNetworkFeeSplit` values. */
export type BoostNetworkFeeSplitsConnection = {
  __typename?: 'BoostNetworkFeeSplitsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BoostNetworkFeeSplitAggregates>;
  /** A list of edges which contains the `BoostNetworkFeeSplit` and cursor to aid in pagination. */
  edges: Array<BoostNetworkFeeSplitsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BoostNetworkFeeSplitAggregates>>;
  /** A list of `BoostNetworkFeeSplit` objects. */
  nodes: Array<BoostNetworkFeeSplit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BoostNetworkFeeSplit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BoostNetworkFeeSplit` values. */
export type BoostNetworkFeeSplitsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BoostNetworkFeeSplitGroupBy>;
  having?: InputMaybe<BoostNetworkFeeSplitHavingInput>;
};

/** A `BoostNetworkFeeSplit` edge in the connection. */
export type BoostNetworkFeeSplitsEdge = {
  __typename?: 'BoostNetworkFeeSplitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BoostNetworkFeeSplit` at the end of the edge. */
  node: BoostNetworkFeeSplit;
};

/** Methods to use when ordering `BoostNetworkFeeSplit`. */
export type BoostNetworkFeeSplitsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type Broadcast = Node & {
  __typename?: 'Broadcast';
  broadcastAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Broadcast` that is related to this `Broadcast`. */
  broadcastByReplacedById?: Maybe<Broadcast>;
  broadcastRequestedEventId: Scalars['BigInt']['output'];
  broadcastSuccessEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `Broadcast`. */
  broadcastsByReplacedById: BroadcastsConnection;
  destinationChain: ChainflipChain;
  /** Reads and enables pagination through a set of `Egress`. */
  egressesByBroadcastId: EgressesConnection;
  /** Reads and enables pagination through a set of `Egress`. */
  egressesByFallbackBroadcastId: EgressesConnection;
  /** Reads a single `Event` that is related to this `Broadcast`. */
  eventByBroadcastAbortedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Broadcast`. */
  eventByBroadcastRequestedEventId: Event;
  /** Reads a single `Event` that is related to this `Broadcast`. */
  eventByBroadcastSuccessEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Broadcast`. */
  eventByTransactionBroadcastRequestEventId?: Maybe<Event>;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByRefundBroadcastId: FailedDepositsConnection;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByBroadcastId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByBroadcastId: LiquidityWithdrawalsConnection;
  nativeId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  replacedById?: Maybe<Scalars['Int']['output']>;
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigInt']['output']>;
  transactionPayload?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `TransactionRef`. */
  transactionRefsByBroadcastId: TransactionRefsConnection;
};


export type BroadcastBroadcastsByReplacedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


export type BroadcastEgressesByBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EgressCondition>;
  filter?: InputMaybe<EgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EgressesOrderBy>>;
};


export type BroadcastEgressesByFallbackBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EgressCondition>;
  filter?: InputMaybe<EgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EgressesOrderBy>>;
};


export type BroadcastFailedDepositsByRefundBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type BroadcastLiquidityBalanceEventsByBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type BroadcastLiquidityWithdrawalsByBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


export type BroadcastTransactionRefsByBroadcastIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransactionRefCondition>;
  filter?: InputMaybe<TransactionRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransactionRefsOrderBy>>;
};

export type BroadcastAggregates = {
  __typename?: 'BroadcastAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BroadcastAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BroadcastDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BroadcastMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BroadcastMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BroadcastStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BroadcastStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BroadcastSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BroadcastVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BroadcastVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Broadcast` object types. */
export type BroadcastAggregatesFilter = {
  /** Mean average aggregate over matching `Broadcast` objects. */
  average?: InputMaybe<BroadcastAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Broadcast` objects. */
  distinctCount?: InputMaybe<BroadcastDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Broadcast` object to be included within the aggregate. */
  filter?: InputMaybe<BroadcastFilter>;
  /** Maximum aggregate over matching `Broadcast` objects. */
  max?: InputMaybe<BroadcastMaxAggregateFilter>;
  /** Minimum aggregate over matching `Broadcast` objects. */
  min?: InputMaybe<BroadcastMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Broadcast` objects. */
  stddevPopulation?: InputMaybe<BroadcastStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Broadcast` objects. */
  stddevSample?: InputMaybe<BroadcastStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Broadcast` objects. */
  sum?: InputMaybe<BroadcastSumAggregateFilter>;
  /** Population variance aggregate over matching `Broadcast` objects. */
  variancePopulation?: InputMaybe<BroadcastVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Broadcast` objects. */
  varianceSample?: InputMaybe<BroadcastVarianceSampleAggregateFilter>;
};

export type BroadcastAverageAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  replacedById?: InputMaybe<BigFloatFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastAverageAggregates = {
  __typename?: 'BroadcastAverageAggregates';
  /** Mean average of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Broadcast` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type BroadcastCondition = {
  /** Checks for equality with the object’s `broadcastAbortedEventId` field. */
  broadcastAbortedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  broadcastByReplacedById?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `broadcastRequestedEventId` field. */
  broadcastRequestedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `broadcastSuccessEventId` field. */
  broadcastSuccessEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChain>;
  eventByBroadcastAbortedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByBroadcastRequestedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByBroadcastSuccessEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByTransactionBroadcastRequestEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nativeId` field. */
  nativeId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `replacedById` field. */
  replacedById?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `transactionBroadcastRequestEventId` field. */
  transactionBroadcastRequestEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `transactionPayload` field. */
  transactionPayload?: InputMaybe<Scalars['String']['input']>;
};

export type BroadcastDistinctCountAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigIntFilter>;
  broadcastRequestedEventId?: InputMaybe<BigIntFilter>;
  broadcastSuccessEventId?: InputMaybe<BigIntFilter>;
  destinationChain?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  replacedById?: InputMaybe<BigIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigIntFilter>;
  transactionPayload?: InputMaybe<BigIntFilter>;
};

export type BroadcastDistinctCountAggregates = {
  __typename?: 'BroadcastDistinctCountAggregates';
  /** Distinct count of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationChain across the matching connection */
  destinationChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of transactionPayload across the matching connection */
  transactionPayload?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Broadcast` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BroadcastFilter>>;
  /** Filter by the object’s `broadcastAbortedEventId` field. */
  broadcastAbortedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `broadcastByReplacedById` relation. */
  broadcastByReplacedById?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByReplacedById` exists. */
  broadcastByReplacedByIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastRequestedEventId` field. */
  broadcastRequestedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `broadcastSuccessEventId` field. */
  broadcastSuccessEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `broadcastsByReplacedById` relation. */
  broadcastsByReplacedById?: InputMaybe<BroadcastToManyBroadcastFilter>;
  /** Some related `broadcastsByReplacedById` exist. */
  broadcastsByReplacedByIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `egressesByBroadcastId` relation. */
  egressesByBroadcastId?: InputMaybe<BroadcastToManyEgressFilter>;
  /** Some related `egressesByBroadcastId` exist. */
  egressesByBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressesByFallbackBroadcastId` relation. */
  egressesByFallbackBroadcastId?: InputMaybe<BroadcastToManyEgressFilter>;
  /** Some related `egressesByFallbackBroadcastId` exist. */
  egressesByFallbackBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByBroadcastAbortedEventId` relation. */
  eventByBroadcastAbortedEventId?: InputMaybe<EventFilter>;
  /** A related `eventByBroadcastAbortedEventId` exists. */
  eventByBroadcastAbortedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByBroadcastRequestedEventId` relation. */
  eventByBroadcastRequestedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventByBroadcastSuccessEventId` relation. */
  eventByBroadcastSuccessEventId?: InputMaybe<EventFilter>;
  /** A related `eventByBroadcastSuccessEventId` exists. */
  eventByBroadcastSuccessEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByTransactionBroadcastRequestEventId` relation. */
  eventByTransactionBroadcastRequestEventId?: InputMaybe<EventFilter>;
  /** A related `eventByTransactionBroadcastRequestEventId` exists. */
  eventByTransactionBroadcastRequestEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `failedDepositsByRefundBroadcastId` relation. */
  failedDepositsByRefundBroadcastId?: InputMaybe<BroadcastToManyFailedDepositFilter>;
  /** Some related `failedDepositsByRefundBroadcastId` exist. */
  failedDepositsByRefundBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityBalanceEventsByBroadcastId` relation. */
  liquidityBalanceEventsByBroadcastId?: InputMaybe<BroadcastToManyLiquidityBalanceEventFilter>;
  /** Some related `liquidityBalanceEventsByBroadcastId` exist. */
  liquidityBalanceEventsByBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityWithdrawalsByBroadcastId` relation. */
  liquidityWithdrawalsByBroadcastId?: InputMaybe<BroadcastToManyLiquidityWithdrawalFilter>;
  /** Some related `liquidityWithdrawalsByBroadcastId` exist. */
  liquidityWithdrawalsByBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `nativeId` field. */
  nativeId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BroadcastFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BroadcastFilter>>;
  /** Filter by the object’s `replacedById` field. */
  replacedById?: InputMaybe<IntFilter>;
  /** Filter by the object’s `transactionBroadcastRequestEventId` field. */
  transactionBroadcastRequestEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `transactionPayload` field. */
  transactionPayload?: InputMaybe<StringFilter>;
  /** Filter by the object’s `transactionRefsByBroadcastId` relation. */
  transactionRefsByBroadcastId?: InputMaybe<BroadcastToManyTransactionRefFilter>;
  /** Some related `transactionRefsByBroadcastId` exist. */
  transactionRefsByBroadcastIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Broadcast` for usage during aggregation. */
export type BroadcastGroupBy =
  | 'BROADCAST_ABORTED_EVENT_ID'
  | 'BROADCAST_REQUESTED_EVENT_ID'
  | 'BROADCAST_SUCCESS_EVENT_ID'
  | 'DESTINATION_CHAIN'
  | 'NATIVE_ID'
  | 'REPLACED_BY_ID'
  | 'TRANSACTION_BROADCAST_REQUEST_EVENT_ID'
  | 'TRANSACTION_PAYLOAD';

export type BroadcastHavingAverageInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingDistinctCountInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `Broadcast` aggregates. */
export type BroadcastHavingInput = {
  AND?: InputMaybe<Array<BroadcastHavingInput>>;
  OR?: InputMaybe<Array<BroadcastHavingInput>>;
  average?: InputMaybe<BroadcastHavingAverageInput>;
  distinctCount?: InputMaybe<BroadcastHavingDistinctCountInput>;
  max?: InputMaybe<BroadcastHavingMaxInput>;
  min?: InputMaybe<BroadcastHavingMinInput>;
  stddevPopulation?: InputMaybe<BroadcastHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BroadcastHavingStddevSampleInput>;
  sum?: InputMaybe<BroadcastHavingSumInput>;
  variancePopulation?: InputMaybe<BroadcastHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BroadcastHavingVarianceSampleInput>;
};

export type BroadcastHavingMaxInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingMinInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingStddevPopulationInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingStddevSampleInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingSumInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingVariancePopulationInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastHavingVarianceSampleInput = {
  broadcastAbortedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastRequestedEventId?: InputMaybe<HavingBigintFilter>;
  broadcastSuccessEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingIntFilter>;
  replacedById?: InputMaybe<HavingIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<HavingBigintFilter>;
};

export type BroadcastMaxAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigIntFilter>;
  broadcastRequestedEventId?: InputMaybe<BigIntFilter>;
  broadcastSuccessEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<IntFilter>;
  replacedById?: InputMaybe<IntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigIntFilter>;
};

export type BroadcastMaxAggregates = {
  __typename?: 'BroadcastMaxAggregates';
  /** Maximum of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['Int']['output']>;
  /** Maximum of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BroadcastMinAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigIntFilter>;
  broadcastRequestedEventId?: InputMaybe<BigIntFilter>;
  broadcastSuccessEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<IntFilter>;
  replacedById?: InputMaybe<IntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigIntFilter>;
};

export type BroadcastMinAggregates = {
  __typename?: 'BroadcastMinAggregates';
  /** Minimum of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['Int']['output']>;
  /** Minimum of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BroadcastStddevPopulationAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  replacedById?: InputMaybe<BigFloatFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastStddevPopulationAggregates = {
  __typename?: 'BroadcastStddevPopulationAggregates';
  /** Population standard deviation of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BroadcastStddevSampleAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  replacedById?: InputMaybe<BigFloatFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastStddevSampleAggregates = {
  __typename?: 'BroadcastStddevSampleAggregates';
  /** Sample standard deviation of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BroadcastSumAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  replacedById?: InputMaybe<BigIntFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastSumAggregates = {
  __typename?: 'BroadcastSumAggregates';
  /** Sum of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId: Scalars['BigFloat']['output'];
  /** Sum of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId: Scalars['BigFloat']['output'];
  /** Sum of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of nativeId across the matching connection */
  nativeId: Scalars['BigInt']['output'];
  /** Sum of replacedById across the matching connection */
  replacedById: Scalars['BigInt']['output'];
  /** Sum of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `Broadcast` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyBroadcastFilter = {
  /** Aggregates across related `Broadcast` match the filter criteria. */
  aggregates?: InputMaybe<BroadcastAggregatesFilter>;
  /** Every related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BroadcastFilter>;
  /** No related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BroadcastFilter>;
  /** Some related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BroadcastFilter>;
};

/** A filter to be used against many `Egress` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyEgressFilter = {
  /** Aggregates across related `Egress` match the filter criteria. */
  aggregates?: InputMaybe<EgressAggregatesFilter>;
  /** Every related `Egress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EgressFilter>;
  /** No related `Egress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EgressFilter>;
  /** Some related `Egress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EgressFilter>;
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyLiquidityBalanceEventFilter = {
  /** Aggregates across related `LiquidityBalanceEvent` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityBalanceEventAggregatesFilter>;
  /** Every related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityBalanceEventFilter>;
  /** No related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Some related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityBalanceEventFilter>;
};

/** A filter to be used against many `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyLiquidityWithdrawalFilter = {
  /** Aggregates across related `LiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityWithdrawalAggregatesFilter>;
  /** Every related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityWithdrawalFilter>;
  /** No related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Some related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityWithdrawalFilter>;
};

/** A filter to be used against many `TransactionRef` object types. All fields are combined with a logical ‘and.’ */
export type BroadcastToManyTransactionRefFilter = {
  /** Aggregates across related `TransactionRef` match the filter criteria. */
  aggregates?: InputMaybe<TransactionRefAggregatesFilter>;
  /** Every related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TransactionRefFilter>;
  /** No related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TransactionRefFilter>;
  /** Some related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TransactionRefFilter>;
};

export type BroadcastVariancePopulationAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  replacedById?: InputMaybe<BigFloatFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastVariancePopulationAggregates = {
  __typename?: 'BroadcastVariancePopulationAggregates';
  /** Population variance of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BroadcastVarianceSampleAggregateFilter = {
  broadcastAbortedEventId?: InputMaybe<BigFloatFilter>;
  broadcastRequestedEventId?: InputMaybe<BigFloatFilter>;
  broadcastSuccessEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  replacedById?: InputMaybe<BigFloatFilter>;
  transactionBroadcastRequestEventId?: InputMaybe<BigFloatFilter>;
};

export type BroadcastVarianceSampleAggregates = {
  __typename?: 'BroadcastVarianceSampleAggregates';
  /** Sample variance of broadcastAbortedEventId across the matching connection */
  broadcastAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of broadcastRequestedEventId across the matching connection */
  broadcastRequestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of broadcastSuccessEventId across the matching connection */
  broadcastSuccessEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of replacedById across the matching connection */
  replacedById?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of transactionBroadcastRequestEventId across the matching connection */
  transactionBroadcastRequestEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Broadcast` values. */
export type BroadcastsConnection = {
  __typename?: 'BroadcastsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BroadcastAggregates>;
  /** A list of edges which contains the `Broadcast` and cursor to aid in pagination. */
  edges: Array<BroadcastsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BroadcastAggregates>>;
  /** A list of `Broadcast` objects. */
  nodes: Array<Broadcast>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Broadcast` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Broadcast` values. */
export type BroadcastsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BroadcastGroupBy>;
  having?: InputMaybe<BroadcastHavingInput>;
};

/** A `Broadcast` edge in the connection. */
export type BroadcastsEdge = {
  __typename?: 'BroadcastsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Broadcast` at the end of the edge. */
  node: Broadcast;
};

/** Methods to use when ordering `Broadcast`. */
export type BroadcastsOrderBy =
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_COUNT_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_COUNT_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_REPLACED_BY_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'DESTINATION_CHAIN_ASC'
  | 'DESTINATION_CHAIN_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_AVERAGE_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_COUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_COUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_DESTINATION_ADDRESS_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_DESTINATION_ADDRESS_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MAX_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_MIN_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_SUM_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'EGRESSES_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_AVERAGE_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_COUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_COUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_DESTINATION_ADDRESS_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_FALLBACK_DESTINATION_ADDRESS_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MAX_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_MIN_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_SUM_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_FALLBACK_BROADCAST_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_FALLBACK_BROADCAST_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_SCHEDULED_EVENT_ID_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_SCHEDULED_EVENT_ID_DESC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'EGRESSES_BY_FALLBACK_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_BROADCAST_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_COUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_COUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_COUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_COUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_BROADCAST_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NATIVE_ID_ASC'
  | 'NATIVE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REPLACED_BY_ID_ASC'
  | 'REPLACED_BY_ID_DESC'
  | 'TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'TRANSACTION_PAYLOAD_ASC'
  | 'TRANSACTION_PAYLOAD_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_COUNT_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_COUNT_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_REF_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_REF_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_BROADCAST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC';

export type Broker = Node & {
  __typename?: 'Broker';
  /** Reads a single `Account` that is related to this `Broker`. */
  accountByAccountId: Account;
  /** Reads and enables pagination through a set of `AccountCreationDepositChannel`. */
  accountCreationDepositChannelsByBrokerId: AccountCreationDepositChannelsConnection;
  accountId: Scalars['Int']['output'];
  /** Reads a single `Broker` that is related to this `Broker`. */
  brokerByDelegateBrokerId?: Maybe<Broker>;
  /** Reads and enables pagination through a set of `BrokerChannel`. */
  brokerChannelsByBrokerId: BrokerChannelsConnection;
  /** Reads and enables pagination through a set of `BrokerFeeAndWithdrawalV2`. */
  brokerFeeAndWithdrawalV2SByAffiliatedWithBrokerId: BrokerFeeAndWithdrawalV2SConnection;
  /** Reads and enables pagination through a set of `BrokerFeeAndWithdrawalV2`. */
  brokerFeeAndWithdrawalV2SByBrokerId: BrokerFeeAndWithdrawalV2SConnection;
  /** Reads and enables pagination through a set of `BrokerVaultAddress`. */
  brokerVaultAddressesByBrokerId: BrokerVaultAddressesConnection;
  /** Reads and enables pagination through a set of `BrokerWithdrawal`. */
  brokerWithdrawalsByBrokerId: BrokerWithdrawalsConnection;
  /** Reads and enables pagination through a set of `Broker`. */
  brokersByDelegateBrokerId: BrokersConnection;
  delegateBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Event` that is related to this `Broker`. */
  eventByRegistratonEventId?: Maybe<Event>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  registrationId?: Maybe<Scalars['Int']['output']>;
  registratonEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `SwapChannel`. */
  swapChannelsByBrokerId: SwapChannelsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByBrokerId: SwapRequestsConnection;
  withdrawalAddress?: Maybe<Scalars['String']['output']>;
};


export type BrokerAccountCreationDepositChannelsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCreationDepositChannelCondition>;
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCreationDepositChannelsOrderBy>>;
};


export type BrokerBrokerChannelsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerChannelCondition>;
  filter?: InputMaybe<BrokerChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerChannelsOrderBy>>;
};


export type BrokerBrokerFeeAndWithdrawalV2SByAffiliatedWithBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerFeeAndWithdrawalV2Condition>;
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerFeeAndWithdrawalV2SOrderBy>>;
};


export type BrokerBrokerFeeAndWithdrawalV2SByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerFeeAndWithdrawalV2Condition>;
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerFeeAndWithdrawalV2SOrderBy>>;
};


export type BrokerBrokerVaultAddressesByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerVaultAddressCondition>;
  filter?: InputMaybe<BrokerVaultAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerVaultAddressesOrderBy>>;
};


export type BrokerBrokerWithdrawalsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerWithdrawalCondition>;
  filter?: InputMaybe<BrokerWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerWithdrawalsOrderBy>>;
};


export type BrokerBrokersByDelegateBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerCondition>;
  filter?: InputMaybe<BrokerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokersOrderBy>>;
};


export type BrokerSwapChannelsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelCondition>;
  filter?: InputMaybe<SwapChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelsOrderBy>>;
};


export type BrokerSwapRequestsByBrokerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type BrokerAggregates = {
  __typename?: 'BrokerAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Broker` object types. */
export type BrokerAggregatesFilter = {
  /** Mean average aggregate over matching `Broker` objects. */
  average?: InputMaybe<BrokerAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Broker` objects. */
  distinctCount?: InputMaybe<BrokerDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Broker` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerFilter>;
  /** Maximum aggregate over matching `Broker` objects. */
  max?: InputMaybe<BrokerMaxAggregateFilter>;
  /** Minimum aggregate over matching `Broker` objects. */
  min?: InputMaybe<BrokerMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Broker` objects. */
  stddevPopulation?: InputMaybe<BrokerStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Broker` objects. */
  stddevSample?: InputMaybe<BrokerStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Broker` objects. */
  sum?: InputMaybe<BrokerSumAggregateFilter>;
  /** Population variance aggregate over matching `Broker` objects. */
  variancePopulation?: InputMaybe<BrokerVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Broker` objects. */
  varianceSample?: InputMaybe<BrokerVarianceSampleAggregateFilter>;
};

export type BrokerAllTimeStat = {
  __typename?: 'BrokerAllTimeStat';
  totalCount?: Maybe<Scalars['BigInt']['output']>;
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatAggregates = {
  __typename?: 'BrokerAllTimeStatAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerAllTimeStatAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerAllTimeStatDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerAllTimeStatMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerAllTimeStatMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerAllTimeStatStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerAllTimeStatStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerAllTimeStatSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerAllTimeStatVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerAllTimeStatVarianceSampleAggregates>;
};

export type BrokerAllTimeStatAverageAggregates = {
  __typename?: 'BrokerAllTimeStatAverageAggregates';
  /** Mean average of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerAllTimeStat` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerAllTimeStatCondition = {
  /** Checks for equality with the object’s `totalCount` field. */
  totalCount?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalVolume` field. */
  totalVolume?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BrokerAllTimeStatDistinctCountAggregates = {
  __typename?: 'BrokerAllTimeStatDistinctCountAggregates';
  /** Distinct count of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerAllTimeStat` object types. All fields are combined with a logical ‘and.’ */
export type BrokerAllTimeStatFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerAllTimeStatFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerAllTimeStatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerAllTimeStatFilter>>;
  /** Filter by the object’s `totalCount` field. */
  totalCount?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `totalVolume` field. */
  totalVolume?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BrokerAllTimeStat` for usage during aggregation. */
export type BrokerAllTimeStatGroupBy =
  | 'TOTAL_COUNT'
  | 'TOTAL_VOLUME';

export type BrokerAllTimeStatHavingAverageInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingDistinctCountInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BrokerAllTimeStat` aggregates. */
export type BrokerAllTimeStatHavingInput = {
  AND?: InputMaybe<Array<BrokerAllTimeStatHavingInput>>;
  OR?: InputMaybe<Array<BrokerAllTimeStatHavingInput>>;
  average?: InputMaybe<BrokerAllTimeStatHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerAllTimeStatHavingDistinctCountInput>;
  max?: InputMaybe<BrokerAllTimeStatHavingMaxInput>;
  min?: InputMaybe<BrokerAllTimeStatHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerAllTimeStatHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerAllTimeStatHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerAllTimeStatHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerAllTimeStatHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerAllTimeStatHavingVarianceSampleInput>;
};

export type BrokerAllTimeStatHavingMaxInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingMinInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingStddevPopulationInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingStddevSampleInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingSumInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingVariancePopulationInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatHavingVarianceSampleInput = {
  totalCount?: InputMaybe<HavingBigintFilter>;
  totalVolume?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerAllTimeStatMaxAggregates = {
  __typename?: 'BrokerAllTimeStatMaxAggregates';
  /** Maximum of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatMinAggregates = {
  __typename?: 'BrokerAllTimeStatMinAggregates';
  /** Minimum of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatStddevPopulationAggregates = {
  __typename?: 'BrokerAllTimeStatStddevPopulationAggregates';
  /** Population standard deviation of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatStddevSampleAggregates = {
  __typename?: 'BrokerAllTimeStatStddevSampleAggregates';
  /** Sample standard deviation of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatSumAggregates = {
  __typename?: 'BrokerAllTimeStatSumAggregates';
  /** Sum of totalCount across the matching connection */
  totalCount: Scalars['BigFloat']['output'];
  /** Sum of totalVolume across the matching connection */
  totalVolume: Scalars['BigFloat']['output'];
};

export type BrokerAllTimeStatVariancePopulationAggregates = {
  __typename?: 'BrokerAllTimeStatVariancePopulationAggregates';
  /** Population variance of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerAllTimeStatVarianceSampleAggregates = {
  __typename?: 'BrokerAllTimeStatVarianceSampleAggregates';
  /** Sample variance of totalCount across the matching connection */
  totalCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalVolume across the matching connection */
  totalVolume?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerAllTimeStat` values. */
export type BrokerAllTimeStatsConnection = {
  __typename?: 'BrokerAllTimeStatsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerAllTimeStatAggregates>;
  /** A list of edges which contains the `BrokerAllTimeStat` and cursor to aid in pagination. */
  edges: Array<BrokerAllTimeStatsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerAllTimeStatAggregates>>;
  /** A list of `BrokerAllTimeStat` objects. */
  nodes: Array<BrokerAllTimeStat>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerAllTimeStat` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerAllTimeStat` values. */
export type BrokerAllTimeStatsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerAllTimeStatGroupBy>;
  having?: InputMaybe<BrokerAllTimeStatHavingInput>;
};

/** A `BrokerAllTimeStat` edge in the connection. */
export type BrokerAllTimeStatsEdge = {
  __typename?: 'BrokerAllTimeStatsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerAllTimeStat` at the end of the edge. */
  node: BrokerAllTimeStat;
};

/** Methods to use when ordering `BrokerAllTimeStat`. */
export type BrokerAllTimeStatsOrderBy =
  | 'NATURAL'
  | 'TOTAL_COUNT_ASC'
  | 'TOTAL_COUNT_DESC'
  | 'TOTAL_VOLUME_ASC'
  | 'TOTAL_VOLUME_DESC';

export type BrokerAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  delegateBrokerId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerAverageAggregates = {
  __typename?: 'BrokerAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerChannel = Node & {
  __typename?: 'BrokerChannel';
  asset: ChainflipAsset;
  /** Reads a single `Broker` that is related to this `BrokerChannel`. */
  brokerByBrokerId: Broker;
  brokerId: Scalars['Int']['output'];
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['output'];
  closeEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Event` that is related to this `BrokerChannel`. */
  eventByCloseEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `BrokerChannel`. */
  eventByOpenEventId: Event;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByBrokerChannelId: FailedDepositsConnection;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openEventId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByBrokerChannelId: SwapRequestsConnection;
};


export type BrokerChannelFailedDepositsByBrokerChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type BrokerChannelSwapRequestsByBrokerChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type BrokerChannelAggregates = {
  __typename?: 'BrokerChannelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerChannelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerChannelDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerChannelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerChannelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerChannelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerChannelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerChannelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerChannelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerChannelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerChannel` object types. */
export type BrokerChannelAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerChannel` objects. */
  average?: InputMaybe<BrokerChannelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerChannel` objects. */
  distinctCount?: InputMaybe<BrokerChannelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerChannel` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerChannelFilter>;
  /** Maximum aggregate over matching `BrokerChannel` objects. */
  max?: InputMaybe<BrokerChannelMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerChannel` objects. */
  min?: InputMaybe<BrokerChannelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerChannel` objects. */
  stddevPopulation?: InputMaybe<BrokerChannelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerChannel` objects. */
  stddevSample?: InputMaybe<BrokerChannelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerChannel` objects. */
  sum?: InputMaybe<BrokerChannelSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerChannel` objects. */
  variancePopulation?: InputMaybe<BrokerChannelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerChannel` objects. */
  varianceSample?: InputMaybe<BrokerChannelVarianceSampleAggregateFilter>;
};

export type BrokerChannelAverageAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelAverageAggregates = {
  __typename?: 'BrokerChannelAverageAggregates';
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerChannel` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerChannelCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `closeEventId` field. */
  closeEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByCloseEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByOpenEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openEventId` field. */
  openEventId?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BrokerChannelDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  openEventId?: InputMaybe<BigIntFilter>;
};

export type BrokerChannelDistinctCountAggregates = {
  __typename?: 'BrokerChannelDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerChannel` object types. All fields are combined with a logical ‘and.’ */
export type BrokerChannelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerChannelFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `closeEventId` field. */
  closeEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByCloseEventId` relation. */
  eventByCloseEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCloseEventId` exists. */
  eventByCloseEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByOpenEventId` relation. */
  eventByOpenEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `failedDepositsByBrokerChannelId` relation. */
  failedDepositsByBrokerChannelId?: InputMaybe<BrokerChannelToManyFailedDepositFilter>;
  /** Some related `failedDepositsByBrokerChannelId` exist. */
  failedDepositsByBrokerChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerChannelFilter>;
  /** Filter by the object’s `openEventId` field. */
  openEventId?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerChannelFilter>>;
  /** Filter by the object’s `swapRequestsByBrokerChannelId` relation. */
  swapRequestsByBrokerChannelId?: InputMaybe<BrokerChannelToManySwapRequestFilter>;
  /** Some related `swapRequestsByBrokerChannelId` exist. */
  swapRequestsByBrokerChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `BrokerChannel` for usage during aggregation. */
export type BrokerChannelGroupBy =
  | 'ASSET'
  | 'BROKER_ID'
  | 'CHAIN'
  | 'CHANNEL_ID'
  | 'CLOSE_EVENT_ID'
  | 'OPEN_EVENT_ID';

export type BrokerChannelHavingAverageInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingDistinctCountInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `BrokerChannel` aggregates. */
export type BrokerChannelHavingInput = {
  AND?: InputMaybe<Array<BrokerChannelHavingInput>>;
  OR?: InputMaybe<Array<BrokerChannelHavingInput>>;
  average?: InputMaybe<BrokerChannelHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerChannelHavingDistinctCountInput>;
  max?: InputMaybe<BrokerChannelHavingMaxInput>;
  min?: InputMaybe<BrokerChannelHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerChannelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerChannelHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerChannelHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerChannelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerChannelHavingVarianceSampleInput>;
};

export type BrokerChannelHavingMaxInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingMinInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingStddevPopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingStddevSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingSumInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingVariancePopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelHavingVarianceSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  closeEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  openEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerChannelMaxAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  openEventId?: InputMaybe<BigIntFilter>;
};

export type BrokerChannelMaxAggregates = {
  __typename?: 'BrokerChannelMaxAggregates';
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerChannelMinAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  closeEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  openEventId?: InputMaybe<BigIntFilter>;
};

export type BrokerChannelMinAggregates = {
  __typename?: 'BrokerChannelMinAggregates';
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerChannelStddevPopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelStddevPopulationAggregates = {
  __typename?: 'BrokerChannelStddevPopulationAggregates';
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerChannelStddevSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelStddevSampleAggregates = {
  __typename?: 'BrokerChannelStddevSampleAggregates';
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerChannelSumAggregateFilter = {
  brokerId?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelSumAggregates = {
  __typename?: 'BrokerChannelSumAggregates';
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of channelId across the matching connection */
  channelId: Scalars['BigFloat']['output'];
  /** Sum of closeEventId across the matching connection */
  closeEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of openEventId across the matching connection */
  openEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type BrokerChannelToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type BrokerChannelToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type BrokerChannelVariancePopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelVariancePopulationAggregates = {
  __typename?: 'BrokerChannelVariancePopulationAggregates';
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerChannelVarianceSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  closeEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  openEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerChannelVarianceSampleAggregates = {
  __typename?: 'BrokerChannelVarianceSampleAggregates';
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of closeEventId across the matching connection */
  closeEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of openEventId across the matching connection */
  openEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerChannel` values. */
export type BrokerChannelsConnection = {
  __typename?: 'BrokerChannelsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerChannelAggregates>;
  /** A list of edges which contains the `BrokerChannel` and cursor to aid in pagination. */
  edges: Array<BrokerChannelsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerChannelAggregates>>;
  /** A list of `BrokerChannel` objects. */
  nodes: Array<BrokerChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerChannel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerChannel` values. */
export type BrokerChannelsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerChannelGroupBy>;
  having?: InputMaybe<BrokerChannelHavingInput>;
};

/** A `BrokerChannel` edge in the connection. */
export type BrokerChannelsEdge = {
  __typename?: 'BrokerChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerChannel` at the end of the edge. */
  node: BrokerChannel;
};

/** Methods to use when ordering `BrokerChannel`. */
export type BrokerChannelsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'CHANNEL_ID_ASC'
  | 'CHANNEL_ID_DESC'
  | 'CLOSE_EVENT_ID_ASC'
  | 'CLOSE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPEN_EVENT_ID_ASC'
  | 'OPEN_EVENT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC';

/** A condition to be used against `Broker` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BrokerCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  brokerByDelegateBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<Scalars['Int']['input']>;
  eventByRegistratonEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `registrationId` field. */
  registrationId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `registratonEventId` field. */
  registratonEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

export type BrokerDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  delegateBrokerId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
  registratonEventId?: InputMaybe<BigIntFilter>;
  withdrawalAddress?: InputMaybe<BigIntFilter>;
};

export type BrokerDistinctCountAggregates = {
  __typename?: 'BrokerDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawalAddress across the matching connection */
  withdrawalAddress?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerFeeAndWithdrawalV2 = {
  __typename?: 'BrokerFeeAndWithdrawalV2';
  affiliatedWithBrokerId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Broker` that is related to this `BrokerFeeAndWithdrawalV2`. */
  brokerByAffiliatedWithBrokerId?: Maybe<Broker>;
  /** Reads a single `Broker` that is related to this `BrokerFeeAndWithdrawalV2`. */
  brokerByBrokerId: Broker;
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  brokerId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `BrokerFeeAndWithdrawalV2`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  type: Scalars['String']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type BrokerFeeAndWithdrawalV2Aggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2Aggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerFeeAndWithdrawalV2AverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerFeeAndWithdrawalV2DistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerFeeAndWithdrawalV2MaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerFeeAndWithdrawalV2MinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerFeeAndWithdrawalV2StddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerFeeAndWithdrawalV2StddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerFeeAndWithdrawalV2SumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerFeeAndWithdrawalV2VariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerFeeAndWithdrawalV2VarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerFeeAndWithdrawalV2` object types. */
export type BrokerFeeAndWithdrawalV2AggregatesFilter = {
  /** Mean average aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  average?: InputMaybe<BrokerFeeAndWithdrawalV2AverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  distinctCount?: InputMaybe<BrokerFeeAndWithdrawalV2DistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerFeeAndWithdrawalV2` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  /** Maximum aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  max?: InputMaybe<BrokerFeeAndWithdrawalV2MaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  min?: InputMaybe<BrokerFeeAndWithdrawalV2MinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  stddevPopulation?: InputMaybe<BrokerFeeAndWithdrawalV2StddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  stddevSample?: InputMaybe<BrokerFeeAndWithdrawalV2StddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  sum?: InputMaybe<BrokerFeeAndWithdrawalV2SumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  variancePopulation?: InputMaybe<BrokerFeeAndWithdrawalV2VariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerFeeAndWithdrawalV2` objects. */
  varianceSample?: InputMaybe<BrokerFeeAndWithdrawalV2VarianceSampleAggregateFilter>;
};

export type BrokerFeeAndWithdrawalV2AverageAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2AverageAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2AverageAggregates';
  /** Mean average of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerFeeAndWithdrawalV2` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type BrokerFeeAndWithdrawalV2Condition = {
  /** Checks for equality with the object’s `affiliatedWithBrokerId` field. */
  affiliatedWithBrokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  brokerByAffiliatedWithBrokerId?: InputMaybe<Scalars['ID']['input']>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BrokerFeeAndWithdrawalV2DistinctCountAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type BrokerFeeAndWithdrawalV2DistinctCountAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2DistinctCountAggregates';
  /** Distinct count of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerFeeAndWithdrawalV2` object types. All fields are combined with a logical ‘and.’ */
export type BrokerFeeAndWithdrawalV2Filter = {
  /** Filter by the object’s `affiliatedWithBrokerId` field. */
  affiliatedWithBrokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerFeeAndWithdrawalV2Filter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerByAffiliatedWithBrokerId` relation. */
  brokerByAffiliatedWithBrokerId?: InputMaybe<BrokerFilter>;
  /** A related `brokerByAffiliatedWithBrokerId` exists. */
  brokerByAffiliatedWithBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerFeeAndWithdrawalV2Filter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `BrokerFeeAndWithdrawalV2` for usage during aggregation. */
export type BrokerFeeAndWithdrawalV2GroupBy =
  | 'AFFILIATED_WITH_BROKER_ID'
  | 'AMOUNT'
  | 'ASSET'
  | 'BROKER_COMMISSION_RATE_BPS'
  | 'BROKER_ID'
  | 'TYPE'
  | 'VALUE_USD';

export type BrokerFeeAndWithdrawalV2HavingAverageInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingDistinctCountInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `BrokerFeeAndWithdrawalV2` aggregates. */
export type BrokerFeeAndWithdrawalV2HavingInput = {
  AND?: InputMaybe<Array<BrokerFeeAndWithdrawalV2HavingInput>>;
  OR?: InputMaybe<Array<BrokerFeeAndWithdrawalV2HavingInput>>;
  average?: InputMaybe<BrokerFeeAndWithdrawalV2HavingAverageInput>;
  distinctCount?: InputMaybe<BrokerFeeAndWithdrawalV2HavingDistinctCountInput>;
  max?: InputMaybe<BrokerFeeAndWithdrawalV2HavingMaxInput>;
  min?: InputMaybe<BrokerFeeAndWithdrawalV2HavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerFeeAndWithdrawalV2HavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerFeeAndWithdrawalV2HavingStddevSampleInput>;
  sum?: InputMaybe<BrokerFeeAndWithdrawalV2HavingSumInput>;
  variancePopulation?: InputMaybe<BrokerFeeAndWithdrawalV2HavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerFeeAndWithdrawalV2HavingVarianceSampleInput>;
};

export type BrokerFeeAndWithdrawalV2HavingMaxInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingMinInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingStddevPopulationInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingStddevSampleInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingSumInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingVariancePopulationInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2HavingVarianceSampleInput = {
  affiliatedWithBrokerId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BrokerFeeAndWithdrawalV2MaxAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2MaxAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2MaxAggregates';
  /** Maximum of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerFeeAndWithdrawalV2MinAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2MinAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2MinAggregates';
  /** Minimum of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerFeeAndWithdrawalV2` values. */
export type BrokerFeeAndWithdrawalV2SConnection = {
  __typename?: 'BrokerFeeAndWithdrawalV2SConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerFeeAndWithdrawalV2Aggregates>;
  /** A list of edges which contains the `BrokerFeeAndWithdrawalV2` and cursor to aid in pagination. */
  edges: Array<BrokerFeeAndWithdrawalV2SEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerFeeAndWithdrawalV2Aggregates>>;
  /** A list of `BrokerFeeAndWithdrawalV2` objects. */
  nodes: Array<BrokerFeeAndWithdrawalV2>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerFeeAndWithdrawalV2` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerFeeAndWithdrawalV2` values. */
export type BrokerFeeAndWithdrawalV2SConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerFeeAndWithdrawalV2GroupBy>;
  having?: InputMaybe<BrokerFeeAndWithdrawalV2HavingInput>;
};

/** A `BrokerFeeAndWithdrawalV2` edge in the connection. */
export type BrokerFeeAndWithdrawalV2SEdge = {
  __typename?: 'BrokerFeeAndWithdrawalV2SEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerFeeAndWithdrawalV2` at the end of the edge. */
  node: BrokerFeeAndWithdrawalV2;
};

/** Methods to use when ordering `BrokerFeeAndWithdrawalV2`. */
export type BrokerFeeAndWithdrawalV2SOrderBy =
  | 'AFFILIATED_WITH_BROKER_ID_ASC'
  | 'AFFILIATED_WITH_BROKER_ID_DESC'
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'NATURAL'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type BrokerFeeAndWithdrawalV2StddevPopulationAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2StddevPopulationAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2StddevPopulationAggregates';
  /** Population standard deviation of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerFeeAndWithdrawalV2StddevSampleAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2StddevSampleAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2StddevSampleAggregates';
  /** Sample standard deviation of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerFeeAndWithdrawalV2SumAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2SumAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2SumAggregates';
  /** Sum of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps: Scalars['BigInt']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type BrokerFeeAndWithdrawalV2VariancePopulationAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2VariancePopulationAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2VariancePopulationAggregates';
  /** Population variance of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerFeeAndWithdrawalV2VarianceSampleAggregateFilter = {
  affiliatedWithBrokerId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BrokerFeeAndWithdrawalV2VarianceSampleAggregates = {
  __typename?: 'BrokerFeeAndWithdrawalV2VarianceSampleAggregates';
  /** Sample variance of affiliatedWithBrokerId across the matching connection */
  affiliatedWithBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A filter to be used against `Broker` object types. All fields are combined with a logical ‘and.’ */
export type BrokerFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountCreationDepositChannelsByBrokerId` relation. */
  accountCreationDepositChannelsByBrokerId?: InputMaybe<BrokerToManyAccountCreationDepositChannelFilter>;
  /** Some related `accountCreationDepositChannelsByBrokerId` exist. */
  accountCreationDepositChannelsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerFilter>>;
  /** Filter by the object’s `brokerByDelegateBrokerId` relation. */
  brokerByDelegateBrokerId?: InputMaybe<BrokerFilter>;
  /** A related `brokerByDelegateBrokerId` exists. */
  brokerByDelegateBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelsByBrokerId` relation. */
  brokerChannelsByBrokerId?: InputMaybe<BrokerToManyBrokerChannelFilter>;
  /** Some related `brokerChannelsByBrokerId` exist. */
  brokerChannelsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerFeeAndWithdrawalV2SByAffiliatedWithBrokerId` relation. */
  brokerFeeAndWithdrawalV2SByAffiliatedWithBrokerId?: InputMaybe<BrokerToManyBrokerFeeAndWithdrawalV2Filter>;
  /** Some related `brokerFeeAndWithdrawalV2SByAffiliatedWithBrokerId` exist. */
  brokerFeeAndWithdrawalV2SByAffiliatedWithBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerFeeAndWithdrawalV2SByBrokerId` relation. */
  brokerFeeAndWithdrawalV2SByBrokerId?: InputMaybe<BrokerToManyBrokerFeeAndWithdrawalV2Filter>;
  /** Some related `brokerFeeAndWithdrawalV2SByBrokerId` exist. */
  brokerFeeAndWithdrawalV2SByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerVaultAddressesByBrokerId` relation. */
  brokerVaultAddressesByBrokerId?: InputMaybe<BrokerToManyBrokerVaultAddressFilter>;
  /** Some related `brokerVaultAddressesByBrokerId` exist. */
  brokerVaultAddressesByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerWithdrawalsByBrokerId` relation. */
  brokerWithdrawalsByBrokerId?: InputMaybe<BrokerToManyBrokerWithdrawalFilter>;
  /** Some related `brokerWithdrawalsByBrokerId` exist. */
  brokerWithdrawalsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokersByDelegateBrokerId` relation. */
  brokersByDelegateBrokerId?: InputMaybe<BrokerToManyBrokerFilter>;
  /** Some related `brokersByDelegateBrokerId` exist. */
  brokersByDelegateBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `delegateBrokerId` field. */
  delegateBrokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByRegistratonEventId` relation. */
  eventByRegistratonEventId?: InputMaybe<EventFilter>;
  /** A related `eventByRegistratonEventId` exists. */
  eventByRegistratonEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerFilter>>;
  /** Filter by the object’s `registrationId` field. */
  registrationId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `registratonEventId` field. */
  registratonEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapChannelsByBrokerId` relation. */
  swapChannelsByBrokerId?: InputMaybe<BrokerToManySwapChannelFilter>;
  /** Some related `swapChannelsByBrokerId` exist. */
  swapChannelsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByBrokerId` relation. */
  swapRequestsByBrokerId?: InputMaybe<BrokerToManySwapRequestFilter>;
  /** Some related `swapRequestsByBrokerId` exist. */
  swapRequestsByBrokerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `Broker` for usage during aggregation. */
export type BrokerGroupBy =
  | 'DELEGATE_BROKER_ID'
  | 'REGISTRATION_ID'
  | 'REGISTRATON_EVENT_ID'
  | 'WITHDRAWAL_ADDRESS';

export type BrokerHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `Broker` aggregates. */
export type BrokerHavingInput = {
  AND?: InputMaybe<Array<BrokerHavingInput>>;
  OR?: InputMaybe<Array<BrokerHavingInput>>;
  average?: InputMaybe<BrokerHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerHavingDistinctCountInput>;
  max?: InputMaybe<BrokerHavingMaxInput>;
  min?: InputMaybe<BrokerHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerHavingVarianceSampleInput>;
};

export type BrokerHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  delegateBrokerId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  registrationId?: InputMaybe<HavingIntFilter>;
  registratonEventId?: InputMaybe<HavingBigintFilter>;
};

export type BrokerMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  delegateBrokerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  registrationId?: InputMaybe<IntFilter>;
  registratonEventId?: InputMaybe<BigIntFilter>;
};

export type BrokerMaxAggregates = {
  __typename?: 'BrokerMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  delegateBrokerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  registrationId?: InputMaybe<IntFilter>;
  registratonEventId?: InputMaybe<BigIntFilter>;
};

export type BrokerMinAggregates = {
  __typename?: 'BrokerMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type BrokerStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  delegateBrokerId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerStddevPopulationAggregates = {
  __typename?: 'BrokerStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  delegateBrokerId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerStddevSampleAggregates = {
  __typename?: 'BrokerStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  delegateBrokerId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  registrationId?: InputMaybe<BigIntFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerSumAggregates = {
  __typename?: 'BrokerSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of delegateBrokerId across the matching connection */
  delegateBrokerId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of registrationId across the matching connection */
  registrationId: Scalars['BigInt']['output'];
  /** Sum of registratonEventId across the matching connection */
  registratonEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `AccountCreationDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyAccountCreationDepositChannelFilter = {
  /** Aggregates across related `AccountCreationDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<AccountCreationDepositChannelAggregatesFilter>;
  /** Every related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** No related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Some related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCreationDepositChannelFilter>;
};

/** A filter to be used against many `BrokerChannel` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyBrokerChannelFilter = {
  /** Aggregates across related `BrokerChannel` match the filter criteria. */
  aggregates?: InputMaybe<BrokerChannelAggregatesFilter>;
  /** Every related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerChannelFilter>;
  /** No related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerChannelFilter>;
  /** Some related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerChannelFilter>;
};

/** A filter to be used against many `BrokerFeeAndWithdrawalV2` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyBrokerFeeAndWithdrawalV2Filter = {
  /** Aggregates across related `BrokerFeeAndWithdrawalV2` match the filter criteria. */
  aggregates?: InputMaybe<BrokerFeeAndWithdrawalV2AggregatesFilter>;
  /** Every related `BrokerFeeAndWithdrawalV2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  /** No related `BrokerFeeAndWithdrawalV2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  /** Some related `BrokerFeeAndWithdrawalV2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
};

/** A filter to be used against many `Broker` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyBrokerFilter = {
  /** Aggregates across related `Broker` match the filter criteria. */
  aggregates?: InputMaybe<BrokerAggregatesFilter>;
  /** Every related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerFilter>;
  /** No related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerFilter>;
  /** Some related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerFilter>;
};

/** A filter to be used against many `BrokerVaultAddress` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyBrokerVaultAddressFilter = {
  /** Aggregates across related `BrokerVaultAddress` match the filter criteria. */
  aggregates?: InputMaybe<BrokerVaultAddressAggregatesFilter>;
  /** Every related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerVaultAddressFilter>;
  /** No related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerVaultAddressFilter>;
  /** Some related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerVaultAddressFilter>;
};

/** A filter to be used against many `BrokerWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManyBrokerWithdrawalFilter = {
  /** Aggregates across related `BrokerWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<BrokerWithdrawalAggregatesFilter>;
  /** Every related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerWithdrawalFilter>;
  /** No related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerWithdrawalFilter>;
  /** Some related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerWithdrawalFilter>;
};

/** A filter to be used against many `SwapChannel` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManySwapChannelFilter = {
  /** Aggregates across related `SwapChannel` match the filter criteria. */
  aggregates?: InputMaybe<SwapChannelAggregatesFilter>;
  /** Every related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapChannelFilter>;
  /** No related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapChannelFilter>;
  /** Some related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapChannelFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type BrokerToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type BrokerType =
  | 'AFFILIATE'
  | 'SUBMITTER';

/** A filter to be used against BrokerType fields. All fields are combined with a logical ‘and.’ */
export type BrokerTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<BrokerType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<BrokerType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<BrokerType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<BrokerType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<BrokerType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<BrokerType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<BrokerType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<BrokerType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<BrokerType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<BrokerType>>;
};

export type BrokerVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  delegateBrokerId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerVariancePopulationAggregates = {
  __typename?: 'BrokerVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  delegateBrokerId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  registrationId?: InputMaybe<BigFloatFilter>;
  registratonEventId?: InputMaybe<BigFloatFilter>;
};

export type BrokerVarianceSampleAggregates = {
  __typename?: 'BrokerVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegateBrokerId across the matching connection */
  delegateBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of registrationId across the matching connection */
  registrationId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of registratonEventId across the matching connection */
  registratonEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerVaultAddress = Node & {
  __typename?: 'BrokerVaultAddress';
  address: Scalars['String']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Broker` that is related to this `BrokerVaultAddress`. */
  brokerByBrokerId: Broker;
  brokerId: Scalars['Int']['output'];
  /** Reads a single `Epoch` that is related to this `BrokerVaultAddress`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type BrokerVaultAddressAggregates = {
  __typename?: 'BrokerVaultAddressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerVaultAddressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerVaultAddressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerVaultAddressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerVaultAddressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerVaultAddressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerVaultAddressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerVaultAddressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerVaultAddressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerVaultAddressVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerVaultAddress` object types. */
export type BrokerVaultAddressAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerVaultAddress` objects. */
  average?: InputMaybe<BrokerVaultAddressAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerVaultAddress` objects. */
  distinctCount?: InputMaybe<BrokerVaultAddressDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerVaultAddress` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerVaultAddressFilter>;
  /** Maximum aggregate over matching `BrokerVaultAddress` objects. */
  max?: InputMaybe<BrokerVaultAddressMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerVaultAddress` objects. */
  min?: InputMaybe<BrokerVaultAddressMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerVaultAddress` objects. */
  stddevPopulation?: InputMaybe<BrokerVaultAddressStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerVaultAddress` objects. */
  stddevSample?: InputMaybe<BrokerVaultAddressStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerVaultAddress` objects. */
  sum?: InputMaybe<BrokerVaultAddressSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerVaultAddress` objects. */
  variancePopulation?: InputMaybe<BrokerVaultAddressVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerVaultAddress` objects. */
  varianceSample?: InputMaybe<BrokerVaultAddressVarianceSampleAggregateFilter>;
};

export type BrokerVaultAddressAverageAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerVaultAddressAverageAggregates = {
  __typename?: 'BrokerVaultAddressAverageAggregates';
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerVaultAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerVaultAddressCondition = {
  /** Checks for equality with the object’s `address` field. */
  address?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BrokerVaultAddressDistinctCountAggregateFilter = {
  address?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerVaultAddressDistinctCountAggregates = {
  __typename?: 'BrokerVaultAddressDistinctCountAggregates';
  /** Distinct count of address across the matching connection */
  address?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerVaultAddress` object types. All fields are combined with a logical ‘and.’ */
export type BrokerVaultAddressFilter = {
  /** Filter by the object’s `address` field. */
  address?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerVaultAddressFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerVaultAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerVaultAddressFilter>>;
};

/** Grouping methods for `BrokerVaultAddress` for usage during aggregation. */
export type BrokerVaultAddressGroupBy =
  | 'ADDRESS'
  | 'ASSET'
  | 'BROKER_ID'
  | 'EPOCH_ID';

export type BrokerVaultAddressHavingAverageInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingDistinctCountInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BrokerVaultAddress` aggregates. */
export type BrokerVaultAddressHavingInput = {
  AND?: InputMaybe<Array<BrokerVaultAddressHavingInput>>;
  OR?: InputMaybe<Array<BrokerVaultAddressHavingInput>>;
  average?: InputMaybe<BrokerVaultAddressHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerVaultAddressHavingDistinctCountInput>;
  max?: InputMaybe<BrokerVaultAddressHavingMaxInput>;
  min?: InputMaybe<BrokerVaultAddressHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerVaultAddressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerVaultAddressHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerVaultAddressHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerVaultAddressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerVaultAddressHavingVarianceSampleInput>;
};

export type BrokerVaultAddressHavingMaxInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingMinInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingStddevPopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingStddevSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingSumInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingVariancePopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressHavingVarianceSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerVaultAddressMaxAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerVaultAddressMaxAggregates = {
  __typename?: 'BrokerVaultAddressMaxAggregates';
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerVaultAddressMinAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerVaultAddressMinAggregates = {
  __typename?: 'BrokerVaultAddressMinAggregates';
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerVaultAddressStddevPopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerVaultAddressStddevPopulationAggregates = {
  __typename?: 'BrokerVaultAddressStddevPopulationAggregates';
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerVaultAddressStddevSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerVaultAddressStddevSampleAggregates = {
  __typename?: 'BrokerVaultAddressStddevSampleAggregates';
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerVaultAddressSumAggregateFilter = {
  brokerId?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerVaultAddressSumAggregates = {
  __typename?: 'BrokerVaultAddressSumAggregates';
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type BrokerVaultAddressVariancePopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerVaultAddressVariancePopulationAggregates = {
  __typename?: 'BrokerVaultAddressVariancePopulationAggregates';
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerVaultAddressVarianceSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerVaultAddressVarianceSampleAggregates = {
  __typename?: 'BrokerVaultAddressVarianceSampleAggregates';
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerVaultAddress` values. */
export type BrokerVaultAddressesConnection = {
  __typename?: 'BrokerVaultAddressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerVaultAddressAggregates>;
  /** A list of edges which contains the `BrokerVaultAddress` and cursor to aid in pagination. */
  edges: Array<BrokerVaultAddressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerVaultAddressAggregates>>;
  /** A list of `BrokerVaultAddress` objects. */
  nodes: Array<BrokerVaultAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerVaultAddress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerVaultAddress` values. */
export type BrokerVaultAddressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerVaultAddressGroupBy>;
  having?: InputMaybe<BrokerVaultAddressHavingInput>;
};

/** A `BrokerVaultAddress` edge in the connection. */
export type BrokerVaultAddressesEdge = {
  __typename?: 'BrokerVaultAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerVaultAddress` at the end of the edge. */
  node: BrokerVaultAddress;
};

/** Methods to use when ordering `BrokerVaultAddress`. */
export type BrokerVaultAddressesOrderBy =
  | 'ADDRESS_ASC'
  | 'ADDRESS_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BrokerWithdrawal = Node & {
  __typename?: 'BrokerWithdrawal';
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `BrokerWithdrawal`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `Broker` that is related to this `BrokerWithdrawal`. */
  brokerByBrokerId: Broker;
  brokerId: Scalars['Int']['output'];
  chain: ChainflipChain;
  destinationAddress: Scalars['String']['output'];
  egressAmount: Scalars['BigFloat']['output'];
  egressFee: Scalars['BigFloat']['output'];
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  egressId: Scalars['BigInt']['output'];
  egressValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `BrokerWithdrawal`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type BrokerWithdrawalAggregates = {
  __typename?: 'BrokerWithdrawalAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BrokerWithdrawalAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BrokerWithdrawalDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BrokerWithdrawalMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BrokerWithdrawalMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BrokerWithdrawalStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BrokerWithdrawalStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BrokerWithdrawalSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BrokerWithdrawalVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BrokerWithdrawalVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `BrokerWithdrawal` object types. */
export type BrokerWithdrawalAggregatesFilter = {
  /** Mean average aggregate over matching `BrokerWithdrawal` objects. */
  average?: InputMaybe<BrokerWithdrawalAverageAggregateFilter>;
  /** Distinct count aggregate over matching `BrokerWithdrawal` objects. */
  distinctCount?: InputMaybe<BrokerWithdrawalDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `BrokerWithdrawal` object to be included within the aggregate. */
  filter?: InputMaybe<BrokerWithdrawalFilter>;
  /** Maximum aggregate over matching `BrokerWithdrawal` objects. */
  max?: InputMaybe<BrokerWithdrawalMaxAggregateFilter>;
  /** Minimum aggregate over matching `BrokerWithdrawal` objects. */
  min?: InputMaybe<BrokerWithdrawalMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `BrokerWithdrawal` objects. */
  stddevPopulation?: InputMaybe<BrokerWithdrawalStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `BrokerWithdrawal` objects. */
  stddevSample?: InputMaybe<BrokerWithdrawalStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `BrokerWithdrawal` objects. */
  sum?: InputMaybe<BrokerWithdrawalSumAggregateFilter>;
  /** Population variance aggregate over matching `BrokerWithdrawal` objects. */
  variancePopulation?: InputMaybe<BrokerWithdrawalVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `BrokerWithdrawal` objects. */
  varianceSample?: InputMaybe<BrokerWithdrawalVarianceSampleAggregateFilter>;
};

export type BrokerWithdrawalAverageAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerWithdrawalAverageAggregates = {
  __typename?: 'BrokerWithdrawalAverageAggregates';
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `BrokerWithdrawal` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type BrokerWithdrawalCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `egressAmount` field. */
  egressAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `egressFee` field. */
  egressFee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `egressFeeUsd` field. */
  egressFeeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `egressId` field. */
  egressId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `egressValueUsd` field. */
  egressValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BrokerWithdrawalDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  destinationAddress?: InputMaybe<BigIntFilter>;
  egressAmount?: InputMaybe<BigIntFilter>;
  egressFee?: InputMaybe<BigIntFilter>;
  egressFeeUsd?: InputMaybe<BigIntFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  egressValueUsd?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerWithdrawalDistinctCountAggregates = {
  __typename?: 'BrokerWithdrawalDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAddress across the matching connection */
  destinationAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `BrokerWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type BrokerWithdrawalFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BrokerWithdrawalFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `egressAmount` field. */
  egressAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `egressFee` field. */
  egressFee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `egressFeeUsd` field. */
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `egressId` field. */
  egressId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `egressValueUsd` field. */
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BrokerWithdrawalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BrokerWithdrawalFilter>>;
};

/** Grouping methods for `BrokerWithdrawal` for usage during aggregation. */
export type BrokerWithdrawalGroupBy =
  | 'ASSET'
  | 'BLOCK_ID'
  | 'BROKER_ID'
  | 'CHAIN'
  | 'DESTINATION_ADDRESS'
  | 'EGRESS_AMOUNT'
  | 'EGRESS_FEE'
  | 'EGRESS_FEE_USD'
  | 'EGRESS_ID'
  | 'EGRESS_VALUE_USD'
  | 'EVENT_ID';

export type BrokerWithdrawalHavingAverageInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingDistinctCountInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `BrokerWithdrawal` aggregates. */
export type BrokerWithdrawalHavingInput = {
  AND?: InputMaybe<Array<BrokerWithdrawalHavingInput>>;
  OR?: InputMaybe<Array<BrokerWithdrawalHavingInput>>;
  average?: InputMaybe<BrokerWithdrawalHavingAverageInput>;
  distinctCount?: InputMaybe<BrokerWithdrawalHavingDistinctCountInput>;
  max?: InputMaybe<BrokerWithdrawalHavingMaxInput>;
  min?: InputMaybe<BrokerWithdrawalHavingMinInput>;
  stddevPopulation?: InputMaybe<BrokerWithdrawalHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BrokerWithdrawalHavingStddevSampleInput>;
  sum?: InputMaybe<BrokerWithdrawalHavingSumInput>;
  variancePopulation?: InputMaybe<BrokerWithdrawalHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BrokerWithdrawalHavingVarianceSampleInput>;
};

export type BrokerWithdrawalHavingMaxInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingMinInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingStddevPopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingStddevSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingSumInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingVariancePopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalHavingVarianceSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  egressAmount?: InputMaybe<HavingBigfloatFilter>;
  egressFee?: InputMaybe<HavingBigfloatFilter>;
  egressFeeUsd?: InputMaybe<HavingBigfloatFilter>;
  egressId?: InputMaybe<HavingBigintFilter>;
  egressValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type BrokerWithdrawalMaxAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerWithdrawalMaxAggregates = {
  __typename?: 'BrokerWithdrawalMaxAggregates';
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerWithdrawalMinAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type BrokerWithdrawalMinAggregates = {
  __typename?: 'BrokerWithdrawalMinAggregates';
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type BrokerWithdrawalStddevPopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerWithdrawalStddevPopulationAggregates = {
  __typename?: 'BrokerWithdrawalStddevPopulationAggregates';
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerWithdrawalStddevSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerWithdrawalStddevSampleAggregates = {
  __typename?: 'BrokerWithdrawalStddevSampleAggregates';
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerWithdrawalSumAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type BrokerWithdrawalSumAggregates = {
  __typename?: 'BrokerWithdrawalSumAggregates';
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of egressAmount across the matching connection */
  egressAmount: Scalars['BigFloat']['output'];
  /** Sum of egressFee across the matching connection */
  egressFee: Scalars['BigFloat']['output'];
  /** Sum of egressFeeUsd across the matching connection */
  egressFeeUsd: Scalars['BigFloat']['output'];
  /** Sum of egressId across the matching connection */
  egressId: Scalars['BigFloat']['output'];
  /** Sum of egressValueUsd across the matching connection */
  egressValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type BrokerWithdrawalVariancePopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerWithdrawalVariancePopulationAggregates = {
  __typename?: 'BrokerWithdrawalVariancePopulationAggregates';
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type BrokerWithdrawalVarianceSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  egressAmount?: InputMaybe<BigFloatFilter>;
  egressFee?: InputMaybe<BigFloatFilter>;
  egressFeeUsd?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  egressValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type BrokerWithdrawalVarianceSampleAggregates = {
  __typename?: 'BrokerWithdrawalVarianceSampleAggregates';
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressAmount across the matching connection */
  egressAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressFee across the matching connection */
  egressFee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressFeeUsd across the matching connection */
  egressFeeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressValueUsd across the matching connection */
  egressValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `BrokerWithdrawal` values. */
export type BrokerWithdrawalsConnection = {
  __typename?: 'BrokerWithdrawalsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerWithdrawalAggregates>;
  /** A list of edges which contains the `BrokerWithdrawal` and cursor to aid in pagination. */
  edges: Array<BrokerWithdrawalsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerWithdrawalAggregates>>;
  /** A list of `BrokerWithdrawal` objects. */
  nodes: Array<BrokerWithdrawal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `BrokerWithdrawal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `BrokerWithdrawal` values. */
export type BrokerWithdrawalsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerWithdrawalGroupBy>;
  having?: InputMaybe<BrokerWithdrawalHavingInput>;
};

/** A `BrokerWithdrawal` edge in the connection. */
export type BrokerWithdrawalsEdge = {
  __typename?: 'BrokerWithdrawalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `BrokerWithdrawal` at the end of the edge. */
  node: BrokerWithdrawal;
};

/** Methods to use when ordering `BrokerWithdrawal`. */
export type BrokerWithdrawalsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'DESTINATION_ADDRESS_ASC'
  | 'DESTINATION_ADDRESS_DESC'
  | 'EGRESS_AMOUNT_ASC'
  | 'EGRESS_AMOUNT_DESC'
  | 'EGRESS_FEE_ASC'
  | 'EGRESS_FEE_DESC'
  | 'EGRESS_FEE_USD_ASC'
  | 'EGRESS_FEE_USD_DESC'
  | 'EGRESS_ID_ASC'
  | 'EGRESS_ID_DESC'
  | 'EGRESS_VALUE_USD_ASC'
  | 'EGRESS_VALUE_USD_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type BrokersAggregate = {
  __typename?: 'BrokersAggregate';
  alias?: Maybe<Scalars['String']['output']>;
  day: Scalars['String']['output'];
  idSs58?: Maybe<Scalars['String']['output']>;
  swapCount?: Maybe<Scalars['Int']['output']>;
  swapFeeUsd?: Maybe<Scalars['Float']['output']>;
  volume?: Maybe<Scalars['Float']['output']>;
};

/** A connection to a list of `Broker` values. */
export type BrokersConnection = {
  __typename?: 'BrokersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BrokerAggregates>;
  /** A list of edges which contains the `Broker` and cursor to aid in pagination. */
  edges: Array<BrokersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BrokerAggregates>>;
  /** A list of `Broker` objects. */
  nodes: Array<Broker>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Broker` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Broker` values. */
export type BrokersConnectionGroupedAggregatesArgs = {
  groupBy: Array<BrokerGroupBy>;
  having?: InputMaybe<BrokerHavingInput>;
};

/** A `Broker` edge in the connection. */
export type BrokersEdge = {
  __typename?: 'BrokersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Broker` at the end of the edge. */
  node: Broker;
};

/** Methods to use when ordering `Broker`. */
export type BrokersOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_COUNT_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_COUNT_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_REFUND_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_REFUND_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_AVERAGE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_COUNT_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_COUNT_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MAX_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_MIN_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_POPULATION_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_STDDEV_SAMPLE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_SUM_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_POPULATION_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_DELEGATE_BROKER_ID_VARIANCE_SAMPLE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_AVERAGE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_COUNT_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_COUNT_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MAX_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_MIN_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_SUM_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_AVERAGE_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_COUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_COUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MAX_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_MIN_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_SUM_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_AFFILIATED_WITH_BROKER_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_AVERAGE_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_COUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_COUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MAX_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_MIN_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_SUM_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_AFFILIATED_WITH_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_AFFILIATED_WITH_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'BROKER_FEE_AND_WITHDRAWAL_V2_SBY_BROKER_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_COUNT_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_COUNT_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MAX_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_MIN_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_SUM_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_COUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_COUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MAX_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_MIN_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_SUM_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DELEGATE_BROKER_ID_ASC'
  | 'DELEGATE_BROKER_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REGISTRATION_ID_ASC'
  | 'REGISTRATION_ID_DESC'
  | 'REGISTRATON_EVENT_ID_ASC'
  | 'REGISTRATON_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_COUNT_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_COUNT_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_BROKER_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_BROKER_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'WITHDRAWAL_ADDRESS_ASC'
  | 'WITHDRAWAL_ADDRESS_DESC';

export type Burn = Node & {
  __typename?: 'Burn';
  boostAmount: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `Burn`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
  totalAmount: Scalars['BigFloat']['output'];
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnAggregates = {
  __typename?: 'BurnAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<BurnAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<BurnDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<BurnMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<BurnMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<BurnStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<BurnStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<BurnSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<BurnVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<BurnVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Burn` object types. */
export type BurnAggregatesFilter = {
  /** Mean average aggregate over matching `Burn` objects. */
  average?: InputMaybe<BurnAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Burn` objects. */
  distinctCount?: InputMaybe<BurnDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Burn` object to be included within the aggregate. */
  filter?: InputMaybe<BurnFilter>;
  /** Maximum aggregate over matching `Burn` objects. */
  max?: InputMaybe<BurnMaxAggregateFilter>;
  /** Minimum aggregate over matching `Burn` objects. */
  min?: InputMaybe<BurnMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Burn` objects. */
  stddevPopulation?: InputMaybe<BurnStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Burn` objects. */
  stddevSample?: InputMaybe<BurnStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Burn` objects. */
  sum?: InputMaybe<BurnSumAggregateFilter>;
  /** Population variance aggregate over matching `Burn` objects. */
  variancePopulation?: InputMaybe<BurnVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Burn` objects. */
  varianceSample?: InputMaybe<BurnVarianceSampleAggregateFilter>;
};

export type BurnAverageAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnAverageAggregates = {
  __typename?: 'BurnAverageAggregates';
  /** Mean average of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Burn` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type BurnCondition = {
  /** Checks for equality with the object’s `boostAmount` field. */
  boostAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type BurnDistinctCountAggregateFilter = {
  boostAmount?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type BurnDistinctCountAggregates = {
  __typename?: 'BurnDistinctCountAggregates';
  /** Distinct count of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Burn` object types. All fields are combined with a logical ‘and.’ */
export type BurnFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<BurnFilter>>;
  /** Filter by the object’s `boostAmount` field. */
  boostAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<BurnFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<BurnFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `totalAmount` field. */
  totalAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Burn` for usage during aggregation. */
export type BurnGroupBy =
  | 'BOOST_AMOUNT'
  | 'EVENT_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TOTAL_AMOUNT'
  | 'VALUE_USD';

export type BurnHavingAverageInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingDistinctCountInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Burn` aggregates. */
export type BurnHavingInput = {
  AND?: InputMaybe<Array<BurnHavingInput>>;
  OR?: InputMaybe<Array<BurnHavingInput>>;
  average?: InputMaybe<BurnHavingAverageInput>;
  distinctCount?: InputMaybe<BurnHavingDistinctCountInput>;
  max?: InputMaybe<BurnHavingMaxInput>;
  min?: InputMaybe<BurnHavingMinInput>;
  stddevPopulation?: InputMaybe<BurnHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<BurnHavingStddevSampleInput>;
  sum?: InputMaybe<BurnHavingSumInput>;
  variancePopulation?: InputMaybe<BurnHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<BurnHavingVarianceSampleInput>;
};

export type BurnHavingMaxInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingMinInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingStddevPopulationInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingStddevSampleInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingSumInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingVariancePopulationInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnHavingVarianceSampleInput = {
  boostAmount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  totalAmount?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type BurnMaxAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnMaxAggregates = {
  __typename?: 'BurnMaxAggregates';
  /** Maximum of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnMinAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnMinAggregates = {
  __typename?: 'BurnMinAggregates';
  /** Minimum of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnStddevPopulationAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnStddevPopulationAggregates = {
  __typename?: 'BurnStddevPopulationAggregates';
  /** Population standard deviation of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnStddevSampleAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnStddevSampleAggregates = {
  __typename?: 'BurnStddevSampleAggregates';
  /** Sample standard deviation of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnSumAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnSumAggregates = {
  __typename?: 'BurnSumAggregates';
  /** Sum of boostAmount across the matching connection */
  boostAmount: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of totalAmount across the matching connection */
  totalAmount: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type BurnVariancePopulationAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnVariancePopulationAggregates = {
  __typename?: 'BurnVariancePopulationAggregates';
  /** Population variance of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type BurnVarianceSampleAggregateFilter = {
  boostAmount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  totalAmount?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type BurnVarianceSampleAggregates = {
  __typename?: 'BurnVarianceSampleAggregates';
  /** Sample variance of boostAmount across the matching connection */
  boostAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalAmount across the matching connection */
  totalAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Burn` values. */
export type BurnsConnection = {
  __typename?: 'BurnsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<BurnAggregates>;
  /** A list of edges which contains the `Burn` and cursor to aid in pagination. */
  edges: Array<BurnsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<BurnAggregates>>;
  /** A list of `Burn` objects. */
  nodes: Array<Burn>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Burn` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Burn` values. */
export type BurnsConnectionGroupedAggregatesArgs = {
  groupBy: Array<BurnGroupBy>;
  having?: InputMaybe<BurnHavingInput>;
};

/** A `Burn` edge in the connection. */
export type BurnsEdge = {
  __typename?: 'BurnsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Burn` at the end of the edge. */
  node: Burn;
};

/** Methods to use when ordering `Burn`. */
export type BurnsOrderBy =
  | 'BOOST_AMOUNT_ASC'
  | 'BOOST_AMOUNT_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TOTAL_AMOUNT_ASC'
  | 'TOTAL_AMOUNT_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type CandlestickData = {
  __typename?: 'CandlestickData';
  close: Scalars['Float']['output'];
  high: Scalars['Float']['output'];
  low: Scalars['Float']['output'];
  open: Scalars['Float']['output'];
  time: Scalars['Int']['output'];
};

export type CandlestickResult = CandlestickData | WhitespaceData;

export type CfeVersion = Node & {
  __typename?: 'CfeVersion';
  id: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `Validator`. */
  validatorsByCfeVersionId: ValidatorsConnection;
};


export type CfeVersionValidatorsByCfeVersionIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};

export type CfeVersionAggregates = {
  __typename?: 'CfeVersionAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CfeVersionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A condition to be used against `CfeVersion` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CfeVersionCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
};

export type CfeVersionDistinctCountAggregates = {
  __typename?: 'CfeVersionDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `CfeVersion` object types. All fields are combined with a logical ‘and.’ */
export type CfeVersionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CfeVersionFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CfeVersionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CfeVersionFilter>>;
  /** Filter by the object’s `validatorsByCfeVersionId` relation. */
  validatorsByCfeVersionId?: InputMaybe<CfeVersionToManyValidatorFilter>;
  /** Some related `validatorsByCfeVersionId` exist. */
  validatorsByCfeVersionIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `Validator` object types. All fields are combined with a logical ‘and.’ */
export type CfeVersionToManyValidatorFilter = {
  /** Aggregates across related `Validator` match the filter criteria. */
  aggregates?: InputMaybe<ValidatorAggregatesFilter>;
  /** Every related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ValidatorFilter>;
  /** No related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ValidatorFilter>;
  /** Some related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ValidatorFilter>;
};

/** A connection to a list of `CfeVersion` values. */
export type CfeVersionsConnection = {
  __typename?: 'CfeVersionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CfeVersionAggregates>;
  /** A list of edges which contains the `CfeVersion` and cursor to aid in pagination. */
  edges: Array<CfeVersionsEdge>;
  /** A list of `CfeVersion` objects. */
  nodes: Array<CfeVersion>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CfeVersion` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `CfeVersion` edge in the connection. */
export type CfeVersionsEdge = {
  __typename?: 'CfeVersionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CfeVersion` at the end of the edge. */
  node: CfeVersion;
};

/** Methods to use when ordering `CfeVersion`. */
export type CfeVersionsOrderBy =
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_COUNT_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_COUNT_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_CFE_VERSION_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_CFE_VERSION_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MAX_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_MIN_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_SUM_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_CFE_VERSION_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC';

export type ChainTracking = Node & {
  __typename?: 'ChainTracking';
  chain: ChainflipChain;
  height: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  updatedAt: Scalars['Datetime']['output'];
};

export type ChainTrackingAggregates = {
  __typename?: 'ChainTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ChainTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ChainTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ChainTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ChainTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ChainTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ChainTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ChainTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ChainTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ChainTrackingVarianceSampleAggregates>;
};

export type ChainTrackingAverageAggregates = {
  __typename?: 'ChainTrackingAverageAggregates';
  /** Mean average of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ChainTracking` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ChainTrackingCondition = {
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `height` field. */
  height?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ChainTrackingDistinctCountAggregates = {
  __typename?: 'ChainTrackingDistinctCountAggregates';
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of height across the matching connection */
  height?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `ChainTracking` object types. All fields are combined with a logical ‘and.’ */
export type ChainTrackingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ChainTrackingFilter>>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `height` field. */
  height?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ChainTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ChainTrackingFilter>>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `ChainTracking` for usage during aggregation. */
export type ChainTrackingGroupBy =
  | 'HEIGHT'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT_TRUNCATED_TO_MONTH'
  | 'UPDATED_AT_TRUNCATED_TO_WEEK';

export type ChainTrackingHavingAverageInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingDistinctCountInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ChainTracking` aggregates. */
export type ChainTrackingHavingInput = {
  AND?: InputMaybe<Array<ChainTrackingHavingInput>>;
  OR?: InputMaybe<Array<ChainTrackingHavingInput>>;
  average?: InputMaybe<ChainTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<ChainTrackingHavingDistinctCountInput>;
  max?: InputMaybe<ChainTrackingHavingMaxInput>;
  min?: InputMaybe<ChainTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<ChainTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ChainTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<ChainTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<ChainTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ChainTrackingHavingVarianceSampleInput>;
};

export type ChainTrackingHavingMaxInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingMinInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingStddevPopulationInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingStddevSampleInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingSumInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingVariancePopulationInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingHavingVarianceSampleInput = {
  height?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ChainTrackingMaxAggregates = {
  __typename?: 'ChainTrackingMaxAggregates';
  /** Maximum of height across the matching connection */
  height?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ChainTrackingMinAggregates = {
  __typename?: 'ChainTrackingMinAggregates';
  /** Minimum of height across the matching connection */
  height?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type ChainTrackingStddevPopulationAggregates = {
  __typename?: 'ChainTrackingStddevPopulationAggregates';
  /** Population standard deviation of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChainTrackingStddevSampleAggregates = {
  __typename?: 'ChainTrackingStddevSampleAggregates';
  /** Sample standard deviation of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChainTrackingSumAggregates = {
  __typename?: 'ChainTrackingSumAggregates';
  /** Sum of height across the matching connection */
  height: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type ChainTrackingVariancePopulationAggregates = {
  __typename?: 'ChainTrackingVariancePopulationAggregates';
  /** Population variance of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type ChainTrackingVarianceSampleAggregates = {
  __typename?: 'ChainTrackingVarianceSampleAggregates';
  /** Sample variance of height across the matching connection */
  height?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `ChainTracking` values. */
export type ChainTrackingsConnection = {
  __typename?: 'ChainTrackingsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ChainTrackingAggregates>;
  /** A list of edges which contains the `ChainTracking` and cursor to aid in pagination. */
  edges: Array<ChainTrackingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ChainTrackingAggregates>>;
  /** A list of `ChainTracking` objects. */
  nodes: Array<ChainTracking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ChainTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ChainTracking` values. */
export type ChainTrackingsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ChainTrackingGroupBy>;
  having?: InputMaybe<ChainTrackingHavingInput>;
};

/** A `ChainTracking` edge in the connection. */
export type ChainTrackingsEdge = {
  __typename?: 'ChainTrackingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ChainTracking` at the end of the edge. */
  node: ChainTracking;
};

/** Methods to use when ordering `ChainTracking`. */
export type ChainTrackingsOrderBy =
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'HEIGHT_ASC'
  | 'HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type ChainflipAsset =
  | 'ArbEth'
  | 'ArbUsdc'
  | 'ArbUsdt'
  | 'Bnb'
  | 'BscUsdt'
  | 'Btc'
  | 'Cbbtc'
  | 'Dot'
  | 'Eth'
  | 'Flip'
  | 'HubDot'
  | 'HubUsdc'
  | 'HubUsdt'
  | 'Sol'
  | 'SolUsdc'
  | 'SolUsdt'
  | 'Trx'
  | 'TrxUsdt'
  | 'Usdc'
  | 'Usdt'
  | 'Wbtc';

/** A filter to be used against ChainflipAsset fields. All fields are combined with a logical ‘and.’ */
export type ChainflipAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipAsset>>;
};

export type ChainflipChain =
  | 'Arbitrum'
  | 'Assethub'
  | 'Bitcoin'
  | 'Bsc'
  | 'Ethereum'
  | 'Polkadot'
  | 'Solana'
  | 'Tron';

/** A filter to be used against ChainflipChain fields. All fields are combined with a logical ‘and.’ */
export type ChainflipChainFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ChainflipChain>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ChainflipChain>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ChainflipChain>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ChainflipChain>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ChainflipChain>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ChainflipChain>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ChainflipChain>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ChainflipChain>>;
};

export type CollectedFee = Node & {
  __typename?: 'CollectedFee';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Event` that is related to this `CollectedFee`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `LiquidityProvider` that is related to this `CollectedFee`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeAggregates = {
  __typename?: 'CollectedFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CollectedFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CollectedFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CollectedFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CollectedFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CollectedFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CollectedFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CollectedFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CollectedFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CollectedFeeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `CollectedFee` object types. */
export type CollectedFeeAggregatesFilter = {
  /** Mean average aggregate over matching `CollectedFee` objects. */
  average?: InputMaybe<CollectedFeeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `CollectedFee` objects. */
  distinctCount?: InputMaybe<CollectedFeeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `CollectedFee` object to be included within the aggregate. */
  filter?: InputMaybe<CollectedFeeFilter>;
  /** Maximum aggregate over matching `CollectedFee` objects. */
  max?: InputMaybe<CollectedFeeMaxAggregateFilter>;
  /** Minimum aggregate over matching `CollectedFee` objects. */
  min?: InputMaybe<CollectedFeeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `CollectedFee` objects. */
  stddevPopulation?: InputMaybe<CollectedFeeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `CollectedFee` objects. */
  stddevSample?: InputMaybe<CollectedFeeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `CollectedFee` objects. */
  sum?: InputMaybe<CollectedFeeSumAggregateFilter>;
  /** Population variance aggregate over matching `CollectedFee` objects. */
  variancePopulation?: InputMaybe<CollectedFeeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `CollectedFee` objects. */
  varianceSample?: InputMaybe<CollectedFeeVarianceSampleAggregateFilter>;
};

export type CollectedFeeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeAverageAggregates = {
  __typename?: 'CollectedFeeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `CollectedFee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type CollectedFeeCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type CollectedFeeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type CollectedFeeDistinctCountAggregates = {
  __typename?: 'CollectedFeeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `CollectedFee` object types. All fields are combined with a logical ‘and.’ */
export type CollectedFeeFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CollectedFeeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CollectedFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CollectedFeeFilter>>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `CollectedFee` for usage during aggregation. */
export type CollectedFeeGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'EVENT_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'VALUE_USD';

export type CollectedFeeHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `CollectedFee` aggregates. */
export type CollectedFeeHavingInput = {
  AND?: InputMaybe<Array<CollectedFeeHavingInput>>;
  OR?: InputMaybe<Array<CollectedFeeHavingInput>>;
  average?: InputMaybe<CollectedFeeHavingAverageInput>;
  distinctCount?: InputMaybe<CollectedFeeHavingDistinctCountInput>;
  max?: InputMaybe<CollectedFeeHavingMaxInput>;
  min?: InputMaybe<CollectedFeeHavingMinInput>;
  stddevPopulation?: InputMaybe<CollectedFeeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CollectedFeeHavingStddevSampleInput>;
  sum?: InputMaybe<CollectedFeeHavingSumInput>;
  variancePopulation?: InputMaybe<CollectedFeeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CollectedFeeHavingVarianceSampleInput>;
};

export type CollectedFeeHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type CollectedFeeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeMaxAggregates = {
  __typename?: 'CollectedFeeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeMinAggregates = {
  __typename?: 'CollectedFeeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeStddevPopulationAggregates = {
  __typename?: 'CollectedFeeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeStddevSampleAggregates = {
  __typename?: 'CollectedFeeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeSumAggregates = {
  __typename?: 'CollectedFeeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type CollectedFeeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeVariancePopulationAggregates = {
  __typename?: 'CollectedFeeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type CollectedFeeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type CollectedFeeVarianceSampleAggregates = {
  __typename?: 'CollectedFeeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `CollectedFee` values. */
export type CollectedFeesConnection = {
  __typename?: 'CollectedFeesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CollectedFeeAggregates>;
  /** A list of edges which contains the `CollectedFee` and cursor to aid in pagination. */
  edges: Array<CollectedFeesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CollectedFeeAggregates>>;
  /** A list of `CollectedFee` objects. */
  nodes: Array<CollectedFee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `CollectedFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `CollectedFee` values. */
export type CollectedFeesConnectionGroupedAggregatesArgs = {
  groupBy: Array<CollectedFeeGroupBy>;
  having?: InputMaybe<CollectedFeeHavingInput>;
};

/** A `CollectedFee` edge in the connection. */
export type CollectedFeesEdge = {
  __typename?: 'CollectedFeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `CollectedFee` at the end of the edge. */
  node: CollectedFee;
};

/** Methods to use when ordering `CollectedFee`. */
export type CollectedFeesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

/** A connection to a list of `DelegationActivity` values. */
export type DelegationActivitiesConnection = {
  __typename?: 'DelegationActivitiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<DelegationActivityAggregates>;
  /** A list of edges which contains the `DelegationActivity` and cursor to aid in pagination. */
  edges: Array<DelegationActivitiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<DelegationActivityAggregates>>;
  /** A list of `DelegationActivity` objects. */
  nodes: Array<DelegationActivity>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DelegationActivity` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `DelegationActivity` values. */
export type DelegationActivitiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<DelegationActivityGroupBy>;
  having?: InputMaybe<DelegationActivityHavingInput>;
};

/** A `DelegationActivity` edge in the connection. */
export type DelegationActivitiesEdge = {
  __typename?: 'DelegationActivitiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DelegationActivity` at the end of the edge. */
  node: DelegationActivity;
};

/** Methods to use when ordering `DelegationActivity`. */
export type DelegationActivitiesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATOR_ACCOUNT_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TX_HASH_ASC'
  | 'TX_HASH_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type DelegationActivity = Node & {
  __typename?: 'DelegationActivity';
  /** Reads a single `Account` that is related to this `DelegationActivity`. */
  accountByDelegatorAccountId: Account;
  amount: Scalars['BigFloat']['output'];
  delegatorAccountId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `DelegationActivity`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `DelegationActivity`. */
  operatorByOperatorId: Operator;
  operatorId: Scalars['Int']['output'];
  timestamp: Scalars['Datetime']['output'];
  txHash?: Maybe<Scalars['String']['output']>;
  type: DelegationActivityType;
  valueUsd: Scalars['BigFloat']['output'];
};

export type DelegationActivityAggregates = {
  __typename?: 'DelegationActivityAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<DelegationActivityAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<DelegationActivityDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<DelegationActivityMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<DelegationActivityMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<DelegationActivityStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<DelegationActivityStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<DelegationActivitySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<DelegationActivityVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<DelegationActivityVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `DelegationActivity` object types. */
export type DelegationActivityAggregatesFilter = {
  /** Mean average aggregate over matching `DelegationActivity` objects. */
  average?: InputMaybe<DelegationActivityAverageAggregateFilter>;
  /** Distinct count aggregate over matching `DelegationActivity` objects. */
  distinctCount?: InputMaybe<DelegationActivityDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `DelegationActivity` object to be included within the aggregate. */
  filter?: InputMaybe<DelegationActivityFilter>;
  /** Maximum aggregate over matching `DelegationActivity` objects. */
  max?: InputMaybe<DelegationActivityMaxAggregateFilter>;
  /** Minimum aggregate over matching `DelegationActivity` objects. */
  min?: InputMaybe<DelegationActivityMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `DelegationActivity` objects. */
  stddevPopulation?: InputMaybe<DelegationActivityStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `DelegationActivity` objects. */
  stddevSample?: InputMaybe<DelegationActivityStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `DelegationActivity` objects. */
  sum?: InputMaybe<DelegationActivitySumAggregateFilter>;
  /** Population variance aggregate over matching `DelegationActivity` objects. */
  variancePopulation?: InputMaybe<DelegationActivityVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `DelegationActivity` objects. */
  varianceSample?: InputMaybe<DelegationActivityVarianceSampleAggregateFilter>;
};

export type DelegationActivityAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityAverageAggregates = {
  __typename?: 'DelegationActivityAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `DelegationActivity` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type DelegationActivityCondition = {
  accountByDelegatorAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<DelegationActivityType>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type DelegationActivityDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  delegatorAccountId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  txHash?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type DelegationActivityDistinctCountAggregates = {
  __typename?: 'DelegationActivityDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of txHash across the matching connection */
  txHash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `DelegationActivity` object types. All fields are combined with a logical ‘and.’ */
export type DelegationActivityFilter = {
  /** Filter by the object’s `accountByDelegatorAccountId` relation. */
  accountByDelegatorAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DelegationActivityFilter>>;
  /** Filter by the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DelegationActivityFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DelegationActivityFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<DelegationActivityTypeFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `DelegationActivity` for usage during aggregation. */
export type DelegationActivityGroupBy =
  | 'AMOUNT'
  | 'DELEGATOR_ACCOUNT_ID'
  | 'EVENT_ID'
  | 'OPERATOR_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TX_HASH'
  | 'TYPE'
  | 'VALUE_USD';

export type DelegationActivityHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `DelegationActivity` aggregates. */
export type DelegationActivityHavingInput = {
  AND?: InputMaybe<Array<DelegationActivityHavingInput>>;
  OR?: InputMaybe<Array<DelegationActivityHavingInput>>;
  average?: InputMaybe<DelegationActivityHavingAverageInput>;
  distinctCount?: InputMaybe<DelegationActivityHavingDistinctCountInput>;
  max?: InputMaybe<DelegationActivityHavingMaxInput>;
  min?: InputMaybe<DelegationActivityHavingMinInput>;
  stddevPopulation?: InputMaybe<DelegationActivityHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<DelegationActivityHavingStddevSampleInput>;
  sum?: InputMaybe<DelegationActivityHavingSumInput>;
  variancePopulation?: InputMaybe<DelegationActivityHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<DelegationActivityHavingVarianceSampleInput>;
};

export type DelegationActivityHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type DelegationActivityMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityMaxAggregates = {
  __typename?: 'DelegationActivityMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationActivityMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityMinAggregates = {
  __typename?: 'DelegationActivityMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationActivityStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityStddevPopulationAggregates = {
  __typename?: 'DelegationActivityStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationActivityStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityStddevSampleAggregates = {
  __typename?: 'DelegationActivityStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationActivitySumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivitySumAggregates = {
  __typename?: 'DelegationActivitySumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of delegatorAccountId across the matching connection */
  delegatorAccountId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type DelegationActivityType =
  | 'BID_CHANGE'
  | 'DELEGATE'
  | 'REWARD'
  | 'SLASH'
  | 'UNDELEGATE';

/** A filter to be used against DelegationActivityType fields. All fields are combined with a logical ‘and.’ */
export type DelegationActivityTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DelegationActivityType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DelegationActivityType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DelegationActivityType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DelegationActivityType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DelegationActivityType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DelegationActivityType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DelegationActivityType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DelegationActivityType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DelegationActivityType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DelegationActivityType>>;
};

export type DelegationActivityVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityVariancePopulationAggregates = {
  __typename?: 'DelegationActivityVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DelegationActivityVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type DelegationActivityVarianceSampleAggregates = {
  __typename?: 'DelegationActivityVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type DepositFailedReason =
  | 'BELOW_MINIMUM_DEPOSIT'
  | 'CCM_INVALID_METADATA'
  | 'CCM_UNSUPPORTED_FOR_TARGET_CHAIN'
  | 'DEPOSIT_WITNESS_REJECTED'
  | 'INVALID_BROKER_FEES'
  | 'INVALID_DCA_PARAMETERS'
  | 'INVALID_DESTINATION_ADDRESS'
  | 'INVALID_REFUND_PARAMETERS'
  | 'NOT_ENOUGH_TO_PAY_FEES'
  | 'TRANSACTION_REJECTED_BY_BROKER'
  | 'UNREFUNDABLE';

/** A filter to be used against DepositFailedReason fields. All fields are combined with a logical ‘and.’ */
export type DepositFailedReasonFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DepositFailedReason>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DepositFailedReason>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DepositFailedReason>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DepositFailedReason>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DepositFailedReason>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DepositFailedReason>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DepositFailedReason>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DepositFailedReason>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DepositFailedReason>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DepositFailedReason>>;
};

export type Egress = Node & {
  __typename?: 'Egress';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Broadcast` that is related to this `Egress`. */
  broadcastByBroadcastId?: Maybe<Broadcast>;
  /** Reads a single `Broadcast` that is related to this `Egress`. */
  broadcastByFallbackBroadcastId?: Maybe<Broadcast>;
  broadcastId?: Maybe<Scalars['Int']['output']>;
  chain: ChainflipChain;
  /** Reads a single `Event` that is related to this `Egress`. */
  eventByFailedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Egress`. */
  eventByScheduledEventId: Event;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByRefundEgressId: FailedDepositsConnection;
  failedEventId?: Maybe<Scalars['BigInt']['output']>;
  fallbackBroadcastId?: Maybe<Scalars['Int']['output']>;
  fallbackDestinationAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityWithdrawal` that is related to this `Egress`. */
  liquidityWithdrawalByEgressId?: Maybe<LiquidityWithdrawal>;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByEgressId: LiquidityWithdrawalsConnection;
  nativeId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  scheduledEventId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByEgressId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByFallbackEgressId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByRefundEgressId: SwapRequestsConnection;
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};


export type EgressFailedDepositsByRefundEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type EgressLiquidityWithdrawalsByEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


export type EgressSwapRequestsByEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type EgressSwapRequestsByFallbackEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type EgressSwapRequestsByRefundEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type EgressAggregates = {
  __typename?: 'EgressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EgressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EgressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EgressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EgressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EgressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EgressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EgressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EgressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EgressVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Egress` object types. */
export type EgressAggregatesFilter = {
  /** Mean average aggregate over matching `Egress` objects. */
  average?: InputMaybe<EgressAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Egress` objects. */
  distinctCount?: InputMaybe<EgressDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Egress` object to be included within the aggregate. */
  filter?: InputMaybe<EgressFilter>;
  /** Maximum aggregate over matching `Egress` objects. */
  max?: InputMaybe<EgressMaxAggregateFilter>;
  /** Minimum aggregate over matching `Egress` objects. */
  min?: InputMaybe<EgressMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Egress` objects. */
  stddevPopulation?: InputMaybe<EgressStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Egress` objects. */
  stddevSample?: InputMaybe<EgressStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Egress` objects. */
  sum?: InputMaybe<EgressSumAggregateFilter>;
  /** Population variance aggregate over matching `Egress` objects. */
  variancePopulation?: InputMaybe<EgressVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Egress` objects. */
  varianceSample?: InputMaybe<EgressVarianceSampleAggregateFilter>;
};

export type EgressAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressAverageAggregates = {
  __typename?: 'EgressAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Egress` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EgressCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  broadcastByBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  broadcastByFallbackBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  eventByFailedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByScheduledEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `failedEventId` field. */
  failedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fallbackBroadcastId` field. */
  fallbackBroadcastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fallbackDestinationAddress` field. */
  fallbackDestinationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nativeId` field. */
  nativeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `scheduledEventId` field. */
  scheduledEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type EgressDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  failedEventId?: InputMaybe<BigIntFilter>;
  fallbackBroadcastId?: InputMaybe<BigIntFilter>;
  fallbackDestinationAddress?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  scheduledEventId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type EgressDistinctCountAggregates = {
  __typename?: 'EgressDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fallbackDestinationAddress across the matching connection */
  fallbackDestinationAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Egress` object types. All fields are combined with a logical ‘and.’ */
export type EgressFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EgressFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `broadcastByBroadcastId` relation. */
  broadcastByBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByBroadcastId` exists. */
  broadcastByBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastByFallbackBroadcastId` relation. */
  broadcastByFallbackBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByFallbackBroadcastId` exists. */
  broadcastByFallbackBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `eventByFailedEventId` relation. */
  eventByFailedEventId?: InputMaybe<EventFilter>;
  /** A related `eventByFailedEventId` exists. */
  eventByFailedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByScheduledEventId` relation. */
  eventByScheduledEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `failedDepositsByRefundEgressId` relation. */
  failedDepositsByRefundEgressId?: InputMaybe<EgressToManyFailedDepositFilter>;
  /** Some related `failedDepositsByRefundEgressId` exist. */
  failedDepositsByRefundEgressIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `failedEventId` field. */
  failedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fallbackBroadcastId` field. */
  fallbackBroadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fallbackDestinationAddress` field. */
  fallbackDestinationAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityWithdrawalByEgressId` relation. */
  liquidityWithdrawalByEgressId?: InputMaybe<LiquidityWithdrawalFilter>;
  /** A related `liquidityWithdrawalByEgressId` exists. */
  liquidityWithdrawalByEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `nativeId` field. */
  nativeId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EgressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EgressFilter>>;
  /** Filter by the object’s `scheduledEventId` field. */
  scheduledEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapRequestsByEgressId` relation. */
  swapRequestsByEgressId?: InputMaybe<EgressToManySwapRequestFilter>;
  /** Some related `swapRequestsByEgressId` exist. */
  swapRequestsByEgressIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByFallbackEgressId` relation. */
  swapRequestsByFallbackEgressId?: InputMaybe<EgressToManySwapRequestFilter>;
  /** Some related `swapRequestsByFallbackEgressId` exist. */
  swapRequestsByFallbackEgressIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByRefundEgressId` relation. */
  swapRequestsByRefundEgressId?: InputMaybe<EgressToManySwapRequestFilter>;
  /** Some related `swapRequestsByRefundEgressId` exist. */
  swapRequestsByRefundEgressIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Egress` for usage during aggregation. */
export type EgressGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BROADCAST_ID'
  | 'CHAIN'
  | 'FALLBACK_BROADCAST_ID'
  | 'FALLBACK_DESTINATION_ADDRESS'
  | 'NATIVE_ID'
  | 'VALUE_USD';

export type EgressHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Egress` aggregates. */
export type EgressHavingInput = {
  AND?: InputMaybe<Array<EgressHavingInput>>;
  OR?: InputMaybe<Array<EgressHavingInput>>;
  average?: InputMaybe<EgressHavingAverageInput>;
  distinctCount?: InputMaybe<EgressHavingDistinctCountInput>;
  max?: InputMaybe<EgressHavingMaxInput>;
  min?: InputMaybe<EgressHavingMinInput>;
  stddevPopulation?: InputMaybe<EgressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EgressHavingStddevSampleInput>;
  sum?: InputMaybe<EgressHavingSumInput>;
  variancePopulation?: InputMaybe<EgressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EgressHavingVarianceSampleInput>;
};

export type EgressHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedEventId?: InputMaybe<HavingBigintFilter>;
  fallbackBroadcastId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  scheduledEventId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type EgressMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  failedEventId?: InputMaybe<BigIntFilter>;
  fallbackBroadcastId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  scheduledEventId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressMaxAggregates = {
  __typename?: 'EgressMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type EgressMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  failedEventId?: InputMaybe<BigIntFilter>;
  fallbackBroadcastId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  scheduledEventId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressMinAggregates = {
  __typename?: 'EgressMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type EgressStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressStddevPopulationAggregates = {
  __typename?: 'EgressStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type EgressStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressStddevSampleAggregates = {
  __typename?: 'EgressStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type EgressSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressSumAggregates = {
  __typename?: 'EgressSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of broadcastId across the matching connection */
  broadcastId: Scalars['BigInt']['output'];
  /** Sum of failedEventId across the matching connection */
  failedEventId: Scalars['BigFloat']['output'];
  /** Sum of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of nativeId across the matching connection */
  nativeId: Scalars['BigFloat']['output'];
  /** Sum of scheduledEventId across the matching connection */
  scheduledEventId: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type EgressToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type EgressToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type EgressVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressVariancePopulationAggregates = {
  __typename?: 'EgressVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type EgressVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedEventId?: InputMaybe<BigFloatFilter>;
  fallbackBroadcastId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  scheduledEventId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type EgressVarianceSampleAggregates = {
  __typename?: 'EgressVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of failedEventId across the matching connection */
  failedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fallbackBroadcastId across the matching connection */
  fallbackBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of scheduledEventId across the matching connection */
  scheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Egress` values. */
export type EgressesConnection = {
  __typename?: 'EgressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EgressAggregates>;
  /** A list of edges which contains the `Egress` and cursor to aid in pagination. */
  edges: Array<EgressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EgressAggregates>>;
  /** A list of `Egress` objects. */
  nodes: Array<Egress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Egress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Egress` values. */
export type EgressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<EgressGroupBy>;
  having?: InputMaybe<EgressHavingInput>;
};

/** A `Egress` edge in the connection. */
export type EgressesEdge = {
  __typename?: 'EgressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Egress` at the end of the edge. */
  node: Egress;
};

/** Methods to use when ordering `Egress`. */
export type EgressesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROADCAST_ID_ASC'
  | 'BROADCAST_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_EVENT_ID_ASC'
  | 'FAILED_EVENT_ID_DESC'
  | 'FALLBACK_BROADCAST_ID_ASC'
  | 'FALLBACK_BROADCAST_ID_DESC'
  | 'FALLBACK_DESTINATION_ADDRESS_ASC'
  | 'FALLBACK_DESTINATION_ADDRESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATIVE_ID_ASC'
  | 'NATIVE_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SCHEDULED_EVENT_ID_ASC'
  | 'SCHEDULED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FALLBACK_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REFUND_EGRESS_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type Epoch = Node & {
  __typename?: 'Epoch';
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsByEpochId: AccountFundingEventsConnection;
  /** Reads and enables pagination through a set of `AuthorityHeartbeat`. */
  authorityHeartbeatsByEpochId: AuthorityHeartbeatsConnection;
  /** Reads and enables pagination through a set of `AuthorityMembership`. */
  authorityMembershipsByEpochId: AuthorityMembershipsConnection;
  /** Reads a single `Block` that is related to this `Epoch`. */
  blockByEndBlockId?: Maybe<Block>;
  /** Reads a single `Block` that is related to this `Epoch`. */
  blockByStartBlockId: Block;
  bond: Scalars['BigFloat']['output'];
  /** Reads and enables pagination through a set of `BrokerVaultAddress`. */
  brokerVaultAddressesByEpochId: BrokerVaultAddressesConnection;
  endBlockId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  maxAuthoritySetSize: Scalars['Int']['output'];
  minAuthoritySetSize: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OperatorEpochDelegationApy`. */
  operatorEpochDelegationApiesByEpochId: OperatorEpochDelegationApiesConnection;
  /** Reads and enables pagination through a set of `OperatorEpoch`. */
  operatorEpochesByEpochId: OperatorEpochesConnection;
  /** Reads and enables pagination through a set of `RotationEvent`. */
  rotationEventsByEpochId: RotationEventsConnection;
  startBlockId: Scalars['Int']['output'];
  totalBonded: Scalars['BigFloat']['output'];
};


export type EpochAccountFundingEventsByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type EpochAuthorityHeartbeatsByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityHeartbeatCondition>;
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityHeartbeatsOrderBy>>;
};


export type EpochAuthorityMembershipsByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityMembershipCondition>;
  filter?: InputMaybe<AuthorityMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityMembershipsOrderBy>>;
};


export type EpochBrokerVaultAddressesByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerVaultAddressCondition>;
  filter?: InputMaybe<BrokerVaultAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerVaultAddressesOrderBy>>;
};


export type EpochOperatorEpochDelegationApiesByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationApyCondition>;
  filter?: InputMaybe<OperatorEpochDelegationApyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationApiesOrderBy>>;
};


export type EpochOperatorEpochesByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochCondition>;
  filter?: InputMaybe<OperatorEpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochesOrderBy>>;
};


export type EpochRotationEventsByEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RotationEventCondition>;
  filter?: InputMaybe<RotationEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RotationEventsOrderBy>>;
};

export type EpochAggregates = {
  __typename?: 'EpochAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EpochAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EpochDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EpochMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EpochMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EpochStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EpochStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EpochSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EpochVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EpochVarianceSampleAggregates>;
};

export type EpochAverageAggregates = {
  __typename?: 'EpochAverageAggregates';
  /** Mean average of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Epoch` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EpochCondition = {
  blockByEndBlockId?: InputMaybe<Scalars['ID']['input']>;
  blockByStartBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `bond` field. */
  bond?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `endBlockId` field. */
  endBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxAuthoritySetSize` field. */
  maxAuthoritySetSize?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `minAuthoritySetSize` field. */
  minAuthoritySetSize?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `startBlockId` field. */
  startBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `totalBonded` field. */
  totalBonded?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type EpochDistinctCountAggregates = {
  __typename?: 'EpochDistinctCountAggregates';
  /** Distinct count of bond across the matching connection */
  bond?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Epoch` object types. All fields are combined with a logical ‘and.’ */
export type EpochFilter = {
  /** Filter by the object’s `accountFundingEventsByEpochId` relation. */
  accountFundingEventsByEpochId?: InputMaybe<EpochToManyAccountFundingEventFilter>;
  /** Some related `accountFundingEventsByEpochId` exist. */
  accountFundingEventsByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EpochFilter>>;
  /** Filter by the object’s `authorityHeartbeatsByEpochId` relation. */
  authorityHeartbeatsByEpochId?: InputMaybe<EpochToManyAuthorityHeartbeatFilter>;
  /** Some related `authorityHeartbeatsByEpochId` exist. */
  authorityHeartbeatsByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `authorityMembershipsByEpochId` relation. */
  authorityMembershipsByEpochId?: InputMaybe<EpochToManyAuthorityMembershipFilter>;
  /** Some related `authorityMembershipsByEpochId` exist. */
  authorityMembershipsByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `blockByEndBlockId` relation. */
  blockByEndBlockId?: InputMaybe<BlockFilter>;
  /** A related `blockByEndBlockId` exists. */
  blockByEndBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `blockByStartBlockId` relation. */
  blockByStartBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `bond` field. */
  bond?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `brokerVaultAddressesByEpochId` relation. */
  brokerVaultAddressesByEpochId?: InputMaybe<EpochToManyBrokerVaultAddressFilter>;
  /** Some related `brokerVaultAddressesByEpochId` exist. */
  brokerVaultAddressesByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `endBlockId` field. */
  endBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxAuthoritySetSize` field. */
  maxAuthoritySetSize?: InputMaybe<IntFilter>;
  /** Filter by the object’s `minAuthoritySetSize` field. */
  minAuthoritySetSize?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `operatorEpochDelegationApiesByEpochId` relation. */
  operatorEpochDelegationApiesByEpochId?: InputMaybe<EpochToManyOperatorEpochDelegationApyFilter>;
  /** Some related `operatorEpochDelegationApiesByEpochId` exist. */
  operatorEpochDelegationApiesByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochesByEpochId` relation. */
  operatorEpochesByEpochId?: InputMaybe<EpochToManyOperatorEpochFilter>;
  /** Some related `operatorEpochesByEpochId` exist. */
  operatorEpochesByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EpochFilter>>;
  /** Filter by the object’s `rotationEventsByEpochId` relation. */
  rotationEventsByEpochId?: InputMaybe<EpochToManyRotationEventFilter>;
  /** Some related `rotationEventsByEpochId` exist. */
  rotationEventsByEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `startBlockId` field. */
  startBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `totalBonded` field. */
  totalBonded?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `Epoch` for usage during aggregation. */
export type EpochGroupBy =
  | 'BOND'
  | 'MAX_AUTHORITY_SET_SIZE'
  | 'MIN_AUTHORITY_SET_SIZE'
  | 'TOTAL_BONDED';

export type EpochHavingAverageInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingDistinctCountInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `Epoch` aggregates. */
export type EpochHavingInput = {
  AND?: InputMaybe<Array<EpochHavingInput>>;
  OR?: InputMaybe<Array<EpochHavingInput>>;
  average?: InputMaybe<EpochHavingAverageInput>;
  distinctCount?: InputMaybe<EpochHavingDistinctCountInput>;
  max?: InputMaybe<EpochHavingMaxInput>;
  min?: InputMaybe<EpochHavingMinInput>;
  stddevPopulation?: InputMaybe<EpochHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EpochHavingStddevSampleInput>;
  sum?: InputMaybe<EpochHavingSumInput>;
  variancePopulation?: InputMaybe<EpochHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EpochHavingVarianceSampleInput>;
};

export type EpochHavingMaxInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingMinInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingStddevPopulationInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingStddevSampleInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingSumInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingVariancePopulationInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochHavingVarianceSampleInput = {
  bond?: InputMaybe<HavingBigfloatFilter>;
  endBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  maxAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  minAuthoritySetSize?: InputMaybe<HavingIntFilter>;
  startBlockId?: InputMaybe<HavingIntFilter>;
  totalBonded?: InputMaybe<HavingBigfloatFilter>;
};

export type EpochMaxAggregates = {
  __typename?: 'EpochMaxAggregates';
  /** Maximum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['Int']['output']>;
  /** Maximum of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['Int']['output']>;
  /** Maximum of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

export type EpochMinAggregates = {
  __typename?: 'EpochMinAggregates';
  /** Minimum of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['Int']['output']>;
  /** Minimum of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['Int']['output']>;
  /** Minimum of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

export type EpochStddevPopulationAggregates = {
  __typename?: 'EpochStddevPopulationAggregates';
  /** Population standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

export type EpochStddevSampleAggregates = {
  __typename?: 'EpochStddevSampleAggregates';
  /** Sample standard deviation of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

export type EpochSumAggregates = {
  __typename?: 'EpochSumAggregates';
  /** Sum of bond across the matching connection */
  bond: Scalars['BigFloat']['output'];
  /** Sum of endBlockId across the matching connection */
  endBlockId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize: Scalars['BigInt']['output'];
  /** Sum of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize: Scalars['BigInt']['output'];
  /** Sum of startBlockId across the matching connection */
  startBlockId: Scalars['BigInt']['output'];
  /** Sum of totalBonded across the matching connection */
  totalBonded: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `AccountFundingEvent` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyAccountFundingEventFilter = {
  /** Aggregates across related `AccountFundingEvent` match the filter criteria. */
  aggregates?: InputMaybe<AccountFundingEventAggregatesFilter>;
  /** Every related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFundingEventFilter>;
  /** No related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFundingEventFilter>;
  /** Some related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFundingEventFilter>;
};

/** A filter to be used against many `AuthorityHeartbeat` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyAuthorityHeartbeatFilter = {
  /** Aggregates across related `AuthorityHeartbeat` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityHeartbeatAggregatesFilter>;
  /** Every related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityHeartbeatFilter>;
  /** No related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Some related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityHeartbeatFilter>;
};

/** A filter to be used against many `AuthorityMembership` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyAuthorityMembershipFilter = {
  /** Aggregates across related `AuthorityMembership` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityMembershipAggregatesFilter>;
  /** Every related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityMembershipFilter>;
  /** No related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityMembershipFilter>;
  /** Some related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityMembershipFilter>;
};

/** A filter to be used against many `BrokerVaultAddress` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyBrokerVaultAddressFilter = {
  /** Aggregates across related `BrokerVaultAddress` match the filter criteria. */
  aggregates?: InputMaybe<BrokerVaultAddressAggregatesFilter>;
  /** Every related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerVaultAddressFilter>;
  /** No related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerVaultAddressFilter>;
  /** Some related `BrokerVaultAddress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerVaultAddressFilter>;
};

/** A filter to be used against many `OperatorEpochDelegationApy` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyOperatorEpochDelegationApyFilter = {
  /** Aggregates across related `OperatorEpochDelegationApy` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochDelegationApyAggregatesFilter>;
  /** Every related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** No related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** Some related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochDelegationApyFilter>;
};

/** A filter to be used against many `OperatorEpoch` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyOperatorEpochFilter = {
  /** Aggregates across related `OperatorEpoch` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochAggregatesFilter>;
  /** Every related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochFilter>;
  /** No related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochFilter>;
  /** Some related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochFilter>;
};

/** A filter to be used against many `RotationEvent` object types. All fields are combined with a logical ‘and.’ */
export type EpochToManyRotationEventFilter = {
  /** Aggregates across related `RotationEvent` match the filter criteria. */
  aggregates?: InputMaybe<RotationEventAggregatesFilter>;
  /** Every related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RotationEventFilter>;
  /** No related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RotationEventFilter>;
  /** Some related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RotationEventFilter>;
};

export type EpochVariancePopulationAggregates = {
  __typename?: 'EpochVariancePopulationAggregates';
  /** Population variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

export type EpochVarianceSampleAggregates = {
  __typename?: 'EpochVarianceSampleAggregates';
  /** Sample variance of bond across the matching connection */
  bond?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of endBlockId across the matching connection */
  endBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxAuthoritySetSize across the matching connection */
  maxAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minAuthoritySetSize across the matching connection */
  minAuthoritySetSize?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of startBlockId across the matching connection */
  startBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBonded across the matching connection */
  totalBonded?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Epoch` values. */
export type EpochesConnection = {
  __typename?: 'EpochesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EpochAggregates>;
  /** A list of edges which contains the `Epoch` and cursor to aid in pagination. */
  edges: Array<EpochesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EpochAggregates>>;
  /** A list of `Epoch` objects. */
  nodes: Array<Epoch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Epoch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Epoch` values. */
export type EpochesConnectionGroupedAggregatesArgs = {
  groupBy: Array<EpochGroupBy>;
  having?: InputMaybe<EpochHavingInput>;
};

/** A `Epoch` edge in the connection. */
export type EpochesEdge = {
  __typename?: 'EpochesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Epoch` at the end of the edge. */
  node: Epoch;
};

/** Methods to use when ordering `Epoch`. */
export type EpochesOrderBy =
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_AVERAGE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_COUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_COUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_FUNDED_FUNDER_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_FUNDED_FUNDER_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MAX_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_MIN_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_SUM_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_COUNT_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_COUNT_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_COUNT_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_COUNT_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'BOND_ASC'
  | 'BOND_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_COUNT_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_COUNT_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ADDRESS_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ADDRESS_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MAX_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_MIN_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_SUM_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_VAULT_ADDRESSES_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'END_BLOCK_ID_ASC'
  | 'END_BLOCK_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MAX_AUTHORITY_SET_SIZE_ASC'
  | 'MAX_AUTHORITY_SET_SIZE_DESC'
  | 'MIN_AUTHORITY_SET_SIZE_ASC'
  | 'MIN_AUTHORITY_SET_SIZE_DESC'
  | 'NATURAL'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_AVERAGE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_COUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_COUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_DISTINCT_COUNT_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MAX_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_MIN_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_POPULATION_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_STDDEV_SAMPLE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_SUM_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_POPULATION_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_EPOCH_ID_VARIANCE_SAMPLE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_AVERAGE_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_COUNT_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_COUNT_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MAX_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_MIN_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_SUM_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'START_BLOCK_ID_ASC'
  | 'START_BLOCK_ID_DESC'
  | 'TOTAL_BONDED_ASC'
  | 'TOTAL_BONDED_DESC';

export type Event = Node & {
  __typename?: 'Event';
  /** Reads and enables pagination through a set of `AccountCreationDepositChannel`. */
  accountCreationDepositChannelsByIssuedEventId: AccountCreationDepositChannelsConnection;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsByEventId: AccountFundingEventsConnection;
  /** Reads a single `Block` that is related to this `Event`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitsByEventId: BoostNetworkFeeSplitsConnection;
  /** Reads and enables pagination through a set of `Broadcast`. */
  broadcastsByBroadcastAbortedEventId: BroadcastsConnection;
  /** Reads and enables pagination through a set of `Broadcast`. */
  broadcastsByBroadcastRequestedEventId: BroadcastsConnection;
  /** Reads and enables pagination through a set of `Broadcast`. */
  broadcastsByBroadcastSuccessEventId: BroadcastsConnection;
  /** Reads and enables pagination through a set of `Broadcast`. */
  broadcastsByTransactionBroadcastRequestEventId: BroadcastsConnection;
  /** Reads and enables pagination through a set of `BrokerChannel`. */
  brokerChannelsByCloseEventId: BrokerChannelsConnection;
  /** Reads and enables pagination through a set of `BrokerChannel`. */
  brokerChannelsByOpenEventId: BrokerChannelsConnection;
  /** Reads a single `BrokerFeeAndWithdrawalV2` that is related to this `Event`. */
  brokerFeeAndWithdrawalV2ByEventId?: Maybe<BrokerFeeAndWithdrawalV2>;
  /** Reads and enables pagination through a set of `BrokerFeeAndWithdrawalV2`. */
  brokerFeeAndWithdrawalV2SByEventId: BrokerFeeAndWithdrawalV2SConnection;
  /** Reads and enables pagination through a set of `BrokerWithdrawal`. */
  brokerWithdrawalsByEventId: BrokerWithdrawalsConnection;
  /** Reads and enables pagination through a set of `Broker`. */
  brokersByRegistratonEventId: BrokersConnection;
  /** Reads and enables pagination through a set of `Burn`. */
  burnsByEventId: BurnsConnection;
  /** Reads and enables pagination through a set of `CollectedFee`. */
  collectedFeesByEventId: CollectedFeesConnection;
  /** Reads and enables pagination through a set of `DelegationActivity`. */
  delegationActivitiesByEventId: DelegationActivitiesConnection;
  /** Reads a single `Egress` that is related to this `Event`. */
  egressByFailedEventId?: Maybe<Egress>;
  /** Reads a single `Egress` that is related to this `Event`. */
  egressByScheduledEventId?: Maybe<Egress>;
  /** Reads and enables pagination through a set of `Egress`. */
  egressesByFailedEventId: EgressesConnection;
  /** Reads and enables pagination through a set of `Egress`. */
  egressesByScheduledEventId: EgressesConnection;
  /** Reads and enables pagination through a set of `EvmStateChainCall`. */
  evmStateChainCallsByEventId: EvmStateChainCallsConnection;
  /** Reads a single `FailedDeposit` that is related to this `Event`. */
  failedDepositByEventId?: Maybe<FailedDeposit>;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByEventId: FailedDepositsConnection;
  /** Reads and enables pagination through a set of `ForeignChainTracking`. */
  foreignChainTrackingsByStateChainEventId: ForeignChainTrackingsConnection;
  id: Scalars['BigInt']['output'];
  /** Reads a single `IgnoredEgress` that is related to this `Event`. */
  ignoredEgressByEventId?: Maybe<IgnoredEgress>;
  /** Reads and enables pagination through a set of `IgnoredEgress`. */
  ignoredEgressesByEventId: IgnoredEgressesConnection;
  indexInBlock: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosByAbortedAtEventId: LiquidationSwapInfosConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosByCollateralAddedEventId: LiquidationSwapInfosConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosByCompletedAtEventId: LiquidationSwapInfosConnection;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosByLoanRepaidEventId: LiquidationSwapInfosConnection;
  /** Reads a single `LiquidityBalanceEvent` that is related to this `Event`. */
  liquidityBalanceEventByEventId?: Maybe<LiquidityBalanceEvent>;
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByEventId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityDepositChannel`. */
  liquidityDepositChannelsByIssuedEventId: LiquidityDepositChannelsConnection;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  liquidityDepositsByEventId: LiquidityDepositsConnection;
  /** Reads and enables pagination through a set of `LiquidityTransfer`. */
  liquidityTransfersByEventId: LiquidityTransfersConnection;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByEventId: LiquidityWithdrawalsConnection;
  metadataId: Scalars['Int']['output'];
  /** Reads a single `Metadatum` that is related to this `Event`. */
  metadatumByMetadataId: Metadatum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OnChainSwapInfo`. */
  onChainSwapInfosByCreditedOnChainEventId: OnChainSwapInfosConnection;
  /** Reads and enables pagination through a set of `OnChainSwapInfo`. */
  onChainSwapInfosByRefundedOnChainEventId: OnChainSwapInfosConnection;
  /** Reads and enables pagination through a set of `OperatorAction`. */
  operatorActionsByEventId: OperatorActionsConnection;
  /** Reads and enables pagination through a set of `OperatorValidatorLink`. */
  operatorValidatorLinksByEventId: OperatorValidatorLinksConnection;
  /** Reads and enables pagination through a set of `OraclePriceTracking`. */
  oraclePriceTrackingsByCreatedAtEventId: OraclePriceTrackingsConnection;
  /** Reads and enables pagination through a set of `Penalty`. */
  penaltiesByEventId: PenaltiesConnection;
  /** Reads a single `PoolOrderEvent` that is related to this `Event`. */
  poolOrderEventByEventId?: Maybe<PoolOrderEvent>;
  /** Reads and enables pagination through a set of `PoolOrderEvent`. */
  poolOrderEventsByEventId: PoolOrderEventsConnection;
  /** Reads and enables pagination through a set of `PoolSwap`. */
  poolSwapsByAssetSwappedEventId: PoolSwapsConnection;
  /** Reads a single `RecentPoolOrderEvent` that is related to this `Event`. */
  recentPoolOrderEventByEventId?: Maybe<RecentPoolOrderEvent>;
  /** Reads and enables pagination through a set of `RecentPoolOrderEvent`. */
  recentPoolOrderEventsByEventId: RecentPoolOrderEventsConnection;
  /** Reads and enables pagination through a set of `RotationEvent`. */
  rotationEventsByEventId: RotationEventsConnection;
  /** Reads and enables pagination through a set of `SwapChannel`. */
  swapChannelsByIssuedEventId: SwapChannelsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByCompletedEventId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByRequestedEventId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `Swap`. */
  swapsBySwapAbortedEventId: SwapsConnection;
  /** Reads and enables pagination through a set of `Swap`. */
  swapsBySwapExecutedEventId: SwapsConnection;
  /** Reads and enables pagination through a set of `Swap`. */
  swapsBySwapScheduledEventId: SwapsConnection;
};


export type EventAccountCreationDepositChannelsByIssuedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCreationDepositChannelCondition>;
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCreationDepositChannelsOrderBy>>;
};


export type EventAccountFundingEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type EventBoostNetworkFeeSplitsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


export type EventBroadcastsByBroadcastAbortedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


export type EventBroadcastsByBroadcastRequestedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


export type EventBroadcastsByBroadcastSuccessEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


export type EventBroadcastsByTransactionBroadcastRequestEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


export type EventBrokerChannelsByCloseEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerChannelCondition>;
  filter?: InputMaybe<BrokerChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerChannelsOrderBy>>;
};


export type EventBrokerChannelsByOpenEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerChannelCondition>;
  filter?: InputMaybe<BrokerChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerChannelsOrderBy>>;
};


export type EventBrokerFeeAndWithdrawalV2SByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerFeeAndWithdrawalV2Condition>;
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerFeeAndWithdrawalV2SOrderBy>>;
};


export type EventBrokerWithdrawalsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerWithdrawalCondition>;
  filter?: InputMaybe<BrokerWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerWithdrawalsOrderBy>>;
};


export type EventBrokersByRegistratonEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerCondition>;
  filter?: InputMaybe<BrokerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokersOrderBy>>;
};


export type EventBurnsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BurnCondition>;
  filter?: InputMaybe<BurnFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BurnsOrderBy>>;
};


export type EventCollectedFeesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CollectedFeeCondition>;
  filter?: InputMaybe<CollectedFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CollectedFeesOrderBy>>;
};


export type EventDelegationActivitiesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationActivityCondition>;
  filter?: InputMaybe<DelegationActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationActivitiesOrderBy>>;
};


export type EventEgressesByFailedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EgressCondition>;
  filter?: InputMaybe<EgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EgressesOrderBy>>;
};


export type EventEgressesByScheduledEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EgressCondition>;
  filter?: InputMaybe<EgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EgressesOrderBy>>;
};


export type EventEvmStateChainCallsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvmStateChainCallCondition>;
  filter?: InputMaybe<EvmStateChainCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvmStateChainCallsOrderBy>>;
};


export type EventFailedDepositsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type EventForeignChainTrackingsByStateChainEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ForeignChainTrackingCondition>;
  filter?: InputMaybe<ForeignChainTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ForeignChainTrackingsOrderBy>>;
};


export type EventIgnoredEgressesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IgnoredEgressCondition>;
  filter?: InputMaybe<IgnoredEgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IgnoredEgressesOrderBy>>;
};


export type EventLiquidationSwapInfosByAbortedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type EventLiquidationSwapInfosByCollateralAddedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type EventLiquidationSwapInfosByCompletedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type EventLiquidationSwapInfosByLoanRepaidEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type EventLiquidityBalanceEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type EventLiquidityDepositChannelsByIssuedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositChannelCondition>;
  filter?: InputMaybe<LiquidityDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositChannelsOrderBy>>;
};


export type EventLiquidityDepositsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};


export type EventLiquidityTransfersByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityTransferCondition>;
  filter?: InputMaybe<LiquidityTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityTransfersOrderBy>>;
};


export type EventLiquidityWithdrawalsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


export type EventOnChainSwapInfosByCreditedOnChainEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OnChainSwapInfoCondition>;
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OnChainSwapInfosOrderBy>>;
};


export type EventOnChainSwapInfosByRefundedOnChainEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OnChainSwapInfoCondition>;
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OnChainSwapInfosOrderBy>>;
};


export type EventOperatorActionsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorActionCondition>;
  filter?: InputMaybe<OperatorActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorActionsOrderBy>>;
};


export type EventOperatorValidatorLinksByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorLinkCondition>;
  filter?: InputMaybe<OperatorValidatorLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorLinksOrderBy>>;
};


export type EventOraclePriceTrackingsByCreatedAtEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OraclePriceTrackingCondition>;
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OraclePriceTrackingsOrderBy>>;
};


export type EventPenaltiesByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PenaltyCondition>;
  filter?: InputMaybe<PenaltyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PenaltiesOrderBy>>;
};


export type EventPoolOrderEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderEventCondition>;
  filter?: InputMaybe<PoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrderEventsOrderBy>>;
};


export type EventPoolSwapsByAssetSwappedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolSwapCondition>;
  filter?: InputMaybe<PoolSwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolSwapsOrderBy>>;
};


export type EventRecentPoolOrderEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RecentPoolOrderEventCondition>;
  filter?: InputMaybe<RecentPoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecentPoolOrderEventsOrderBy>>;
};


export type EventRotationEventsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RotationEventCondition>;
  filter?: InputMaybe<RotationEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RotationEventsOrderBy>>;
};


export type EventSwapChannelsByIssuedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelCondition>;
  filter?: InputMaybe<SwapChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelsOrderBy>>;
};


export type EventSwapRequestsByCompletedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type EventSwapRequestsByRequestedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type EventSwapsBySwapAbortedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCondition>;
  filter?: InputMaybe<SwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapsOrderBy>>;
};


export type EventSwapsBySwapExecutedEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCondition>;
  filter?: InputMaybe<SwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapsOrderBy>>;
};


export type EventSwapsBySwapScheduledEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCondition>;
  filter?: InputMaybe<SwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapsOrderBy>>;
};

export type EventAggregates = {
  __typename?: 'EventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Event` object types. */
export type EventAggregatesFilter = {
  /** Mean average aggregate over matching `Event` objects. */
  average?: InputMaybe<EventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Event` objects. */
  distinctCount?: InputMaybe<EventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Event` object to be included within the aggregate. */
  filter?: InputMaybe<EventFilter>;
  /** Maximum aggregate over matching `Event` objects. */
  max?: InputMaybe<EventMaxAggregateFilter>;
  /** Minimum aggregate over matching `Event` objects. */
  min?: InputMaybe<EventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Event` objects. */
  stddevPopulation?: InputMaybe<EventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Event` objects. */
  stddevSample?: InputMaybe<EventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Event` objects. */
  sum?: InputMaybe<EventSumAggregateFilter>;
  /** Population variance aggregate over matching `Event` objects. */
  variancePopulation?: InputMaybe<EventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Event` objects. */
  varianceSample?: InputMaybe<EventVarianceSampleAggregateFilter>;
};

export type EventAverageAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
};

export type EventAverageAggregates = {
  __typename?: 'EventAverageAggregates';
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Event` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type EventCondition = {
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars['Int']['input']>;
  metadatumByMetadataId?: InputMaybe<Scalars['ID']['input']>;
};

export type EventDistinctCountAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  indexInBlock?: InputMaybe<BigIntFilter>;
  metadataId?: InputMaybe<BigIntFilter>;
};

export type EventDistinctCountAggregates = {
  __typename?: 'EventDistinctCountAggregates';
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Event` object types. All fields are combined with a logical ‘and.’ */
export type EventFilter = {
  /** Filter by the object’s `accountCreationDepositChannelsByIssuedEventId` relation. */
  accountCreationDepositChannelsByIssuedEventId?: InputMaybe<EventToManyAccountCreationDepositChannelFilter>;
  /** Some related `accountCreationDepositChannelsByIssuedEventId` exist. */
  accountCreationDepositChannelsByIssuedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountFundingEventsByEventId` relation. */
  accountFundingEventsByEventId?: InputMaybe<EventToManyAccountFundingEventFilter>;
  /** Some related `accountFundingEventsByEventId` exist. */
  accountFundingEventsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostNetworkFeeSplitsByEventId` relation. */
  boostNetworkFeeSplitsByEventId?: InputMaybe<EventToManyBoostNetworkFeeSplitFilter>;
  /** Some related `boostNetworkFeeSplitsByEventId` exist. */
  boostNetworkFeeSplitsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastsByBroadcastAbortedEventId` relation. */
  broadcastsByBroadcastAbortedEventId?: InputMaybe<EventToManyBroadcastFilter>;
  /** Some related `broadcastsByBroadcastAbortedEventId` exist. */
  broadcastsByBroadcastAbortedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastsByBroadcastRequestedEventId` relation. */
  broadcastsByBroadcastRequestedEventId?: InputMaybe<EventToManyBroadcastFilter>;
  /** Some related `broadcastsByBroadcastRequestedEventId` exist. */
  broadcastsByBroadcastRequestedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastsByBroadcastSuccessEventId` relation. */
  broadcastsByBroadcastSuccessEventId?: InputMaybe<EventToManyBroadcastFilter>;
  /** Some related `broadcastsByBroadcastSuccessEventId` exist. */
  broadcastsByBroadcastSuccessEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastsByTransactionBroadcastRequestEventId` relation. */
  broadcastsByTransactionBroadcastRequestEventId?: InputMaybe<EventToManyBroadcastFilter>;
  /** Some related `broadcastsByTransactionBroadcastRequestEventId` exist. */
  broadcastsByTransactionBroadcastRequestEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelsByCloseEventId` relation. */
  brokerChannelsByCloseEventId?: InputMaybe<EventToManyBrokerChannelFilter>;
  /** Some related `brokerChannelsByCloseEventId` exist. */
  brokerChannelsByCloseEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelsByOpenEventId` relation. */
  brokerChannelsByOpenEventId?: InputMaybe<EventToManyBrokerChannelFilter>;
  /** Some related `brokerChannelsByOpenEventId` exist. */
  brokerChannelsByOpenEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerFeeAndWithdrawalV2ByEventId` relation. */
  brokerFeeAndWithdrawalV2ByEventId?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  /** A related `brokerFeeAndWithdrawalV2ByEventId` exists. */
  brokerFeeAndWithdrawalV2ByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerWithdrawalsByEventId` relation. */
  brokerWithdrawalsByEventId?: InputMaybe<EventToManyBrokerWithdrawalFilter>;
  /** Some related `brokerWithdrawalsByEventId` exist. */
  brokerWithdrawalsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokersByRegistratonEventId` relation. */
  brokersByRegistratonEventId?: InputMaybe<EventToManyBrokerFilter>;
  /** Some related `brokersByRegistratonEventId` exist. */
  brokersByRegistratonEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `burnsByEventId` relation. */
  burnsByEventId?: InputMaybe<EventToManyBurnFilter>;
  /** Some related `burnsByEventId` exist. */
  burnsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `collectedFeesByEventId` relation. */
  collectedFeesByEventId?: InputMaybe<EventToManyCollectedFeeFilter>;
  /** Some related `collectedFeesByEventId` exist. */
  collectedFeesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `delegationActivitiesByEventId` relation. */
  delegationActivitiesByEventId?: InputMaybe<EventToManyDelegationActivityFilter>;
  /** Some related `delegationActivitiesByEventId` exist. */
  delegationActivitiesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressByFailedEventId` relation. */
  egressByFailedEventId?: InputMaybe<EgressFilter>;
  /** A related `egressByFailedEventId` exists. */
  egressByFailedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressByScheduledEventId` relation. */
  egressByScheduledEventId?: InputMaybe<EgressFilter>;
  /** A related `egressByScheduledEventId` exists. */
  egressByScheduledEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `evmStateChainCallsByEventId` relation. */
  evmStateChainCallsByEventId?: InputMaybe<EventToManyEvmStateChainCallFilter>;
  /** Some related `evmStateChainCallsByEventId` exist. */
  evmStateChainCallsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `failedDepositByEventId` relation. */
  failedDepositByEventId?: InputMaybe<FailedDepositFilter>;
  /** A related `failedDepositByEventId` exists. */
  failedDepositByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `foreignChainTrackingsByStateChainEventId` relation. */
  foreignChainTrackingsByStateChainEventId?: InputMaybe<EventToManyForeignChainTrackingFilter>;
  /** Some related `foreignChainTrackingsByStateChainEventId` exist. */
  foreignChainTrackingsByStateChainEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `ignoredEgressByEventId` relation. */
  ignoredEgressByEventId?: InputMaybe<IgnoredEgressFilter>;
  /** A related `ignoredEgressByEventId` exists. */
  ignoredEgressByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidationSwapInfosByAbortedAtEventId` relation. */
  liquidationSwapInfosByAbortedAtEventId?: InputMaybe<EventToManyLiquidationSwapInfoFilter>;
  /** Some related `liquidationSwapInfosByAbortedAtEventId` exist. */
  liquidationSwapInfosByAbortedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapInfosByCollateralAddedEventId` relation. */
  liquidationSwapInfosByCollateralAddedEventId?: InputMaybe<EventToManyLiquidationSwapInfoFilter>;
  /** Some related `liquidationSwapInfosByCollateralAddedEventId` exist. */
  liquidationSwapInfosByCollateralAddedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapInfosByCompletedAtEventId` relation. */
  liquidationSwapInfosByCompletedAtEventId?: InputMaybe<EventToManyLiquidationSwapInfoFilter>;
  /** Some related `liquidationSwapInfosByCompletedAtEventId` exist. */
  liquidationSwapInfosByCompletedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapInfosByLoanRepaidEventId` relation. */
  liquidationSwapInfosByLoanRepaidEventId?: InputMaybe<EventToManyLiquidationSwapInfoFilter>;
  /** Some related `liquidationSwapInfosByLoanRepaidEventId` exist. */
  liquidationSwapInfosByLoanRepaidEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityBalanceEventByEventId` relation. */
  liquidityBalanceEventByEventId?: InputMaybe<LiquidityBalanceEventFilter>;
  /** A related `liquidityBalanceEventByEventId` exists. */
  liquidityBalanceEventByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelsByIssuedEventId` relation. */
  liquidityDepositChannelsByIssuedEventId?: InputMaybe<EventToManyLiquidityDepositChannelFilter>;
  /** Some related `liquidityDepositChannelsByIssuedEventId` exist. */
  liquidityDepositChannelsByIssuedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositsByEventId` relation. */
  liquidityDepositsByEventId?: InputMaybe<EventToManyLiquidityDepositFilter>;
  /** Some related `liquidityDepositsByEventId` exist. */
  liquidityDepositsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityTransfersByEventId` relation. */
  liquidityTransfersByEventId?: InputMaybe<EventToManyLiquidityTransferFilter>;
  /** Some related `liquidityTransfersByEventId` exist. */
  liquidityTransfersByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityWithdrawalsByEventId` relation. */
  liquidityWithdrawalsByEventId?: InputMaybe<EventToManyLiquidityWithdrawalFilter>;
  /** Some related `liquidityWithdrawalsByEventId` exist. */
  liquidityWithdrawalsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EventFilter>;
  /** Filter by the object’s `onChainSwapInfosByCreditedOnChainEventId` relation. */
  onChainSwapInfosByCreditedOnChainEventId?: InputMaybe<EventToManyOnChainSwapInfoFilter>;
  /** Some related `onChainSwapInfosByCreditedOnChainEventId` exist. */
  onChainSwapInfosByCreditedOnChainEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `onChainSwapInfosByRefundedOnChainEventId` relation. */
  onChainSwapInfosByRefundedOnChainEventId?: InputMaybe<EventToManyOnChainSwapInfoFilter>;
  /** Some related `onChainSwapInfosByRefundedOnChainEventId` exist. */
  onChainSwapInfosByRefundedOnChainEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorActionsByEventId` relation. */
  operatorActionsByEventId?: InputMaybe<EventToManyOperatorActionFilter>;
  /** Some related `operatorActionsByEventId` exist. */
  operatorActionsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorValidatorLinksByEventId` relation. */
  operatorValidatorLinksByEventId?: InputMaybe<EventToManyOperatorValidatorLinkFilter>;
  /** Some related `operatorValidatorLinksByEventId` exist. */
  operatorValidatorLinksByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EventFilter>>;
  /** Filter by the object’s `oraclePriceTrackingsByCreatedAtEventId` relation. */
  oraclePriceTrackingsByCreatedAtEventId?: InputMaybe<EventToManyOraclePriceTrackingFilter>;
  /** Some related `oraclePriceTrackingsByCreatedAtEventId` exist. */
  oraclePriceTrackingsByCreatedAtEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `penaltiesByEventId` relation. */
  penaltiesByEventId?: InputMaybe<EventToManyPenaltyFilter>;
  /** Some related `penaltiesByEventId` exist. */
  penaltiesByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `poolOrderEventByEventId` relation. */
  poolOrderEventByEventId?: InputMaybe<PoolOrderEventFilter>;
  /** A related `poolOrderEventByEventId` exists. */
  poolOrderEventByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `poolSwapsByAssetSwappedEventId` relation. */
  poolSwapsByAssetSwappedEventId?: InputMaybe<EventToManyPoolSwapFilter>;
  /** Some related `poolSwapsByAssetSwappedEventId` exist. */
  poolSwapsByAssetSwappedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `recentPoolOrderEventByEventId` relation. */
  recentPoolOrderEventByEventId?: InputMaybe<RecentPoolOrderEventFilter>;
  /** A related `recentPoolOrderEventByEventId` exists. */
  recentPoolOrderEventByEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `rotationEventsByEventId` relation. */
  rotationEventsByEventId?: InputMaybe<EventToManyRotationEventFilter>;
  /** Some related `rotationEventsByEventId` exist. */
  rotationEventsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapChannelsByIssuedEventId` relation. */
  swapChannelsByIssuedEventId?: InputMaybe<EventToManySwapChannelFilter>;
  /** Some related `swapChannelsByIssuedEventId` exist. */
  swapChannelsByIssuedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByCompletedEventId` relation. */
  swapRequestsByCompletedEventId?: InputMaybe<EventToManySwapRequestFilter>;
  /** Some related `swapRequestsByCompletedEventId` exist. */
  swapRequestsByCompletedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByRequestedEventId` relation. */
  swapRequestsByRequestedEventId?: InputMaybe<EventToManySwapRequestFilter>;
  /** Some related `swapRequestsByRequestedEventId` exist. */
  swapRequestsByRequestedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapsBySwapAbortedEventId` relation. */
  swapsBySwapAbortedEventId?: InputMaybe<EventToManySwapFilter>;
  /** Some related `swapsBySwapAbortedEventId` exist. */
  swapsBySwapAbortedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapsBySwapExecutedEventId` relation. */
  swapsBySwapExecutedEventId?: InputMaybe<EventToManySwapFilter>;
  /** Some related `swapsBySwapExecutedEventId` exist. */
  swapsBySwapExecutedEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapsBySwapScheduledEventId` relation. */
  swapsBySwapScheduledEventId?: InputMaybe<EventToManySwapFilter>;
  /** Some related `swapsBySwapScheduledEventId` exist. */
  swapsBySwapScheduledEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Event` for usage during aggregation. */
export type EventGroupBy =
  | 'BLOCK_ID'
  | 'INDEX_IN_BLOCK'
  | 'METADATA_ID';

export type EventHavingAverageInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingDistinctCountInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Event` aggregates. */
export type EventHavingInput = {
  AND?: InputMaybe<Array<EventHavingInput>>;
  OR?: InputMaybe<Array<EventHavingInput>>;
  average?: InputMaybe<EventHavingAverageInput>;
  distinctCount?: InputMaybe<EventHavingDistinctCountInput>;
  max?: InputMaybe<EventHavingMaxInput>;
  min?: InputMaybe<EventHavingMinInput>;
  stddevPopulation?: InputMaybe<EventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EventHavingStddevSampleInput>;
  sum?: InputMaybe<EventHavingSumInput>;
  variancePopulation?: InputMaybe<EventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EventHavingVarianceSampleInput>;
};

export type EventHavingMaxInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingMinInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingStddevPopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingStddevSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingSumInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingVariancePopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventHavingVarianceSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
};

export type EventInfo = {
  __typename?: 'EventInfo';
  args?: Maybe<Scalars['JSON']['output']>;
  blockHeight: Scalars['Int']['output'];
  extrinsicHash?: Maybe<Scalars['String']['output']>;
  indexInBlock: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  phase: Scalars['String']['output'];
};

export type EventMaxAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  indexInBlock?: InputMaybe<IntFilter>;
  metadataId?: InputMaybe<IntFilter>;
};

export type EventMaxAggregates = {
  __typename?: 'EventMaxAggregates';
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['Int']['output']>;
};

export type EventMinAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  id?: InputMaybe<BigIntFilter>;
  indexInBlock?: InputMaybe<IntFilter>;
  metadataId?: InputMaybe<IntFilter>;
};

export type EventMinAggregates = {
  __typename?: 'EventMinAggregates';
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['Int']['output']>;
};

export type EventStddevPopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
};

export type EventStddevPopulationAggregates = {
  __typename?: 'EventStddevPopulationAggregates';
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventStddevSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
};

export type EventStddevSampleAggregates = {
  __typename?: 'EventStddevSampleAggregates';
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventSumAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigIntFilter>;
  metadataId?: InputMaybe<BigIntFilter>;
};

export type EventSumAggregates = {
  __typename?: 'EventSumAggregates';
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of indexInBlock across the matching connection */
  indexInBlock: Scalars['BigInt']['output'];
  /** Sum of metadataId across the matching connection */
  metadataId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AccountCreationDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyAccountCreationDepositChannelFilter = {
  /** Aggregates across related `AccountCreationDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<AccountCreationDepositChannelAggregatesFilter>;
  /** Every related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** No related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** Some related `AccountCreationDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountCreationDepositChannelFilter>;
};

/** A filter to be used against many `AccountFundingEvent` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyAccountFundingEventFilter = {
  /** Aggregates across related `AccountFundingEvent` match the filter criteria. */
  aggregates?: InputMaybe<AccountFundingEventAggregatesFilter>;
  /** Every related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AccountFundingEventFilter>;
  /** No related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AccountFundingEventFilter>;
  /** Some related `AccountFundingEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AccountFundingEventFilter>;
};

/** A filter to be used against many `BoostNetworkFeeSplit` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBoostNetworkFeeSplitFilter = {
  /** Aggregates across related `BoostNetworkFeeSplit` match the filter criteria. */
  aggregates?: InputMaybe<BoostNetworkFeeSplitAggregatesFilter>;
  /** Every related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** No related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** Some related `BoostNetworkFeeSplit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BoostNetworkFeeSplitFilter>;
};

/** A filter to be used against many `Broadcast` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBroadcastFilter = {
  /** Aggregates across related `Broadcast` match the filter criteria. */
  aggregates?: InputMaybe<BroadcastAggregatesFilter>;
  /** Every related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BroadcastFilter>;
  /** No related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BroadcastFilter>;
  /** Some related `Broadcast` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BroadcastFilter>;
};

/** A filter to be used against many `BrokerChannel` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBrokerChannelFilter = {
  /** Aggregates across related `BrokerChannel` match the filter criteria. */
  aggregates?: InputMaybe<BrokerChannelAggregatesFilter>;
  /** Every related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerChannelFilter>;
  /** No related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerChannelFilter>;
  /** Some related `BrokerChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerChannelFilter>;
};

/** A filter to be used against many `Broker` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBrokerFilter = {
  /** Aggregates across related `Broker` match the filter criteria. */
  aggregates?: InputMaybe<BrokerAggregatesFilter>;
  /** Every related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerFilter>;
  /** No related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerFilter>;
  /** Some related `Broker` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerFilter>;
};

/** A filter to be used against many `BrokerWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBrokerWithdrawalFilter = {
  /** Aggregates across related `BrokerWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<BrokerWithdrawalAggregatesFilter>;
  /** Every related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BrokerWithdrawalFilter>;
  /** No related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BrokerWithdrawalFilter>;
  /** Some related `BrokerWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BrokerWithdrawalFilter>;
};

/** A filter to be used against many `Burn` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyBurnFilter = {
  /** Aggregates across related `Burn` match the filter criteria. */
  aggregates?: InputMaybe<BurnAggregatesFilter>;
  /** Every related `Burn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BurnFilter>;
  /** No related `Burn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BurnFilter>;
  /** Some related `Burn` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BurnFilter>;
};

/** A filter to be used against many `CollectedFee` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyCollectedFeeFilter = {
  /** Aggregates across related `CollectedFee` match the filter criteria. */
  aggregates?: InputMaybe<CollectedFeeAggregatesFilter>;
  /** Every related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CollectedFeeFilter>;
  /** No related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CollectedFeeFilter>;
  /** Some related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CollectedFeeFilter>;
};

/** A filter to be used against many `DelegationActivity` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyDelegationActivityFilter = {
  /** Aggregates across related `DelegationActivity` match the filter criteria. */
  aggregates?: InputMaybe<DelegationActivityAggregatesFilter>;
  /** Every related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DelegationActivityFilter>;
  /** No related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DelegationActivityFilter>;
  /** Some related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DelegationActivityFilter>;
};

/** A filter to be used against many `EvmStateChainCall` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyEvmStateChainCallFilter = {
  /** Aggregates across related `EvmStateChainCall` match the filter criteria. */
  aggregates?: InputMaybe<EvmStateChainCallAggregatesFilter>;
  /** Every related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EvmStateChainCallFilter>;
  /** No related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EvmStateChainCallFilter>;
  /** Some related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EvmStateChainCallFilter>;
};

/** A filter to be used against many `ForeignChainTracking` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyForeignChainTrackingFilter = {
  /** Aggregates across related `ForeignChainTracking` match the filter criteria. */
  aggregates?: InputMaybe<ForeignChainTrackingAggregatesFilter>;
  /** Every related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ForeignChainTrackingFilter>;
  /** No related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ForeignChainTrackingFilter>;
  /** Some related `ForeignChainTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ForeignChainTrackingFilter>;
};

/** A filter to be used against many `LiquidationSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidationSwapInfoFilter = {
  /** Aggregates across related `LiquidationSwapInfo` match the filter criteria. */
  aggregates?: InputMaybe<LiquidationSwapInfoAggregatesFilter>;
  /** Every related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidationSwapInfoFilter>;
  /** No related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidationSwapInfoFilter>;
  /** Some related `LiquidationSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidationSwapInfoFilter>;
};

/** A filter to be used against many `LiquidityDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidityDepositChannelFilter = {
  /** Aggregates across related `LiquidityDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositChannelAggregatesFilter>;
  /** Every related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositChannelFilter>;
  /** No related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositChannelFilter>;
  /** Some related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositChannelFilter>;
};

/** A filter to be used against many `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidityDepositFilter = {
  /** Aggregates across related `LiquidityDeposit` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositAggregatesFilter>;
  /** Every related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositFilter>;
  /** No related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositFilter>;
  /** Some related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositFilter>;
};

/** A filter to be used against many `LiquidityTransfer` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidityTransferFilter = {
  /** Aggregates across related `LiquidityTransfer` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityTransferAggregatesFilter>;
  /** Every related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityTransferFilter>;
  /** No related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityTransferFilter>;
  /** Some related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityTransferFilter>;
};

/** A filter to be used against many `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyLiquidityWithdrawalFilter = {
  /** Aggregates across related `LiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityWithdrawalAggregatesFilter>;
  /** Every related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityWithdrawalFilter>;
  /** No related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Some related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityWithdrawalFilter>;
};

/** A filter to be used against many `OnChainSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyOnChainSwapInfoFilter = {
  /** Aggregates across related `OnChainSwapInfo` match the filter criteria. */
  aggregates?: InputMaybe<OnChainSwapInfoAggregatesFilter>;
  /** Every related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OnChainSwapInfoFilter>;
  /** No related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OnChainSwapInfoFilter>;
  /** Some related `OnChainSwapInfo` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OnChainSwapInfoFilter>;
};

/** A filter to be used against many `OperatorAction` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyOperatorActionFilter = {
  /** Aggregates across related `OperatorAction` match the filter criteria. */
  aggregates?: InputMaybe<OperatorActionAggregatesFilter>;
  /** Every related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorActionFilter>;
  /** No related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorActionFilter>;
  /** Some related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorActionFilter>;
};

/** A filter to be used against many `OperatorValidatorLink` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyOperatorValidatorLinkFilter = {
  /** Aggregates across related `OperatorValidatorLink` match the filter criteria. */
  aggregates?: InputMaybe<OperatorValidatorLinkAggregatesFilter>;
  /** Every related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorValidatorLinkFilter>;
  /** No related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorValidatorLinkFilter>;
  /** Some related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorValidatorLinkFilter>;
};

/** A filter to be used against many `OraclePriceTracking` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyOraclePriceTrackingFilter = {
  /** Aggregates across related `OraclePriceTracking` match the filter criteria. */
  aggregates?: InputMaybe<OraclePriceTrackingAggregatesFilter>;
  /** Every related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OraclePriceTrackingFilter>;
  /** No related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OraclePriceTrackingFilter>;
  /** Some related `OraclePriceTracking` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OraclePriceTrackingFilter>;
};

/** A filter to be used against many `Penalty` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyPenaltyFilter = {
  /** Aggregates across related `Penalty` match the filter criteria. */
  aggregates?: InputMaybe<PenaltyAggregatesFilter>;
  /** Every related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PenaltyFilter>;
  /** No related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PenaltyFilter>;
  /** Some related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PenaltyFilter>;
};

/** A filter to be used against many `PoolSwap` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyPoolSwapFilter = {
  /** Aggregates across related `PoolSwap` match the filter criteria. */
  aggregates?: InputMaybe<PoolSwapAggregatesFilter>;
  /** Every related `PoolSwap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PoolSwapFilter>;
  /** No related `PoolSwap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PoolSwapFilter>;
  /** Some related `PoolSwap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PoolSwapFilter>;
};

/** A filter to be used against many `RotationEvent` object types. All fields are combined with a logical ‘and.’ */
export type EventToManyRotationEventFilter = {
  /** Aggregates across related `RotationEvent` match the filter criteria. */
  aggregates?: InputMaybe<RotationEventAggregatesFilter>;
  /** Every related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RotationEventFilter>;
  /** No related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RotationEventFilter>;
  /** Some related `RotationEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RotationEventFilter>;
};

/** A filter to be used against many `SwapChannel` object types. All fields are combined with a logical ‘and.’ */
export type EventToManySwapChannelFilter = {
  /** Aggregates across related `SwapChannel` match the filter criteria. */
  aggregates?: InputMaybe<SwapChannelAggregatesFilter>;
  /** Every related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapChannelFilter>;
  /** No related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapChannelFilter>;
  /** Some related `SwapChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapChannelFilter>;
};

/** A filter to be used against many `Swap` object types. All fields are combined with a logical ‘and.’ */
export type EventToManySwapFilter = {
  /** Aggregates across related `Swap` match the filter criteria. */
  aggregates?: InputMaybe<SwapAggregatesFilter>;
  /** Every related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapFilter>;
  /** No related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapFilter>;
  /** Some related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type EventToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type EventVariancePopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
};

export type EventVariancePopulationAggregates = {
  __typename?: 'EventVariancePopulationAggregates';
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EventVarianceSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
};

export type EventVarianceSampleAggregates = {
  __typename?: 'EventVarianceSampleAggregates';
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Event` values. */
export type EventsConnection = {
  __typename?: 'EventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EventAggregates>;
  /** A list of edges which contains the `Event` and cursor to aid in pagination. */
  edges: Array<EventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EventAggregates>>;
  /** A list of `Event` objects. */
  nodes: Array<Event>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Event` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Event` values. */
export type EventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<EventGroupBy>;
  having?: InputMaybe<EventHavingInput>;
};

/** A `Event` edge in the connection. */
export type EventsEdge = {
  __typename?: 'EventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Event` at the end of the edge. */
  node: Event;
};

/** Methods to use when ordering `Event`. */
export type EventsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_REFUND_ADDRESS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_REFUND_ADDRESS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CREATED_ACCOUNT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHAIN_EXPIRY_BLOCK_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_COUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_COUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_FUNDED_FUNDER_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_FUNDED_FUNDER_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_REDEEMED_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_REBALANCE_COUNTERPARTY_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'ACCOUNT_FUNDING_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_COUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_COUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOSTED_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOSTED_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOSTED_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_NETWORK_FEE_SWAP_REQUEST_ID_DESC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'BOOST_NETWORK_FEE_SPLITS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_COUNT_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_COUNT_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_ABORTED_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_COUNT_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_COUNT_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_COUNT_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_COUNT_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_BROADCAST_SUCCESS_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_AVERAGE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_COUNT_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_COUNT_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DISTINCT_COUNT_TRANSACTION_PAYLOAD_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MAX_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_MIN_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_STDDEV_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_SUM_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_POPULATION_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ABORTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_REQUESTED_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_SUCCESS_EVENT_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_REPLACED_BY_ID_DESC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_ASC'
  | 'BROADCASTS_BY_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_VARIANCE_SAMPLE_TRANSACTION_BROADCAST_REQUEST_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_AVERAGE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_COUNT_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_COUNT_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MAX_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_MIN_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_POPULATION_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_STDDEV_SAMPLE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_SUM_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_POPULATION_REGISTRATON_EVENT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_DELEGATE_BROKER_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_REGISTRATION_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_REGISTRATION_ID_DESC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_REGISTRATON_EVENT_ID_ASC'
  | 'BROKERS_BY_REGISTRATON_EVENT_ID_VARIANCE_SAMPLE_REGISTRATON_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_AVERAGE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_COUNT_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_COUNT_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_DISTINCT_COUNT_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MAX_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_MIN_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_SUM_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_CLOSE_EVENT_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_AVERAGE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_COUNT_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_COUNT_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_DISTINCT_COUNT_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MAX_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_MIN_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_STDDEV_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_SUM_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_POPULATION_OPEN_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_CLOSE_EVENT_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_ASC'
  | 'BROKER_CHANNELS_BY_OPEN_EVENT_ID_VARIANCE_SAMPLE_OPEN_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_COUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_COUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MAX_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_MIN_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_SUM_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_AMOUNT_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_FEE_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_FEE_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_FEE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_VALUE_USD_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BROKER_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_COUNT_ASC'
  | 'BURNS_BY_EVENT_ID_COUNT_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_ID_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_ID_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_ID_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_ID_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_SUM_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_SUM_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_SUM_ID_ASC'
  | 'BURNS_BY_EVENT_ID_SUM_ID_DESC'
  | 'BURNS_BY_EVENT_ID_SUM_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_SUM_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_BOOST_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_TOTAL_AMOUNT_DESC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'BURNS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_COUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_COUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_COUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_COUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_AVERAGE_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_COUNT_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_COUNT_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_BYTES_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_BYTES_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_CALL_DATA_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_CALL_DATA_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_SUCCESS_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_SUCCESS_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MAX_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_MIN_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_SUM_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_AVERAGE_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_COUNT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_COUNT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_DISTINCT_COUNT_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MAX_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_TIMESTAMP_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_MIN_STATE_CHAIN_TIMESTAMP_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_POPULATION_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_STDDEV_SAMPLE_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_SUM_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_POPULATION_STATE_CHAIN_EVENT_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_BLOCK_HEIGHT_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_EVENT_ID_ASC'
  | 'FOREIGN_CHAIN_TRACKINGS_BY_STATE_CHAIN_EVENT_ID_VARIANCE_SAMPLE_STATE_CHAIN_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INDEX_IN_BLOCK_ASC'
  | 'INDEX_IN_BLOCK_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_ABORTED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COLLATERAL_ADDED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_COMPLETED_AT_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_COUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_COUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ABORTED_REASON_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LIQUIDATION_TYPE_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_ABORTED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_BORROWER_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_AT_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_INPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_EVENT_ID_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_LOAN_REPAID_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'LIQUIDATION_SWAP_INFOS_BY_LOAN_REPAID_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_COUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_COUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_COUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_COUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'METADATA_ID_ASC'
  | 'METADATA_ID_DESC'
  | 'NATURAL'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_COUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_COUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_ACTION_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_ACTION_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_CREDITED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_COUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_COUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_ACTION_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_ACTION_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_OUTPUT_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_AMOUNT_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_REFUND_VALUE_USD_DESC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'ON_CHAIN_SWAP_INFOS_BY_REFUNDED_ON_CHAIN_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_COUNT_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_COUNT_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MAX_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_MIN_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_COUNT_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_COUNT_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MAX_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_MIN_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_SUM_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_EVENT_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_AVERAGE_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_COUNT_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_COUNT_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_QUOTE_ASSET_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_DISTINCT_COUNT_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MAX_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_MIN_UPDATED_AT_ORACLE_TIMESTAMP_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_POPULATION_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_STDDEV_SAMPLE_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_SUM_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_POPULATION_PRICE_X128_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_CREATED_AT_EVENT_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_FROM_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_FROM_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_TO_BLOCK_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_VALID_TO_BLOCK_DESC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_X128_ASC'
  | 'ORACLE_PRICE_TRACKINGS_BY_CREATED_AT_EVENT_ID_VARIANCE_SAMPLE_PRICE_X128_DESC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_COUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_COUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_REASON_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_REASON_DESC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MAX_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MAX_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MAX_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MAX_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MIN_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MIN_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_MIN_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_MIN_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_SUM_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_SUM_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_SUM_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_SUM_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_EVENT_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_AVERAGE_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_COUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_COUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ASSET_SWAPPED_BLOCK_TIMESTAMP_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ASSET_SWAPPED_BLOCK_TIMESTAMP_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_ASSET_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_ASSET_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_ASSET_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_ASSET_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_DISTINCT_COUNT_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ASSET_SWAPPED_BLOCK_TIMESTAMP_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ASSET_SWAPPED_BLOCK_TIMESTAMP_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MAX_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ASSET_SWAPPED_BLOCK_TIMESTAMP_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ASSET_SWAPPED_BLOCK_TIMESTAMP_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_MIN_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_POPULATION_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_STDDEV_SAMPLE_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_SUM_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_POPULATION_TO_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_ASSET_SWAPPED_EVENT_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_ASSET_SWAPPED_EVENT_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_FROM_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_FROM_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_FROM_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_FROM_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_FEE_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_FEE_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_TO_AMOUNT_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_TO_AMOUNT_DESC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_TO_VALUE_USD_ASC'
  | 'POOL_SWAPS_BY_ASSET_SWAPPED_EVENT_ID_VARIANCE_SAMPLE_TO_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_COUNT_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_COUNT_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MAX_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_MIN_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_SUM_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'ROTATION_EVENTS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_ABORTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_EXECUTED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MAX_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_MIN_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_SUM_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_SCHEDULED_EVENT_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_COUNT_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_CHANNELS_BY_ISSUED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_COMPLETED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_REQUESTED_EVENT_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC';

export type EvmStateChainCall = Node & {
  __typename?: 'EvmStateChainCall';
  bytes?: Maybe<Scalars['Base64EncodedBinary']['output']>;
  callData?: Maybe<Scalars['JSON']['output']>;
  /** Reads a single `Event` that is related to this `EvmStateChainCall`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `StateChainError` that is related to this `EvmStateChainCall`. */
  stateChainErrorByStateChainErrorId?: Maybe<StateChainError>;
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  txHash: Scalars['String']['output'];
};

export type EvmStateChainCallAggregates = {
  __typename?: 'EvmStateChainCallAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EvmStateChainCallAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EvmStateChainCallDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EvmStateChainCallMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EvmStateChainCallMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EvmStateChainCallStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EvmStateChainCallStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EvmStateChainCallSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EvmStateChainCallVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EvmStateChainCallVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `EvmStateChainCall` object types. */
export type EvmStateChainCallAggregatesFilter = {
  /** Mean average aggregate over matching `EvmStateChainCall` objects. */
  average?: InputMaybe<EvmStateChainCallAverageAggregateFilter>;
  /** Distinct count aggregate over matching `EvmStateChainCall` objects. */
  distinctCount?: InputMaybe<EvmStateChainCallDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `EvmStateChainCall` object to be included within the aggregate. */
  filter?: InputMaybe<EvmStateChainCallFilter>;
  /** Maximum aggregate over matching `EvmStateChainCall` objects. */
  max?: InputMaybe<EvmStateChainCallMaxAggregateFilter>;
  /** Minimum aggregate over matching `EvmStateChainCall` objects. */
  min?: InputMaybe<EvmStateChainCallMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `EvmStateChainCall` objects. */
  stddevPopulation?: InputMaybe<EvmStateChainCallStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `EvmStateChainCall` objects. */
  stddevSample?: InputMaybe<EvmStateChainCallStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `EvmStateChainCall` objects. */
  sum?: InputMaybe<EvmStateChainCallSumAggregateFilter>;
  /** Population variance aggregate over matching `EvmStateChainCall` objects. */
  variancePopulation?: InputMaybe<EvmStateChainCallVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `EvmStateChainCall` objects. */
  varianceSample?: InputMaybe<EvmStateChainCallVarianceSampleAggregateFilter>;
};

export type EvmStateChainCallAverageAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
};

export type EvmStateChainCallAverageAggregates = {
  __typename?: 'EvmStateChainCallAverageAggregates';
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `EvmStateChainCall` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type EvmStateChainCallCondition = {
  /** Checks for equality with the object’s `callData` field. */
  callData?: InputMaybe<Scalars['JSON']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  stateChainErrorByStateChainErrorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `stateChainErrorId` field. */
  stateChainErrorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `success` field. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `txHash` field. */
  txHash?: InputMaybe<Scalars['String']['input']>;
};

export type EvmStateChainCallDistinctCountAggregateFilter = {
  bytes?: InputMaybe<BigIntFilter>;
  callData?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainErrorId?: InputMaybe<BigIntFilter>;
  success?: InputMaybe<BigIntFilter>;
  txHash?: InputMaybe<BigIntFilter>;
};

export type EvmStateChainCallDistinctCountAggregates = {
  __typename?: 'EvmStateChainCallDistinctCountAggregates';
  /** Distinct count of bytes across the matching connection */
  bytes?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of callData across the matching connection */
  callData?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of success across the matching connection */
  success?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of txHash across the matching connection */
  txHash?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `EvmStateChainCall` object types. All fields are combined with a logical ‘and.’ */
export type EvmStateChainCallFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EvmStateChainCallFilter>>;
  /** Filter by the object’s `bytes` field. */
  bytes?: InputMaybe<Base64EncodedBinaryFilter>;
  /** Filter by the object’s `callData` field. */
  callData?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EvmStateChainCallFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EvmStateChainCallFilter>>;
  /** Filter by the object’s `stateChainErrorByStateChainErrorId` relation. */
  stateChainErrorByStateChainErrorId?: InputMaybe<StateChainErrorFilter>;
  /** A related `stateChainErrorByStateChainErrorId` exists. */
  stateChainErrorByStateChainErrorIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `stateChainErrorId` field. */
  stateChainErrorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `success` field. */
  success?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `txHash` field. */
  txHash?: InputMaybe<StringFilter>;
};

/** Grouping methods for `EvmStateChainCall` for usage during aggregation. */
export type EvmStateChainCallGroupBy =
  | 'BYTES'
  | 'CALL_DATA'
  | 'EVENT_ID'
  | 'STATE_CHAIN_ERROR_ID'
  | 'SUCCESS';

export type EvmStateChainCallHavingAverageInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingDistinctCountInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EvmStateChainCall` aggregates. */
export type EvmStateChainCallHavingInput = {
  AND?: InputMaybe<Array<EvmStateChainCallHavingInput>>;
  OR?: InputMaybe<Array<EvmStateChainCallHavingInput>>;
  average?: InputMaybe<EvmStateChainCallHavingAverageInput>;
  distinctCount?: InputMaybe<EvmStateChainCallHavingDistinctCountInput>;
  max?: InputMaybe<EvmStateChainCallHavingMaxInput>;
  min?: InputMaybe<EvmStateChainCallHavingMinInput>;
  stddevPopulation?: InputMaybe<EvmStateChainCallHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EvmStateChainCallHavingStddevSampleInput>;
  sum?: InputMaybe<EvmStateChainCallHavingSumInput>;
  variancePopulation?: InputMaybe<EvmStateChainCallHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EvmStateChainCallHavingVarianceSampleInput>;
};

export type EvmStateChainCallHavingMaxInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingMinInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingStddevPopulationInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingStddevSampleInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingSumInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingVariancePopulationInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallHavingVarianceSampleInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
};

export type EvmStateChainCallMaxAggregateFilter = {
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainErrorId?: InputMaybe<IntFilter>;
};

export type EvmStateChainCallMaxAggregates = {
  __typename?: 'EvmStateChainCallMaxAggregates';
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
};

export type EvmStateChainCallMinAggregateFilter = {
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainErrorId?: InputMaybe<IntFilter>;
};

export type EvmStateChainCallMinAggregates = {
  __typename?: 'EvmStateChainCallMinAggregates';
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
};

export type EvmStateChainCallStddevPopulationAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
};

export type EvmStateChainCallStddevPopulationAggregates = {
  __typename?: 'EvmStateChainCallStddevPopulationAggregates';
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EvmStateChainCallStddevSampleAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
};

export type EvmStateChainCallStddevSampleAggregates = {
  __typename?: 'EvmStateChainCallStddevSampleAggregates';
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EvmStateChainCallSumAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainErrorId?: InputMaybe<BigIntFilter>;
};

export type EvmStateChainCallSumAggregates = {
  __typename?: 'EvmStateChainCallSumAggregates';
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of stateChainErrorId across the matching connection */
  stateChainErrorId: Scalars['BigInt']['output'];
};

export type EvmStateChainCallVariancePopulationAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
};

export type EvmStateChainCallVariancePopulationAggregates = {
  __typename?: 'EvmStateChainCallVariancePopulationAggregates';
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type EvmStateChainCallVarianceSampleAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
};

export type EvmStateChainCallVarianceSampleAggregates = {
  __typename?: 'EvmStateChainCallVarianceSampleAggregates';
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `EvmStateChainCall` values. */
export type EvmStateChainCallsConnection = {
  __typename?: 'EvmStateChainCallsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EvmStateChainCallAggregates>;
  /** A list of edges which contains the `EvmStateChainCall` and cursor to aid in pagination. */
  edges: Array<EvmStateChainCallsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EvmStateChainCallAggregates>>;
  /** A list of `EvmStateChainCall` objects. */
  nodes: Array<EvmStateChainCall>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EvmStateChainCall` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `EvmStateChainCall` values. */
export type EvmStateChainCallsConnectionGroupedAggregatesArgs = {
  groupBy: Array<EvmStateChainCallGroupBy>;
  having?: InputMaybe<EvmStateChainCallHavingInput>;
};

/** A `EvmStateChainCall` edge in the connection. */
export type EvmStateChainCallsEdge = {
  __typename?: 'EvmStateChainCallsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `EvmStateChainCall` at the end of the edge. */
  node: EvmStateChainCall;
};

/** Methods to use when ordering `EvmStateChainCall`. */
export type EvmStateChainCallsOrderBy =
  | 'CALL_DATA_ASC'
  | 'CALL_DATA_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STATE_CHAIN_ERROR_ID_ASC'
  | 'STATE_CHAIN_ERROR_ID_DESC'
  | 'SUCCESS_ASC'
  | 'SUCCESS_DESC'
  | 'TX_HASH_ASC'
  | 'TX_HASH_DESC';

export type Extrinsic = Node & {
  __typename?: 'Extrinsic';
  /** Reads a single `Account` that is related to this `Extrinsic`. */
  accountBySubmitterId?: Maybe<Account>;
  /** Reads a single `Block` that is related to this `Extrinsic`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  fee?: Maybe<Scalars['BigFloat']['output']>;
  hash: Scalars['String']['output'];
  id: Scalars['String']['output'];
  indexInBlock: Scalars['Int']['output'];
  metadataId: Scalars['Int']['output'];
  /** Reads a single `Metadatum` that is related to this `Extrinsic`. */
  metadatumByMetadataId: Metadatum;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  signature?: Maybe<Scalars['String']['output']>;
  submitterId?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
  tip?: Maybe<Scalars['BigFloat']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

export type ExtrinsicAggregates = {
  __typename?: 'ExtrinsicAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ExtrinsicAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ExtrinsicDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ExtrinsicMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ExtrinsicMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ExtrinsicStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ExtrinsicStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ExtrinsicSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ExtrinsicVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ExtrinsicVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Extrinsic` object types. */
export type ExtrinsicAggregatesFilter = {
  /** Mean average aggregate over matching `Extrinsic` objects. */
  average?: InputMaybe<ExtrinsicAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Extrinsic` objects. */
  distinctCount?: InputMaybe<ExtrinsicDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Extrinsic` object to be included within the aggregate. */
  filter?: InputMaybe<ExtrinsicFilter>;
  /** Maximum aggregate over matching `Extrinsic` objects. */
  max?: InputMaybe<ExtrinsicMaxAggregateFilter>;
  /** Minimum aggregate over matching `Extrinsic` objects. */
  min?: InputMaybe<ExtrinsicMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Extrinsic` objects. */
  stddevPopulation?: InputMaybe<ExtrinsicStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Extrinsic` objects. */
  stddevSample?: InputMaybe<ExtrinsicStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Extrinsic` objects. */
  sum?: InputMaybe<ExtrinsicSumAggregateFilter>;
  /** Population variance aggregate over matching `Extrinsic` objects. */
  variancePopulation?: InputMaybe<ExtrinsicVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Extrinsic` objects. */
  varianceSample?: InputMaybe<ExtrinsicVarianceSampleAggregateFilter>;
};

export type ExtrinsicAverageAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
  submitterId?: InputMaybe<BigFloatFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type ExtrinsicAverageAggregates = {
  __typename?: 'ExtrinsicAverageAggregates';
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Extrinsic` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ExtrinsicCondition = {
  accountBySubmitterId?: InputMaybe<Scalars['ID']['input']>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `hash` field. */
  hash?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `metadataId` field. */
  metadataId?: InputMaybe<Scalars['Int']['input']>;
  metadatumByMetadataId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `signature` field. */
  signature?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `submitterId` field. */
  submitterId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `success` field. */
  success?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `tip` field. */
  tip?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `version` field. */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type ExtrinsicDistinctCountAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  hash?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  indexInBlock?: InputMaybe<BigIntFilter>;
  metadataId?: InputMaybe<BigIntFilter>;
  signature?: InputMaybe<BigIntFilter>;
  submitterId?: InputMaybe<BigIntFilter>;
  success?: InputMaybe<BigIntFilter>;
  tip?: InputMaybe<BigIntFilter>;
  version?: InputMaybe<BigIntFilter>;
};

export type ExtrinsicDistinctCountAggregates = {
  __typename?: 'ExtrinsicDistinctCountAggregates';
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of hash across the matching connection */
  hash?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of signature across the matching connection */
  signature?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of success across the matching connection */
  success?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tip across the matching connection */
  tip?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of version across the matching connection */
  version?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Extrinsic` object types. All fields are combined with a logical ‘and.’ */
export type ExtrinsicFilter = {
  /** Filter by the object’s `accountBySubmitterId` relation. */
  accountBySubmitterId?: InputMaybe<AccountFilter>;
  /** A related `accountBySubmitterId` exists. */
  accountBySubmitterIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ExtrinsicFilter>>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `hash` field. */
  hash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `indexInBlock` field. */
  indexInBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadataId` field. */
  metadataId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `metadatumByMetadataId` relation. */
  metadatumByMetadataId?: InputMaybe<MetadatumFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ExtrinsicFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ExtrinsicFilter>>;
  /** Filter by the object’s `signature` field. */
  signature?: InputMaybe<StringFilter>;
  /** Filter by the object’s `submitterId` field. */
  submitterId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `success` field. */
  success?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `tip` field. */
  tip?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `version` field. */
  version?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Extrinsic` for usage during aggregation. */
export type ExtrinsicGroupBy =
  | 'BLOCK_ID'
  | 'FEE'
  | 'HASH'
  | 'INDEX_IN_BLOCK'
  | 'METADATA_ID'
  | 'SIGNATURE'
  | 'SUBMITTER_ID'
  | 'SUCCESS'
  | 'TIP'
  | 'VERSION';

export type ExtrinsicHavingAverageInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingDistinctCountInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Extrinsic` aggregates. */
export type ExtrinsicHavingInput = {
  AND?: InputMaybe<Array<ExtrinsicHavingInput>>;
  OR?: InputMaybe<Array<ExtrinsicHavingInput>>;
  average?: InputMaybe<ExtrinsicHavingAverageInput>;
  distinctCount?: InputMaybe<ExtrinsicHavingDistinctCountInput>;
  max?: InputMaybe<ExtrinsicHavingMaxInput>;
  min?: InputMaybe<ExtrinsicHavingMinInput>;
  stddevPopulation?: InputMaybe<ExtrinsicHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ExtrinsicHavingStddevSampleInput>;
  sum?: InputMaybe<ExtrinsicHavingSumInput>;
  variancePopulation?: InputMaybe<ExtrinsicHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ExtrinsicHavingVarianceSampleInput>;
};

export type ExtrinsicHavingMaxInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingMinInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingStddevPopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingStddevSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingSumInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingVariancePopulationInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicHavingVarianceSampleInput = {
  blockId?: InputMaybe<HavingIntFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  indexInBlock?: InputMaybe<HavingIntFilter>;
  metadataId?: InputMaybe<HavingIntFilter>;
  submitterId?: InputMaybe<HavingIntFilter>;
  tip?: InputMaybe<HavingBigfloatFilter>;
  version?: InputMaybe<HavingIntFilter>;
};

export type ExtrinsicInfo = {
  __typename?: 'ExtrinsicInfo';
  blockHeight: Scalars['Int']['output'];
  callArgs?: Maybe<Scalars['JSON']['output']>;
  callName?: Maybe<Scalars['String']['output']>;
  callOrigin?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  indexInBlock: Scalars['Int']['output'];
  signature?: Maybe<Scalars['JSON']['output']>;
};

export type ExtrinsicMaxAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<IntFilter>;
  metadataId?: InputMaybe<IntFilter>;
  submitterId?: InputMaybe<IntFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<IntFilter>;
};

export type ExtrinsicMaxAggregates = {
  __typename?: 'ExtrinsicMaxAggregates';
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of version across the matching connection */
  version?: Maybe<Scalars['Int']['output']>;
};

export type ExtrinsicMinAggregateFilter = {
  blockId?: InputMaybe<IntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<IntFilter>;
  metadataId?: InputMaybe<IntFilter>;
  submitterId?: InputMaybe<IntFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<IntFilter>;
};

export type ExtrinsicMinAggregates = {
  __typename?: 'ExtrinsicMinAggregates';
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of version across the matching connection */
  version?: Maybe<Scalars['Int']['output']>;
};

export type ExtrinsicStddevPopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
  submitterId?: InputMaybe<BigFloatFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type ExtrinsicStddevPopulationAggregates = {
  __typename?: 'ExtrinsicStddevPopulationAggregates';
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type ExtrinsicStddevSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
  submitterId?: InputMaybe<BigFloatFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type ExtrinsicStddevSampleAggregates = {
  __typename?: 'ExtrinsicStddevSampleAggregates';
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type ExtrinsicSumAggregateFilter = {
  blockId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigIntFilter>;
  metadataId?: InputMaybe<BigIntFilter>;
  submitterId?: InputMaybe<BigIntFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigIntFilter>;
};

export type ExtrinsicSumAggregates = {
  __typename?: 'ExtrinsicSumAggregates';
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of indexInBlock across the matching connection */
  indexInBlock: Scalars['BigInt']['output'];
  /** Sum of metadataId across the matching connection */
  metadataId: Scalars['BigInt']['output'];
  /** Sum of submitterId across the matching connection */
  submitterId: Scalars['BigInt']['output'];
  /** Sum of tip across the matching connection */
  tip: Scalars['BigFloat']['output'];
  /** Sum of version across the matching connection */
  version: Scalars['BigInt']['output'];
};

export type ExtrinsicVariancePopulationAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
  submitterId?: InputMaybe<BigFloatFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type ExtrinsicVariancePopulationAggregates = {
  __typename?: 'ExtrinsicVariancePopulationAggregates';
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

export type ExtrinsicVarianceSampleAggregateFilter = {
  blockId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  indexInBlock?: InputMaybe<BigFloatFilter>;
  metadataId?: InputMaybe<BigFloatFilter>;
  submitterId?: InputMaybe<BigFloatFilter>;
  tip?: InputMaybe<BigFloatFilter>;
  version?: InputMaybe<BigFloatFilter>;
};

export type ExtrinsicVarianceSampleAggregates = {
  __typename?: 'ExtrinsicVarianceSampleAggregates';
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of indexInBlock across the matching connection */
  indexInBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of metadataId across the matching connection */
  metadataId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of submitterId across the matching connection */
  submitterId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tip across the matching connection */
  tip?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of version across the matching connection */
  version?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Extrinsic` values. */
export type ExtrinsicsConnection = {
  __typename?: 'ExtrinsicsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ExtrinsicAggregates>;
  /** A list of edges which contains the `Extrinsic` and cursor to aid in pagination. */
  edges: Array<ExtrinsicsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ExtrinsicAggregates>>;
  /** A list of `Extrinsic` objects. */
  nodes: Array<Extrinsic>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Extrinsic` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Extrinsic` values. */
export type ExtrinsicsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ExtrinsicGroupBy>;
  having?: InputMaybe<ExtrinsicHavingInput>;
};

/** A `Extrinsic` edge in the connection. */
export type ExtrinsicsEdge = {
  __typename?: 'ExtrinsicsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Extrinsic` at the end of the edge. */
  node: Extrinsic;
};

/** Methods to use when ordering `Extrinsic`. */
export type ExtrinsicsOrderBy =
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'HASH_ASC'
  | 'HASH_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INDEX_IN_BLOCK_ASC'
  | 'INDEX_IN_BLOCK_DESC'
  | 'METADATA_ID_ASC'
  | 'METADATA_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SIGNATURE_ASC'
  | 'SIGNATURE_DESC'
  | 'SUBMITTER_ID_ASC'
  | 'SUBMITTER_ID_DESC'
  | 'SUCCESS_ASC'
  | 'SUCCESS_DESC'
  | 'TIP_ASC'
  | 'TIP_DESC'
  | 'VERSION_ASC'
  | 'VERSION_DESC';

export type FailedDeposit = Node & {
  __typename?: 'FailedDeposit';
  /** Reads a single `AccountCreationDepositChannel` that is related to this `FailedDeposit`. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: Maybe<AccountCreationDepositChannel>;
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['BigFloat']['output'];
  /** Reads a single `Broadcast` that is related to this `FailedDeposit`. */
  broadcastByRefundBroadcastId?: Maybe<Broadcast>;
  /** Reads a single `BrokerChannel` that is related to this `FailedDeposit`. */
  brokerChannelByBrokerChannelId?: Maybe<BrokerChannel>;
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  ccmAdditionalData?: Maybe<Scalars['String']['output']>;
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  ccmMessage?: Maybe<Scalars['String']['output']>;
  depositAsset: ChainflipAsset;
  depositChain: ChainflipChain;
  destinationAddress?: Maybe<Scalars['String']['output']>;
  destinationAsset?: Maybe<ChainflipAsset>;
  destinationChain?: Maybe<ChainflipChain>;
  /** Reads a single `Egress` that is related to this `FailedDeposit`. */
  egressByRefundEgressId?: Maybe<Egress>;
  /** Reads a single `Event` that is related to this `FailedDeposit`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['BigInt']['output'];
  /** Reads a single `LiquidityDepositChannel` that is related to this `FailedDeposit`. */
  liquidityDepositChannelByLiquidityDepositChannelId?: Maybe<LiquidityDepositChannel>;
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  reason: DepositFailedReason;
  refundBroadcastId?: Maybe<Scalars['Int']['output']>;
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `SwapChannel` that is related to this `FailedDeposit`. */
  swapChannelBySwapDepositChannelId?: Maybe<SwapChannel>;
  swapDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `TransactionRef`. */
  transactionRefsByFailedDepositId: TransactionRefsConnection;
};


export type FailedDepositTransactionRefsByFailedDepositIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransactionRefCondition>;
  filter?: InputMaybe<TransactionRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransactionRefsOrderBy>>;
};

export type FailedDepositAggregates = {
  __typename?: 'FailedDepositAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<FailedDepositAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FailedDepositDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<FailedDepositMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<FailedDepositMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<FailedDepositStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<FailedDepositStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<FailedDepositSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<FailedDepositVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<FailedDepositVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `FailedDeposit` object types. */
export type FailedDepositAggregatesFilter = {
  /** Mean average aggregate over matching `FailedDeposit` objects. */
  average?: InputMaybe<FailedDepositAverageAggregateFilter>;
  /** Distinct count aggregate over matching `FailedDeposit` objects. */
  distinctCount?: InputMaybe<FailedDepositDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `FailedDeposit` object to be included within the aggregate. */
  filter?: InputMaybe<FailedDepositFilter>;
  /** Maximum aggregate over matching `FailedDeposit` objects. */
  max?: InputMaybe<FailedDepositMaxAggregateFilter>;
  /** Minimum aggregate over matching `FailedDeposit` objects. */
  min?: InputMaybe<FailedDepositMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `FailedDeposit` objects. */
  stddevPopulation?: InputMaybe<FailedDepositStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `FailedDeposit` objects. */
  stddevSample?: InputMaybe<FailedDepositStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `FailedDeposit` objects. */
  sum?: InputMaybe<FailedDepositSumAggregateFilter>;
  /** Population variance aggregate over matching `FailedDeposit` objects. */
  variancePopulation?: InputMaybe<FailedDepositVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `FailedDeposit` objects. */
  varianceSample?: InputMaybe<FailedDepositVarianceSampleAggregateFilter>;
};

export type FailedDepositAverageAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  refundBroadcastId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  swapDepositChannelId?: InputMaybe<BigFloatFilter>;
};

export type FailedDepositAverageAggregates = {
  __typename?: 'FailedDepositAverageAggregates';
  /** Mean average of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `FailedDeposit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FailedDepositCondition = {
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  broadcastByRefundBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  brokerChannelByBrokerChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerChannelId` field. */
  brokerChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ccmAdditionalData` field. */
  ccmAdditionalData?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `depositAsset` field. */
  depositAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `depositChain` field. */
  depositChain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChain>;
  egressByRefundEgressId?: InputMaybe<Scalars['ID']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<DepositFailedReason>;
  /** Checks for equality with the object’s `refundBroadcastId` field. */
  refundBroadcastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `refundEgressId` field. */
  refundEgressId?: InputMaybe<Scalars['Int']['input']>;
  swapChannelBySwapDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapDepositChannelId` field. */
  swapDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
};

export type FailedDepositDistinctCountAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigIntFilter>;
  brokerChannelId?: InputMaybe<BigIntFilter>;
  ccmAdditionalData?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigIntFilter>;
  ccmMessage?: InputMaybe<BigIntFilter>;
  depositAsset?: InputMaybe<BigIntFilter>;
  depositChain?: InputMaybe<BigIntFilter>;
  destinationAddress?: InputMaybe<BigIntFilter>;
  destinationAsset?: InputMaybe<BigIntFilter>;
  destinationChain?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  reason?: InputMaybe<BigIntFilter>;
  refundBroadcastId?: InputMaybe<BigIntFilter>;
  refundEgressId?: InputMaybe<BigIntFilter>;
  swapDepositChannelId?: InputMaybe<BigIntFilter>;
};

export type FailedDepositDistinctCountAggregates = {
  __typename?: 'FailedDepositDistinctCountAggregates';
  /** Distinct count of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmAdditionalData across the matching connection */
  ccmAdditionalData?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmMessage across the matching connection */
  ccmMessage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAsset across the matching connection */
  depositAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositChain across the matching connection */
  depositChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAddress across the matching connection */
  destinationAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAsset across the matching connection */
  destinationAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationChain across the matching connection */
  destinationChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reason across the matching connection */
  reason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type FailedDepositFilter = {
  /** Filter by the object’s `accountCreationDepositChannelByAccountCreationDepositChannelId` relation. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** A related `accountCreationDepositChannelByAccountCreationDepositChannelId` exists. */
  accountCreationDepositChannelByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FailedDepositFilter>>;
  /** Filter by the object’s `broadcastByRefundBroadcastId` relation. */
  broadcastByRefundBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByRefundBroadcastId` exists. */
  broadcastByRefundBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelByBrokerChannelId` relation. */
  brokerChannelByBrokerChannelId?: InputMaybe<BrokerChannelFilter>;
  /** A related `brokerChannelByBrokerChannelId` exists. */
  brokerChannelByBrokerChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelId` field. */
  brokerChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ccmAdditionalData` field. */
  ccmAdditionalData?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `depositAsset` field. */
  depositAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `depositChain` field. */
  depositChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `egressByRefundEgressId` relation. */
  egressByRefundEgressId?: InputMaybe<EgressFilter>;
  /** A related `egressByRefundEgressId` exists. */
  egressByRefundEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityDepositChannelByLiquidityDepositChannelId` relation. */
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelFilter>;
  /** A related `liquidityDepositChannelByLiquidityDepositChannelId` exists. */
  liquidityDepositChannelByLiquidityDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<FailedDepositFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FailedDepositFilter>>;
  /** Filter by the object’s `reason` field. */
  reason?: InputMaybe<DepositFailedReasonFilter>;
  /** Filter by the object’s `refundBroadcastId` field. */
  refundBroadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `refundEgressId` field. */
  refundEgressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapChannelBySwapDepositChannelId` relation. */
  swapChannelBySwapDepositChannelId?: InputMaybe<SwapChannelFilter>;
  /** A related `swapChannelBySwapDepositChannelId` exists. */
  swapChannelBySwapDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapDepositChannelId` field. */
  swapDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `transactionRefsByFailedDepositId` relation. */
  transactionRefsByFailedDepositId?: InputMaybe<FailedDepositToManyTransactionRefFilter>;
  /** Some related `transactionRefsByFailedDepositId` exist. */
  transactionRefsByFailedDepositIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `FailedDeposit` for usage during aggregation. */
export type FailedDepositGroupBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID'
  | 'AMOUNT'
  | 'BROKER_CHANNEL_ID'
  | 'CCM_ADDITIONAL_DATA'
  | 'CCM_GAS_BUDGET'
  | 'CCM_MESSAGE'
  | 'DEPOSIT_ASSET'
  | 'DEPOSIT_CHAIN'
  | 'DESTINATION_ADDRESS'
  | 'DESTINATION_ASSET'
  | 'DESTINATION_CHAIN'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID'
  | 'REASON'
  | 'REFUND_BROADCAST_ID'
  | 'REFUND_EGRESS_ID'
  | 'SWAP_DEPOSIT_CHANNEL_ID';

export type FailedDepositHavingAverageInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingDistinctCountInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `FailedDeposit` aggregates. */
export type FailedDepositHavingInput = {
  AND?: InputMaybe<Array<FailedDepositHavingInput>>;
  OR?: InputMaybe<Array<FailedDepositHavingInput>>;
  average?: InputMaybe<FailedDepositHavingAverageInput>;
  distinctCount?: InputMaybe<FailedDepositHavingDistinctCountInput>;
  max?: InputMaybe<FailedDepositHavingMaxInput>;
  min?: InputMaybe<FailedDepositHavingMinInput>;
  stddevPopulation?: InputMaybe<FailedDepositHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FailedDepositHavingStddevSampleInput>;
  sum?: InputMaybe<FailedDepositHavingSumInput>;
  variancePopulation?: InputMaybe<FailedDepositHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FailedDepositHavingVarianceSampleInput>;
};

export type FailedDepositHavingMaxInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingMinInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingStddevPopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingStddevSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingSumInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingVariancePopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositHavingVarianceSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  refundBroadcastId?: InputMaybe<HavingIntFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  swapDepositChannelId?: InputMaybe<HavingIntFilter>;
};

export type FailedDepositMaxAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  refundBroadcastId?: InputMaybe<IntFilter>;
  refundEgressId?: InputMaybe<IntFilter>;
  swapDepositChannelId?: InputMaybe<IntFilter>;
};

export type FailedDepositMaxAggregates = {
  __typename?: 'FailedDepositMaxAggregates';
  /** Maximum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['Int']['output']>;
};

export type FailedDepositMinAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  refundBroadcastId?: InputMaybe<IntFilter>;
  refundEgressId?: InputMaybe<IntFilter>;
  swapDepositChannelId?: InputMaybe<IntFilter>;
};

export type FailedDepositMinAggregates = {
  __typename?: 'FailedDepositMinAggregates';
  /** Minimum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['Int']['output']>;
};

export type FailedDepositStddevPopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  refundBroadcastId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  swapDepositChannelId?: InputMaybe<BigFloatFilter>;
};

export type FailedDepositStddevPopulationAggregates = {
  __typename?: 'FailedDepositStddevPopulationAggregates';
  /** Population standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FailedDepositStddevSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  refundBroadcastId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  swapDepositChannelId?: InputMaybe<BigFloatFilter>;
};

export type FailedDepositStddevSampleAggregates = {
  __typename?: 'FailedDepositStddevSampleAggregates';
  /** Sample standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FailedDepositSumAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  refundBroadcastId?: InputMaybe<BigIntFilter>;
  refundEgressId?: InputMaybe<BigIntFilter>;
  swapDepositChannelId?: InputMaybe<BigIntFilter>;
};

export type FailedDepositSumAggregates = {
  __typename?: 'FailedDepositSumAggregates';
  /** Sum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of brokerChannelId across the matching connection */
  brokerChannelId: Scalars['BigInt']['output'];
  /** Sum of ccmGasBudget across the matching connection */
  ccmGasBudget: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigFloat']['output'];
  /** Sum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of refundBroadcastId across the matching connection */
  refundBroadcastId: Scalars['BigInt']['output'];
  /** Sum of refundEgressId across the matching connection */
  refundEgressId: Scalars['BigInt']['output'];
  /** Sum of swapDepositChannelId across the matching connection */
  swapDepositChannelId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `TransactionRef` object types. All fields are combined with a logical ‘and.’ */
export type FailedDepositToManyTransactionRefFilter = {
  /** Aggregates across related `TransactionRef` match the filter criteria. */
  aggregates?: InputMaybe<TransactionRefAggregatesFilter>;
  /** Every related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TransactionRefFilter>;
  /** No related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TransactionRefFilter>;
  /** Some related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TransactionRefFilter>;
};

export type FailedDepositVariancePopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  refundBroadcastId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  swapDepositChannelId?: InputMaybe<BigFloatFilter>;
};

export type FailedDepositVariancePopulationAggregates = {
  __typename?: 'FailedDepositVariancePopulationAggregates';
  /** Population variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
};

export type FailedDepositVarianceSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  refundBroadcastId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  swapDepositChannelId?: InputMaybe<BigFloatFilter>;
};

export type FailedDepositVarianceSampleAggregates = {
  __typename?: 'FailedDepositVarianceSampleAggregates';
  /** Sample variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundBroadcastId across the matching connection */
  refundBroadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapDepositChannelId across the matching connection */
  swapDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `FailedDeposit` values. */
export type FailedDepositsConnection = {
  __typename?: 'FailedDepositsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FailedDepositAggregates>;
  /** A list of edges which contains the `FailedDeposit` and cursor to aid in pagination. */
  edges: Array<FailedDepositsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FailedDepositAggregates>>;
  /** A list of `FailedDeposit` objects. */
  nodes: Array<FailedDeposit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FailedDeposit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `FailedDeposit` values. */
export type FailedDepositsConnectionGroupedAggregatesArgs = {
  groupBy: Array<FailedDepositGroupBy>;
  having?: InputMaybe<FailedDepositHavingInput>;
};

/** A `FailedDeposit` edge in the connection. */
export type FailedDepositsEdge = {
  __typename?: 'FailedDepositsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `FailedDeposit` at the end of the edge. */
  node: FailedDeposit;
};

/** Methods to use when ordering `FailedDeposit`. */
export type FailedDepositsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BROKER_CHANNEL_ID_ASC'
  | 'BROKER_CHANNEL_ID_DESC'
  | 'CCM_ADDITIONAL_DATA_ASC'
  | 'CCM_ADDITIONAL_DATA_DESC'
  | 'CCM_GAS_BUDGET_ASC'
  | 'CCM_GAS_BUDGET_DESC'
  | 'CCM_MESSAGE_ASC'
  | 'CCM_MESSAGE_DESC'
  | 'DEPOSIT_ASSET_ASC'
  | 'DEPOSIT_ASSET_DESC'
  | 'DEPOSIT_CHAIN_ASC'
  | 'DEPOSIT_CHAIN_DESC'
  | 'DESTINATION_ADDRESS_ASC'
  | 'DESTINATION_ADDRESS_DESC'
  | 'DESTINATION_ASSET_ASC'
  | 'DESTINATION_ASSET_DESC'
  | 'DESTINATION_CHAIN_ASC'
  | 'DESTINATION_CHAIN_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REASON_ASC'
  | 'REASON_DESC'
  | 'REFUND_BROADCAST_ID_ASC'
  | 'REFUND_BROADCAST_ID_DESC'
  | 'REFUND_EGRESS_ID_ASC'
  | 'REFUND_EGRESS_ID_DESC'
  | 'SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_COUNT_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_COUNT_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_REF_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_REF_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_FAILED_DEPOSIT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC';

/** A filter to be used against Float fields. All fields are combined with a logical ‘and.’ */
export type FloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Float']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ForeignChainTracking = Node & {
  __typename?: 'ForeignChainTracking';
  /** Reads a single `Block` that is related to this `ForeignChainTracking`. */
  blockByStateChainBlockId: Block;
  chain: ChainflipChain;
  /** Reads a single `Event` that is related to this `ForeignChainTracking`. */
  eventByStateChainEventId: Event;
  foreignBlockHeight: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  stateChainBlockId: Scalars['Int']['output'];
  stateChainEventId: Scalars['BigInt']['output'];
  stateChainTimestamp: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByForeignChainDepositBlockId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByForeignChainDepositFinalizedBlockId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByForeignChainPreDepositBlockId: SwapRequestsConnection;
};


export type ForeignChainTrackingSwapRequestsByForeignChainDepositBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type ForeignChainTrackingSwapRequestsByForeignChainDepositFinalizedBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type ForeignChainTrackingSwapRequestsByForeignChainPreDepositBlockIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type ForeignChainTrackingAggregates = {
  __typename?: 'ForeignChainTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ForeignChainTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ForeignChainTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ForeignChainTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ForeignChainTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ForeignChainTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ForeignChainTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ForeignChainTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ForeignChainTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ForeignChainTrackingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `ForeignChainTracking` object types. */
export type ForeignChainTrackingAggregatesFilter = {
  /** Mean average aggregate over matching `ForeignChainTracking` objects. */
  average?: InputMaybe<ForeignChainTrackingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `ForeignChainTracking` objects. */
  distinctCount?: InputMaybe<ForeignChainTrackingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `ForeignChainTracking` object to be included within the aggregate. */
  filter?: InputMaybe<ForeignChainTrackingFilter>;
  /** Maximum aggregate over matching `ForeignChainTracking` objects. */
  max?: InputMaybe<ForeignChainTrackingMaxAggregateFilter>;
  /** Minimum aggregate over matching `ForeignChainTracking` objects. */
  min?: InputMaybe<ForeignChainTrackingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `ForeignChainTracking` objects. */
  stddevPopulation?: InputMaybe<ForeignChainTrackingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `ForeignChainTracking` objects. */
  stddevSample?: InputMaybe<ForeignChainTrackingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `ForeignChainTracking` objects. */
  sum?: InputMaybe<ForeignChainTrackingSumAggregateFilter>;
  /** Population variance aggregate over matching `ForeignChainTracking` objects. */
  variancePopulation?: InputMaybe<ForeignChainTrackingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `ForeignChainTracking` objects. */
  varianceSample?: InputMaybe<ForeignChainTrackingVarianceSampleAggregateFilter>;
};

export type ForeignChainTrackingAverageAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainBlockId?: InputMaybe<BigFloatFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingAverageAggregates = {
  __typename?: 'ForeignChainTrackingAverageAggregates';
  /** Mean average of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `ForeignChainTracking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ForeignChainTrackingCondition = {
  blockByStateChainBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  eventByStateChainEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `foreignBlockHeight` field. */
  foreignBlockHeight?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stateChainBlockId` field. */
  stateChainBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `stateChainEventId` field. */
  stateChainEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `stateChainTimestamp` field. */
  stateChainTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ForeignChainTrackingDistinctCountAggregateFilter = {
  chain?: InputMaybe<BigIntFilter>;
  foreignBlockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainBlockId?: InputMaybe<BigIntFilter>;
  stateChainEventId?: InputMaybe<BigIntFilter>;
  stateChainTimestamp?: InputMaybe<BigIntFilter>;
};

export type ForeignChainTrackingDistinctCountAggregates = {
  __typename?: 'ForeignChainTrackingDistinctCountAggregates';
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainTimestamp across the matching connection */
  stateChainTimestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `ForeignChainTracking` object types. All fields are combined with a logical ‘and.’ */
export type ForeignChainTrackingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ForeignChainTrackingFilter>>;
  /** Filter by the object’s `blockByStateChainBlockId` relation. */
  blockByStateChainBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `eventByStateChainEventId` relation. */
  eventByStateChainEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `foreignBlockHeight` field. */
  foreignBlockHeight?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ForeignChainTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ForeignChainTrackingFilter>>;
  /** Filter by the object’s `stateChainBlockId` field. */
  stateChainBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stateChainEventId` field. */
  stateChainEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `stateChainTimestamp` field. */
  stateChainTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `swapRequestsByForeignChainDepositBlockId` relation. */
  swapRequestsByForeignChainDepositBlockId?: InputMaybe<ForeignChainTrackingToManySwapRequestFilter>;
  /** Some related `swapRequestsByForeignChainDepositBlockId` exist. */
  swapRequestsByForeignChainDepositBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByForeignChainDepositFinalizedBlockId` relation. */
  swapRequestsByForeignChainDepositFinalizedBlockId?: InputMaybe<ForeignChainTrackingToManySwapRequestFilter>;
  /** Some related `swapRequestsByForeignChainDepositFinalizedBlockId` exist. */
  swapRequestsByForeignChainDepositFinalizedBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByForeignChainPreDepositBlockId` relation. */
  swapRequestsByForeignChainPreDepositBlockId?: InputMaybe<ForeignChainTrackingToManySwapRequestFilter>;
  /** Some related `swapRequestsByForeignChainPreDepositBlockId` exist. */
  swapRequestsByForeignChainPreDepositBlockIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `ForeignChainTracking` for usage during aggregation. */
export type ForeignChainTrackingGroupBy =
  | 'CHAIN'
  | 'FOREIGN_BLOCK_HEIGHT'
  | 'STATE_CHAIN_BLOCK_ID'
  | 'STATE_CHAIN_EVENT_ID'
  | 'STATE_CHAIN_TIMESTAMP'
  | 'STATE_CHAIN_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'STATE_CHAIN_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'STATE_CHAIN_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'STATE_CHAIN_TIMESTAMP_TRUNCATED_TO_WEEK';

export type ForeignChainTrackingHavingAverageInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingDistinctCountInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `ForeignChainTracking` aggregates. */
export type ForeignChainTrackingHavingInput = {
  AND?: InputMaybe<Array<ForeignChainTrackingHavingInput>>;
  OR?: InputMaybe<Array<ForeignChainTrackingHavingInput>>;
  average?: InputMaybe<ForeignChainTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<ForeignChainTrackingHavingDistinctCountInput>;
  max?: InputMaybe<ForeignChainTrackingHavingMaxInput>;
  min?: InputMaybe<ForeignChainTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<ForeignChainTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ForeignChainTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<ForeignChainTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<ForeignChainTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ForeignChainTrackingHavingVarianceSampleInput>;
};

export type ForeignChainTrackingHavingMaxInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingMinInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingStddevPopulationInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingStddevSampleInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingSumInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingVariancePopulationInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingHavingVarianceSampleInput = {
  foreignBlockHeight?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainBlockId?: InputMaybe<HavingIntFilter>;
  stateChainEventId?: InputMaybe<HavingBigintFilter>;
  stateChainTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type ForeignChainTrackingMaxAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainBlockId?: InputMaybe<IntFilter>;
  stateChainEventId?: InputMaybe<BigIntFilter>;
  stateChainTimestamp?: InputMaybe<DatetimeFilter>;
};

export type ForeignChainTrackingMaxAggregates = {
  __typename?: 'ForeignChainTrackingMaxAggregates';
  /** Maximum of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of stateChainTimestamp across the matching connection */
  stateChainTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type ForeignChainTrackingMinAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainBlockId?: InputMaybe<IntFilter>;
  stateChainEventId?: InputMaybe<BigIntFilter>;
  stateChainTimestamp?: InputMaybe<DatetimeFilter>;
};

export type ForeignChainTrackingMinAggregates = {
  __typename?: 'ForeignChainTrackingMinAggregates';
  /** Minimum of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of stateChainTimestamp across the matching connection */
  stateChainTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type ForeignChainTrackingStddevPopulationAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainBlockId?: InputMaybe<BigFloatFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingStddevPopulationAggregates = {
  __typename?: 'ForeignChainTrackingStddevPopulationAggregates';
  /** Population standard deviation of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ForeignChainTrackingStddevSampleAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainBlockId?: InputMaybe<BigFloatFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingStddevSampleAggregates = {
  __typename?: 'ForeignChainTrackingStddevSampleAggregates';
  /** Sample standard deviation of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ForeignChainTrackingSumAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainBlockId?: InputMaybe<BigIntFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingSumAggregates = {
  __typename?: 'ForeignChainTrackingSumAggregates';
  /** Sum of foreignBlockHeight across the matching connection */
  foreignBlockHeight: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of stateChainBlockId across the matching connection */
  stateChainBlockId: Scalars['BigInt']['output'];
  /** Sum of stateChainEventId across the matching connection */
  stateChainEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type ForeignChainTrackingToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type ForeignChainTrackingVariancePopulationAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainBlockId?: InputMaybe<BigFloatFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingVariancePopulationAggregates = {
  __typename?: 'ForeignChainTrackingVariancePopulationAggregates';
  /** Population variance of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ForeignChainTrackingVarianceSampleAggregateFilter = {
  foreignBlockHeight?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainBlockId?: InputMaybe<BigFloatFilter>;
  stateChainEventId?: InputMaybe<BigFloatFilter>;
};

export type ForeignChainTrackingVarianceSampleAggregates = {
  __typename?: 'ForeignChainTrackingVarianceSampleAggregates';
  /** Sample variance of foreignBlockHeight across the matching connection */
  foreignBlockHeight?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stateChainBlockId across the matching connection */
  stateChainBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stateChainEventId across the matching connection */
  stateChainEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `ForeignChainTracking` values. */
export type ForeignChainTrackingsConnection = {
  __typename?: 'ForeignChainTrackingsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ForeignChainTrackingAggregates>;
  /** A list of edges which contains the `ForeignChainTracking` and cursor to aid in pagination. */
  edges: Array<ForeignChainTrackingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ForeignChainTrackingAggregates>>;
  /** A list of `ForeignChainTracking` objects. */
  nodes: Array<ForeignChainTracking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ForeignChainTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `ForeignChainTracking` values. */
export type ForeignChainTrackingsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ForeignChainTrackingGroupBy>;
  having?: InputMaybe<ForeignChainTrackingHavingInput>;
};

/** A `ForeignChainTracking` edge in the connection. */
export type ForeignChainTrackingsEdge = {
  __typename?: 'ForeignChainTrackingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ForeignChainTracking` at the end of the edge. */
  node: ForeignChainTracking;
};

/** Methods to use when ordering `ForeignChainTracking`. */
export type ForeignChainTrackingsOrderBy =
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'FOREIGN_BLOCK_HEIGHT_ASC'
  | 'FOREIGN_BLOCK_HEIGHT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STATE_CHAIN_BLOCK_ID_ASC'
  | 'STATE_CHAIN_BLOCK_ID_DESC'
  | 'STATE_CHAIN_EVENT_ID_ASC'
  | 'STATE_CHAIN_EVENT_ID_DESC'
  | 'STATE_CHAIN_TIMESTAMP_ASC'
  | 'STATE_CHAIN_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC';

export type FundingEventType =
  | 'FUNDED'
  | 'FUNDED_ON_CHAIN'
  | 'REBALANCE'
  | 'REDEEMED'
  | 'REDEMPTION_REQUESTED'
  | 'SLASHED';

/** A filter to be used against FundingEventType fields. All fields are combined with a logical ‘and.’ */
export type FundingEventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<FundingEventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<FundingEventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<FundingEventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<FundingEventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<FundingEventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<FundingEventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<FundingEventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<FundingEventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<FundingEventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<FundingEventType>>;
};

export type HavingBigfloatFilter = {
  equalTo?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThan?: InputMaybe<Scalars['BigFloat']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThan?: InputMaybe<Scalars['BigFloat']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  lessThan?: InputMaybe<Scalars['BigInt']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']['input']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
};

export type HavingFloatFilter = {
  equalTo?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  lessThan?: InputMaybe<Scalars['Float']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Float']['input']>;
  notEqualTo?: InputMaybe<Scalars['Float']['input']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

export type HistogramData = {
  __typename?: 'HistogramData';
  time: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type IgnoredEgress = Node & {
  __typename?: 'IgnoredEgress';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Event` that is related to this `IgnoredEgress`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `StateChainError` that is related to this `IgnoredEgress`. */
  stateChainErrorByStateChainErrorId?: Maybe<StateChainError>;
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `SwapRequest` that is related to this `IgnoredEgress`. */
  swapRequestByIgnoredEgressId?: Maybe<SwapRequest>;
  /** Reads a single `SwapRequest` that is related to this `IgnoredEgress`. */
  swapRequestByIgnoredRefundEgressId?: Maybe<SwapRequest>;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByIgnoredEgressId: SwapRequestsConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByIgnoredRefundEgressId: SwapRequestsConnection;
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};


export type IgnoredEgressSwapRequestsByIgnoredEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


export type IgnoredEgressSwapRequestsByIgnoredRefundEgressIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type IgnoredEgressAggregates = {
  __typename?: 'IgnoredEgressAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<IgnoredEgressAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<IgnoredEgressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<IgnoredEgressMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<IgnoredEgressMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<IgnoredEgressStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<IgnoredEgressStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<IgnoredEgressSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<IgnoredEgressVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<IgnoredEgressVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `IgnoredEgress` object types. */
export type IgnoredEgressAggregatesFilter = {
  /** Mean average aggregate over matching `IgnoredEgress` objects. */
  average?: InputMaybe<IgnoredEgressAverageAggregateFilter>;
  /** Distinct count aggregate over matching `IgnoredEgress` objects. */
  distinctCount?: InputMaybe<IgnoredEgressDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `IgnoredEgress` object to be included within the aggregate. */
  filter?: InputMaybe<IgnoredEgressFilter>;
  /** Maximum aggregate over matching `IgnoredEgress` objects. */
  max?: InputMaybe<IgnoredEgressMaxAggregateFilter>;
  /** Minimum aggregate over matching `IgnoredEgress` objects. */
  min?: InputMaybe<IgnoredEgressMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `IgnoredEgress` objects. */
  stddevPopulation?: InputMaybe<IgnoredEgressStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `IgnoredEgress` objects. */
  stddevSample?: InputMaybe<IgnoredEgressStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `IgnoredEgress` objects. */
  sum?: InputMaybe<IgnoredEgressSumAggregateFilter>;
  /** Population variance aggregate over matching `IgnoredEgress` objects. */
  variancePopulation?: InputMaybe<IgnoredEgressVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `IgnoredEgress` objects. */
  varianceSample?: InputMaybe<IgnoredEgressVarianceSampleAggregateFilter>;
};

export type IgnoredEgressAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressAverageAggregates = {
  __typename?: 'IgnoredEgressAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `IgnoredEgress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type IgnoredEgressCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  stateChainErrorByStateChainErrorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `stateChainErrorId` field. */
  stateChainErrorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type IgnoredEgressDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainErrorId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type IgnoredEgressDistinctCountAggregates = {
  __typename?: 'IgnoredEgressDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `IgnoredEgress` object types. All fields are combined with a logical ‘and.’ */
export type IgnoredEgressFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<IgnoredEgressFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<IgnoredEgressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<IgnoredEgressFilter>>;
  /** Filter by the object’s `stateChainErrorByStateChainErrorId` relation. */
  stateChainErrorByStateChainErrorId?: InputMaybe<StateChainErrorFilter>;
  /** A related `stateChainErrorByStateChainErrorId` exists. */
  stateChainErrorByStateChainErrorIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `stateChainErrorId` field. */
  stateChainErrorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapRequestByIgnoredEgressId` relation. */
  swapRequestByIgnoredEgressId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestByIgnoredEgressId` exists. */
  swapRequestByIgnoredEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestByIgnoredRefundEgressId` relation. */
  swapRequestByIgnoredRefundEgressId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestByIgnoredRefundEgressId` exists. */
  swapRequestByIgnoredRefundEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `IgnoredEgress` for usage during aggregation. */
export type IgnoredEgressGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'STATE_CHAIN_ERROR_ID'
  | 'VALUE_USD';

export type IgnoredEgressHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `IgnoredEgress` aggregates. */
export type IgnoredEgressHavingInput = {
  AND?: InputMaybe<Array<IgnoredEgressHavingInput>>;
  OR?: InputMaybe<Array<IgnoredEgressHavingInput>>;
  average?: InputMaybe<IgnoredEgressHavingAverageInput>;
  distinctCount?: InputMaybe<IgnoredEgressHavingDistinctCountInput>;
  max?: InputMaybe<IgnoredEgressHavingMaxInput>;
  min?: InputMaybe<IgnoredEgressHavingMinInput>;
  stddevPopulation?: InputMaybe<IgnoredEgressHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<IgnoredEgressHavingStddevSampleInput>;
  sum?: InputMaybe<IgnoredEgressHavingSumInput>;
  variancePopulation?: InputMaybe<IgnoredEgressHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<IgnoredEgressHavingVarianceSampleInput>;
};

export type IgnoredEgressHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  stateChainErrorId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type IgnoredEgressMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainErrorId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressMaxAggregates = {
  __typename?: 'IgnoredEgressMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type IgnoredEgressMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  stateChainErrorId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressMinAggregates = {
  __typename?: 'IgnoredEgressMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type IgnoredEgressStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressStddevPopulationAggregates = {
  __typename?: 'IgnoredEgressStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type IgnoredEgressStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressStddevSampleAggregates = {
  __typename?: 'IgnoredEgressStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type IgnoredEgressSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  stateChainErrorId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressSumAggregates = {
  __typename?: 'IgnoredEgressSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of stateChainErrorId across the matching connection */
  stateChainErrorId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type IgnoredEgressVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressVariancePopulationAggregates = {
  __typename?: 'IgnoredEgressVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type IgnoredEgressVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  stateChainErrorId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type IgnoredEgressVarianceSampleAggregates = {
  __typename?: 'IgnoredEgressVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stateChainErrorId across the matching connection */
  stateChainErrorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `IgnoredEgress` values. */
export type IgnoredEgressesConnection = {
  __typename?: 'IgnoredEgressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<IgnoredEgressAggregates>;
  /** A list of edges which contains the `IgnoredEgress` and cursor to aid in pagination. */
  edges: Array<IgnoredEgressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<IgnoredEgressAggregates>>;
  /** A list of `IgnoredEgress` objects. */
  nodes: Array<IgnoredEgress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `IgnoredEgress` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `IgnoredEgress` values. */
export type IgnoredEgressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<IgnoredEgressGroupBy>;
  having?: InputMaybe<IgnoredEgressHavingInput>;
};

/** A `IgnoredEgress` edge in the connection. */
export type IgnoredEgressesEdge = {
  __typename?: 'IgnoredEgressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `IgnoredEgress` at the end of the edge. */
  node: IgnoredEgress;
};

/** Methods to use when ordering `IgnoredEgress`. */
export type IgnoredEgressesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STATE_CHAIN_ERROR_ID_ASC'
  | 'STATE_CHAIN_ERROR_ID_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type IndexInBlockFilter = {
  height: Scalars['Int']['input'];
  indexInBlock: Scalars['Int']['input'];
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

export type LatestDelegationReward = Node & {
  __typename?: 'LatestDelegationReward';
  /** Reads a single `Account` that is related to this `LatestDelegationReward`. */
  accountByDelegatorAccountId: Account;
  amount: Scalars['BigFloat']['output'];
  delegatorAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type LatestDelegationRewardAggregates = {
  __typename?: 'LatestDelegationRewardAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LatestDelegationRewardAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LatestDelegationRewardDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LatestDelegationRewardMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LatestDelegationRewardMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LatestDelegationRewardStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LatestDelegationRewardStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LatestDelegationRewardSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LatestDelegationRewardVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LatestDelegationRewardVarianceSampleAggregates>;
};

export type LatestDelegationRewardAverageAggregates = {
  __typename?: 'LatestDelegationRewardAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LatestDelegationReward` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LatestDelegationRewardCondition = {
  accountByDelegatorAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LatestDelegationRewardDistinctCountAggregates = {
  __typename?: 'LatestDelegationRewardDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LatestDelegationReward` object types. All fields are combined with a logical ‘and.’ */
export type LatestDelegationRewardFilter = {
  /** Filter by the object’s `accountByDelegatorAccountId` relation. */
  accountByDelegatorAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LatestDelegationRewardFilter>>;
  /** Filter by the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LatestDelegationRewardFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LatestDelegationRewardFilter>>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LatestDelegationReward` for usage during aggregation. */
export type LatestDelegationRewardGroupBy =
  | 'AMOUNT'
  | 'VALUE_USD';

export type LatestDelegationRewardHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LatestDelegationReward` aggregates. */
export type LatestDelegationRewardHavingInput = {
  AND?: InputMaybe<Array<LatestDelegationRewardHavingInput>>;
  OR?: InputMaybe<Array<LatestDelegationRewardHavingInput>>;
  average?: InputMaybe<LatestDelegationRewardHavingAverageInput>;
  distinctCount?: InputMaybe<LatestDelegationRewardHavingDistinctCountInput>;
  max?: InputMaybe<LatestDelegationRewardHavingMaxInput>;
  min?: InputMaybe<LatestDelegationRewardHavingMinInput>;
  stddevPopulation?: InputMaybe<LatestDelegationRewardHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LatestDelegationRewardHavingStddevSampleInput>;
  sum?: InputMaybe<LatestDelegationRewardHavingSumInput>;
  variancePopulation?: InputMaybe<LatestDelegationRewardHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LatestDelegationRewardHavingVarianceSampleInput>;
};

export type LatestDelegationRewardHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LatestDelegationRewardMaxAggregates = {
  __typename?: 'LatestDelegationRewardMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LatestDelegationRewardMinAggregates = {
  __typename?: 'LatestDelegationRewardMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LatestDelegationRewardStddevPopulationAggregates = {
  __typename?: 'LatestDelegationRewardStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LatestDelegationRewardStddevSampleAggregates = {
  __typename?: 'LatestDelegationRewardStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LatestDelegationRewardSumAggregates = {
  __typename?: 'LatestDelegationRewardSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of delegatorAccountId across the matching connection */
  delegatorAccountId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type LatestDelegationRewardVariancePopulationAggregates = {
  __typename?: 'LatestDelegationRewardVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LatestDelegationRewardVarianceSampleAggregates = {
  __typename?: 'LatestDelegationRewardVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LatestDelegationReward` values. */
export type LatestDelegationRewardsConnection = {
  __typename?: 'LatestDelegationRewardsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LatestDelegationRewardAggregates>;
  /** A list of edges which contains the `LatestDelegationReward` and cursor to aid in pagination. */
  edges: Array<LatestDelegationRewardsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LatestDelegationRewardAggregates>>;
  /** A list of `LatestDelegationReward` objects. */
  nodes: Array<LatestDelegationReward>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LatestDelegationReward` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LatestDelegationReward` values. */
export type LatestDelegationRewardsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LatestDelegationRewardGroupBy>;
  having?: InputMaybe<LatestDelegationRewardHavingInput>;
};

/** A `LatestDelegationReward` edge in the connection. */
export type LatestDelegationRewardsEdge = {
  __typename?: 'LatestDelegationRewardsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LatestDelegationReward` at the end of the edge. */
  node: LatestDelegationReward;
};

/** Methods to use when ordering `LatestDelegationReward`. */
export type LatestDelegationRewardsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATOR_ACCOUNT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type LendingNetworkFee = Node & {
  __typename?: 'LendingNetworkFee';
  asset: ChainflipAsset;
  id: Scalars['Int']['output'];
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SwapRequest` that is related to this `LendingNetworkFee`. */
  swapRequestBySwapRequestId: SwapRequest;
  swapRequestId: Scalars['Int']['output'];
};

export type LendingNetworkFeeAggregates = {
  __typename?: 'LendingNetworkFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LendingNetworkFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LendingNetworkFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LendingNetworkFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LendingNetworkFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LendingNetworkFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LendingNetworkFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LendingNetworkFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LendingNetworkFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LendingNetworkFeeVarianceSampleAggregates>;
};

export type LendingNetworkFeeAverageAggregates = {
  __typename?: 'LendingNetworkFeeAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LendingNetworkFee` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LendingNetworkFeeCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `networkFeeAmount` field. */
  networkFeeAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `networkFeeValueUsd` field. */
  networkFeeValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
};

export type LendingNetworkFeeDistinctCountAggregates = {
  __typename?: 'LendingNetworkFeeDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LendingNetworkFee` object types. All fields are combined with a logical ‘and.’ */
export type LendingNetworkFeeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LendingNetworkFeeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `networkFeeAmount` field. */
  networkFeeAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `networkFeeValueUsd` field. */
  networkFeeValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LendingNetworkFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LendingNetworkFeeFilter>>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `LendingNetworkFee` for usage during aggregation. */
export type LendingNetworkFeeGroupBy =
  | 'ASSET'
  | 'NETWORK_FEE_AMOUNT'
  | 'NETWORK_FEE_VALUE_USD';

export type LendingNetworkFeeHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LendingNetworkFee` aggregates. */
export type LendingNetworkFeeHavingInput = {
  AND?: InputMaybe<Array<LendingNetworkFeeHavingInput>>;
  OR?: InputMaybe<Array<LendingNetworkFeeHavingInput>>;
  average?: InputMaybe<LendingNetworkFeeHavingAverageInput>;
  distinctCount?: InputMaybe<LendingNetworkFeeHavingDistinctCountInput>;
  max?: InputMaybe<LendingNetworkFeeHavingMaxInput>;
  min?: InputMaybe<LendingNetworkFeeHavingMinInput>;
  stddevPopulation?: InputMaybe<LendingNetworkFeeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LendingNetworkFeeHavingStddevSampleInput>;
  sum?: InputMaybe<LendingNetworkFeeHavingSumInput>;
  variancePopulation?: InputMaybe<LendingNetworkFeeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LendingNetworkFeeHavingVarianceSampleInput>;
};

export type LendingNetworkFeeHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  networkFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  networkFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LendingNetworkFeeMaxAggregates = {
  __typename?: 'LendingNetworkFeeMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type LendingNetworkFeeMinAggregates = {
  __typename?: 'LendingNetworkFeeMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type LendingNetworkFeeStddevPopulationAggregates = {
  __typename?: 'LendingNetworkFeeStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingNetworkFeeStddevSampleAggregates = {
  __typename?: 'LendingNetworkFeeStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingNetworkFeeSumAggregates = {
  __typename?: 'LendingNetworkFeeSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of networkFeeAmount across the matching connection */
  networkFeeAmount: Scalars['BigFloat']['output'];
  /** Sum of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
};

export type LendingNetworkFeeVariancePopulationAggregates = {
  __typename?: 'LendingNetworkFeeVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LendingNetworkFeeVarianceSampleAggregates = {
  __typename?: 'LendingNetworkFeeVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeeAmount across the matching connection */
  networkFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of networkFeeValueUsd across the matching connection */
  networkFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LendingNetworkFee` values. */
export type LendingNetworkFeesConnection = {
  __typename?: 'LendingNetworkFeesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LendingNetworkFeeAggregates>;
  /** A list of edges which contains the `LendingNetworkFee` and cursor to aid in pagination. */
  edges: Array<LendingNetworkFeesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LendingNetworkFeeAggregates>>;
  /** A list of `LendingNetworkFee` objects. */
  nodes: Array<LendingNetworkFee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LendingNetworkFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LendingNetworkFee` values. */
export type LendingNetworkFeesConnectionGroupedAggregatesArgs = {
  groupBy: Array<LendingNetworkFeeGroupBy>;
  having?: InputMaybe<LendingNetworkFeeHavingInput>;
};

/** A `LendingNetworkFee` edge in the connection. */
export type LendingNetworkFeesEdge = {
  __typename?: 'LendingNetworkFeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LendingNetworkFee` at the end of the edge. */
  node: LendingNetworkFee;
};

/** Methods to use when ordering `LendingNetworkFee`. */
export type LendingNetworkFeesOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NETWORK_FEE_AMOUNT_ASC'
  | 'NETWORK_FEE_AMOUNT_DESC'
  | 'NETWORK_FEE_VALUE_USD_ASC'
  | 'NETWORK_FEE_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

export type LineData = {
  __typename?: 'LineData';
  time: Scalars['Int']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type LiquidationSwapAbortedReason =
  | 'LIQUIDATION_COMPLETED'
  | 'MANUAL_ABORT'
  | 'SYSTEM_ABORT_LTV_HARD_TO_HEALTHY'
  | 'SYSTEM_ABORT_LTV_HARD_TO_MANUAL'
  | 'SYSTEM_ABORT_LTV_HARD_TO_SOFT'
  | 'SYSTEM_ABORT_LTV_MANUAL_TO_HARD'
  | 'SYSTEM_ABORT_LTV_MANUAL_TO_SOFT'
  | 'SYSTEM_ABORT_LTV_SOFT_TO_HARD'
  | 'SYSTEM_ABORT_LTV_SOFT_TO_HEALTHY'
  | 'SYSTEM_ABORT_LTV_SOFT_TO_MANUAL';

/** A filter to be used against LiquidationSwapAbortedReason fields. All fields are combined with a logical ‘and.’ */
export type LiquidationSwapAbortedReasonFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LiquidationSwapAbortedReason>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LiquidationSwapAbortedReason>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LiquidationSwapAbortedReason>>;
};

export type LiquidationSwapInfo = Node & {
  __typename?: 'LiquidationSwapInfo';
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  abortedReason?: Maybe<LiquidationSwapAbortedReason>;
  /** Reads a single `Account` that is related to this `LiquidationSwapInfo`. */
  accountByBorrowerId: Account;
  borrowerId: Scalars['Int']['output'];
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  collateralAddedEventId?: Maybe<Scalars['BigInt']['output']>;
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Event` that is related to this `LiquidationSwapInfo`. */
  eventByAbortedAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `LiquidationSwapInfo`. */
  eventByCollateralAddedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `LiquidationSwapInfo`. */
  eventByCompletedAtEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `LiquidationSwapInfo`. */
  eventByLoanRepaidEventId?: Maybe<Event>;
  id: Scalars['Int']['output'];
  inputAmount: Scalars['BigFloat']['output'];
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  liquidationType?: Maybe<LiquidationType>;
  loanId: Scalars['BigInt']['output'];
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  loanRepaidEventId?: Maybe<Scalars['BigInt']['output']>;
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `SwapRequest` that is related to this `LiquidationSwapInfo`. */
  swapRequestBySwapRequestId: SwapRequest;
  swapRequestId: Scalars['Int']['output'];
};

export type LiquidationSwapInfoAggregates = {
  __typename?: 'LiquidationSwapInfoAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidationSwapInfoAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidationSwapInfoDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidationSwapInfoMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidationSwapInfoMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidationSwapInfoStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidationSwapInfoStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidationSwapInfoSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidationSwapInfoVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidationSwapInfoVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidationSwapInfo` object types. */
export type LiquidationSwapInfoAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidationSwapInfo` objects. */
  average?: InputMaybe<LiquidationSwapInfoAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidationSwapInfo` objects. */
  distinctCount?: InputMaybe<LiquidationSwapInfoDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidationSwapInfo` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  /** Maximum aggregate over matching `LiquidationSwapInfo` objects. */
  max?: InputMaybe<LiquidationSwapInfoMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidationSwapInfo` objects. */
  min?: InputMaybe<LiquidationSwapInfoMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidationSwapInfo` objects. */
  stddevPopulation?: InputMaybe<LiquidationSwapInfoStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidationSwapInfo` objects. */
  stddevSample?: InputMaybe<LiquidationSwapInfoStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidationSwapInfo` objects. */
  sum?: InputMaybe<LiquidationSwapInfoSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidationSwapInfo` objects. */
  variancePopulation?: InputMaybe<LiquidationSwapInfoVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidationSwapInfo` objects. */
  varianceSample?: InputMaybe<LiquidationSwapInfoVarianceSampleAggregateFilter>;
};

export type LiquidationSwapInfoAverageAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapInfoAverageAggregates = {
  __typename?: 'LiquidationSwapInfoAverageAggregates';
  /** Mean average of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidationSwapInfo` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LiquidationSwapInfoCondition = {
  /** Checks for equality with the object’s `abortedAtEventId` field. */
  abortedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `abortedReason` field. */
  abortedReason?: InputMaybe<LiquidationSwapAbortedReason>;
  accountByBorrowerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `borrowerId` field. */
  borrowerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `collateralAddedAmount` field. */
  collateralAddedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `collateralAddedEventId` field. */
  collateralAddedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `collateralAddedValueUsd` field. */
  collateralAddedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `completedAtEventId` field. */
  completedAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByAbortedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByCollateralAddedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByCompletedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByLoanRepaidEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `inputAmount` field. */
  inputAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `inputValueUsd` field. */
  inputValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidationType` field. */
  liquidationType?: InputMaybe<LiquidationType>;
  /** Checks for equality with the object’s `loanId` field. */
  loanId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loanRepaidAmount` field. */
  loanRepaidAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `loanRepaidEventId` field. */
  loanRepaidEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `loanRepaidValueUsd` field. */
  loanRepaidValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `outputAmount` field. */
  outputAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `outputValueUsd` field. */
  outputValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundAmount` field. */
  refundAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundValueUsd` field. */
  refundValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
};

export type LiquidationSwapInfoDistinctCountAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  abortedReason?: InputMaybe<BigIntFilter>;
  borrowerId?: InputMaybe<BigIntFilter>;
  collateralAddedAmount?: InputMaybe<BigIntFilter>;
  collateralAddedEventId?: InputMaybe<BigIntFilter>;
  collateralAddedValueUsd?: InputMaybe<BigIntFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  inputAmount?: InputMaybe<BigIntFilter>;
  inputValueUsd?: InputMaybe<BigIntFilter>;
  liquidationType?: InputMaybe<BigIntFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  loanRepaidAmount?: InputMaybe<BigIntFilter>;
  loanRepaidEventId?: InputMaybe<BigIntFilter>;
  loanRepaidValueUsd?: InputMaybe<BigIntFilter>;
  outputAmount?: InputMaybe<BigIntFilter>;
  outputValueUsd?: InputMaybe<BigIntFilter>;
  refundAmount?: InputMaybe<BigIntFilter>;
  refundValueUsd?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type LiquidationSwapInfoDistinctCountAggregates = {
  __typename?: 'LiquidationSwapInfoDistinctCountAggregates';
  /** Distinct count of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of abortedReason across the matching connection */
  abortedReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidationType across the matching connection */
  liquidationType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidationSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type LiquidationSwapInfoFilter = {
  /** Filter by the object’s `abortedAtEventId` field. */
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `abortedReason` field. */
  abortedReason?: InputMaybe<LiquidationSwapAbortedReasonFilter>;
  /** Filter by the object’s `accountByBorrowerId` relation. */
  accountByBorrowerId?: InputMaybe<AccountFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidationSwapInfoFilter>>;
  /** Filter by the object’s `borrowerId` field. */
  borrowerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `collateralAddedAmount` field. */
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `collateralAddedEventId` field. */
  collateralAddedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `collateralAddedValueUsd` field. */
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `completedAtEventId` field. */
  completedAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByAbortedAtEventId` relation. */
  eventByAbortedAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByAbortedAtEventId` exists. */
  eventByAbortedAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByCollateralAddedEventId` relation. */
  eventByCollateralAddedEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCollateralAddedEventId` exists. */
  eventByCollateralAddedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByCompletedAtEventId` relation. */
  eventByCompletedAtEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCompletedAtEventId` exists. */
  eventByCompletedAtEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByLoanRepaidEventId` relation. */
  eventByLoanRepaidEventId?: InputMaybe<EventFilter>;
  /** A related `eventByLoanRepaidEventId` exists. */
  eventByLoanRepaidEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `inputAmount` field. */
  inputAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `inputValueUsd` field. */
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidationType` field. */
  liquidationType?: InputMaybe<LiquidationTypeFilter>;
  /** Filter by the object’s `loanId` field. */
  loanId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loanRepaidAmount` field. */
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `loanRepaidEventId` field. */
  loanRepaidEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `loanRepaidValueUsd` field. */
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidationSwapInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidationSwapInfoFilter>>;
  /** Filter by the object’s `outputAmount` field. */
  outputAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `outputValueUsd` field. */
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `refundAmount` field. */
  refundAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `refundValueUsd` field. */
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `LiquidationSwapInfo` for usage during aggregation. */
export type LiquidationSwapInfoGroupBy =
  | 'ABORTED_AT_EVENT_ID'
  | 'ABORTED_REASON'
  | 'BORROWER_ID'
  | 'COLLATERAL_ADDED_AMOUNT'
  | 'COLLATERAL_ADDED_EVENT_ID'
  | 'COLLATERAL_ADDED_VALUE_USD'
  | 'COMPLETED_AT_EVENT_ID'
  | 'INPUT_AMOUNT'
  | 'INPUT_VALUE_USD'
  | 'LIQUIDATION_TYPE'
  | 'LOAN_ID'
  | 'LOAN_REPAID_AMOUNT'
  | 'LOAN_REPAID_EVENT_ID'
  | 'LOAN_REPAID_VALUE_USD'
  | 'OUTPUT_AMOUNT'
  | 'OUTPUT_VALUE_USD'
  | 'REFUND_AMOUNT'
  | 'REFUND_VALUE_USD';

export type LiquidationSwapInfoHavingAverageInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingDistinctCountInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LiquidationSwapInfo` aggregates. */
export type LiquidationSwapInfoHavingInput = {
  AND?: InputMaybe<Array<LiquidationSwapInfoHavingInput>>;
  OR?: InputMaybe<Array<LiquidationSwapInfoHavingInput>>;
  average?: InputMaybe<LiquidationSwapInfoHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidationSwapInfoHavingDistinctCountInput>;
  max?: InputMaybe<LiquidationSwapInfoHavingMaxInput>;
  min?: InputMaybe<LiquidationSwapInfoHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidationSwapInfoHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidationSwapInfoHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidationSwapInfoHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidationSwapInfoHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidationSwapInfoHavingVarianceSampleInput>;
};

export type LiquidationSwapInfoHavingMaxInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingMinInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingStddevPopulationInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingStddevSampleInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingSumInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingVariancePopulationInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoHavingVarianceSampleInput = {
  abortedAtEventId?: InputMaybe<HavingBigintFilter>;
  borrowerId?: InputMaybe<HavingIntFilter>;
  collateralAddedAmount?: InputMaybe<HavingBigfloatFilter>;
  collateralAddedEventId?: InputMaybe<HavingBigintFilter>;
  collateralAddedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  completedAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  inputAmount?: InputMaybe<HavingBigfloatFilter>;
  inputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  loanId?: InputMaybe<HavingBigintFilter>;
  loanRepaidAmount?: InputMaybe<HavingBigfloatFilter>;
  loanRepaidEventId?: InputMaybe<HavingBigintFilter>;
  loanRepaidValueUsd?: InputMaybe<HavingBigfloatFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type LiquidationSwapInfoMaxAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  borrowerId?: InputMaybe<IntFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigIntFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigIntFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type LiquidationSwapInfoMaxAggregates = {
  __typename?: 'LiquidationSwapInfoMaxAggregates';
  /** Maximum of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidationSwapInfoMinAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigIntFilter>;
  borrowerId?: InputMaybe<IntFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigIntFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigIntFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigIntFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type LiquidationSwapInfoMinAggregates = {
  __typename?: 'LiquidationSwapInfoMinAggregates';
  /** Minimum of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidationSwapInfoStddevPopulationAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapInfoStddevPopulationAggregates = {
  __typename?: 'LiquidationSwapInfoStddevPopulationAggregates';
  /** Population standard deviation of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapInfoStddevSampleAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapInfoStddevSampleAggregates = {
  __typename?: 'LiquidationSwapInfoStddevSampleAggregates';
  /** Sample standard deviation of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapInfoSumAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigIntFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type LiquidationSwapInfoSumAggregates = {
  __typename?: 'LiquidationSwapInfoSumAggregates';
  /** Sum of abortedAtEventId across the matching connection */
  abortedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of borrowerId across the matching connection */
  borrowerId: Scalars['BigInt']['output'];
  /** Sum of collateralAddedAmount across the matching connection */
  collateralAddedAmount: Scalars['BigFloat']['output'];
  /** Sum of collateralAddedEventId across the matching connection */
  collateralAddedEventId: Scalars['BigFloat']['output'];
  /** Sum of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of completedAtEventId across the matching connection */
  completedAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of inputAmount across the matching connection */
  inputAmount: Scalars['BigFloat']['output'];
  /** Sum of inputValueUsd across the matching connection */
  inputValueUsd: Scalars['BigFloat']['output'];
  /** Sum of loanId across the matching connection */
  loanId: Scalars['BigFloat']['output'];
  /** Sum of loanRepaidAmount across the matching connection */
  loanRepaidAmount: Scalars['BigFloat']['output'];
  /** Sum of loanRepaidEventId across the matching connection */
  loanRepaidEventId: Scalars['BigFloat']['output'];
  /** Sum of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd: Scalars['BigFloat']['output'];
  /** Sum of outputAmount across the matching connection */
  outputAmount: Scalars['BigFloat']['output'];
  /** Sum of outputValueUsd across the matching connection */
  outputValueUsd: Scalars['BigFloat']['output'];
  /** Sum of refundAmount across the matching connection */
  refundAmount: Scalars['BigFloat']['output'];
  /** Sum of refundValueUsd across the matching connection */
  refundValueUsd: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
};

export type LiquidationSwapInfoVariancePopulationAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapInfoVariancePopulationAggregates = {
  __typename?: 'LiquidationSwapInfoVariancePopulationAggregates';
  /** Population variance of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidationSwapInfoVarianceSampleAggregateFilter = {
  abortedAtEventId?: InputMaybe<BigFloatFilter>;
  borrowerId?: InputMaybe<BigFloatFilter>;
  collateralAddedAmount?: InputMaybe<BigFloatFilter>;
  collateralAddedEventId?: InputMaybe<BigFloatFilter>;
  collateralAddedValueUsd?: InputMaybe<BigFloatFilter>;
  completedAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  inputAmount?: InputMaybe<BigFloatFilter>;
  inputValueUsd?: InputMaybe<BigFloatFilter>;
  loanId?: InputMaybe<BigFloatFilter>;
  loanRepaidAmount?: InputMaybe<BigFloatFilter>;
  loanRepaidEventId?: InputMaybe<BigFloatFilter>;
  loanRepaidValueUsd?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type LiquidationSwapInfoVarianceSampleAggregates = {
  __typename?: 'LiquidationSwapInfoVarianceSampleAggregates';
  /** Sample variance of abortedAtEventId across the matching connection */
  abortedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of borrowerId across the matching connection */
  borrowerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of collateralAddedAmount across the matching connection */
  collateralAddedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of collateralAddedEventId across the matching connection */
  collateralAddedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of collateralAddedValueUsd across the matching connection */
  collateralAddedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of completedAtEventId across the matching connection */
  completedAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of inputAmount across the matching connection */
  inputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of inputValueUsd across the matching connection */
  inputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanId across the matching connection */
  loanId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanRepaidAmount across the matching connection */
  loanRepaidAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanRepaidEventId across the matching connection */
  loanRepaidEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of loanRepaidValueUsd across the matching connection */
  loanRepaidValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidationSwapInfo` values. */
export type LiquidationSwapInfosConnection = {
  __typename?: 'LiquidationSwapInfosConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidationSwapInfoAggregates>;
  /** A list of edges which contains the `LiquidationSwapInfo` and cursor to aid in pagination. */
  edges: Array<LiquidationSwapInfosEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidationSwapInfoAggregates>>;
  /** A list of `LiquidationSwapInfo` objects. */
  nodes: Array<LiquidationSwapInfo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidationSwapInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidationSwapInfo` values. */
export type LiquidationSwapInfosConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidationSwapInfoGroupBy>;
  having?: InputMaybe<LiquidationSwapInfoHavingInput>;
};

/** A `LiquidationSwapInfo` edge in the connection. */
export type LiquidationSwapInfosEdge = {
  __typename?: 'LiquidationSwapInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidationSwapInfo` at the end of the edge. */
  node: LiquidationSwapInfo;
};

/** Methods to use when ordering `LiquidationSwapInfo`. */
export type LiquidationSwapInfosOrderBy =
  | 'ABORTED_AT_EVENT_ID_ASC'
  | 'ABORTED_AT_EVENT_ID_DESC'
  | 'ABORTED_REASON_ASC'
  | 'ABORTED_REASON_DESC'
  | 'BORROWER_ID_ASC'
  | 'BORROWER_ID_DESC'
  | 'COLLATERAL_ADDED_AMOUNT_ASC'
  | 'COLLATERAL_ADDED_AMOUNT_DESC'
  | 'COLLATERAL_ADDED_EVENT_ID_ASC'
  | 'COLLATERAL_ADDED_EVENT_ID_DESC'
  | 'COLLATERAL_ADDED_VALUE_USD_ASC'
  | 'COLLATERAL_ADDED_VALUE_USD_DESC'
  | 'COMPLETED_AT_EVENT_ID_ASC'
  | 'COMPLETED_AT_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INPUT_AMOUNT_ASC'
  | 'INPUT_AMOUNT_DESC'
  | 'INPUT_VALUE_USD_ASC'
  | 'INPUT_VALUE_USD_DESC'
  | 'LIQUIDATION_TYPE_ASC'
  | 'LIQUIDATION_TYPE_DESC'
  | 'LOAN_ID_ASC'
  | 'LOAN_ID_DESC'
  | 'LOAN_REPAID_AMOUNT_ASC'
  | 'LOAN_REPAID_AMOUNT_DESC'
  | 'LOAN_REPAID_EVENT_ID_ASC'
  | 'LOAN_REPAID_EVENT_ID_DESC'
  | 'LOAN_REPAID_VALUE_USD_ASC'
  | 'LOAN_REPAID_VALUE_USD_DESC'
  | 'NATURAL'
  | 'OUTPUT_AMOUNT_ASC'
  | 'OUTPUT_AMOUNT_DESC'
  | 'OUTPUT_VALUE_USD_ASC'
  | 'OUTPUT_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFUND_AMOUNT_ASC'
  | 'REFUND_AMOUNT_DESC'
  | 'REFUND_VALUE_USD_ASC'
  | 'REFUND_VALUE_USD_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

export type LiquidationType =
  | 'HARD'
  | 'SOFT'
  | 'SOFT_VOLUNTARY';

/** A filter to be used against LiquidationType fields. All fields are combined with a logical ‘and.’ */
export type LiquidationTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LiquidationType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LiquidationType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LiquidationType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LiquidationType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LiquidationType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LiquidationType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LiquidationType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LiquidationType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LiquidationType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LiquidationType>>;
};

export type LiquidityBalanceEvent = {
  __typename?: 'LiquidityBalanceEvent';
  /** Reads a single `AccountCreationDepositChannel` that is related to this `LiquidityBalanceEvent`. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: Maybe<AccountCreationDepositChannel>;
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `LiquidityBalanceEvent`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `Broadcast` that is related to this `LiquidityBalanceEvent`. */
  broadcastByBroadcastId?: Maybe<Broadcast>;
  broadcastId?: Maybe<Scalars['Int']['output']>;
  chain: ChainflipChain;
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Event` that is related to this `LiquidityBalanceEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  /** Reads a single `LiquidityDepositChannel` that is related to this `LiquidityBalanceEvent`. */
  liquidityDepositChannelByLiquidityDepositChannelId?: Maybe<LiquidityDepositChannel>;
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityBalanceEvent`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByEventId: LiquidityWithdrawalsConnection;
  txRef?: Maybe<Scalars['String']['output']>;
  valueUsd: Scalars['BigFloat']['output'];
};


export type LiquidityBalanceEventLiquidityWithdrawalsByEventIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};

export type LiquidityBalanceEventAggregates = {
  __typename?: 'LiquidityBalanceEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityBalanceEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityBalanceEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityBalanceEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityBalanceEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityBalanceEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityBalanceEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityBalanceEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityBalanceEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityBalanceEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityBalanceEvent` object types. */
export type LiquidityBalanceEventAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityBalanceEvent` objects. */
  average?: InputMaybe<LiquidityBalanceEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityBalanceEvent` objects. */
  distinctCount?: InputMaybe<LiquidityBalanceEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityBalanceEvent` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Maximum aggregate over matching `LiquidityBalanceEvent` objects. */
  max?: InputMaybe<LiquidityBalanceEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityBalanceEvent` objects. */
  min?: InputMaybe<LiquidityBalanceEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityBalanceEvent` objects. */
  stddevPopulation?: InputMaybe<LiquidityBalanceEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityBalanceEvent` objects. */
  stddevSample?: InputMaybe<LiquidityBalanceEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityBalanceEvent` objects. */
  sum?: InputMaybe<LiquidityBalanceEventSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityBalanceEvent` objects. */
  variancePopulation?: InputMaybe<LiquidityBalanceEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityBalanceEvent` objects. */
  varianceSample?: InputMaybe<LiquidityBalanceEventVarianceSampleAggregateFilter>;
};

export type LiquidityBalanceEventAverageAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventAverageAggregates = {
  __typename?: 'LiquidityBalanceEventAverageAggregates';
  /** Mean average of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityBalanceEvent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LiquidityBalanceEventCondition = {
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  broadcastByBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `txRef` field. */
  txRef?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LiquidityBalanceEventDistinctCountAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  txRef?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type LiquidityBalanceEventDistinctCountAggregates = {
  __typename?: 'LiquidityBalanceEventDistinctCountAggregates';
  /** Distinct count of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of txRef across the matching connection */
  txRef?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityBalanceEventFilter = {
  /** Filter by the object’s `accountCreationDepositChannelByAccountCreationDepositChannelId` relation. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** A related `accountCreationDepositChannelByAccountCreationDepositChannelId` exists. */
  accountCreationDepositChannelByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityBalanceEventFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `broadcastByBroadcastId` relation. */
  broadcastByBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByBroadcastId` exists. */
  broadcastByBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityDepositChannelByLiquidityDepositChannelId` relation. */
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelFilter>;
  /** A related `liquidityDepositChannelByLiquidityDepositChannelId` exists. */
  liquidityDepositChannelByLiquidityDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityWithdrawalsByEventId` relation. */
  liquidityWithdrawalsByEventId?: InputMaybe<LiquidityBalanceEventToManyLiquidityWithdrawalFilter>;
  /** Some related `liquidityWithdrawalsByEventId` exist. */
  liquidityWithdrawalsByEventIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityBalanceEventFilter>>;
  /** Filter by the object’s `txRef` field. */
  txRef?: InputMaybe<StringFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LiquidityBalanceEvent` for usage during aggregation. */
export type LiquidityBalanceEventGroupBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID'
  | 'AMOUNT'
  | 'ASSET'
  | 'BLOCK_ID'
  | 'BROADCAST_ID'
  | 'CHAIN'
  | 'EFFECTIVE_BOOST_FEE_BPS'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'TX_REF'
  | 'VALUE_USD';

export type LiquidityBalanceEventHavingAverageInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingDistinctCountInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LiquidityBalanceEvent` aggregates. */
export type LiquidityBalanceEventHavingInput = {
  AND?: InputMaybe<Array<LiquidityBalanceEventHavingInput>>;
  OR?: InputMaybe<Array<LiquidityBalanceEventHavingInput>>;
  average?: InputMaybe<LiquidityBalanceEventHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityBalanceEventHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityBalanceEventHavingMaxInput>;
  min?: InputMaybe<LiquidityBalanceEventHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityBalanceEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityBalanceEventHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityBalanceEventHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityBalanceEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityBalanceEventHavingVarianceSampleInput>;
};

export type LiquidityBalanceEventHavingMaxInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingMinInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingStddevPopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingStddevSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingSumInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingVariancePopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventHavingVarianceSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityBalanceEventMaxAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventMaxAggregates = {
  __typename?: 'LiquidityBalanceEventMaxAggregates';
  /** Maximum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityBalanceEventMinAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventMinAggregates = {
  __typename?: 'LiquidityBalanceEventMinAggregates';
  /** Minimum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityBalanceEventStddevPopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventStddevPopulationAggregates = {
  __typename?: 'LiquidityBalanceEventStddevPopulationAggregates';
  /** Population standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityBalanceEventStddevSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventStddevSampleAggregates = {
  __typename?: 'LiquidityBalanceEventStddevSampleAggregates';
  /** Sample standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityBalanceEventSumAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventSumAggregates = {
  __typename?: 'LiquidityBalanceEventSumAggregates';
  /** Sum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of broadcastId across the matching connection */
  broadcastId: Scalars['BigInt']['output'];
  /** Sum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityBalanceEventToManyLiquidityWithdrawalFilter = {
  /** Aggregates across related `LiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityWithdrawalAggregatesFilter>;
  /** Every related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityWithdrawalFilter>;
  /** No related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Some related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityWithdrawalFilter>;
};

export type LiquidityBalanceEventVariancePopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventVariancePopulationAggregates = {
  __typename?: 'LiquidityBalanceEventVariancePopulationAggregates';
  /** Population variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityBalanceEventVarianceSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityBalanceEventVarianceSampleAggregates = {
  __typename?: 'LiquidityBalanceEventVarianceSampleAggregates';
  /** Sample variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityBalanceEvent` values. */
export type LiquidityBalanceEventsConnection = {
  __typename?: 'LiquidityBalanceEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityBalanceEventAggregates>;
  /** A list of edges which contains the `LiquidityBalanceEvent` and cursor to aid in pagination. */
  edges: Array<LiquidityBalanceEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityBalanceEventAggregates>>;
  /** A list of `LiquidityBalanceEvent` objects. */
  nodes: Array<LiquidityBalanceEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityBalanceEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityBalanceEvent` values. */
export type LiquidityBalanceEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityBalanceEventGroupBy>;
  having?: InputMaybe<LiquidityBalanceEventHavingInput>;
};

/** A `LiquidityBalanceEvent` edge in the connection. */
export type LiquidityBalanceEventsEdge = {
  __typename?: 'LiquidityBalanceEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityBalanceEvent` at the end of the edge. */
  node: LiquidityBalanceEvent;
};

/** Methods to use when ordering `LiquidityBalanceEvent`. */
export type LiquidityBalanceEventsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BROADCAST_ID_ASC'
  | 'BROADCAST_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_COUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_COUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_EVENT_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NATURAL'
  | 'TX_REF_ASC'
  | 'TX_REF_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type LiquidityDeposit = Node & {
  __typename?: 'LiquidityDeposit';
  /** Reads a single `AccountCreationDepositChannel` that is related to this `LiquidityDeposit`. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: Maybe<AccountCreationDepositChannel>;
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `LiquidityDeposit`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `BoostNetworkFeeSplit` that is related to this `LiquidityDeposit`. */
  boostNetworkFeeSplitByBoostedLiquidityDepositId?: Maybe<BoostNetworkFeeSplit>;
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitsByBoostedLiquidityDepositId: BoostNetworkFeeSplitsConnection;
  chain: ChainflipChain;
  depositAmount: Scalars['BigFloat']['output'];
  depositValueUsd: Scalars['BigFloat']['output'];
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Event` that is related to this `LiquidityDeposit`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  fee?: Maybe<Scalars['BigFloat']['output']>;
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityDepositChannel` that is related to this `LiquidityDeposit`. */
  liquidityDepositChannelByLiquidityDepositChannelId?: Maybe<LiquidityDepositChannel>;
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityDeposit`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  timestamp: Scalars['Datetime']['output'];
  /** Reads and enables pagination through a set of `TransactionRef`. */
  transactionRefsByLiquidityDepositId: TransactionRefsConnection;
};


export type LiquidityDepositBoostNetworkFeeSplitsByBoostedLiquidityDepositIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


export type LiquidityDepositTransactionRefsByLiquidityDepositIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransactionRefCondition>;
  filter?: InputMaybe<TransactionRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransactionRefsOrderBy>>;
};

export type LiquidityDepositAggregates = {
  __typename?: 'LiquidityDepositAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityDepositAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityDepositDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityDepositMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityDepositMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityDepositStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityDepositStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityDepositSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityDepositVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityDepositVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityDeposit` object types. */
export type LiquidityDepositAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityDeposit` objects. */
  average?: InputMaybe<LiquidityDepositAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityDeposit` objects. */
  distinctCount?: InputMaybe<LiquidityDepositDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityDeposit` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityDepositFilter>;
  /** Maximum aggregate over matching `LiquidityDeposit` objects. */
  max?: InputMaybe<LiquidityDepositMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityDeposit` objects. */
  min?: InputMaybe<LiquidityDepositMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityDeposit` objects. */
  stddevPopulation?: InputMaybe<LiquidityDepositStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityDeposit` objects. */
  stddevSample?: InputMaybe<LiquidityDepositStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityDeposit` objects. */
  sum?: InputMaybe<LiquidityDepositSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityDeposit` objects. */
  variancePopulation?: InputMaybe<LiquidityDepositVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityDeposit` objects. */
  varianceSample?: InputMaybe<LiquidityDepositVarianceSampleAggregateFilter>;
};

export type LiquidityDepositAverageAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositAverageAggregates = {
  __typename?: 'LiquidityDepositAverageAggregates';
  /** Mean average of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositChannel = Node & {
  __typename?: 'LiquidityDepositChannel';
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `LiquidityDepositChannel`. */
  blockByIssuedBlockId: Block;
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['output'];
  depositAddress: Scalars['String']['output'];
  /** Reads a single `Event` that is related to this `LiquidityDepositChannel`. */
  eventByIssuedEventId: Event;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsByLiquidityDepositChannelId: FailedDepositsConnection;
  id: Scalars['Int']['output'];
  isExpired: Scalars['Boolean']['output'];
  issuedBlockId: Scalars['Int']['output'];
  issuedEventId: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByLiquidityDepositChannelId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  liquidityDepositsByLiquidityDepositChannelId: LiquidityDepositsConnection;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityDepositChannel`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  maxBoostFeeBps: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openingFeePaid: Scalars['BigFloat']['output'];
  sourceChainExpiryBlock: Scalars['BigInt']['output'];
};


export type LiquidityDepositChannelFailedDepositsByLiquidityDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type LiquidityDepositChannelLiquidityBalanceEventsByLiquidityDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type LiquidityDepositChannelLiquidityDepositsByLiquidityDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};

export type LiquidityDepositChannelAggregates = {
  __typename?: 'LiquidityDepositChannelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityDepositChannelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityDepositChannelDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityDepositChannelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityDepositChannelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityDepositChannelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityDepositChannelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityDepositChannelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityDepositChannelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityDepositChannelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityDepositChannel` object types. */
export type LiquidityDepositChannelAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityDepositChannel` objects. */
  average?: InputMaybe<LiquidityDepositChannelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityDepositChannel` objects. */
  distinctCount?: InputMaybe<LiquidityDepositChannelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityDepositChannel` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityDepositChannelFilter>;
  /** Maximum aggregate over matching `LiquidityDepositChannel` objects. */
  max?: InputMaybe<LiquidityDepositChannelMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityDepositChannel` objects. */
  min?: InputMaybe<LiquidityDepositChannelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityDepositChannel` objects. */
  stddevPopulation?: InputMaybe<LiquidityDepositChannelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityDepositChannel` objects. */
  stddevSample?: InputMaybe<LiquidityDepositChannelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityDepositChannel` objects. */
  sum?: InputMaybe<LiquidityDepositChannelSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityDepositChannel` objects. */
  variancePopulation?: InputMaybe<LiquidityDepositChannelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityDepositChannel` objects. */
  varianceSample?: InputMaybe<LiquidityDepositChannelVarianceSampleAggregateFilter>;
};

export type LiquidityDepositChannelAverageAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelAverageAggregates = {
  __typename?: 'LiquidityDepositChannelAverageAggregates';
  /** Mean average of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityDepositChannel` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type LiquidityDepositChannelCondition = {
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByIssuedBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<Scalars['String']['input']>;
  eventByIssuedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isExpired` field. */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sourceChainExpiryBlock` field. */
  sourceChainExpiryBlock?: InputMaybe<Scalars['BigInt']['input']>;
};

export type LiquidityDepositChannelDistinctCountAggregateFilter = {
  asset?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  depositAddress?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isExpired?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigIntFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
};

export type LiquidityDepositChannelDistinctCountAggregates = {
  __typename?: 'LiquidityDepositChannelDistinctCountAggregates';
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAddress across the matching connection */
  depositAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isExpired across the matching connection */
  isExpired?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositChannelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityDepositChannelFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByIssuedBlockId` relation. */
  blockByIssuedBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventByIssuedEventId` relation. */
  eventByIssuedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `failedDepositsByLiquidityDepositChannelId` relation. */
  failedDepositsByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelToManyFailedDepositFilter>;
  /** Some related `failedDepositsByLiquidityDepositChannelId` exist. */
  failedDepositsByLiquidityDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isExpired` field. */
  isExpired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `liquidityBalanceEventsByLiquidityDepositChannelId` relation. */
  liquidityBalanceEventsByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelToManyLiquidityBalanceEventFilter>;
  /** Some related `liquidityBalanceEventsByLiquidityDepositChannelId` exist. */
  liquidityBalanceEventsByLiquidityDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositsByLiquidityDepositChannelId` relation. */
  liquidityDepositsByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelToManyLiquidityDepositFilter>;
  /** Some related `liquidityDepositsByLiquidityDepositChannelId` exist. */
  liquidityDepositsByLiquidityDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityDepositChannelFilter>;
  /** Filter by the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityDepositChannelFilter>>;
  /** Filter by the object’s `sourceChainExpiryBlock` field. */
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
};

/** Grouping methods for `LiquidityDepositChannel` for usage during aggregation. */
export type LiquidityDepositChannelGroupBy =
  | 'ASSET'
  | 'CHAIN'
  | 'CHANNEL_ID'
  | 'DEPOSIT_ADDRESS'
  | 'ISSUED_BLOCK_ID'
  | 'ISSUED_EVENT_ID'
  | 'IS_EXPIRED'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'MAX_BOOST_FEE_BPS'
  | 'OPENING_FEE_PAID'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK';

export type LiquidityDepositChannelHavingAverageInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingDistinctCountInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `LiquidityDepositChannel` aggregates. */
export type LiquidityDepositChannelHavingInput = {
  AND?: InputMaybe<Array<LiquidityDepositChannelHavingInput>>;
  OR?: InputMaybe<Array<LiquidityDepositChannelHavingInput>>;
  average?: InputMaybe<LiquidityDepositChannelHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityDepositChannelHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityDepositChannelHavingMaxInput>;
  min?: InputMaybe<LiquidityDepositChannelHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityDepositChannelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityDepositChannelHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityDepositChannelHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityDepositChannelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityDepositChannelHavingVarianceSampleInput>;
};

export type LiquidityDepositChannelHavingMaxInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingMinInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingStddevPopulationInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingStddevSampleInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingSumInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingVariancePopulationInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelHavingVarianceSampleInput = {
  channelId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
};

export type LiquidityDepositChannelMaxAggregateFilter = {
  channelId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
};

export type LiquidityDepositChannelMaxAggregates = {
  __typename?: 'LiquidityDepositChannelMaxAggregates';
  /** Maximum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
};

export type LiquidityDepositChannelMinAggregateFilter = {
  channelId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
};

export type LiquidityDepositChannelMinAggregates = {
  __typename?: 'LiquidityDepositChannelMinAggregates';
  /** Minimum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
};

export type LiquidityDepositChannelStddevPopulationAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelStddevPopulationAggregates = {
  __typename?: 'LiquidityDepositChannelStddevPopulationAggregates';
  /** Population standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositChannelStddevSampleAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelStddevSampleAggregates = {
  __typename?: 'LiquidityDepositChannelStddevSampleAggregates';
  /** Sample standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositChannelSumAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelSumAggregates = {
  __typename?: 'LiquidityDepositChannelSumAggregates';
  /** Sum of channelId across the matching connection */
  channelId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of issuedBlockId across the matching connection */
  issuedBlockId: Scalars['BigInt']['output'];
  /** Sum of issuedEventId across the matching connection */
  issuedEventId: Scalars['BigFloat']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of openingFeePaid across the matching connection */
  openingFeePaid: Scalars['BigFloat']['output'];
  /** Sum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositChannelToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositChannelToManyLiquidityBalanceEventFilter = {
  /** Aggregates across related `LiquidityBalanceEvent` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityBalanceEventAggregatesFilter>;
  /** Every related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityBalanceEventFilter>;
  /** No related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Some related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityBalanceEventFilter>;
};

/** A filter to be used against many `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositChannelToManyLiquidityDepositFilter = {
  /** Aggregates across related `LiquidityDeposit` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositAggregatesFilter>;
  /** Every related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositFilter>;
  /** No related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositFilter>;
  /** Some related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositFilter>;
};

export type LiquidityDepositChannelVariancePopulationAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelVariancePopulationAggregates = {
  __typename?: 'LiquidityDepositChannelVariancePopulationAggregates';
  /** Population variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositChannelVarianceSampleAggregateFilter = {
  channelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositChannelVarianceSampleAggregates = {
  __typename?: 'LiquidityDepositChannelVarianceSampleAggregates';
  /** Sample variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityDepositChannel` values. */
export type LiquidityDepositChannelsConnection = {
  __typename?: 'LiquidityDepositChannelsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityDepositChannelAggregates>;
  /** A list of edges which contains the `LiquidityDepositChannel` and cursor to aid in pagination. */
  edges: Array<LiquidityDepositChannelsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityDepositChannelAggregates>>;
  /** A list of `LiquidityDepositChannel` objects. */
  nodes: Array<LiquidityDepositChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityDepositChannel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityDepositChannel` values. */
export type LiquidityDepositChannelsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityDepositChannelGroupBy>;
  having?: InputMaybe<LiquidityDepositChannelHavingInput>;
};

/** A `LiquidityDepositChannel` edge in the connection. */
export type LiquidityDepositChannelsEdge = {
  __typename?: 'LiquidityDepositChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityDepositChannel` at the end of the edge. */
  node: LiquidityDepositChannel;
};

/** Methods to use when ordering `LiquidityDepositChannel`. */
export type LiquidityDepositChannelsOrderBy =
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'CHANNEL_ID_ASC'
  | 'CHANNEL_ID_DESC'
  | 'DEPOSIT_ADDRESS_ASC'
  | 'DEPOSIT_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ISSUED_BLOCK_ID_ASC'
  | 'ISSUED_BLOCK_ID_DESC'
  | 'ISSUED_EVENT_ID_ASC'
  | 'ISSUED_EVENT_ID_DESC'
  | 'IS_EXPIRED_ASC'
  | 'IS_EXPIRED_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'MAX_BOOST_FEE_BPS_ASC'
  | 'MAX_BOOST_FEE_BPS_DESC'
  | 'NATURAL'
  | 'OPENING_FEE_PAID_ASC'
  | 'OPENING_FEE_PAID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK_DESC';

/**
 * A condition to be used against `LiquidityDeposit` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiquidityDepositCondition = {
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `depositValueUsd` field. */
  depositValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type LiquidityDepositDistinctCountAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  depositAmount?: InputMaybe<BigIntFilter>;
  depositValueUsd?: InputMaybe<BigIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type LiquidityDepositDistinctCountAggregates = {
  __typename?: 'LiquidityDepositDistinctCountAggregates';
  /** Distinct count of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositFilter = {
  /** Filter by the object’s `accountCreationDepositChannelByAccountCreationDepositChannelId` relation. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** A related `accountCreationDepositChannelByAccountCreationDepositChannelId` exists. */
  accountCreationDepositChannelByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityDepositFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `boostNetworkFeeSplitByBoostedLiquidityDepositId` relation. */
  boostNetworkFeeSplitByBoostedLiquidityDepositId?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** A related `boostNetworkFeeSplitByBoostedLiquidityDepositId` exists. */
  boostNetworkFeeSplitByBoostedLiquidityDepositIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `depositValueUsd` field. */
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityDepositChannelByLiquidityDepositChannelId` relation. */
  liquidityDepositChannelByLiquidityDepositChannelId?: InputMaybe<LiquidityDepositChannelFilter>;
  /** A related `liquidityDepositChannelByLiquidityDepositChannelId` exists. */
  liquidityDepositChannelByLiquidityDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelId` field. */
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityDepositFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityDepositFilter>>;
  /** Filter by the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `transactionRefsByLiquidityDepositId` relation. */
  transactionRefsByLiquidityDepositId?: InputMaybe<LiquidityDepositToManyTransactionRefFilter>;
  /** Some related `transactionRefsByLiquidityDepositId` exist. */
  transactionRefsByLiquidityDepositIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `LiquidityDeposit` for usage during aggregation. */
export type LiquidityDepositGroupBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID'
  | 'ASSET'
  | 'BLOCK_ID'
  | 'CHAIN'
  | 'DEPOSIT_AMOUNT'
  | 'DEPOSIT_VALUE_USD'
  | 'EFFECTIVE_BOOST_FEE_BPS'
  | 'EVENT_ID'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'PREWITNESSED_DEPOSIT_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type LiquidityDepositHavingAverageInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingDistinctCountInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `LiquidityDeposit` aggregates. */
export type LiquidityDepositHavingInput = {
  AND?: InputMaybe<Array<LiquidityDepositHavingInput>>;
  OR?: InputMaybe<Array<LiquidityDepositHavingInput>>;
  average?: InputMaybe<LiquidityDepositHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityDepositHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityDepositHavingMaxInput>;
  min?: InputMaybe<LiquidityDepositHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityDepositHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityDepositHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityDepositHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityDepositHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityDepositHavingVarianceSampleInput>;
};

export type LiquidityDepositHavingMaxInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingMinInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingStddevPopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingStddevSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingSumInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingVariancePopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositHavingVarianceSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositChannelId?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type LiquidityDepositMaxAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LiquidityDepositMaxAggregates = {
  __typename?: 'LiquidityDepositMaxAggregates';
  /** Maximum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LiquidityDepositMinAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityDepositChannelId?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type LiquidityDepositMinAggregates = {
  __typename?: 'LiquidityDepositMinAggregates';
  /** Minimum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type LiquidityDepositStddevPopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositStddevPopulationAggregates = {
  __typename?: 'LiquidityDepositStddevPopulationAggregates';
  /** Population standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositStddevSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositStddevSampleAggregates = {
  __typename?: 'LiquidityDepositStddevSampleAggregates';
  /** Sample standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositSumAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositChannelId?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositSumAggregates = {
  __typename?: 'LiquidityDepositSumAggregates';
  /** Sum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of depositAmount across the matching connection */
  depositAmount: Scalars['BigFloat']['output'];
  /** Sum of depositValueUsd across the matching connection */
  depositValueUsd: Scalars['BigFloat']['output'];
  /** Sum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `TransactionRef` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityDepositToManyTransactionRefFilter = {
  /** Aggregates across related `TransactionRef` match the filter criteria. */
  aggregates?: InputMaybe<TransactionRefAggregatesFilter>;
  /** Every related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TransactionRefFilter>;
  /** No related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TransactionRefFilter>;
  /** Some related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TransactionRefFilter>;
};

export type LiquidityDepositVariancePopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositVariancePopulationAggregates = {
  __typename?: 'LiquidityDepositVariancePopulationAggregates';
  /** Population variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityDepositVarianceSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositChannelId?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityDepositVarianceSampleAggregates = {
  __typename?: 'LiquidityDepositVarianceSampleAggregates';
  /** Sample variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityDepositChannelId across the matching connection */
  liquidityDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityDeposit` values. */
export type LiquidityDepositsConnection = {
  __typename?: 'LiquidityDepositsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityDepositAggregates>;
  /** A list of edges which contains the `LiquidityDeposit` and cursor to aid in pagination. */
  edges: Array<LiquidityDepositsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityDepositAggregates>>;
  /** A list of `LiquidityDeposit` objects. */
  nodes: Array<LiquidityDeposit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityDeposit` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityDeposit` values. */
export type LiquidityDepositsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityDepositGroupBy>;
  having?: InputMaybe<LiquidityDepositHavingInput>;
};

/** A `LiquidityDeposit` edge in the connection. */
export type LiquidityDepositsEdge = {
  __typename?: 'LiquidityDepositsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityDeposit` at the end of the edge. */
  node: LiquidityDeposit;
};

/** Methods to use when ordering `LiquidityDeposit`. */
export type LiquidityDepositsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'DEPOSIT_AMOUNT_ASC'
  | 'DEPOSIT_AMOUNT_DESC'
  | 'DEPOSIT_VALUE_USD_ASC'
  | 'DEPOSIT_VALUE_USD_DESC'
  | 'EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATURAL'
  | 'PREWITNESSED_DEPOSIT_ID_ASC'
  | 'PREWITNESSED_DEPOSIT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_COUNT_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_COUNT_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_REF_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_REF_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_LIQUIDITY_DEPOSIT_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC';

export type LiquidityProvider = Node & {
  __typename?: 'LiquidityProvider';
  /** Reads a single `Account` that is related to this `LiquidityProvider`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  arbitrumRefundAddress?: Maybe<Scalars['String']['output']>;
  assethubRefundAddress?: Maybe<Scalars['String']['output']>;
  bitcoinRefundAddress?: Maybe<Scalars['String']['output']>;
  bscRefundAddress?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `CollectedFee`. */
  collectedFeesByLiquidityProviderId: CollectedFeesConnection;
  ethereumRefundAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isTradingStrategy: Scalars['Boolean']['output'];
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  liquidityBalanceEventsByLiquidityProviderId: LiquidityBalanceEventsConnection;
  /** Reads and enables pagination through a set of `LiquidityDepositChannel`. */
  liquidityDepositChannelsByLiquidityProviderId: LiquidityDepositChannelsConnection;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  liquidityDepositsByLiquidityProviderId: LiquidityDepositsConnection;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityProvider`. */
  liquidityProviderByTradingStrategyOwnerId?: Maybe<LiquidityProvider>;
  /** Reads and enables pagination through a set of `LiquidityProvider`. */
  liquidityProvidersByTradingStrategyOwnerId: LiquidityProvidersConnection;
  /** Reads and enables pagination through a set of `LiquidityTransfer`. */
  liquidityTransfersByLiquidityProviderFromId: LiquidityTransfersConnection;
  /** Reads and enables pagination through a set of `LiquidityTransfer`. */
  liquidityTransfersByLiquidityProviderToId: LiquidityTransfersConnection;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  liquidityWithdrawalsByLiquidityProviderId: LiquidityWithdrawalsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  polkadotRefundAddress?: Maybe<Scalars['String']['output']>;
  /** Reads and enables pagination through a set of `PoolOrderEvent`. */
  poolOrderEventsByLiquidityProviderId: PoolOrderEventsConnection;
  /** Reads and enables pagination through a set of `RecentPoolOrderEvent`. */
  recentPoolOrderEventsByLiquidityProviderId: RecentPoolOrderEventsConnection;
  solanaRefundAddress?: Maybe<Scalars['String']['output']>;
  tradingStrategyOwnerId?: Maybe<Scalars['Int']['output']>;
  tronRefundAddress?: Maybe<Scalars['String']['output']>;
};


export type LiquidityProviderCollectedFeesByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CollectedFeeCondition>;
  filter?: InputMaybe<CollectedFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CollectedFeesOrderBy>>;
};


export type LiquidityProviderLiquidityBalanceEventsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


export type LiquidityProviderLiquidityDepositChannelsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositChannelCondition>;
  filter?: InputMaybe<LiquidityDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositChannelsOrderBy>>;
};


export type LiquidityProviderLiquidityDepositsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};


export type LiquidityProviderLiquidityProvidersByTradingStrategyOwnerIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderCondition>;
  filter?: InputMaybe<LiquidityProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProvidersOrderBy>>;
};


export type LiquidityProviderLiquidityTransfersByLiquidityProviderFromIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityTransferCondition>;
  filter?: InputMaybe<LiquidityTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityTransfersOrderBy>>;
};


export type LiquidityProviderLiquidityTransfersByLiquidityProviderToIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityTransferCondition>;
  filter?: InputMaybe<LiquidityTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityTransfersOrderBy>>;
};


export type LiquidityProviderLiquidityWithdrawalsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


export type LiquidityProviderPoolOrderEventsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderEventCondition>;
  filter?: InputMaybe<PoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrderEventsOrderBy>>;
};


export type LiquidityProviderRecentPoolOrderEventsByLiquidityProviderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RecentPoolOrderEventCondition>;
  filter?: InputMaybe<RecentPoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecentPoolOrderEventsOrderBy>>;
};

export type LiquidityProviderAggregates = {
  __typename?: 'LiquidityProviderAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityProviderAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityProviderDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityProviderMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityProviderMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityProviderStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityProviderStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityProviderSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityProviderVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityProviderVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityProvider` object types. */
export type LiquidityProviderAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityProvider` objects. */
  average?: InputMaybe<LiquidityProviderAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityProvider` objects. */
  distinctCount?: InputMaybe<LiquidityProviderDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityProvider` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityProviderFilter>;
  /** Maximum aggregate over matching `LiquidityProvider` objects. */
  max?: InputMaybe<LiquidityProviderMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityProvider` objects. */
  min?: InputMaybe<LiquidityProviderMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityProvider` objects. */
  stddevPopulation?: InputMaybe<LiquidityProviderStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityProvider` objects. */
  stddevSample?: InputMaybe<LiquidityProviderStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityProvider` objects. */
  sum?: InputMaybe<LiquidityProviderSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityProvider` objects. */
  variancePopulation?: InputMaybe<LiquidityProviderVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityProvider` objects. */
  varianceSample?: InputMaybe<LiquidityProviderVarianceSampleAggregateFilter>;
};

export type LiquidityProviderAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderAverageAggregates = {
  __typename?: 'LiquidityProviderAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityProvider` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiquidityProviderCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `arbitrumRefundAddress` field. */
  arbitrumRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `assethubRefundAddress` field. */
  assethubRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bitcoinRefundAddress` field. */
  bitcoinRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `bscRefundAddress` field. */
  bscRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ethereumRefundAddress` field. */
  ethereumRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isTradingStrategy` field. */
  isTradingStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  liquidityProviderByTradingStrategyOwnerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `polkadotRefundAddress` field. */
  polkadotRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `solanaRefundAddress` field. */
  solanaRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tradingStrategyOwnerId` field. */
  tradingStrategyOwnerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tronRefundAddress` field. */
  tronRefundAddress?: InputMaybe<Scalars['String']['input']>;
};

export type LiquidityProviderDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  arbitrumRefundAddress?: InputMaybe<BigIntFilter>;
  assethubRefundAddress?: InputMaybe<BigIntFilter>;
  bitcoinRefundAddress?: InputMaybe<BigIntFilter>;
  bscRefundAddress?: InputMaybe<BigIntFilter>;
  ethereumRefundAddress?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isTradingStrategy?: InputMaybe<BigIntFilter>;
  polkadotRefundAddress?: InputMaybe<BigIntFilter>;
  solanaRefundAddress?: InputMaybe<BigIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigIntFilter>;
  tronRefundAddress?: InputMaybe<BigIntFilter>;
};

export type LiquidityProviderDistinctCountAggregates = {
  __typename?: 'LiquidityProviderDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of arbitrumRefundAddress across the matching connection */
  arbitrumRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assethubRefundAddress across the matching connection */
  assethubRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bitcoinRefundAddress across the matching connection */
  bitcoinRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of bscRefundAddress across the matching connection */
  bscRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ethereumRefundAddress across the matching connection */
  ethereumRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isTradingStrategy across the matching connection */
  isTradingStrategy?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of polkadotRefundAddress across the matching connection */
  polkadotRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of solanaRefundAddress across the matching connection */
  solanaRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of tronRefundAddress across the matching connection */
  tronRefundAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityProvider` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityProviderFilter>>;
  /** Filter by the object’s `arbitrumRefundAddress` field. */
  arbitrumRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `assethubRefundAddress` field. */
  assethubRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bitcoinRefundAddress` field. */
  bitcoinRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `bscRefundAddress` field. */
  bscRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `collectedFeesByLiquidityProviderId` relation. */
  collectedFeesByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyCollectedFeeFilter>;
  /** Some related `collectedFeesByLiquidityProviderId` exist. */
  collectedFeesByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ethereumRefundAddress` field. */
  ethereumRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isTradingStrategy` field. */
  isTradingStrategy?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `liquidityBalanceEventsByLiquidityProviderId` relation. */
  liquidityBalanceEventsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyLiquidityBalanceEventFilter>;
  /** Some related `liquidityBalanceEventsByLiquidityProviderId` exist. */
  liquidityBalanceEventsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositChannelsByLiquidityProviderId` relation. */
  liquidityDepositChannelsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyLiquidityDepositChannelFilter>;
  /** Some related `liquidityDepositChannelsByLiquidityProviderId` exist. */
  liquidityDepositChannelsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositsByLiquidityProviderId` relation. */
  liquidityDepositsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyLiquidityDepositFilter>;
  /** Some related `liquidityDepositsByLiquidityProviderId` exist. */
  liquidityDepositsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityProviderByTradingStrategyOwnerId` relation. */
  liquidityProviderByTradingStrategyOwnerId?: InputMaybe<LiquidityProviderFilter>;
  /** A related `liquidityProviderByTradingStrategyOwnerId` exists. */
  liquidityProviderByTradingStrategyOwnerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityProvidersByTradingStrategyOwnerId` relation. */
  liquidityProvidersByTradingStrategyOwnerId?: InputMaybe<LiquidityProviderToManyLiquidityProviderFilter>;
  /** Some related `liquidityProvidersByTradingStrategyOwnerId` exist. */
  liquidityProvidersByTradingStrategyOwnerIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityTransfersByLiquidityProviderFromId` relation. */
  liquidityTransfersByLiquidityProviderFromId?: InputMaybe<LiquidityProviderToManyLiquidityTransferFilter>;
  /** Some related `liquidityTransfersByLiquidityProviderFromId` exist. */
  liquidityTransfersByLiquidityProviderFromIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityTransfersByLiquidityProviderToId` relation. */
  liquidityTransfersByLiquidityProviderToId?: InputMaybe<LiquidityProviderToManyLiquidityTransferFilter>;
  /** Some related `liquidityTransfersByLiquidityProviderToId` exist. */
  liquidityTransfersByLiquidityProviderToIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityWithdrawalsByLiquidityProviderId` relation. */
  liquidityWithdrawalsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyLiquidityWithdrawalFilter>;
  /** Some related `liquidityWithdrawalsByLiquidityProviderId` exist. */
  liquidityWithdrawalsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityProviderFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityProviderFilter>>;
  /** Filter by the object’s `polkadotRefundAddress` field. */
  polkadotRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `poolOrderEventsByLiquidityProviderId` relation. */
  poolOrderEventsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyPoolOrderEventFilter>;
  /** Some related `poolOrderEventsByLiquidityProviderId` exist. */
  poolOrderEventsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `recentPoolOrderEventsByLiquidityProviderId` relation. */
  recentPoolOrderEventsByLiquidityProviderId?: InputMaybe<LiquidityProviderToManyRecentPoolOrderEventFilter>;
  /** Some related `recentPoolOrderEventsByLiquidityProviderId` exist. */
  recentPoolOrderEventsByLiquidityProviderIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `solanaRefundAddress` field. */
  solanaRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tradingStrategyOwnerId` field. */
  tradingStrategyOwnerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tronRefundAddress` field. */
  tronRefundAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `LiquidityProvider` for usage during aggregation. */
export type LiquidityProviderGroupBy =
  | 'ARBITRUM_REFUND_ADDRESS'
  | 'ASSETHUB_REFUND_ADDRESS'
  | 'BITCOIN_REFUND_ADDRESS'
  | 'BSC_REFUND_ADDRESS'
  | 'ETHEREUM_REFUND_ADDRESS'
  | 'IS_TRADING_STRATEGY'
  | 'POLKADOT_REFUND_ADDRESS'
  | 'SOLANA_REFUND_ADDRESS'
  | 'TRADING_STRATEGY_OWNER_ID'
  | 'TRON_REFUND_ADDRESS';

export type LiquidityProviderHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LiquidityProvider` aggregates. */
export type LiquidityProviderHavingInput = {
  AND?: InputMaybe<Array<LiquidityProviderHavingInput>>;
  OR?: InputMaybe<Array<LiquidityProviderHavingInput>>;
  average?: InputMaybe<LiquidityProviderHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityProviderHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityProviderHavingMaxInput>;
  min?: InputMaybe<LiquidityProviderHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityProviderHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityProviderHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityProviderHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityProviderHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityProviderHavingVarianceSampleInput>;
};

export type LiquidityProviderHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<HavingIntFilter>;
};

export type LiquidityProviderMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  tradingStrategyOwnerId?: InputMaybe<IntFilter>;
};

export type LiquidityProviderMaxAggregates = {
  __typename?: 'LiquidityProviderMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidityProviderMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  tradingStrategyOwnerId?: InputMaybe<IntFilter>;
};

export type LiquidityProviderMinAggregates = {
  __typename?: 'LiquidityProviderMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['Int']['output']>;
};

export type LiquidityProviderStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderStddevPopulationAggregates = {
  __typename?: 'LiquidityProviderStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderStddevSampleAggregates = {
  __typename?: 'LiquidityProviderStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigIntFilter>;
};

export type LiquidityProviderSumAggregates = {
  __typename?: 'LiquidityProviderSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `CollectedFee` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyCollectedFeeFilter = {
  /** Aggregates across related `CollectedFee` match the filter criteria. */
  aggregates?: InputMaybe<CollectedFeeAggregatesFilter>;
  /** Every related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<CollectedFeeFilter>;
  /** No related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<CollectedFeeFilter>;
  /** Some related `CollectedFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<CollectedFeeFilter>;
};

/** A filter to be used against many `LiquidityBalanceEvent` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityBalanceEventFilter = {
  /** Aggregates across related `LiquidityBalanceEvent` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityBalanceEventAggregatesFilter>;
  /** Every related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityBalanceEventFilter>;
  /** No related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Some related `LiquidityBalanceEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityBalanceEventFilter>;
};

/** A filter to be used against many `LiquidityDepositChannel` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityDepositChannelFilter = {
  /** Aggregates across related `LiquidityDepositChannel` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositChannelAggregatesFilter>;
  /** Every related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositChannelFilter>;
  /** No related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositChannelFilter>;
  /** Some related `LiquidityDepositChannel` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositChannelFilter>;
};

/** A filter to be used against many `LiquidityDeposit` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityDepositFilter = {
  /** Aggregates across related `LiquidityDeposit` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityDepositAggregatesFilter>;
  /** Every related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityDepositFilter>;
  /** No related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityDepositFilter>;
  /** Some related `LiquidityDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityDepositFilter>;
};

/** A filter to be used against many `LiquidityProvider` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityProviderFilter = {
  /** Aggregates across related `LiquidityProvider` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityProviderAggregatesFilter>;
  /** Every related `LiquidityProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityProviderFilter>;
  /** No related `LiquidityProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityProviderFilter>;
  /** Some related `LiquidityProvider` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityProviderFilter>;
};

/** A filter to be used against many `LiquidityTransfer` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityTransferFilter = {
  /** Aggregates across related `LiquidityTransfer` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityTransferAggregatesFilter>;
  /** Every related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityTransferFilter>;
  /** No related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityTransferFilter>;
  /** Some related `LiquidityTransfer` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityTransferFilter>;
};

/** A filter to be used against many `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyLiquidityWithdrawalFilter = {
  /** Aggregates across related `LiquidityWithdrawal` match the filter criteria. */
  aggregates?: InputMaybe<LiquidityWithdrawalAggregatesFilter>;
  /** Every related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LiquidityWithdrawalFilter>;
  /** No related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Some related `LiquidityWithdrawal` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LiquidityWithdrawalFilter>;
};

/** A filter to be used against many `PoolOrderEvent` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyPoolOrderEventFilter = {
  /** Aggregates across related `PoolOrderEvent` match the filter criteria. */
  aggregates?: InputMaybe<PoolOrderEventAggregatesFilter>;
  /** Every related `PoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PoolOrderEventFilter>;
  /** No related `PoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PoolOrderEventFilter>;
  /** Some related `PoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PoolOrderEventFilter>;
};

/** A filter to be used against many `RecentPoolOrderEvent` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityProviderToManyRecentPoolOrderEventFilter = {
  /** Aggregates across related `RecentPoolOrderEvent` match the filter criteria. */
  aggregates?: InputMaybe<RecentPoolOrderEventAggregatesFilter>;
  /** Every related `RecentPoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RecentPoolOrderEventFilter>;
  /** No related `RecentPoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RecentPoolOrderEventFilter>;
  /** Some related `RecentPoolOrderEvent` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RecentPoolOrderEventFilter>;
};

export type LiquidityProviderVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderVariancePopulationAggregates = {
  __typename?: 'LiquidityProviderVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityProviderVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  tradingStrategyOwnerId?: InputMaybe<BigFloatFilter>;
};

export type LiquidityProviderVarianceSampleAggregates = {
  __typename?: 'LiquidityProviderVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of tradingStrategyOwnerId across the matching connection */
  tradingStrategyOwnerId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityProvider` values. */
export type LiquidityProvidersConnection = {
  __typename?: 'LiquidityProvidersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityProviderAggregates>;
  /** A list of edges which contains the `LiquidityProvider` and cursor to aid in pagination. */
  edges: Array<LiquidityProvidersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityProviderAggregates>>;
  /** A list of `LiquidityProvider` objects. */
  nodes: Array<LiquidityProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityProvider` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityProvider` values. */
export type LiquidityProvidersConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityProviderGroupBy>;
  having?: InputMaybe<LiquidityProviderHavingInput>;
};

/** A `LiquidityProvider` edge in the connection. */
export type LiquidityProvidersEdge = {
  __typename?: 'LiquidityProvidersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityProvider` at the end of the edge. */
  node: LiquidityProvider;
};

/** Methods to use when ordering `LiquidityProvider`. */
export type LiquidityProvidersOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'ARBITRUM_REFUND_ADDRESS_ASC'
  | 'ARBITRUM_REFUND_ADDRESS_DESC'
  | 'ASSETHUB_REFUND_ADDRESS_ASC'
  | 'ASSETHUB_REFUND_ADDRESS_DESC'
  | 'BITCOIN_REFUND_ADDRESS_ASC'
  | 'BITCOIN_REFUND_ADDRESS_DESC'
  | 'BSC_REFUND_ADDRESS_ASC'
  | 'BSC_REFUND_ADDRESS_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'COLLECTED_FEES_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'ETHEREUM_REFUND_ADDRESS_ASC'
  | 'ETHEREUM_REFUND_ADDRESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_TRADING_STRATEGY_ASC'
  | 'IS_TRADING_STRATEGY_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TX_REF_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TX_REF_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_BALANCE_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSITS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_DEPOSIT_ADDRESS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_EXPIRED_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_IS_EXPIRED_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MAX_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_MIN_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_SUM_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CHANNEL_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_CHANNEL_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_BLOCK_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ISSUED_EVENT_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_OPENING_FEE_PAID_DESC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'LIQUIDITY_DEPOSIT_CHANNELS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_AVERAGE_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_COUNT_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_COUNT_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ARBITRUM_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ARBITRUM_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ASSETHUB_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ASSETHUB_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_BITCOIN_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_BITCOIN_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_BSC_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_BSC_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ETHEREUM_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ETHEREUM_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_IS_TRADING_STRATEGY_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_IS_TRADING_STRATEGY_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_POLKADOT_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_POLKADOT_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_SOLANA_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_SOLANA_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_TRON_REFUND_ADDRESS_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_DISTINCT_COUNT_TRON_REFUND_ADDRESS_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MAX_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_MIN_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_POPULATION_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_STDDEV_SAMPLE_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_SUM_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_POPULATION_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_OWNER_ID_ASC'
  | 'LIQUIDITY_PROVIDERS_BY_TRADING_STRATEGY_OWNER_ID_VARIANCE_SAMPLE_TRADING_STRATEGY_OWNER_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_COUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_COUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_FROM_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_COUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_COUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_TIMESTAMP_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_TIMESTAMP_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_TRANSFERS_BY_LIQUIDITY_PROVIDER_TO_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_CHAIN_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_WITHDRAWAL_ADDRESS_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MAX_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_MIN_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_SUM_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_FEE_USD_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_NATIVE_EGRESS_ID_DESC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'LIQUIDITY_WITHDRAWALS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NATURAL'
  | 'POLKADOT_REFUND_ADDRESS_ASC'
  | 'POLKADOT_REFUND_ADDRESS_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_TYPE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_TYPE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_VALUE_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAXIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAXIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MINIMUM_RATE_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MINIMUM_RATE_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_VALUE_USD_ASC'
  | 'POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_AVERAGE_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_COUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_ASSET_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_TYPE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_EVENT_TYPE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_ORDER_TYPE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MAX_TIMESTAMP_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_MIN_TIMESTAMP_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_POPULATION_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_STDDEV_SAMPLE_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_SUM_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_POPULATION_QUOTE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_BASE_VALUE_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_LIQUIDITY_PROVIDER_ID_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAXIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MAXIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MINIMUM_RATE_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_MINIMUM_RATE_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_AMOUNT_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_COLLECTED_FEES_USD_DESC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_VALUE_USD_ASC'
  | 'RECENT_POOL_ORDER_EVENTS_BY_LIQUIDITY_PROVIDER_ID_VARIANCE_SAMPLE_QUOTE_VALUE_USD_DESC'
  | 'SOLANA_REFUND_ADDRESS_ASC'
  | 'SOLANA_REFUND_ADDRESS_DESC'
  | 'TRADING_STRATEGY_OWNER_ID_ASC'
  | 'TRADING_STRATEGY_OWNER_ID_DESC'
  | 'TRON_REFUND_ADDRESS_ASC'
  | 'TRON_REFUND_ADDRESS_DESC';

export type LiquidityTransfer = Node & {
  __typename?: 'LiquidityTransfer';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `LiquidityTransfer`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  chain: ChainflipChain;
  /** Reads a single `Event` that is related to this `LiquidityTransfer`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityTransfer`. */
  liquidityProviderByLiquidityProviderFromId: LiquidityProvider;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityTransfer`. */
  liquidityProviderByLiquidityProviderToId: LiquidityProvider;
  liquidityProviderFromId: Scalars['Int']['output'];
  liquidityProviderToId: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  timestamp: Scalars['Datetime']['output'];
  type: LiquidityTransferType;
  valueUsd: Scalars['BigFloat']['output'];
};

export type LiquidityTransferAggregates = {
  __typename?: 'LiquidityTransferAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityTransferAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityTransferDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityTransferMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityTransferMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityTransferStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityTransferStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityTransferSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityTransferVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityTransferVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityTransfer` object types. */
export type LiquidityTransferAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityTransfer` objects. */
  average?: InputMaybe<LiquidityTransferAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityTransfer` objects. */
  distinctCount?: InputMaybe<LiquidityTransferDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityTransfer` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityTransferFilter>;
  /** Maximum aggregate over matching `LiquidityTransfer` objects. */
  max?: InputMaybe<LiquidityTransferMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityTransfer` objects. */
  min?: InputMaybe<LiquidityTransferMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityTransfer` objects. */
  stddevPopulation?: InputMaybe<LiquidityTransferStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityTransfer` objects. */
  stddevSample?: InputMaybe<LiquidityTransferStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityTransfer` objects. */
  sum?: InputMaybe<LiquidityTransferSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityTransfer` objects. */
  variancePopulation?: InputMaybe<LiquidityTransferVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityTransfer` objects. */
  varianceSample?: InputMaybe<LiquidityTransferVarianceSampleAggregateFilter>;
};

export type LiquidityTransferAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFromId?: InputMaybe<BigFloatFilter>;
  liquidityProviderToId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferAverageAggregates = {
  __typename?: 'LiquidityTransferAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityTransfer` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LiquidityTransferCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderFromId?: InputMaybe<Scalars['ID']['input']>;
  liquidityProviderByLiquidityProviderToId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderFromId` field. */
  liquidityProviderFromId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityProviderToId` field. */
  liquidityProviderToId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<LiquidityTransferType>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type LiquidityTransferDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFromId?: InputMaybe<BigIntFilter>;
  liquidityProviderToId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type LiquidityTransferDistinctCountAggregates = {
  __typename?: 'LiquidityTransferDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityTransfer` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityTransferFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityTransferFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderFromId` relation. */
  liquidityProviderByLiquidityProviderFromId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderToId` relation. */
  liquidityProviderByLiquidityProviderToId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderFromId` field. */
  liquidityProviderFromId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderToId` field. */
  liquidityProviderToId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityTransferFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityTransferFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<LiquidityTransferTypeFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `LiquidityTransfer` for usage during aggregation. */
export type LiquidityTransferGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BLOCK_ID'
  | 'CHAIN'
  | 'EVENT_ID'
  | 'LIQUIDITY_PROVIDER_FROM_ID'
  | 'LIQUIDITY_PROVIDER_TO_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TYPE'
  | 'VALUE_USD';

export type LiquidityTransferHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LiquidityTransfer` aggregates. */
export type LiquidityTransferHavingInput = {
  AND?: InputMaybe<Array<LiquidityTransferHavingInput>>;
  OR?: InputMaybe<Array<LiquidityTransferHavingInput>>;
  average?: InputMaybe<LiquidityTransferHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityTransferHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityTransferHavingMaxInput>;
  min?: InputMaybe<LiquidityTransferHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityTransferHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityTransferHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityTransferHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityTransferHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityTransferHavingVarianceSampleInput>;
};

export type LiquidityTransferHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderFromId?: InputMaybe<HavingIntFilter>;
  liquidityProviderToId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityTransferMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderFromId?: InputMaybe<IntFilter>;
  liquidityProviderToId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferMaxAggregates = {
  __typename?: 'LiquidityTransferMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityTransferMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderFromId?: InputMaybe<IntFilter>;
  liquidityProviderToId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferMinAggregates = {
  __typename?: 'LiquidityTransferMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityTransferStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFromId?: InputMaybe<BigFloatFilter>;
  liquidityProviderToId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferStddevPopulationAggregates = {
  __typename?: 'LiquidityTransferStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityTransferStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFromId?: InputMaybe<BigFloatFilter>;
  liquidityProviderToId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferStddevSampleAggregates = {
  __typename?: 'LiquidityTransferStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityTransferSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderFromId?: InputMaybe<BigIntFilter>;
  liquidityProviderToId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferSumAggregates = {
  __typename?: 'LiquidityTransferSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderToId across the matching connection */
  liquidityProviderToId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type LiquidityTransferType =
  | 'ASSET_BALANCE_TO_ASSET_BALANCE'
  | 'ASSET_BALANCE_TO_NETWORK_BALANCE';

/** A filter to be used against LiquidityTransferType fields. All fields are combined with a logical ‘and.’ */
export type LiquidityTransferTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<LiquidityTransferType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<LiquidityTransferType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<LiquidityTransferType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<LiquidityTransferType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<LiquidityTransferType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<LiquidityTransferType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<LiquidityTransferType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<LiquidityTransferType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<LiquidityTransferType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<LiquidityTransferType>>;
};

export type LiquidityTransferVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFromId?: InputMaybe<BigFloatFilter>;
  liquidityProviderToId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferVariancePopulationAggregates = {
  __typename?: 'LiquidityTransferVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityTransferVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderFromId?: InputMaybe<BigFloatFilter>;
  liquidityProviderToId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityTransferVarianceSampleAggregates = {
  __typename?: 'LiquidityTransferVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderFromId across the matching connection */
  liquidityProviderFromId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderToId across the matching connection */
  liquidityProviderToId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityTransfer` values. */
export type LiquidityTransfersConnection = {
  __typename?: 'LiquidityTransfersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityTransferAggregates>;
  /** A list of edges which contains the `LiquidityTransfer` and cursor to aid in pagination. */
  edges: Array<LiquidityTransfersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityTransferAggregates>>;
  /** A list of `LiquidityTransfer` objects. */
  nodes: Array<LiquidityTransfer>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityTransfer` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityTransfer` values. */
export type LiquidityTransfersConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityTransferGroupBy>;
  having?: InputMaybe<LiquidityTransferHavingInput>;
};

/** A `LiquidityTransfer` edge in the connection. */
export type LiquidityTransfersEdge = {
  __typename?: 'LiquidityTransfersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityTransfer` at the end of the edge. */
  node: LiquidityTransfer;
};

/** Methods to use when ordering `LiquidityTransfer`. */
export type LiquidityTransfersOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_FROM_ID_ASC'
  | 'LIQUIDITY_PROVIDER_FROM_ID_DESC'
  | 'LIQUIDITY_PROVIDER_TO_ID_ASC'
  | 'LIQUIDITY_PROVIDER_TO_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type LiquidityWithdrawal = Node & {
  __typename?: 'LiquidityWithdrawal';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  /** Reads a single `Block` that is related to this `LiquidityWithdrawal`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `Broadcast` that is related to this `LiquidityWithdrawal`. */
  broadcastByBroadcastId?: Maybe<Broadcast>;
  broadcastId?: Maybe<Scalars['Int']['output']>;
  chain: ChainflipChain;
  /** Reads a single `Egress` that is related to this `LiquidityWithdrawal`. */
  egressByEgressId: Egress;
  egressId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `LiquidityWithdrawal`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  fee: Scalars['BigFloat']['output'];
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityBalanceEvent` that is related to this `LiquidityWithdrawal`. */
  liquidityBalanceEventByEventId: LiquidityBalanceEvent;
  /** Reads a single `LiquidityProvider` that is related to this `LiquidityWithdrawal`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  nativeEgressId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  valueUsd: Scalars['BigFloat']['output'];
  withdrawalAddress: Scalars['String']['output'];
};

export type LiquidityWithdrawalAggregates = {
  __typename?: 'LiquidityWithdrawalAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LiquidityWithdrawalAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LiquidityWithdrawalDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LiquidityWithdrawalMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LiquidityWithdrawalMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LiquidityWithdrawalStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LiquidityWithdrawalStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LiquidityWithdrawalSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LiquidityWithdrawalVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LiquidityWithdrawalVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LiquidityWithdrawal` object types. */
export type LiquidityWithdrawalAggregatesFilter = {
  /** Mean average aggregate over matching `LiquidityWithdrawal` objects. */
  average?: InputMaybe<LiquidityWithdrawalAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LiquidityWithdrawal` objects. */
  distinctCount?: InputMaybe<LiquidityWithdrawalDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LiquidityWithdrawal` object to be included within the aggregate. */
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Maximum aggregate over matching `LiquidityWithdrawal` objects. */
  max?: InputMaybe<LiquidityWithdrawalMaxAggregateFilter>;
  /** Minimum aggregate over matching `LiquidityWithdrawal` objects. */
  min?: InputMaybe<LiquidityWithdrawalMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LiquidityWithdrawal` objects. */
  stddevPopulation?: InputMaybe<LiquidityWithdrawalStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LiquidityWithdrawal` objects. */
  stddevSample?: InputMaybe<LiquidityWithdrawalStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LiquidityWithdrawal` objects. */
  sum?: InputMaybe<LiquidityWithdrawalSumAggregateFilter>;
  /** Population variance aggregate over matching `LiquidityWithdrawal` objects. */
  variancePopulation?: InputMaybe<LiquidityWithdrawalVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LiquidityWithdrawal` objects. */
  varianceSample?: InputMaybe<LiquidityWithdrawalVarianceSampleAggregateFilter>;
};

export type LiquidityWithdrawalAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalAverageAggregates = {
  __typename?: 'LiquidityWithdrawalAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `LiquidityWithdrawal` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type LiquidityWithdrawalCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  broadcastByBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChain>;
  egressByEgressId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `egressId` field. */
  egressId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `fee` field. */
  fee?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nativeEgressId` field. */
  nativeEgressId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<Scalars['String']['input']>;
};

export type LiquidityWithdrawalDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  chain?: InputMaybe<BigIntFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigIntFilter>;
  feeUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  nativeEgressId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
  withdrawalAddress?: InputMaybe<BigIntFilter>;
};

export type LiquidityWithdrawalDistinctCountAggregates = {
  __typename?: 'LiquidityWithdrawalDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of chain across the matching connection */
  chain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fee across the matching connection */
  fee?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of withdrawalAddress across the matching connection */
  withdrawalAddress?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `LiquidityWithdrawal` object types. All fields are combined with a logical ‘and.’ */
export type LiquidityWithdrawalFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LiquidityWithdrawalFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `broadcastByBroadcastId` relation. */
  broadcastByBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByBroadcastId` exists. */
  broadcastByBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `chain` field. */
  chain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `egressByEgressId` relation. */
  egressByEgressId?: InputMaybe<EgressFilter>;
  /** Filter by the object’s `egressId` field. */
  egressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `fee` field. */
  fee?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `feeUsd` field. */
  feeUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityBalanceEventByEventId` relation. */
  liquidityBalanceEventByEventId?: InputMaybe<LiquidityBalanceEventFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nativeEgressId` field. */
  nativeEgressId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LiquidityWithdrawalFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LiquidityWithdrawalFilter>>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `withdrawalAddress` field. */
  withdrawalAddress?: InputMaybe<StringFilter>;
};

/** Grouping methods for `LiquidityWithdrawal` for usage during aggregation. */
export type LiquidityWithdrawalGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BLOCK_ID'
  | 'BROADCAST_ID'
  | 'CHAIN'
  | 'EVENT_ID'
  | 'FEE'
  | 'FEE_USD'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'NATIVE_EGRESS_ID'
  | 'VALUE_USD'
  | 'WITHDRAWAL_ADDRESS';

export type LiquidityWithdrawalHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `LiquidityWithdrawal` aggregates. */
export type LiquidityWithdrawalHavingInput = {
  AND?: InputMaybe<Array<LiquidityWithdrawalHavingInput>>;
  OR?: InputMaybe<Array<LiquidityWithdrawalHavingInput>>;
  average?: InputMaybe<LiquidityWithdrawalHavingAverageInput>;
  distinctCount?: InputMaybe<LiquidityWithdrawalHavingDistinctCountInput>;
  max?: InputMaybe<LiquidityWithdrawalHavingMaxInput>;
  min?: InputMaybe<LiquidityWithdrawalHavingMinInput>;
  stddevPopulation?: InputMaybe<LiquidityWithdrawalHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LiquidityWithdrawalHavingStddevSampleInput>;
  sum?: InputMaybe<LiquidityWithdrawalHavingSumInput>;
  variancePopulation?: InputMaybe<LiquidityWithdrawalHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LiquidityWithdrawalHavingVarianceSampleInput>;
};

export type LiquidityWithdrawalHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  broadcastId?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  fee?: InputMaybe<HavingBigfloatFilter>;
  feeUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  nativeEgressId?: InputMaybe<HavingBigintFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type LiquidityWithdrawalMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  egressId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  nativeEgressId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalMaxAggregates = {
  __typename?: 'LiquidityWithdrawalMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of egressId across the matching connection */
  egressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityWithdrawalMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<IntFilter>;
  broadcastId?: InputMaybe<IntFilter>;
  egressId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  nativeEgressId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalMinAggregates = {
  __typename?: 'LiquidityWithdrawalMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of egressId across the matching connection */
  egressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityWithdrawalStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalStddevPopulationAggregates = {
  __typename?: 'LiquidityWithdrawalStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityWithdrawalStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalStddevSampleAggregates = {
  __typename?: 'LiquidityWithdrawalStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityWithdrawalSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  broadcastId?: InputMaybe<BigIntFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalSumAggregates = {
  __typename?: 'LiquidityWithdrawalSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of broadcastId across the matching connection */
  broadcastId: Scalars['BigInt']['output'];
  /** Sum of egressId across the matching connection */
  egressId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of fee across the matching connection */
  fee: Scalars['BigFloat']['output'];
  /** Sum of feeUsd across the matching connection */
  feeUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of nativeEgressId across the matching connection */
  nativeEgressId: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type LiquidityWithdrawalVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalVariancePopulationAggregates = {
  __typename?: 'LiquidityWithdrawalVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type LiquidityWithdrawalVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  broadcastId?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  fee?: InputMaybe<BigFloatFilter>;
  feeUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  nativeEgressId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type LiquidityWithdrawalVarianceSampleAggregates = {
  __typename?: 'LiquidityWithdrawalVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fee across the matching connection */
  fee?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of feeUsd across the matching connection */
  feeUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nativeEgressId across the matching connection */
  nativeEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `LiquidityWithdrawal` values. */
export type LiquidityWithdrawalsConnection = {
  __typename?: 'LiquidityWithdrawalsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LiquidityWithdrawalAggregates>;
  /** A list of edges which contains the `LiquidityWithdrawal` and cursor to aid in pagination. */
  edges: Array<LiquidityWithdrawalsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LiquidityWithdrawalAggregates>>;
  /** A list of `LiquidityWithdrawal` objects. */
  nodes: Array<LiquidityWithdrawal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LiquidityWithdrawal` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `LiquidityWithdrawal` values. */
export type LiquidityWithdrawalsConnectionGroupedAggregatesArgs = {
  groupBy: Array<LiquidityWithdrawalGroupBy>;
  having?: InputMaybe<LiquidityWithdrawalHavingInput>;
};

/** A `LiquidityWithdrawal` edge in the connection. */
export type LiquidityWithdrawalsEdge = {
  __typename?: 'LiquidityWithdrawalsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `LiquidityWithdrawal` at the end of the edge. */
  node: LiquidityWithdrawal;
};

/** Methods to use when ordering `LiquidityWithdrawal`. */
export type LiquidityWithdrawalsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'BROADCAST_ID_ASC'
  | 'BROADCAST_ID_DESC'
  | 'CHAIN_ASC'
  | 'CHAIN_DESC'
  | 'EGRESS_ID_ASC'
  | 'EGRESS_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'FEE_ASC'
  | 'FEE_DESC'
  | 'FEE_USD_ASC'
  | 'FEE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'NATIVE_EGRESS_ID_ASC'
  | 'NATIVE_EGRESS_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC'
  | 'WITHDRAWAL_ADDRESS_ASC'
  | 'WITHDRAWAL_ADDRESS_DESC';

export type MarketData = {
  __typename?: 'MarketData';
  candlesticks: Array<CandlestickResult>;
  globalVolume?: Maybe<Scalars['Float']['output']>;
  prices: Array<LineData>;
  volumes: Array<VolumeResult>;
};

/** A connection to a list of `Metadatum` values. */
export type MetadataConnection = {
  __typename?: 'MetadataConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MetadatumAggregates>;
  /** A list of edges which contains the `Metadatum` and cursor to aid in pagination. */
  edges: Array<MetadataEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MetadatumAggregates>>;
  /** A list of `Metadatum` objects. */
  nodes: Array<Metadatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Metadatum` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Metadatum` values. */
export type MetadataConnectionGroupedAggregatesArgs = {
  groupBy: Array<MetadatumGroupBy>;
  having?: InputMaybe<MetadatumHavingInput>;
};

/** A `Metadatum` edge in the connection. */
export type MetadataEdge = {
  __typename?: 'MetadataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Metadatum` at the end of the edge. */
  node: Metadatum;
};

/** Methods to use when ordering `Metadatum`. */
export type MetadataOrderBy =
  | 'CHAINSPEC_ASC'
  | 'CHAINSPEC_DESC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_AVERAGE_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_COUNT_ASC'
  | 'EVENTS_BY_METADATA_ID_COUNT_DESC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_DISTINCT_COUNT_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MAX_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MAX_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MAX_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MAX_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MAX_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_MAX_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_MAX_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MAX_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MIN_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MIN_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MIN_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MIN_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_MIN_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_MIN_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_MIN_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_MIN_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_POPULATION_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_STDDEV_SAMPLE_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_SUM_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_SUM_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_SUM_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_SUM_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_SUM_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_SUM_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_SUM_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_SUM_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_POPULATION_METADATA_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_METADATA_ID_ASC'
  | 'EVENTS_BY_METADATA_ID_VARIANCE_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_AVERAGE_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_COUNT_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_COUNT_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_HASH_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_HASH_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SIGNATURE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SIGNATURE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SUCCESS_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_SUCCESS_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_DISTINCT_COUNT_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MAX_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_MIN_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_STDDEV_SAMPLE_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_SUM_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_POPULATION_VERSION_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_FEE_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_FEE_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_INDEX_IN_BLOCK_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_METADATA_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_METADATA_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_SUBMITTER_ID_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_SUBMITTER_ID_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_TIP_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_TIP_DESC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_VERSION_ASC'
  | 'EXTRINSICS_BY_METADATA_ID_VARIANCE_SAMPLE_VERSION_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LABEL_ASC'
  | 'LABEL_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type Metadatum = Node & {
  __typename?: 'Metadatum';
  chainspec: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `Event`. */
  eventsByMetadataId: EventsConnection;
  /** Reads and enables pagination through a set of `Extrinsic`. */
  extrinsicsByMetadataId: ExtrinsicsConnection;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};


export type MetadatumEventsByMetadataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


export type MetadatumExtrinsicsByMetadataIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExtrinsicCondition>;
  filter?: InputMaybe<ExtrinsicFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicsOrderBy>>;
};

export type MetadatumAggregates = {
  __typename?: 'MetadatumAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<MetadatumAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MetadatumDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<MetadatumMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<MetadatumMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<MetadatumStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<MetadatumStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<MetadatumSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<MetadatumVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<MetadatumVarianceSampleAggregates>;
};

export type MetadatumAverageAggregates = {
  __typename?: 'MetadatumAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Metadatum` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MetadatumCondition = {
  /** Checks for equality with the object’s `chainspec` field. */
  chainspec?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `label` field. */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MetadatumDistinctCountAggregates = {
  __typename?: 'MetadatumDistinctCountAggregates';
  /** Distinct count of chainspec across the matching connection */
  chainspec?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of label across the matching connection */
  label?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Metadatum` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MetadatumFilter>>;
  /** Filter by the object’s `chainspec` field. */
  chainspec?: InputMaybe<StringFilter>;
  /** Filter by the object’s `eventsByMetadataId` relation. */
  eventsByMetadataId?: InputMaybe<MetadatumToManyEventFilter>;
  /** Some related `eventsByMetadataId` exist. */
  eventsByMetadataIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `extrinsicsByMetadataId` relation. */
  extrinsicsByMetadataId?: InputMaybe<MetadatumToManyExtrinsicFilter>;
  /** Some related `extrinsicsByMetadataId` exist. */
  extrinsicsByMetadataIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `label` field. */
  label?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MetadatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MetadatumFilter>>;
};

/** Grouping methods for `Metadatum` for usage during aggregation. */
export type MetadatumGroupBy =
  | 'CHAINSPEC'
  | 'LABEL'
  | 'NAME';

export type MetadatumHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Metadatum` aggregates. */
export type MetadatumHavingInput = {
  AND?: InputMaybe<Array<MetadatumHavingInput>>;
  OR?: InputMaybe<Array<MetadatumHavingInput>>;
  average?: InputMaybe<MetadatumHavingAverageInput>;
  distinctCount?: InputMaybe<MetadatumHavingDistinctCountInput>;
  max?: InputMaybe<MetadatumHavingMaxInput>;
  min?: InputMaybe<MetadatumHavingMinInput>;
  stddevPopulation?: InputMaybe<MetadatumHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MetadatumHavingStddevSampleInput>;
  sum?: InputMaybe<MetadatumHavingSumInput>;
  variancePopulation?: InputMaybe<MetadatumHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MetadatumHavingVarianceSampleInput>;
};

export type MetadatumHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
};

export type MetadatumMaxAggregates = {
  __typename?: 'MetadatumMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type MetadatumMinAggregates = {
  __typename?: 'MetadatumMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type MetadatumStddevPopulationAggregates = {
  __typename?: 'MetadatumStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type MetadatumStddevSampleAggregates = {
  __typename?: 'MetadatumStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type MetadatumSumAggregates = {
  __typename?: 'MetadatumSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `Event` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyEventFilter = {
  /** Aggregates across related `Event` match the filter criteria. */
  aggregates?: InputMaybe<EventAggregatesFilter>;
  /** Every related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EventFilter>;
  /** No related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EventFilter>;
  /** Some related `Event` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EventFilter>;
};

/** A filter to be used against many `Extrinsic` object types. All fields are combined with a logical ‘and.’ */
export type MetadatumToManyExtrinsicFilter = {
  /** Aggregates across related `Extrinsic` match the filter criteria. */
  aggregates?: InputMaybe<ExtrinsicAggregatesFilter>;
  /** Every related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ExtrinsicFilter>;
  /** No related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ExtrinsicFilter>;
  /** Some related `Extrinsic` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ExtrinsicFilter>;
};

export type MetadatumVariancePopulationAggregates = {
  __typename?: 'MetadatumVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type MetadatumVarianceSampleAggregates = {
  __typename?: 'MetadatumVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `NetworkParticipantEarningsDaily` values. */
export type NetworkParticipantEarningsDailiesConnection = {
  __typename?: 'NetworkParticipantEarningsDailiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NetworkParticipantEarningsDailyAggregates>;
  /** A list of edges which contains the `NetworkParticipantEarningsDaily` and cursor to aid in pagination. */
  edges: Array<NetworkParticipantEarningsDailiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NetworkParticipantEarningsDailyAggregates>>;
  /** A list of `NetworkParticipantEarningsDaily` objects. */
  nodes: Array<NetworkParticipantEarningsDaily>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NetworkParticipantEarningsDaily` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `NetworkParticipantEarningsDaily` values. */
export type NetworkParticipantEarningsDailiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<NetworkParticipantEarningsDailyGroupBy>;
  having?: InputMaybe<NetworkParticipantEarningsDailyHavingInput>;
};

/** A `NetworkParticipantEarningsDaily` edge in the connection. */
export type NetworkParticipantEarningsDailiesEdge = {
  __typename?: 'NetworkParticipantEarningsDailiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NetworkParticipantEarningsDaily` at the end of the edge. */
  node: NetworkParticipantEarningsDaily;
};

/** Methods to use when ordering `NetworkParticipantEarningsDaily`. */
export type NetworkParticipantEarningsDailiesOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'ACTIVE_HOURS_ASC'
  | 'ACTIVE_HOURS_DESC'
  | 'AVG_PRINCIPAL_ASC'
  | 'AVG_PRINCIPAL_DESC'
  | 'DAY_ASC'
  | 'DAY_DESC'
  | 'EARNINGS_ASC'
  | 'EARNINGS_DESC'
  | 'EARNINGS_VALUE_USD_ASC'
  | 'EARNINGS_VALUE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOSSES_ASC'
  | 'LOSSES_DESC'
  | 'LOSSES_VALUE_USD_ASC'
  | 'LOSSES_VALUE_USD_DESC'
  | 'MAX_PRINCIPAL_ASC'
  | 'MAX_PRINCIPAL_DESC'
  | 'MIN_PRINCIPAL_ASC'
  | 'MIN_PRINCIPAL_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PROJECTED_APY6H_ASC'
  | 'PROJECTED_APY6H_DESC'
  | 'PROJECTED_APY24H_ASC'
  | 'PROJECTED_APY24H_DESC'
  | 'PROJECTED_APY72H_ASC'
  | 'PROJECTED_APY72H_DESC'
  | 'PROJECTED_APY168H_ASC'
  | 'PROJECTED_APY168H_DESC'
  | 'PROJECTED_APY720H_ASC'
  | 'PROJECTED_APY720H_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC';

export type NetworkParticipantEarningsDaily = Node & {
  __typename?: 'NetworkParticipantEarningsDaily';
  /** Reads a single `Account` that is related to this `NetworkParticipantEarningsDaily`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  activeHours: Scalars['Int']['output'];
  avgPrincipal: Scalars['BigFloat']['output'];
  day: Scalars['Date']['output'];
  earnings: Scalars['BigFloat']['output'];
  earningsValueUsd: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  losses: Scalars['BigFloat']['output'];
  lossesValueUsd: Scalars['BigFloat']['output'];
  maxPrincipal: Scalars['BigFloat']['output'];
  minPrincipal: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  role: NetworkParticipantRole;
};

export type NetworkParticipantEarningsDailyAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<NetworkParticipantEarningsDailyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NetworkParticipantEarningsDailyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<NetworkParticipantEarningsDailyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<NetworkParticipantEarningsDailyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<NetworkParticipantEarningsDailyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<NetworkParticipantEarningsDailyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<NetworkParticipantEarningsDailySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<NetworkParticipantEarningsDailyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<NetworkParticipantEarningsDailyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `NetworkParticipantEarningsDaily` object types. */
export type NetworkParticipantEarningsDailyAggregatesFilter = {
  /** Mean average aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  average?: InputMaybe<NetworkParticipantEarningsDailyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  distinctCount?: InputMaybe<NetworkParticipantEarningsDailyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NetworkParticipantEarningsDaily` object to be included within the aggregate. */
  filter?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  /** Maximum aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  max?: InputMaybe<NetworkParticipantEarningsDailyMaxAggregateFilter>;
  /** Minimum aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  min?: InputMaybe<NetworkParticipantEarningsDailyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  stddevPopulation?: InputMaybe<NetworkParticipantEarningsDailyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  stddevSample?: InputMaybe<NetworkParticipantEarningsDailyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  sum?: InputMaybe<NetworkParticipantEarningsDailySumAggregateFilter>;
  /** Population variance aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  variancePopulation?: InputMaybe<NetworkParticipantEarningsDailyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `NetworkParticipantEarningsDaily` objects. */
  varianceSample?: InputMaybe<NetworkParticipantEarningsDailyVarianceSampleAggregateFilter>;
};

export type NetworkParticipantEarningsDailyAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  activeHours?: InputMaybe<BigFloatFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyAverageAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `NetworkParticipantEarningsDaily` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type NetworkParticipantEarningsDailyCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `activeHours` field. */
  activeHours?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `avgPrincipal` field. */
  avgPrincipal?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `day` field. */
  day?: InputMaybe<Scalars['Date']['input']>;
  /** Checks for equality with the object’s `earnings` field. */
  earnings?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `earningsValueUsd` field. */
  earningsValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `losses` field. */
  losses?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `maxPrincipal` field. */
  maxPrincipal?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minPrincipal` field. */
  minPrincipal?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<NetworkParticipantRole>;
};

export type NetworkParticipantEarningsDailyDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  activeHours?: InputMaybe<BigIntFilter>;
  avgPrincipal?: InputMaybe<BigIntFilter>;
  day?: InputMaybe<BigIntFilter>;
  earnings?: InputMaybe<BigIntFilter>;
  earningsValueUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigIntFilter>;
  lossesValueUsd?: InputMaybe<BigIntFilter>;
  maxPrincipal?: InputMaybe<BigIntFilter>;
  minPrincipal?: InputMaybe<BigIntFilter>;
  projectedApy6H?: InputMaybe<BigIntFilter>;
  projectedApy24H?: InputMaybe<BigIntFilter>;
  projectedApy72H?: InputMaybe<BigIntFilter>;
  projectedApy168H?: InputMaybe<BigIntFilter>;
  projectedApy720H?: InputMaybe<BigIntFilter>;
  role?: InputMaybe<BigIntFilter>;
};

export type NetworkParticipantEarningsDailyDistinctCountAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of day across the matching connection */
  day?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losses across the matching connection */
  losses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `NetworkParticipantEarningsDaily` object types. All fields are combined with a logical ‘and.’ */
export type NetworkParticipantEarningsDailyFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `activeHours` field. */
  activeHours?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NetworkParticipantEarningsDailyFilter>>;
  /** Filter by the object’s `avgPrincipal` field. */
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `day` field. */
  day?: InputMaybe<DateFilter>;
  /** Filter by the object’s `earnings` field. */
  earnings?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `earningsValueUsd` field. */
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `losses` field. */
  losses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `maxPrincipal` field. */
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minPrincipal` field. */
  minPrincipal?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NetworkParticipantEarningsDailyFilter>>;
  /** Filter by the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<NetworkParticipantRoleFilter>;
};

/** Grouping methods for `NetworkParticipantEarningsDaily` for usage during aggregation. */
export type NetworkParticipantEarningsDailyGroupBy =
  | 'ACCOUNT_ID'
  | 'ACTIVE_HOURS'
  | 'AVG_PRINCIPAL'
  | 'DAY'
  | 'EARNINGS'
  | 'EARNINGS_VALUE_USD'
  | 'LOSSES'
  | 'LOSSES_VALUE_USD'
  | 'MAX_PRINCIPAL'
  | 'MIN_PRINCIPAL'
  | 'PROJECTED_APY6H'
  | 'PROJECTED_APY24H'
  | 'PROJECTED_APY72H'
  | 'PROJECTED_APY168H'
  | 'PROJECTED_APY720H'
  | 'ROLE';

export type NetworkParticipantEarningsDailyHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `NetworkParticipantEarningsDaily` aggregates. */
export type NetworkParticipantEarningsDailyHavingInput = {
  AND?: InputMaybe<Array<NetworkParticipantEarningsDailyHavingInput>>;
  OR?: InputMaybe<Array<NetworkParticipantEarningsDailyHavingInput>>;
  average?: InputMaybe<NetworkParticipantEarningsDailyHavingAverageInput>;
  distinctCount?: InputMaybe<NetworkParticipantEarningsDailyHavingDistinctCountInput>;
  max?: InputMaybe<NetworkParticipantEarningsDailyHavingMaxInput>;
  min?: InputMaybe<NetworkParticipantEarningsDailyHavingMinInput>;
  stddevPopulation?: InputMaybe<NetworkParticipantEarningsDailyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NetworkParticipantEarningsDailyHavingStddevSampleInput>;
  sum?: InputMaybe<NetworkParticipantEarningsDailyHavingSumInput>;
  variancePopulation?: InputMaybe<NetworkParticipantEarningsDailyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NetworkParticipantEarningsDailyHavingVarianceSampleInput>;
};

export type NetworkParticipantEarningsDailyHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  activeHours?: InputMaybe<HavingIntFilter>;
  avgPrincipal?: InputMaybe<HavingBigfloatFilter>;
  day?: InputMaybe<HavingDatetimeFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  maxPrincipal?: InputMaybe<HavingBigfloatFilter>;
  minPrincipal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
};

export type NetworkParticipantEarningsDailyMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  activeHours?: InputMaybe<IntFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  day?: InputMaybe<DateFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyMaxAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['Int']['output']>;
  /** Maximum of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of day across the matching connection */
  day?: Maybe<Scalars['Date']['output']>;
  /** Maximum of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsDailyMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  activeHours?: InputMaybe<IntFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  day?: InputMaybe<DateFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyMinAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['Int']['output']>;
  /** Minimum of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of day across the matching connection */
  day?: Maybe<Scalars['Date']['output']>;
  /** Minimum of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsDailyStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  activeHours?: InputMaybe<BigFloatFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyStddevPopulationAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsDailyStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  activeHours?: InputMaybe<BigFloatFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyStddevSampleAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsDailySumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  activeHours?: InputMaybe<BigIntFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailySumAggregates = {
  __typename?: 'NetworkParticipantEarningsDailySumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of activeHours across the matching connection */
  activeHours: Scalars['BigInt']['output'];
  /** Sum of avgPrincipal across the matching connection */
  avgPrincipal: Scalars['BigFloat']['output'];
  /** Sum of earnings across the matching connection */
  earnings: Scalars['BigFloat']['output'];
  /** Sum of earningsValueUsd across the matching connection */
  earningsValueUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of losses across the matching connection */
  losses: Scalars['BigFloat']['output'];
  /** Sum of lossesValueUsd across the matching connection */
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of maxPrincipal across the matching connection */
  maxPrincipal: Scalars['BigFloat']['output'];
  /** Sum of minPrincipal across the matching connection */
  minPrincipal: Scalars['BigFloat']['output'];
  /** Sum of projectedApy6H across the matching connection */
  projectedApy6H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy24H across the matching connection */
  projectedApy24H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy72H across the matching connection */
  projectedApy72H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy168H across the matching connection */
  projectedApy168H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy720H across the matching connection */
  projectedApy720H: Scalars['BigFloat']['output'];
};

export type NetworkParticipantEarningsDailyVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  activeHours?: InputMaybe<BigFloatFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyVariancePopulationAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsDailyVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  activeHours?: InputMaybe<BigFloatFilter>;
  avgPrincipal?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  maxPrincipal?: InputMaybe<BigFloatFilter>;
  minPrincipal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsDailyVarianceSampleAggregates = {
  __typename?: 'NetworkParticipantEarningsDailyVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of activeHours across the matching connection */
  activeHours?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of avgPrincipal across the matching connection */
  avgPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxPrincipal across the matching connection */
  maxPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minPrincipal across the matching connection */
  minPrincipal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `NetworkParticipantEarningsHourly` values. */
export type NetworkParticipantEarningsHourliesConnection = {
  __typename?: 'NetworkParticipantEarningsHourliesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<NetworkParticipantEarningsHourlyAggregates>;
  /** A list of edges which contains the `NetworkParticipantEarningsHourly` and cursor to aid in pagination. */
  edges: Array<NetworkParticipantEarningsHourliesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<NetworkParticipantEarningsHourlyAggregates>>;
  /** A list of `NetworkParticipantEarningsHourly` objects. */
  nodes: Array<NetworkParticipantEarningsHourly>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `NetworkParticipantEarningsHourly` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `NetworkParticipantEarningsHourly` values. */
export type NetworkParticipantEarningsHourliesConnectionGroupedAggregatesArgs = {
  groupBy: Array<NetworkParticipantEarningsHourlyGroupBy>;
  having?: InputMaybe<NetworkParticipantEarningsHourlyHavingInput>;
};

/** A `NetworkParticipantEarningsHourly` edge in the connection. */
export type NetworkParticipantEarningsHourliesEdge = {
  __typename?: 'NetworkParticipantEarningsHourliesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `NetworkParticipantEarningsHourly` at the end of the edge. */
  node: NetworkParticipantEarningsHourly;
};

/** Methods to use when ordering `NetworkParticipantEarningsHourly`. */
export type NetworkParticipantEarningsHourliesOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'BLOCK_ASC'
  | 'BLOCK_DESC'
  | 'CUMULATIVE_REWARD_ASC'
  | 'CUMULATIVE_REWARD_DESC'
  | 'EARNINGS_ASC'
  | 'EARNINGS_DESC'
  | 'EARNINGS_VALUE_USD_ASC'
  | 'EARNINGS_VALUE_USD_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERVAL_ASC'
  | 'INTERVAL_DESC'
  | 'LOSSES_ASC'
  | 'LOSSES_DESC'
  | 'LOSSES_VALUE_USD_ASC'
  | 'LOSSES_VALUE_USD_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRINCIPAL_ASC'
  | 'PRINCIPAL_DESC'
  | 'PROJECTED_APY6H_ASC'
  | 'PROJECTED_APY6H_DESC'
  | 'PROJECTED_APY24H_ASC'
  | 'PROJECTED_APY24H_DESC'
  | 'PROJECTED_APY72H_ASC'
  | 'PROJECTED_APY72H_DESC'
  | 'PROJECTED_APY168H_ASC'
  | 'PROJECTED_APY168H_DESC'
  | 'PROJECTED_APY720H_ASC'
  | 'PROJECTED_APY720H_DESC'
  | 'RATIO_ASC'
  | 'RATIO_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type NetworkParticipantEarningsHourly = Node & {
  __typename?: 'NetworkParticipantEarningsHourly';
  /** Reads a single `Account` that is related to this `NetworkParticipantEarningsHourly`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  block: Scalars['Int']['output'];
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  earnings: Scalars['BigFloat']['output'];
  earningsValueUsd: Scalars['BigFloat']['output'];
  epochId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  interval: Scalars['Int']['output'];
  losses: Scalars['BigFloat']['output'];
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  principal: Scalars['BigFloat']['output'];
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  ratio: Scalars['BigFloat']['output'];
  role: NetworkParticipantRole;
  timestamp: Scalars['Datetime']['output'];
};

export type NetworkParticipantEarningsHourlyAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<NetworkParticipantEarningsHourlyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<NetworkParticipantEarningsHourlyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<NetworkParticipantEarningsHourlyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<NetworkParticipantEarningsHourlyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<NetworkParticipantEarningsHourlyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<NetworkParticipantEarningsHourlyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<NetworkParticipantEarningsHourlySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<NetworkParticipantEarningsHourlyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<NetworkParticipantEarningsHourlyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `NetworkParticipantEarningsHourly` object types. */
export type NetworkParticipantEarningsHourlyAggregatesFilter = {
  /** Mean average aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  average?: InputMaybe<NetworkParticipantEarningsHourlyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  distinctCount?: InputMaybe<NetworkParticipantEarningsHourlyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `NetworkParticipantEarningsHourly` object to be included within the aggregate. */
  filter?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  /** Maximum aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  max?: InputMaybe<NetworkParticipantEarningsHourlyMaxAggregateFilter>;
  /** Minimum aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  min?: InputMaybe<NetworkParticipantEarningsHourlyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  stddevPopulation?: InputMaybe<NetworkParticipantEarningsHourlyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  stddevSample?: InputMaybe<NetworkParticipantEarningsHourlyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  sum?: InputMaybe<NetworkParticipantEarningsHourlySumAggregateFilter>;
  /** Population variance aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  variancePopulation?: InputMaybe<NetworkParticipantEarningsHourlyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `NetworkParticipantEarningsHourly` objects. */
  varianceSample?: InputMaybe<NetworkParticipantEarningsHourlyVarianceSampleAggregateFilter>;
};

export type NetworkParticipantEarningsHourlyAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlyAverageAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `NetworkParticipantEarningsHourly` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type NetworkParticipantEarningsHourlyCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `block` field. */
  block?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `cumulativeReward` field. */
  cumulativeReward?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `earnings` field. */
  earnings?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `earningsValueUsd` field. */
  earningsValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `interval` field. */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `losses` field. */
  losses?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `principal` field. */
  principal?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ratio` field. */
  ratio?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<NetworkParticipantRole>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type NetworkParticipantEarningsHourlyDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  cumulativeReward?: InputMaybe<BigIntFilter>;
  earnings?: InputMaybe<BigIntFilter>;
  earningsValueUsd?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigIntFilter>;
  lossesValueUsd?: InputMaybe<BigIntFilter>;
  principal?: InputMaybe<BigIntFilter>;
  projectedApy6H?: InputMaybe<BigIntFilter>;
  projectedApy24H?: InputMaybe<BigIntFilter>;
  projectedApy72H?: InputMaybe<BigIntFilter>;
  projectedApy168H?: InputMaybe<BigIntFilter>;
  projectedApy720H?: InputMaybe<BigIntFilter>;
  ratio?: InputMaybe<BigIntFilter>;
  role?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type NetworkParticipantEarningsHourlyDistinctCountAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of block across the matching connection */
  block?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of interval across the matching connection */
  interval?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losses across the matching connection */
  losses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of principal across the matching connection */
  principal?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `NetworkParticipantEarningsHourly` object types. All fields are combined with a logical ‘and.’ */
export type NetworkParticipantEarningsHourlyFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<NetworkParticipantEarningsHourlyFilter>>;
  /** Filter by the object’s `block` field. */
  block?: InputMaybe<IntFilter>;
  /** Filter by the object’s `cumulativeReward` field. */
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `earnings` field. */
  earnings?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `earningsValueUsd` field. */
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `interval` field. */
  interval?: InputMaybe<IntFilter>;
  /** Filter by the object’s `losses` field. */
  losses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<NetworkParticipantEarningsHourlyFilter>>;
  /** Filter by the object’s `principal` field. */
  principal?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy6H` field. */
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy24H` field. */
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy72H` field. */
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy168H` field. */
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `projectedApy720H` field. */
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ratio` field. */
  ratio?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<NetworkParticipantRoleFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `NetworkParticipantEarningsHourly` for usage during aggregation. */
export type NetworkParticipantEarningsHourlyGroupBy =
  | 'ACCOUNT_ID'
  | 'BLOCK'
  | 'CUMULATIVE_REWARD'
  | 'EARNINGS'
  | 'EARNINGS_VALUE_USD'
  | 'EPOCH_ID'
  | 'INTERVAL'
  | 'LOSSES'
  | 'LOSSES_VALUE_USD'
  | 'PRINCIPAL'
  | 'PROJECTED_APY6H'
  | 'PROJECTED_APY24H'
  | 'PROJECTED_APY72H'
  | 'PROJECTED_APY168H'
  | 'PROJECTED_APY720H'
  | 'RATIO'
  | 'ROLE'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type NetworkParticipantEarningsHourlyHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `NetworkParticipantEarningsHourly` aggregates. */
export type NetworkParticipantEarningsHourlyHavingInput = {
  AND?: InputMaybe<Array<NetworkParticipantEarningsHourlyHavingInput>>;
  OR?: InputMaybe<Array<NetworkParticipantEarningsHourlyHavingInput>>;
  average?: InputMaybe<NetworkParticipantEarningsHourlyHavingAverageInput>;
  distinctCount?: InputMaybe<NetworkParticipantEarningsHourlyHavingDistinctCountInput>;
  max?: InputMaybe<NetworkParticipantEarningsHourlyHavingMaxInput>;
  min?: InputMaybe<NetworkParticipantEarningsHourlyHavingMinInput>;
  stddevPopulation?: InputMaybe<NetworkParticipantEarningsHourlyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<NetworkParticipantEarningsHourlyHavingStddevSampleInput>;
  sum?: InputMaybe<NetworkParticipantEarningsHourlyHavingSumInput>;
  variancePopulation?: InputMaybe<NetworkParticipantEarningsHourlyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<NetworkParticipantEarningsHourlyHavingVarianceSampleInput>;
};

export type NetworkParticipantEarningsHourlyHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  block?: InputMaybe<HavingIntFilter>;
  cumulativeReward?: InputMaybe<HavingBigfloatFilter>;
  earnings?: InputMaybe<HavingBigfloatFilter>;
  earningsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  interval?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  principal?: InputMaybe<HavingBigfloatFilter>;
  projectedApy6H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy24H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy72H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy168H?: InputMaybe<HavingBigfloatFilter>;
  projectedApy720H?: InputMaybe<HavingBigfloatFilter>;
  ratio?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  block?: InputMaybe<IntFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyMaxAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Maximum of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type NetworkParticipantEarningsHourlyMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  block?: InputMaybe<IntFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  interval?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type NetworkParticipantEarningsHourlyMinAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of block across the matching connection */
  block?: Maybe<Scalars['Int']['output']>;
  /** Minimum of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of interval across the matching connection */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type NetworkParticipantEarningsHourlyStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlyStddevPopulationAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsHourlyStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlyStddevSampleAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsHourlySumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  block?: InputMaybe<BigIntFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  interval?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlySumAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlySumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of block across the matching connection */
  block: Scalars['BigInt']['output'];
  /** Sum of cumulativeReward across the matching connection */
  cumulativeReward: Scalars['BigFloat']['output'];
  /** Sum of earnings across the matching connection */
  earnings: Scalars['BigFloat']['output'];
  /** Sum of earningsValueUsd across the matching connection */
  earningsValueUsd: Scalars['BigFloat']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of interval across the matching connection */
  interval: Scalars['BigInt']['output'];
  /** Sum of losses across the matching connection */
  losses: Scalars['BigFloat']['output'];
  /** Sum of lossesValueUsd across the matching connection */
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of principal across the matching connection */
  principal: Scalars['BigFloat']['output'];
  /** Sum of projectedApy6H across the matching connection */
  projectedApy6H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy24H across the matching connection */
  projectedApy24H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy72H across the matching connection */
  projectedApy72H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy168H across the matching connection */
  projectedApy168H: Scalars['BigFloat']['output'];
  /** Sum of projectedApy720H across the matching connection */
  projectedApy720H: Scalars['BigFloat']['output'];
  /** Sum of ratio across the matching connection */
  ratio: Scalars['BigFloat']['output'];
};

export type NetworkParticipantEarningsHourlyVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlyVariancePopulationAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantEarningsHourlyVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  block?: InputMaybe<BigFloatFilter>;
  cumulativeReward?: InputMaybe<BigFloatFilter>;
  earnings?: InputMaybe<BigFloatFilter>;
  earningsValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  interval?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  principal?: InputMaybe<BigFloatFilter>;
  projectedApy6H?: InputMaybe<BigFloatFilter>;
  projectedApy24H?: InputMaybe<BigFloatFilter>;
  projectedApy72H?: InputMaybe<BigFloatFilter>;
  projectedApy168H?: InputMaybe<BigFloatFilter>;
  projectedApy720H?: InputMaybe<BigFloatFilter>;
  ratio?: InputMaybe<BigFloatFilter>;
};

export type NetworkParticipantEarningsHourlyVarianceSampleAggregates = {
  __typename?: 'NetworkParticipantEarningsHourlyVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of block across the matching connection */
  block?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of cumulativeReward across the matching connection */
  cumulativeReward?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of earnings across the matching connection */
  earnings?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of earningsValueUsd across the matching connection */
  earningsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of interval across the matching connection */
  interval?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of principal across the matching connection */
  principal?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy6H across the matching connection */
  projectedApy6H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy24H across the matching connection */
  projectedApy24H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy72H across the matching connection */
  projectedApy72H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy168H across the matching connection */
  projectedApy168H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of projectedApy720H across the matching connection */
  projectedApy720H?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ratio across the matching connection */
  ratio?: Maybe<Scalars['BigFloat']['output']>;
};

export type NetworkParticipantRole =
  | 'DELEGATOR'
  | 'OPERATOR'
  | 'OPERATOR_DELEGATOR'
  | 'VALIDATOR';

/** A filter to be used against NetworkParticipantRole fields. All fields are combined with a logical ‘and.’ */
export type NetworkParticipantRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<NetworkParticipantRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<NetworkParticipantRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<NetworkParticipantRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<NetworkParticipantRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<NetworkParticipantRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<NetworkParticipantRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<NetworkParticipantRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<NetworkParticipantRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<NetworkParticipantRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<NetworkParticipantRole>>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
};

export type OnChainSwapInfo = Node & {
  __typename?: 'OnChainSwapInfo';
  /** Reads a single `Account` that is related to this `OnChainSwapInfo`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  creditedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `Event` that is related to this `OnChainSwapInfo`. */
  eventByCreditedOnChainEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `OnChainSwapInfo`. */
  eventByRefundedOnChainEventId?: Maybe<Event>;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  outputAction: OnChainSwapOutputAction;
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  refundedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads a single `SwapRequest` that is related to this `OnChainSwapInfo`. */
  swapRequestBySwapRequestId: SwapRequest;
  swapRequestId: Scalars['Int']['output'];
};

export type OnChainSwapInfoAggregates = {
  __typename?: 'OnChainSwapInfoAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OnChainSwapInfoAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OnChainSwapInfoDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OnChainSwapInfoMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OnChainSwapInfoMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OnChainSwapInfoStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OnChainSwapInfoStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OnChainSwapInfoSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OnChainSwapInfoVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OnChainSwapInfoVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OnChainSwapInfo` object types. */
export type OnChainSwapInfoAggregatesFilter = {
  /** Mean average aggregate over matching `OnChainSwapInfo` objects. */
  average?: InputMaybe<OnChainSwapInfoAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OnChainSwapInfo` objects. */
  distinctCount?: InputMaybe<OnChainSwapInfoDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OnChainSwapInfo` object to be included within the aggregate. */
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  /** Maximum aggregate over matching `OnChainSwapInfo` objects. */
  max?: InputMaybe<OnChainSwapInfoMaxAggregateFilter>;
  /** Minimum aggregate over matching `OnChainSwapInfo` objects. */
  min?: InputMaybe<OnChainSwapInfoMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OnChainSwapInfo` objects. */
  stddevPopulation?: InputMaybe<OnChainSwapInfoStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OnChainSwapInfo` objects. */
  stddevSample?: InputMaybe<OnChainSwapInfoStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OnChainSwapInfo` objects. */
  sum?: InputMaybe<OnChainSwapInfoSumAggregateFilter>;
  /** Population variance aggregate over matching `OnChainSwapInfo` objects. */
  variancePopulation?: InputMaybe<OnChainSwapInfoVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OnChainSwapInfo` objects. */
  varianceSample?: InputMaybe<OnChainSwapInfoVarianceSampleAggregateFilter>;
};

export type OnChainSwapInfoAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type OnChainSwapInfoAverageAggregates = {
  __typename?: 'OnChainSwapInfoAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OnChainSwapInfo` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OnChainSwapInfoCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `creditedOnChainEventId` field. */
  creditedOnChainEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByCreditedOnChainEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByRefundedOnChainEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `outputAction` field. */
  outputAction?: InputMaybe<OnChainSwapOutputAction>;
  /** Checks for equality with the object’s `outputAmount` field. */
  outputAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `outputValueUsd` field. */
  outputValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundAmount` field. */
  refundAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundValueUsd` field. */
  refundValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `refundedOnChainEventId` field. */
  refundedOnChainEventId?: InputMaybe<Scalars['BigInt']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
};

export type OnChainSwapInfoDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  creditedOnChainEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  outputAction?: InputMaybe<BigIntFilter>;
  outputAmount?: InputMaybe<BigIntFilter>;
  outputValueUsd?: InputMaybe<BigIntFilter>;
  refundAmount?: InputMaybe<BigIntFilter>;
  refundValueUsd?: InputMaybe<BigIntFilter>;
  refundedOnChainEventId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type OnChainSwapInfoDistinctCountAggregates = {
  __typename?: 'OnChainSwapInfoDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of outputAction across the matching connection */
  outputAction?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OnChainSwapInfo` object types. All fields are combined with a logical ‘and.’ */
export type OnChainSwapInfoFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OnChainSwapInfoFilter>>;
  /** Filter by the object’s `creditedOnChainEventId` field. */
  creditedOnChainEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByCreditedOnChainEventId` relation. */
  eventByCreditedOnChainEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCreditedOnChainEventId` exists. */
  eventByCreditedOnChainEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByRefundedOnChainEventId` relation. */
  eventByRefundedOnChainEventId?: InputMaybe<EventFilter>;
  /** A related `eventByRefundedOnChainEventId` exists. */
  eventByRefundedOnChainEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OnChainSwapInfoFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OnChainSwapInfoFilter>>;
  /** Filter by the object’s `outputAction` field. */
  outputAction?: InputMaybe<OnChainSwapOutputActionFilter>;
  /** Filter by the object’s `outputAmount` field. */
  outputAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `outputValueUsd` field. */
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `refundAmount` field. */
  refundAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `refundValueUsd` field. */
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `refundedOnChainEventId` field. */
  refundedOnChainEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `OnChainSwapInfo` for usage during aggregation. */
export type OnChainSwapInfoGroupBy =
  | 'ACCOUNT_ID'
  | 'CREDITED_ON_CHAIN_EVENT_ID'
  | 'OUTPUT_ACTION'
  | 'OUTPUT_AMOUNT'
  | 'OUTPUT_VALUE_USD'
  | 'REFUNDED_ON_CHAIN_EVENT_ID'
  | 'REFUND_AMOUNT'
  | 'REFUND_VALUE_USD';

export type OnChainSwapInfoHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OnChainSwapInfo` aggregates. */
export type OnChainSwapInfoHavingInput = {
  AND?: InputMaybe<Array<OnChainSwapInfoHavingInput>>;
  OR?: InputMaybe<Array<OnChainSwapInfoHavingInput>>;
  average?: InputMaybe<OnChainSwapInfoHavingAverageInput>;
  distinctCount?: InputMaybe<OnChainSwapInfoHavingDistinctCountInput>;
  max?: InputMaybe<OnChainSwapInfoHavingMaxInput>;
  min?: InputMaybe<OnChainSwapInfoHavingMinInput>;
  stddevPopulation?: InputMaybe<OnChainSwapInfoHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OnChainSwapInfoHavingStddevSampleInput>;
  sum?: InputMaybe<OnChainSwapInfoHavingSumInput>;
  variancePopulation?: InputMaybe<OnChainSwapInfoHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OnChainSwapInfoHavingVarianceSampleInput>;
};

export type OnChainSwapInfoHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  creditedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  outputAmount?: InputMaybe<HavingBigfloatFilter>;
  outputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundAmount?: InputMaybe<HavingBigfloatFilter>;
  refundValueUsd?: InputMaybe<HavingBigfloatFilter>;
  refundedOnChainEventId?: InputMaybe<HavingBigintFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type OnChainSwapInfoMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  creditedOnChainEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type OnChainSwapInfoMaxAggregates = {
  __typename?: 'OnChainSwapInfoMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type OnChainSwapInfoMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  creditedOnChainEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type OnChainSwapInfoMinAggregates = {
  __typename?: 'OnChainSwapInfoMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type OnChainSwapInfoStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type OnChainSwapInfoStddevPopulationAggregates = {
  __typename?: 'OnChainSwapInfoStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OnChainSwapInfoStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type OnChainSwapInfoStddevSampleAggregates = {
  __typename?: 'OnChainSwapInfoStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OnChainSwapInfoSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type OnChainSwapInfoSumAggregates = {
  __typename?: 'OnChainSwapInfoSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of outputAmount across the matching connection */
  outputAmount: Scalars['BigFloat']['output'];
  /** Sum of outputValueUsd across the matching connection */
  outputValueUsd: Scalars['BigFloat']['output'];
  /** Sum of refundAmount across the matching connection */
  refundAmount: Scalars['BigFloat']['output'];
  /** Sum of refundValueUsd across the matching connection */
  refundValueUsd: Scalars['BigFloat']['output'];
  /** Sum of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
};

export type OnChainSwapInfoVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type OnChainSwapInfoVariancePopulationAggregates = {
  __typename?: 'OnChainSwapInfoVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OnChainSwapInfoVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  creditedOnChainEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  outputAmount?: InputMaybe<BigFloatFilter>;
  outputValueUsd?: InputMaybe<BigFloatFilter>;
  refundAmount?: InputMaybe<BigFloatFilter>;
  refundValueUsd?: InputMaybe<BigFloatFilter>;
  refundedOnChainEventId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type OnChainSwapInfoVarianceSampleAggregates = {
  __typename?: 'OnChainSwapInfoVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of creditedOnChainEventId across the matching connection */
  creditedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of outputAmount across the matching connection */
  outputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of outputValueUsd across the matching connection */
  outputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundAmount across the matching connection */
  refundAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundValueUsd across the matching connection */
  refundValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundedOnChainEventId across the matching connection */
  refundedOnChainEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OnChainSwapInfo` values. */
export type OnChainSwapInfosConnection = {
  __typename?: 'OnChainSwapInfosConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OnChainSwapInfoAggregates>;
  /** A list of edges which contains the `OnChainSwapInfo` and cursor to aid in pagination. */
  edges: Array<OnChainSwapInfosEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OnChainSwapInfoAggregates>>;
  /** A list of `OnChainSwapInfo` objects. */
  nodes: Array<OnChainSwapInfo>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OnChainSwapInfo` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OnChainSwapInfo` values. */
export type OnChainSwapInfosConnectionGroupedAggregatesArgs = {
  groupBy: Array<OnChainSwapInfoGroupBy>;
  having?: InputMaybe<OnChainSwapInfoHavingInput>;
};

/** A `OnChainSwapInfo` edge in the connection. */
export type OnChainSwapInfosEdge = {
  __typename?: 'OnChainSwapInfosEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OnChainSwapInfo` at the end of the edge. */
  node: OnChainSwapInfo;
};

/** Methods to use when ordering `OnChainSwapInfo`. */
export type OnChainSwapInfosOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'CREDITED_ON_CHAIN_EVENT_ID_ASC'
  | 'CREDITED_ON_CHAIN_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OUTPUT_ACTION_ASC'
  | 'OUTPUT_ACTION_DESC'
  | 'OUTPUT_AMOUNT_ASC'
  | 'OUTPUT_AMOUNT_DESC'
  | 'OUTPUT_VALUE_USD_ASC'
  | 'OUTPUT_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFUNDED_ON_CHAIN_EVENT_ID_ASC'
  | 'REFUNDED_ON_CHAIN_EVENT_ID_DESC'
  | 'REFUND_AMOUNT_ASC'
  | 'REFUND_AMOUNT_DESC'
  | 'REFUND_VALUE_USD_ASC'
  | 'REFUND_VALUE_USD_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

export type OnChainSwapOutputAction =
  | 'CREDIT_ACCOUNT'
  | 'FUND_ACCOUNT';

/** A filter to be used against OnChainSwapOutputAction fields. All fields are combined with a logical ‘and.’ */
export type OnChainSwapOutputActionFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OnChainSwapOutputAction>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OnChainSwapOutputAction>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OnChainSwapOutputAction>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OnChainSwapOutputAction>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OnChainSwapOutputAction>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OnChainSwapOutputAction>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OnChainSwapOutputAction>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OnChainSwapOutputAction>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OnChainSwapOutputAction>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OnChainSwapOutputAction>>;
};

export type Operator = Node & {
  __typename?: 'Operator';
  /** Reads a single `Account` that is related to this `Operator`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `DelegationActivity`. */
  delegationActivitiesByOperatorId: DelegationActivitiesConnection;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `OperatorAction`. */
  operatorActionsByOperatorId: OperatorActionsConnection;
  /** Reads and enables pagination through a set of `OperatorEpochDelegationApy`. */
  operatorEpochDelegationApiesByOperatorId: OperatorEpochDelegationApiesConnection;
  /** Reads and enables pagination through a set of `OperatorEpoch`. */
  operatorEpochesByOperatorId: OperatorEpochesConnection;
  /** Reads and enables pagination through a set of `OperatorValidatorLink`. */
  operatorValidatorLinksByOperatorId: OperatorValidatorLinksConnection;
  /** Reads and enables pagination through a set of `Validator`. */
  validatorsByOperatorId: ValidatorsConnection;
};


export type OperatorDelegationActivitiesByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationActivityCondition>;
  filter?: InputMaybe<DelegationActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationActivitiesOrderBy>>;
};


export type OperatorOperatorActionsByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorActionCondition>;
  filter?: InputMaybe<OperatorActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorActionsOrderBy>>;
};


export type OperatorOperatorEpochDelegationApiesByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationApyCondition>;
  filter?: InputMaybe<OperatorEpochDelegationApyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationApiesOrderBy>>;
};


export type OperatorOperatorEpochesByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochCondition>;
  filter?: InputMaybe<OperatorEpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochesOrderBy>>;
};


export type OperatorOperatorValidatorLinksByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorLinkCondition>;
  filter?: InputMaybe<OperatorValidatorLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorLinksOrderBy>>;
};


export type OperatorValidatorsByOperatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};

export type OperatorAction = Node & {
  __typename?: 'OperatorAction';
  /** Reads a single `Account` that is related to this `OperatorAction`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `OperatorAction`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `OperatorAction`. */
  operatorByOperatorId: Operator;
  operatorId: Scalars['Int']['output'];
  timestamp: Scalars['Datetime']['output'];
  type: OperatorActionType;
};

export type OperatorActionAggregates = {
  __typename?: 'OperatorActionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorActionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorActionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorActionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorActionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorActionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorActionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorActionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorActionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorActionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorAction` object types. */
export type OperatorActionAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorAction` objects. */
  average?: InputMaybe<OperatorActionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorAction` objects. */
  distinctCount?: InputMaybe<OperatorActionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorAction` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorActionFilter>;
  /** Maximum aggregate over matching `OperatorAction` objects. */
  max?: InputMaybe<OperatorActionMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorAction` objects. */
  min?: InputMaybe<OperatorActionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorAction` objects. */
  stddevPopulation?: InputMaybe<OperatorActionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorAction` objects. */
  stddevSample?: InputMaybe<OperatorActionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorAction` objects. */
  sum?: InputMaybe<OperatorActionSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorAction` objects. */
  variancePopulation?: InputMaybe<OperatorActionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorAction` objects. */
  varianceSample?: InputMaybe<OperatorActionVarianceSampleAggregateFilter>;
};

export type OperatorActionAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorActionAverageAggregates = {
  __typename?: 'OperatorActionAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorAction` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OperatorActionCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<OperatorActionType>;
};

export type OperatorActionDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type OperatorActionDistinctCountAggregates = {
  __typename?: 'OperatorActionDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorAction` object types. All fields are combined with a logical ‘and.’ */
export type OperatorActionFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorActionFilter>>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorActionFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorActionFilter>>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<OperatorActionTypeFilter>;
};

/** Grouping methods for `OperatorAction` for usage during aggregation. */
export type OperatorActionGroupBy =
  | 'ACCOUNT_ID'
  | 'EVENT_ID'
  | 'OPERATOR_ID'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'TYPE';

export type OperatorActionHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `OperatorAction` aggregates. */
export type OperatorActionHavingInput = {
  AND?: InputMaybe<Array<OperatorActionHavingInput>>;
  OR?: InputMaybe<Array<OperatorActionHavingInput>>;
  average?: InputMaybe<OperatorActionHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorActionHavingDistinctCountInput>;
  max?: InputMaybe<OperatorActionHavingMaxInput>;
  min?: InputMaybe<OperatorActionHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorActionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorActionHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorActionHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorActionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorActionHavingVarianceSampleInput>;
};

export type OperatorActionHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OperatorActionMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type OperatorActionMaxAggregates = {
  __typename?: 'OperatorActionMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OperatorActionMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type OperatorActionMinAggregates = {
  __typename?: 'OperatorActionMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OperatorActionStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorActionStddevPopulationAggregates = {
  __typename?: 'OperatorActionStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorActionStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorActionStddevSampleAggregates = {
  __typename?: 'OperatorActionStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorActionSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorActionSumAggregates = {
  __typename?: 'OperatorActionSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
};

export type OperatorActionType =
  | 'ALLOW_DELEGATOR'
  | 'BLOCK_DELEGATOR';

/** A filter to be used against OperatorActionType fields. All fields are combined with a logical ‘and.’ */
export type OperatorActionTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<OperatorActionType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<OperatorActionType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<OperatorActionType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<OperatorActionType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<OperatorActionType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<OperatorActionType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<OperatorActionType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<OperatorActionType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<OperatorActionType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<OperatorActionType>>;
};

export type OperatorActionVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorActionVariancePopulationAggregates = {
  __typename?: 'OperatorActionVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorActionVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorActionVarianceSampleAggregates = {
  __typename?: 'OperatorActionVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorAction` values. */
export type OperatorActionsConnection = {
  __typename?: 'OperatorActionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorActionAggregates>;
  /** A list of edges which contains the `OperatorAction` and cursor to aid in pagination. */
  edges: Array<OperatorActionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorActionAggregates>>;
  /** A list of `OperatorAction` objects. */
  nodes: Array<OperatorAction>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorAction` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorAction` values. */
export type OperatorActionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorActionGroupBy>;
  having?: InputMaybe<OperatorActionHavingInput>;
};

/** A `OperatorAction` edge in the connection. */
export type OperatorActionsEdge = {
  __typename?: 'OperatorActionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorAction` at the end of the edge. */
  node: OperatorAction;
};

/** Methods to use when ordering `OperatorAction`. */
export type OperatorActionsOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type OperatorAggregates = {
  __typename?: 'OperatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorVarianceSampleAggregates>;
};

export type OperatorAverageAggregates = {
  __typename?: 'OperatorAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Operator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type OperatorCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorDistinctCountAggregates = {
  __typename?: 'OperatorDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
};

export type OperatorEpoch = Node & {
  __typename?: 'OperatorEpoch';
  commissionBps: Scalars['Int']['output'];
  delegatedAmount: Scalars['BigFloat']['output'];
  delegatedValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Epoch` that is related to this `OperatorEpoch`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `OperatorEpoch`. */
  operatorByOperatorId: Operator;
  /** Reads and enables pagination through a set of `OperatorEpochDelegation`. */
  operatorEpochDelegationsByOperatorEpochId: OperatorEpochDelegationsConnection;
  /** Reads and enables pagination through a set of `OperatorEpochValidator`. */
  operatorEpochValidatorsByOperatorEpochId: OperatorEpochValidatorsConnection;
  operatorId: Scalars['Int']['output'];
  operatorLossAmount: Scalars['BigFloat']['output'];
  operatorLossValueUsd: Scalars['BigFloat']['output'];
  operatorRewardAmount: Scalars['BigFloat']['output'];
  operatorRewardValueUsd: Scalars['BigFloat']['output'];
  stakedAmount: Scalars['BigFloat']['output'];
  stakedValueUsd: Scalars['BigFloat']['output'];
};


export type OperatorEpochOperatorEpochDelegationsByOperatorEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationCondition>;
  filter?: InputMaybe<OperatorEpochDelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationsOrderBy>>;
};


export type OperatorEpochOperatorEpochValidatorsByOperatorEpochIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochValidatorCondition>;
  filter?: InputMaybe<OperatorEpochValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochValidatorsOrderBy>>;
};

export type OperatorEpochAggregates = {
  __typename?: 'OperatorEpochAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorEpochAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorEpochDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorEpochMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorEpochMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorEpochStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorEpochStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorEpochSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorEpochVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorEpochVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorEpoch` object types. */
export type OperatorEpochAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorEpoch` objects. */
  average?: InputMaybe<OperatorEpochAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorEpoch` objects. */
  distinctCount?: InputMaybe<OperatorEpochDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorEpoch` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorEpochFilter>;
  /** Maximum aggregate over matching `OperatorEpoch` objects. */
  max?: InputMaybe<OperatorEpochMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorEpoch` objects. */
  min?: InputMaybe<OperatorEpochMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorEpoch` objects. */
  stddevPopulation?: InputMaybe<OperatorEpochStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorEpoch` objects. */
  stddevSample?: InputMaybe<OperatorEpochStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorEpoch` objects. */
  sum?: InputMaybe<OperatorEpochSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorEpoch` objects. */
  variancePopulation?: InputMaybe<OperatorEpochVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorEpoch` objects. */
  varianceSample?: InputMaybe<OperatorEpochVarianceSampleAggregateFilter>;
};

export type OperatorEpochAverageAggregateFilter = {
  commissionBps?: InputMaybe<BigFloatFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochAverageAggregates = {
  __typename?: 'OperatorEpochAverageAggregates';
  /** Mean average of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorEpoch` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type OperatorEpochCondition = {
  /** Checks for equality with the object’s `commissionBps` field. */
  commissionBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `delegatedAmount` field. */
  delegatedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `delegatedValueUsd` field. */
  delegatedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `operatorLossAmount` field. */
  operatorLossAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `operatorLossValueUsd` field. */
  operatorLossValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `operatorRewardAmount` field. */
  operatorRewardAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `operatorRewardValueUsd` field. */
  operatorRewardValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stakedAmount` field. */
  stakedAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `stakedValueUsd` field. */
  stakedValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type OperatorEpochDelegation = Node & {
  __typename?: 'OperatorEpochDelegation';
  /** Reads a single `Account` that is related to this `OperatorEpochDelegation`. */
  accountByDelegatorAccountId: Account;
  amount: Scalars['BigFloat']['output'];
  delegatorAccountId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  losses: Scalars['BigFloat']['output'];
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OperatorEpoch` that is related to this `OperatorEpochDelegation`. */
  operatorEpochByOperatorEpochId: OperatorEpoch;
  operatorEpochId: Scalars['Int']['output'];
  rewards: Scalars['BigFloat']['output'];
  rewardsValueUsd: Scalars['BigFloat']['output'];
  valueUsd: Scalars['BigFloat']['output'];
};

export type OperatorEpochDelegationAggregates = {
  __typename?: 'OperatorEpochDelegationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorEpochDelegationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorEpochDelegationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorEpochDelegationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorEpochDelegationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorEpochDelegationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorEpochDelegationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorEpochDelegationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorEpochDelegationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorEpochDelegationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorEpochDelegation` object types. */
export type OperatorEpochDelegationAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorEpochDelegation` objects. */
  average?: InputMaybe<OperatorEpochDelegationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorEpochDelegation` objects. */
  distinctCount?: InputMaybe<OperatorEpochDelegationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorEpochDelegation` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorEpochDelegationFilter>;
  /** Maximum aggregate over matching `OperatorEpochDelegation` objects. */
  max?: InputMaybe<OperatorEpochDelegationMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorEpochDelegation` objects. */
  min?: InputMaybe<OperatorEpochDelegationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorEpochDelegation` objects. */
  stddevPopulation?: InputMaybe<OperatorEpochDelegationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorEpochDelegation` objects. */
  stddevSample?: InputMaybe<OperatorEpochDelegationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorEpochDelegation` objects. */
  sum?: InputMaybe<OperatorEpochDelegationSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorEpochDelegation` objects. */
  variancePopulation?: InputMaybe<OperatorEpochDelegationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorEpochDelegation` objects. */
  varianceSample?: InputMaybe<OperatorEpochDelegationVarianceSampleAggregateFilter>;
};

/** A connection to a list of `OperatorEpochDelegationApy` values. */
export type OperatorEpochDelegationApiesConnection = {
  __typename?: 'OperatorEpochDelegationApiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorEpochDelegationApyAggregates>;
  /** A list of edges which contains the `OperatorEpochDelegationApy` and cursor to aid in pagination. */
  edges: Array<OperatorEpochDelegationApiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorEpochDelegationApyAggregates>>;
  /** A list of `OperatorEpochDelegationApy` objects. */
  nodes: Array<OperatorEpochDelegationApy>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorEpochDelegationApy` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorEpochDelegationApy` values. */
export type OperatorEpochDelegationApiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorEpochDelegationApyGroupBy>;
  having?: InputMaybe<OperatorEpochDelegationApyHavingInput>;
};

/** A `OperatorEpochDelegationApy` edge in the connection. */
export type OperatorEpochDelegationApiesEdge = {
  __typename?: 'OperatorEpochDelegationApiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorEpochDelegationApy` at the end of the edge. */
  node: OperatorEpochDelegationApy;
};

/** Methods to use when ordering `OperatorEpochDelegationApy`. */
export type OperatorEpochDelegationApiesOrderBy =
  | 'APY_BP_ASC'
  | 'APY_BP_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC';

export type OperatorEpochDelegationApy = {
  __typename?: 'OperatorEpochDelegationApy';
  apyBp: Scalars['Int']['output'];
  /** Reads a single `Epoch` that is related to this `OperatorEpochDelegationApy`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  /** Reads a single `Operator` that is related to this `OperatorEpochDelegationApy`. */
  operatorByOperatorId: Operator;
  operatorId: Scalars['Int']['output'];
};

export type OperatorEpochDelegationApyAggregates = {
  __typename?: 'OperatorEpochDelegationApyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorEpochDelegationApyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorEpochDelegationApyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorEpochDelegationApyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorEpochDelegationApyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorEpochDelegationApyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorEpochDelegationApyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorEpochDelegationApySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorEpochDelegationApyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorEpochDelegationApyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorEpochDelegationApy` object types. */
export type OperatorEpochDelegationApyAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorEpochDelegationApy` objects. */
  average?: InputMaybe<OperatorEpochDelegationApyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorEpochDelegationApy` objects. */
  distinctCount?: InputMaybe<OperatorEpochDelegationApyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorEpochDelegationApy` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** Maximum aggregate over matching `OperatorEpochDelegationApy` objects. */
  max?: InputMaybe<OperatorEpochDelegationApyMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorEpochDelegationApy` objects. */
  min?: InputMaybe<OperatorEpochDelegationApyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorEpochDelegationApy` objects. */
  stddevPopulation?: InputMaybe<OperatorEpochDelegationApyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorEpochDelegationApy` objects. */
  stddevSample?: InputMaybe<OperatorEpochDelegationApyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorEpochDelegationApy` objects. */
  sum?: InputMaybe<OperatorEpochDelegationApySumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorEpochDelegationApy` objects. */
  variancePopulation?: InputMaybe<OperatorEpochDelegationApyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorEpochDelegationApy` objects. */
  varianceSample?: InputMaybe<OperatorEpochDelegationApyVarianceSampleAggregateFilter>;
};

export type OperatorEpochDelegationApyAverageAggregateFilter = {
  apyBp?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationApyAverageAggregates = {
  __typename?: 'OperatorEpochDelegationApyAverageAggregates';
  /** Mean average of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorEpochDelegationApy` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OperatorEpochDelegationApyCondition = {
  /** Checks for equality with the object’s `apyBp` field. */
  apyBp?: InputMaybe<Scalars['Int']['input']>;
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorEpochDelegationApyDistinctCountAggregateFilter = {
  apyBp?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochDelegationApyDistinctCountAggregates = {
  __typename?: 'OperatorEpochDelegationApyDistinctCountAggregates';
  /** Distinct count of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorEpochDelegationApy` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochDelegationApyFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorEpochDelegationApyFilter>>;
  /** Filter by the object’s `apyBp` field. */
  apyBp?: InputMaybe<IntFilter>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorEpochDelegationApyFilter>>;
};

/** Grouping methods for `OperatorEpochDelegationApy` for usage during aggregation. */
export type OperatorEpochDelegationApyGroupBy =
  | 'APY_BP'
  | 'EPOCH_ID'
  | 'OPERATOR_ID';

export type OperatorEpochDelegationApyHavingAverageInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingDistinctCountInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OperatorEpochDelegationApy` aggregates. */
export type OperatorEpochDelegationApyHavingInput = {
  AND?: InputMaybe<Array<OperatorEpochDelegationApyHavingInput>>;
  OR?: InputMaybe<Array<OperatorEpochDelegationApyHavingInput>>;
  average?: InputMaybe<OperatorEpochDelegationApyHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorEpochDelegationApyHavingDistinctCountInput>;
  max?: InputMaybe<OperatorEpochDelegationApyHavingMaxInput>;
  min?: InputMaybe<OperatorEpochDelegationApyHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorEpochDelegationApyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorEpochDelegationApyHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorEpochDelegationApyHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorEpochDelegationApyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorEpochDelegationApyHavingVarianceSampleInput>;
};

export type OperatorEpochDelegationApyHavingMaxInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingMinInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingStddevPopulationInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingStddevSampleInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingSumInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingVariancePopulationInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyHavingVarianceSampleInput = {
  apyBp?: InputMaybe<HavingIntFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochDelegationApyMaxAggregateFilter = {
  apyBp?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
};

export type OperatorEpochDelegationApyMaxAggregates = {
  __typename?: 'OperatorEpochDelegationApyMaxAggregates';
  /** Maximum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorEpochDelegationApyMinAggregateFilter = {
  apyBp?: InputMaybe<IntFilter>;
  epochId?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
};

export type OperatorEpochDelegationApyMinAggregates = {
  __typename?: 'OperatorEpochDelegationApyMinAggregates';
  /** Minimum of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['Int']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorEpochDelegationApyStddevPopulationAggregateFilter = {
  apyBp?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationApyStddevPopulationAggregates = {
  __typename?: 'OperatorEpochDelegationApyStddevPopulationAggregates';
  /** Population standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationApyStddevSampleAggregateFilter = {
  apyBp?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationApyStddevSampleAggregates = {
  __typename?: 'OperatorEpochDelegationApyStddevSampleAggregates';
  /** Sample standard deviation of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationApySumAggregateFilter = {
  apyBp?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochDelegationApySumAggregates = {
  __typename?: 'OperatorEpochDelegationApySumAggregates';
  /** Sum of apyBp across the matching connection */
  apyBp: Scalars['BigInt']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
};

export type OperatorEpochDelegationApyVariancePopulationAggregateFilter = {
  apyBp?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationApyVariancePopulationAggregates = {
  __typename?: 'OperatorEpochDelegationApyVariancePopulationAggregates';
  /** Population variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationApyVarianceSampleAggregateFilter = {
  apyBp?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationApyVarianceSampleAggregates = {
  __typename?: 'OperatorEpochDelegationApyVarianceSampleAggregates';
  /** Sample variance of apyBp across the matching connection */
  apyBp?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationAverageAggregates = {
  __typename?: 'OperatorEpochDelegationAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorEpochDelegation` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type OperatorEpochDelegationCondition = {
  accountByDelegatorAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `losses` field. */
  losses?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  operatorEpochByOperatorEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorEpochId` field. */
  operatorEpochId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `rewards` field. */
  rewards?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `rewardsValueUsd` field. */
  rewardsValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type OperatorEpochDelegationDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  delegatorAccountId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigIntFilter>;
  lossesValueUsd?: InputMaybe<BigIntFilter>;
  operatorEpochId?: InputMaybe<BigIntFilter>;
  rewards?: InputMaybe<BigIntFilter>;
  rewardsValueUsd?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochDelegationDistinctCountAggregates = {
  __typename?: 'OperatorEpochDelegationDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of losses across the matching connection */
  losses?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorEpochDelegation` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochDelegationFilter = {
  /** Filter by the object’s `accountByDelegatorAccountId` relation. */
  accountByDelegatorAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorEpochDelegationFilter>>;
  /** Filter by the object’s `delegatorAccountId` field. */
  delegatorAccountId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `losses` field. */
  losses?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `lossesValueUsd` field. */
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorEpochDelegationFilter>;
  /** Filter by the object’s `operatorEpochByOperatorEpochId` relation. */
  operatorEpochByOperatorEpochId?: InputMaybe<OperatorEpochFilter>;
  /** Filter by the object’s `operatorEpochId` field. */
  operatorEpochId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorEpochDelegationFilter>>;
  /** Filter by the object’s `rewards` field. */
  rewards?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `rewardsValueUsd` field. */
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `OperatorEpochDelegation` for usage during aggregation. */
export type OperatorEpochDelegationGroupBy =
  | 'AMOUNT'
  | 'DELEGATOR_ACCOUNT_ID'
  | 'LOSSES'
  | 'LOSSES_VALUE_USD'
  | 'OPERATOR_EPOCH_ID'
  | 'REWARDS'
  | 'REWARDS_VALUE_USD'
  | 'VALUE_USD';

export type OperatorEpochDelegationHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `OperatorEpochDelegation` aggregates. */
export type OperatorEpochDelegationHavingInput = {
  AND?: InputMaybe<Array<OperatorEpochDelegationHavingInput>>;
  OR?: InputMaybe<Array<OperatorEpochDelegationHavingInput>>;
  average?: InputMaybe<OperatorEpochDelegationHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorEpochDelegationHavingDistinctCountInput>;
  max?: InputMaybe<OperatorEpochDelegationHavingMaxInput>;
  min?: InputMaybe<OperatorEpochDelegationHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorEpochDelegationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorEpochDelegationHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorEpochDelegationHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorEpochDelegationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorEpochDelegationHavingVarianceSampleInput>;
};

export type OperatorEpochDelegationHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  delegatorAccountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  losses?: InputMaybe<HavingBigfloatFilter>;
  lossesValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  rewards?: InputMaybe<HavingBigfloatFilter>;
  rewardsValueUsd?: InputMaybe<HavingBigfloatFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochDelegationMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<IntFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationMaxAggregates = {
  __typename?: 'OperatorEpochDelegationMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<IntFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationMinAggregates = {
  __typename?: 'OperatorEpochDelegationMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationStddevPopulationAggregates = {
  __typename?: 'OperatorEpochDelegationStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationStddevSampleAggregates = {
  __typename?: 'OperatorEpochDelegationStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigIntFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationSumAggregates = {
  __typename?: 'OperatorEpochDelegationSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of delegatorAccountId across the matching connection */
  delegatorAccountId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of losses across the matching connection */
  losses: Scalars['BigFloat']['output'];
  /** Sum of lossesValueUsd across the matching connection */
  lossesValueUsd: Scalars['BigFloat']['output'];
  /** Sum of operatorEpochId across the matching connection */
  operatorEpochId: Scalars['BigInt']['output'];
  /** Sum of rewards across the matching connection */
  rewards: Scalars['BigFloat']['output'];
  /** Sum of rewardsValueUsd across the matching connection */
  rewardsValueUsd: Scalars['BigFloat']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type OperatorEpochDelegationVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationVariancePopulationAggregates = {
  __typename?: 'OperatorEpochDelegationVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochDelegationVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  delegatorAccountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  losses?: InputMaybe<BigFloatFilter>;
  lossesValueUsd?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  rewards?: InputMaybe<BigFloatFilter>;
  rewardsValueUsd?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochDelegationVarianceSampleAggregates = {
  __typename?: 'OperatorEpochDelegationVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegatorAccountId across the matching connection */
  delegatorAccountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of losses across the matching connection */
  losses?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lossesValueUsd across the matching connection */
  lossesValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rewards across the matching connection */
  rewards?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of rewardsValueUsd across the matching connection */
  rewardsValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorEpochDelegation` values. */
export type OperatorEpochDelegationsConnection = {
  __typename?: 'OperatorEpochDelegationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorEpochDelegationAggregates>;
  /** A list of edges which contains the `OperatorEpochDelegation` and cursor to aid in pagination. */
  edges: Array<OperatorEpochDelegationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorEpochDelegationAggregates>>;
  /** A list of `OperatorEpochDelegation` objects. */
  nodes: Array<OperatorEpochDelegation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorEpochDelegation` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorEpochDelegation` values. */
export type OperatorEpochDelegationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorEpochDelegationGroupBy>;
  having?: InputMaybe<OperatorEpochDelegationHavingInput>;
};

/** A `OperatorEpochDelegation` edge in the connection. */
export type OperatorEpochDelegationsEdge = {
  __typename?: 'OperatorEpochDelegationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorEpochDelegation` at the end of the edge. */
  node: OperatorEpochDelegation;
};

/** Methods to use when ordering `OperatorEpochDelegation`. */
export type OperatorEpochDelegationsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATOR_ACCOUNT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOSSES_ASC'
  | 'LOSSES_DESC'
  | 'LOSSES_VALUE_USD_ASC'
  | 'LOSSES_VALUE_USD_DESC'
  | 'NATURAL'
  | 'OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REWARDS_ASC'
  | 'REWARDS_DESC'
  | 'REWARDS_VALUE_USD_ASC'
  | 'REWARDS_VALUE_USD_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

export type OperatorEpochDistinctCountAggregateFilter = {
  commissionBps?: InputMaybe<BigIntFilter>;
  delegatedAmount?: InputMaybe<BigIntFilter>;
  delegatedValueUsd?: InputMaybe<BigIntFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  operatorLossAmount?: InputMaybe<BigIntFilter>;
  operatorLossValueUsd?: InputMaybe<BigIntFilter>;
  operatorRewardAmount?: InputMaybe<BigIntFilter>;
  operatorRewardValueUsd?: InputMaybe<BigIntFilter>;
  stakedAmount?: InputMaybe<BigIntFilter>;
  stakedValueUsd?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochDistinctCountAggregates = {
  __typename?: 'OperatorEpochDistinctCountAggregates';
  /** Distinct count of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorEpoch` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorEpochFilter>>;
  /** Filter by the object’s `commissionBps` field. */
  commissionBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `delegatedAmount` field. */
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `delegatedValueUsd` field. */
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorEpochFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorEpochDelegationsByOperatorEpochId` relation. */
  operatorEpochDelegationsByOperatorEpochId?: InputMaybe<OperatorEpochToManyOperatorEpochDelegationFilter>;
  /** Some related `operatorEpochDelegationsByOperatorEpochId` exist. */
  operatorEpochDelegationsByOperatorEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochValidatorsByOperatorEpochId` relation. */
  operatorEpochValidatorsByOperatorEpochId?: InputMaybe<OperatorEpochToManyOperatorEpochValidatorFilter>;
  /** Some related `operatorEpochValidatorsByOperatorEpochId` exist. */
  operatorEpochValidatorsByOperatorEpochIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `operatorLossAmount` field. */
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `operatorLossValueUsd` field. */
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `operatorRewardAmount` field. */
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `operatorRewardValueUsd` field. */
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorEpochFilter>>;
  /** Filter by the object’s `stakedAmount` field. */
  stakedAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `stakedValueUsd` field. */
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `OperatorEpoch` for usage during aggregation. */
export type OperatorEpochGroupBy =
  | 'COMMISSION_BPS'
  | 'DELEGATED_AMOUNT'
  | 'DELEGATED_VALUE_USD'
  | 'EPOCH_ID'
  | 'OPERATOR_ID'
  | 'OPERATOR_LOSS_AMOUNT'
  | 'OPERATOR_LOSS_VALUE_USD'
  | 'OPERATOR_REWARD_AMOUNT'
  | 'OPERATOR_REWARD_VALUE_USD'
  | 'STAKED_AMOUNT'
  | 'STAKED_VALUE_USD';

export type OperatorEpochHavingAverageInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingDistinctCountInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `OperatorEpoch` aggregates. */
export type OperatorEpochHavingInput = {
  AND?: InputMaybe<Array<OperatorEpochHavingInput>>;
  OR?: InputMaybe<Array<OperatorEpochHavingInput>>;
  average?: InputMaybe<OperatorEpochHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorEpochHavingDistinctCountInput>;
  max?: InputMaybe<OperatorEpochHavingMaxInput>;
  min?: InputMaybe<OperatorEpochHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorEpochHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorEpochHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorEpochHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorEpochHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorEpochHavingVarianceSampleInput>;
};

export type OperatorEpochHavingMaxInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingMinInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingStddevPopulationInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingStddevSampleInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingSumInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingVariancePopulationInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochHavingVarianceSampleInput = {
  commissionBps?: InputMaybe<HavingIntFilter>;
  delegatedAmount?: InputMaybe<HavingBigfloatFilter>;
  delegatedValueUsd?: InputMaybe<HavingBigfloatFilter>;
  epochId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  operatorLossAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorLossValueUsd?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardAmount?: InputMaybe<HavingBigfloatFilter>;
  operatorRewardValueUsd?: InputMaybe<HavingBigfloatFilter>;
  stakedAmount?: InputMaybe<HavingBigfloatFilter>;
  stakedValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type OperatorEpochMaxAggregateFilter = {
  commissionBps?: InputMaybe<IntFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochMaxAggregates = {
  __typename?: 'OperatorEpochMaxAggregates';
  /** Maximum of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochMinAggregateFilter = {
  commissionBps?: InputMaybe<IntFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochMinAggregates = {
  __typename?: 'OperatorEpochMinAggregates';
  /** Minimum of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochStddevPopulationAggregateFilter = {
  commissionBps?: InputMaybe<BigFloatFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochStddevPopulationAggregates = {
  __typename?: 'OperatorEpochStddevPopulationAggregates';
  /** Population standard deviation of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochStddevSampleAggregateFilter = {
  commissionBps?: InputMaybe<BigFloatFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochStddevSampleAggregates = {
  __typename?: 'OperatorEpochStddevSampleAggregates';
  /** Sample standard deviation of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochSumAggregateFilter = {
  commissionBps?: InputMaybe<BigIntFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochSumAggregates = {
  __typename?: 'OperatorEpochSumAggregates';
  /** Sum of commissionBps across the matching connection */
  commissionBps: Scalars['BigInt']['output'];
  /** Sum of delegatedAmount across the matching connection */
  delegatedAmount: Scalars['BigFloat']['output'];
  /** Sum of delegatedValueUsd across the matching connection */
  delegatedValueUsd: Scalars['BigFloat']['output'];
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
  /** Sum of operatorLossAmount across the matching connection */
  operatorLossAmount: Scalars['BigFloat']['output'];
  /** Sum of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd: Scalars['BigFloat']['output'];
  /** Sum of operatorRewardAmount across the matching connection */
  operatorRewardAmount: Scalars['BigFloat']['output'];
  /** Sum of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd: Scalars['BigFloat']['output'];
  /** Sum of stakedAmount across the matching connection */
  stakedAmount: Scalars['BigFloat']['output'];
  /** Sum of stakedValueUsd across the matching connection */
  stakedValueUsd: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `OperatorEpochDelegation` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochToManyOperatorEpochDelegationFilter = {
  /** Aggregates across related `OperatorEpochDelegation` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochDelegationAggregatesFilter>;
  /** Every related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochDelegationFilter>;
  /** No related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochDelegationFilter>;
  /** Some related `OperatorEpochDelegation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochDelegationFilter>;
};

/** A filter to be used against many `OperatorEpochValidator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochToManyOperatorEpochValidatorFilter = {
  /** Aggregates across related `OperatorEpochValidator` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochValidatorAggregatesFilter>;
  /** Every related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochValidatorFilter>;
  /** No related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochValidatorFilter>;
  /** Some related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochValidatorFilter>;
};

export type OperatorEpochValidator = Node & {
  __typename?: 'OperatorEpochValidator';
  /** Reads a single `AuthorityMembership` that is related to this `OperatorEpochValidator`. */
  authorityMembershipByAuthorityMembershipId: AuthorityMembership;
  authorityMembershipId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OperatorEpoch` that is related to this `OperatorEpochValidator`. */
  operatorEpochByOperatorEpochId: OperatorEpoch;
  operatorEpochId: Scalars['Int']['output'];
  /** Reads a single `Validator` that is related to this `OperatorEpochValidator`. */
  validatorByValidatorId: Validator;
  validatorId: Scalars['Int']['output'];
};

export type OperatorEpochValidatorAggregates = {
  __typename?: 'OperatorEpochValidatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorEpochValidatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorEpochValidatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorEpochValidatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorEpochValidatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorEpochValidatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorEpochValidatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorEpochValidatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorEpochValidatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorEpochValidatorVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorEpochValidator` object types. */
export type OperatorEpochValidatorAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorEpochValidator` objects. */
  average?: InputMaybe<OperatorEpochValidatorAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorEpochValidator` objects. */
  distinctCount?: InputMaybe<OperatorEpochValidatorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorEpochValidator` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorEpochValidatorFilter>;
  /** Maximum aggregate over matching `OperatorEpochValidator` objects. */
  max?: InputMaybe<OperatorEpochValidatorMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorEpochValidator` objects. */
  min?: InputMaybe<OperatorEpochValidatorMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorEpochValidator` objects. */
  stddevPopulation?: InputMaybe<OperatorEpochValidatorStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorEpochValidator` objects. */
  stddevSample?: InputMaybe<OperatorEpochValidatorStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorEpochValidator` objects. */
  sum?: InputMaybe<OperatorEpochValidatorSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorEpochValidator` objects. */
  variancePopulation?: InputMaybe<OperatorEpochValidatorVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorEpochValidator` objects. */
  varianceSample?: InputMaybe<OperatorEpochValidatorVarianceSampleAggregateFilter>;
};

export type OperatorEpochValidatorAverageAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochValidatorAverageAggregates = {
  __typename?: 'OperatorEpochValidatorAverageAggregates';
  /** Mean average of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorEpochValidator` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OperatorEpochValidatorCondition = {
  authorityMembershipByAuthorityMembershipId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `authorityMembershipId` field. */
  authorityMembershipId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorEpochByOperatorEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorEpochId` field. */
  operatorEpochId?: InputMaybe<Scalars['Int']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorEpochValidatorDistinctCountAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorEpochId?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochValidatorDistinctCountAggregates = {
  __typename?: 'OperatorEpochValidatorDistinctCountAggregates';
  /** Distinct count of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorEpochValidator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorEpochValidatorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorEpochValidatorFilter>>;
  /** Filter by the object’s `authorityMembershipByAuthorityMembershipId` relation. */
  authorityMembershipByAuthorityMembershipId?: InputMaybe<AuthorityMembershipFilter>;
  /** Filter by the object’s `authorityMembershipId` field. */
  authorityMembershipId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorEpochValidatorFilter>;
  /** Filter by the object’s `operatorEpochByOperatorEpochId` relation. */
  operatorEpochByOperatorEpochId?: InputMaybe<OperatorEpochFilter>;
  /** Filter by the object’s `operatorEpochId` field. */
  operatorEpochId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorEpochValidatorFilter>>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `OperatorEpochValidator` for usage during aggregation. */
export type OperatorEpochValidatorGroupBy =
  | 'OPERATOR_EPOCH_ID'
  | 'VALIDATOR_ID';

export type OperatorEpochValidatorHavingAverageInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingDistinctCountInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OperatorEpochValidator` aggregates. */
export type OperatorEpochValidatorHavingInput = {
  AND?: InputMaybe<Array<OperatorEpochValidatorHavingInput>>;
  OR?: InputMaybe<Array<OperatorEpochValidatorHavingInput>>;
  average?: InputMaybe<OperatorEpochValidatorHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorEpochValidatorHavingDistinctCountInput>;
  max?: InputMaybe<OperatorEpochValidatorHavingMaxInput>;
  min?: InputMaybe<OperatorEpochValidatorHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorEpochValidatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorEpochValidatorHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorEpochValidatorHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorEpochValidatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorEpochValidatorHavingVarianceSampleInput>;
};

export type OperatorEpochValidatorHavingMaxInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingMinInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingStddevPopulationInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingStddevSampleInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingSumInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingVariancePopulationInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorHavingVarianceSampleInput = {
  authorityMembershipId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorEpochId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorEpochValidatorMaxAggregateFilter = {
  authorityMembershipId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorEpochId?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type OperatorEpochValidatorMaxAggregates = {
  __typename?: 'OperatorEpochValidatorMaxAggregates';
  /** Maximum of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorEpochValidatorMinAggregateFilter = {
  authorityMembershipId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorEpochId?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type OperatorEpochValidatorMinAggregates = {
  __typename?: 'OperatorEpochValidatorMinAggregates';
  /** Minimum of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorEpochValidatorStddevPopulationAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochValidatorStddevPopulationAggregates = {
  __typename?: 'OperatorEpochValidatorStddevPopulationAggregates';
  /** Population standard deviation of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochValidatorStddevSampleAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochValidatorStddevSampleAggregates = {
  __typename?: 'OperatorEpochValidatorStddevSampleAggregates';
  /** Sample standard deviation of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochValidatorSumAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorEpochId?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorEpochValidatorSumAggregates = {
  __typename?: 'OperatorEpochValidatorSumAggregates';
  /** Sum of authorityMembershipId across the matching connection */
  authorityMembershipId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of operatorEpochId across the matching connection */
  operatorEpochId: Scalars['BigInt']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

export type OperatorEpochValidatorVariancePopulationAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochValidatorVariancePopulationAggregates = {
  __typename?: 'OperatorEpochValidatorVariancePopulationAggregates';
  /** Population variance of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochValidatorVarianceSampleAggregateFilter = {
  authorityMembershipId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorEpochId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochValidatorVarianceSampleAggregates = {
  __typename?: 'OperatorEpochValidatorVarianceSampleAggregates';
  /** Sample variance of authorityMembershipId across the matching connection */
  authorityMembershipId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorEpochId across the matching connection */
  operatorEpochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorEpochValidator` values. */
export type OperatorEpochValidatorsConnection = {
  __typename?: 'OperatorEpochValidatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorEpochValidatorAggregates>;
  /** A list of edges which contains the `OperatorEpochValidator` and cursor to aid in pagination. */
  edges: Array<OperatorEpochValidatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorEpochValidatorAggregates>>;
  /** A list of `OperatorEpochValidator` objects. */
  nodes: Array<OperatorEpochValidator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorEpochValidator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorEpochValidator` values. */
export type OperatorEpochValidatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorEpochValidatorGroupBy>;
  having?: InputMaybe<OperatorEpochValidatorHavingInput>;
};

/** A `OperatorEpochValidator` edge in the connection. */
export type OperatorEpochValidatorsEdge = {
  __typename?: 'OperatorEpochValidatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorEpochValidator` at the end of the edge. */
  node: OperatorEpochValidator;
};

/** Methods to use when ordering `OperatorEpochValidator`. */
export type OperatorEpochValidatorsOrderBy =
  | 'AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

export type OperatorEpochVariancePopulationAggregateFilter = {
  commissionBps?: InputMaybe<BigFloatFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochVariancePopulationAggregates = {
  __typename?: 'OperatorEpochVariancePopulationAggregates';
  /** Population variance of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorEpochVarianceSampleAggregateFilter = {
  commissionBps?: InputMaybe<BigFloatFilter>;
  delegatedAmount?: InputMaybe<BigFloatFilter>;
  delegatedValueUsd?: InputMaybe<BigFloatFilter>;
  epochId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  operatorLossAmount?: InputMaybe<BigFloatFilter>;
  operatorLossValueUsd?: InputMaybe<BigFloatFilter>;
  operatorRewardAmount?: InputMaybe<BigFloatFilter>;
  operatorRewardValueUsd?: InputMaybe<BigFloatFilter>;
  stakedAmount?: InputMaybe<BigFloatFilter>;
  stakedValueUsd?: InputMaybe<BigFloatFilter>;
};

export type OperatorEpochVarianceSampleAggregates = {
  __typename?: 'OperatorEpochVarianceSampleAggregates';
  /** Sample variance of commissionBps across the matching connection */
  commissionBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegatedAmount across the matching connection */
  delegatedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of delegatedValueUsd across the matching connection */
  delegatedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorLossAmount across the matching connection */
  operatorLossAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorLossValueUsd across the matching connection */
  operatorLossValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorRewardAmount across the matching connection */
  operatorRewardAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorRewardValueUsd across the matching connection */
  operatorRewardValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stakedAmount across the matching connection */
  stakedAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of stakedValueUsd across the matching connection */
  stakedValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorEpoch` values. */
export type OperatorEpochesConnection = {
  __typename?: 'OperatorEpochesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorEpochAggregates>;
  /** A list of edges which contains the `OperatorEpoch` and cursor to aid in pagination. */
  edges: Array<OperatorEpochesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorEpochAggregates>>;
  /** A list of `OperatorEpoch` objects. */
  nodes: Array<OperatorEpoch>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorEpoch` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorEpoch` values. */
export type OperatorEpochesConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorEpochGroupBy>;
  having?: InputMaybe<OperatorEpochHavingInput>;
};

/** A `OperatorEpoch` edge in the connection. */
export type OperatorEpochesEdge = {
  __typename?: 'OperatorEpochesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorEpoch` at the end of the edge. */
  node: OperatorEpoch;
};

/** Methods to use when ordering `OperatorEpoch`. */
export type OperatorEpochesOrderBy =
  | 'COMMISSION_BPS_ASC'
  | 'COMMISSION_BPS_DESC'
  | 'DELEGATED_AMOUNT_ASC'
  | 'DELEGATED_AMOUNT_DESC'
  | 'DELEGATED_VALUE_USD_ASC'
  | 'DELEGATED_VALUE_USD_DESC'
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_AVERAGE_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MAX_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_MIN_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_SUM_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_LOSSES_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_LOSSES_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_LOSSES_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_REWARDS_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_REWARDS_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_REWARDS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_REWARDS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'OPERATOR_EPOCH_DELEGATIONS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MAX_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_MIN_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_SUM_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_OPERATOR_EPOCH_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC'
  | 'OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_REWARD_VALUE_USD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STAKED_AMOUNT_ASC'
  | 'STAKED_AMOUNT_DESC'
  | 'STAKED_VALUE_USD_ASC'
  | 'STAKED_VALUE_USD_DESC';

/** A filter to be used against `Operator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorFilter>>;
  /** Filter by the object’s `delegationActivitiesByOperatorId` relation. */
  delegationActivitiesByOperatorId?: InputMaybe<OperatorToManyDelegationActivityFilter>;
  /** Some related `delegationActivitiesByOperatorId` exist. */
  delegationActivitiesByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorActionsByOperatorId` relation. */
  operatorActionsByOperatorId?: InputMaybe<OperatorToManyOperatorActionFilter>;
  /** Some related `operatorActionsByOperatorId` exist. */
  operatorActionsByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochDelegationApiesByOperatorId` relation. */
  operatorEpochDelegationApiesByOperatorId?: InputMaybe<OperatorToManyOperatorEpochDelegationApyFilter>;
  /** Some related `operatorEpochDelegationApiesByOperatorId` exist. */
  operatorEpochDelegationApiesByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochesByOperatorId` relation. */
  operatorEpochesByOperatorId?: InputMaybe<OperatorToManyOperatorEpochFilter>;
  /** Some related `operatorEpochesByOperatorId` exist. */
  operatorEpochesByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorValidatorLinksByOperatorId` relation. */
  operatorValidatorLinksByOperatorId?: InputMaybe<OperatorToManyOperatorValidatorLinkFilter>;
  /** Some related `operatorValidatorLinksByOperatorId` exist. */
  operatorValidatorLinksByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorFilter>>;
  /** Filter by the object’s `validatorsByOperatorId` relation. */
  validatorsByOperatorId?: InputMaybe<OperatorToManyValidatorFilter>;
  /** Some related `validatorsByOperatorId` exist. */
  validatorsByOperatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OperatorMaxAggregates = {
  __typename?: 'OperatorMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type OperatorMinAggregates = {
  __typename?: 'OperatorMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type OperatorStddevPopulationAggregates = {
  __typename?: 'OperatorStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorStddevSampleAggregates = {
  __typename?: 'OperatorStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorSumAggregates = {
  __typename?: 'OperatorSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `DelegationActivity` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyDelegationActivityFilter = {
  /** Aggregates across related `DelegationActivity` match the filter criteria. */
  aggregates?: InputMaybe<DelegationActivityAggregatesFilter>;
  /** Every related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DelegationActivityFilter>;
  /** No related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DelegationActivityFilter>;
  /** Some related `DelegationActivity` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DelegationActivityFilter>;
};

/** A filter to be used against many `OperatorAction` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyOperatorActionFilter = {
  /** Aggregates across related `OperatorAction` match the filter criteria. */
  aggregates?: InputMaybe<OperatorActionAggregatesFilter>;
  /** Every related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorActionFilter>;
  /** No related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorActionFilter>;
  /** Some related `OperatorAction` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorActionFilter>;
};

/** A filter to be used against many `OperatorEpochDelegationApy` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyOperatorEpochDelegationApyFilter = {
  /** Aggregates across related `OperatorEpochDelegationApy` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochDelegationApyAggregatesFilter>;
  /** Every related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** No related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochDelegationApyFilter>;
  /** Some related `OperatorEpochDelegationApy` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochDelegationApyFilter>;
};

/** A filter to be used against many `OperatorEpoch` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyOperatorEpochFilter = {
  /** Aggregates across related `OperatorEpoch` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochAggregatesFilter>;
  /** Every related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochFilter>;
  /** No related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochFilter>;
  /** Some related `OperatorEpoch` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochFilter>;
};

/** A filter to be used against many `OperatorValidatorLink` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyOperatorValidatorLinkFilter = {
  /** Aggregates across related `OperatorValidatorLink` match the filter criteria. */
  aggregates?: InputMaybe<OperatorValidatorLinkAggregatesFilter>;
  /** Every related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorValidatorLinkFilter>;
  /** No related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorValidatorLinkFilter>;
  /** Some related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorValidatorLinkFilter>;
};

/** A filter to be used against many `Validator` object types. All fields are combined with a logical ‘and.’ */
export type OperatorToManyValidatorFilter = {
  /** Aggregates across related `Validator` match the filter criteria. */
  aggregates?: InputMaybe<ValidatorAggregatesFilter>;
  /** Every related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ValidatorFilter>;
  /** No related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ValidatorFilter>;
  /** Some related `Validator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ValidatorFilter>;
};

export type OperatorValidatorLink = Node & {
  __typename?: 'OperatorValidatorLink';
  /** Reads a single `Event` that is related to this `OperatorValidatorLink`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `OperatorValidatorLink`. */
  operatorByOperatorId: Operator;
  operatorId: Scalars['Int']['output'];
  /** Reads a single `Validator` that is related to this `OperatorValidatorLink`. */
  validatorByValidatorId: Validator;
  validatorId: Scalars['Int']['output'];
};

export type OperatorValidatorLinkAggregates = {
  __typename?: 'OperatorValidatorLinkAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OperatorValidatorLinkAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OperatorValidatorLinkDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OperatorValidatorLinkMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OperatorValidatorLinkMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OperatorValidatorLinkStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OperatorValidatorLinkStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OperatorValidatorLinkSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OperatorValidatorLinkVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OperatorValidatorLinkVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OperatorValidatorLink` object types. */
export type OperatorValidatorLinkAggregatesFilter = {
  /** Mean average aggregate over matching `OperatorValidatorLink` objects. */
  average?: InputMaybe<OperatorValidatorLinkAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OperatorValidatorLink` objects. */
  distinctCount?: InputMaybe<OperatorValidatorLinkDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OperatorValidatorLink` object to be included within the aggregate. */
  filter?: InputMaybe<OperatorValidatorLinkFilter>;
  /** Maximum aggregate over matching `OperatorValidatorLink` objects. */
  max?: InputMaybe<OperatorValidatorLinkMaxAggregateFilter>;
  /** Minimum aggregate over matching `OperatorValidatorLink` objects. */
  min?: InputMaybe<OperatorValidatorLinkMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OperatorValidatorLink` objects. */
  stddevPopulation?: InputMaybe<OperatorValidatorLinkStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OperatorValidatorLink` objects. */
  stddevSample?: InputMaybe<OperatorValidatorLinkStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OperatorValidatorLink` objects. */
  sum?: InputMaybe<OperatorValidatorLinkSumAggregateFilter>;
  /** Population variance aggregate over matching `OperatorValidatorLink` objects. */
  variancePopulation?: InputMaybe<OperatorValidatorLinkVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OperatorValidatorLink` objects. */
  varianceSample?: InputMaybe<OperatorValidatorLinkVarianceSampleAggregateFilter>;
};

export type OperatorValidatorLinkAverageAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorLinkAverageAggregates = {
  __typename?: 'OperatorValidatorLinkAverageAggregates';
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OperatorValidatorLink` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OperatorValidatorLinkCondition = {
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type OperatorValidatorLinkDistinctCountAggregateFilter = {
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorValidatorLinkDistinctCountAggregates = {
  __typename?: 'OperatorValidatorLinkDistinctCountAggregates';
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OperatorValidatorLink` object types. All fields are combined with a logical ‘and.’ */
export type OperatorValidatorLinkFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OperatorValidatorLinkFilter>>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OperatorValidatorLinkFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OperatorValidatorLinkFilter>>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `OperatorValidatorLink` for usage during aggregation. */
export type OperatorValidatorLinkGroupBy =
  | 'EVENT_ID'
  | 'OPERATOR_ID'
  | 'VALIDATOR_ID';

export type OperatorValidatorLinkHavingAverageInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingDistinctCountInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `OperatorValidatorLink` aggregates. */
export type OperatorValidatorLinkHavingInput = {
  AND?: InputMaybe<Array<OperatorValidatorLinkHavingInput>>;
  OR?: InputMaybe<Array<OperatorValidatorLinkHavingInput>>;
  average?: InputMaybe<OperatorValidatorLinkHavingAverageInput>;
  distinctCount?: InputMaybe<OperatorValidatorLinkHavingDistinctCountInput>;
  max?: InputMaybe<OperatorValidatorLinkHavingMaxInput>;
  min?: InputMaybe<OperatorValidatorLinkHavingMinInput>;
  stddevPopulation?: InputMaybe<OperatorValidatorLinkHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OperatorValidatorLinkHavingStddevSampleInput>;
  sum?: InputMaybe<OperatorValidatorLinkHavingSumInput>;
  variancePopulation?: InputMaybe<OperatorValidatorLinkHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OperatorValidatorLinkHavingVarianceSampleInput>;
};

export type OperatorValidatorLinkHavingMaxInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingMinInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingStddevPopulationInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingStddevSampleInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingSumInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingVariancePopulationInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkHavingVarianceSampleInput = {
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type OperatorValidatorLinkMaxAggregateFilter = {
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type OperatorValidatorLinkMaxAggregates = {
  __typename?: 'OperatorValidatorLinkMaxAggregates';
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorValidatorLinkMinAggregateFilter = {
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type OperatorValidatorLinkMinAggregates = {
  __typename?: 'OperatorValidatorLinkMinAggregates';
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type OperatorValidatorLinkStddevPopulationAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorLinkStddevPopulationAggregates = {
  __typename?: 'OperatorValidatorLinkStddevPopulationAggregates';
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorLinkStddevSampleAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorLinkStddevSampleAggregates = {
  __typename?: 'OperatorValidatorLinkStddevSampleAggregates';
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorLinkSumAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type OperatorValidatorLinkSumAggregates = {
  __typename?: 'OperatorValidatorLinkSumAggregates';
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

export type OperatorValidatorLinkVariancePopulationAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorLinkVariancePopulationAggregates = {
  __typename?: 'OperatorValidatorLinkVariancePopulationAggregates';
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorValidatorLinkVarianceSampleAggregateFilter = {
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type OperatorValidatorLinkVarianceSampleAggregates = {
  __typename?: 'OperatorValidatorLinkVarianceSampleAggregates';
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OperatorValidatorLink` values. */
export type OperatorValidatorLinksConnection = {
  __typename?: 'OperatorValidatorLinksConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorValidatorLinkAggregates>;
  /** A list of edges which contains the `OperatorValidatorLink` and cursor to aid in pagination. */
  edges: Array<OperatorValidatorLinksEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OperatorValidatorLinkAggregates>>;
  /** A list of `OperatorValidatorLink` objects. */
  nodes: Array<OperatorValidatorLink>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OperatorValidatorLink` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OperatorValidatorLink` values. */
export type OperatorValidatorLinksConnectionGroupedAggregatesArgs = {
  groupBy: Array<OperatorValidatorLinkGroupBy>;
  having?: InputMaybe<OperatorValidatorLinkHavingInput>;
};

/** A `OperatorValidatorLink` edge in the connection. */
export type OperatorValidatorLinksEdge = {
  __typename?: 'OperatorValidatorLinksEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OperatorValidatorLink` at the end of the edge. */
  node: OperatorValidatorLink;
};

/** Methods to use when ordering `OperatorValidatorLink`. */
export type OperatorValidatorLinksOrderBy =
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

export type OperatorVariancePopulationAggregates = {
  __typename?: 'OperatorVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type OperatorVarianceSampleAggregates = {
  __typename?: 'OperatorVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Operator` values. */
export type OperatorsConnection = {
  __typename?: 'OperatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OperatorAggregates>;
  /** A list of edges which contains the `Operator` and cursor to aid in pagination. */
  edges: Array<OperatorsEdge>;
  /** A list of `Operator` objects. */
  nodes: Array<Operator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Operator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `Operator` edge in the connection. */
export type OperatorsEdge = {
  __typename?: 'OperatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Operator` at the end of the edge. */
  node: Operator;
};

/** Methods to use when ordering `Operator`. */
export type OperatorsOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_AVERAGE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_COUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_COUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MAX_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_TIMESTAMP_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_TIMESTAMP_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_MIN_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_SUM_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATOR_ACCOUNT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'DELEGATION_ACTIVITIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_COUNT_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_COUNT_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MAX_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_TIMESTAMP_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_MIN_TIMESTAMP_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_ACTIONS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_AVERAGE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_COUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_COUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_DISTINCT_COUNT_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MAX_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_MIN_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_POPULATION_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_STDDEV_SAMPLE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_SUM_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_POPULATION_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_COMMISSION_BPS_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_COMMISSION_BPS_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_DELEGATED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_LOSS_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_REWARD_VALUE_USD_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_STAKED_AMOUNT_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_STAKED_AMOUNT_DESC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_STAKED_VALUE_USD_ASC'
  | 'OPERATOR_EPOCHES_BY_OPERATOR_ID_VARIANCE_SAMPLE_STAKED_VALUE_USD_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_APY_BP_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_APY_BP_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_EPOCH_DELEGATION_APIES_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_COUNT_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_COUNT_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_OPERATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_COUNT_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_COUNT_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_CFE_VERSION_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_CFE_VERSION_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'VALIDATORS_BY_OPERATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC';

export type OraclePriceTracking = Node & {
  __typename?: 'OraclePriceTracking';
  baseAsset: PriceAsset;
  createdAtEventId: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `OraclePriceTracking`. */
  eventByCreatedAtEventId: Event;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  priceValidFromBlock: Scalars['Int']['output'];
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  priceX128: Scalars['BigFloat']['output'];
  quoteAsset: PriceAsset;
  updatedAtOracleTimestamp: Scalars['Datetime']['output'];
};

export type OraclePriceTrackingAggregates = {
  __typename?: 'OraclePriceTrackingAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<OraclePriceTrackingAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<OraclePriceTrackingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<OraclePriceTrackingMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<OraclePriceTrackingMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<OraclePriceTrackingStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<OraclePriceTrackingStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<OraclePriceTrackingSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<OraclePriceTrackingVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<OraclePriceTrackingVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `OraclePriceTracking` object types. */
export type OraclePriceTrackingAggregatesFilter = {
  /** Mean average aggregate over matching `OraclePriceTracking` objects. */
  average?: InputMaybe<OraclePriceTrackingAverageAggregateFilter>;
  /** Distinct count aggregate over matching `OraclePriceTracking` objects. */
  distinctCount?: InputMaybe<OraclePriceTrackingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `OraclePriceTracking` object to be included within the aggregate. */
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  /** Maximum aggregate over matching `OraclePriceTracking` objects. */
  max?: InputMaybe<OraclePriceTrackingMaxAggregateFilter>;
  /** Minimum aggregate over matching `OraclePriceTracking` objects. */
  min?: InputMaybe<OraclePriceTrackingMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `OraclePriceTracking` objects. */
  stddevPopulation?: InputMaybe<OraclePriceTrackingStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `OraclePriceTracking` objects. */
  stddevSample?: InputMaybe<OraclePriceTrackingStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `OraclePriceTracking` objects. */
  sum?: InputMaybe<OraclePriceTrackingSumAggregateFilter>;
  /** Population variance aggregate over matching `OraclePriceTracking` objects. */
  variancePopulation?: InputMaybe<OraclePriceTrackingVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `OraclePriceTracking` objects. */
  varianceSample?: InputMaybe<OraclePriceTrackingVarianceSampleAggregateFilter>;
};

export type OraclePriceTrackingAverageAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingAverageAggregates = {
  __typename?: 'OraclePriceTrackingAverageAggregates';
  /** Mean average of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Mean average of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `OraclePriceTracking` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type OraclePriceTrackingCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByCreatedAtEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `price` field. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Checks for equality with the object’s `priceValidFromBlock` field. */
  priceValidFromBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `priceValidToBlock` field. */
  priceValidToBlock?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `priceX128` field. */
  priceX128?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAsset>;
  /** Checks for equality with the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type OraclePriceTrackingDistinctCountAggregateFilter = {
  baseAsset?: InputMaybe<BigIntFilter>;
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<BigIntFilter>;
  priceValidFromBlock?: InputMaybe<BigIntFilter>;
  priceValidToBlock?: InputMaybe<BigIntFilter>;
  priceX128?: InputMaybe<BigIntFilter>;
  quoteAsset?: InputMaybe<BigIntFilter>;
  updatedAtOracleTimestamp?: InputMaybe<BigIntFilter>;
};

export type OraclePriceTrackingDistinctCountAggregates = {
  __typename?: 'OraclePriceTrackingDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of price across the matching connection */
  price?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `OraclePriceTracking` object types. All fields are combined with a logical ‘and.’ */
export type OraclePriceTrackingFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<OraclePriceTrackingFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `createdAtEventId` field. */
  createdAtEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByCreatedAtEventId` relation. */
  eventByCreatedAtEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<OraclePriceTrackingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<OraclePriceTrackingFilter>>;
  /** Filter by the object’s `price` field. */
  price?: InputMaybe<FloatFilter>;
  /** Filter by the object’s `priceValidFromBlock` field. */
  priceValidFromBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `priceValidToBlock` field. */
  priceValidToBlock?: InputMaybe<IntFilter>;
  /** Filter by the object’s `priceX128` field. */
  priceX128?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<PriceAssetFilter>;
  /** Filter by the object’s `updatedAtOracleTimestamp` field. */
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `OraclePriceTracking` for usage during aggregation. */
export type OraclePriceTrackingGroupBy =
  | 'BASE_ASSET'
  | 'CREATED_AT_EVENT_ID'
  | 'PRICE'
  | 'PRICE_VALID_FROM_BLOCK'
  | 'PRICE_VALID_TO_BLOCK'
  | 'PRICE_X128'
  | 'QUOTE_ASSET'
  | 'UPDATED_AT_ORACLE_TIMESTAMP'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_TRUNCATED_TO_WEEK';

export type OraclePriceTrackingHavingAverageInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingDistinctCountInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `OraclePriceTracking` aggregates. */
export type OraclePriceTrackingHavingInput = {
  AND?: InputMaybe<Array<OraclePriceTrackingHavingInput>>;
  OR?: InputMaybe<Array<OraclePriceTrackingHavingInput>>;
  average?: InputMaybe<OraclePriceTrackingHavingAverageInput>;
  distinctCount?: InputMaybe<OraclePriceTrackingHavingDistinctCountInput>;
  max?: InputMaybe<OraclePriceTrackingHavingMaxInput>;
  min?: InputMaybe<OraclePriceTrackingHavingMinInput>;
  stddevPopulation?: InputMaybe<OraclePriceTrackingHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<OraclePriceTrackingHavingStddevSampleInput>;
  sum?: InputMaybe<OraclePriceTrackingHavingSumInput>;
  variancePopulation?: InputMaybe<OraclePriceTrackingHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<OraclePriceTrackingHavingVarianceSampleInput>;
};

export type OraclePriceTrackingHavingMaxInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingMinInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingStddevPopulationInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingStddevSampleInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingSumInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingVariancePopulationInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingHavingVarianceSampleInput = {
  createdAtEventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  price?: InputMaybe<HavingFloatFilter>;
  priceValidFromBlock?: InputMaybe<HavingIntFilter>;
  priceValidToBlock?: InputMaybe<HavingIntFilter>;
  priceX128?: InputMaybe<HavingBigfloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type OraclePriceTrackingMaxAggregateFilter = {
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<IntFilter>;
  priceValidToBlock?: InputMaybe<IntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

export type OraclePriceTrackingMaxAggregates = {
  __typename?: 'OraclePriceTrackingMaxAggregates';
  /** Maximum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Maximum of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  /** Maximum of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OraclePriceTrackingMinAggregateFilter = {
  createdAtEventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<IntFilter>;
  priceValidToBlock?: InputMaybe<IntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
  updatedAtOracleTimestamp?: InputMaybe<DatetimeFilter>;
};

export type OraclePriceTrackingMinAggregates = {
  __typename?: 'OraclePriceTrackingMinAggregates';
  /** Minimum of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Minimum of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['Int']['output']>;
  /** Minimum of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of updatedAtOracleTimestamp across the matching connection */
  updatedAtOracleTimestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type OraclePriceTrackingStddevPopulationAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingStddevPopulationAggregates = {
  __typename?: 'OraclePriceTrackingStddevPopulationAggregates';
  /** Population standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population standard deviation of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingStddevSampleAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingStddevSampleAggregates = {
  __typename?: 'OraclePriceTrackingStddevSampleAggregates';
  /** Sample standard deviation of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample standard deviation of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingSumAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigIntFilter>;
  priceValidToBlock?: InputMaybe<BigIntFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingSumAggregates = {
  __typename?: 'OraclePriceTrackingSumAggregates';
  /** Sum of createdAtEventId across the matching connection */
  createdAtEventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of price across the matching connection */
  price: Scalars['Float']['output'];
  /** Sum of priceValidFromBlock across the matching connection */
  priceValidFromBlock: Scalars['BigInt']['output'];
  /** Sum of priceValidToBlock across the matching connection */
  priceValidToBlock: Scalars['BigInt']['output'];
  /** Sum of priceX128 across the matching connection */
  priceX128: Scalars['BigFloat']['output'];
};

export type OraclePriceTrackingVariancePopulationAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingVariancePopulationAggregates = {
  __typename?: 'OraclePriceTrackingVariancePopulationAggregates';
  /** Population variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Population variance of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

export type OraclePriceTrackingVarianceSampleAggregateFilter = {
  createdAtEventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  price?: InputMaybe<FloatFilter>;
  priceValidFromBlock?: InputMaybe<BigFloatFilter>;
  priceValidToBlock?: InputMaybe<BigFloatFilter>;
  priceX128?: InputMaybe<BigFloatFilter>;
};

export type OraclePriceTrackingVarianceSampleAggregates = {
  __typename?: 'OraclePriceTrackingVarianceSampleAggregates';
  /** Sample variance of createdAtEventId across the matching connection */
  createdAtEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of price across the matching connection */
  price?: Maybe<Scalars['Float']['output']>;
  /** Sample variance of priceValidFromBlock across the matching connection */
  priceValidFromBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of priceValidToBlock across the matching connection */
  priceValidToBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of priceX128 across the matching connection */
  priceX128?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `OraclePriceTracking` values. */
export type OraclePriceTrackingsConnection = {
  __typename?: 'OraclePriceTrackingsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<OraclePriceTrackingAggregates>;
  /** A list of edges which contains the `OraclePriceTracking` and cursor to aid in pagination. */
  edges: Array<OraclePriceTrackingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<OraclePriceTrackingAggregates>>;
  /** A list of `OraclePriceTracking` objects. */
  nodes: Array<OraclePriceTracking>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `OraclePriceTracking` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `OraclePriceTracking` values. */
export type OraclePriceTrackingsConnectionGroupedAggregatesArgs = {
  groupBy: Array<OraclePriceTrackingGroupBy>;
  having?: InputMaybe<OraclePriceTrackingHavingInput>;
};

/** A `OraclePriceTracking` edge in the connection. */
export type OraclePriceTrackingsEdge = {
  __typename?: 'OraclePriceTrackingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `OraclePriceTracking` at the end of the edge. */
  node: OraclePriceTracking;
};

/** Methods to use when ordering `OraclePriceTracking`. */
export type OraclePriceTrackingsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'CREATED_AT_EVENT_ID_ASC'
  | 'CREATED_AT_EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRICE_ASC'
  | 'PRICE_DESC'
  | 'PRICE_VALID_FROM_BLOCK_ASC'
  | 'PRICE_VALID_FROM_BLOCK_DESC'
  | 'PRICE_VALID_TO_BLOCK_ASC'
  | 'PRICE_VALID_TO_BLOCK_DESC'
  | 'PRICE_X128_ASC'
  | 'PRICE_X128_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_ASC'
  | 'UPDATED_AT_ORACLE_TIMESTAMP_DESC';

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

/** A connection to a list of `Penalty` values. */
export type PenaltiesConnection = {
  __typename?: 'PenaltiesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PenaltyAggregates>;
  /** A list of edges which contains the `Penalty` and cursor to aid in pagination. */
  edges: Array<PenaltiesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PenaltyAggregates>>;
  /** A list of `Penalty` objects. */
  nodes: Array<Penalty>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Penalty` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Penalty` values. */
export type PenaltiesConnectionGroupedAggregatesArgs = {
  groupBy: Array<PenaltyGroupBy>;
  having?: InputMaybe<PenaltyHavingInput>;
};

/** A `Penalty` edge in the connection. */
export type PenaltiesEdge = {
  __typename?: 'PenaltiesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Penalty` at the end of the edge. */
  node: Penalty;
};

/** Methods to use when ordering `Penalty`. */
export type PenaltiesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'BLOCK_ID_ASC'
  | 'BLOCK_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REASON_ASC'
  | 'REASON_DESC'
  | 'VALIDATOR_ID_ASC'
  | 'VALIDATOR_ID_DESC';

export type Penalty = Node & {
  __typename?: 'Penalty';
  amount: Scalars['Int']['output'];
  /** Reads a single `Block` that is related to this `Penalty`. */
  blockByBlockId: Block;
  blockId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `Penalty`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  /** Reads a single `Validator` that is related to this `Penalty`. */
  validatorByValidatorId: Validator;
  validatorId: Scalars['Int']['output'];
};

export type PenaltyAggregates = {
  __typename?: 'PenaltyAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PenaltyAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PenaltyDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PenaltyMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PenaltyMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PenaltyStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PenaltyStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PenaltySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PenaltyVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PenaltyVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Penalty` object types. */
export type PenaltyAggregatesFilter = {
  /** Mean average aggregate over matching `Penalty` objects. */
  average?: InputMaybe<PenaltyAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Penalty` objects. */
  distinctCount?: InputMaybe<PenaltyDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Penalty` object to be included within the aggregate. */
  filter?: InputMaybe<PenaltyFilter>;
  /** Maximum aggregate over matching `Penalty` objects. */
  max?: InputMaybe<PenaltyMaxAggregateFilter>;
  /** Minimum aggregate over matching `Penalty` objects. */
  min?: InputMaybe<PenaltyMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Penalty` objects. */
  stddevPopulation?: InputMaybe<PenaltyStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Penalty` objects. */
  stddevSample?: InputMaybe<PenaltyStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Penalty` objects. */
  sum?: InputMaybe<PenaltySumAggregateFilter>;
  /** Population variance aggregate over matching `Penalty` objects. */
  variancePopulation?: InputMaybe<PenaltyVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Penalty` objects. */
  varianceSample?: InputMaybe<PenaltyVarianceSampleAggregateFilter>;
};

export type PenaltyAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type PenaltyAverageAggregates = {
  __typename?: 'PenaltyAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Penalty` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PenaltyCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  blockByBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `blockId` field. */
  blockId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `reason` field. */
  reason?: InputMaybe<Scalars['String']['input']>;
  validatorByValidatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `validatorId` field. */
  validatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type PenaltyDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  reason?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type PenaltyDistinctCountAggregates = {
  __typename?: 'PenaltyDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of reason across the matching connection */
  reason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Penalty` object types. All fields are combined with a logical ‘and.’ */
export type PenaltyFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PenaltyFilter>>;
  /** Filter by the object’s `blockByBlockId` relation. */
  blockByBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `blockId` field. */
  blockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PenaltyFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PenaltyFilter>>;
  /** Filter by the object’s `reason` field. */
  reason?: InputMaybe<StringFilter>;
  /** Filter by the object’s `validatorByValidatorId` relation. */
  validatorByValidatorId?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `validatorId` field. */
  validatorId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `Penalty` for usage during aggregation. */
export type PenaltyGroupBy =
  | 'AMOUNT'
  | 'BLOCK_ID'
  | 'EVENT_ID'
  | 'REASON'
  | 'VALIDATOR_ID';

export type PenaltyHavingAverageInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingDistinctCountInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Penalty` aggregates. */
export type PenaltyHavingInput = {
  AND?: InputMaybe<Array<PenaltyHavingInput>>;
  OR?: InputMaybe<Array<PenaltyHavingInput>>;
  average?: InputMaybe<PenaltyHavingAverageInput>;
  distinctCount?: InputMaybe<PenaltyHavingDistinctCountInput>;
  max?: InputMaybe<PenaltyHavingMaxInput>;
  min?: InputMaybe<PenaltyHavingMinInput>;
  stddevPopulation?: InputMaybe<PenaltyHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PenaltyHavingStddevSampleInput>;
  sum?: InputMaybe<PenaltyHavingSumInput>;
  variancePopulation?: InputMaybe<PenaltyHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PenaltyHavingVarianceSampleInput>;
};

export type PenaltyHavingMaxInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingMinInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingStddevSampleInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingSumInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingIntFilter>;
  blockId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  validatorId?: InputMaybe<HavingIntFilter>;
};

export type PenaltyMaxAggregateFilter = {
  amount?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type PenaltyMaxAggregates = {
  __typename?: 'PenaltyMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type PenaltyMinAggregateFilter = {
  amount?: InputMaybe<IntFilter>;
  blockId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  validatorId?: InputMaybe<IntFilter>;
};

export type PenaltyMinAggregates = {
  __typename?: 'PenaltyMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of blockId across the matching connection */
  blockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['Int']['output']>;
};

export type PenaltyStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type PenaltyStddevPopulationAggregates = {
  __typename?: 'PenaltyStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PenaltyStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type PenaltyStddevSampleAggregates = {
  __typename?: 'PenaltyStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PenaltySumAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  blockId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  validatorId?: InputMaybe<BigIntFilter>;
};

export type PenaltySumAggregates = {
  __typename?: 'PenaltySumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigInt']['output'];
  /** Sum of blockId across the matching connection */
  blockId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of validatorId across the matching connection */
  validatorId: Scalars['BigInt']['output'];
};

export type PenaltyVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type PenaltyVariancePopulationAggregates = {
  __typename?: 'PenaltyVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type PenaltyVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  blockId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  validatorId?: InputMaybe<BigFloatFilter>;
};

export type PenaltyVarianceSampleAggregates = {
  __typename?: 'PenaltyVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of blockId across the matching connection */
  blockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of validatorId across the matching connection */
  validatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type Pool = Node & {
  __typename?: 'Pool';
  baseAsset: ChainflipAsset;
  id: Scalars['Int']['output'];
  liquidityFeeHundredthPips: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  quoteAsset: ChainflipAsset;
};

export type PoolAggregates = {
  __typename?: 'PoolAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolVarianceSampleAggregates>;
};

export type PoolAverageAggregates = {
  __typename?: 'PoolAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `Pool` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PoolCondition = {
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAsset>;
};

export type PoolDistinctCountAggregates = {
  __typename?: 'PoolDistinctCountAggregates';
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAsset across the matching connection */
  quoteAsset?: Maybe<Scalars['BigInt']['output']>;
};

export type PoolEventType =
  | 'DECREASED'
  | 'INCREASED';

/** A filter to be used against PoolEventType fields. All fields are combined with a logical ‘and.’ */
export type PoolEventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PoolEventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PoolEventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PoolEventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PoolEventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PoolEventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PoolEventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PoolEventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PoolEventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PoolEventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PoolEventType>>;
};

/** A filter to be used against `Pool` object types. All fields are combined with a logical ‘and.’ */
export type PoolFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityFeeHundredthPips` field. */
  liquidityFeeHundredthPips?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolFilter>>;
  /** Filter by the object’s `quoteAsset` field. */
  quoteAsset?: InputMaybe<ChainflipAssetFilter>;
};

/** Grouping methods for `Pool` for usage during aggregation. */
export type PoolGroupBy =
  | 'BASE_ASSET'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS'
  | 'QUOTE_ASSET';

export type PoolHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Pool` aggregates. */
export type PoolHavingInput = {
  AND?: InputMaybe<Array<PoolHavingInput>>;
  OR?: InputMaybe<Array<PoolHavingInput>>;
  average?: InputMaybe<PoolHavingAverageInput>;
  distinctCount?: InputMaybe<PoolHavingDistinctCountInput>;
  max?: InputMaybe<PoolHavingMaxInput>;
  min?: InputMaybe<PoolHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolHavingStddevSampleInput>;
  sum?: InputMaybe<PoolHavingSumInput>;
  variancePopulation?: InputMaybe<PoolHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolHavingVarianceSampleInput>;
};

export type PoolHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeHundredthPips?: InputMaybe<HavingIntFilter>;
};

export type PoolMaxAggregates = {
  __typename?: 'PoolMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
};

export type PoolMinAggregates = {
  __typename?: 'PoolMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['Int']['output']>;
};

export type PoolOrderEvent = Node & {
  __typename?: 'PoolOrderEvent';
  baseAmount: Scalars['BigFloat']['output'];
  baseAsset: ChainflipAsset;
  baseCollectedFees: Scalars['BigFloat']['output'];
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  baseValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `PoolOrderEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  eventType: PoolEventType;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityProvider` that is related to this `PoolOrderEvent`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  maximumRate: Scalars['BigFloat']['output'];
  minimumRate: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  orderId: Scalars['String']['output'];
  orderType: PoolOrderType;
  quoteAmount: Scalars['BigFloat']['output'];
  quoteCollectedFees: Scalars['BigFloat']['output'];
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  quoteValueUsd: Scalars['BigFloat']['output'];
  timestamp: Scalars['Datetime']['output'];
};

export type PoolOrderEventAggregates = {
  __typename?: 'PoolOrderEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolOrderEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolOrderEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolOrderEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolOrderEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolOrderEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolOrderEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolOrderEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolOrderEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolOrderEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PoolOrderEvent` object types. */
export type PoolOrderEventAggregatesFilter = {
  /** Mean average aggregate over matching `PoolOrderEvent` objects. */
  average?: InputMaybe<PoolOrderEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PoolOrderEvent` objects. */
  distinctCount?: InputMaybe<PoolOrderEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PoolOrderEvent` object to be included within the aggregate. */
  filter?: InputMaybe<PoolOrderEventFilter>;
  /** Maximum aggregate over matching `PoolOrderEvent` objects. */
  max?: InputMaybe<PoolOrderEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `PoolOrderEvent` objects. */
  min?: InputMaybe<PoolOrderEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PoolOrderEvent` objects. */
  stddevPopulation?: InputMaybe<PoolOrderEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PoolOrderEvent` objects. */
  stddevSample?: InputMaybe<PoolOrderEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PoolOrderEvent` objects. */
  sum?: InputMaybe<PoolOrderEventSumAggregateFilter>;
  /** Population variance aggregate over matching `PoolOrderEvent` objects. */
  variancePopulation?: InputMaybe<PoolOrderEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PoolOrderEvent` objects. */
  varianceSample?: InputMaybe<PoolOrderEventVarianceSampleAggregateFilter>;
};

export type PoolOrderEventAverageAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventAverageAggregates = {
  __typename?: 'PoolOrderEventAverageAggregates';
  /** Mean average of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PoolOrderEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PoolOrderEventCondition = {
  /** Checks for equality with the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseValueUsd` field. */
  baseValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<PoolEventType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maximumRate` field. */
  maximumRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minimumRate` field. */
  minimumRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderType>;
  /** Checks for equality with the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteValueUsd` field. */
  quoteValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type PoolOrderEventDistinctCountAggregateFilter = {
  baseAmount?: InputMaybe<BigIntFilter>;
  baseAsset?: InputMaybe<BigIntFilter>;
  baseCollectedFees?: InputMaybe<BigIntFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  baseValueUsd?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  eventType?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maximumRate?: InputMaybe<BigIntFilter>;
  minimumRate?: InputMaybe<BigIntFilter>;
  orderId?: InputMaybe<BigIntFilter>;
  orderType?: InputMaybe<BigIntFilter>;
  quoteAmount?: InputMaybe<BigIntFilter>;
  quoteCollectedFees?: InputMaybe<BigIntFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  quoteValueUsd?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type PoolOrderEventDistinctCountAggregates = {
  __typename?: 'PoolOrderEventDistinctCountAggregates';
  /** Distinct count of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventType across the matching connection */
  eventType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderId across the matching connection */
  orderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderType across the matching connection */
  orderType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `PoolOrderEvent` object types. All fields are combined with a logical ‘and.’ */
export type PoolOrderEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolOrderEventFilter>>;
  /** Filter by the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseValueUsd` field. */
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<PoolEventTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maximumRate` field. */
  maximumRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minimumRate` field. */
  minimumRate?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolOrderEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolOrderEventFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderTypeFilter>;
  /** Filter by the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteValueUsd` field. */
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `PoolOrderEvent` for usage during aggregation. */
export type PoolOrderEventGroupBy =
  | 'BASE_AMOUNT'
  | 'BASE_ASSET'
  | 'BASE_COLLECTED_FEES'
  | 'BASE_COLLECTED_FEES_USD'
  | 'BASE_VALUE_USD'
  | 'EVENT_TYPE'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'MAXIMUM_RATE'
  | 'MINIMUM_RATE'
  | 'ORDER_ID'
  | 'ORDER_TYPE'
  | 'QUOTE_AMOUNT'
  | 'QUOTE_COLLECTED_FEES'
  | 'QUOTE_COLLECTED_FEES_USD'
  | 'QUOTE_VALUE_USD'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type PoolOrderEventHavingAverageInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingDistinctCountInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PoolOrderEvent` aggregates. */
export type PoolOrderEventHavingInput = {
  AND?: InputMaybe<Array<PoolOrderEventHavingInput>>;
  OR?: InputMaybe<Array<PoolOrderEventHavingInput>>;
  average?: InputMaybe<PoolOrderEventHavingAverageInput>;
  distinctCount?: InputMaybe<PoolOrderEventHavingDistinctCountInput>;
  max?: InputMaybe<PoolOrderEventHavingMaxInput>;
  min?: InputMaybe<PoolOrderEventHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolOrderEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolOrderEventHavingStddevSampleInput>;
  sum?: InputMaybe<PoolOrderEventHavingSumInput>;
  variancePopulation?: InputMaybe<PoolOrderEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolOrderEventHavingVarianceSampleInput>;
};

export type PoolOrderEventHavingMaxInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingMinInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingStddevPopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingStddevSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingSumInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingVariancePopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventHavingVarianceSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type PoolOrderEventMaxAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type PoolOrderEventMaxAggregates = {
  __typename?: 'PoolOrderEventMaxAggregates';
  /** Maximum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type PoolOrderEventMinAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type PoolOrderEventMinAggregates = {
  __typename?: 'PoolOrderEventMinAggregates';
  /** Minimum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type PoolOrderEventStddevPopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventStddevPopulationAggregates = {
  __typename?: 'PoolOrderEventStddevPopulationAggregates';
  /** Population standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderEventStddevSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventStddevSampleAggregates = {
  __typename?: 'PoolOrderEventStddevSampleAggregates';
  /** Sample standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderEventSumAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventSumAggregates = {
  __typename?: 'PoolOrderEventSumAggregates';
  /** Sum of baseAmount across the matching connection */
  baseAmount: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFees across the matching connection */
  baseCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of baseValueUsd across the matching connection */
  baseValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of maximumRate across the matching connection */
  maximumRate: Scalars['BigFloat']['output'];
  /** Sum of minimumRate across the matching connection */
  minimumRate: Scalars['BigFloat']['output'];
  /** Sum of quoteAmount across the matching connection */
  quoteAmount: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFees across the matching connection */
  quoteCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of quoteValueUsd across the matching connection */
  quoteValueUsd: Scalars['BigFloat']['output'];
};

export type PoolOrderEventVariancePopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventVariancePopulationAggregates = {
  __typename?: 'PoolOrderEventVariancePopulationAggregates';
  /** Population variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolOrderEventVarianceSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolOrderEventVarianceSampleAggregates = {
  __typename?: 'PoolOrderEventVarianceSampleAggregates';
  /** Sample variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `PoolOrderEvent` values. */
export type PoolOrderEventsConnection = {
  __typename?: 'PoolOrderEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolOrderEventAggregates>;
  /** A list of edges which contains the `PoolOrderEvent` and cursor to aid in pagination. */
  edges: Array<PoolOrderEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolOrderEventAggregates>>;
  /** A list of `PoolOrderEvent` objects. */
  nodes: Array<PoolOrderEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PoolOrderEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PoolOrderEvent` values. */
export type PoolOrderEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolOrderEventGroupBy>;
  having?: InputMaybe<PoolOrderEventHavingInput>;
};

/** A `PoolOrderEvent` edge in the connection. */
export type PoolOrderEventsEdge = {
  __typename?: 'PoolOrderEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PoolOrderEvent` at the end of the edge. */
  node: PoolOrderEvent;
};

/** Methods to use when ordering `PoolOrderEvent`. */
export type PoolOrderEventsOrderBy =
  | 'BASE_AMOUNT_ASC'
  | 'BASE_AMOUNT_DESC'
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_COLLECTED_FEES_ASC'
  | 'BASE_COLLECTED_FEES_DESC'
  | 'BASE_COLLECTED_FEES_USD_ASC'
  | 'BASE_COLLECTED_FEES_USD_DESC'
  | 'BASE_VALUE_USD_ASC'
  | 'BASE_VALUE_USD_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'EVENT_TYPE_ASC'
  | 'EVENT_TYPE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'MAXIMUM_RATE_ASC'
  | 'MAXIMUM_RATE_DESC'
  | 'MINIMUM_RATE_ASC'
  | 'MINIMUM_RATE_DESC'
  | 'NATURAL'
  | 'ORDER_ID_ASC'
  | 'ORDER_ID_DESC'
  | 'ORDER_TYPE_ASC'
  | 'ORDER_TYPE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_AMOUNT_ASC'
  | 'QUOTE_AMOUNT_DESC'
  | 'QUOTE_COLLECTED_FEES_ASC'
  | 'QUOTE_COLLECTED_FEES_DESC'
  | 'QUOTE_COLLECTED_FEES_USD_ASC'
  | 'QUOTE_COLLECTED_FEES_USD_DESC'
  | 'QUOTE_VALUE_USD_ASC'
  | 'QUOTE_VALUE_USD_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type PoolOrderType =
  | 'LIMIT'
  | 'RANGE';

/** A filter to be used against PoolOrderType fields. All fields are combined with a logical ‘and.’ */
export type PoolOrderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PoolOrderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PoolOrderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PoolOrderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PoolOrderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PoolOrderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PoolOrderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PoolOrderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PoolOrderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PoolOrderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PoolOrderType>>;
};

export type PoolStddevPopulationAggregates = {
  __typename?: 'PoolStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolStddevSampleAggregates = {
  __typename?: 'PoolStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSumAggregates = {
  __typename?: 'PoolSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips: Scalars['BigInt']['output'];
};

export type PoolSwap = Node & {
  __typename?: 'PoolSwap';
  assetSwappedBlockTimestamp: Scalars['Datetime']['output'];
  assetSwappedEventId: Scalars['BigInt']['output'];
  /** Reads a single `Event` that is related to this `PoolSwap`. */
  eventByAssetSwappedEventId: Event;
  fromAmount: Scalars['BigFloat']['output'];
  fromAsset: ChainflipAsset;
  fromValueUsd: Scalars['BigFloat']['output'];
  id: Scalars['Int']['output'];
  liquidityFeeAmount: Scalars['BigFloat']['output'];
  liquidityFeeValueUsd: Scalars['BigFloat']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  toAmount: Scalars['BigFloat']['output'];
  toAsset: ChainflipAsset;
  toValueUsd: Scalars['BigFloat']['output'];
};

export type PoolSwapAggregates = {
  __typename?: 'PoolSwapAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PoolSwapAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PoolSwapDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PoolSwapMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PoolSwapMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PoolSwapStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PoolSwapStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PoolSwapSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PoolSwapVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PoolSwapVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PoolSwap` object types. */
export type PoolSwapAggregatesFilter = {
  /** Mean average aggregate over matching `PoolSwap` objects. */
  average?: InputMaybe<PoolSwapAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PoolSwap` objects. */
  distinctCount?: InputMaybe<PoolSwapDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PoolSwap` object to be included within the aggregate. */
  filter?: InputMaybe<PoolSwapFilter>;
  /** Maximum aggregate over matching `PoolSwap` objects. */
  max?: InputMaybe<PoolSwapMaxAggregateFilter>;
  /** Minimum aggregate over matching `PoolSwap` objects. */
  min?: InputMaybe<PoolSwapMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PoolSwap` objects. */
  stddevPopulation?: InputMaybe<PoolSwapStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PoolSwap` objects. */
  stddevSample?: InputMaybe<PoolSwapStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PoolSwap` objects. */
  sum?: InputMaybe<PoolSwapSumAggregateFilter>;
  /** Population variance aggregate over matching `PoolSwap` objects. */
  variancePopulation?: InputMaybe<PoolSwapVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PoolSwap` objects. */
  varianceSample?: InputMaybe<PoolSwapVarianceSampleAggregateFilter>;
};

export type PoolSwapAverageAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapAverageAggregates = {
  __typename?: 'PoolSwapAverageAggregates';
  /** Mean average of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `PoolSwap` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type PoolSwapCondition = {
  /** Checks for equality with the object’s `assetSwappedBlockTimestamp` field. */
  assetSwappedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `assetSwappedEventId` field. */
  assetSwappedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  eventByAssetSwappedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `fromAmount` field. */
  fromAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fromAsset` field. */
  fromAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `fromValueUsd` field. */
  fromValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `liquidityFeeAmount` field. */
  liquidityFeeAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `liquidityFeeValueUsd` field. */
  liquidityFeeValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `toAmount` field. */
  toAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `toAsset` field. */
  toAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `toValueUsd` field. */
  toValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type PoolSwapDistinctCountAggregateFilter = {
  assetSwappedBlockTimestamp?: InputMaybe<BigIntFilter>;
  assetSwappedEventId?: InputMaybe<BigIntFilter>;
  fromAmount?: InputMaybe<BigIntFilter>;
  fromAsset?: InputMaybe<BigIntFilter>;
  fromValueUsd?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityFeeAmount?: InputMaybe<BigIntFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigIntFilter>;
  toAmount?: InputMaybe<BigIntFilter>;
  toAsset?: InputMaybe<BigIntFilter>;
  toValueUsd?: InputMaybe<BigIntFilter>;
};

export type PoolSwapDistinctCountAggregates = {
  __typename?: 'PoolSwapDistinctCountAggregates';
  /** Distinct count of assetSwappedBlockTimestamp across the matching connection */
  assetSwappedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fromAsset across the matching connection */
  fromAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of toAsset across the matching connection */
  toAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `PoolSwap` object types. All fields are combined with a logical ‘and.’ */
export type PoolSwapFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PoolSwapFilter>>;
  /** Filter by the object’s `assetSwappedBlockTimestamp` field. */
  assetSwappedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `assetSwappedEventId` field. */
  assetSwappedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventByAssetSwappedEventId` relation. */
  eventByAssetSwappedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `fromAmount` field. */
  fromAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fromAsset` field. */
  fromAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `fromValueUsd` field. */
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityFeeAmount` field. */
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `liquidityFeeValueUsd` field. */
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PoolSwapFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PoolSwapFilter>>;
  /** Filter by the object’s `toAmount` field. */
  toAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `toAsset` field. */
  toAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `toValueUsd` field. */
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `PoolSwap` for usage during aggregation. */
export type PoolSwapGroupBy =
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP'
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'ASSET_SWAPPED_EVENT_ID'
  | 'FROM_AMOUNT'
  | 'FROM_ASSET'
  | 'FROM_VALUE_USD'
  | 'LIQUIDITY_FEE_AMOUNT'
  | 'LIQUIDITY_FEE_VALUE_USD'
  | 'TO_AMOUNT'
  | 'TO_ASSET'
  | 'TO_VALUE_USD';

export type PoolSwapHavingAverageInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingDistinctCountInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `PoolSwap` aggregates. */
export type PoolSwapHavingInput = {
  AND?: InputMaybe<Array<PoolSwapHavingInput>>;
  OR?: InputMaybe<Array<PoolSwapHavingInput>>;
  average?: InputMaybe<PoolSwapHavingAverageInput>;
  distinctCount?: InputMaybe<PoolSwapHavingDistinctCountInput>;
  max?: InputMaybe<PoolSwapHavingMaxInput>;
  min?: InputMaybe<PoolSwapHavingMinInput>;
  stddevPopulation?: InputMaybe<PoolSwapHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PoolSwapHavingStddevSampleInput>;
  sum?: InputMaybe<PoolSwapHavingSumInput>;
  variancePopulation?: InputMaybe<PoolSwapHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PoolSwapHavingVarianceSampleInput>;
};

export type PoolSwapHavingMaxInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingMinInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingStddevPopulationInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingStddevSampleInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingSumInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingVariancePopulationInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapHavingVarianceSampleInput = {
  assetSwappedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  assetSwappedEventId?: InputMaybe<HavingBigintFilter>;
  fromAmount?: InputMaybe<HavingBigfloatFilter>;
  fromValueUsd?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityFeeAmount?: InputMaybe<HavingBigfloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<HavingBigfloatFilter>;
  toAmount?: InputMaybe<HavingBigfloatFilter>;
  toValueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type PoolSwapMaxAggregateFilter = {
  assetSwappedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  assetSwappedEventId?: InputMaybe<BigIntFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapMaxAggregates = {
  __typename?: 'PoolSwapMaxAggregates';
  /** Maximum of assetSwappedBlockTimestamp across the matching connection */
  assetSwappedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSwapMinAggregateFilter = {
  assetSwappedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  assetSwappedEventId?: InputMaybe<BigIntFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapMinAggregates = {
  __typename?: 'PoolSwapMinAggregates';
  /** Minimum of assetSwappedBlockTimestamp across the matching connection */
  assetSwappedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSwapStddevPopulationAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapStddevPopulationAggregates = {
  __typename?: 'PoolSwapStddevPopulationAggregates';
  /** Population standard deviation of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSwapStddevSampleAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapStddevSampleAggregates = {
  __typename?: 'PoolSwapStddevSampleAggregates';
  /** Sample standard deviation of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSwapSumAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapSumAggregates = {
  __typename?: 'PoolSwapSumAggregates';
  /** Sum of assetSwappedEventId across the matching connection */
  assetSwappedEventId: Scalars['BigFloat']['output'];
  /** Sum of fromAmount across the matching connection */
  fromAmount: Scalars['BigFloat']['output'];
  /** Sum of fromValueUsd across the matching connection */
  fromValueUsd: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount: Scalars['BigFloat']['output'];
  /** Sum of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd: Scalars['BigFloat']['output'];
  /** Sum of toAmount across the matching connection */
  toAmount: Scalars['BigFloat']['output'];
  /** Sum of toValueUsd across the matching connection */
  toValueUsd: Scalars['BigFloat']['output'];
};

export type PoolSwapVariancePopulationAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapVariancePopulationAggregates = {
  __typename?: 'PoolSwapVariancePopulationAggregates';
  /** Population variance of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolSwapVarianceSampleAggregateFilter = {
  assetSwappedEventId?: InputMaybe<BigFloatFilter>;
  fromAmount?: InputMaybe<BigFloatFilter>;
  fromValueUsd?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityFeeAmount?: InputMaybe<BigFloatFilter>;
  liquidityFeeValueUsd?: InputMaybe<BigFloatFilter>;
  toAmount?: InputMaybe<BigFloatFilter>;
  toValueUsd?: InputMaybe<BigFloatFilter>;
};

export type PoolSwapVarianceSampleAggregates = {
  __typename?: 'PoolSwapVarianceSampleAggregates';
  /** Sample variance of assetSwappedEventId across the matching connection */
  assetSwappedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fromAmount across the matching connection */
  fromAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fromValueUsd across the matching connection */
  fromValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityFeeAmount across the matching connection */
  liquidityFeeAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityFeeValueUsd across the matching connection */
  liquidityFeeValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of toAmount across the matching connection */
  toAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of toValueUsd across the matching connection */
  toValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `PoolSwap` values. */
export type PoolSwapsConnection = {
  __typename?: 'PoolSwapsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolSwapAggregates>;
  /** A list of edges which contains the `PoolSwap` and cursor to aid in pagination. */
  edges: Array<PoolSwapsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolSwapAggregates>>;
  /** A list of `PoolSwap` objects. */
  nodes: Array<PoolSwap>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PoolSwap` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `PoolSwap` values. */
export type PoolSwapsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolSwapGroupBy>;
  having?: InputMaybe<PoolSwapHavingInput>;
};

/** A `PoolSwap` edge in the connection. */
export type PoolSwapsEdge = {
  __typename?: 'PoolSwapsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `PoolSwap` at the end of the edge. */
  node: PoolSwap;
};

/** Methods to use when ordering `PoolSwap`. */
export type PoolSwapsOrderBy =
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_ASC'
  | 'ASSET_SWAPPED_BLOCK_TIMESTAMP_DESC'
  | 'ASSET_SWAPPED_EVENT_ID_ASC'
  | 'ASSET_SWAPPED_EVENT_ID_DESC'
  | 'FROM_AMOUNT_ASC'
  | 'FROM_AMOUNT_DESC'
  | 'FROM_ASSET_ASC'
  | 'FROM_ASSET_DESC'
  | 'FROM_VALUE_USD_ASC'
  | 'FROM_VALUE_USD_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_FEE_AMOUNT_ASC'
  | 'LIQUIDITY_FEE_AMOUNT_DESC'
  | 'LIQUIDITY_FEE_VALUE_USD_ASC'
  | 'LIQUIDITY_FEE_VALUE_USD_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TO_AMOUNT_ASC'
  | 'TO_AMOUNT_DESC'
  | 'TO_ASSET_ASC'
  | 'TO_ASSET_DESC'
  | 'TO_VALUE_USD_ASC'
  | 'TO_VALUE_USD_DESC';

export type PoolVariancePopulationAggregates = {
  __typename?: 'PoolVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
};

export type PoolVarianceSampleAggregates = {
  __typename?: 'PoolVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityFeeHundredthPips across the matching connection */
  liquidityFeeHundredthPips?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Pool` values. */
export type PoolsConnection = {
  __typename?: 'PoolsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PoolAggregates>;
  /** A list of edges which contains the `Pool` and cursor to aid in pagination. */
  edges: Array<PoolsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PoolAggregates>>;
  /** A list of `Pool` objects. */
  nodes: Array<Pool>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Pool` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Pool` values. */
export type PoolsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PoolGroupBy>;
  having?: InputMaybe<PoolHavingInput>;
};

/** A `Pool` edge in the connection. */
export type PoolsEdge = {
  __typename?: 'PoolsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Pool` at the end of the edge. */
  node: Pool;
};

/** Methods to use when ordering `Pool`. */
export type PoolsOrderBy =
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_ASC'
  | 'LIQUIDITY_FEE_HUNDREDTH_PIPS_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'QUOTE_ASSET_ASC'
  | 'QUOTE_ASSET_DESC';

export type PriceAsset =
  | 'Btc'
  | 'Eth'
  | 'Fine'
  | 'Sol'
  | 'Usd'
  | 'Usdc'
  | 'Usdt';

/** A filter to be used against PriceAsset fields. All fields are combined with a logical ‘and.’ */
export type PriceAssetFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<PriceAsset>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<PriceAsset>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<PriceAsset>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<PriceAsset>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<PriceAsset>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<PriceAsset>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<PriceAsset>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<PriceAsset>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<PriceAsset>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  /** Reads a single `_PrismaMigration` using its globally unique `ID`. */
  _prismaMigration?: Maybe<_PrismaMigration>;
  /** Get a single `_PrismaMigration`. */
  _prismaMigrationById?: Maybe<_PrismaMigration>;
  /** Reads a single `Account` using its globally unique `ID`. */
  account?: Maybe<Account>;
  /** Get a single `Account`. */
  accountById?: Maybe<Account>;
  /** Get a single `Account`. */
  accountByIdHex?: Maybe<Account>;
  /** Get a single `Account`. */
  accountByIdSs58?: Maybe<Account>;
  /** Reads a single `AccountCreationDepositChannel` using its globally unique `ID`. */
  accountCreationDepositChannel?: Maybe<AccountCreationDepositChannel>;
  /** Get a single `AccountCreationDepositChannel`. */
  accountCreationDepositChannelById?: Maybe<AccountCreationDepositChannel>;
  /** Get a single `AccountCreationDepositChannel`. */
  accountCreationDepositChannelByIssuedBlockIdAndChainAndChannelId?: Maybe<AccountCreationDepositChannel>;
  /** Reads a single `AccountFundingEvent` using its globally unique `ID`. */
  accountFundingEvent?: Maybe<AccountFundingEvent>;
  /** Get a single `AccountFundingEvent`. */
  accountFundingEventByAccountCreationDepositChannelId?: Maybe<AccountFundingEvent>;
  /** Get a single `AccountFundingEvent`. */
  accountFundingEventById?: Maybe<AccountFundingEvent>;
  /** Get a single `AccountFundingEvent`. */
  accountFundingEventBySwapRequestId?: Maybe<AccountFundingEvent>;
  /** Reads and enables pagination through a set of `AccountCreationDepositChannel`. */
  allAccountCreationDepositChannels?: Maybe<AccountCreationDepositChannelsConnection>;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  allAccountFundingEvents?: Maybe<AccountFundingEventsConnection>;
  /** Reads and enables pagination through a set of `Account`. */
  allAccounts?: Maybe<AccountsConnection>;
  /** Reads and enables pagination through a set of `Auction`. */
  allAuctions?: Maybe<AuctionsConnection>;
  /** Reads and enables pagination through a set of `AuthorityHeartbeat`. */
  allAuthorityHeartbeats?: Maybe<AuthorityHeartbeatsConnection>;
  /** Reads and enables pagination through a set of `AuthorityMembership`. */
  allAuthorityMemberships?: Maybe<AuthorityMembershipsConnection>;
  /** Reads and enables pagination through a set of `Block`. */
  allBlocks?: Maybe<BlocksConnection>;
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  allBoostNetworkFeeSplits?: Maybe<BoostNetworkFeeSplitsConnection>;
  /** Reads and enables pagination through a set of `Broadcast`. */
  allBroadcasts?: Maybe<BroadcastsConnection>;
  /** Reads and enables pagination through a set of `BrokerAllTimeStat`. */
  allBrokerAllTimeStats?: Maybe<BrokerAllTimeStatsConnection>;
  /** Reads and enables pagination through a set of `BrokerChannel`. */
  allBrokerChannels?: Maybe<BrokerChannelsConnection>;
  /** Reads and enables pagination through a set of `BrokerFeeAndWithdrawalV2`. */
  allBrokerFeeAndWithdrawalV2S?: Maybe<BrokerFeeAndWithdrawalV2SConnection>;
  /** Reads and enables pagination through a set of `BrokerVaultAddress`. */
  allBrokerVaultAddresses?: Maybe<BrokerVaultAddressesConnection>;
  /** Reads and enables pagination through a set of `BrokerWithdrawal`. */
  allBrokerWithdrawals?: Maybe<BrokerWithdrawalsConnection>;
  /** Reads and enables pagination through a set of `Broker`. */
  allBrokers?: Maybe<BrokersConnection>;
  /** Reads and enables pagination through a set of `Burn`. */
  allBurns?: Maybe<BurnsConnection>;
  /** Reads and enables pagination through a set of `CfeVersion`. */
  allCfeVersions?: Maybe<CfeVersionsConnection>;
  /** Reads and enables pagination through a set of `ChainTracking`. */
  allChainTrackings?: Maybe<ChainTrackingsConnection>;
  /** Reads and enables pagination through a set of `CollectedFee`. */
  allCollectedFees?: Maybe<CollectedFeesConnection>;
  /** Reads and enables pagination through a set of `DelegationActivity`. */
  allDelegationActivities?: Maybe<DelegationActivitiesConnection>;
  /** Reads and enables pagination through a set of `Egress`. */
  allEgresses?: Maybe<EgressesConnection>;
  /** Reads and enables pagination through a set of `Epoch`. */
  allEpoches?: Maybe<EpochesConnection>;
  /** Reads and enables pagination through a set of `Event`. */
  allEvents?: Maybe<EventsConnection>;
  /** Reads and enables pagination through a set of `EvmStateChainCall`. */
  allEvmStateChainCalls?: Maybe<EvmStateChainCallsConnection>;
  /** Reads and enables pagination through a set of `Extrinsic`. */
  allExtrinsics?: Maybe<ExtrinsicsConnection>;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  allFailedDeposits?: Maybe<FailedDepositsConnection>;
  /** Reads and enables pagination through a set of `ForeignChainTracking`. */
  allForeignChainTrackings?: Maybe<ForeignChainTrackingsConnection>;
  /** Reads and enables pagination through a set of `IgnoredEgress`. */
  allIgnoredEgresses?: Maybe<IgnoredEgressesConnection>;
  /** Reads and enables pagination through a set of `LatestDelegationReward`. */
  allLatestDelegationRewards?: Maybe<LatestDelegationRewardsConnection>;
  /** Reads and enables pagination through a set of `LendingNetworkFee`. */
  allLendingNetworkFees?: Maybe<LendingNetworkFeesConnection>;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  allLiquidationSwapInfos?: Maybe<LiquidationSwapInfosConnection>;
  /** Reads and enables pagination through a set of `LiquidityBalanceEvent`. */
  allLiquidityBalanceEvents?: Maybe<LiquidityBalanceEventsConnection>;
  /** Reads and enables pagination through a set of `LiquidityDepositChannel`. */
  allLiquidityDepositChannels?: Maybe<LiquidityDepositChannelsConnection>;
  /** Reads and enables pagination through a set of `LiquidityDeposit`. */
  allLiquidityDeposits?: Maybe<LiquidityDepositsConnection>;
  /** Reads and enables pagination through a set of `LiquidityProvider`. */
  allLiquidityProviders?: Maybe<LiquidityProvidersConnection>;
  /** Reads and enables pagination through a set of `LiquidityTransfer`. */
  allLiquidityTransfers?: Maybe<LiquidityTransfersConnection>;
  /** Reads and enables pagination through a set of `LiquidityWithdrawal`. */
  allLiquidityWithdrawals?: Maybe<LiquidityWithdrawalsConnection>;
  /** Reads and enables pagination through a set of `Metadatum`. */
  allMetadata?: Maybe<MetadataConnection>;
  /** Reads and enables pagination through a set of `NetworkParticipantEarningsDaily`. */
  allNetworkParticipantEarningsDailies?: Maybe<NetworkParticipantEarningsDailiesConnection>;
  /** Reads and enables pagination through a set of `NetworkParticipantEarningsHourly`. */
  allNetworkParticipantEarningsHourlies?: Maybe<NetworkParticipantEarningsHourliesConnection>;
  /** Reads and enables pagination through a set of `OnChainSwapInfo`. */
  allOnChainSwapInfos?: Maybe<OnChainSwapInfosConnection>;
  /** Reads and enables pagination through a set of `OperatorAction`. */
  allOperatorActions?: Maybe<OperatorActionsConnection>;
  /** Reads and enables pagination through a set of `OperatorEpochDelegationApy`. */
  allOperatorEpochDelegationApies?: Maybe<OperatorEpochDelegationApiesConnection>;
  /** Reads and enables pagination through a set of `OperatorEpochDelegation`. */
  allOperatorEpochDelegations?: Maybe<OperatorEpochDelegationsConnection>;
  /** Reads and enables pagination through a set of `OperatorEpochValidator`. */
  allOperatorEpochValidators?: Maybe<OperatorEpochValidatorsConnection>;
  /** Reads and enables pagination through a set of `OperatorEpoch`. */
  allOperatorEpoches?: Maybe<OperatorEpochesConnection>;
  /** Reads and enables pagination through a set of `OperatorValidatorLink`. */
  allOperatorValidatorLinks?: Maybe<OperatorValidatorLinksConnection>;
  /** Reads and enables pagination through a set of `Operator`. */
  allOperators?: Maybe<OperatorsConnection>;
  /** Reads and enables pagination through a set of `OraclePriceTracking`. */
  allOraclePriceTrackings?: Maybe<OraclePriceTrackingsConnection>;
  /** Reads and enables pagination through a set of `Penalty`. */
  allPenalties?: Maybe<PenaltiesConnection>;
  /** Reads and enables pagination through a set of `PoolOrderEvent`. */
  allPoolOrderEvents?: Maybe<PoolOrderEventsConnection>;
  /** Reads and enables pagination through a set of `PoolSwap`. */
  allPoolSwaps?: Maybe<PoolSwapsConnection>;
  /** Reads and enables pagination through a set of `Pool`. */
  allPools?: Maybe<PoolsConnection>;
  /** Reads and enables pagination through a set of `_PrismaMigration`. */
  allPrismaMigrations?: Maybe<_PrismaMigrationsConnection>;
  /** Reads and enables pagination through a set of `RecentPoolOrderEvent`. */
  allRecentPoolOrderEvents?: Maybe<RecentPoolOrderEventsConnection>;
  /** Reads and enables pagination through a set of `RotationEvent`. */
  allRotationEvents?: Maybe<RotationEventsConnection>;
  /** Reads and enables pagination through a set of `StateChainError`. */
  allStateChainErrors?: Maybe<StateChainErrorsConnection>;
  /** Reads and enables pagination through a set of `SwapChannelBeneficiary`. */
  allSwapChannelBeneficiaries?: Maybe<SwapChannelBeneficiariesConnection>;
  /** Reads and enables pagination through a set of `SwapChannel`. */
  allSwapChannels?: Maybe<SwapChannelsConnection>;
  /** Reads and enables pagination through a set of `SwapCommission`. */
  allSwapCommissions?: Maybe<SwapCommissionsConnection>;
  /** Reads and enables pagination through a set of `SwapFee`. */
  allSwapFees?: Maybe<SwapFeesConnection>;
  /** Reads and enables pagination through a set of `SwapRequestBeneficiary`. */
  allSwapRequestBeneficiaries?: Maybe<SwapRequestBeneficiariesConnection>;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  allSwapRequests?: Maybe<SwapRequestsConnection>;
  /** Reads and enables pagination through a set of `Swap`. */
  allSwaps?: Maybe<SwapsConnection>;
  /** Reads and enables pagination through a set of `TransactionRef`. */
  allTransactionRefs?: Maybe<TransactionRefsConnection>;
  /** Reads and enables pagination through a set of `Validator`. */
  allValidators?: Maybe<ValidatorsConnection>;
  archiveInfo: ArchiveInfo;
  /** Reads a single `Auction` using its globally unique `ID`. */
  auction?: Maybe<Auction>;
  /** Get a single `Auction`. */
  auctionById?: Maybe<Auction>;
  /** Reads a single `AuthorityHeartbeat` using its globally unique `ID`. */
  authorityHeartbeat?: Maybe<AuthorityHeartbeat>;
  /** Get a single `AuthorityHeartbeat`. */
  authorityHeartbeatById?: Maybe<AuthorityHeartbeat>;
  /** Reads a single `AuthorityMembership` using its globally unique `ID`. */
  authorityMembership?: Maybe<AuthorityMembership>;
  /** Get a single `AuthorityMembership`. */
  authorityMembershipByEpochIdAndValidatorId?: Maybe<AuthorityMembership>;
  /** Get a single `AuthorityMembership`. */
  authorityMembershipById?: Maybe<AuthorityMembership>;
  /** Reads a single `Block` using its globally unique `ID`. */
  block?: Maybe<Block>;
  /** Get a single `Block`. */
  blockByHash?: Maybe<Block>;
  /** Get a single `Block`. */
  blockById?: Maybe<Block>;
  /** Reads a single `BoostNetworkFeeSplit` using its globally unique `ID`. */
  boostNetworkFeeSplit?: Maybe<BoostNetworkFeeSplit>;
  /** Get a single `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitByBoostedLiquidityDepositId?: Maybe<BoostNetworkFeeSplit>;
  /** Get a single `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitByBoostedSwapRequestId?: Maybe<BoostNetworkFeeSplit>;
  /** Get a single `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitById?: Maybe<BoostNetworkFeeSplit>;
  /** Get a single `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitByNetworkFeeSwapRequestId?: Maybe<BoostNetworkFeeSplit>;
  /** Reads a single `Broadcast` using its globally unique `ID`. */
  broadcast?: Maybe<Broadcast>;
  /** Get a single `Broadcast`. */
  broadcastByDestinationChainAndNativeId?: Maybe<Broadcast>;
  /** Get a single `Broadcast`. */
  broadcastById?: Maybe<Broadcast>;
  /** Reads a single `Broker` using its globally unique `ID`. */
  broker?: Maybe<Broker>;
  /** Get a single `Broker`. */
  brokerByAccountId?: Maybe<Broker>;
  /** Get a single `Broker`. */
  brokerByDelegateBrokerIdAndRegistrationId?: Maybe<Broker>;
  /** Get a single `Broker`. */
  brokerById?: Maybe<Broker>;
  /** Reads a single `BrokerChannel` using its globally unique `ID`. */
  brokerChannel?: Maybe<BrokerChannel>;
  /** Get a single `BrokerChannel`. */
  brokerChannelByChannelIdAndOpenEventId?: Maybe<BrokerChannel>;
  /** Get a single `BrokerChannel`. */
  brokerChannelById?: Maybe<BrokerChannel>;
  /** Get a single `BrokerFeeAndWithdrawalV2`. */
  brokerFeeAndWithdrawalV2ByEventId?: Maybe<BrokerFeeAndWithdrawalV2>;
  /** Reads a single `BrokerVaultAddress` using its globally unique `ID`. */
  brokerVaultAddress?: Maybe<BrokerVaultAddress>;
  /** Get a single `BrokerVaultAddress`. */
  brokerVaultAddressByBrokerIdAndAssetAndEpochId?: Maybe<BrokerVaultAddress>;
  /** Get a single `BrokerVaultAddress`. */
  brokerVaultAddressById?: Maybe<BrokerVaultAddress>;
  /** Reads a single `BrokerWithdrawal` using its globally unique `ID`. */
  brokerWithdrawal?: Maybe<BrokerWithdrawal>;
  /** Get a single `BrokerWithdrawal`. */
  brokerWithdrawalByEgressIdAndChain?: Maybe<BrokerWithdrawal>;
  /** Get a single `BrokerWithdrawal`. */
  brokerWithdrawalById?: Maybe<BrokerWithdrawal>;
  /** Reads a single `Burn` using its globally unique `ID`. */
  burn?: Maybe<Burn>;
  /** Get a single `Burn`. */
  burnById?: Maybe<Burn>;
  /** Reads a single `CfeVersion` using its globally unique `ID`. */
  cfeVersion?: Maybe<CfeVersion>;
  /** Get a single `CfeVersion`. */
  cfeVersionById?: Maybe<CfeVersion>;
  /** Reads a single `ChainTracking` using its globally unique `ID`. */
  chainTracking?: Maybe<ChainTracking>;
  /** Get a single `ChainTracking`. */
  chainTrackingByChain?: Maybe<ChainTracking>;
  /** Get a single `ChainTracking`. */
  chainTrackingById?: Maybe<ChainTracking>;
  /** Reads a single `CollectedFee` using its globally unique `ID`. */
  collectedFee?: Maybe<CollectedFee>;
  /** Get a single `CollectedFee`. */
  collectedFeeById?: Maybe<CollectedFee>;
  /** Reads a single `DelegationActivity` using its globally unique `ID`. */
  delegationActivity?: Maybe<DelegationActivity>;
  /** Get a single `DelegationActivity`. */
  delegationActivityById?: Maybe<DelegationActivity>;
  /** Reads a single `Egress` using its globally unique `ID`. */
  egress?: Maybe<Egress>;
  /** Get a single `Egress`. */
  egressByFailedEventId?: Maybe<Egress>;
  /** Get a single `Egress`. */
  egressById?: Maybe<Egress>;
  /** Get a single `Egress`. */
  egressByNativeIdAndChain?: Maybe<Egress>;
  /** Get a single `Egress`. */
  egressByScheduledEventId?: Maybe<Egress>;
  /** Reads a single `Epoch` using its globally unique `ID`. */
  epoch?: Maybe<Epoch>;
  /** Get a single `Epoch`. */
  epochByEndBlockId?: Maybe<Epoch>;
  /** Get a single `Epoch`. */
  epochById?: Maybe<Epoch>;
  /** Get a single `Epoch`. */
  epochByStartBlockId?: Maybe<Epoch>;
  /** Reads a single `Event` using its globally unique `ID`. */
  event?: Maybe<Event>;
  /** Get a single `Event`. */
  eventByBlockIdAndIndexInBlock?: Maybe<Event>;
  /** Get a single `Event`. */
  eventById?: Maybe<Event>;
  /** Reads a single `EvmStateChainCall` using its globally unique `ID`. */
  evmStateChainCall?: Maybe<EvmStateChainCall>;
  /** Get a single `EvmStateChainCall`. */
  evmStateChainCallById?: Maybe<EvmStateChainCall>;
  /** Get a single `EvmStateChainCall`. */
  evmStateChainCallByTxHash?: Maybe<EvmStateChainCall>;
  /** Reads a single `Extrinsic` using its globally unique `ID`. */
  extrinsic?: Maybe<Extrinsic>;
  /** Get a single `Extrinsic`. */
  extrinsicById?: Maybe<Extrinsic>;
  /** Reads a single `FailedDeposit` using its globally unique `ID`. */
  failedDeposit?: Maybe<FailedDeposit>;
  /** Get a single `FailedDeposit`. */
  failedDepositByEventId?: Maybe<FailedDeposit>;
  /** Get a single `FailedDeposit`. */
  failedDepositById?: Maybe<FailedDeposit>;
  /** Reads a single `ForeignChainTracking` using its globally unique `ID`. */
  foreignChainTracking?: Maybe<ForeignChainTracking>;
  /** Get a single `ForeignChainTracking`. */
  foreignChainTrackingByChainAndForeignBlockHeight?: Maybe<ForeignChainTracking>;
  /** Get a single `ForeignChainTracking`. */
  foreignChainTrackingById?: Maybe<ForeignChainTracking>;
  getBlockCounts: Array<BlockCounts>;
  getBlockDetails: BlockDetails;
  getBlocksDetails: BlocksDetails;
  getEvent?: Maybe<EventInfo>;
  getExtrinsic?: Maybe<ExtrinsicInfo>;
  /** Reads a single `IgnoredEgress` using its globally unique `ID`. */
  ignoredEgress?: Maybe<IgnoredEgress>;
  /** Get a single `IgnoredEgress`. */
  ignoredEgressByEventId?: Maybe<IgnoredEgress>;
  /** Get a single `IgnoredEgress`. */
  ignoredEgressById?: Maybe<IgnoredEgress>;
  /** Reads a single `LatestDelegationReward` using its globally unique `ID`. */
  latestDelegationReward?: Maybe<LatestDelegationReward>;
  /** Get a single `LatestDelegationReward`. */
  latestDelegationRewardByDelegatorAccountId?: Maybe<LatestDelegationReward>;
  /** Get a single `LatestDelegationReward`. */
  latestDelegationRewardById?: Maybe<LatestDelegationReward>;
  /** Reads a single `LendingNetworkFee` using its globally unique `ID`. */
  lendingNetworkFee?: Maybe<LendingNetworkFee>;
  /** Get a single `LendingNetworkFee`. */
  lendingNetworkFeeById?: Maybe<LendingNetworkFee>;
  /** Get a single `LendingNetworkFee`. */
  lendingNetworkFeeBySwapRequestId?: Maybe<LendingNetworkFee>;
  /** Reads a single `LiquidationSwapInfo` using its globally unique `ID`. */
  liquidationSwapInfo?: Maybe<LiquidationSwapInfo>;
  /** Get a single `LiquidationSwapInfo`. */
  liquidationSwapInfoById?: Maybe<LiquidationSwapInfo>;
  /** Get a single `LiquidationSwapInfo`. */
  liquidationSwapInfoBySwapRequestId?: Maybe<LiquidationSwapInfo>;
  /** Get a single `LiquidityBalanceEvent`. */
  liquidityBalanceEventByEventId?: Maybe<LiquidityBalanceEvent>;
  /** Reads a single `LiquidityDeposit` using its globally unique `ID`. */
  liquidityDeposit?: Maybe<LiquidityDeposit>;
  /** Get a single `LiquidityDeposit`. */
  liquidityDepositByChainAndPrewitnessedDepositId?: Maybe<LiquidityDeposit>;
  /** Get a single `LiquidityDeposit`. */
  liquidityDepositById?: Maybe<LiquidityDeposit>;
  /** Reads a single `LiquidityDepositChannel` using its globally unique `ID`. */
  liquidityDepositChannel?: Maybe<LiquidityDepositChannel>;
  /** Get a single `LiquidityDepositChannel`. */
  liquidityDepositChannelById?: Maybe<LiquidityDepositChannel>;
  /** Get a single `LiquidityDepositChannel`. */
  liquidityDepositChannelByIssuedBlockIdAndChainAndChannelId?: Maybe<LiquidityDepositChannel>;
  /** Reads a single `LiquidityProvider` using its globally unique `ID`. */
  liquidityProvider?: Maybe<LiquidityProvider>;
  /** Get a single `LiquidityProvider`. */
  liquidityProviderByAccountId?: Maybe<LiquidityProvider>;
  /** Get a single `LiquidityProvider`. */
  liquidityProviderById?: Maybe<LiquidityProvider>;
  /** Reads a single `LiquidityTransfer` using its globally unique `ID`. */
  liquidityTransfer?: Maybe<LiquidityTransfer>;
  /** Get a single `LiquidityTransfer`. */
  liquidityTransferById?: Maybe<LiquidityTransfer>;
  /** Reads a single `LiquidityWithdrawal` using its globally unique `ID`. */
  liquidityWithdrawal?: Maybe<LiquidityWithdrawal>;
  /** Get a single `LiquidityWithdrawal`. */
  liquidityWithdrawalByEgressId?: Maybe<LiquidityWithdrawal>;
  /** Get a single `LiquidityWithdrawal`. */
  liquidityWithdrawalById?: Maybe<LiquidityWithdrawal>;
  /** Get a single `LiquidityWithdrawal`. */
  liquidityWithdrawalByNativeEgressIdAndChain?: Maybe<LiquidityWithdrawal>;
  marketData: MarketData;
  /** Reads a single `Metadatum` using its globally unique `ID`. */
  metadatum?: Maybe<Metadatum>;
  /** Get a single `Metadatum`. */
  metadatumByChainspecAndName?: Maybe<Metadatum>;
  /** Get a single `Metadatum`. */
  metadatumById?: Maybe<Metadatum>;
  /** Reads a single `NetworkParticipantEarningsDaily` using its globally unique `ID`. */
  networkParticipantEarningsDaily?: Maybe<NetworkParticipantEarningsDaily>;
  /** Get a single `NetworkParticipantEarningsDaily`. */
  networkParticipantEarningsDailyByAccountIdAndRoleAndDay?: Maybe<NetworkParticipantEarningsDaily>;
  /** Get a single `NetworkParticipantEarningsDaily`. */
  networkParticipantEarningsDailyById?: Maybe<NetworkParticipantEarningsDaily>;
  /** Reads a single `NetworkParticipantEarningsHourly` using its globally unique `ID`. */
  networkParticipantEarningsHourly?: Maybe<NetworkParticipantEarningsHourly>;
  /** Get a single `NetworkParticipantEarningsHourly`. */
  networkParticipantEarningsHourlyByAccountIdAndRoleAndBlock?: Maybe<NetworkParticipantEarningsHourly>;
  /** Get a single `NetworkParticipantEarningsHourly`. */
  networkParticipantEarningsHourlyById?: Maybe<NetworkParticipantEarningsHourly>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OnChainSwapInfo` using its globally unique `ID`. */
  onChainSwapInfo?: Maybe<OnChainSwapInfo>;
  /** Get a single `OnChainSwapInfo`. */
  onChainSwapInfoById?: Maybe<OnChainSwapInfo>;
  /** Get a single `OnChainSwapInfo`. */
  onChainSwapInfoBySwapRequestId?: Maybe<OnChainSwapInfo>;
  /** Reads a single `Operator` using its globally unique `ID`. */
  operator?: Maybe<Operator>;
  /** Reads a single `OperatorAction` using its globally unique `ID`. */
  operatorAction?: Maybe<OperatorAction>;
  /** Get a single `OperatorAction`. */
  operatorActionById?: Maybe<OperatorAction>;
  /** Get a single `Operator`. */
  operatorByAccountId?: Maybe<Operator>;
  /** Get a single `Operator`. */
  operatorById?: Maybe<Operator>;
  /** Reads a single `OperatorEpoch` using its globally unique `ID`. */
  operatorEpoch?: Maybe<OperatorEpoch>;
  /** Get a single `OperatorEpoch`. */
  operatorEpochById?: Maybe<OperatorEpoch>;
  /** Get a single `OperatorEpoch`. */
  operatorEpochByOperatorIdAndEpochId?: Maybe<OperatorEpoch>;
  /** Reads a single `OperatorEpochDelegation` using its globally unique `ID`. */
  operatorEpochDelegation?: Maybe<OperatorEpochDelegation>;
  /** Get a single `OperatorEpochDelegationApy`. */
  operatorEpochDelegationApyByOperatorIdAndEpochId?: Maybe<OperatorEpochDelegationApy>;
  /** Get a single `OperatorEpochDelegation`. */
  operatorEpochDelegationById?: Maybe<OperatorEpochDelegation>;
  /** Get a single `OperatorEpochDelegation`. */
  operatorEpochDelegationByOperatorEpochIdAndDelegatorAccountId?: Maybe<OperatorEpochDelegation>;
  /** Reads a single `OperatorEpochValidator` using its globally unique `ID`. */
  operatorEpochValidator?: Maybe<OperatorEpochValidator>;
  /** Get a single `OperatorEpochValidator`. */
  operatorEpochValidatorByAuthorityMembershipId?: Maybe<OperatorEpochValidator>;
  /** Get a single `OperatorEpochValidator`. */
  operatorEpochValidatorById?: Maybe<OperatorEpochValidator>;
  /** Get a single `OperatorEpochValidator`. */
  operatorEpochValidatorByOperatorEpochIdAndValidatorId?: Maybe<OperatorEpochValidator>;
  /** Reads a single `OperatorValidatorLink` using its globally unique `ID`. */
  operatorValidatorLink?: Maybe<OperatorValidatorLink>;
  /** Get a single `OperatorValidatorLink`. */
  operatorValidatorLinkById?: Maybe<OperatorValidatorLink>;
  /** Reads a single `OraclePriceTracking` using its globally unique `ID`. */
  oraclePriceTracking?: Maybe<OraclePriceTracking>;
  /** Get a single `OraclePriceTracking`. */
  oraclePriceTrackingByBaseAssetAndQuoteAssetAndCreatedAtEventId?: Maybe<OraclePriceTracking>;
  /** Get a single `OraclePriceTracking`. */
  oraclePriceTrackingById?: Maybe<OraclePriceTracking>;
  /** Reads a single `Penalty` using its globally unique `ID`. */
  penalty?: Maybe<Penalty>;
  /** Get a single `Penalty`. */
  penaltyById?: Maybe<Penalty>;
  /** Reads a single `Pool` using its globally unique `ID`. */
  pool?: Maybe<Pool>;
  /** Get a single `Pool`. */
  poolByBaseAssetAndQuoteAsset?: Maybe<Pool>;
  /** Get a single `Pool`. */
  poolById?: Maybe<Pool>;
  /** Reads a single `PoolOrderEvent` using its globally unique `ID`. */
  poolOrderEvent?: Maybe<PoolOrderEvent>;
  /** Get a single `PoolOrderEvent`. */
  poolOrderEventByEventId?: Maybe<PoolOrderEvent>;
  /** Get a single `PoolOrderEvent`. */
  poolOrderEventById?: Maybe<PoolOrderEvent>;
  /** Reads a single `PoolSwap` using its globally unique `ID`. */
  poolSwap?: Maybe<PoolSwap>;
  /** Get a single `PoolSwap`. */
  poolSwapById?: Maybe<PoolSwap>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Get a single `RecentPoolOrderEvent`. */
  recentPoolOrderEventByEventId?: Maybe<RecentPoolOrderEvent>;
  /** Reads a single `RotationEvent` using its globally unique `ID`. */
  rotationEvent?: Maybe<RotationEvent>;
  /** Get a single `RotationEvent`. */
  rotationEventById?: Maybe<RotationEvent>;
  /** Reads a single `StateChainError` using its globally unique `ID`. */
  stateChainError?: Maybe<StateChainError>;
  /** Get a single `StateChainError`. */
  stateChainErrorByChainspecAndPalletIndexAndErrorIndex?: Maybe<StateChainError>;
  /** Get a single `StateChainError`. */
  stateChainErrorById?: Maybe<StateChainError>;
  /** Reads a single `Swap` using its globally unique `ID`. */
  swap?: Maybe<Swap>;
  /** Get a single `Swap`. */
  swapById?: Maybe<Swap>;
  /** Get a single `Swap`. */
  swapByNativeId?: Maybe<Swap>;
  /** Reads a single `SwapChannel` using its globally unique `ID`. */
  swapChannel?: Maybe<SwapChannel>;
  /** Reads a single `SwapChannelBeneficiary` using its globally unique `ID`. */
  swapChannelBeneficiary?: Maybe<SwapChannelBeneficiary>;
  /** Get a single `SwapChannelBeneficiary`. */
  swapChannelBeneficiaryById?: Maybe<SwapChannelBeneficiary>;
  /** Get a single `SwapChannel`. */
  swapChannelById?: Maybe<SwapChannel>;
  /** Get a single `SwapChannel`. */
  swapChannelByIssuedBlockIdAndSourceChainAndChannelId?: Maybe<SwapChannel>;
  /** Reads a single `SwapCommission` using its globally unique `ID`. */
  swapCommission?: Maybe<SwapCommission>;
  /** Get a single `SwapCommission`. */
  swapCommissionById?: Maybe<SwapCommission>;
  /** Reads a single `SwapFee` using its globally unique `ID`. */
  swapFee?: Maybe<SwapFee>;
  /** Get a single `SwapFee`. */
  swapFeeById?: Maybe<SwapFee>;
  /** Reads a single `SwapRequest` using its globally unique `ID`. */
  swapRequest?: Maybe<SwapRequest>;
  /** Reads a single `SwapRequestBeneficiary` using its globally unique `ID`. */
  swapRequestBeneficiary?: Maybe<SwapRequestBeneficiary>;
  /** Get a single `SwapRequestBeneficiary`. */
  swapRequestBeneficiaryById?: Maybe<SwapRequestBeneficiary>;
  /** Get a single `SwapRequest`. */
  swapRequestById?: Maybe<SwapRequest>;
  /** Get a single `SwapRequest`. */
  swapRequestByIgnoredEgressId?: Maybe<SwapRequest>;
  /** Get a single `SwapRequest`. */
  swapRequestByIgnoredRefundEgressId?: Maybe<SwapRequest>;
  /** Get a single `SwapRequest`. */
  swapRequestByNativeId?: Maybe<SwapRequest>;
  /** Get a single `SwapRequest`. */
  swapRequestBySourceChainAndPrewitnessedDepositId?: Maybe<SwapRequest>;
  /** Reads a single `TransactionRef` using its globally unique `ID`. */
  transactionRef?: Maybe<TransactionRef>;
  /** Get a single `TransactionRef`. */
  transactionRefById?: Maybe<TransactionRef>;
  /** Get a single `TransactionRef`. */
  transactionRefByRef?: Maybe<TransactionRef>;
  /** Reads a single `Validator` using its globally unique `ID`. */
  validator?: Maybe<Validator>;
  /** Get a single `Validator`. */
  validatorByAccountId?: Maybe<Validator>;
  /** Get a single `Validator`. */
  validatorById?: Maybe<Validator>;
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type Query_PrismaMigrationByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdHexArgs = {
  idHex: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountByIdSs58Args = {
  idSs58: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountCreationDepositChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountCreationDepositChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountCreationDepositChannelByIssuedBlockIdAndChainAndChannelIdArgs = {
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['input'];
  issuedBlockId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountFundingEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountFundingEventByAccountCreationDepositChannelIdArgs = {
  accountCreationDepositChannelId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountFundingEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAccountFundingEventBySwapRequestIdArgs = {
  swapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountCreationDepositChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCreationDepositChannelCondition>;
  filter?: InputMaybe<AccountCreationDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountCreationDepositChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountFundingEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAccountsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountCondition>;
  filter?: InputMaybe<AccountFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAuctionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuctionCondition>;
  filter?: InputMaybe<AuctionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuctionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAuthorityHeartbeatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityHeartbeatCondition>;
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityHeartbeatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllAuthorityMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityMembershipCondition>;
  filter?: InputMaybe<AuthorityMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityMembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBlocksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlockCondition>;
  filter?: InputMaybe<BlockFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlocksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBoostNetworkFeeSplitsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBroadcastsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BroadcastCondition>;
  filter?: InputMaybe<BroadcastFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BroadcastsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerAllTimeStatsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerAllTimeStatCondition>;
  filter?: InputMaybe<BrokerAllTimeStatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerAllTimeStatsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerChannelCondition>;
  filter?: InputMaybe<BrokerChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerFeeAndWithdrawalV2SArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerFeeAndWithdrawalV2Condition>;
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerFeeAndWithdrawalV2SOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerVaultAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerVaultAddressCondition>;
  filter?: InputMaybe<BrokerVaultAddressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerVaultAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokerWithdrawalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerWithdrawalCondition>;
  filter?: InputMaybe<BrokerWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokerWithdrawalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBrokersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BrokerCondition>;
  filter?: InputMaybe<BrokerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BrokersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllBurnsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BurnCondition>;
  filter?: InputMaybe<BurnFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BurnsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCfeVersionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CfeVersionCondition>;
  filter?: InputMaybe<CfeVersionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CfeVersionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllChainTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ChainTrackingCondition>;
  filter?: InputMaybe<ChainTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChainTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllCollectedFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<CollectedFeeCondition>;
  filter?: InputMaybe<CollectedFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CollectedFeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllDelegationActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DelegationActivityCondition>;
  filter?: InputMaybe<DelegationActivityFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DelegationActivitiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEgressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EgressCondition>;
  filter?: InputMaybe<EgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EgressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEpochesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EpochCondition>;
  filter?: InputMaybe<EpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EpochesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EventCondition>;
  filter?: InputMaybe<EventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllEvmStateChainCallsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvmStateChainCallCondition>;
  filter?: InputMaybe<EvmStateChainCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvmStateChainCallsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllExtrinsicsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ExtrinsicCondition>;
  filter?: InputMaybe<ExtrinsicFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ExtrinsicsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllFailedDepositsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllForeignChainTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ForeignChainTrackingCondition>;
  filter?: InputMaybe<ForeignChainTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ForeignChainTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllIgnoredEgressesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IgnoredEgressCondition>;
  filter?: InputMaybe<IgnoredEgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IgnoredEgressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLatestDelegationRewardsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LatestDelegationRewardCondition>;
  filter?: InputMaybe<LatestDelegationRewardFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LatestDelegationRewardsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLendingNetworkFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingNetworkFeeCondition>;
  filter?: InputMaybe<LendingNetworkFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingNetworkFeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidationSwapInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityBalanceEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityBalanceEventCondition>;
  filter?: InputMaybe<LiquidityBalanceEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityBalanceEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityDepositChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositChannelCondition>;
  filter?: InputMaybe<LiquidityDepositChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityDepositsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityDepositCondition>;
  filter?: InputMaybe<LiquidityDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityDepositsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityProvidersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityProviderCondition>;
  filter?: InputMaybe<LiquidityProviderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityProvidersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityTransfersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityTransferCondition>;
  filter?: InputMaybe<LiquidityTransferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityTransfersOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllLiquidityWithdrawalsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidityWithdrawalCondition>;
  filter?: InputMaybe<LiquidityWithdrawalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidityWithdrawalsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllMetadataArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<MetadatumCondition>;
  filter?: InputMaybe<MetadatumFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<MetadataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNetworkParticipantEarningsDailiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NetworkParticipantEarningsDailyCondition>;
  filter?: InputMaybe<NetworkParticipantEarningsDailyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NetworkParticipantEarningsDailiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllNetworkParticipantEarningsHourliesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<NetworkParticipantEarningsHourlyCondition>;
  filter?: InputMaybe<NetworkParticipantEarningsHourlyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<NetworkParticipantEarningsHourliesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOnChainSwapInfosArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OnChainSwapInfoCondition>;
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OnChainSwapInfosOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorActionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorActionCondition>;
  filter?: InputMaybe<OperatorActionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorActionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorEpochDelegationApiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationApyCondition>;
  filter?: InputMaybe<OperatorEpochDelegationApyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationApiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorEpochDelegationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochDelegationCondition>;
  filter?: InputMaybe<OperatorEpochDelegationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochDelegationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorEpochValidatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochValidatorCondition>;
  filter?: InputMaybe<OperatorEpochValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochValidatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorEpochesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochCondition>;
  filter?: InputMaybe<OperatorEpochFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorValidatorLinksArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorLinkCondition>;
  filter?: InputMaybe<OperatorValidatorLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorLinksOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOperatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorCondition>;
  filter?: InputMaybe<OperatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllOraclePriceTrackingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OraclePriceTrackingCondition>;
  filter?: InputMaybe<OraclePriceTrackingFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OraclePriceTrackingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPenaltiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PenaltyCondition>;
  filter?: InputMaybe<PenaltyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PenaltiesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolOrderEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolOrderEventCondition>;
  filter?: InputMaybe<PoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolOrderEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolSwapsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolSwapCondition>;
  filter?: InputMaybe<PoolSwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolSwapsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPoolsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PoolCondition>;
  filter?: InputMaybe<PoolFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PoolsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllPrismaMigrationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<_PrismaMigrationCondition>;
  filter?: InputMaybe<_PrismaMigrationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<_PrismaMigrationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRecentPoolOrderEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RecentPoolOrderEventCondition>;
  filter?: InputMaybe<RecentPoolOrderEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecentPoolOrderEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllRotationEventsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<RotationEventCondition>;
  filter?: InputMaybe<RotationEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RotationEventsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllStateChainErrorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<StateChainErrorCondition>;
  filter?: InputMaybe<StateChainErrorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<StateChainErrorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapChannelBeneficiariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelBeneficiaryCondition>;
  filter?: InputMaybe<SwapChannelBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelBeneficiariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapChannelsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelCondition>;
  filter?: InputMaybe<SwapChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapCommissionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCommissionCondition>;
  filter?: InputMaybe<SwapCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapCommissionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapFeesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapFeeCondition>;
  filter?: InputMaybe<SwapFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapFeesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapRequestBeneficiariesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestBeneficiaryCondition>;
  filter?: InputMaybe<SwapRequestBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestBeneficiariesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapRequestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllSwapsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCondition>;
  filter?: InputMaybe<SwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllTransactionRefsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransactionRefCondition>;
  filter?: InputMaybe<TransactionRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransactionRefsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAllValidatorsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ValidatorCondition>;
  filter?: InputMaybe<ValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ValidatorsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuctionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthorityHeartbeatArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthorityHeartbeatByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthorityMembershipArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthorityMembershipByEpochIdAndValidatorIdArgs = {
  epochId: Scalars['Int']['input'];
  validatorId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAuthorityMembershipByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBlockArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBlockByHashArgs = {
  hash: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBlockByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostNetworkFeeSplitArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostNetworkFeeSplitByBoostedLiquidityDepositIdArgs = {
  boostedLiquidityDepositId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostNetworkFeeSplitByBoostedSwapRequestIdArgs = {
  boostedSwapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostNetworkFeeSplitByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBoostNetworkFeeSplitByNetworkFeeSwapRequestIdArgs = {
  networkFeeSwapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBroadcastArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBroadcastByDestinationChainAndNativeIdArgs = {
  destinationChain: ChainflipChain;
  nativeId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBroadcastByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerByAccountIdArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerByDelegateBrokerIdAndRegistrationIdArgs = {
  delegateBrokerId: Scalars['Int']['input'];
  registrationId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerChannelByChannelIdAndOpenEventIdArgs = {
  channelId: Scalars['BigInt']['input'];
  openEventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerFeeAndWithdrawalV2ByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerVaultAddressArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerVaultAddressByBrokerIdAndAssetAndEpochIdArgs = {
  asset: ChainflipAsset;
  brokerId: Scalars['Int']['input'];
  epochId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerVaultAddressByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerWithdrawalArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerWithdrawalByEgressIdAndChainArgs = {
  chain: ChainflipChain;
  egressId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBrokerWithdrawalByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBurnArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryBurnByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCfeVersionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCfeVersionByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChainTrackingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryChainTrackingByChainArgs = {
  chain: ChainflipChain;
};


/** The root query type which gives access points into the data universe. */
export type QueryChainTrackingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCollectedFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCollectedFeeByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDelegationActivityArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDelegationActivityByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEgressArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEgressByFailedEventIdArgs = {
  failedEventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEgressByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEgressByNativeIdAndChainArgs = {
  chain: ChainflipChain;
  nativeId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEgressByScheduledEventIdArgs = {
  scheduledEventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEpochArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEpochByEndBlockIdArgs = {
  endBlockId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEpochByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEpochByStartBlockIdArgs = {
  startBlockId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByBlockIdAndIndexInBlockArgs = {
  blockId: Scalars['Int']['input'];
  indexInBlock: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEvmStateChainCallArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEvmStateChainCallByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEvmStateChainCallByTxHashArgs = {
  txHash: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrinsicArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryExtrinsicByIdArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFailedDepositArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFailedDepositByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFailedDepositByIdArgs = {
  id: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForeignChainTrackingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForeignChainTrackingByChainAndForeignBlockHeightArgs = {
  chain: ChainflipChain;
  foreignBlockHeight: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryForeignChainTrackingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBlockCountsArgs = {
  endBlockHeight: Scalars['Int']['input'];
  startBlockHeight: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBlockDetailsArgs = {
  blockHeight?: InputMaybe<Scalars['Int']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetBlocksDetailsArgs = {
  endBlockHeight: Scalars['Int']['input'];
  startBlockHeight: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGetEventArgs = {
  block: IndexInBlockFilter;
};


/** The root query type which gives access points into the data universe. */
export type QueryGetExtrinsicArgs = {
  block?: InputMaybe<IndexInBlockFilter>;
  hash?: InputMaybe<Scalars['String']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryIgnoredEgressArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIgnoredEgressByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryIgnoredEgressByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestDelegationRewardArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestDelegationRewardByDelegatorAccountIdArgs = {
  delegatorAccountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLatestDelegationRewardByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingNetworkFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingNetworkFeeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLendingNetworkFeeBySwapRequestIdArgs = {
  swapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapInfoArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapInfoByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidationSwapInfoBySwapRequestIdArgs = {
  swapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityBalanceEventByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositByChainAndPrewitnessedDepositIdArgs = {
  chain: ChainflipChain;
  prewitnessedDepositId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityDepositChannelByIssuedBlockIdAndChainAndChannelIdArgs = {
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['input'];
  issuedBlockId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityProviderArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityProviderByAccountIdArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityProviderByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityTransferArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityTransferByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityWithdrawalArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityWithdrawalByEgressIdArgs = {
  egressId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityWithdrawalByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLiquidityWithdrawalByNativeEgressIdAndChainArgs = {
  chain: ChainflipChain;
  nativeEgressId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMarketDataArgs = {
  asset: ChainflipAsset;
  numberOfDays?: InputMaybe<Scalars['Int']['input']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMetadatumArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetadatumByChainspecAndNameArgs = {
  chainspec: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMetadatumByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsDailyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsDailyByAccountIdAndRoleAndDayArgs = {
  accountId: Scalars['Int']['input'];
  day: Scalars['Date']['input'];
  role: NetworkParticipantRole;
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsDailyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsHourlyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsHourlyByAccountIdAndRoleAndBlockArgs = {
  accountId: Scalars['Int']['input'];
  block: Scalars['Int']['input'];
  role: NetworkParticipantRole;
};


/** The root query type which gives access points into the data universe. */
export type QueryNetworkParticipantEarningsHourlyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOnChainSwapInfoArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOnChainSwapInfoByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOnChainSwapInfoBySwapRequestIdArgs = {
  swapRequestId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorActionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorActionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorByAccountIdArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochByOperatorIdAndEpochIdArgs = {
  epochId: Scalars['Int']['input'];
  operatorId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochDelegationArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochDelegationApyByOperatorIdAndEpochIdArgs = {
  epochId: Scalars['Int']['input'];
  operatorId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochDelegationByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochDelegationByOperatorEpochIdAndDelegatorAccountIdArgs = {
  delegatorAccountId: Scalars['Int']['input'];
  operatorEpochId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochValidatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochValidatorByAuthorityMembershipIdArgs = {
  authorityMembershipId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochValidatorByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorEpochValidatorByOperatorEpochIdAndValidatorIdArgs = {
  operatorEpochId: Scalars['Int']['input'];
  validatorId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorValidatorLinkArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOperatorValidatorLinkByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingByBaseAssetAndQuoteAssetAndCreatedAtEventIdArgs = {
  baseAsset: PriceAsset;
  createdAtEventId: Scalars['BigInt']['input'];
  quoteAsset: PriceAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryOraclePriceTrackingByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPenaltyArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPenaltyByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolByBaseAssetAndQuoteAssetArgs = {
  baseAsset: ChainflipAsset;
  quoteAsset: ChainflipAsset;
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderEventByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolOrderEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolSwapArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPoolSwapByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRecentPoolOrderEventByEventIdArgs = {
  eventId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRotationEventArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRotationEventByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStateChainErrorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStateChainErrorByChainspecAndPalletIndexAndErrorIndexArgs = {
  chainspec: Scalars['String']['input'];
  errorIndex: Scalars['Int']['input'];
  palletIndex: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryStateChainErrorByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapByNativeIdArgs = {
  nativeId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapChannelArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapChannelBeneficiaryArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapChannelBeneficiaryByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapChannelByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapChannelByIssuedBlockIdAndSourceChainAndChannelIdArgs = {
  channelId: Scalars['BigInt']['input'];
  issuedBlockId: Scalars['Int']['input'];
  sourceChain: ChainflipChain;
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapCommissionArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapCommissionByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapFeeArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapFeeByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestBeneficiaryArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestBeneficiaryByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestByIgnoredEgressIdArgs = {
  ignoredEgressId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestByIgnoredRefundEgressIdArgs = {
  ignoredRefundEgressId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestByNativeIdArgs = {
  nativeId: Scalars['BigInt']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QuerySwapRequestBySourceChainAndPrewitnessedDepositIdArgs = {
  prewitnessedDepositId: Scalars['BigInt']['input'];
  sourceChain: ChainflipChain;
};


/** The root query type which gives access points into the data universe. */
export type QueryTransactionRefArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTransactionRefByIdArgs = {
  id: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTransactionRefByRefArgs = {
  ref: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorArgs = {
  nodeId: Scalars['ID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorByAccountIdArgs = {
  accountId: Scalars['Int']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryValidatorByIdArgs = {
  id: Scalars['Int']['input'];
};

export type RecentPoolOrderEvent = {
  __typename?: 'RecentPoolOrderEvent';
  baseAmount: Scalars['BigFloat']['output'];
  baseAsset: ChainflipAsset;
  baseCollectedFees: Scalars['BigFloat']['output'];
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  baseValueUsd: Scalars['BigFloat']['output'];
  /** Reads a single `Event` that is related to this `RecentPoolOrderEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  eventType: PoolEventType;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityProvider` that is related to this `RecentPoolOrderEvent`. */
  liquidityProviderByLiquidityProviderId: LiquidityProvider;
  liquidityProviderId: Scalars['Int']['output'];
  maximumRate: Scalars['BigFloat']['output'];
  minimumRate: Scalars['BigFloat']['output'];
  orderId: Scalars['String']['output'];
  orderType: PoolOrderType;
  quoteAmount: Scalars['BigFloat']['output'];
  quoteCollectedFees: Scalars['BigFloat']['output'];
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  quoteValueUsd: Scalars['BigFloat']['output'];
  timestamp: Scalars['Datetime']['output'];
};

export type RecentPoolOrderEventAggregates = {
  __typename?: 'RecentPoolOrderEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RecentPoolOrderEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RecentPoolOrderEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RecentPoolOrderEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RecentPoolOrderEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RecentPoolOrderEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RecentPoolOrderEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RecentPoolOrderEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RecentPoolOrderEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RecentPoolOrderEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `RecentPoolOrderEvent` object types. */
export type RecentPoolOrderEventAggregatesFilter = {
  /** Mean average aggregate over matching `RecentPoolOrderEvent` objects. */
  average?: InputMaybe<RecentPoolOrderEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `RecentPoolOrderEvent` objects. */
  distinctCount?: InputMaybe<RecentPoolOrderEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `RecentPoolOrderEvent` object to be included within the aggregate. */
  filter?: InputMaybe<RecentPoolOrderEventFilter>;
  /** Maximum aggregate over matching `RecentPoolOrderEvent` objects. */
  max?: InputMaybe<RecentPoolOrderEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `RecentPoolOrderEvent` objects. */
  min?: InputMaybe<RecentPoolOrderEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `RecentPoolOrderEvent` objects. */
  stddevPopulation?: InputMaybe<RecentPoolOrderEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `RecentPoolOrderEvent` objects. */
  stddevSample?: InputMaybe<RecentPoolOrderEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `RecentPoolOrderEvent` objects. */
  sum?: InputMaybe<RecentPoolOrderEventSumAggregateFilter>;
  /** Population variance aggregate over matching `RecentPoolOrderEvent` objects. */
  variancePopulation?: InputMaybe<RecentPoolOrderEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `RecentPoolOrderEvent` objects. */
  varianceSample?: InputMaybe<RecentPoolOrderEventVarianceSampleAggregateFilter>;
};

export type RecentPoolOrderEventAverageAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventAverageAggregates = {
  __typename?: 'RecentPoolOrderEventAverageAggregates';
  /** Mean average of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `RecentPoolOrderEvent` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RecentPoolOrderEventCondition = {
  /** Checks for equality with the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `baseValueUsd` field. */
  baseValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `eventType` field. */
  eventType?: InputMaybe<PoolEventType>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityProviderByLiquidityProviderId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `maximumRate` field. */
  maximumRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `minimumRate` field. */
  minimumRate?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `orderId` field. */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderType>;
  /** Checks for equality with the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `quoteValueUsd` field. */
  quoteValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

export type RecentPoolOrderEventDistinctCountAggregateFilter = {
  baseAmount?: InputMaybe<BigIntFilter>;
  baseAsset?: InputMaybe<BigIntFilter>;
  baseCollectedFees?: InputMaybe<BigIntFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  baseValueUsd?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  eventType?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maximumRate?: InputMaybe<BigIntFilter>;
  minimumRate?: InputMaybe<BigIntFilter>;
  orderId?: InputMaybe<BigIntFilter>;
  orderType?: InputMaybe<BigIntFilter>;
  quoteAmount?: InputMaybe<BigIntFilter>;
  quoteCollectedFees?: InputMaybe<BigIntFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigIntFilter>;
  quoteValueUsd?: InputMaybe<BigIntFilter>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type RecentPoolOrderEventDistinctCountAggregates = {
  __typename?: 'RecentPoolOrderEventDistinctCountAggregates';
  /** Distinct count of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseAsset across the matching connection */
  baseAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventType across the matching connection */
  eventType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderId across the matching connection */
  orderId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of orderType across the matching connection */
  orderType?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `RecentPoolOrderEvent` object types. All fields are combined with a logical ‘and.’ */
export type RecentPoolOrderEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RecentPoolOrderEventFilter>>;
  /** Filter by the object’s `baseAmount` field. */
  baseAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseAsset` field. */
  baseAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `baseCollectedFees` field. */
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseCollectedFeesUsd` field. */
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `baseValueUsd` field. */
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `eventType` field. */
  eventType?: InputMaybe<PoolEventTypeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityProviderByLiquidityProviderId` relation. */
  liquidityProviderByLiquidityProviderId?: InputMaybe<LiquidityProviderFilter>;
  /** Filter by the object’s `liquidityProviderId` field. */
  liquidityProviderId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `maximumRate` field. */
  maximumRate?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `minimumRate` field. */
  minimumRate?: InputMaybe<BigFloatFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RecentPoolOrderEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RecentPoolOrderEventFilter>>;
  /** Filter by the object’s `orderId` field. */
  orderId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `orderType` field. */
  orderType?: InputMaybe<PoolOrderTypeFilter>;
  /** Filter by the object’s `quoteAmount` field. */
  quoteAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteCollectedFees` field. */
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteCollectedFeesUsd` field. */
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `quoteValueUsd` field. */
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `RecentPoolOrderEvent` for usage during aggregation. */
export type RecentPoolOrderEventGroupBy =
  | 'BASE_AMOUNT'
  | 'BASE_ASSET'
  | 'BASE_COLLECTED_FEES'
  | 'BASE_COLLECTED_FEES_USD'
  | 'BASE_VALUE_USD'
  | 'EVENT_TYPE'
  | 'ID'
  | 'LIQUIDITY_PROVIDER_ID'
  | 'MAXIMUM_RATE'
  | 'MINIMUM_RATE'
  | 'ORDER_ID'
  | 'ORDER_TYPE'
  | 'QUOTE_AMOUNT'
  | 'QUOTE_COLLECTED_FEES'
  | 'QUOTE_COLLECTED_FEES_USD'
  | 'QUOTE_VALUE_USD'
  | 'TIMESTAMP'
  | 'TIMESTAMP_TRUNCATED_TO_DAY'
  | 'TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'TIMESTAMP_TRUNCATED_TO_WEEK';

export type RecentPoolOrderEventHavingAverageInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingDistinctCountInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `RecentPoolOrderEvent` aggregates. */
export type RecentPoolOrderEventHavingInput = {
  AND?: InputMaybe<Array<RecentPoolOrderEventHavingInput>>;
  OR?: InputMaybe<Array<RecentPoolOrderEventHavingInput>>;
  average?: InputMaybe<RecentPoolOrderEventHavingAverageInput>;
  distinctCount?: InputMaybe<RecentPoolOrderEventHavingDistinctCountInput>;
  max?: InputMaybe<RecentPoolOrderEventHavingMaxInput>;
  min?: InputMaybe<RecentPoolOrderEventHavingMinInput>;
  stddevPopulation?: InputMaybe<RecentPoolOrderEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RecentPoolOrderEventHavingStddevSampleInput>;
  sum?: InputMaybe<RecentPoolOrderEventHavingSumInput>;
  variancePopulation?: InputMaybe<RecentPoolOrderEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RecentPoolOrderEventHavingVarianceSampleInput>;
};

export type RecentPoolOrderEventHavingMaxInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingMinInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingStddevPopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingStddevSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingSumInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingVariancePopulationInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventHavingVarianceSampleInput = {
  baseAmount?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  baseValueUsd?: InputMaybe<HavingBigfloatFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityProviderId?: InputMaybe<HavingIntFilter>;
  maximumRate?: InputMaybe<HavingBigfloatFilter>;
  minimumRate?: InputMaybe<HavingBigfloatFilter>;
  quoteAmount?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFees?: InputMaybe<HavingBigfloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<HavingBigfloatFilter>;
  quoteValueUsd?: InputMaybe<HavingBigfloatFilter>;
  timestamp?: InputMaybe<HavingDatetimeFilter>;
};

export type RecentPoolOrderEventMaxAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type RecentPoolOrderEventMaxAggregates = {
  __typename?: 'RecentPoolOrderEventMaxAggregates';
  /** Maximum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type RecentPoolOrderEventMinAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityProviderId?: InputMaybe<IntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
};

export type RecentPoolOrderEventMinAggregates = {
  __typename?: 'RecentPoolOrderEventMinAggregates';
  /** Minimum of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of timestamp across the matching connection */
  timestamp?: Maybe<Scalars['Datetime']['output']>;
};

export type RecentPoolOrderEventStddevPopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventStddevPopulationAggregates = {
  __typename?: 'RecentPoolOrderEventStddevPopulationAggregates';
  /** Population standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type RecentPoolOrderEventStddevSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventStddevSampleAggregates = {
  __typename?: 'RecentPoolOrderEventStddevSampleAggregates';
  /** Sample standard deviation of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type RecentPoolOrderEventSumAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityProviderId?: InputMaybe<BigIntFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventSumAggregates = {
  __typename?: 'RecentPoolOrderEventSumAggregates';
  /** Sum of baseAmount across the matching connection */
  baseAmount: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFees across the matching connection */
  baseCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of baseValueUsd across the matching connection */
  baseValueUsd: Scalars['BigFloat']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityProviderId across the matching connection */
  liquidityProviderId: Scalars['BigInt']['output'];
  /** Sum of maximumRate across the matching connection */
  maximumRate: Scalars['BigFloat']['output'];
  /** Sum of minimumRate across the matching connection */
  minimumRate: Scalars['BigFloat']['output'];
  /** Sum of quoteAmount across the matching connection */
  quoteAmount: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFees across the matching connection */
  quoteCollectedFees: Scalars['BigFloat']['output'];
  /** Sum of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd: Scalars['BigFloat']['output'];
  /** Sum of quoteValueUsd across the matching connection */
  quoteValueUsd: Scalars['BigFloat']['output'];
};

export type RecentPoolOrderEventVariancePopulationAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventVariancePopulationAggregates = {
  __typename?: 'RecentPoolOrderEventVariancePopulationAggregates';
  /** Population variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type RecentPoolOrderEventVarianceSampleAggregateFilter = {
  baseAmount?: InputMaybe<BigFloatFilter>;
  baseCollectedFees?: InputMaybe<BigFloatFilter>;
  baseCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  baseValueUsd?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityProviderId?: InputMaybe<BigFloatFilter>;
  maximumRate?: InputMaybe<BigFloatFilter>;
  minimumRate?: InputMaybe<BigFloatFilter>;
  quoteAmount?: InputMaybe<BigFloatFilter>;
  quoteCollectedFees?: InputMaybe<BigFloatFilter>;
  quoteCollectedFeesUsd?: InputMaybe<BigFloatFilter>;
  quoteValueUsd?: InputMaybe<BigFloatFilter>;
};

export type RecentPoolOrderEventVarianceSampleAggregates = {
  __typename?: 'RecentPoolOrderEventVarianceSampleAggregates';
  /** Sample variance of baseAmount across the matching connection */
  baseAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFees across the matching connection */
  baseCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseCollectedFeesUsd across the matching connection */
  baseCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of baseValueUsd across the matching connection */
  baseValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityProviderId across the matching connection */
  liquidityProviderId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maximumRate across the matching connection */
  maximumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of minimumRate across the matching connection */
  minimumRate?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteAmount across the matching connection */
  quoteAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFees across the matching connection */
  quoteCollectedFees?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteCollectedFeesUsd across the matching connection */
  quoteCollectedFeesUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of quoteValueUsd across the matching connection */
  quoteValueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `RecentPoolOrderEvent` values. */
export type RecentPoolOrderEventsConnection = {
  __typename?: 'RecentPoolOrderEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RecentPoolOrderEventAggregates>;
  /** A list of edges which contains the `RecentPoolOrderEvent` and cursor to aid in pagination. */
  edges: Array<RecentPoolOrderEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RecentPoolOrderEventAggregates>>;
  /** A list of `RecentPoolOrderEvent` objects. */
  nodes: Array<RecentPoolOrderEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RecentPoolOrderEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `RecentPoolOrderEvent` values. */
export type RecentPoolOrderEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<RecentPoolOrderEventGroupBy>;
  having?: InputMaybe<RecentPoolOrderEventHavingInput>;
};

/** A `RecentPoolOrderEvent` edge in the connection. */
export type RecentPoolOrderEventsEdge = {
  __typename?: 'RecentPoolOrderEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RecentPoolOrderEvent` at the end of the edge. */
  node: RecentPoolOrderEvent;
};

/** Methods to use when ordering `RecentPoolOrderEvent`. */
export type RecentPoolOrderEventsOrderBy =
  | 'BASE_AMOUNT_ASC'
  | 'BASE_AMOUNT_DESC'
  | 'BASE_ASSET_ASC'
  | 'BASE_ASSET_DESC'
  | 'BASE_COLLECTED_FEES_ASC'
  | 'BASE_COLLECTED_FEES_DESC'
  | 'BASE_COLLECTED_FEES_USD_ASC'
  | 'BASE_COLLECTED_FEES_USD_DESC'
  | 'BASE_VALUE_USD_ASC'
  | 'BASE_VALUE_USD_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'EVENT_TYPE_ASC'
  | 'EVENT_TYPE_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_PROVIDER_ID_ASC'
  | 'LIQUIDITY_PROVIDER_ID_DESC'
  | 'MAXIMUM_RATE_ASC'
  | 'MAXIMUM_RATE_DESC'
  | 'MINIMUM_RATE_ASC'
  | 'MINIMUM_RATE_DESC'
  | 'NATURAL'
  | 'ORDER_ID_ASC'
  | 'ORDER_ID_DESC'
  | 'ORDER_TYPE_ASC'
  | 'ORDER_TYPE_DESC'
  | 'QUOTE_AMOUNT_ASC'
  | 'QUOTE_AMOUNT_DESC'
  | 'QUOTE_COLLECTED_FEES_ASC'
  | 'QUOTE_COLLECTED_FEES_DESC'
  | 'QUOTE_COLLECTED_FEES_USD_ASC'
  | 'QUOTE_COLLECTED_FEES_USD_DESC'
  | 'QUOTE_VALUE_USD_ASC'
  | 'QUOTE_VALUE_USD_DESC'
  | 'TIMESTAMP_ASC'
  | 'TIMESTAMP_DESC';

export type RotationEvent = Node & {
  __typename?: 'RotationEvent';
  /** Reads a single `Epoch` that is related to this `RotationEvent`. */
  epochByEpochId: Epoch;
  epochId: Scalars['Int']['output'];
  /** Reads a single `Event` that is related to this `RotationEvent`. */
  eventByEventId: Event;
  eventId: Scalars['BigInt']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  type: RotationEventType;
};

export type RotationEventAggregates = {
  __typename?: 'RotationEventAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RotationEventAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RotationEventDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RotationEventMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RotationEventMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RotationEventStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RotationEventStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RotationEventSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RotationEventVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RotationEventVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `RotationEvent` object types. */
export type RotationEventAggregatesFilter = {
  /** Mean average aggregate over matching `RotationEvent` objects. */
  average?: InputMaybe<RotationEventAverageAggregateFilter>;
  /** Distinct count aggregate over matching `RotationEvent` objects. */
  distinctCount?: InputMaybe<RotationEventDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `RotationEvent` object to be included within the aggregate. */
  filter?: InputMaybe<RotationEventFilter>;
  /** Maximum aggregate over matching `RotationEvent` objects. */
  max?: InputMaybe<RotationEventMaxAggregateFilter>;
  /** Minimum aggregate over matching `RotationEvent` objects. */
  min?: InputMaybe<RotationEventMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `RotationEvent` objects. */
  stddevPopulation?: InputMaybe<RotationEventStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `RotationEvent` objects. */
  stddevSample?: InputMaybe<RotationEventStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `RotationEvent` objects. */
  sum?: InputMaybe<RotationEventSumAggregateFilter>;
  /** Population variance aggregate over matching `RotationEvent` objects. */
  variancePopulation?: InputMaybe<RotationEventVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `RotationEvent` objects. */
  varianceSample?: InputMaybe<RotationEventVarianceSampleAggregateFilter>;
};

export type RotationEventAverageAggregateFilter = {
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type RotationEventAverageAggregates = {
  __typename?: 'RotationEventAverageAggregates';
  /** Mean average of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `RotationEvent` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RotationEventCondition = {
  epochByEpochId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `epochId` field. */
  epochId?: InputMaybe<Scalars['Int']['input']>;
  eventByEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<RotationEventType>;
};

export type RotationEventDistinctCountAggregateFilter = {
  epochId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type RotationEventDistinctCountAggregates = {
  __typename?: 'RotationEventDistinctCountAggregates';
  /** Distinct count of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `RotationEvent` object types. All fields are combined with a logical ‘and.’ */
export type RotationEventFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RotationEventFilter>>;
  /** Filter by the object’s `epochByEpochId` relation. */
  epochByEpochId?: InputMaybe<EpochFilter>;
  /** Filter by the object’s `epochId` field. */
  epochId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByEventId` relation. */
  eventByEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RotationEventFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RotationEventFilter>>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<RotationEventTypeFilter>;
};

/** Grouping methods for `RotationEvent` for usage during aggregation. */
export type RotationEventGroupBy =
  | 'EPOCH_ID'
  | 'EVENT_ID'
  | 'TYPE';

export type RotationEventHavingAverageInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingDistinctCountInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `RotationEvent` aggregates. */
export type RotationEventHavingInput = {
  AND?: InputMaybe<Array<RotationEventHavingInput>>;
  OR?: InputMaybe<Array<RotationEventHavingInput>>;
  average?: InputMaybe<RotationEventHavingAverageInput>;
  distinctCount?: InputMaybe<RotationEventHavingDistinctCountInput>;
  max?: InputMaybe<RotationEventHavingMaxInput>;
  min?: InputMaybe<RotationEventHavingMinInput>;
  stddevPopulation?: InputMaybe<RotationEventHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RotationEventHavingStddevSampleInput>;
  sum?: InputMaybe<RotationEventHavingSumInput>;
  variancePopulation?: InputMaybe<RotationEventHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RotationEventHavingVarianceSampleInput>;
};

export type RotationEventHavingMaxInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingMinInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingStddevPopulationInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingStddevSampleInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingSumInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingVariancePopulationInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventHavingVarianceSampleInput = {
  epochId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type RotationEventMaxAggregateFilter = {
  epochId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type RotationEventMaxAggregates = {
  __typename?: 'RotationEventMaxAggregates';
  /** Maximum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type RotationEventMinAggregateFilter = {
  epochId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type RotationEventMinAggregates = {
  __typename?: 'RotationEventMinAggregates';
  /** Minimum of epochId across the matching connection */
  epochId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type RotationEventStddevPopulationAggregateFilter = {
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type RotationEventStddevPopulationAggregates = {
  __typename?: 'RotationEventStddevPopulationAggregates';
  /** Population standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type RotationEventStddevSampleAggregateFilter = {
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type RotationEventStddevSampleAggregates = {
  __typename?: 'RotationEventStddevSampleAggregates';
  /** Sample standard deviation of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type RotationEventSumAggregateFilter = {
  epochId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type RotationEventSumAggregates = {
  __typename?: 'RotationEventSumAggregates';
  /** Sum of epochId across the matching connection */
  epochId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

export type RotationEventType =
  | 'ACTIVATING_KEYS_ROTATION_PHASE'
  | 'ARBITRUM_VAULT_ACTIVATION_COMPLETED'
  | 'ASSETHUB_VAULT_ACTIVATION_COMPLETED'
  | 'AUCTION_COMPLETED'
  | 'BITCOIN_KEYGEN_REQUEST'
  | 'BITCOIN_KEYGEN_VERIFICATION_SUCCESS'
  | 'BITCOIN_KEY_HANDOVER_REQUEST'
  | 'BITCOIN_KEY_HANDOVER_VERIFICATION_SUCCESS'
  | 'BITCOIN_KEY_ROTATION_COMPLETED'
  | 'BITCOIN_VAULT_ACTIVATION_COMPLETED'
  | 'BITCOIN_VAULT_ROTATION_COMPLETED'
  | 'BSC_VAULT_ACTIVATION_COMPLETED'
  | 'ETHEREUM_KEYGEN_REQUEST'
  | 'ETHEREUM_KEYGEN_VERIFICATION_SUCCESS'
  | 'ETHEREUM_KEY_ROTATION_COMPLETED'
  | 'ETHEREUM_VAULT_ACTIVATION_COMPLETED'
  | 'ETHEREUM_VAULT_ROTATION_COMPLETED'
  | 'EVM_KEYGEN_REQUEST'
  | 'EVM_KEYGEN_VERIFICATION_SUCCESS'
  | 'EVM_KEY_ROTATION_COMPLETED'
  | 'NEW_EPOCH'
  | 'NEW_KEYS_ACTIVATED_ROTATION_PHASE'
  | 'POLKADOT_KEYGEN_REQUEST'
  | 'POLKADOT_KEYGEN_VERIFICATION_SUCCESS'
  | 'POLKADOT_KEY_ROTATION_COMPLETED'
  | 'POLKADOT_VAULT_ACTIVATION_COMPLETED'
  | 'POLKADOT_VAULT_ROTATION_COMPLETED'
  | 'SOLANA_KEYGEN_REQUEST'
  | 'SOLANA_KEYGEN_VERIFICATION_SUCCESS'
  | 'SOLANA_KEY_ROTATION_COMPLETED'
  | 'SOLANA_VAULT_ACTIVATION_COMPLETED'
  | 'TRON_VAULT_ACTIVATION_COMPLETED';

/** A filter to be used against RotationEventType fields. All fields are combined with a logical ‘and.’ */
export type RotationEventTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<RotationEventType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<RotationEventType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<RotationEventType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<RotationEventType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<RotationEventType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<RotationEventType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<RotationEventType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<RotationEventType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<RotationEventType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<RotationEventType>>;
};

export type RotationEventVariancePopulationAggregateFilter = {
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type RotationEventVariancePopulationAggregates = {
  __typename?: 'RotationEventVariancePopulationAggregates';
  /** Population variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type RotationEventVarianceSampleAggregateFilter = {
  epochId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type RotationEventVarianceSampleAggregates = {
  __typename?: 'RotationEventVarianceSampleAggregates';
  /** Sample variance of epochId across the matching connection */
  epochId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `RotationEvent` values. */
export type RotationEventsConnection = {
  __typename?: 'RotationEventsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RotationEventAggregates>;
  /** A list of edges which contains the `RotationEvent` and cursor to aid in pagination. */
  edges: Array<RotationEventsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RotationEventAggregates>>;
  /** A list of `RotationEvent` objects. */
  nodes: Array<RotationEvent>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RotationEvent` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `RotationEvent` values. */
export type RotationEventsConnectionGroupedAggregatesArgs = {
  groupBy: Array<RotationEventGroupBy>;
  having?: InputMaybe<RotationEventHavingInput>;
};

/** A `RotationEvent` edge in the connection. */
export type RotationEventsEdge = {
  __typename?: 'RotationEventsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `RotationEvent` at the end of the edge. */
  node: RotationEvent;
};

/** Methods to use when ordering `RotationEvent`. */
export type RotationEventsOrderBy =
  | 'EPOCH_ID_ASC'
  | 'EPOCH_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type StateChainError = Node & {
  __typename?: 'StateChainError';
  chainspec: Scalars['String']['output'];
  docs: Scalars['String']['output'];
  errorIndex: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `EvmStateChainCall`. */
  evmStateChainCallsByStateChainErrorId: EvmStateChainCallsConnection;
  id: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `IgnoredEgress`. */
  ignoredEgressesByStateChainErrorId: IgnoredEgressesConnection;
  name: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  palletIndex: Scalars['Int']['output'];
};


export type StateChainErrorEvmStateChainCallsByStateChainErrorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<EvmStateChainCallCondition>;
  filter?: InputMaybe<EvmStateChainCallFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvmStateChainCallsOrderBy>>;
};


export type StateChainErrorIgnoredEgressesByStateChainErrorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<IgnoredEgressCondition>;
  filter?: InputMaybe<IgnoredEgressFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<IgnoredEgressesOrderBy>>;
};

export type StateChainErrorAggregates = {
  __typename?: 'StateChainErrorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<StateChainErrorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<StateChainErrorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<StateChainErrorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<StateChainErrorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<StateChainErrorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<StateChainErrorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<StateChainErrorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<StateChainErrorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<StateChainErrorVarianceSampleAggregates>;
};

export type StateChainErrorAverageAggregates = {
  __typename?: 'StateChainErrorAverageAggregates';
  /** Mean average of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `StateChainError` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type StateChainErrorCondition = {
  /** Checks for equality with the object’s `chainspec` field. */
  chainspec?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `docs` field. */
  docs?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `errorIndex` field. */
  errorIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `palletIndex` field. */
  palletIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type StateChainErrorDistinctCountAggregates = {
  __typename?: 'StateChainErrorDistinctCountAggregates';
  /** Distinct count of chainspec across the matching connection */
  chainspec?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of docs across the matching connection */
  docs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `StateChainError` object types. All fields are combined with a logical ‘and.’ */
export type StateChainErrorFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<StateChainErrorFilter>>;
  /** Filter by the object’s `chainspec` field. */
  chainspec?: InputMaybe<StringFilter>;
  /** Filter by the object’s `docs` field. */
  docs?: InputMaybe<StringFilter>;
  /** Filter by the object’s `errorIndex` field. */
  errorIndex?: InputMaybe<IntFilter>;
  /** Filter by the object’s `evmStateChainCallsByStateChainErrorId` relation. */
  evmStateChainCallsByStateChainErrorId?: InputMaybe<StateChainErrorToManyEvmStateChainCallFilter>;
  /** Some related `evmStateChainCallsByStateChainErrorId` exist. */
  evmStateChainCallsByStateChainErrorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ignoredEgressesByStateChainErrorId` relation. */
  ignoredEgressesByStateChainErrorId?: InputMaybe<StateChainErrorToManyIgnoredEgressFilter>;
  /** Some related `ignoredEgressesByStateChainErrorId` exist. */
  ignoredEgressesByStateChainErrorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<StateChainErrorFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<StateChainErrorFilter>>;
  /** Filter by the object’s `palletIndex` field. */
  palletIndex?: InputMaybe<IntFilter>;
};

/** Grouping methods for `StateChainError` for usage during aggregation. */
export type StateChainErrorGroupBy =
  | 'CHAINSPEC'
  | 'DOCS'
  | 'ERROR_INDEX'
  | 'NAME'
  | 'PALLET_INDEX';

export type StateChainErrorHavingAverageInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingDistinctCountInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `StateChainError` aggregates. */
export type StateChainErrorHavingInput = {
  AND?: InputMaybe<Array<StateChainErrorHavingInput>>;
  OR?: InputMaybe<Array<StateChainErrorHavingInput>>;
  average?: InputMaybe<StateChainErrorHavingAverageInput>;
  distinctCount?: InputMaybe<StateChainErrorHavingDistinctCountInput>;
  max?: InputMaybe<StateChainErrorHavingMaxInput>;
  min?: InputMaybe<StateChainErrorHavingMinInput>;
  stddevPopulation?: InputMaybe<StateChainErrorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<StateChainErrorHavingStddevSampleInput>;
  sum?: InputMaybe<StateChainErrorHavingSumInput>;
  variancePopulation?: InputMaybe<StateChainErrorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<StateChainErrorHavingVarianceSampleInput>;
};

export type StateChainErrorHavingMaxInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingMinInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingStddevPopulationInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingStddevSampleInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingSumInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingVariancePopulationInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorHavingVarianceSampleInput = {
  errorIndex?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  palletIndex?: InputMaybe<HavingIntFilter>;
};

export type StateChainErrorMaxAggregates = {
  __typename?: 'StateChainErrorMaxAggregates';
  /** Maximum of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['Int']['output']>;
};

export type StateChainErrorMinAggregates = {
  __typename?: 'StateChainErrorMinAggregates';
  /** Minimum of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['Int']['output']>;
};

export type StateChainErrorStddevPopulationAggregates = {
  __typename?: 'StateChainErrorStddevPopulationAggregates';
  /** Population standard deviation of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigFloat']['output']>;
};

export type StateChainErrorStddevSampleAggregates = {
  __typename?: 'StateChainErrorStddevSampleAggregates';
  /** Sample standard deviation of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigFloat']['output']>;
};

export type StateChainErrorSumAggregates = {
  __typename?: 'StateChainErrorSumAggregates';
  /** Sum of errorIndex across the matching connection */
  errorIndex: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of palletIndex across the matching connection */
  palletIndex: Scalars['BigInt']['output'];
};

/** A filter to be used against many `EvmStateChainCall` object types. All fields are combined with a logical ‘and.’ */
export type StateChainErrorToManyEvmStateChainCallFilter = {
  /** Aggregates across related `EvmStateChainCall` match the filter criteria. */
  aggregates?: InputMaybe<EvmStateChainCallAggregatesFilter>;
  /** Every related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EvmStateChainCallFilter>;
  /** No related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EvmStateChainCallFilter>;
  /** Some related `EvmStateChainCall` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EvmStateChainCallFilter>;
};

/** A filter to be used against many `IgnoredEgress` object types. All fields are combined with a logical ‘and.’ */
export type StateChainErrorToManyIgnoredEgressFilter = {
  /** Aggregates across related `IgnoredEgress` match the filter criteria. */
  aggregates?: InputMaybe<IgnoredEgressAggregatesFilter>;
  /** Every related `IgnoredEgress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<IgnoredEgressFilter>;
  /** No related `IgnoredEgress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<IgnoredEgressFilter>;
  /** Some related `IgnoredEgress` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<IgnoredEgressFilter>;
};

export type StateChainErrorVariancePopulationAggregates = {
  __typename?: 'StateChainErrorVariancePopulationAggregates';
  /** Population variance of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigFloat']['output']>;
};

export type StateChainErrorVarianceSampleAggregates = {
  __typename?: 'StateChainErrorVarianceSampleAggregates';
  /** Sample variance of errorIndex across the matching connection */
  errorIndex?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of palletIndex across the matching connection */
  palletIndex?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `StateChainError` values. */
export type StateChainErrorsConnection = {
  __typename?: 'StateChainErrorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<StateChainErrorAggregates>;
  /** A list of edges which contains the `StateChainError` and cursor to aid in pagination. */
  edges: Array<StateChainErrorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<StateChainErrorAggregates>>;
  /** A list of `StateChainError` objects. */
  nodes: Array<StateChainError>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `StateChainError` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `StateChainError` values. */
export type StateChainErrorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<StateChainErrorGroupBy>;
  having?: InputMaybe<StateChainErrorHavingInput>;
};

/** A `StateChainError` edge in the connection. */
export type StateChainErrorsEdge = {
  __typename?: 'StateChainErrorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `StateChainError` at the end of the edge. */
  node: StateChainError;
};

/** Methods to use when ordering `StateChainError`. */
export type StateChainErrorsOrderBy =
  | 'CHAINSPEC_ASC'
  | 'CHAINSPEC_DESC'
  | 'DOCS_ASC'
  | 'DOCS_DESC'
  | 'ERROR_INDEX_ASC'
  | 'ERROR_INDEX_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_AVERAGE_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_COUNT_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_COUNT_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_BYTES_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_BYTES_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_CALL_DATA_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_CALL_DATA_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_SUCCESS_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_SUCCESS_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_TX_HASH_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_TX_HASH_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MAX_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_MIN_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_SUM_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'EVM_STATE_CHAIN_CALLS_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_AVERAGE_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_COUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_COUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MAX_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_MIN_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_SUM_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_STATE_CHAIN_ERROR_ID_DESC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'IGNORED_EGRESSES_BY_STATE_CHAIN_ERROR_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PALLET_INDEX_ASC'
  | 'PALLET_INDEX_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

export type Swap = Node & {
  __typename?: 'Swap';
  destinationAsset: ChainflipAsset;
  destinationChain: ChainflipChain;
  /** Reads a single `Event` that is related to this `Swap`. */
  eventBySwapAbortedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Swap`. */
  eventBySwapExecutedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `Swap`. */
  eventBySwapScheduledEventId: Event;
  id: Scalars['Int']['output'];
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  nativeId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  retryCount: Scalars['Int']['output'];
  sourceAsset: ChainflipAsset;
  sourceChain: ChainflipChain;
  swapAbortedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  swapAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  swapAbortedReason?: Maybe<SwapFailureReason>;
  /** Reads and enables pagination through a set of `SwapCommission`. */
  swapCommissionsBySwapId: SwapCommissionsConnection;
  swapExecutedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  swapExecutedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Reads and enables pagination through a set of `SwapFee`. */
  swapFeesBySwapId: SwapFeesConnection;
  swapInputAmount: Scalars['BigFloat']['output'];
  swapInputValueUsd: Scalars['BigFloat']['output'];
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Reads a single `SwapRequest` that is related to this `Swap`. */
  swapRequestBySwapRequestId: SwapRequest;
  swapRequestId: Scalars['Int']['output'];
  swapRescheduledReason?: Maybe<SwapFailureReason>;
  swapScheduledBlockTimestamp: Scalars['Datetime']['output'];
  swapScheduledEventId: Scalars['BigInt']['output'];
  type: SwapType;
};


export type SwapSwapCommissionsBySwapIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCommissionCondition>;
  filter?: InputMaybe<SwapCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapCommissionsOrderBy>>;
};


export type SwapSwapFeesBySwapIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapFeeCondition>;
  filter?: InputMaybe<SwapFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapFeesOrderBy>>;
};

export type SwapAggregates = {
  __typename?: 'SwapAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Swap` object types. */
export type SwapAggregatesFilter = {
  /** Mean average aggregate over matching `Swap` objects. */
  average?: InputMaybe<SwapAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Swap` objects. */
  distinctCount?: InputMaybe<SwapDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Swap` object to be included within the aggregate. */
  filter?: InputMaybe<SwapFilter>;
  /** Maximum aggregate over matching `Swap` objects. */
  max?: InputMaybe<SwapMaxAggregateFilter>;
  /** Minimum aggregate over matching `Swap` objects. */
  min?: InputMaybe<SwapMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Swap` objects. */
  stddevPopulation?: InputMaybe<SwapStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Swap` objects. */
  stddevSample?: InputMaybe<SwapStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Swap` objects. */
  sum?: InputMaybe<SwapSumAggregateFilter>;
  /** Population variance aggregate over matching `Swap` objects. */
  variancePopulation?: InputMaybe<SwapVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Swap` objects. */
  varianceSample?: InputMaybe<SwapVarianceSampleAggregateFilter>;
};

export type SwapAverageAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigFloatFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapAverageAggregates = {
  __typename?: 'SwapAverageAggregates';
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannel = Node & {
  __typename?: 'SwapChannel';
  /** Reads a single `Block` that is related to this `SwapChannel`. */
  blockByIssuedBlockId: Block;
  /** Reads a single `Broker` that is related to this `SwapChannel`. */
  brokerByBrokerId: Broker;
  brokerId: Scalars['Int']['output'];
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  ccmMessage?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['BigInt']['output'];
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  dcaNumberOfChunks: Scalars['Int']['output'];
  depositAddress: Scalars['String']['output'];
  destinationAddress: Scalars['String']['output'];
  destinationAsset: ChainflipAsset;
  destinationChain: ChainflipChain;
  /** Reads a single `Event` that is related to this `SwapChannel`. */
  eventByIssuedEventId: Event;
  /** Reads and enables pagination through a set of `FailedDeposit`. */
  failedDepositsBySwapDepositChannelId: FailedDepositsConnection;
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  fokRefundAddress?: Maybe<Scalars['String']['output']>;
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isExpired: Scalars['Boolean']['output'];
  issuedBlockId: Scalars['Int']['output'];
  issuedBlockTimestamp: Scalars['Datetime']['output'];
  issuedEventId: Scalars['BigInt']['output'];
  maxBoostFeeBps: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  openingFeePaid: Scalars['BigFloat']['output'];
  sourceAsset: ChainflipAsset;
  sourceChain: ChainflipChain;
  sourceChainExpiryBlock: Scalars['BigInt']['output'];
  /** Reads and enables pagination through a set of `SwapChannelBeneficiary`. */
  swapChannelBeneficiariesByDepositChannelId: SwapChannelBeneficiariesConnection;
  /** Reads and enables pagination through a set of `SwapRequest`. */
  swapRequestsByDepositChannelId: SwapRequestsConnection;
  totalBrokerCommissionBps: Scalars['Int']['output'];
};


export type SwapChannelFailedDepositsBySwapDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<FailedDepositCondition>;
  filter?: InputMaybe<FailedDepositFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy>>;
};


export type SwapChannelSwapChannelBeneficiariesByDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapChannelBeneficiaryCondition>;
  filter?: InputMaybe<SwapChannelBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapChannelBeneficiariesOrderBy>>;
};


export type SwapChannelSwapRequestsByDepositChannelIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestCondition>;
  filter?: InputMaybe<SwapRequestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestsOrderBy>>;
};

export type SwapChannelAggregates = {
  __typename?: 'SwapChannelAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapChannelAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapChannelDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapChannelMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapChannelMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapChannelStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapChannelStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapChannelSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapChannelVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapChannelVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapChannel` object types. */
export type SwapChannelAggregatesFilter = {
  /** Mean average aggregate over matching `SwapChannel` objects. */
  average?: InputMaybe<SwapChannelAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapChannel` objects. */
  distinctCount?: InputMaybe<SwapChannelDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapChannel` object to be included within the aggregate. */
  filter?: InputMaybe<SwapChannelFilter>;
  /** Maximum aggregate over matching `SwapChannel` objects. */
  max?: InputMaybe<SwapChannelMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapChannel` objects. */
  min?: InputMaybe<SwapChannelMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapChannel` objects. */
  stddevPopulation?: InputMaybe<SwapChannelStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapChannel` objects. */
  stddevSample?: InputMaybe<SwapChannelStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapChannel` objects. */
  sum?: InputMaybe<SwapChannelSumAggregateFilter>;
  /** Population variance aggregate over matching `SwapChannel` objects. */
  variancePopulation?: InputMaybe<SwapChannelVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapChannel` objects. */
  varianceSample?: InputMaybe<SwapChannelVarianceSampleAggregateFilter>;
};

export type SwapChannelAverageAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelAverageAggregates = {
  __typename?: 'SwapChannelAverageAggregates';
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapChannelBeneficiary` values. */
export type SwapChannelBeneficiariesConnection = {
  __typename?: 'SwapChannelBeneficiariesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapChannelBeneficiaryAggregates>;
  /** A list of edges which contains the `SwapChannelBeneficiary` and cursor to aid in pagination. */
  edges: Array<SwapChannelBeneficiariesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapChannelBeneficiaryAggregates>>;
  /** A list of `SwapChannelBeneficiary` objects. */
  nodes: Array<SwapChannelBeneficiary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapChannelBeneficiary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapChannelBeneficiary` values. */
export type SwapChannelBeneficiariesConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapChannelBeneficiaryGroupBy>;
  having?: InputMaybe<SwapChannelBeneficiaryHavingInput>;
};

/** A `SwapChannelBeneficiary` edge in the connection. */
export type SwapChannelBeneficiariesEdge = {
  __typename?: 'SwapChannelBeneficiariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapChannelBeneficiary` at the end of the edge. */
  node: SwapChannelBeneficiary;
};

/** Methods to use when ordering `SwapChannelBeneficiary`. */
export type SwapChannelBeneficiariesOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_COMMISSION_RATE_BPS_DESC'
  | 'DEPOSIT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNEL_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_AVERAGE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_COUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_COUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MAX_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_MIN_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_SUM_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_CHANNEL_BENEFICIARY_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type SwapChannelBeneficiary = Node & {
  __typename?: 'SwapChannelBeneficiary';
  /** Reads a single `Account` that is related to this `SwapChannelBeneficiary`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  brokerCommissionRateBps: Scalars['Int']['output'];
  depositChannelId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `SwapChannel` that is related to this `SwapChannelBeneficiary`. */
  swapChannelByDepositChannelId: SwapChannel;
  /** Reads and enables pagination through a set of `SwapCommission`. */
  swapCommissionsBySwapChannelBeneficiaryId: SwapCommissionsConnection;
  type: BrokerType;
};


export type SwapChannelBeneficiarySwapCommissionsBySwapChannelBeneficiaryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCommissionCondition>;
  filter?: InputMaybe<SwapCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapCommissionsOrderBy>>;
};

export type SwapChannelBeneficiaryAggregates = {
  __typename?: 'SwapChannelBeneficiaryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapChannelBeneficiaryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapChannelBeneficiaryDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapChannelBeneficiaryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapChannelBeneficiaryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapChannelBeneficiaryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapChannelBeneficiaryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapChannelBeneficiarySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapChannelBeneficiaryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapChannelBeneficiaryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapChannelBeneficiary` object types. */
export type SwapChannelBeneficiaryAggregatesFilter = {
  /** Mean average aggregate over matching `SwapChannelBeneficiary` objects. */
  average?: InputMaybe<SwapChannelBeneficiaryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapChannelBeneficiary` objects. */
  distinctCount?: InputMaybe<SwapChannelBeneficiaryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapChannelBeneficiary` object to be included within the aggregate. */
  filter?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** Maximum aggregate over matching `SwapChannelBeneficiary` objects. */
  max?: InputMaybe<SwapChannelBeneficiaryMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapChannelBeneficiary` objects. */
  min?: InputMaybe<SwapChannelBeneficiaryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapChannelBeneficiary` objects. */
  stddevPopulation?: InputMaybe<SwapChannelBeneficiaryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapChannelBeneficiary` objects. */
  stddevSample?: InputMaybe<SwapChannelBeneficiaryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapChannelBeneficiary` objects. */
  sum?: InputMaybe<SwapChannelBeneficiarySumAggregateFilter>;
  /** Population variance aggregate over matching `SwapChannelBeneficiary` objects. */
  variancePopulation?: InputMaybe<SwapChannelBeneficiaryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapChannelBeneficiary` objects. */
  varianceSample?: InputMaybe<SwapChannelBeneficiaryVarianceSampleAggregateFilter>;
};

export type SwapChannelBeneficiaryAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelBeneficiaryAverageAggregates = {
  __typename?: 'SwapChannelBeneficiaryAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SwapChannelBeneficiary` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SwapChannelBeneficiaryCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  swapChannelByDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<BrokerType>;
};

export type SwapChannelBeneficiaryDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type SwapChannelBeneficiaryDistinctCountAggregates = {
  __typename?: 'SwapChannelBeneficiaryDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapChannelBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelBeneficiaryFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapChannelBeneficiaryFilter>>;
  /** Filter by the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapChannelBeneficiaryFilter>>;
  /** Filter by the object’s `swapChannelByDepositChannelId` relation. */
  swapChannelByDepositChannelId?: InputMaybe<SwapChannelFilter>;
  /** Filter by the object’s `swapCommissionsBySwapChannelBeneficiaryId` relation. */
  swapCommissionsBySwapChannelBeneficiaryId?: InputMaybe<SwapChannelBeneficiaryToManySwapCommissionFilter>;
  /** Some related `swapCommissionsBySwapChannelBeneficiaryId` exist. */
  swapCommissionsBySwapChannelBeneficiaryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<BrokerTypeFilter>;
};

/** Grouping methods for `SwapChannelBeneficiary` for usage during aggregation. */
export type SwapChannelBeneficiaryGroupBy =
  | 'ACCOUNT_ID'
  | 'BROKER_COMMISSION_RATE_BPS'
  | 'DEPOSIT_CHANNEL_ID'
  | 'TYPE';

export type SwapChannelBeneficiaryHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `SwapChannelBeneficiary` aggregates. */
export type SwapChannelBeneficiaryHavingInput = {
  AND?: InputMaybe<Array<SwapChannelBeneficiaryHavingInput>>;
  OR?: InputMaybe<Array<SwapChannelBeneficiaryHavingInput>>;
  average?: InputMaybe<SwapChannelBeneficiaryHavingAverageInput>;
  distinctCount?: InputMaybe<SwapChannelBeneficiaryHavingDistinctCountInput>;
  max?: InputMaybe<SwapChannelBeneficiaryHavingMaxInput>;
  min?: InputMaybe<SwapChannelBeneficiaryHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapChannelBeneficiaryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapChannelBeneficiaryHavingStddevSampleInput>;
  sum?: InputMaybe<SwapChannelBeneficiaryHavingSumInput>;
  variancePopulation?: InputMaybe<SwapChannelBeneficiaryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapChannelBeneficiaryHavingVarianceSampleInput>;
};

export type SwapChannelBeneficiaryHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelBeneficiaryMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type SwapChannelBeneficiaryMaxAggregates = {
  __typename?: 'SwapChannelBeneficiaryMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type SwapChannelBeneficiaryMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
};

export type SwapChannelBeneficiaryMinAggregates = {
  __typename?: 'SwapChannelBeneficiaryMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
};

export type SwapChannelBeneficiaryStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelBeneficiaryStddevPopulationAggregates = {
  __typename?: 'SwapChannelBeneficiaryStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelBeneficiaryStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelBeneficiaryStddevSampleAggregates = {
  __typename?: 'SwapChannelBeneficiaryStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelBeneficiarySumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
};

export type SwapChannelBeneficiarySumAggregates = {
  __typename?: 'SwapChannelBeneficiarySumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps: Scalars['BigInt']['output'];
  /** Sum of depositChannelId across the matching connection */
  depositChannelId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
};

/** A filter to be used against many `SwapCommission` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelBeneficiaryToManySwapCommissionFilter = {
  /** Aggregates across related `SwapCommission` match the filter criteria. */
  aggregates?: InputMaybe<SwapCommissionAggregatesFilter>;
  /** Every related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapCommissionFilter>;
  /** No related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapCommissionFilter>;
  /** Some related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapCommissionFilter>;
};

export type SwapChannelBeneficiaryVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelBeneficiaryVariancePopulationAggregates = {
  __typename?: 'SwapChannelBeneficiaryVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelBeneficiaryVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelBeneficiaryVarianceSampleAggregates = {
  __typename?: 'SwapChannelBeneficiaryVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SwapChannel` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SwapChannelCondition = {
  blockByIssuedBlockId?: InputMaybe<Scalars['ID']['input']>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `channelId` field. */
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dcaChunkIntervalBlocks` field. */
  dcaChunkIntervalBlocks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dcaNumberOfChunks` field. */
  dcaNumberOfChunks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChain>;
  eventByIssuedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `fokMaxOraclePriceSlippageBps` field. */
  fokMaxOraclePriceSlippageBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fokMinPriceX128` field. */
  fokMinPriceX128?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fokRefundAddress` field. */
  fokRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fokRetryDurationBlocks` field. */
  fokRetryDurationBlocks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isExpired` field. */
  isExpired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `issuedBlockTimestamp` field. */
  issuedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `sourceChainExpiryBlock` field. */
  sourceChainExpiryBlock?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `totalBrokerCommissionBps` field. */
  totalBrokerCommissionBps?: InputMaybe<Scalars['Int']['input']>;
};

export type SwapChannelDistinctCountAggregateFilter = {
  brokerId?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigIntFilter>;
  ccmMessage?: InputMaybe<BigIntFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigIntFilter>;
  dcaNumberOfChunks?: InputMaybe<BigIntFilter>;
  depositAddress?: InputMaybe<BigIntFilter>;
  destinationAddress?: InputMaybe<BigIntFilter>;
  destinationAsset?: InputMaybe<BigIntFilter>;
  destinationChain?: InputMaybe<BigIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigIntFilter>;
  fokMinPriceX128?: InputMaybe<BigIntFilter>;
  fokRefundAddress?: InputMaybe<BigIntFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isExpired?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedBlockTimestamp?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigIntFilter>;
  sourceAsset?: InputMaybe<BigIntFilter>;
  sourceChain?: InputMaybe<BigIntFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigIntFilter>;
};

export type SwapChannelDistinctCountAggregates = {
  __typename?: 'SwapChannelDistinctCountAggregates';
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmMessage across the matching connection */
  ccmMessage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAddress across the matching connection */
  depositAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAddress across the matching connection */
  destinationAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAsset across the matching connection */
  destinationAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationChain across the matching connection */
  destinationChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokRefundAddress across the matching connection */
  fokRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isExpired across the matching connection */
  isExpired?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceAsset across the matching connection */
  sourceAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceChain across the matching connection */
  sourceChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapChannel` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapChannelFilter>>;
  /** Filter by the object’s `blockByIssuedBlockId` relation. */
  blockByIssuedBlockId?: InputMaybe<BlockFilter>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `channelId` field. */
  channelId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dcaChunkIntervalBlocks` field. */
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dcaNumberOfChunks` field. */
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `depositAddress` field. */
  depositAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `eventByIssuedEventId` relation. */
  eventByIssuedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `failedDepositsBySwapDepositChannelId` relation. */
  failedDepositsBySwapDepositChannelId?: InputMaybe<SwapChannelToManyFailedDepositFilter>;
  /** Some related `failedDepositsBySwapDepositChannelId` exist. */
  failedDepositsBySwapDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `fokMaxOraclePriceSlippageBps` field. */
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fokMinPriceX128` field. */
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fokRefundAddress` field. */
  fokRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fokRetryDurationBlocks` field. */
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isExpired` field. */
  isExpired?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `issuedBlockId` field. */
  issuedBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `issuedBlockTimestamp` field. */
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `issuedEventId` field. */
  issuedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapChannelFilter>;
  /** Filter by the object’s `openingFeePaid` field. */
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapChannelFilter>>;
  /** Filter by the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `sourceChainExpiryBlock` field. */
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapChannelBeneficiariesByDepositChannelId` relation. */
  swapChannelBeneficiariesByDepositChannelId?: InputMaybe<SwapChannelToManySwapChannelBeneficiaryFilter>;
  /** Some related `swapChannelBeneficiariesByDepositChannelId` exist. */
  swapChannelBeneficiariesByDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestsByDepositChannelId` relation. */
  swapRequestsByDepositChannelId?: InputMaybe<SwapChannelToManySwapRequestFilter>;
  /** Some related `swapRequestsByDepositChannelId` exist. */
  swapRequestsByDepositChannelIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `totalBrokerCommissionBps` field. */
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
};

/** Grouping methods for `SwapChannel` for usage during aggregation. */
export type SwapChannelGroupBy =
  | 'BROKER_ID'
  | 'CCM_GAS_BUDGET'
  | 'CCM_MESSAGE'
  | 'CHANNEL_ID'
  | 'DCA_CHUNK_INTERVAL_BLOCKS'
  | 'DCA_NUMBER_OF_CHUNKS'
  | 'DEPOSIT_ADDRESS'
  | 'DESTINATION_ADDRESS'
  | 'DESTINATION_ASSET'
  | 'DESTINATION_CHAIN'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS'
  | 'FOK_MIN_PRICE_X128'
  | 'FOK_REFUND_ADDRESS'
  | 'FOK_RETRY_DURATION_BLOCKS'
  | 'ISSUED_BLOCK_ID'
  | 'ISSUED_BLOCK_TIMESTAMP'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'ISSUED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'ISSUED_EVENT_ID'
  | 'IS_EXPIRED'
  | 'MAX_BOOST_FEE_BPS'
  | 'OPENING_FEE_PAID'
  | 'SOURCE_ASSET'
  | 'SOURCE_CHAIN'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK'
  | 'TOTAL_BROKER_COMMISSION_BPS';

export type SwapChannelHavingAverageInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingDistinctCountInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `SwapChannel` aggregates. */
export type SwapChannelHavingInput = {
  AND?: InputMaybe<Array<SwapChannelHavingInput>>;
  OR?: InputMaybe<Array<SwapChannelHavingInput>>;
  average?: InputMaybe<SwapChannelHavingAverageInput>;
  distinctCount?: InputMaybe<SwapChannelHavingDistinctCountInput>;
  max?: InputMaybe<SwapChannelHavingMaxInput>;
  min?: InputMaybe<SwapChannelHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapChannelHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapChannelHavingStddevSampleInput>;
  sum?: InputMaybe<SwapChannelHavingSumInput>;
  variancePopulation?: InputMaybe<SwapChannelHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapChannelHavingVarianceSampleInput>;
};

export type SwapChannelHavingMaxInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingMinInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingStddevPopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingStddevSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingSumInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingVariancePopulationInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelHavingVarianceSampleInput = {
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  channelId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  issuedBlockId?: InputMaybe<HavingIntFilter>;
  issuedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  issuedEventId?: InputMaybe<HavingBigintFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  openingFeePaid?: InputMaybe<HavingBigfloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapChannelMaxAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
};

export type SwapChannelMaxAggregates = {
  __typename?: 'SwapChannelMaxAggregates';
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['Int']['output']>;
};

export type SwapChannelMinAggregateFilter = {
  brokerId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  issuedBlockId?: InputMaybe<IntFilter>;
  issuedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  issuedEventId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
};

export type SwapChannelMinAggregates = {
  __typename?: 'SwapChannelMinAggregates';
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of issuedBlockTimestamp across the matching connection */
  issuedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['Int']['output']>;
};

export type SwapChannelStddevPopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelStddevPopulationAggregates = {
  __typename?: 'SwapChannelStddevPopulationAggregates';
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelStddevSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelStddevSampleAggregates = {
  __typename?: 'SwapChannelStddevSampleAggregates';
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelSumAggregateFilter = {
  brokerId?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigIntFilter>;
  dcaNumberOfChunks?: InputMaybe<BigIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  issuedBlockId?: InputMaybe<BigIntFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigIntFilter>;
};

export type SwapChannelSumAggregates = {
  __typename?: 'SwapChannelSumAggregates';
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of ccmGasBudget across the matching connection */
  ccmGasBudget: Scalars['BigFloat']['output'];
  /** Sum of channelId across the matching connection */
  channelId: Scalars['BigFloat']['output'];
  /** Sum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks: Scalars['BigInt']['output'];
  /** Sum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks: Scalars['BigInt']['output'];
  /** Sum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps: Scalars['BigFloat']['output'];
  /** Sum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128: Scalars['BigFloat']['output'];
  /** Sum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of issuedBlockId across the matching connection */
  issuedBlockId: Scalars['BigInt']['output'];
  /** Sum of issuedEventId across the matching connection */
  issuedEventId: Scalars['BigFloat']['output'];
  /** Sum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of openingFeePaid across the matching connection */
  openingFeePaid: Scalars['BigFloat']['output'];
  /** Sum of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock: Scalars['BigFloat']['output'];
  /** Sum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps: Scalars['BigInt']['output'];
};

/** A filter to be used against many `FailedDeposit` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelToManyFailedDepositFilter = {
  /** Aggregates across related `FailedDeposit` match the filter criteria. */
  aggregates?: InputMaybe<FailedDepositAggregatesFilter>;
  /** Every related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FailedDepositFilter>;
  /** No related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FailedDepositFilter>;
  /** Some related `FailedDeposit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FailedDepositFilter>;
};

/** A filter to be used against many `SwapChannelBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelToManySwapChannelBeneficiaryFilter = {
  /** Aggregates across related `SwapChannelBeneficiary` match the filter criteria. */
  aggregates?: InputMaybe<SwapChannelBeneficiaryAggregatesFilter>;
  /** Every related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** No related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** Some related `SwapChannelBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapChannelBeneficiaryFilter>;
};

/** A filter to be used against many `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type SwapChannelToManySwapRequestFilter = {
  /** Aggregates across related `SwapRequest` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestAggregatesFilter>;
  /** Every related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestFilter>;
  /** No related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestFilter>;
  /** Some related `SwapRequest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestFilter>;
};

export type SwapChannelVariancePopulationAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelVariancePopulationAggregates = {
  __typename?: 'SwapChannelVariancePopulationAggregates';
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapChannelVarianceSampleAggregateFilter = {
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  channelId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  issuedBlockId?: InputMaybe<BigFloatFilter>;
  issuedEventId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  openingFeePaid?: InputMaybe<BigFloatFilter>;
  sourceChainExpiryBlock?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapChannelVarianceSampleAggregates = {
  __typename?: 'SwapChannelVarianceSampleAggregates';
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of channelId across the matching connection */
  channelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedBlockId across the matching connection */
  issuedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of issuedEventId across the matching connection */
  issuedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of openingFeePaid across the matching connection */
  openingFeePaid?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of sourceChainExpiryBlock across the matching connection */
  sourceChainExpiryBlock?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapChannel` values. */
export type SwapChannelsConnection = {
  __typename?: 'SwapChannelsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapChannelAggregates>;
  /** A list of edges which contains the `SwapChannel` and cursor to aid in pagination. */
  edges: Array<SwapChannelsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapChannelAggregates>>;
  /** A list of `SwapChannel` objects. */
  nodes: Array<SwapChannel>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapChannel` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapChannel` values. */
export type SwapChannelsConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapChannelGroupBy>;
  having?: InputMaybe<SwapChannelHavingInput>;
};

/** A `SwapChannel` edge in the connection. */
export type SwapChannelsEdge = {
  __typename?: 'SwapChannelsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapChannel` at the end of the edge. */
  node: SwapChannel;
};

/** Methods to use when ordering `SwapChannel`. */
export type SwapChannelsOrderBy =
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CCM_GAS_BUDGET_ASC'
  | 'CCM_GAS_BUDGET_DESC'
  | 'CCM_MESSAGE_ASC'
  | 'CCM_MESSAGE_DESC'
  | 'CHANNEL_ID_ASC'
  | 'CHANNEL_ID_DESC'
  | 'DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'DCA_NUMBER_OF_CHUNKS_ASC'
  | 'DCA_NUMBER_OF_CHUNKS_DESC'
  | 'DEPOSIT_ADDRESS_ASC'
  | 'DEPOSIT_ADDRESS_DESC'
  | 'DESTINATION_ADDRESS_ASC'
  | 'DESTINATION_ADDRESS_DESC'
  | 'DESTINATION_ASSET_ASC'
  | 'DESTINATION_ASSET_DESC'
  | 'DESTINATION_CHAIN_ASC'
  | 'DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_AVERAGE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_ADDITIONAL_DATA_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REASON_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MAX_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_MIN_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_SUM_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_CHANNEL_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_BROADCAST_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_ASC'
  | 'FAILED_DEPOSITS_BY_SWAP_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_SWAP_DEPOSIT_CHANNEL_ID_DESC'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'FOK_MIN_PRICE_X128_ASC'
  | 'FOK_MIN_PRICE_X128_DESC'
  | 'FOK_REFUND_ADDRESS_ASC'
  | 'FOK_REFUND_ADDRESS_DESC'
  | 'FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'ISSUED_BLOCK_ID_ASC'
  | 'ISSUED_BLOCK_ID_DESC'
  | 'ISSUED_BLOCK_TIMESTAMP_ASC'
  | 'ISSUED_BLOCK_TIMESTAMP_DESC'
  | 'ISSUED_EVENT_ID_ASC'
  | 'ISSUED_EVENT_ID_DESC'
  | 'IS_EXPIRED_ASC'
  | 'IS_EXPIRED_DESC'
  | 'MAX_BOOST_FEE_BPS_ASC'
  | 'MAX_BOOST_FEE_BPS_DESC'
  | 'NATURAL'
  | 'OPENING_FEE_PAID_ASC'
  | 'OPENING_FEE_PAID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SOURCE_ASSET_ASC'
  | 'SOURCE_ASSET_DESC'
  | 'SOURCE_CHAIN_ASC'
  | 'SOURCE_CHAIN_DESC'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK_ASC'
  | 'SOURCE_CHAIN_EXPIRY_BLOCK_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARIES_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_AVERAGE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_COUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_COUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_CCM_MESSAGE_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_REFUND_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_IS_LIQUIDATION_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ADDRESS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MAX_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_MIN_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_STDDEV_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_SUM_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_POPULATION_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_CCM_GAS_BUDGET_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_COMPLETED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DCA_NUMBER_OF_CHUNKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_AMOUNT_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_CHANNEL_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_DEPOSIT_VALUE_USD_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FALLBACK_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_MIN_PRICE_X128_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_IGNORED_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_MAX_BOOST_FEE_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_PREWITNESSED_DEPOSIT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REFUND_EGRESS_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_REQUESTED_EVENT_ID_DESC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'SWAP_REQUESTS_BY_DEPOSIT_CHANNEL_ID_VARIANCE_SAMPLE_TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'TOTAL_BROKER_COMMISSION_BPS_DESC';

export type SwapCommission = Node & {
  __typename?: 'SwapCommission';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  brokerId?: Maybe<Scalars['Int']['output']>;
  eventId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  mainBrokerId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Swap` that is related to this `SwapCommission`. */
  swapBySwapId: Swap;
  /** Reads a single `SwapChannelBeneficiary` that is related to this `SwapCommission`. */
  swapChannelBeneficiaryBySwapChannelBeneficiaryId?: Maybe<SwapChannelBeneficiary>;
  swapChannelBeneficiaryId?: Maybe<Scalars['Int']['output']>;
  swapId: Scalars['Int']['output'];
  /** Reads a single `SwapRequestBeneficiary` that is related to this `SwapCommission`. */
  swapRequestBeneficiaryBySwapRequestBeneficiaryId: SwapRequestBeneficiary;
  swapRequestBeneficiaryId: Scalars['Int']['output'];
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionAggregates = {
  __typename?: 'SwapCommissionAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapCommissionAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapCommissionDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapCommissionMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapCommissionMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapCommissionStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapCommissionStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapCommissionSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapCommissionVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapCommissionVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapCommission` object types. */
export type SwapCommissionAggregatesFilter = {
  /** Mean average aggregate over matching `SwapCommission` objects. */
  average?: InputMaybe<SwapCommissionAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapCommission` objects. */
  distinctCount?: InputMaybe<SwapCommissionDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapCommission` object to be included within the aggregate. */
  filter?: InputMaybe<SwapCommissionFilter>;
  /** Maximum aggregate over matching `SwapCommission` objects. */
  max?: InputMaybe<SwapCommissionMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapCommission` objects. */
  min?: InputMaybe<SwapCommissionMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapCommission` objects. */
  stddevPopulation?: InputMaybe<SwapCommissionStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapCommission` objects. */
  stddevSample?: InputMaybe<SwapCommissionStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapCommission` objects. */
  sum?: InputMaybe<SwapCommissionSumAggregateFilter>;
  /** Population variance aggregate over matching `SwapCommission` objects. */
  variancePopulation?: InputMaybe<SwapCommissionVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapCommission` objects. */
  varianceSample?: InputMaybe<SwapCommissionVarianceSampleAggregateFilter>;
};

export type SwapCommissionAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  mainBrokerId?: InputMaybe<BigFloatFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionAverageAggregates = {
  __typename?: 'SwapCommissionAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SwapCommission` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type SwapCommissionCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `eventId` field. */
  eventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `mainBrokerId` field. */
  mainBrokerId?: InputMaybe<Scalars['Int']['input']>;
  swapBySwapId?: InputMaybe<Scalars['ID']['input']>;
  swapChannelBeneficiaryBySwapChannelBeneficiaryId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapChannelBeneficiaryId` field. */
  swapChannelBeneficiaryId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `swapId` field. */
  swapId?: InputMaybe<Scalars['Int']['input']>;
  swapRequestBeneficiaryBySwapRequestBeneficiaryId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestBeneficiaryId` field. */
  swapRequestBeneficiaryId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type SwapCommissionDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  mainBrokerId?: InputMaybe<BigIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigIntFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type SwapCommissionDistinctCountAggregates = {
  __typename?: 'SwapCommissionDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapCommission` object types. All fields are combined with a logical ‘and.’ */
export type SwapCommissionFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapCommissionFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventId` field. */
  eventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `mainBrokerId` field. */
  mainBrokerId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapCommissionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapCommissionFilter>>;
  /** Filter by the object’s `swapBySwapId` relation. */
  swapBySwapId?: InputMaybe<SwapFilter>;
  /** Filter by the object’s `swapChannelBeneficiaryBySwapChannelBeneficiaryId` relation. */
  swapChannelBeneficiaryBySwapChannelBeneficiaryId?: InputMaybe<SwapChannelBeneficiaryFilter>;
  /** A related `swapChannelBeneficiaryBySwapChannelBeneficiaryId` exists. */
  swapChannelBeneficiaryBySwapChannelBeneficiaryIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapChannelBeneficiaryId` field. */
  swapChannelBeneficiaryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapId` field. */
  swapId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapRequestBeneficiaryBySwapRequestBeneficiaryId` relation. */
  swapRequestBeneficiaryBySwapRequestBeneficiaryId?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** Filter by the object’s `swapRequestBeneficiaryId` field. */
  swapRequestBeneficiaryId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `SwapCommission` for usage during aggregation. */
export type SwapCommissionGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'BROKER_ID'
  | 'EVENT_ID'
  | 'MAIN_BROKER_ID'
  | 'SWAP_CHANNEL_BENEFICIARY_ID'
  | 'SWAP_ID'
  | 'SWAP_REQUEST_BENEFICIARY_ID'
  | 'VALUE_USD';

export type SwapCommissionHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `SwapCommission` aggregates. */
export type SwapCommissionHavingInput = {
  AND?: InputMaybe<Array<SwapCommissionHavingInput>>;
  OR?: InputMaybe<Array<SwapCommissionHavingInput>>;
  average?: InputMaybe<SwapCommissionHavingAverageInput>;
  distinctCount?: InputMaybe<SwapCommissionHavingDistinctCountInput>;
  max?: InputMaybe<SwapCommissionHavingMaxInput>;
  min?: InputMaybe<SwapCommissionHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapCommissionHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapCommissionHavingStddevSampleInput>;
  sum?: InputMaybe<SwapCommissionHavingSumInput>;
  variancePopulation?: InputMaybe<SwapCommissionHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapCommissionHavingVarianceSampleInput>;
};

export type SwapCommissionHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  eventId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  mainBrokerId?: InputMaybe<HavingIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapCommissionMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  mainBrokerId?: InputMaybe<IntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<IntFilter>;
  swapId?: InputMaybe<IntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionMaxAggregates = {
  __typename?: 'SwapCommissionMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapId across the matching connection */
  swapId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<IntFilter>;
  eventId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  mainBrokerId?: InputMaybe<IntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<IntFilter>;
  swapId?: InputMaybe<IntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionMinAggregates = {
  __typename?: 'SwapCommissionMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapId across the matching connection */
  swapId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  mainBrokerId?: InputMaybe<BigFloatFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionStddevPopulationAggregates = {
  __typename?: 'SwapCommissionStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  mainBrokerId?: InputMaybe<BigFloatFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionStddevSampleAggregates = {
  __typename?: 'SwapCommissionStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  mainBrokerId?: InputMaybe<BigIntFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigIntFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionSumAggregates = {
  __typename?: 'SwapCommissionSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of eventId across the matching connection */
  eventId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of mainBrokerId across the matching connection */
  mainBrokerId: Scalars['BigInt']['output'];
  /** Sum of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId: Scalars['BigInt']['output'];
  /** Sum of swapId across the matching connection */
  swapId: Scalars['BigInt']['output'];
  /** Sum of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type SwapCommissionVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  mainBrokerId?: InputMaybe<BigFloatFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionVariancePopulationAggregates = {
  __typename?: 'SwapCommissionVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapCommissionVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  eventId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  mainBrokerId?: InputMaybe<BigFloatFilter>;
  swapChannelBeneficiaryId?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestBeneficiaryId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapCommissionVarianceSampleAggregates = {
  __typename?: 'SwapCommissionVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of eventId across the matching connection */
  eventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of mainBrokerId across the matching connection */
  mainBrokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapChannelBeneficiaryId across the matching connection */
  swapChannelBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestBeneficiaryId across the matching connection */
  swapRequestBeneficiaryId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapCommission` values. */
export type SwapCommissionsConnection = {
  __typename?: 'SwapCommissionsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapCommissionAggregates>;
  /** A list of edges which contains the `SwapCommission` and cursor to aid in pagination. */
  edges: Array<SwapCommissionsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapCommissionAggregates>>;
  /** A list of `SwapCommission` objects. */
  nodes: Array<SwapCommission>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapCommission` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapCommission` values. */
export type SwapCommissionsConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapCommissionGroupBy>;
  having?: InputMaybe<SwapCommissionHavingInput>;
};

/** A `SwapCommission` edge in the connection. */
export type SwapCommissionsEdge = {
  __typename?: 'SwapCommissionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapCommission` at the end of the edge. */
  node: SwapCommission;
};

/** Methods to use when ordering `SwapCommission`. */
export type SwapCommissionsOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'EVENT_ID_ASC'
  | 'EVENT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MAIN_BROKER_ID_ASC'
  | 'MAIN_BROKER_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_ID_ASC'
  | 'SWAP_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

/** A condition to be used against `Swap` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SwapCondition = {
  /** Checks for equality with the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChain>;
  eventBySwapAbortedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventBySwapExecutedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventBySwapScheduledEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `intermediateAmount` field. */
  intermediateAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `intermediateValueUsd` field. */
  intermediateValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `nativeId` field. */
  nativeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `oraclePriceDeltaBps` field. */
  oraclePriceDeltaBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `oraclePriceDeltaExFeesBps` field. */
  oraclePriceDeltaExFeesBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `retryCount` field. */
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `swapAbortedBlockTimestamp` field. */
  swapAbortedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `swapAbortedEventId` field. */
  swapAbortedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `swapAbortedReason` field. */
  swapAbortedReason?: InputMaybe<SwapFailureReason>;
  /** Checks for equality with the object’s `swapExecutedBlockTimestamp` field. */
  swapExecutedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `swapExecutedEventId` field. */
  swapExecutedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `swapInputAmount` field. */
  swapInputAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `swapInputValueUsd` field. */
  swapInputValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `swapOutputAmount` field. */
  swapOutputAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `swapOutputValueUsd` field. */
  swapOutputValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `swapRescheduledReason` field. */
  swapRescheduledReason?: InputMaybe<SwapFailureReason>;
  /** Checks for equality with the object’s `swapScheduledBlockTimestamp` field. */
  swapScheduledBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `swapScheduledEventId` field. */
  swapScheduledEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SwapType>;
};

export type SwapDistinctCountAggregateFilter = {
  destinationAsset?: InputMaybe<BigIntFilter>;
  destinationChain?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  intermediateAmount?: InputMaybe<BigIntFilter>;
  intermediateValueUsd?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigIntFilter>;
  retryCount?: InputMaybe<BigIntFilter>;
  sourceAsset?: InputMaybe<BigIntFilter>;
  sourceChain?: InputMaybe<BigIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<BigIntFilter>;
  swapAbortedEventId?: InputMaybe<BigIntFilter>;
  swapAbortedReason?: InputMaybe<BigIntFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<BigIntFilter>;
  swapExecutedEventId?: InputMaybe<BigIntFilter>;
  swapInputAmount?: InputMaybe<BigIntFilter>;
  swapInputValueUsd?: InputMaybe<BigIntFilter>;
  swapOutputAmount?: InputMaybe<BigIntFilter>;
  swapOutputValueUsd?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  swapRescheduledReason?: InputMaybe<BigIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<BigIntFilter>;
  swapScheduledEventId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type SwapDistinctCountAggregates = {
  __typename?: 'SwapDistinctCountAggregates';
  /** Distinct count of destinationAsset across the matching connection */
  destinationAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationChain across the matching connection */
  destinationChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceAsset across the matching connection */
  sourceAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceChain across the matching connection */
  sourceChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapAbortedBlockTimestamp across the matching connection */
  swapAbortedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapAbortedReason across the matching connection */
  swapAbortedReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapExecutedBlockTimestamp across the matching connection */
  swapExecutedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRescheduledReason across the matching connection */
  swapRescheduledReason?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapScheduledBlockTimestamp across the matching connection */
  swapScheduledBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

export type SwapFailureReason =
  | 'AbortedFromOrigin'
  | 'LogicError'
  | 'MinPriceViolation'
  | 'OraclePriceSlippageExceeded'
  | 'OraclePriceStale'
  | 'PredecessorSwapFailure'
  | 'PriceImpactLimit'
  | 'SafeModeActive';

/** A filter to be used against SwapFailureReason fields. All fields are combined with a logical ‘and.’ */
export type SwapFailureReasonFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SwapFailureReason>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SwapFailureReason>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SwapFailureReason>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SwapFailureReason>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SwapFailureReason>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SwapFailureReason>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SwapFailureReason>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SwapFailureReason>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SwapFailureReason>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SwapFailureReason>>;
};

export type SwapFee = Node & {
  __typename?: 'SwapFee';
  amount: Scalars['BigFloat']['output'];
  asset: ChainflipAsset;
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Swap` that is related to this `SwapFee`. */
  swapBySwapId?: Maybe<Swap>;
  swapId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `SwapRequest` that is related to this `SwapFee`. */
  swapRequestBySwapRequestId?: Maybe<SwapRequest>;
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  type: SwapFeeType;
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeAggregates = {
  __typename?: 'SwapFeeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapFeeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapFeeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapFeeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapFeeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapFeeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapFeeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapFeeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapFeeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapFeeVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapFee` object types. */
export type SwapFeeAggregatesFilter = {
  /** Mean average aggregate over matching `SwapFee` objects. */
  average?: InputMaybe<SwapFeeAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapFee` objects. */
  distinctCount?: InputMaybe<SwapFeeDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapFee` object to be included within the aggregate. */
  filter?: InputMaybe<SwapFeeFilter>;
  /** Maximum aggregate over matching `SwapFee` objects. */
  max?: InputMaybe<SwapFeeMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapFee` objects. */
  min?: InputMaybe<SwapFeeMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapFee` objects. */
  stddevPopulation?: InputMaybe<SwapFeeStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapFee` objects. */
  stddevSample?: InputMaybe<SwapFeeStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapFee` objects. */
  sum?: InputMaybe<SwapFeeSumAggregateFilter>;
  /** Population variance aggregate over matching `SwapFee` objects. */
  variancePopulation?: InputMaybe<SwapFeeVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapFee` objects. */
  varianceSample?: InputMaybe<SwapFeeVarianceSampleAggregateFilter>;
};

export type SwapFeeAverageAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeAverageAggregates = {
  __typename?: 'SwapFeeAverageAggregates';
  /** Mean average of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A condition to be used against `SwapFee` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type SwapFeeCondition = {
  /** Checks for equality with the object’s `amount` field. */
  amount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  swapBySwapId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapId` field. */
  swapId?: InputMaybe<Scalars['Int']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SwapFeeType>;
  /** Checks for equality with the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
};

export type SwapFeeDistinctCountAggregateFilter = {
  amount?: InputMaybe<BigIntFilter>;
  asset?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigIntFilter>;
};

export type SwapFeeDistinctCountAggregates = {
  __typename?: 'SwapFeeDistinctCountAggregates';
  /** Distinct count of amount across the matching connection */
  amount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of asset across the matching connection */
  asset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapFee` object types. All fields are combined with a logical ‘and.’ */
export type SwapFeeFilter = {
  /** Filter by the object’s `amount` field. */
  amount?: InputMaybe<BigFloatFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapFeeFilter>>;
  /** Filter by the object’s `asset` field. */
  asset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapFeeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapFeeFilter>>;
  /** Filter by the object’s `swapBySwapId` relation. */
  swapBySwapId?: InputMaybe<SwapFilter>;
  /** A related `swapBySwapId` exists. */
  swapBySwapIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapId` field. */
  swapId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestBySwapRequestId` exists. */
  swapRequestBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SwapFeeTypeFilter>;
  /** Filter by the object’s `valueUsd` field. */
  valueUsd?: InputMaybe<BigFloatFilter>;
};

/** Grouping methods for `SwapFee` for usage during aggregation. */
export type SwapFeeGroupBy =
  | 'AMOUNT'
  | 'ASSET'
  | 'SWAP_ID'
  | 'SWAP_REQUEST_ID'
  | 'TYPE'
  | 'VALUE_USD';

export type SwapFeeHavingAverageInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingDistinctCountInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

/** Conditions for `SwapFee` aggregates. */
export type SwapFeeHavingInput = {
  AND?: InputMaybe<Array<SwapFeeHavingInput>>;
  OR?: InputMaybe<Array<SwapFeeHavingInput>>;
  average?: InputMaybe<SwapFeeHavingAverageInput>;
  distinctCount?: InputMaybe<SwapFeeHavingDistinctCountInput>;
  max?: InputMaybe<SwapFeeHavingMaxInput>;
  min?: InputMaybe<SwapFeeHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapFeeHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapFeeHavingStddevSampleInput>;
  sum?: InputMaybe<SwapFeeHavingSumInput>;
  variancePopulation?: InputMaybe<SwapFeeHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapFeeHavingVarianceSampleInput>;
};

export type SwapFeeHavingMaxInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingMinInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingStddevPopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingStddevSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingSumInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingVariancePopulationInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeHavingVarianceSampleInput = {
  amount?: InputMaybe<HavingBigfloatFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  valueUsd?: InputMaybe<HavingBigfloatFilter>;
};

export type SwapFeeMaxAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  swapId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeMaxAggregates = {
  __typename?: 'SwapFeeMaxAggregates';
  /** Maximum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapId across the matching connection */
  swapId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeMinAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<IntFilter>;
  swapId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeMinAggregates = {
  __typename?: 'SwapFeeMinAggregates';
  /** Minimum of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapId across the matching connection */
  swapId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeStddevPopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeStddevPopulationAggregates = {
  __typename?: 'SwapFeeStddevPopulationAggregates';
  /** Population standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeStddevSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeStddevSampleAggregates = {
  __typename?: 'SwapFeeStddevSampleAggregates';
  /** Sample standard deviation of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeSumAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  swapId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeSumAggregates = {
  __typename?: 'SwapFeeSumAggregates';
  /** Sum of amount across the matching connection */
  amount: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of swapId across the matching connection */
  swapId: Scalars['BigInt']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
  /** Sum of valueUsd across the matching connection */
  valueUsd: Scalars['BigFloat']['output'];
};

export type SwapFeeType =
  | 'BOOST'
  | 'BROKER'
  | 'EGRESS'
  | 'INGRESS'
  | 'LIQUIDITY'
  | 'NETWORK'
  | 'REFUND';

/** A filter to be used against SwapFeeType fields. All fields are combined with a logical ‘and.’ */
export type SwapFeeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SwapFeeType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SwapFeeType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SwapFeeType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SwapFeeType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SwapFeeType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SwapFeeType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SwapFeeType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SwapFeeType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SwapFeeType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SwapFeeType>>;
};

export type SwapFeeVariancePopulationAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeVariancePopulationAggregates = {
  __typename?: 'SwapFeeVariancePopulationAggregates';
  /** Population variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapFeeVarianceSampleAggregateFilter = {
  amount?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  valueUsd?: InputMaybe<BigFloatFilter>;
};

export type SwapFeeVarianceSampleAggregates = {
  __typename?: 'SwapFeeVarianceSampleAggregates';
  /** Sample variance of amount across the matching connection */
  amount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapId across the matching connection */
  swapId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of valueUsd across the matching connection */
  valueUsd?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapFee` values. */
export type SwapFeesConnection = {
  __typename?: 'SwapFeesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapFeeAggregates>;
  /** A list of edges which contains the `SwapFee` and cursor to aid in pagination. */
  edges: Array<SwapFeesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapFeeAggregates>>;
  /** A list of `SwapFee` objects. */
  nodes: Array<SwapFee>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapFee` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapFee` values. */
export type SwapFeesConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapFeeGroupBy>;
  having?: InputMaybe<SwapFeeHavingInput>;
};

/** A `SwapFee` edge in the connection. */
export type SwapFeesEdge = {
  __typename?: 'SwapFeesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapFee` at the end of the edge. */
  node: SwapFee;
};

/** Methods to use when ordering `SwapFee`. */
export type SwapFeesOrderBy =
  | 'AMOUNT_ASC'
  | 'AMOUNT_DESC'
  | 'ASSET_ASC'
  | 'ASSET_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_ID_ASC'
  | 'SWAP_ID_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'VALUE_USD_ASC'
  | 'VALUE_USD_DESC';

/** A filter to be used against `Swap` object types. All fields are combined with a logical ‘and.’ */
export type SwapFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapFilter>>;
  /** Filter by the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `eventBySwapAbortedEventId` relation. */
  eventBySwapAbortedEventId?: InputMaybe<EventFilter>;
  /** A related `eventBySwapAbortedEventId` exists. */
  eventBySwapAbortedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventBySwapExecutedEventId` relation. */
  eventBySwapExecutedEventId?: InputMaybe<EventFilter>;
  /** A related `eventBySwapExecutedEventId` exists. */
  eventBySwapExecutedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventBySwapScheduledEventId` relation. */
  eventBySwapScheduledEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `intermediateAmount` field. */
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `intermediateValueUsd` field. */
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `nativeId` field. */
  nativeId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapFilter>>;
  /** Filter by the object’s `oraclePriceDeltaBps` field. */
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `oraclePriceDeltaExFeesBps` field. */
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `retryCount` field. */
  retryCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `swapAbortedBlockTimestamp` field. */
  swapAbortedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `swapAbortedEventId` field. */
  swapAbortedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapAbortedReason` field. */
  swapAbortedReason?: InputMaybe<SwapFailureReasonFilter>;
  /** Filter by the object’s `swapCommissionsBySwapId` relation. */
  swapCommissionsBySwapId?: InputMaybe<SwapToManySwapCommissionFilter>;
  /** Some related `swapCommissionsBySwapId` exist. */
  swapCommissionsBySwapIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapExecutedBlockTimestamp` field. */
  swapExecutedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `swapExecutedEventId` field. */
  swapExecutedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `swapFeesBySwapId` relation. */
  swapFeesBySwapId?: InputMaybe<SwapToManySwapFeeFilter>;
  /** Some related `swapFeesBySwapId` exist. */
  swapFeesBySwapIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapInputAmount` field. */
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `swapInputValueUsd` field. */
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `swapOutputAmount` field. */
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `swapOutputValueUsd` field. */
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `swapRescheduledReason` field. */
  swapRescheduledReason?: InputMaybe<SwapFailureReasonFilter>;
  /** Filter by the object’s `swapScheduledBlockTimestamp` field. */
  swapScheduledBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `swapScheduledEventId` field. */
  swapScheduledEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SwapTypeFilter>;
};

/** Grouping methods for `Swap` for usage during aggregation. */
export type SwapGroupBy =
  | 'DESTINATION_ASSET'
  | 'DESTINATION_CHAIN'
  | 'INTERMEDIATE_AMOUNT'
  | 'INTERMEDIATE_VALUE_USD'
  | 'ORACLE_PRICE_DELTA_BPS'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS'
  | 'RETRY_COUNT'
  | 'SOURCE_ASSET'
  | 'SOURCE_CHAIN'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'SWAP_ABORTED_EVENT_ID'
  | 'SWAP_ABORTED_REASON'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'SWAP_EXECUTED_EVENT_ID'
  | 'SWAP_INPUT_AMOUNT'
  | 'SWAP_INPUT_VALUE_USD'
  | 'SWAP_OUTPUT_AMOUNT'
  | 'SWAP_OUTPUT_VALUE_USD'
  | 'SWAP_REQUEST_ID'
  | 'SWAP_RESCHEDULED_REASON'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'SWAP_SCHEDULED_EVENT_ID'
  | 'TYPE';

export type SwapHavingAverageInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingDistinctCountInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

/** Conditions for `Swap` aggregates. */
export type SwapHavingInput = {
  AND?: InputMaybe<Array<SwapHavingInput>>;
  OR?: InputMaybe<Array<SwapHavingInput>>;
  average?: InputMaybe<SwapHavingAverageInput>;
  distinctCount?: InputMaybe<SwapHavingDistinctCountInput>;
  max?: InputMaybe<SwapHavingMaxInput>;
  min?: InputMaybe<SwapHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapHavingStddevSampleInput>;
  sum?: InputMaybe<SwapHavingSumInput>;
  variancePopulation?: InputMaybe<SwapHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapHavingVarianceSampleInput>;
};

export type SwapHavingMaxInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingMinInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingStddevPopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingStddevSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingSumInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingVariancePopulationInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapHavingVarianceSampleInput = {
  id?: InputMaybe<HavingIntFilter>;
  intermediateAmount?: InputMaybe<HavingBigfloatFilter>;
  intermediateValueUsd?: InputMaybe<HavingBigfloatFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  retryCount?: InputMaybe<HavingIntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapAbortedEventId?: InputMaybe<HavingBigintFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapExecutedEventId?: InputMaybe<HavingBigintFilter>;
  swapInputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapInputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapOutputAmount?: InputMaybe<HavingBigfloatFilter>;
  swapOutputValueUsd?: InputMaybe<HavingBigfloatFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  swapScheduledEventId?: InputMaybe<HavingBigintFilter>;
};

export type SwapMaxAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<IntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapAbortedEventId?: InputMaybe<BigIntFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapExecutedEventId?: InputMaybe<BigIntFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapScheduledEventId?: InputMaybe<BigIntFilter>;
};

export type SwapMaxAggregates = {
  __typename?: 'SwapMaxAggregates';
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapAbortedBlockTimestamp across the matching connection */
  swapAbortedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of swapExecutedBlockTimestamp across the matching connection */
  swapExecutedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapScheduledBlockTimestamp across the matching connection */
  swapScheduledBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type SwapMinAggregateFilter = {
  id?: InputMaybe<IntFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<IntFilter>;
  swapAbortedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapAbortedEventId?: InputMaybe<BigIntFilter>;
  swapExecutedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapExecutedEventId?: InputMaybe<BigIntFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
  swapScheduledBlockTimestamp?: InputMaybe<DatetimeFilter>;
  swapScheduledEventId?: InputMaybe<BigIntFilter>;
};

export type SwapMinAggregates = {
  __typename?: 'SwapMinAggregates';
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapAbortedBlockTimestamp across the matching connection */
  swapAbortedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of swapExecutedBlockTimestamp across the matching connection */
  swapExecutedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapScheduledBlockTimestamp across the matching connection */
  swapScheduledBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigInt']['output']>;
};

export type SwapRequest = Node & {
  __typename?: 'SwapRequest';
  /** Reads a single `AccountCreationDepositChannel` that is related to this `SwapRequest`. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: Maybe<AccountCreationDepositChannel>;
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `AccountFundingEvent` that is related to this `SwapRequest`. */
  accountFundingEventBySwapRequestId?: Maybe<AccountFundingEvent>;
  /** Reads and enables pagination through a set of `AccountFundingEvent`. */
  accountFundingEventsBySwapRequestId: AccountFundingEventsConnection;
  /** Reads a single `BoostNetworkFeeSplit` that is related to this `SwapRequest`. */
  boostNetworkFeeSplitByBoostedSwapRequestId?: Maybe<BoostNetworkFeeSplit>;
  /** Reads a single `BoostNetworkFeeSplit` that is related to this `SwapRequest`. */
  boostNetworkFeeSplitByNetworkFeeSwapRequestId?: Maybe<BoostNetworkFeeSplit>;
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitsByBoostedSwapRequestId: BoostNetworkFeeSplitsConnection;
  /** Reads and enables pagination through a set of `BoostNetworkFeeSplit`. */
  boostNetworkFeeSplitsByNetworkFeeSwapRequestId: BoostNetworkFeeSplitsConnection;
  /** Reads a single `Broker` that is related to this `SwapRequest`. */
  brokerByBrokerId?: Maybe<Broker>;
  /** Reads a single `BrokerChannel` that is related to this `SwapRequest`. */
  brokerChannelByBrokerChannelId?: Maybe<BrokerChannel>;
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  brokerId?: Maybe<Scalars['Int']['output']>;
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  ccmMessage?: Maybe<Scalars['String']['output']>;
  completedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  completedEventId?: Maybe<Scalars['BigInt']['output']>;
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  dcaNumberOfChunks: Scalars['Int']['output'];
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  destinationAddress?: Maybe<Scalars['String']['output']>;
  destinationAsset: ChainflipAsset;
  destinationChain: ChainflipChain;
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Egress` that is related to this `SwapRequest`. */
  egressByEgressId?: Maybe<Egress>;
  /** Reads a single `Egress` that is related to this `SwapRequest`. */
  egressByFallbackEgressId?: Maybe<Egress>;
  /** Reads a single `Egress` that is related to this `SwapRequest`. */
  egressByRefundEgressId?: Maybe<Egress>;
  egressId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `Event` that is related to this `SwapRequest`. */
  eventByCompletedEventId?: Maybe<Event>;
  /** Reads a single `Event` that is related to this `SwapRequest`. */
  eventByRequestedEventId: Event;
  fallbackEgressId?: Maybe<Scalars['Int']['output']>;
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  fokRefundAddress?: Maybe<Scalars['String']['output']>;
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  foreignChainDepositBlockId?: Maybe<Scalars['Int']['output']>;
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['Int']['output']>;
  foreignChainPreDepositBlockId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `ForeignChainTracking` that is related to this `SwapRequest`. */
  foreignChainTrackingByForeignChainDepositBlockId?: Maybe<ForeignChainTracking>;
  /** Reads a single `ForeignChainTracking` that is related to this `SwapRequest`. */
  foreignChainTrackingByForeignChainDepositFinalizedBlockId?: Maybe<ForeignChainTracking>;
  /** Reads a single `ForeignChainTracking` that is related to this `SwapRequest`. */
  foreignChainTrackingByForeignChainPreDepositBlockId?: Maybe<ForeignChainTracking>;
  id: Scalars['Int']['output'];
  /** Reads a single `IgnoredEgress` that is related to this `SwapRequest`. */
  ignoredEgressByIgnoredEgressId?: Maybe<IgnoredEgress>;
  /** Reads a single `IgnoredEgress` that is related to this `SwapRequest`. */
  ignoredEgressByIgnoredRefundEgressId?: Maybe<IgnoredEgress>;
  ignoredEgressId?: Maybe<Scalars['Int']['output']>;
  ignoredRefundEgressId?: Maybe<Scalars['Int']['output']>;
  isLiquidation: Scalars['Boolean']['output'];
  /** Reads a single `LendingNetworkFee` that is related to this `SwapRequest`. */
  lendingNetworkFeeBySwapRequestId?: Maybe<LendingNetworkFee>;
  /** Reads and enables pagination through a set of `LendingNetworkFee`. */
  lendingNetworkFeesBySwapRequestId: LendingNetworkFeesConnection;
  /** Reads a single `LiquidationSwapInfo` that is related to this `SwapRequest`. */
  liquidationSwapInfoBySwapRequestId?: Maybe<LiquidationSwapInfo>;
  /** Reads and enables pagination through a set of `LiquidationSwapInfo`. */
  liquidationSwapInfosBySwapRequestId: LiquidationSwapInfosConnection;
  maxBoostFeeBps: Scalars['Int']['output'];
  nativeId: Scalars['BigInt']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `OnChainSwapInfo` that is related to this `SwapRequest`. */
  onChainSwapInfoBySwapRequestId?: Maybe<OnChainSwapInfo>;
  /** Reads and enables pagination through a set of `OnChainSwapInfo`. */
  onChainSwapInfosBySwapRequestId: OnChainSwapInfosConnection;
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  requestedBlockTimestamp: Scalars['Datetime']['output'];
  requestedEventId: Scalars['BigInt']['output'];
  sourceAddress?: Maybe<Scalars['String']['output']>;
  sourceAsset: ChainflipAsset;
  sourceChain: ChainflipChain;
  /** Reads a single `SwapChannel` that is related to this `SwapRequest`. */
  swapChannelByDepositChannelId?: Maybe<SwapChannel>;
  /** Reads and enables pagination through a set of `SwapFee`. */
  swapFeesBySwapRequestId: SwapFeesConnection;
  /** Reads and enables pagination through a set of `SwapRequestBeneficiary`. */
  swapRequestBeneficiariesBySwapRequestId: SwapRequestBeneficiariesConnection;
  /** Reads and enables pagination through a set of `Swap`. */
  swapsBySwapRequestId: SwapsConnection;
  totalBrokerCommissionBps: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `TransactionRef`. */
  transactionRefsBySwapRequestId: TransactionRefsConnection;
  type: SwapRequestType;
};


export type SwapRequestAccountFundingEventsBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AccountFundingEventCondition>;
  filter?: InputMaybe<AccountFundingEventFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AccountFundingEventsOrderBy>>;
};


export type SwapRequestBoostNetworkFeeSplitsByBoostedSwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


export type SwapRequestBoostNetworkFeeSplitsByNetworkFeeSwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BoostNetworkFeeSplitCondition>;
  filter?: InputMaybe<BoostNetworkFeeSplitFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BoostNetworkFeeSplitsOrderBy>>;
};


export type SwapRequestLendingNetworkFeesBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LendingNetworkFeeCondition>;
  filter?: InputMaybe<LendingNetworkFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LendingNetworkFeesOrderBy>>;
};


export type SwapRequestLiquidationSwapInfosBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<LiquidationSwapInfoCondition>;
  filter?: InputMaybe<LiquidationSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<LiquidationSwapInfosOrderBy>>;
};


export type SwapRequestOnChainSwapInfosBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OnChainSwapInfoCondition>;
  filter?: InputMaybe<OnChainSwapInfoFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OnChainSwapInfosOrderBy>>;
};


export type SwapRequestSwapFeesBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapFeeCondition>;
  filter?: InputMaybe<SwapFeeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapFeesOrderBy>>;
};


export type SwapRequestSwapRequestBeneficiariesBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapRequestBeneficiaryCondition>;
  filter?: InputMaybe<SwapRequestBeneficiaryFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapRequestBeneficiariesOrderBy>>;
};


export type SwapRequestSwapsBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCondition>;
  filter?: InputMaybe<SwapFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapsOrderBy>>;
};


export type SwapRequestTransactionRefsBySwapRequestIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<TransactionRefCondition>;
  filter?: InputMaybe<TransactionRefFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TransactionRefsOrderBy>>;
};

export type SwapRequestAggregates = {
  __typename?: 'SwapRequestAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapRequestAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapRequestDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapRequestMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapRequestMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapRequestStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapRequestStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapRequestSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapRequestVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapRequestVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapRequest` object types. */
export type SwapRequestAggregatesFilter = {
  /** Mean average aggregate over matching `SwapRequest` objects. */
  average?: InputMaybe<SwapRequestAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapRequest` objects. */
  distinctCount?: InputMaybe<SwapRequestDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapRequest` object to be included within the aggregate. */
  filter?: InputMaybe<SwapRequestFilter>;
  /** Maximum aggregate over matching `SwapRequest` objects. */
  max?: InputMaybe<SwapRequestMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapRequest` objects. */
  min?: InputMaybe<SwapRequestMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapRequest` objects. */
  stddevPopulation?: InputMaybe<SwapRequestStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapRequest` objects. */
  stddevSample?: InputMaybe<SwapRequestStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapRequest` objects. */
  sum?: InputMaybe<SwapRequestSumAggregateFilter>;
  /** Population variance aggregate over matching `SwapRequest` objects. */
  variancePopulation?: InputMaybe<SwapRequestVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapRequest` objects. */
  varianceSample?: InputMaybe<SwapRequestVarianceSampleAggregateFilter>;
};

export type SwapRequestAverageAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  fallbackEgressId?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ignoredEgressId?: InputMaybe<BigFloatFilter>;
  ignoredRefundEgressId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestAverageAggregates = {
  __typename?: 'SwapRequestAverageAggregates';
  /** Mean average of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapRequestBeneficiary` values. */
export type SwapRequestBeneficiariesConnection = {
  __typename?: 'SwapRequestBeneficiariesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapRequestBeneficiaryAggregates>;
  /** A list of edges which contains the `SwapRequestBeneficiary` and cursor to aid in pagination. */
  edges: Array<SwapRequestBeneficiariesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapRequestBeneficiaryAggregates>>;
  /** A list of `SwapRequestBeneficiary` objects. */
  nodes: Array<SwapRequestBeneficiary>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapRequestBeneficiary` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapRequestBeneficiary` values. */
export type SwapRequestBeneficiariesConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapRequestBeneficiaryGroupBy>;
  having?: InputMaybe<SwapRequestBeneficiaryHavingInput>;
};

/** A `SwapRequestBeneficiary` edge in the connection. */
export type SwapRequestBeneficiariesEdge = {
  __typename?: 'SwapRequestBeneficiariesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapRequestBeneficiary` at the end of the edge. */
  node: SwapRequestBeneficiary;
};

/** Methods to use when ordering `SwapRequestBeneficiary`. */
export type SwapRequestBeneficiariesOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'BROKER_COMMISSION_RATE_BPS_ASC'
  | 'BROKER_COMMISSION_RATE_BPS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_AVERAGE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_COUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_COUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MAX_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_MIN_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_SUM_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_REQUEST_BENEFICIARY_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type SwapRequestBeneficiary = Node & {
  __typename?: 'SwapRequestBeneficiary';
  /** Reads a single `Account` that is related to this `SwapRequestBeneficiary`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  brokerCommissionRateBps: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads and enables pagination through a set of `SwapCommission`. */
  swapCommissionsBySwapRequestBeneficiaryId: SwapCommissionsConnection;
  /** Reads a single `SwapRequest` that is related to this `SwapRequestBeneficiary`. */
  swapRequestBySwapRequestId?: Maybe<SwapRequest>;
  swapRequestId?: Maybe<Scalars['Int']['output']>;
  type: BrokerType;
};


export type SwapRequestBeneficiarySwapCommissionsBySwapRequestBeneficiaryIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<SwapCommissionCondition>;
  filter?: InputMaybe<SwapCommissionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SwapCommissionsOrderBy>>;
};

export type SwapRequestBeneficiaryAggregates = {
  __typename?: 'SwapRequestBeneficiaryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<SwapRequestBeneficiaryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<SwapRequestBeneficiaryDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<SwapRequestBeneficiaryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<SwapRequestBeneficiaryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<SwapRequestBeneficiaryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<SwapRequestBeneficiaryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<SwapRequestBeneficiarySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<SwapRequestBeneficiaryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<SwapRequestBeneficiaryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `SwapRequestBeneficiary` object types. */
export type SwapRequestBeneficiaryAggregatesFilter = {
  /** Mean average aggregate over matching `SwapRequestBeneficiary` objects. */
  average?: InputMaybe<SwapRequestBeneficiaryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `SwapRequestBeneficiary` objects. */
  distinctCount?: InputMaybe<SwapRequestBeneficiaryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `SwapRequestBeneficiary` object to be included within the aggregate. */
  filter?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** Maximum aggregate over matching `SwapRequestBeneficiary` objects. */
  max?: InputMaybe<SwapRequestBeneficiaryMaxAggregateFilter>;
  /** Minimum aggregate over matching `SwapRequestBeneficiary` objects. */
  min?: InputMaybe<SwapRequestBeneficiaryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `SwapRequestBeneficiary` objects. */
  stddevPopulation?: InputMaybe<SwapRequestBeneficiaryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `SwapRequestBeneficiary` objects. */
  stddevSample?: InputMaybe<SwapRequestBeneficiaryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `SwapRequestBeneficiary` objects. */
  sum?: InputMaybe<SwapRequestBeneficiarySumAggregateFilter>;
  /** Population variance aggregate over matching `SwapRequestBeneficiary` objects. */
  variancePopulation?: InputMaybe<SwapRequestBeneficiaryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `SwapRequestBeneficiary` objects. */
  varianceSample?: InputMaybe<SwapRequestBeneficiaryVarianceSampleAggregateFilter>;
};

export type SwapRequestBeneficiaryAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestBeneficiaryAverageAggregates = {
  __typename?: 'SwapRequestBeneficiaryAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SwapRequestBeneficiary` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type SwapRequestBeneficiaryCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<BrokerType>;
};

export type SwapRequestBeneficiaryDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type SwapRequestBeneficiaryDistinctCountAggregates = {
  __typename?: 'SwapRequestBeneficiaryDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapRequestBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestBeneficiaryFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapRequestBeneficiaryFilter>>;
  /** Filter by the object’s `brokerCommissionRateBps` field. */
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapRequestBeneficiaryFilter>>;
  /** Filter by the object’s `swapCommissionsBySwapRequestBeneficiaryId` relation. */
  swapCommissionsBySwapRequestBeneficiaryId?: InputMaybe<SwapRequestBeneficiaryToManySwapCommissionFilter>;
  /** Some related `swapCommissionsBySwapRequestBeneficiaryId` exist. */
  swapCommissionsBySwapRequestBeneficiaryIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestBySwapRequestId` exists. */
  swapRequestBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<BrokerTypeFilter>;
};

/** Grouping methods for `SwapRequestBeneficiary` for usage during aggregation. */
export type SwapRequestBeneficiaryGroupBy =
  | 'ACCOUNT_ID'
  | 'BROKER_COMMISSION_RATE_BPS'
  | 'SWAP_REQUEST_ID'
  | 'TYPE';

export type SwapRequestBeneficiaryHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `SwapRequestBeneficiary` aggregates. */
export type SwapRequestBeneficiaryHavingInput = {
  AND?: InputMaybe<Array<SwapRequestBeneficiaryHavingInput>>;
  OR?: InputMaybe<Array<SwapRequestBeneficiaryHavingInput>>;
  average?: InputMaybe<SwapRequestBeneficiaryHavingAverageInput>;
  distinctCount?: InputMaybe<SwapRequestBeneficiaryHavingDistinctCountInput>;
  max?: InputMaybe<SwapRequestBeneficiaryHavingMaxInput>;
  min?: InputMaybe<SwapRequestBeneficiaryHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapRequestBeneficiaryHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapRequestBeneficiaryHavingStddevSampleInput>;
  sum?: InputMaybe<SwapRequestBeneficiaryHavingSumInput>;
  variancePopulation?: InputMaybe<SwapRequestBeneficiaryHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapRequestBeneficiaryHavingVarianceSampleInput>;
};

export type SwapRequestBeneficiaryHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  brokerCommissionRateBps?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestBeneficiaryMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type SwapRequestBeneficiaryMaxAggregates = {
  __typename?: 'SwapRequestBeneficiaryMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type SwapRequestBeneficiaryMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  brokerCommissionRateBps?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type SwapRequestBeneficiaryMinAggregates = {
  __typename?: 'SwapRequestBeneficiaryMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type SwapRequestBeneficiaryStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestBeneficiaryStddevPopulationAggregates = {
  __typename?: 'SwapRequestBeneficiaryStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestBeneficiaryStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestBeneficiaryStddevSampleAggregates = {
  __typename?: 'SwapRequestBeneficiaryStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestBeneficiarySumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  brokerCommissionRateBps?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type SwapRequestBeneficiarySumAggregates = {
  __typename?: 'SwapRequestBeneficiarySumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `SwapCommission` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestBeneficiaryToManySwapCommissionFilter = {
  /** Aggregates across related `SwapCommission` match the filter criteria. */
  aggregates?: InputMaybe<SwapCommissionAggregatesFilter>;
  /** Every related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapCommissionFilter>;
  /** No related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapCommissionFilter>;
  /** Some related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapCommissionFilter>;
};

export type SwapRequestBeneficiaryVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestBeneficiaryVariancePopulationAggregates = {
  __typename?: 'SwapRequestBeneficiaryVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestBeneficiaryVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  brokerCommissionRateBps?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestBeneficiaryVarianceSampleAggregates = {
  __typename?: 'SwapRequestBeneficiaryVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerCommissionRateBps across the matching connection */
  brokerCommissionRateBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `SwapRequest` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type SwapRequestCondition = {
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<Scalars['Int']['input']>;
  brokerByBrokerId?: InputMaybe<Scalars['ID']['input']>;
  brokerChannelByBrokerChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `brokerChannelId` field. */
  brokerChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `brokerId` field. */
  brokerId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `completedBlockTimestamp` field. */
  completedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `completedEventId` field. */
  completedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `dcaChunkIntervalBlocks` field. */
  dcaChunkIntervalBlocks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `dcaNumberOfChunks` field. */
  dcaNumberOfChunks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `depositValueUsd` field. */
  depositValueUsd?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChain>;
  /** Checks for equality with the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  egressByEgressId?: InputMaybe<Scalars['ID']['input']>;
  egressByFallbackEgressId?: InputMaybe<Scalars['ID']['input']>;
  egressByRefundEgressId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `egressId` field. */
  egressId?: InputMaybe<Scalars['Int']['input']>;
  eventByCompletedEventId?: InputMaybe<Scalars['ID']['input']>;
  eventByRequestedEventId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `fallbackEgressId` field. */
  fallbackEgressId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `fokMaxOraclePriceSlippageBps` field. */
  fokMaxOraclePriceSlippageBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fokMinPriceX128` field. */
  fokMinPriceX128?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `fokRefundAddress` field. */
  fokRefundAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `fokRetryDurationBlocks` field. */
  fokRetryDurationBlocks?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `foreignChainDepositBlockId` field. */
  foreignChainDepositBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `foreignChainDepositFinalizedBlockId` field. */
  foreignChainDepositFinalizedBlockId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `foreignChainPreDepositBlockId` field. */
  foreignChainPreDepositBlockId?: InputMaybe<Scalars['Int']['input']>;
  foreignChainTrackingByForeignChainDepositBlockId?: InputMaybe<Scalars['ID']['input']>;
  foreignChainTrackingByForeignChainDepositFinalizedBlockId?: InputMaybe<Scalars['ID']['input']>;
  foreignChainTrackingByForeignChainPreDepositBlockId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  ignoredEgressByIgnoredEgressId?: InputMaybe<Scalars['ID']['input']>;
  ignoredEgressByIgnoredRefundEgressId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `ignoredEgressId` field. */
  ignoredEgressId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ignoredRefundEgressId` field. */
  ignoredRefundEgressId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `isLiquidation` field. */
  isLiquidation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `nativeId` field. */
  nativeId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `oraclePriceDeltaBps` field. */
  oraclePriceDeltaBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `oraclePriceDeltaExFeesBps` field. */
  oraclePriceDeltaExFeesBps?: InputMaybe<Scalars['BigFloat']['input']>;
  /** Checks for equality with the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `refundEgressId` field. */
  refundEgressId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `requestedBlockTimestamp` field. */
  requestedBlockTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `requestedEventId` field. */
  requestedEventId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `sourceAddress` field. */
  sourceAddress?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAsset>;
  /** Checks for equality with the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChain>;
  swapChannelByDepositChannelId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `totalBrokerCommissionBps` field. */
  totalBrokerCommissionBps?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<SwapRequestType>;
};

export type SwapRequestDistinctCountAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  brokerChannelId?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigIntFilter>;
  ccmMessage?: InputMaybe<BigIntFilter>;
  completedBlockTimestamp?: InputMaybe<BigIntFilter>;
  completedEventId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigIntFilter>;
  dcaNumberOfChunks?: InputMaybe<BigIntFilter>;
  depositAmount?: InputMaybe<BigIntFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  depositValueUsd?: InputMaybe<BigIntFilter>;
  destinationAddress?: InputMaybe<BigIntFilter>;
  destinationAsset?: InputMaybe<BigIntFilter>;
  destinationChain?: InputMaybe<BigIntFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  fallbackEgressId?: InputMaybe<BigIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigIntFilter>;
  fokMinPriceX128?: InputMaybe<BigIntFilter>;
  fokRefundAddress?: InputMaybe<BigIntFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  ignoredEgressId?: InputMaybe<BigIntFilter>;
  ignoredRefundEgressId?: InputMaybe<BigIntFilter>;
  isLiquidation?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigIntFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  refundEgressId?: InputMaybe<BigIntFilter>;
  requestedBlockTimestamp?: InputMaybe<BigIntFilter>;
  requestedEventId?: InputMaybe<BigIntFilter>;
  sourceAddress?: InputMaybe<BigIntFilter>;
  sourceAsset?: InputMaybe<BigIntFilter>;
  sourceChain?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
};

export type SwapRequestDistinctCountAggregates = {
  __typename?: 'SwapRequestDistinctCountAggregates';
  /** Distinct count of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ccmMessage across the matching connection */
  ccmMessage?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of completedBlockTimestamp across the matching connection */
  completedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAddress across the matching connection */
  destinationAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationAsset across the matching connection */
  destinationAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of destinationChain across the matching connection */
  destinationChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokRefundAddress across the matching connection */
  fokRefundAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of isLiquidation across the matching connection */
  isLiquidation?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of requestedBlockTimestamp across the matching connection */
  requestedBlockTimestamp?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceAddress across the matching connection */
  sourceAddress?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceAsset across the matching connection */
  sourceAsset?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of sourceChain across the matching connection */
  sourceChain?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `SwapRequest` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestFilter = {
  /** Filter by the object’s `accountCreationDepositChannelByAccountCreationDepositChannelId` relation. */
  accountCreationDepositChannelByAccountCreationDepositChannelId?: InputMaybe<AccountCreationDepositChannelFilter>;
  /** A related `accountCreationDepositChannelByAccountCreationDepositChannelId` exists. */
  accountCreationDepositChannelByAccountCreationDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `accountCreationDepositChannelId` field. */
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `accountFundingEventBySwapRequestId` relation. */
  accountFundingEventBySwapRequestId?: InputMaybe<AccountFundingEventFilter>;
  /** A related `accountFundingEventBySwapRequestId` exists. */
  accountFundingEventBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<SwapRequestFilter>>;
  /** Filter by the object’s `boostNetworkFeeSplitByBoostedSwapRequestId` relation. */
  boostNetworkFeeSplitByBoostedSwapRequestId?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** A related `boostNetworkFeeSplitByBoostedSwapRequestId` exists. */
  boostNetworkFeeSplitByBoostedSwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `boostNetworkFeeSplitByNetworkFeeSwapRequestId` relation. */
  boostNetworkFeeSplitByNetworkFeeSwapRequestId?: InputMaybe<BoostNetworkFeeSplitFilter>;
  /** A related `boostNetworkFeeSplitByNetworkFeeSwapRequestId` exists. */
  boostNetworkFeeSplitByNetworkFeeSwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerByBrokerId` relation. */
  brokerByBrokerId?: InputMaybe<BrokerFilter>;
  /** A related `brokerByBrokerId` exists. */
  brokerByBrokerIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelByBrokerChannelId` relation. */
  brokerChannelByBrokerChannelId?: InputMaybe<BrokerChannelFilter>;
  /** A related `brokerChannelByBrokerChannelId` exists. */
  brokerChannelByBrokerChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `brokerChannelId` field. */
  brokerChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `brokerId` field. */
  brokerId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ccmGasBudget` field. */
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `ccmMessage` field. */
  ccmMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `completedBlockTimestamp` field. */
  completedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `completedEventId` field. */
  completedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `dcaChunkIntervalBlocks` field. */
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `dcaNumberOfChunks` field. */
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `depositAmount` field. */
  depositAmount?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `depositChannelId` field. */
  depositChannelId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `depositValueUsd` field. */
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `destinationAddress` field. */
  destinationAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `destinationAsset` field. */
  destinationAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `destinationChain` field. */
  destinationChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `effectiveBoostFeeBps` field. */
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `egressByEgressId` relation. */
  egressByEgressId?: InputMaybe<EgressFilter>;
  /** A related `egressByEgressId` exists. */
  egressByEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressByFallbackEgressId` relation. */
  egressByFallbackEgressId?: InputMaybe<EgressFilter>;
  /** A related `egressByFallbackEgressId` exists. */
  egressByFallbackEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressByRefundEgressId` relation. */
  egressByRefundEgressId?: InputMaybe<EgressFilter>;
  /** A related `egressByRefundEgressId` exists. */
  egressByRefundEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `egressId` field. */
  egressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `eventByCompletedEventId` relation. */
  eventByCompletedEventId?: InputMaybe<EventFilter>;
  /** A related `eventByCompletedEventId` exists. */
  eventByCompletedEventIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `eventByRequestedEventId` relation. */
  eventByRequestedEventId?: InputMaybe<EventFilter>;
  /** Filter by the object’s `fallbackEgressId` field. */
  fallbackEgressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `fokMaxOraclePriceSlippageBps` field. */
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fokMinPriceX128` field. */
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `fokRefundAddress` field. */
  fokRefundAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fokRetryDurationBlocks` field. */
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  /** Filter by the object’s `foreignChainDepositBlockId` field. */
  foreignChainDepositBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `foreignChainDepositFinalizedBlockId` field. */
  foreignChainDepositFinalizedBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `foreignChainPreDepositBlockId` field. */
  foreignChainPreDepositBlockId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `foreignChainTrackingByForeignChainDepositBlockId` relation. */
  foreignChainTrackingByForeignChainDepositBlockId?: InputMaybe<ForeignChainTrackingFilter>;
  /** A related `foreignChainTrackingByForeignChainDepositBlockId` exists. */
  foreignChainTrackingByForeignChainDepositBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `foreignChainTrackingByForeignChainDepositFinalizedBlockId` relation. */
  foreignChainTrackingByForeignChainDepositFinalizedBlockId?: InputMaybe<ForeignChainTrackingFilter>;
  /** A related `foreignChainTrackingByForeignChainDepositFinalizedBlockId` exists. */
  foreignChainTrackingByForeignChainDepositFinalizedBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `foreignChainTrackingByForeignChainPreDepositBlockId` relation. */
  foreignChainTrackingByForeignChainPreDepositBlockId?: InputMaybe<ForeignChainTrackingFilter>;
  /** A related `foreignChainTrackingByForeignChainPreDepositBlockId` exists. */
  foreignChainTrackingByForeignChainPreDepositBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ignoredEgressByIgnoredEgressId` relation. */
  ignoredEgressByIgnoredEgressId?: InputMaybe<IgnoredEgressFilter>;
  /** A related `ignoredEgressByIgnoredEgressId` exists. */
  ignoredEgressByIgnoredEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ignoredEgressByIgnoredRefundEgressId` relation. */
  ignoredEgressByIgnoredRefundEgressId?: InputMaybe<IgnoredEgressFilter>;
  /** A related `ignoredEgressByIgnoredRefundEgressId` exists. */
  ignoredEgressByIgnoredRefundEgressIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `ignoredEgressId` field. */
  ignoredEgressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `ignoredRefundEgressId` field. */
  ignoredRefundEgressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `isLiquidation` field. */
  isLiquidation?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `lendingNetworkFeeBySwapRequestId` relation. */
  lendingNetworkFeeBySwapRequestId?: InputMaybe<LendingNetworkFeeFilter>;
  /** A related `lendingNetworkFeeBySwapRequestId` exists. */
  lendingNetworkFeeBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidationSwapInfoBySwapRequestId` relation. */
  liquidationSwapInfoBySwapRequestId?: InputMaybe<LiquidationSwapInfoFilter>;
  /** A related `liquidationSwapInfoBySwapRequestId` exists. */
  liquidationSwapInfoBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `maxBoostFeeBps` field. */
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `nativeId` field. */
  nativeId?: InputMaybe<BigIntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<SwapRequestFilter>;
  /** Filter by the object’s `onChainSwapInfoBySwapRequestId` relation. */
  onChainSwapInfoBySwapRequestId?: InputMaybe<OnChainSwapInfoFilter>;
  /** A related `onChainSwapInfoBySwapRequestId` exists. */
  onChainSwapInfoBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<SwapRequestFilter>>;
  /** Filter by the object’s `oraclePriceDeltaBps` field. */
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `oraclePriceDeltaExFeesBps` field. */
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  /** Filter by the object’s `prewitnessedDepositId` field. */
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `refundEgressId` field. */
  refundEgressId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `requestedBlockTimestamp` field. */
  requestedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `requestedEventId` field. */
  requestedEventId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `sourceAddress` field. */
  sourceAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `sourceAsset` field. */
  sourceAsset?: InputMaybe<ChainflipAssetFilter>;
  /** Filter by the object’s `sourceChain` field. */
  sourceChain?: InputMaybe<ChainflipChainFilter>;
  /** Filter by the object’s `swapChannelByDepositChannelId` relation. */
  swapChannelByDepositChannelId?: InputMaybe<SwapChannelFilter>;
  /** A related `swapChannelByDepositChannelId` exists. */
  swapChannelByDepositChannelIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapFeesBySwapRequestId` relation. */
  swapFeesBySwapRequestId?: InputMaybe<SwapRequestToManySwapFeeFilter>;
  /** Some related `swapFeesBySwapRequestId` exist. */
  swapFeesBySwapRequestIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestBeneficiariesBySwapRequestId` relation. */
  swapRequestBeneficiariesBySwapRequestId?: InputMaybe<SwapRequestToManySwapRequestBeneficiaryFilter>;
  /** Some related `swapRequestBeneficiariesBySwapRequestId` exist. */
  swapRequestBeneficiariesBySwapRequestIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapsBySwapRequestId` relation. */
  swapsBySwapRequestId?: InputMaybe<SwapRequestToManySwapFilter>;
  /** Some related `swapsBySwapRequestId` exist. */
  swapsBySwapRequestIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `totalBrokerCommissionBps` field. */
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
  /** Filter by the object’s `transactionRefsBySwapRequestId` relation. */
  transactionRefsBySwapRequestId?: InputMaybe<SwapRequestToManyTransactionRefFilter>;
  /** Some related `transactionRefsBySwapRequestId` exist. */
  transactionRefsBySwapRequestIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<SwapRequestTypeFilter>;
};

/** Grouping methods for `SwapRequest` for usage during aggregation. */
export type SwapRequestGroupBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID'
  | 'BROKER_CHANNEL_ID'
  | 'BROKER_ID'
  | 'CCM_GAS_BUDGET'
  | 'CCM_MESSAGE'
  | 'COMPLETED_BLOCK_TIMESTAMP'
  | 'COMPLETED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'COMPLETED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'COMPLETED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'COMPLETED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'COMPLETED_EVENT_ID'
  | 'DCA_CHUNK_INTERVAL_BLOCKS'
  | 'DCA_NUMBER_OF_CHUNKS'
  | 'DEPOSIT_AMOUNT'
  | 'DEPOSIT_CHANNEL_ID'
  | 'DEPOSIT_VALUE_USD'
  | 'DESTINATION_ADDRESS'
  | 'DESTINATION_ASSET'
  | 'DESTINATION_CHAIN'
  | 'EFFECTIVE_BOOST_FEE_BPS'
  | 'EGRESS_ID'
  | 'FALLBACK_EGRESS_ID'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS'
  | 'FOK_MIN_PRICE_X128'
  | 'FOK_REFUND_ADDRESS'
  | 'FOK_RETRY_DURATION_BLOCKS'
  | 'FOREIGN_CHAIN_DEPOSIT_BLOCK_ID'
  | 'FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID'
  | 'FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID'
  | 'IS_LIQUIDATION'
  | 'MAX_BOOST_FEE_BPS'
  | 'ORACLE_PRICE_DELTA_BPS'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS'
  | 'PREWITNESSED_DEPOSIT_ID'
  | 'REFUND_EGRESS_ID'
  | 'REQUESTED_BLOCK_TIMESTAMP'
  | 'REQUESTED_BLOCK_TIMESTAMP_TRUNCATED_TO_DAY'
  | 'REQUESTED_BLOCK_TIMESTAMP_TRUNCATED_TO_HOUR'
  | 'REQUESTED_BLOCK_TIMESTAMP_TRUNCATED_TO_MONTH'
  | 'REQUESTED_BLOCK_TIMESTAMP_TRUNCATED_TO_WEEK'
  | 'REQUESTED_EVENT_ID'
  | 'SOURCE_ADDRESS'
  | 'SOURCE_ASSET'
  | 'SOURCE_CHAIN'
  | 'TOTAL_BROKER_COMMISSION_BPS'
  | 'TYPE';

export type SwapRequestHavingAverageInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingDistinctCountInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `SwapRequest` aggregates. */
export type SwapRequestHavingInput = {
  AND?: InputMaybe<Array<SwapRequestHavingInput>>;
  OR?: InputMaybe<Array<SwapRequestHavingInput>>;
  average?: InputMaybe<SwapRequestHavingAverageInput>;
  distinctCount?: InputMaybe<SwapRequestHavingDistinctCountInput>;
  max?: InputMaybe<SwapRequestHavingMaxInput>;
  min?: InputMaybe<SwapRequestHavingMinInput>;
  stddevPopulation?: InputMaybe<SwapRequestHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<SwapRequestHavingStddevSampleInput>;
  sum?: InputMaybe<SwapRequestHavingSumInput>;
  variancePopulation?: InputMaybe<SwapRequestHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<SwapRequestHavingVarianceSampleInput>;
};

export type SwapRequestHavingMaxInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingMinInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingStddevPopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingStddevSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingSumInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingVariancePopulationInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestHavingVarianceSampleInput = {
  accountCreationDepositChannelId?: InputMaybe<HavingIntFilter>;
  brokerChannelId?: InputMaybe<HavingIntFilter>;
  brokerId?: InputMaybe<HavingIntFilter>;
  ccmGasBudget?: InputMaybe<HavingBigfloatFilter>;
  completedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  completedEventId?: InputMaybe<HavingBigintFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<HavingIntFilter>;
  dcaNumberOfChunks?: InputMaybe<HavingIntFilter>;
  depositAmount?: InputMaybe<HavingBigfloatFilter>;
  depositChannelId?: InputMaybe<HavingIntFilter>;
  depositValueUsd?: InputMaybe<HavingBigfloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<HavingIntFilter>;
  egressId?: InputMaybe<HavingIntFilter>;
  fallbackEgressId?: InputMaybe<HavingIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<HavingBigfloatFilter>;
  fokMinPriceX128?: InputMaybe<HavingBigfloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<HavingIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<HavingIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  ignoredEgressId?: InputMaybe<HavingIntFilter>;
  ignoredRefundEgressId?: InputMaybe<HavingIntFilter>;
  maxBoostFeeBps?: InputMaybe<HavingIntFilter>;
  nativeId?: InputMaybe<HavingBigintFilter>;
  oraclePriceDeltaBps?: InputMaybe<HavingBigfloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<HavingBigfloatFilter>;
  prewitnessedDepositId?: InputMaybe<HavingBigintFilter>;
  refundEgressId?: InputMaybe<HavingIntFilter>;
  requestedBlockTimestamp?: InputMaybe<HavingDatetimeFilter>;
  requestedEventId?: InputMaybe<HavingBigintFilter>;
  totalBrokerCommissionBps?: InputMaybe<HavingIntFilter>;
};

export type SwapRequestMaxAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  brokerChannelId?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  completedEventId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  egressId?: InputMaybe<IntFilter>;
  fallbackEgressId?: InputMaybe<IntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  foreignChainDepositBlockId?: InputMaybe<IntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<IntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  ignoredEgressId?: InputMaybe<IntFilter>;
  ignoredRefundEgressId?: InputMaybe<IntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  refundEgressId?: InputMaybe<IntFilter>;
  requestedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  requestedEventId?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
};

export type SwapRequestMaxAggregates = {
  __typename?: 'SwapRequestMaxAggregates';
  /** Maximum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of completedBlockTimestamp across the matching connection */
  completedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of egressId across the matching connection */
  egressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  /** Maximum of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Maximum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Maximum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of requestedBlockTimestamp across the matching connection */
  requestedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['Int']['output']>;
};

export type SwapRequestMinAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<IntFilter>;
  brokerChannelId?: InputMaybe<IntFilter>;
  brokerId?: InputMaybe<IntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  completedEventId?: InputMaybe<BigIntFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<IntFilter>;
  dcaNumberOfChunks?: InputMaybe<IntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<IntFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<IntFilter>;
  egressId?: InputMaybe<IntFilter>;
  fallbackEgressId?: InputMaybe<IntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<IntFilter>;
  foreignChainDepositBlockId?: InputMaybe<IntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<IntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  ignoredEgressId?: InputMaybe<IntFilter>;
  ignoredRefundEgressId?: InputMaybe<IntFilter>;
  maxBoostFeeBps?: InputMaybe<IntFilter>;
  nativeId?: InputMaybe<BigIntFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigIntFilter>;
  refundEgressId?: InputMaybe<IntFilter>;
  requestedBlockTimestamp?: InputMaybe<DatetimeFilter>;
  requestedEventId?: InputMaybe<BigIntFilter>;
  totalBrokerCommissionBps?: InputMaybe<IntFilter>;
};

export type SwapRequestMinAggregates = {
  __typename?: 'SwapRequestMinAggregates';
  /** Minimum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of completedBlockTimestamp across the matching connection */
  completedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of egressId across the matching connection */
  egressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['Int']['output']>;
  /** Minimum of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['Int']['output']>;
  /** Minimum of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Minimum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of requestedBlockTimestamp across the matching connection */
  requestedBlockTimestamp?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['Int']['output']>;
};

export type SwapRequestStddevPopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  fallbackEgressId?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ignoredEgressId?: InputMaybe<BigFloatFilter>;
  ignoredRefundEgressId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestStddevPopulationAggregates = {
  __typename?: 'SwapRequestStddevPopulationAggregates';
  /** Population standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestStddevSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  fallbackEgressId?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ignoredEgressId?: InputMaybe<BigFloatFilter>;
  ignoredRefundEgressId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestStddevSampleAggregates = {
  __typename?: 'SwapRequestStddevSampleAggregates';
  /** Sample standard deviation of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestSumAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigIntFilter>;
  brokerChannelId?: InputMaybe<BigIntFilter>;
  brokerId?: InputMaybe<BigIntFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigIntFilter>;
  dcaNumberOfChunks?: InputMaybe<BigIntFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigIntFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigIntFilter>;
  egressId?: InputMaybe<BigIntFilter>;
  fallbackEgressId?: InputMaybe<BigIntFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigIntFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigIntFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigIntFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  ignoredEgressId?: InputMaybe<BigIntFilter>;
  ignoredRefundEgressId?: InputMaybe<BigIntFilter>;
  maxBoostFeeBps?: InputMaybe<BigIntFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigIntFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigIntFilter>;
};

export type SwapRequestSumAggregates = {
  __typename?: 'SwapRequestSumAggregates';
  /** Sum of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId: Scalars['BigInt']['output'];
  /** Sum of brokerChannelId across the matching connection */
  brokerChannelId: Scalars['BigInt']['output'];
  /** Sum of brokerId across the matching connection */
  brokerId: Scalars['BigInt']['output'];
  /** Sum of ccmGasBudget across the matching connection */
  ccmGasBudget: Scalars['BigFloat']['output'];
  /** Sum of completedEventId across the matching connection */
  completedEventId: Scalars['BigFloat']['output'];
  /** Sum of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks: Scalars['BigInt']['output'];
  /** Sum of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks: Scalars['BigInt']['output'];
  /** Sum of depositAmount across the matching connection */
  depositAmount: Scalars['BigFloat']['output'];
  /** Sum of depositChannelId across the matching connection */
  depositChannelId: Scalars['BigInt']['output'];
  /** Sum of depositValueUsd across the matching connection */
  depositValueUsd: Scalars['BigFloat']['output'];
  /** Sum of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of egressId across the matching connection */
  egressId: Scalars['BigInt']['output'];
  /** Sum of fallbackEgressId across the matching connection */
  fallbackEgressId: Scalars['BigInt']['output'];
  /** Sum of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps: Scalars['BigFloat']['output'];
  /** Sum of fokMinPriceX128 across the matching connection */
  fokMinPriceX128: Scalars['BigFloat']['output'];
  /** Sum of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks: Scalars['BigInt']['output'];
  /** Sum of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId: Scalars['BigInt']['output'];
  /** Sum of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId: Scalars['BigInt']['output'];
  /** Sum of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of ignoredEgressId across the matching connection */
  ignoredEgressId: Scalars['BigInt']['output'];
  /** Sum of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId: Scalars['BigInt']['output'];
  /** Sum of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps: Scalars['BigInt']['output'];
  /** Sum of nativeId across the matching connection */
  nativeId: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps: Scalars['BigFloat']['output'];
  /** Sum of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId: Scalars['BigFloat']['output'];
  /** Sum of refundEgressId across the matching connection */
  refundEgressId: Scalars['BigInt']['output'];
  /** Sum of requestedEventId across the matching connection */
  requestedEventId: Scalars['BigFloat']['output'];
  /** Sum of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps: Scalars['BigInt']['output'];
};

/** A filter to be used against many `SwapFee` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestToManySwapFeeFilter = {
  /** Aggregates across related `SwapFee` match the filter criteria. */
  aggregates?: InputMaybe<SwapFeeAggregatesFilter>;
  /** Every related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapFeeFilter>;
  /** No related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapFeeFilter>;
  /** Some related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapFeeFilter>;
};

/** A filter to be used against many `Swap` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestToManySwapFilter = {
  /** Aggregates across related `Swap` match the filter criteria. */
  aggregates?: InputMaybe<SwapAggregatesFilter>;
  /** Every related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapFilter>;
  /** No related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapFilter>;
  /** Some related `Swap` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapFilter>;
};

/** A filter to be used against many `SwapRequestBeneficiary` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestToManySwapRequestBeneficiaryFilter = {
  /** Aggregates across related `SwapRequestBeneficiary` match the filter criteria. */
  aggregates?: InputMaybe<SwapRequestBeneficiaryAggregatesFilter>;
  /** Every related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** No related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapRequestBeneficiaryFilter>;
  /** Some related `SwapRequestBeneficiary` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapRequestBeneficiaryFilter>;
};

/** A filter to be used against many `TransactionRef` object types. All fields are combined with a logical ‘and.’ */
export type SwapRequestToManyTransactionRefFilter = {
  /** Aggregates across related `TransactionRef` match the filter criteria. */
  aggregates?: InputMaybe<TransactionRefAggregatesFilter>;
  /** Every related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TransactionRefFilter>;
  /** No related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TransactionRefFilter>;
  /** Some related `TransactionRef` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TransactionRefFilter>;
};

export type SwapRequestType =
  | 'INGRESS_EGRESS_FEE'
  | 'LEGACY_CCM'
  | 'LEGACY_INTERNAL_SWAP'
  | 'LEGACY_SWAP'
  | 'NETWORK_FEE'
  | 'REGULAR';

/** A filter to be used against SwapRequestType fields. All fields are combined with a logical ‘and.’ */
export type SwapRequestTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SwapRequestType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SwapRequestType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SwapRequestType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SwapRequestType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SwapRequestType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SwapRequestType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SwapRequestType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SwapRequestType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SwapRequestType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SwapRequestType>>;
};

export type SwapRequestVariancePopulationAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  fallbackEgressId?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ignoredEgressId?: InputMaybe<BigFloatFilter>;
  ignoredRefundEgressId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestVariancePopulationAggregates = {
  __typename?: 'SwapRequestVariancePopulationAggregates';
  /** Population variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapRequestVarianceSampleAggregateFilter = {
  accountCreationDepositChannelId?: InputMaybe<BigFloatFilter>;
  brokerChannelId?: InputMaybe<BigFloatFilter>;
  brokerId?: InputMaybe<BigFloatFilter>;
  ccmGasBudget?: InputMaybe<BigFloatFilter>;
  completedEventId?: InputMaybe<BigFloatFilter>;
  dcaChunkIntervalBlocks?: InputMaybe<BigFloatFilter>;
  dcaNumberOfChunks?: InputMaybe<BigFloatFilter>;
  depositAmount?: InputMaybe<BigFloatFilter>;
  depositChannelId?: InputMaybe<BigFloatFilter>;
  depositValueUsd?: InputMaybe<BigFloatFilter>;
  effectiveBoostFeeBps?: InputMaybe<BigFloatFilter>;
  egressId?: InputMaybe<BigFloatFilter>;
  fallbackEgressId?: InputMaybe<BigFloatFilter>;
  fokMaxOraclePriceSlippageBps?: InputMaybe<BigFloatFilter>;
  fokMinPriceX128?: InputMaybe<BigFloatFilter>;
  fokRetryDurationBlocks?: InputMaybe<BigFloatFilter>;
  foreignChainDepositBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainDepositFinalizedBlockId?: InputMaybe<BigFloatFilter>;
  foreignChainPreDepositBlockId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  ignoredEgressId?: InputMaybe<BigFloatFilter>;
  ignoredRefundEgressId?: InputMaybe<BigFloatFilter>;
  maxBoostFeeBps?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  prewitnessedDepositId?: InputMaybe<BigFloatFilter>;
  refundEgressId?: InputMaybe<BigFloatFilter>;
  requestedEventId?: InputMaybe<BigFloatFilter>;
  totalBrokerCommissionBps?: InputMaybe<BigFloatFilter>;
};

export type SwapRequestVarianceSampleAggregates = {
  __typename?: 'SwapRequestVarianceSampleAggregates';
  /** Sample variance of accountCreationDepositChannelId across the matching connection */
  accountCreationDepositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerChannelId across the matching connection */
  brokerChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of brokerId across the matching connection */
  brokerId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ccmGasBudget across the matching connection */
  ccmGasBudget?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of completedEventId across the matching connection */
  completedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dcaChunkIntervalBlocks across the matching connection */
  dcaChunkIntervalBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of dcaNumberOfChunks across the matching connection */
  dcaNumberOfChunks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositAmount across the matching connection */
  depositAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositChannelId across the matching connection */
  depositChannelId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of depositValueUsd across the matching connection */
  depositValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of effectiveBoostFeeBps across the matching connection */
  effectiveBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of egressId across the matching connection */
  egressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fallbackEgressId across the matching connection */
  fallbackEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokMaxOraclePriceSlippageBps across the matching connection */
  fokMaxOraclePriceSlippageBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokMinPriceX128 across the matching connection */
  fokMinPriceX128?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of fokRetryDurationBlocks across the matching connection */
  fokRetryDurationBlocks?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of foreignChainDepositBlockId across the matching connection */
  foreignChainDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of foreignChainDepositFinalizedBlockId across the matching connection */
  foreignChainDepositFinalizedBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of foreignChainPreDepositBlockId across the matching connection */
  foreignChainPreDepositBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ignoredEgressId across the matching connection */
  ignoredEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of ignoredRefundEgressId across the matching connection */
  ignoredRefundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of maxBoostFeeBps across the matching connection */
  maxBoostFeeBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of prewitnessedDepositId across the matching connection */
  prewitnessedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of refundEgressId across the matching connection */
  refundEgressId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of requestedEventId across the matching connection */
  requestedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of totalBrokerCommissionBps across the matching connection */
  totalBrokerCommissionBps?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `SwapRequest` values. */
export type SwapRequestsConnection = {
  __typename?: 'SwapRequestsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapRequestAggregates>;
  /** A list of edges which contains the `SwapRequest` and cursor to aid in pagination. */
  edges: Array<SwapRequestsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapRequestAggregates>>;
  /** A list of `SwapRequest` objects. */
  nodes: Array<SwapRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `SwapRequest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `SwapRequest` values. */
export type SwapRequestsConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapRequestGroupBy>;
  having?: InputMaybe<SwapRequestHavingInput>;
};

/** A `SwapRequest` edge in the connection. */
export type SwapRequestsEdge = {
  __typename?: 'SwapRequestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `SwapRequest` at the end of the edge. */
  node: SwapRequest;
};

/** Methods to use when ordering `SwapRequest`. */
export type SwapRequestsOrderBy =
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_ASC'
  | 'ACCOUNT_CREATION_DEPOSIT_CHANNEL_ID_DESC'
  | 'BROKER_CHANNEL_ID_ASC'
  | 'BROKER_CHANNEL_ID_DESC'
  | 'BROKER_ID_ASC'
  | 'BROKER_ID_DESC'
  | 'CCM_GAS_BUDGET_ASC'
  | 'CCM_GAS_BUDGET_DESC'
  | 'CCM_MESSAGE_ASC'
  | 'CCM_MESSAGE_DESC'
  | 'COMPLETED_BLOCK_TIMESTAMP_ASC'
  | 'COMPLETED_BLOCK_TIMESTAMP_DESC'
  | 'COMPLETED_EVENT_ID_ASC'
  | 'COMPLETED_EVENT_ID_DESC'
  | 'DCA_CHUNK_INTERVAL_BLOCKS_ASC'
  | 'DCA_CHUNK_INTERVAL_BLOCKS_DESC'
  | 'DCA_NUMBER_OF_CHUNKS_ASC'
  | 'DCA_NUMBER_OF_CHUNKS_DESC'
  | 'DEPOSIT_AMOUNT_ASC'
  | 'DEPOSIT_AMOUNT_DESC'
  | 'DEPOSIT_CHANNEL_ID_ASC'
  | 'DEPOSIT_CHANNEL_ID_DESC'
  | 'DEPOSIT_VALUE_USD_ASC'
  | 'DEPOSIT_VALUE_USD_DESC'
  | 'DESTINATION_ADDRESS_ASC'
  | 'DESTINATION_ADDRESS_DESC'
  | 'DESTINATION_ASSET_ASC'
  | 'DESTINATION_ASSET_DESC'
  | 'DESTINATION_CHAIN_ASC'
  | 'DESTINATION_CHAIN_DESC'
  | 'EFFECTIVE_BOOST_FEE_BPS_ASC'
  | 'EFFECTIVE_BOOST_FEE_BPS_DESC'
  | 'EGRESS_ID_ASC'
  | 'EGRESS_ID_DESC'
  | 'FALLBACK_EGRESS_ID_ASC'
  | 'FALLBACK_EGRESS_ID_DESC'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_ASC'
  | 'FOK_MAX_ORACLE_PRICE_SLIPPAGE_BPS_DESC'
  | 'FOK_MIN_PRICE_X128_ASC'
  | 'FOK_MIN_PRICE_X128_DESC'
  | 'FOK_REFUND_ADDRESS_ASC'
  | 'FOK_REFUND_ADDRESS_DESC'
  | 'FOK_RETRY_DURATION_BLOCKS_ASC'
  | 'FOK_RETRY_DURATION_BLOCKS_DESC'
  | 'FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_DEPOSIT_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_DEPOSIT_FINALIZED_BLOCK_ID_DESC'
  | 'FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_ASC'
  | 'FOREIGN_CHAIN_PRE_DEPOSIT_BLOCK_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IGNORED_EGRESS_ID_ASC'
  | 'IGNORED_EGRESS_ID_DESC'
  | 'IGNORED_REFUND_EGRESS_ID_ASC'
  | 'IGNORED_REFUND_EGRESS_ID_DESC'
  | 'IS_LIQUIDATION_ASC'
  | 'IS_LIQUIDATION_DESC'
  | 'MAX_BOOST_FEE_BPS_ASC'
  | 'MAX_BOOST_FEE_BPS_DESC'
  | 'NATIVE_ID_ASC'
  | 'NATIVE_ID_DESC'
  | 'NATURAL'
  | 'ORACLE_PRICE_DELTA_BPS_ASC'
  | 'ORACLE_PRICE_DELTA_BPS_DESC'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'PREWITNESSED_DEPOSIT_ID_ASC'
  | 'PREWITNESSED_DEPOSIT_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REFUND_EGRESS_ID_ASC'
  | 'REFUND_EGRESS_ID_DESC'
  | 'REQUESTED_BLOCK_TIMESTAMP_ASC'
  | 'REQUESTED_BLOCK_TIMESTAMP_DESC'
  | 'REQUESTED_EVENT_ID_ASC'
  | 'REQUESTED_EVENT_ID_DESC'
  | 'SOURCE_ADDRESS_ASC'
  | 'SOURCE_ADDRESS_DESC'
  | 'SOURCE_ASSET_ASC'
  | 'SOURCE_ASSET_DESC'
  | 'SOURCE_CHAIN_ASC'
  | 'SOURCE_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_DESTINATION_ASSET_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_DESTINATION_ASSET_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_DESTINATION_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_DESTINATION_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SOURCE_ASSET_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SOURCE_ASSET_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SOURCE_CHAIN_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SOURCE_CHAIN_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ABORTED_REASON_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_RESCHEDULED_REASON_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MAX_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_MIN_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_SUM_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_INTERMEDIATE_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_INTERMEDIATE_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_NATIVE_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_NATIVE_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_RETRY_COUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_RETRY_COUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_INPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAPS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_AVERAGE_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_COUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_COUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MAX_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_MIN_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_SUM_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_COUNT_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_COUNT_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ACCOUNT_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ACCOUNT_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_BROKER_COMMISSION_RATE_BPS_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_BENEFICIARIES_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TOTAL_BROKER_COMMISSION_BPS_ASC'
  | 'TOTAL_BROKER_COMMISSION_BPS_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_COUNT_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_COUNT_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_REF_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_REF_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_BROADCAST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_BROADCAST_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_FAILED_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_LIQUIDITY_DEPOSIT_ID_DESC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'TRANSACTION_REFS_BY_SWAP_REQUEST_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type SwapStddevPopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigFloatFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapStddevPopulationAggregates = {
  __typename?: 'SwapStddevPopulationAggregates';
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapStddevSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigFloatFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapStddevSampleAggregates = {
  __typename?: 'SwapStddevSampleAggregates';
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapSumAggregateFilter = {
  id?: InputMaybe<BigIntFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigIntFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapSumAggregates = {
  __typename?: 'SwapSumAggregates';
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of intermediateAmount across the matching connection */
  intermediateAmount: Scalars['BigFloat']['output'];
  /** Sum of intermediateValueUsd across the matching connection */
  intermediateValueUsd: Scalars['BigFloat']['output'];
  /** Sum of nativeId across the matching connection */
  nativeId: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps: Scalars['BigFloat']['output'];
  /** Sum of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps: Scalars['BigFloat']['output'];
  /** Sum of retryCount across the matching connection */
  retryCount: Scalars['BigInt']['output'];
  /** Sum of swapAbortedEventId across the matching connection */
  swapAbortedEventId: Scalars['BigFloat']['output'];
  /** Sum of swapExecutedEventId across the matching connection */
  swapExecutedEventId: Scalars['BigFloat']['output'];
  /** Sum of swapInputAmount across the matching connection */
  swapInputAmount: Scalars['BigFloat']['output'];
  /** Sum of swapInputValueUsd across the matching connection */
  swapInputValueUsd: Scalars['BigFloat']['output'];
  /** Sum of swapOutputAmount across the matching connection */
  swapOutputAmount: Scalars['BigFloat']['output'];
  /** Sum of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd: Scalars['BigFloat']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
  /** Sum of swapScheduledEventId across the matching connection */
  swapScheduledEventId: Scalars['BigFloat']['output'];
};

/** A filter to be used against many `SwapCommission` object types. All fields are combined with a logical ‘and.’ */
export type SwapToManySwapCommissionFilter = {
  /** Aggregates across related `SwapCommission` match the filter criteria. */
  aggregates?: InputMaybe<SwapCommissionAggregatesFilter>;
  /** Every related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapCommissionFilter>;
  /** No related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapCommissionFilter>;
  /** Some related `SwapCommission` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapCommissionFilter>;
};

/** A filter to be used against many `SwapFee` object types. All fields are combined with a logical ‘and.’ */
export type SwapToManySwapFeeFilter = {
  /** Aggregates across related `SwapFee` match the filter criteria. */
  aggregates?: InputMaybe<SwapFeeAggregatesFilter>;
  /** Every related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<SwapFeeFilter>;
  /** No related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<SwapFeeFilter>;
  /** Some related `SwapFee` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<SwapFeeFilter>;
};

export type SwapType =
  | 'GAS'
  | 'INGRESS_EGRESS_FEE'
  | 'NETWORK_FEE'
  | 'PRINCIPAL'
  | 'SWAP';

/** A filter to be used against SwapType fields. All fields are combined with a logical ‘and.’ */
export type SwapTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<SwapType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<SwapType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<SwapType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<SwapType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<SwapType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<SwapType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<SwapType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<SwapType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<SwapType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<SwapType>>;
};

export type SwapVariancePopulationAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigFloatFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapVariancePopulationAggregates = {
  __typename?: 'SwapVariancePopulationAggregates';
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
};

export type SwapVarianceSampleAggregateFilter = {
  id?: InputMaybe<BigFloatFilter>;
  intermediateAmount?: InputMaybe<BigFloatFilter>;
  intermediateValueUsd?: InputMaybe<BigFloatFilter>;
  nativeId?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaBps?: InputMaybe<BigFloatFilter>;
  oraclePriceDeltaExFeesBps?: InputMaybe<BigFloatFilter>;
  retryCount?: InputMaybe<BigFloatFilter>;
  swapAbortedEventId?: InputMaybe<BigFloatFilter>;
  swapExecutedEventId?: InputMaybe<BigFloatFilter>;
  swapInputAmount?: InputMaybe<BigFloatFilter>;
  swapInputValueUsd?: InputMaybe<BigFloatFilter>;
  swapOutputAmount?: InputMaybe<BigFloatFilter>;
  swapOutputValueUsd?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
  swapScheduledEventId?: InputMaybe<BigFloatFilter>;
};

export type SwapVarianceSampleAggregates = {
  __typename?: 'SwapVarianceSampleAggregates';
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of intermediateAmount across the matching connection */
  intermediateAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of intermediateValueUsd across the matching connection */
  intermediateValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of nativeId across the matching connection */
  nativeId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceDeltaBps across the matching connection */
  oraclePriceDeltaBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of oraclePriceDeltaExFeesBps across the matching connection */
  oraclePriceDeltaExFeesBps?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of retryCount across the matching connection */
  retryCount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapAbortedEventId across the matching connection */
  swapAbortedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapExecutedEventId across the matching connection */
  swapExecutedEventId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapInputAmount across the matching connection */
  swapInputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapInputValueUsd across the matching connection */
  swapInputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapOutputAmount across the matching connection */
  swapOutputAmount?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapOutputValueUsd across the matching connection */
  swapOutputValueUsd?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapScheduledEventId across the matching connection */
  swapScheduledEventId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Swap` values. */
export type SwapsConnection = {
  __typename?: 'SwapsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<SwapAggregates>;
  /** A list of edges which contains the `Swap` and cursor to aid in pagination. */
  edges: Array<SwapsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<SwapAggregates>>;
  /** A list of `Swap` objects. */
  nodes: Array<Swap>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Swap` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Swap` values. */
export type SwapsConnectionGroupedAggregatesArgs = {
  groupBy: Array<SwapGroupBy>;
  having?: InputMaybe<SwapHavingInput>;
};

/** A `Swap` edge in the connection. */
export type SwapsEdge = {
  __typename?: 'SwapsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Swap` at the end of the edge. */
  node: Swap;
};

/** Methods to use when ordering `Swap`. */
export type SwapsOrderBy =
  | 'DESTINATION_ASSET_ASC'
  | 'DESTINATION_ASSET_DESC'
  | 'DESTINATION_CHAIN_ASC'
  | 'DESTINATION_CHAIN_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERMEDIATE_AMOUNT_ASC'
  | 'INTERMEDIATE_AMOUNT_DESC'
  | 'INTERMEDIATE_VALUE_USD_ASC'
  | 'INTERMEDIATE_VALUE_USD_DESC'
  | 'NATIVE_ID_ASC'
  | 'NATIVE_ID_DESC'
  | 'NATURAL'
  | 'ORACLE_PRICE_DELTA_BPS_ASC'
  | 'ORACLE_PRICE_DELTA_BPS_DESC'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS_ASC'
  | 'ORACLE_PRICE_DELTA_EX_FEES_BPS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RETRY_COUNT_ASC'
  | 'RETRY_COUNT_DESC'
  | 'SOURCE_ASSET_ASC'
  | 'SOURCE_ASSET_DESC'
  | 'SOURCE_CHAIN_ASC'
  | 'SOURCE_CHAIN_DESC'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_ABORTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_ABORTED_EVENT_ID_ASC'
  | 'SWAP_ABORTED_EVENT_ID_DESC'
  | 'SWAP_ABORTED_REASON_ASC'
  | 'SWAP_ABORTED_REASON_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_AVERAGE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_COUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_COUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MAX_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_MIN_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_SUM_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_MAIN_BROKER_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_CHANNEL_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_REQUEST_BENEFICIARY_ID_DESC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_COMMISSIONS_BY_SWAP_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_EXECUTED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_EXECUTED_EVENT_ID_ASC'
  | 'SWAP_EXECUTED_EVENT_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_AVERAGE_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_COUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_COUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_ASSET_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_ASSET_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_TYPE_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_TYPE_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_DISTINCT_COUNT_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MAX_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_MIN_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_POPULATION_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_STDDEV_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_SUM_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_POPULATION_VALUE_USD_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_SWAP_REQUEST_ID_DESC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_VALUE_USD_ASC'
  | 'SWAP_FEES_BY_SWAP_ID_VARIANCE_SAMPLE_VALUE_USD_DESC'
  | 'SWAP_INPUT_AMOUNT_ASC'
  | 'SWAP_INPUT_AMOUNT_DESC'
  | 'SWAP_INPUT_VALUE_USD_ASC'
  | 'SWAP_INPUT_VALUE_USD_DESC'
  | 'SWAP_OUTPUT_AMOUNT_ASC'
  | 'SWAP_OUTPUT_AMOUNT_DESC'
  | 'SWAP_OUTPUT_VALUE_USD_ASC'
  | 'SWAP_OUTPUT_VALUE_USD_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC'
  | 'SWAP_RESCHEDULED_REASON_ASC'
  | 'SWAP_RESCHEDULED_REASON_DESC'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_ASC'
  | 'SWAP_SCHEDULED_BLOCK_TIMESTAMP_DESC'
  | 'SWAP_SCHEDULED_EVENT_ID_ASC'
  | 'SWAP_SCHEDULED_EVENT_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC';

export type TransactionRef = Node & {
  __typename?: 'TransactionRef';
  /** Reads a single `Broadcast` that is related to this `TransactionRef`. */
  broadcastByBroadcastId?: Maybe<Broadcast>;
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Reads a single `FailedDeposit` that is related to this `TransactionRef`. */
  failedDepositByFailedDepositId?: Maybe<FailedDeposit>;
  failedDepositId?: Maybe<Scalars['BigInt']['output']>;
  id: Scalars['Int']['output'];
  /** Reads a single `LiquidityDeposit` that is related to this `TransactionRef`. */
  liquidityDepositByLiquidityDepositId?: Maybe<LiquidityDeposit>;
  liquidityDepositId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  ref: Scalars['String']['output'];
  /** Reads a single `SwapRequest` that is related to this `TransactionRef`. */
  swapRequestBySwapRequestId?: Maybe<SwapRequest>;
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type TransactionRefAggregates = {
  __typename?: 'TransactionRefAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TransactionRefAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TransactionRefDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TransactionRefMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TransactionRefMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TransactionRefStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TransactionRefStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TransactionRefSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TransactionRefVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TransactionRefVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `TransactionRef` object types. */
export type TransactionRefAggregatesFilter = {
  /** Mean average aggregate over matching `TransactionRef` objects. */
  average?: InputMaybe<TransactionRefAverageAggregateFilter>;
  /** Distinct count aggregate over matching `TransactionRef` objects. */
  distinctCount?: InputMaybe<TransactionRefDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `TransactionRef` object to be included within the aggregate. */
  filter?: InputMaybe<TransactionRefFilter>;
  /** Maximum aggregate over matching `TransactionRef` objects. */
  max?: InputMaybe<TransactionRefMaxAggregateFilter>;
  /** Minimum aggregate over matching `TransactionRef` objects. */
  min?: InputMaybe<TransactionRefMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `TransactionRef` objects. */
  stddevPopulation?: InputMaybe<TransactionRefStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `TransactionRef` objects. */
  stddevSample?: InputMaybe<TransactionRefStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `TransactionRef` objects. */
  sum?: InputMaybe<TransactionRefSumAggregateFilter>;
  /** Population variance aggregate over matching `TransactionRef` objects. */
  variancePopulation?: InputMaybe<TransactionRefVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `TransactionRef` objects. */
  varianceSample?: InputMaybe<TransactionRefVarianceSampleAggregateFilter>;
};

export type TransactionRefAverageAggregateFilter = {
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type TransactionRefAverageAggregates = {
  __typename?: 'TransactionRefAverageAggregates';
  /** Mean average of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `TransactionRef` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type TransactionRefCondition = {
  broadcastByBroadcastId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<Scalars['Int']['input']>;
  failedDepositByFailedDepositId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `failedDepositId` field. */
  failedDepositId?: InputMaybe<Scalars['BigInt']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  liquidityDepositByLiquidityDepositId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `liquidityDepositId` field. */
  liquidityDepositId?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `ref` field. */
  ref?: InputMaybe<Scalars['String']['input']>;
  swapRequestBySwapRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<Scalars['Int']['input']>;
};

export type TransactionRefDistinctCountAggregateFilter = {
  broadcastId?: InputMaybe<BigIntFilter>;
  failedDepositId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositId?: InputMaybe<BigIntFilter>;
  ref?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type TransactionRefDistinctCountAggregates = {
  __typename?: 'TransactionRefDistinctCountAggregates';
  /** Distinct count of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of ref across the matching connection */
  ref?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `TransactionRef` object types. All fields are combined with a logical ‘and.’ */
export type TransactionRefFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TransactionRefFilter>>;
  /** Filter by the object’s `broadcastByBroadcastId` relation. */
  broadcastByBroadcastId?: InputMaybe<BroadcastFilter>;
  /** A related `broadcastByBroadcastId` exists. */
  broadcastByBroadcastIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `broadcastId` field. */
  broadcastId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `failedDepositByFailedDepositId` relation. */
  failedDepositByFailedDepositId?: InputMaybe<FailedDepositFilter>;
  /** A related `failedDepositByFailedDepositId` exists. */
  failedDepositByFailedDepositIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `failedDepositId` field. */
  failedDepositId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `liquidityDepositByLiquidityDepositId` relation. */
  liquidityDepositByLiquidityDepositId?: InputMaybe<LiquidityDepositFilter>;
  /** A related `liquidityDepositByLiquidityDepositId` exists. */
  liquidityDepositByLiquidityDepositIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `liquidityDepositId` field. */
  liquidityDepositId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TransactionRefFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TransactionRefFilter>>;
  /** Filter by the object’s `ref` field. */
  ref?: InputMaybe<StringFilter>;
  /** Filter by the object’s `swapRequestBySwapRequestId` relation. */
  swapRequestBySwapRequestId?: InputMaybe<SwapRequestFilter>;
  /** A related `swapRequestBySwapRequestId` exists. */
  swapRequestBySwapRequestIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `swapRequestId` field. */
  swapRequestId?: InputMaybe<IntFilter>;
};

/** Grouping methods for `TransactionRef` for usage during aggregation. */
export type TransactionRefGroupBy =
  | 'BROADCAST_ID'
  | 'FAILED_DEPOSIT_ID'
  | 'LIQUIDITY_DEPOSIT_ID'
  | 'SWAP_REQUEST_ID';

export type TransactionRefHavingAverageInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingDistinctCountInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `TransactionRef` aggregates. */
export type TransactionRefHavingInput = {
  AND?: InputMaybe<Array<TransactionRefHavingInput>>;
  OR?: InputMaybe<Array<TransactionRefHavingInput>>;
  average?: InputMaybe<TransactionRefHavingAverageInput>;
  distinctCount?: InputMaybe<TransactionRefHavingDistinctCountInput>;
  max?: InputMaybe<TransactionRefHavingMaxInput>;
  min?: InputMaybe<TransactionRefHavingMinInput>;
  stddevPopulation?: InputMaybe<TransactionRefHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TransactionRefHavingStddevSampleInput>;
  sum?: InputMaybe<TransactionRefHavingSumInput>;
  variancePopulation?: InputMaybe<TransactionRefHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TransactionRefHavingVarianceSampleInput>;
};

export type TransactionRefHavingMaxInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingMinInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingStddevPopulationInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingStddevSampleInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingSumInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingVariancePopulationInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefHavingVarianceSampleInput = {
  broadcastId?: InputMaybe<HavingIntFilter>;
  failedDepositId?: InputMaybe<HavingBigintFilter>;
  id?: InputMaybe<HavingIntFilter>;
  liquidityDepositId?: InputMaybe<HavingIntFilter>;
  swapRequestId?: InputMaybe<HavingIntFilter>;
};

export type TransactionRefMaxAggregateFilter = {
  broadcastId?: InputMaybe<IntFilter>;
  failedDepositId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityDepositId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type TransactionRefMaxAggregates = {
  __typename?: 'TransactionRefMaxAggregates';
  /** Maximum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type TransactionRefMinAggregateFilter = {
  broadcastId?: InputMaybe<IntFilter>;
  failedDepositId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<IntFilter>;
  liquidityDepositId?: InputMaybe<IntFilter>;
  swapRequestId?: InputMaybe<IntFilter>;
};

export type TransactionRefMinAggregates = {
  __typename?: 'TransactionRefMinAggregates';
  /** Minimum of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigInt']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['Int']['output']>;
};

export type TransactionRefStddevPopulationAggregateFilter = {
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type TransactionRefStddevPopulationAggregates = {
  __typename?: 'TransactionRefStddevPopulationAggregates';
  /** Population standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TransactionRefStddevSampleAggregateFilter = {
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type TransactionRefStddevSampleAggregates = {
  __typename?: 'TransactionRefStddevSampleAggregates';
  /** Sample standard deviation of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TransactionRefSumAggregateFilter = {
  broadcastId?: InputMaybe<BigIntFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigIntFilter>;
  liquidityDepositId?: InputMaybe<BigIntFilter>;
  swapRequestId?: InputMaybe<BigIntFilter>;
};

export type TransactionRefSumAggregates = {
  __typename?: 'TransactionRefSumAggregates';
  /** Sum of broadcastId across the matching connection */
  broadcastId: Scalars['BigInt']['output'];
  /** Sum of failedDepositId across the matching connection */
  failedDepositId: Scalars['BigFloat']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of liquidityDepositId across the matching connection */
  liquidityDepositId: Scalars['BigInt']['output'];
  /** Sum of swapRequestId across the matching connection */
  swapRequestId: Scalars['BigInt']['output'];
};

export type TransactionRefVariancePopulationAggregateFilter = {
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type TransactionRefVariancePopulationAggregates = {
  __typename?: 'TransactionRefVariancePopulationAggregates';
  /** Population variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

export type TransactionRefVarianceSampleAggregateFilter = {
  broadcastId?: InputMaybe<BigFloatFilter>;
  failedDepositId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  liquidityDepositId?: InputMaybe<BigFloatFilter>;
  swapRequestId?: InputMaybe<BigFloatFilter>;
};

export type TransactionRefVarianceSampleAggregates = {
  __typename?: 'TransactionRefVarianceSampleAggregates';
  /** Sample variance of broadcastId across the matching connection */
  broadcastId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of failedDepositId across the matching connection */
  failedDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of liquidityDepositId across the matching connection */
  liquidityDepositId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of swapRequestId across the matching connection */
  swapRequestId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `TransactionRef` values. */
export type TransactionRefsConnection = {
  __typename?: 'TransactionRefsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TransactionRefAggregates>;
  /** A list of edges which contains the `TransactionRef` and cursor to aid in pagination. */
  edges: Array<TransactionRefsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TransactionRefAggregates>>;
  /** A list of `TransactionRef` objects. */
  nodes: Array<TransactionRef>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `TransactionRef` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `TransactionRef` values. */
export type TransactionRefsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TransactionRefGroupBy>;
  having?: InputMaybe<TransactionRefHavingInput>;
};

/** A `TransactionRef` edge in the connection. */
export type TransactionRefsEdge = {
  __typename?: 'TransactionRefsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `TransactionRef` at the end of the edge. */
  node: TransactionRef;
};

/** Methods to use when ordering `TransactionRef`. */
export type TransactionRefsOrderBy =
  | 'BROADCAST_ID_ASC'
  | 'BROADCAST_ID_DESC'
  | 'FAILED_DEPOSIT_ID_ASC'
  | 'FAILED_DEPOSIT_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LIQUIDITY_DEPOSIT_ID_ASC'
  | 'LIQUIDITY_DEPOSIT_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REF_ASC'
  | 'REF_DESC'
  | 'SWAP_REQUEST_ID_ASC'
  | 'SWAP_REQUEST_ID_DESC';

export type Validator = Node & {
  __typename?: 'Validator';
  /** Reads a single `Account` that is related to this `Validator`. */
  accountByAccountId: Account;
  accountId: Scalars['Int']['output'];
  /** Reads and enables pagination through a set of `AuthorityHeartbeat`. */
  authorityHeartbeatsByValidatorId: AuthorityHeartbeatsConnection;
  /** Reads and enables pagination through a set of `AuthorityMembership`. */
  authorityMembershipsByValidatorId: AuthorityMembershipsConnection;
  /** Reads a single `Block` that is related to this `Validator`. */
  blockByLastHeartbeatBlockId?: Maybe<Block>;
  /** Reads and enables pagination through a set of `Block`. */
  blocksByValidatorId: BlocksConnection;
  /** Reads a single `CfeVersion` that is related to this `Validator`. */
  cfeVersionByCfeVersionId: CfeVersion;
  cfeVersionId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastHeartbeatBlockId?: Maybe<Scalars['Int']['output']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  /** Reads a single `Operator` that is related to this `Validator`. */
  operatorByOperatorId?: Maybe<Operator>;
  /** Reads and enables pagination through a set of `OperatorEpochValidator`. */
  operatorEpochValidatorsByValidatorId: OperatorEpochValidatorsConnection;
  operatorId?: Maybe<Scalars['Int']['output']>;
  /** Reads and enables pagination through a set of `OperatorValidatorLink`. */
  operatorValidatorLinksByValidatorId: OperatorValidatorLinksConnection;
  /** Reads and enables pagination through a set of `Penalty`. */
  penaltiesByValidatorId: PenaltiesConnection;
};


export type ValidatorAuthorityHeartbeatsByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityHeartbeatCondition>;
  filter?: InputMaybe<AuthorityHeartbeatFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityHeartbeatsOrderBy>>;
};


export type ValidatorAuthorityMembershipsByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AuthorityMembershipCondition>;
  filter?: InputMaybe<AuthorityMembershipFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AuthorityMembershipsOrderBy>>;
};


export type ValidatorBlocksByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<BlockCondition>;
  filter?: InputMaybe<BlockFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BlocksOrderBy>>;
};


export type ValidatorOperatorEpochValidatorsByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorEpochValidatorCondition>;
  filter?: InputMaybe<OperatorEpochValidatorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorEpochValidatorsOrderBy>>;
};


export type ValidatorOperatorValidatorLinksByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<OperatorValidatorLinkCondition>;
  filter?: InputMaybe<OperatorValidatorLinkFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OperatorValidatorLinksOrderBy>>;
};


export type ValidatorPenaltiesByValidatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<PenaltyCondition>;
  filter?: InputMaybe<PenaltyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PenaltiesOrderBy>>;
};

export type ValidatorAggregates = {
  __typename?: 'ValidatorAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ValidatorAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ValidatorDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ValidatorMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ValidatorMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ValidatorStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ValidatorStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ValidatorSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ValidatorVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ValidatorVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Validator` object types. */
export type ValidatorAggregatesFilter = {
  /** Mean average aggregate over matching `Validator` objects. */
  average?: InputMaybe<ValidatorAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Validator` objects. */
  distinctCount?: InputMaybe<ValidatorDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Validator` object to be included within the aggregate. */
  filter?: InputMaybe<ValidatorFilter>;
  /** Maximum aggregate over matching `Validator` objects. */
  max?: InputMaybe<ValidatorMaxAggregateFilter>;
  /** Minimum aggregate over matching `Validator` objects. */
  min?: InputMaybe<ValidatorMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Validator` objects. */
  stddevPopulation?: InputMaybe<ValidatorStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Validator` objects. */
  stddevSample?: InputMaybe<ValidatorStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Validator` objects. */
  sum?: InputMaybe<ValidatorSumAggregateFilter>;
  /** Population variance aggregate over matching `Validator` objects. */
  variancePopulation?: InputMaybe<ValidatorVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Validator` objects. */
  varianceSample?: InputMaybe<ValidatorVarianceSampleAggregateFilter>;
};

export type ValidatorAverageAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type ValidatorAverageAggregates = {
  __typename?: 'ValidatorAverageAggregates';
  /** Mean average of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Mean average of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `Validator` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type ValidatorCondition = {
  accountByAccountId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `accountId` field. */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  blockByLastHeartbeatBlockId?: InputMaybe<Scalars['ID']['input']>;
  cfeVersionByCfeVersionId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `cfeVersionId` field. */
  cfeVersionId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `lastHeartbeatBlockId` field. */
  lastHeartbeatBlockId?: InputMaybe<Scalars['Int']['input']>;
  operatorByOperatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Checks for equality with the object’s `operatorId` field. */
  operatorId?: InputMaybe<Scalars['Int']['input']>;
};

export type ValidatorDistinctCountAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  cfeVersionId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
};

export type ValidatorDistinctCountAggregates = {
  __typename?: 'ValidatorDistinctCountAggregates';
  /** Distinct count of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of cfeVersionId across the matching connection */
  cfeVersionId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `Validator` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorFilter = {
  /** Filter by the object’s `accountByAccountId` relation. */
  accountByAccountId?: InputMaybe<AccountFilter>;
  /** Filter by the object’s `accountId` field. */
  accountId?: InputMaybe<IntFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `authorityHeartbeatsByValidatorId` relation. */
  authorityHeartbeatsByValidatorId?: InputMaybe<ValidatorToManyAuthorityHeartbeatFilter>;
  /** Some related `authorityHeartbeatsByValidatorId` exist. */
  authorityHeartbeatsByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `authorityMembershipsByValidatorId` relation. */
  authorityMembershipsByValidatorId?: InputMaybe<ValidatorToManyAuthorityMembershipFilter>;
  /** Some related `authorityMembershipsByValidatorId` exist. */
  authorityMembershipsByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `blockByLastHeartbeatBlockId` relation. */
  blockByLastHeartbeatBlockId?: InputMaybe<BlockFilter>;
  /** A related `blockByLastHeartbeatBlockId` exists. */
  blockByLastHeartbeatBlockIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `blocksByValidatorId` relation. */
  blocksByValidatorId?: InputMaybe<ValidatorToManyBlockFilter>;
  /** Some related `blocksByValidatorId` exist. */
  blocksByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `cfeVersionByCfeVersionId` relation. */
  cfeVersionByCfeVersionId?: InputMaybe<CfeVersionFilter>;
  /** Filter by the object’s `cfeVersionId` field. */
  cfeVersionId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lastHeartbeatBlockId` field. */
  lastHeartbeatBlockId?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ValidatorFilter>;
  /** Filter by the object’s `operatorByOperatorId` relation. */
  operatorByOperatorId?: InputMaybe<OperatorFilter>;
  /** A related `operatorByOperatorId` exists. */
  operatorByOperatorIdExists?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorEpochValidatorsByValidatorId` relation. */
  operatorEpochValidatorsByValidatorId?: InputMaybe<ValidatorToManyOperatorEpochValidatorFilter>;
  /** Some related `operatorEpochValidatorsByValidatorId` exist. */
  operatorEpochValidatorsByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `operatorId` field. */
  operatorId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `operatorValidatorLinksByValidatorId` relation. */
  operatorValidatorLinksByValidatorId?: InputMaybe<ValidatorToManyOperatorValidatorLinkFilter>;
  /** Some related `operatorValidatorLinksByValidatorId` exist. */
  operatorValidatorLinksByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ValidatorFilter>>;
  /** Filter by the object’s `penaltiesByValidatorId` relation. */
  penaltiesByValidatorId?: InputMaybe<ValidatorToManyPenaltyFilter>;
  /** Some related `penaltiesByValidatorId` exist. */
  penaltiesByValidatorIdExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Grouping methods for `Validator` for usage during aggregation. */
export type ValidatorGroupBy =
  | 'CFE_VERSION_ID'
  | 'LAST_HEARTBEAT_BLOCK_ID'
  | 'OPERATOR_ID';

export type ValidatorHavingAverageInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingDistinctCountInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `Validator` aggregates. */
export type ValidatorHavingInput = {
  AND?: InputMaybe<Array<ValidatorHavingInput>>;
  OR?: InputMaybe<Array<ValidatorHavingInput>>;
  average?: InputMaybe<ValidatorHavingAverageInput>;
  distinctCount?: InputMaybe<ValidatorHavingDistinctCountInput>;
  max?: InputMaybe<ValidatorHavingMaxInput>;
  min?: InputMaybe<ValidatorHavingMinInput>;
  stddevPopulation?: InputMaybe<ValidatorHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ValidatorHavingStddevSampleInput>;
  sum?: InputMaybe<ValidatorHavingSumInput>;
  variancePopulation?: InputMaybe<ValidatorHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ValidatorHavingVarianceSampleInput>;
};

export type ValidatorHavingMaxInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingMinInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingStddevPopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingStddevSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingSumInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingVariancePopulationInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorHavingVarianceSampleInput = {
  accountId?: InputMaybe<HavingIntFilter>;
  id?: InputMaybe<HavingIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<HavingIntFilter>;
  operatorId?: InputMaybe<HavingIntFilter>;
};

export type ValidatorMaxAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  lastHeartbeatBlockId?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
};

export type ValidatorMaxAggregates = {
  __typename?: 'ValidatorMaxAggregates';
  /** Maximum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Maximum of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['Int']['output']>;
  /** Maximum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
};

export type ValidatorMinAggregateFilter = {
  accountId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  lastHeartbeatBlockId?: InputMaybe<IntFilter>;
  operatorId?: InputMaybe<IntFilter>;
};

export type ValidatorMinAggregates = {
  __typename?: 'ValidatorMinAggregates';
  /** Minimum of accountId across the matching connection */
  accountId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of id across the matching connection */
  id?: Maybe<Scalars['Int']['output']>;
  /** Minimum of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['Int']['output']>;
  /** Minimum of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['Int']['output']>;
};

export type ValidatorStddevPopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type ValidatorStddevPopulationAggregates = {
  __typename?: 'ValidatorStddevPopulationAggregates';
  /** Population standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorStddevSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type ValidatorStddevSampleAggregates = {
  __typename?: 'ValidatorStddevSampleAggregates';
  /** Sample standard deviation of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample standard deviation of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorSumAggregateFilter = {
  accountId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigIntFilter>;
  operatorId?: InputMaybe<BigIntFilter>;
};

export type ValidatorSumAggregates = {
  __typename?: 'ValidatorSumAggregates';
  /** Sum of accountId across the matching connection */
  accountId: Scalars['BigInt']['output'];
  /** Sum of id across the matching connection */
  id: Scalars['BigInt']['output'];
  /** Sum of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId: Scalars['BigInt']['output'];
  /** Sum of operatorId across the matching connection */
  operatorId: Scalars['BigInt']['output'];
};

/** A filter to be used against many `AuthorityHeartbeat` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyAuthorityHeartbeatFilter = {
  /** Aggregates across related `AuthorityHeartbeat` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityHeartbeatAggregatesFilter>;
  /** Every related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityHeartbeatFilter>;
  /** No related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityHeartbeatFilter>;
  /** Some related `AuthorityHeartbeat` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityHeartbeatFilter>;
};

/** A filter to be used against many `AuthorityMembership` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyAuthorityMembershipFilter = {
  /** Aggregates across related `AuthorityMembership` match the filter criteria. */
  aggregates?: InputMaybe<AuthorityMembershipAggregatesFilter>;
  /** Every related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AuthorityMembershipFilter>;
  /** No related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AuthorityMembershipFilter>;
  /** Some related `AuthorityMembership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AuthorityMembershipFilter>;
};

/** A filter to be used against many `Block` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyBlockFilter = {
  /** Aggregates across related `Block` match the filter criteria. */
  aggregates?: InputMaybe<BlockAggregatesFilter>;
  /** Every related `Block` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<BlockFilter>;
  /** No related `Block` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<BlockFilter>;
  /** Some related `Block` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<BlockFilter>;
};

/** A filter to be used against many `OperatorEpochValidator` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyOperatorEpochValidatorFilter = {
  /** Aggregates across related `OperatorEpochValidator` match the filter criteria. */
  aggregates?: InputMaybe<OperatorEpochValidatorAggregatesFilter>;
  /** Every related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorEpochValidatorFilter>;
  /** No related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorEpochValidatorFilter>;
  /** Some related `OperatorEpochValidator` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorEpochValidatorFilter>;
};

/** A filter to be used against many `OperatorValidatorLink` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyOperatorValidatorLinkFilter = {
  /** Aggregates across related `OperatorValidatorLink` match the filter criteria. */
  aggregates?: InputMaybe<OperatorValidatorLinkAggregatesFilter>;
  /** Every related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<OperatorValidatorLinkFilter>;
  /** No related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<OperatorValidatorLinkFilter>;
  /** Some related `OperatorValidatorLink` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<OperatorValidatorLinkFilter>;
};

/** A filter to be used against many `Penalty` object types. All fields are combined with a logical ‘and.’ */
export type ValidatorToManyPenaltyFilter = {
  /** Aggregates across related `Penalty` match the filter criteria. */
  aggregates?: InputMaybe<PenaltyAggregatesFilter>;
  /** Every related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PenaltyFilter>;
  /** No related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PenaltyFilter>;
  /** Some related `Penalty` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PenaltyFilter>;
};

export type ValidatorVariancePopulationAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type ValidatorVariancePopulationAggregates = {
  __typename?: 'ValidatorVariancePopulationAggregates';
  /** Population variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Population variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

export type ValidatorVarianceSampleAggregateFilter = {
  accountId?: InputMaybe<BigFloatFilter>;
  id?: InputMaybe<BigFloatFilter>;
  lastHeartbeatBlockId?: InputMaybe<BigFloatFilter>;
  operatorId?: InputMaybe<BigFloatFilter>;
};

export type ValidatorVarianceSampleAggregates = {
  __typename?: 'ValidatorVarianceSampleAggregates';
  /** Sample variance of accountId across the matching connection */
  accountId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of id across the matching connection */
  id?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of lastHeartbeatBlockId across the matching connection */
  lastHeartbeatBlockId?: Maybe<Scalars['BigFloat']['output']>;
  /** Sample variance of operatorId across the matching connection */
  operatorId?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `Validator` values. */
export type ValidatorsConnection = {
  __typename?: 'ValidatorsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ValidatorAggregates>;
  /** A list of edges which contains the `Validator` and cursor to aid in pagination. */
  edges: Array<ValidatorsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ValidatorAggregates>>;
  /** A list of `Validator` objects. */
  nodes: Array<Validator>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Validator` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `Validator` values. */
export type ValidatorsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ValidatorGroupBy>;
  having?: InputMaybe<ValidatorHavingInput>;
};

/** A `Validator` edge in the connection. */
export type ValidatorsEdge = {
  __typename?: 'ValidatorsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `Validator` at the end of the edge. */
  node: Validator;
};

/** Methods to use when ordering `Validator`. */
export type ValidatorsOrderBy =
  | 'ACCOUNT_ID_ASC'
  | 'ACCOUNT_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_COUNT_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_COUNT_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_TIMESTAMP_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_TIMESTAMP_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_HEARTBEATS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_COUNT_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_COUNT_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BALANCE_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BALANCE_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EPOCH_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_LOSS_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_LOSS_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_LOSS_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_LOSS_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'AUTHORITY_MEMBERSHIPS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_COUNT_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_COUNT_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_HASH_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_HASH_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_PARENT_HASH_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_PARENT_HASH_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_STATE_ROOT_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_STATE_ROOT_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_TIMESTAMP_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_TIMESTAMP_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_TIMESTAMP_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_TIMESTAMP_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_TIMESTAMP_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_TIMESTAMP_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_REWARD_VALUE_USD_DESC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'BLOCKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'CFE_VERSION_ID_ASC'
  | 'CFE_VERSION_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LAST_HEARTBEAT_BLOCK_ID_ASC'
  | 'LAST_HEARTBEAT_BLOCK_ID_DESC'
  | 'NATURAL'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_COUNT_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_COUNT_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AUTHORITY_MEMBERSHIP_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_OPERATOR_EPOCH_ID_DESC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_EPOCH_VALIDATORS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_ID_ASC'
  | 'OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_COUNT_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_COUNT_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_OPERATOR_ID_DESC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'OPERATOR_VALIDATOR_LINKS_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_AVERAGE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_COUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_COUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_REASON_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_REASON_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_DISTINCT_COUNT_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MAX_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_MIN_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_STDDEV_SAMPLE_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_SUM_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_POPULATION_VALIDATOR_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AMOUNT_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_AMOUNT_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BLOCK_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_BLOCK_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EVENT_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_EVENT_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_ASC'
  | 'PENALTIES_BY_VALIDATOR_ID_VARIANCE_SAMPLE_VALIDATOR_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type VolumeResult = HistogramData | WhitespaceData;

export type WhitespaceData = {
  __typename?: 'WhitespaceData';
  time: Scalars['Int']['output'];
};

export type _PrismaMigration = Node & {
  __typename?: '_PrismaMigration';
  appliedStepsCount: Scalars['Int']['output'];
  checksum: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['String']['output'];
  logs?: Maybe<Scalars['String']['output']>;
  migrationName: Scalars['String']['output'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID']['output'];
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  startedAt: Scalars['Datetime']['output'];
};

export type _PrismaMigrationAggregates = {
  __typename?: '_PrismaMigrationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<_PrismaMigrationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<_PrismaMigrationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<_PrismaMigrationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<_PrismaMigrationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<_PrismaMigrationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<_PrismaMigrationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<_PrismaMigrationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<_PrismaMigrationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<_PrismaMigrationVarianceSampleAggregates>;
};

export type _PrismaMigrationAverageAggregates = {
  __typename?: '_PrismaMigrationAverageAggregates';
  /** Mean average of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/**
 * A condition to be used against `_PrismaMigration` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type _PrismaMigrationCondition = {
  /** Checks for equality with the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `checksum` field. */
  checksum?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `logs` field. */
  logs?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `migrationName` field. */
  migrationName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type _PrismaMigrationDistinctCountAggregates = {
  __typename?: '_PrismaMigrationDistinctCountAggregates';
  /** Distinct count of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of checksum across the matching connection */
  checksum?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of logs across the matching connection */
  logs?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of migrationName across the matching connection */
  migrationName?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['BigInt']['output']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']['output']>;
};

/** A filter to be used against `_PrismaMigration` object types. All fields are combined with a logical ‘and.’ */
export type _PrismaMigrationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `appliedStepsCount` field. */
  appliedStepsCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `checksum` field. */
  checksum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `finishedAt` field. */
  finishedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `logs` field. */
  logs?: InputMaybe<StringFilter>;
  /** Filter by the object’s `migrationName` field. */
  migrationName?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<_PrismaMigrationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<_PrismaMigrationFilter>>;
  /** Filter by the object’s `rolledBackAt` field. */
  rolledBackAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
};

/** Grouping methods for `_PrismaMigration` for usage during aggregation. */
export type _PrismaMigrationGroupBy =
  | 'APPLIED_STEPS_COUNT'
  | 'CHECKSUM'
  | 'FINISHED_AT'
  | 'FINISHED_AT_TRUNCATED_TO_DAY'
  | 'FINISHED_AT_TRUNCATED_TO_HOUR'
  | 'FINISHED_AT_TRUNCATED_TO_MONTH'
  | 'FINISHED_AT_TRUNCATED_TO_WEEK'
  | 'LOGS'
  | 'MIGRATION_NAME'
  | 'ROLLED_BACK_AT'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_DAY'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_HOUR'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_MONTH'
  | 'ROLLED_BACK_AT_TRUNCATED_TO_WEEK'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT_TRUNCATED_TO_MONTH'
  | 'STARTED_AT_TRUNCATED_TO_WEEK';

export type _PrismaMigrationHavingAverageInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingDistinctCountInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `_PrismaMigration` aggregates. */
export type _PrismaMigrationHavingInput = {
  AND?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  OR?: InputMaybe<Array<_PrismaMigrationHavingInput>>;
  average?: InputMaybe<_PrismaMigrationHavingAverageInput>;
  distinctCount?: InputMaybe<_PrismaMigrationHavingDistinctCountInput>;
  max?: InputMaybe<_PrismaMigrationHavingMaxInput>;
  min?: InputMaybe<_PrismaMigrationHavingMinInput>;
  stddevPopulation?: InputMaybe<_PrismaMigrationHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<_PrismaMigrationHavingStddevSampleInput>;
  sum?: InputMaybe<_PrismaMigrationHavingSumInput>;
  variancePopulation?: InputMaybe<_PrismaMigrationHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<_PrismaMigrationHavingVarianceSampleInput>;
};

export type _PrismaMigrationHavingMaxInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingMinInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevPopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingStddevSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingSumInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVariancePopulationInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationHavingVarianceSampleInput = {
  appliedStepsCount?: InputMaybe<HavingIntFilter>;
  finishedAt?: InputMaybe<HavingDatetimeFilter>;
  rolledBackAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type _PrismaMigrationMaxAggregates = {
  __typename?: '_PrismaMigrationMaxAggregates';
  /** Maximum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Maximum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Maximum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationMinAggregates = {
  __typename?: '_PrismaMigrationMinAggregates';
  /** Minimum of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['Int']['output']>;
  /** Minimum of finishedAt across the matching connection */
  finishedAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of rolledBackAt across the matching connection */
  rolledBackAt?: Maybe<Scalars['Datetime']['output']>;
  /** Minimum of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['Datetime']['output']>;
};

export type _PrismaMigrationStddevPopulationAggregates = {
  __typename?: '_PrismaMigrationStddevPopulationAggregates';
  /** Population standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationStddevSampleAggregates = {
  __typename?: '_PrismaMigrationStddevSampleAggregates';
  /** Sample standard deviation of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationSumAggregates = {
  __typename?: '_PrismaMigrationSumAggregates';
  /** Sum of appliedStepsCount across the matching connection */
  appliedStepsCount: Scalars['BigInt']['output'];
};

export type _PrismaMigrationVariancePopulationAggregates = {
  __typename?: '_PrismaMigrationVariancePopulationAggregates';
  /** Population variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

export type _PrismaMigrationVarianceSampleAggregates = {
  __typename?: '_PrismaMigrationVarianceSampleAggregates';
  /** Sample variance of appliedStepsCount across the matching connection */
  appliedStepsCount?: Maybe<Scalars['BigFloat']['output']>;
};

/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnection = {
  __typename?: '_PrismaMigrationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<_PrismaMigrationAggregates>;
  /** A list of edges which contains the `_PrismaMigration` and cursor to aid in pagination. */
  edges: Array<_PrismaMigrationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<_PrismaMigrationAggregates>>;
  /** A list of `_PrismaMigration` objects. */
  nodes: Array<_PrismaMigration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `_PrismaMigration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};


/** A connection to a list of `_PrismaMigration` values. */
export type _PrismaMigrationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<_PrismaMigrationGroupBy>;
  having?: InputMaybe<_PrismaMigrationHavingInput>;
};

/** A `_PrismaMigration` edge in the connection. */
export type _PrismaMigrationsEdge = {
  __typename?: '_PrismaMigrationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `_PrismaMigration` at the end of the edge. */
  node: _PrismaMigration;
};

/** Methods to use when ordering `_PrismaMigration`. */
export type _PrismaMigrationsOrderBy =
  | 'APPLIED_STEPS_COUNT_ASC'
  | 'APPLIED_STEPS_COUNT_DESC'
  | 'CHECKSUM_ASC'
  | 'CHECKSUM_DESC'
  | 'FINISHED_AT_ASC'
  | 'FINISHED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LOGS_ASC'
  | 'LOGS_DESC'
  | 'MIGRATION_NAME_ASC'
  | 'MIGRATION_NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLLED_BACK_AT_ASC'
  | 'ROLLED_BACK_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC';

export type GetAccountTypeQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetAccountTypeQuery = { __typename?: 'Query', account?: { __typename?: 'Account', lp?: { __typename?: 'LiquidityProvider', id: number } | null, broker?: { __typename?: 'Broker', id: number } | null, validator?: { __typename?: 'Validator', id: number } | null, operator?: { __typename?: 'Operator', id: number } | null } | null };

export type PaginatedPenaltiesQueryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  startBlockId: Scalars['Int']['input'];
}>;


export type PaginatedPenaltiesQueryQuery = { __typename?: 'Query', allPenalties?: { __typename?: 'PenaltiesConnection', totalCount: number, edges: Array<{ __typename?: 'PenaltiesEdge', node: { __typename?: 'Penalty', id: number, reason: string, amount: number, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, block: { __typename?: 'Block', id: number, timestamp: string } } }> } | null };

export type GetTotalBlockCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalBlockCountQuery = { __typename?: 'Query', latestBlock?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', totalCount: number }> } | null };

export type ArchiveInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchiveInfoQuery = { __typename?: 'Query', archiveInfo: { __typename?: 'ArchiveInfo', lastArchivedBlock?: number | null } };

export type GetAllBlocksQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllBlocksQuery = { __typename?: 'Query', allBlocks?: { __typename?: 'BlocksConnection', pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor?: any | null, hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'BlocksEdge', node: { __typename?: 'Block', id: number, timestamp: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null } }> } | null };

export type GetBlockCountsQueryVariables = Exact<{
  startBlockHeight: Scalars['Int']['input'];
  endBlockHeight: Scalars['Int']['input'];
}>;


export type GetBlockCountsQuery = { __typename?: 'Query', getBlockCounts: Array<{ __typename?: 'BlockCounts', blockHeight: number, extrinsicsCount: number, eventsCount: number }> };

export type GetBlocksEventsAndExtrinsicsCountQueryVariables = Exact<{
  startBlockHeight: Scalars['Int']['input'];
  endBlockHeight: Scalars['Int']['input'];
}>;


export type GetBlocksEventsAndExtrinsicsCountQuery = { __typename?: 'Query', getBlocksDetails: { __typename?: 'BlocksDetails', blocks: Array<{ __typename?: 'BlockDetails', extrinsicsCount: number, eventsCount: number, blockHeight: number }> } };

export type GetBlockByHashQueryVariables = Exact<{
  hash?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetBlockByHashQuery = { __typename?: 'Query', blocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number, hash: string, timestamp: string, stateRoot: string, parentHash: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null }> } | null, eventsAndExtrinsics: { __typename?: 'BlockDetails', extrinsics?: Array<{ __typename?: 'ExtrinsicInfo', callName?: string | null, callOrigin?: any | null, hash: string, indexInBlock: number, callArgs?: any | null, blockHeight: number, signature?: any | null }> | null, events?: Array<{ __typename?: 'EventInfo', indexInBlock: number, phase: string, name: string, args?: any | null, extrinsicHash?: string | null, blockHeight: number }> | null }, lastBlocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null };

export type GetBlockByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBlockByIdQuery = { __typename?: 'Query', blocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number, hash: string, timestamp: string, stateRoot: string, parentHash: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null }> } | null, eventsAndExtrinsics: { __typename?: 'BlockDetails', extrinsics?: Array<{ __typename?: 'ExtrinsicInfo', callName?: string | null, callOrigin?: any | null, hash: string, indexInBlock: number, callArgs?: any | null, blockHeight: number, signature?: any | null }> | null, events?: Array<{ __typename?: 'EventInfo', indexInBlock: number, phase: string, name: string, args?: any | null, extrinsicHash?: string | null, blockHeight: number }> | null }, lastBlocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null };

export type GetBrokerAccountMetaDataQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  commissionStartDate: Scalars['Datetime']['input'];
  commissionEndDate: Scalars['Datetime']['input'];
}>;


export type GetBrokerAccountMetaDataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', alias?: string | null, affiliates: { __typename?: 'SwapChannelBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapChannelBeneficiary', id: number }> }, submitters: { __typename?: 'SwapChannelBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapChannelBeneficiary', id: number }> }, beneficiary: { __typename?: 'SwapRequestBeneficiariesConnection', aggregates?: { __typename?: 'SwapRequestBeneficiaryAggregates', max?: { __typename?: 'SwapRequestBeneficiaryMaxAggregates', brokerCommissionRateBps?: number | null } | null, min?: { __typename?: 'SwapRequestBeneficiaryMinAggregates', brokerCommissionRateBps?: number | null } | null } | null }, broker?: { __typename?: 'Broker', eventByRegistratonEventId?: { __typename?: 'Event', blockId: number, indexInBlock: number } | null } | null } | null };

export type GetBrokerFeeAndWithdrawalDataQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<BrokerFeeAndWithdrawalV2Filter>;
  orderBy?: InputMaybe<Array<BrokerFeeAndWithdrawalV2SOrderBy> | BrokerFeeAndWithdrawalV2SOrderBy>;
}>;


export type GetBrokerFeeAndWithdrawalDataQuery = { __typename?: 'Query', account?: { __typename?: 'Account', broker?: { __typename?: 'Broker', feesAndWithdrawals: { __typename?: 'BrokerFeeAndWithdrawalV2SConnection', totalCount: number, edges: Array<{ __typename?: 'BrokerFeeAndWithdrawalV2SEdge', node: { __typename?: 'BrokerFeeAndWithdrawalV2', amount: string, asset: ChainflipAsset, eventId: string, type: string, valueUsd: string, brokerCommissionRateBps?: number | null, brokerByAffiliatedWithBrokerId?: { __typename?: 'Broker', accountByAccountId: { __typename?: 'Account', idSs58: string, alias?: string | null } } | null, event: { __typename?: 'Event', blockId: number, indexInBlock: number, block: { __typename?: 'Block', timestamp: string }, swaps: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', swapRequest: { __typename?: 'SwapRequest', nativeId: string, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', id: number, idSs58: string, alias?: string | null } } | null } }> } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } } | null } | null };

export type ChannelDepositInfoFragment = { __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, fee?: string | null, asset: ChainflipAsset, depositValueUsd: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', id: string, indexInBlock: number }, block: { __typename?: 'Block', id: number, timestamp: string }, txRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } };

export type LiquidityDepositChannelInfoFragment = { __typename?: 'LiquidityDepositChannel', id: number, asset: ChainflipAsset, chain: ChainflipChain, depositAddress: string, channelId: string, maxBoostFeeBps: number, issuedBlockId: number, sourceChainExpiryBlock: string, isExpired: boolean, openingFeePaid: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, deposits: { __typename?: 'LiquidityDepositsConnection', nodes: Array<{ __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, fee?: string | null, asset: ChainflipAsset, depositValueUsd: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', id: string, indexInBlock: number }, block: { __typename?: 'Block', id: number, timestamp: string }, txRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } }> }, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, block: { __typename?: 'Block', timestamp: string, id: number }, event: { __typename?: 'Event', id: string, indexInBlock: number } };

export type SwapChannelInfoFragment = { __typename?: 'SwapChannel', issuedBlockId: number, id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, beneficiaries: { __typename?: 'SwapChannelBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapChannelBeneficiary', id: number, brokerCommissionRateBps: number, type: BrokerType, commissions: { __typename?: 'SwapCommissionsConnection', groupedAggregates?: Array<{ __typename?: 'SwapCommissionAggregates', asset?: Array<string> | null, sum?: { __typename?: 'SwapCommissionSumAggregates', valueUsd: string, amount: string } | null }> | null }, account: { __typename?: 'Account', alias?: string | null, idSs58: string, broker?: { __typename?: 'Broker', id: number } | null } }> }, swapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null } | null, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null }> }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } };

export type AccountCreationDepositChannelOverviewFragment = { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } };

export type AccountCreationDepositChannelInfoFragment = { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, swapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null } | null, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null }> }, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, deposits: { __typename?: 'LiquidityDepositsConnection', nodes: Array<{ __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, fee?: string | null, asset: ChainflipAsset, depositValueUsd: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', id: string, indexInBlock: number }, block: { __typename?: 'Block', id: number, timestamp: string }, txRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } }> }, broker: { __typename?: 'Broker', id: number, account: { __typename?: 'Account', alias?: string | null, idSs58: string } }, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } };

export type GetChannelQueryVariables = Exact<{
  channelId: Scalars['BigInt']['input'];
  chain: ChainflipChain;
  issuedBlockId: Scalars['Int']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, swapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null } | null, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null }> }, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, deposits: { __typename?: 'LiquidityDepositsConnection', nodes: Array<{ __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, fee?: string | null, asset: ChainflipAsset, depositValueUsd: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', id: string, indexInBlock: number }, block: { __typename?: 'Block', id: number, timestamp: string }, txRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } }> }, broker: { __typename?: 'Broker', id: number, account: { __typename?: 'Account', alias?: string | null, idSs58: string } }, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, liquidityChannelChannel?: { __typename?: 'LiquidityDepositChannel', id: number, asset: ChainflipAsset, chain: ChainflipChain, depositAddress: string, channelId: string, maxBoostFeeBps: number, issuedBlockId: number, sourceChainExpiryBlock: string, isExpired: boolean, openingFeePaid: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, deposits: { __typename?: 'LiquidityDepositsConnection', nodes: Array<{ __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, fee?: string | null, asset: ChainflipAsset, depositValueUsd: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', id: string, indexInBlock: number }, block: { __typename?: 'Block', id: number, timestamp: string }, txRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } }> }, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, block: { __typename?: 'Block', timestamp: string, id: number }, event: { __typename?: 'Event', id: string, indexInBlock: number } } | null, swapChannel?: { __typename?: 'SwapChannel', issuedBlockId: number, id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null }> }, beneficiaries: { __typename?: 'SwapChannelBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapChannelBeneficiary', id: number, brokerCommissionRateBps: number, type: BrokerType, commissions: { __typename?: 'SwapCommissionsConnection', groupedAggregates?: Array<{ __typename?: 'SwapCommissionAggregates', asset?: Array<string> | null, sum?: { __typename?: 'SwapCommissionSumAggregates', valueUsd: string, amount: string } | null }> | null }, account: { __typename?: 'Account', alias?: string | null, idSs58: string, broker?: { __typename?: 'Broker', id: number } | null } }> }, swapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null } | null, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null }> }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null };

export type GetActiveAuthorityInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveAuthorityInfoQuery = { __typename?: 'Query', epoch?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number, startBlockId: number, endBlockId?: number | null, memberships: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', id: number, bid: string, reward: string, validator: { __typename?: 'Validator', id: number, cfeVersion: string, account: { __typename?: 'Account', id: number, alias?: string | null, idSs58: string }, totalMemberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number } } }> }, slashedEvents: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', accountId?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null }> | null } }> } | null, lastBlock?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null };

export type GetValidatorLatestBlockInfoQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetValidatorLatestBlockInfoQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', id: number, alias?: string | null, idSs58: string, boundRedeemAddress?: string | null, validator?: { __typename?: 'Validator', id: number, lastHeartbeatBlockId?: number | null, cfeVersion: string, membership: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', epochId: number }> }, operator?: { __typename?: 'Operator', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null } | null }> } | null };

export type GetEventsByBlockIdAndIndexQueryVariables = Exact<{
  blockId: Scalars['Int']['input'];
  index: Scalars['Int']['input'];
}>;


export type GetEventsByBlockIdAndIndexQuery = { __typename?: 'Query', events?: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', metadata: { __typename?: 'Metadatum', name: string, chainspec: string } }> } | null, eventWithExtrinsicHash?: { __typename?: 'EventInfo', extrinsicHash?: string | null, args?: any | null } | null };

export type GetExtrinsicSuccessMetadataIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExtrinsicSuccessMetadataIdQuery = { __typename?: 'Query', metadata?: { __typename?: 'MetadataConnection', nodes: Array<{ __typename?: 'Metadatum', id: number }> } | null };

export type GetRecentEventsQueryVariables = Exact<{
  excludeMetadataId: Scalars['Int']['input'];
  first: Scalars['Int']['input'];
}>;


export type GetRecentEventsQuery = { __typename?: 'Query', blocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number, eventsByBlockId: { __typename?: 'EventsConnection', nodes: Array<{ __typename?: 'Event', blockId: number, indexInBlock: number, metadata: { __typename?: 'Metadatum', name: string } }> } }> } | null };

export type GetExtrinsicByHashQueryVariables = Exact<{
  hash: Scalars['String']['input'];
}>;


export type GetExtrinsicByHashQuery = { __typename?: 'Query', extrinsic?: { __typename?: 'ExtrinsicInfo', callName?: string | null, callOrigin?: any | null, hash: string, indexInBlock: number, callArgs?: any | null } | null };

export type PenaltyFragment = { __typename?: 'Penalty', id: number, reason: string, amount: number, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, block: { __typename?: 'Block', id: number, timestamp: string } };

export type BlockListBlockFragment = { __typename?: 'Block', id: number, timestamp: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null };

export type BlockWithValidatorFragment = { __typename?: 'Block', id: number, hash: string, timestamp: string, stateRoot: string, parentHash: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null };

export type EpochWithMembershipsFragment = { __typename?: 'Epoch', id: number, startBlockId: number, endBlockId?: number | null, memberships: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', id: number, bid: string, reward: string, validator: { __typename?: 'Validator', id: number, cfeVersion: string, account: { __typename?: 'Account', id: number, alias?: string | null, idSs58: string }, totalMemberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number } } }> }, slashedEvents: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', accountId?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null }> | null } };

export type AccountWithPossibleValidatorFragment = { __typename?: 'Account', id: number, alias?: string | null, idSs58: string, boundRedeemAddress?: string | null, validator?: { __typename?: 'Validator', id: number, lastHeartbeatBlockId?: number | null, cfeVersion: string, membership: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', epochId: number }> }, operator?: { __typename?: 'Operator', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null } | null };

export type EventFragment = { __typename?: 'Event', id: string, metadata: { __typename?: 'Metadatum', id: number, name: string, label: string } };

export type SwapRequestOverviewFragment = { __typename?: 'SwapRequest', id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null } | null, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null };

export type SwapFeeFragment = { __typename?: 'SwapFee', valueUsd?: string | null, amount: string, asset: ChainflipAsset, type: SwapFeeType };

export type IgnoredEgressFragment = { __typename?: 'IgnoredEgress', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, error?: { __typename?: 'StateChainError', docs: string, name: string } | null };

export type SwapRequestFragment = { __typename?: 'SwapRequest', sourceChain: ChainflipChain, destinationChain: ChainflipChain, fokMaxOraclePriceSlippageBps?: string | null, oraclePriceDeltaBps?: string | null, oraclePriceDeltaExFeesBps?: string | null, id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, ignoredEgress?: { __typename?: 'IgnoredEgress', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, error?: { __typename?: 'StateChainError', docs: string, name: string } | null } | null, ignoredRefundEgress?: { __typename?: 'IgnoredEgress', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, error?: { __typename?: 'StateChainError', docs: string, name: string } | null } | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, fees: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', valueUsd?: string | null, amount: string, asset: ChainflipAsset, type: SwapFeeType }> }, networkFee?: { __typename?: 'BoostNetworkFeeSplit', amount: string, asset: ChainflipAsset, valueUsd?: string | null } | null, swaps: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', nativeId: string, swapInputAmount: string, swapInputValueUsd: string, intermediateAmount?: string | null, intermediateValueUsd?: string | null, swapOutputAmount?: string | null, swapOutputValueUsd?: string | null, retryCount: number, swapAbortedReason?: SwapFailureReason | null, swapRescheduledReason?: SwapFailureReason | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, scheduledEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, executedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, fees: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', valueUsd?: string | null, amount: string, asset: ChainflipAsset, type: SwapFeeType }> } }> }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, refundAmount?: string | null, outputValueUsd?: string | null, refundValueUsd?: string | null, creditedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, refundedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null, accountFundingEvent?: { __typename?: 'AccountFundingEvent', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } } | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null };

export type LiquidityBalanceEventFragment = { __typename?: 'LiquidityBalanceEvent', eventId: string, amount: string, asset: ChainflipAsset, txRef?: string | null, valueUsd: string, effectiveBoostFeeBps?: number | null, block: { __typename?: 'Block', timestamp: string }, withdrawals: { __typename?: 'LiquidityWithdrawalsConnection', nodes: Array<{ __typename?: 'LiquidityWithdrawal', nativeEgressId: string, chain: ChainflipChain }> }, depositChannel?: { __typename?: 'LiquidityDepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number, maxBoostFeeBps: number } | null, accountCreationDepositChannel?: { __typename?: 'AccountCreationDepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number, maxBoostFeeBps: number } | null, broadcast?: { __typename?: 'Broadcast', id: number, broadcastSuccessEventId?: string | null } | null };

export type RefundAddressesFragment = { __typename?: 'LiquidityProvider', bitcoinRefundAddress?: string | null, ethereumRefundAddress?: string | null, polkadotRefundAddress?: string | null, arbitrumRefundAddress?: string | null, solanaRefundAddress?: string | null, assethubRefundAddress?: string | null, tronRefundAddress?: string | null, bscRefundAddress?: string | null };

export type BlockEventsAndExtrinsicsFragment = { __typename?: 'BlockDetails', extrinsics?: Array<{ __typename?: 'ExtrinsicInfo', callName?: string | null, callOrigin?: any | null, hash: string, indexInBlock: number, callArgs?: any | null, blockHeight: number, signature?: any | null }> | null, events?: Array<{ __typename?: 'EventInfo', indexInBlock: number, phase: string, name: string, args?: any | null, extrinsicHash?: string | null, blockHeight: number }> | null };

export type GetLastLiquidityDepositQueryVariables = Exact<{
  idSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLastLiquidityDepositQuery = { __typename?: 'Query', deposits?: { __typename?: 'LiquidityDepositsConnection', groupedAggregates?: Array<{ __typename?: 'LiquidityDepositAggregates', asset?: Array<string> | null, max?: { __typename?: 'LiquidityDepositMaxAggregates', timestamp?: string | null } | null }> | null } | null };

export type GetAllOpenLpDepositChannelsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllOpenLpDepositChannelsQuery = { __typename?: 'Query', allLiquidityDepositChannels?: { __typename?: 'LiquidityDepositChannelsConnection', totalCount: number, edges: Array<{ __typename?: 'LiquidityDepositChannelsEdge', node: { __typename?: 'LiquidityDepositChannel', id: number, isExpired: boolean, chain: ChainflipChain, issuedBlockId: number, channelId: string, maxBoostFeeBps: number, asset: ChainflipAsset, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, deposits: { __typename?: 'LiquidityDepositsConnection', aggregates?: { __typename?: 'LiquidityDepositAggregates', sum?: { __typename?: 'LiquidityDepositSumAggregates', depositAmount: string, depositValueUsd: string } | null } | null }, issuedEvent: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } | null };

export type GetLpAccountWithRefundAddressesQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetLpAccountWithRefundAddressesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', alias?: string | null, lp?: { __typename?: 'LiquidityProvider', bitcoinRefundAddress?: string | null, ethereumRefundAddress?: string | null, polkadotRefundAddress?: string | null, arbitrumRefundAddress?: string | null, solanaRefundAddress?: string | null, assethubRefundAddress?: string | null, tronRefundAddress?: string | null, bscRefundAddress?: string | null } | null } | null };

export type RecentPoolOrderEventFragment = { __typename?: 'RecentPoolOrderEvent', id: number, eventType: PoolEventType, orderType: PoolOrderType, baseAmount: string, baseAsset: ChainflipAsset, quoteAmount: string, maximumRate: string, minimumRate: string, timestamp: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, event: { __typename?: 'Event', indexInBlock: number, blockId: number } };

export type GetPoolAggregatesByDateQueryVariables = Exact<{
  startingTimestamp: Scalars['Datetime']['input'];
  endingTimestamp?: InputMaybe<Scalars['Datetime']['input']>;
}>;


export type GetPoolAggregatesByDateQuery = { __typename?: 'Query', poolSwaps?: { __typename?: 'PoolSwapsConnection', groupedAggregates?: Array<{ __typename?: 'PoolSwapAggregates', fromAssetToAsset?: Array<string> | null, sum?: { __typename?: 'PoolSwapSumAggregates', toValueUsd: string } | null }> | null } | null };

export type GetBurnInfoQueryVariables = Exact<{
  maxTimestamp: Scalars['Datetime']['input'];
}>;


export type GetBurnInfoQuery = { __typename?: 'Query', historicalBurn?: { __typename?: 'BurnsConnection', aggregates?: { __typename?: 'BurnAggregates', sum?: { __typename?: 'BurnSumAggregates', totalAmount: string } | null } | null } | null, currentBurn?: { __typename?: 'BurnsConnection', aggregates?: { __typename?: 'BurnAggregates', sum?: { __typename?: 'BurnSumAggregates', totalAmount: string } | null } | null } | null };

export type SearchFailedDepositFragment = { __typename?: 'FailedDeposit', swapChannel?: { __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string } | null, liquidityChannel?: { __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null };

export type SearchSwapChannelFragment = { __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string };

export type SearchLiquidityChannelFragment = { __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string };

export type SearchAccountCreationChannelFragment = { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string };

export type SearchAccountFragment = { __typename?: 'Account', idSs58: string, alias?: string | null, validator?: { __typename?: 'Validator', id: number } | null, broker?: { __typename?: 'Broker', id: number } | null, lp?: { __typename?: 'LiquidityProvider', id: number, isTradingStrategy: boolean } | null, operator?: { __typename?: 'Operator', id: number } | null };

export type GetStringSearchResultsQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  swapFilter: SwapRequestFilter;
  swapChannelFilter: SwapChannelFilter;
  liquidityChannelFilter: LiquidityDepositChannelFilter;
  accountCreationChannelFilter: AccountCreationDepositChannelFilter;
  accountFilter: AccountFilter;
}>;


export type GetStringSearchResultsQuery = { __typename?: 'Query', swaps?: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', nativeId: string }> } | null, swapChannels?: { __typename?: 'SwapChannelsConnection', nodes: Array<{ __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string }> } | null, liquidityChannels?: { __typename?: 'LiquidityDepositChannelsConnection', nodes: Array<{ __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null, accountCreationChannels?: { __typename?: 'AccountCreationDepositChannelsConnection', nodes: Array<{ __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null, blocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null, txRefs?: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', swap?: { __typename?: 'SwapRequest', nativeId: string } | null, failedDeposit?: { __typename?: 'FailedDeposit', swapChannel?: { __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string } | null, liquidityChannel?: { __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null } | null, broadcast?: { __typename?: 'Broadcast', egress: { __typename?: 'EgressesConnection', nodes: Array<{ __typename?: 'Egress', swapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', nativeId: string }> }, refundedSwapRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', nativeId: string }> } }> }, liquidityWithdrawals: { __typename?: 'LiquidityWithdrawalsConnection', nodes: Array<{ __typename?: 'LiquidityWithdrawal', nativeEgressId: string, chain: ChainflipChain }> }, failedDeposits: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', swapChannel?: { __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string } | null, liquidityChannel?: { __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null }> } } | null, lpDeposit?: { __typename?: 'LiquidityDeposit', channel?: { __typename?: 'LiquidityDepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number } | null } | null }> } | null, accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, alias?: string | null, validator?: { __typename?: 'Validator', id: number } | null, broker?: { __typename?: 'Broker', id: number } | null, lp?: { __typename?: 'LiquidityProvider', id: number, isTradingStrategy: boolean } | null, operator?: { __typename?: 'Operator', id: number } | null }> } | null, extrinsic?: { __typename?: 'ExtrinsicInfo', blockHeight: number, indexInBlock: number } | null, brokerVaultAddresses?: { __typename?: 'BrokerVaultAddressesConnection', nodes: Array<{ __typename?: 'BrokerVaultAddress', broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } } }> } | null };

export type GetIndexInBlockSearchResultsQueryVariables = Exact<{
  blockId: Scalars['Int']['input'];
  indexInBlock: Scalars['Int']['input'];
}>;


export type GetIndexInBlockSearchResultsQuery = { __typename?: 'Query', event?: { __typename?: 'EventInfo', blockHeight: number, indexInBlock: number } | null, extrinsic?: { __typename?: 'ExtrinsicInfo', blockHeight: number, indexInBlock: number } | null };

export type GetNumericSearchResultsQueryVariables = Exact<{
  intValue: Scalars['Int']['input'];
  bigIntValue: Scalars['BigInt']['input'];
}>;


export type GetNumericSearchResultsQuery = { __typename?: 'Query', swaps?: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', nativeId: string }> } | null, blocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null, epochs?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number }> } | null };

export type GetChannelSearchResultsQueryVariables = Exact<{
  issuedBlockId: Scalars['Int']['input'];
  chain: ChainflipChain;
  channelId: Scalars['BigInt']['input'];
}>;


export type GetChannelSearchResultsQuery = { __typename?: 'Query', swapChannels?: { __typename?: 'SwapChannelsConnection', nodes: Array<{ __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string }> } | null, lpChannels?: { __typename?: 'LiquidityDepositChannelsConnection', nodes: Array<{ __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null, accountCreationChannels?: { __typename?: 'AccountCreationDepositChannelsConnection', nodes: Array<{ __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null };

export type GetSearchResultCountsQueryVariables = Exact<{
  swapFilter: SwapRequestFilter;
  swapChannelFilter: SwapChannelFilter;
  liquidityChannelFilter: LiquidityDepositChannelFilter;
  accountCreationChannelFilter: AccountCreationDepositChannelFilter;
  validatorFilter: AccountFilter;
  brokerFilter: AccountFilter;
  liquidityProviderFilter: AccountFilter;
  operatorFilter: AccountFilter;
}>;


export type GetSearchResultCountsQuery = { __typename?: 'Query', swaps?: { __typename?: 'SwapRequestsConnection', totalCount: number } | null, swapChannels?: { __typename?: 'SwapChannelsConnection', totalCount: number } | null, liquidityChannels?: { __typename?: 'LiquidityDepositChannelsConnection', totalCount: number } | null, accountCreationChannels?: { __typename?: 'AccountCreationDepositChannelsConnection', totalCount: number } | null, validators?: { __typename?: 'AccountsConnection', totalCount: number } | null, brokers?: { __typename?: 'AccountsConnection', totalCount: number } | null, liquidityProviders?: { __typename?: 'AccountsConnection', totalCount: number } | null, operators?: { __typename?: 'AccountsConnection', totalCount: number } | null };

export type GetSwapSearchResultsPageQueryVariables = Exact<{
  filter: SwapRequestFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSwapSearchResultsPageQuery = { __typename?: 'Query', allSwapRequests?: { __typename?: 'SwapRequestsConnection', totalCount: number, nodes: Array<{ __typename?: 'SwapRequest', nativeId: string }> } | null };

export type GetSwapChannelSearchResultsPageQueryVariables = Exact<{
  filter: SwapChannelFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSwapChannelSearchResultsPageQuery = { __typename?: 'Query', allSwapChannels?: { __typename?: 'SwapChannelsConnection', totalCount: number, nodes: Array<{ __typename?: 'SwapChannel', issuedBlockId: number, sourceChain: ChainflipChain, channelId: string }> } | null };

export type GetLiquidityChannelSearchResultsPageQueryVariables = Exact<{
  filter: LiquidityDepositChannelFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLiquidityChannelSearchResultsPageQuery = { __typename?: 'Query', allLiquidityDepositChannels?: { __typename?: 'LiquidityDepositChannelsConnection', totalCount: number, nodes: Array<{ __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null };

export type GetAccountCreationChannelSearchResultsPageQueryVariables = Exact<{
  filter: AccountCreationDepositChannelFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAccountCreationChannelSearchResultsPageQuery = { __typename?: 'Query', allAccountCreationDepositChannels?: { __typename?: 'AccountCreationDepositChannelsConnection', totalCount: number, nodes: Array<{ __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string }> } | null };

export type GetAccountSearchResultsPageQueryVariables = Exact<{
  filter: AccountFilter;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAccountSearchResultsPageQuery = { __typename?: 'Query', allAccounts?: { __typename?: 'AccountsConnection', totalCount: number, nodes: Array<{ __typename?: 'Account', idSs58: string, alias?: string | null }> } | null };

export type GetSwapByNativeIdQueryVariables = Exact<{
  nativeId: Scalars['BigInt']['input'];
}>;


export type GetSwapByNativeIdQuery = { __typename?: 'Query', swapRequest?: { __typename?: 'SwapRequest', sourceChain: ChainflipChain, destinationChain: ChainflipChain, fokMaxOraclePriceSlippageBps?: string | null, oraclePriceDeltaBps?: string | null, oraclePriceDeltaExFeesBps?: string | null, id: number, nativeId: string, sourceAsset: ChainflipAsset, depositAmount?: string | null, depositValueUsd?: string | null, destinationAsset: ChainflipAsset, destinationAddress?: string | null, ignoredEgressId?: number | null, effectiveBoostFeeBps?: number | null, ignoredRefundEgressId?: number | null, ccmGasBudget?: string | null, completedEventId?: string | null, type: SwapRequestType, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokRetryDurationBlocks?: number | null, dcaNumberOfChunks: number, dcaChunkIntervalBlocks?: number | null, requestedBlockTimestamp: string, completedBlockTimestamp?: string | null, beneficiaries: { __typename?: 'SwapRequestBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapRequestBeneficiary', id: number, brokerCommissionRateBps: number, type: BrokerType, commissions: { __typename?: 'SwapCommissionsConnection', groupedAggregates?: Array<{ __typename?: 'SwapCommissionAggregates', asset?: Array<string> | null, sum?: { __typename?: 'SwapCommissionSumAggregates', valueUsd: string, amount: string } | null }> | null }, account: { __typename?: 'Account', alias?: string | null, idSs58: string, broker?: { __typename?: 'Broker', id: number } | null } }> }, ignoredEgress?: { __typename?: 'IgnoredEgress', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, error?: { __typename?: 'StateChainError', docs: string, name: string } | null } | null, ignoredRefundEgress?: { __typename?: 'IgnoredEgress', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, error?: { __typename?: 'StateChainError', docs: string, name: string } | null } | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, fees: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', valueUsd?: string | null, amount: string, asset: ChainflipAsset, type: SwapFeeType }> }, networkFee?: { __typename?: 'BoostNetworkFeeSplit', amount: string, asset: ChainflipAsset, valueUsd?: string | null } | null, swaps: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', nativeId: string, swapInputAmount: string, swapInputValueUsd: string, intermediateAmount?: string | null, intermediateValueUsd?: string | null, swapOutputAmount?: string | null, swapOutputValueUsd?: string | null, retryCount: number, swapAbortedReason?: SwapFailureReason | null, swapRescheduledReason?: SwapFailureReason | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, scheduledEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, executedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, fees: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', valueUsd?: string | null, amount: string, asset: ChainflipAsset, type: SwapFeeType }> } }> }, onChainSwapInfo?: { __typename?: 'OnChainSwapInfo', outputAmount?: string | null, refundAmount?: string | null, outputValueUsd?: string | null, refundValueUsd?: string | null, creditedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, refundedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null, accountFundingEvent?: { __typename?: 'AccountFundingEvent', event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } } | null, broker?: { __typename?: 'Broker', account: { __typename?: 'Account', alias?: string | null, idSs58: string } } | null, egress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, refundEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, fallbackEgress?: { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null, executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', swapInputAmount: string, swapInputValueUsd: string, intermediateAmount: string, intermediateValueUsd: string, swapOutputAmount: string, swapOutputValueUsd: string } | null } | null }, channel?: { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', asset: ChainflipAsset, isExpired: boolean, depositAddress: string, issuedBlockId: number, chain: ChainflipChain, channelId: string, maxBoostFeeBps: number, depositChainExpiryBlock: string, refundAddress: string, openingFeePaid: string, issuedEvent: { __typename?: 'Event', indexInBlock: number }, lpAccount: { __typename?: 'Account', idSs58: string }, issuedBlock: { __typename?: 'Block', id: number, timestamp: string } } | null, depositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, preDepositBlock?: { __typename?: 'ForeignChainTracking', stateChainTimestamp: string } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, liquidationSwapInfo?: { __typename?: 'LiquidationSwapInfo', loanId: string, liquidationType?: LiquidationType | null, outputAmount?: string | null, outputValueUsd?: string | null, refundAmount?: string | null, refundValueUsd?: string | null, abortedAtEventId?: string | null, completedAtEventId?: string | null, abortedReason?: LiquidationSwapAbortedReason | null, loanRepaidAmount?: string | null, loanRepaidValueUsd?: string | null, collateralAddedAmount?: string | null, collateralAddedValueUsd?: string | null, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, completedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, borrower: { __typename?: 'Account', idSs58: string }, loanRepaidEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, collateralAddedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null } | null };

export type ChannelInfoFragment = { __typename?: 'SwapChannel', id: number, channelId: string, depositAddress: string, destinationAddress: string, destinationChain: ChainflipChain, issuedEventId: string, sourceChain: ChainflipChain, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, maxBoostFeeBps: number, isExpired: boolean, sourceChainExpiryBlock: string, openingFeePaid: string, fokRefundAddress?: string | null, fokMinPriceX128?: string | null, fokMaxOraclePriceSlippageBps?: string | null, dcaNumberOfChunks: number, issuedBlock: { __typename?: 'Block', id: number, timestamp: string }, issuedEvent: { __typename?: 'Event', indexInBlock: number } };

export type FailedDepositInfoFragment = { __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broadcast?: { __typename?: 'Broadcast', broadcastSuccessEventId?: string | null, refs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null };

export type OpenChannelFragment = { __typename?: 'SwapChannel', id: number, totalBrokerCommissionBps: number, channelId: string, destinationAddress: string, destinationAsset: ChainflipAsset, destinationChain: ChainflipChain, sourceAsset: ChainflipAsset, sourceChain: ChainflipChain, maxBoostFeeBps: number, fokRefundAddress?: string | null, dcaNumberOfChunks: number, issuedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, swapsRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', intermediateValueUsd: string, swapOutputValueUsd: string } | null } | null } }> } };

export type GetOpenSwapChannelsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOpenSwapChannelsQuery = { __typename?: 'Query', channels?: { __typename?: 'SwapChannelsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor?: any | null, hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'SwapChannelsEdge', node: { __typename?: 'SwapChannel', id: number, totalBrokerCommissionBps: number, channelId: string, destinationAddress: string, destinationAsset: ChainflipAsset, destinationChain: ChainflipChain, sourceAsset: ChainflipAsset, sourceChain: ChainflipChain, maxBoostFeeBps: number, fokRefundAddress?: string | null, dcaNumberOfChunks: number, issuedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, swapsRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', intermediateValueUsd: string, swapOutputValueUsd: string } | null } | null } }> } } }> } | null };

export type BrokerSwapChannelFragment = { __typename?: 'SwapChannel', isExpired: boolean, openingFeePaid: string, id: number, totalBrokerCommissionBps: number, channelId: string, destinationAddress: string, destinationAsset: ChainflipAsset, destinationChain: ChainflipChain, sourceAsset: ChainflipAsset, sourceChain: ChainflipChain, maxBoostFeeBps: number, fokRefundAddress?: string | null, dcaNumberOfChunks: number, issuedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, swapsRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', intermediateValueUsd: string, swapOutputValueUsd: string } | null } | null } }> } };

export type GetSwapChannelsByBrokerIdQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSwapChannelsByBrokerIdQuery = { __typename?: 'Query', account?: { __typename?: 'Account', broker?: { __typename?: 'Broker', channels: { __typename?: 'SwapChannelsConnection', totalCount: number, edges: Array<{ __typename?: 'SwapChannelsEdge', node: { __typename?: 'SwapChannel', isExpired: boolean, openingFeePaid: string, id: number, totalBrokerCommissionBps: number, channelId: string, destinationAddress: string, destinationAsset: ChainflipAsset, destinationChain: ChainflipChain, sourceAsset: ChainflipAsset, sourceChain: ChainflipChain, maxBoostFeeBps: number, fokRefundAddress?: string | null, dcaNumberOfChunks: number, issuedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, swapsRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', intermediateValueUsd: string, swapOutputValueUsd: string } | null } | null } }> } } }> } } | null } | null };

export type GetSwapChannelsByAffiliateBrokerIdQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetSwapChannelsByAffiliateBrokerIdQuery = { __typename?: 'Query', account?: { __typename?: 'Account', beneficiaryChannels: { __typename?: 'SwapChannelBeneficiariesConnection', totalCount: number, edges: Array<{ __typename?: 'SwapChannelBeneficiariesEdge', node: { __typename?: 'SwapChannelBeneficiary', swapChannel: { __typename?: 'SwapChannel', isExpired: boolean, openingFeePaid: string, id: number, totalBrokerCommissionBps: number, channelId: string, destinationAddress: string, destinationAsset: ChainflipAsset, destinationChain: ChainflipChain, sourceAsset: ChainflipAsset, sourceChain: ChainflipChain, maxBoostFeeBps: number, fokRefundAddress?: string | null, dcaNumberOfChunks: number, issuedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, swapsRequests: { __typename?: 'SwapRequestsConnection', nodes: Array<{ __typename?: 'SwapRequest', executedSwaps: { __typename?: 'SwapsConnection', totalCount: number, aggregates?: { __typename?: 'SwapAggregates', sum?: { __typename?: 'SwapSumAggregates', intermediateValueUsd: string, swapOutputValueUsd: string } | null } | null } }> } } } }> } } | null };

export type EgressInfoFragment = { __typename?: 'Egress', amount: string, valueUsd?: string | null, fallbackDestinationAddress?: string | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, failedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, broadcast?: { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null } | null };

export type IgnoredEgressInfoFragment = { __typename?: 'IgnoredEgress', amount: string, valueUsd?: string | null, error?: { __typename?: 'StateChainError', docs: string, name: string } | null, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } };

export type BroadcastInfoFragment = { __typename?: 'Broadcast', broadcastRequestedEventId: string, broadcastAbortedEventId?: string | null, broadcastSuccessEventId?: string | null, transactionPayload?: string | null, transactionRef: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> }, successEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, requestedEvent: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, abortedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null };

export type GetFailedDepositByTxRefQueryVariables = Exact<{
  txRef: Scalars['String']['input'];
}>;


export type GetFailedDepositByTxRefQuery = { __typename?: 'Query', txRef?: { __typename?: 'TransactionRef', failedDeposit?: { __typename?: 'FailedDeposit', reason: DepositFailedReason, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } } | null } | null };

export type GetFailedDepositBySwapDepositChannelIdQueryVariables = Exact<{
  depositChannelId: Scalars['Int']['input'];
}>;


export type GetFailedDepositBySwapDepositChannelIdQuery = { __typename?: 'Query', failedDeposits?: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', reason: DepositFailedReason, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } }> } | null };

export type LiquidityWithdrawalInfoFragment = { __typename?: 'LiquidityWithdrawal', id: number, amount: string, asset: ChainflipAsset, chain: ChainflipChain, fee: string, feeUsd?: string | null, valueUsd: string, nativeEgressId: string, withdrawalAddress: string, eventId: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, block: { __typename?: 'Block', id: number, timestamp: string }, event: { __typename?: 'Event', id: string, indexInBlock: number }, broadcast?: { __typename?: 'Broadcast', id: number, nativeId: number, transactionPayload?: string | null, successEvent?: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, abortedEvent?: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, transactionRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null };

export type GetLiquidityWithdrawalQueryVariables = Exact<{
  nativeEgressId: Scalars['BigInt']['input'];
  chain: ChainflipChain;
}>;


export type GetLiquidityWithdrawalQuery = { __typename?: 'Query', liquidityWithdrawal?: { __typename?: 'LiquidityWithdrawal', id: number, amount: string, asset: ChainflipAsset, chain: ChainflipChain, fee: string, feeUsd?: string | null, valueUsd: string, nativeEgressId: string, withdrawalAddress: string, eventId: string, lp: { __typename?: 'LiquidityProvider', account: { __typename?: 'Account', idSs58: string } }, block: { __typename?: 'Block', id: number, timestamp: string }, event: { __typename?: 'Event', id: string, indexInBlock: number }, broadcast?: { __typename?: 'Broadcast', id: number, nativeId: number, transactionPayload?: string | null, successEvent?: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, abortedEvent?: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } } | null, transactionRefs: { __typename?: 'TransactionRefsConnection', nodes: Array<{ __typename?: 'TransactionRef', ref: string }> } } | null } | null };

export type LpDelegationActivityQueryVariables = Exact<{
  delegationIdSs58?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LpDelegationActivityQuery = { __typename?: 'Query', allDelegationActivities?: { __typename?: 'DelegationActivitiesConnection', totalCount: number, edges: Array<{ __typename?: 'DelegationActivitiesEdge', node: { __typename?: 'DelegationActivity', id: number, type: DelegationActivityType, amount: string, valueUsd: string, txHash?: string | null, event: { __typename?: 'Event', indexInBlock: number, blockId: number, block: { __typename?: 'Block', timestamp: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null } } | null };

export type AccountFundingEventsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AccountFundingEventsQuery = { __typename?: 'Query', events?: { __typename?: 'AccountFundingEventsConnection', totalCount: number, edges: Array<{ __typename?: 'AccountFundingEventsEdge', node: { __typename?: 'AccountFundingEvent', id: number, amount: string, valueUsd: string, type: FundingEventType, txHash?: string | null, rebalanceCounterparty?: { __typename?: 'Account', idSs58: string } | null, event: { __typename?: 'Event', indexInBlock: number, blockId: number, block: { __typename?: 'Block', timestamp: string } }, account: { __typename?: 'Account', idSs58: string, role: AccountRole, alias?: string | null }, swapRequest?: { __typename?: 'SwapRequest', nativeId: string } | null, accountChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null } } | null };

export type LpDelegationHistoryQueryVariables = Exact<{
  delegationIdSs58?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LpDelegationHistoryQuery = { __typename?: 'Query', allOperatorEpochDelegations?: { __typename?: 'OperatorEpochDelegationsConnection', totalCount: number, edges: Array<{ __typename?: 'OperatorEpochDelegationsEdge', node: { __typename?: 'OperatorEpochDelegation', id: number, amount: string, valueUsd: string, rewards: string, rewardsValueUsd: string, losses: string, lossesValueUsd: string, operatorEpoch: { __typename?: 'OperatorEpoch', epoch: { __typename?: 'Epoch', id: number, startBlock: { __typename?: 'Block', id: number, timestamp: string }, endBlock?: { __typename?: 'Block', id: number, timestamp: string } | null }, operator: { __typename?: 'Operator', account: { __typename?: 'Account', idSs58: string, alias?: string | null } } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null } } | null };

export type GetDepositsForSpecificLiquidityDepositChannelQueryVariables = Exact<{
  channelId?: InputMaybe<Scalars['BigInt']['input']>;
  chain?: InputMaybe<ChainflipChain>;
  issuedBlockId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDepositsForSpecificLiquidityDepositChannelQuery = { __typename?: 'Query', channels?: { __typename?: 'LiquidityDepositChannelsConnection', nodes: Array<{ __typename?: 'LiquidityDepositChannel', id: number, asset: ChainflipAsset, chain: ChainflipChain, channelId: string, depositAddress: string, deposits: { __typename?: 'LiquidityDepositsConnection', nodes: Array<{ __typename?: 'LiquidityDeposit', depositAmount: string, effectiveBoostFeeBps?: number | null, event: { __typename?: 'Event', blockId: number, indexInBlock: number } }> } }> } | null };

export type GetDelegatorsDailyRewardsQueryVariables = Exact<{
  startDate: Scalars['Date']['input'];
}>;


export type GetDelegatorsDailyRewardsQuery = { __typename?: 'Query', allNetworkParticipantEarningsDailies?: { __typename?: 'NetworkParticipantEarningsDailiesConnection', groupedAggregates?: Array<{ __typename?: 'NetworkParticipantEarningsDailyAggregates', keys?: Array<string> | null, sum?: { __typename?: 'NetworkParticipantEarningsDailySumAggregates', earnings: string } | null }> | null } | null };

export type GetDelegatorsTotalRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDelegatorsTotalRewardsQuery = { __typename?: 'Query', allNetworkParticipantEarningsDailies?: { __typename?: 'NetworkParticipantEarningsDailiesConnection', aggregates?: { __typename?: 'NetworkParticipantEarningsDailyAggregates', sum?: { __typename?: 'NetworkParticipantEarningsDailySumAggregates', earnings: string, earningsValueUsd: string } | null } | null } | null };

export type GetOperatorsRewardsQueryVariables = Exact<{
  operators: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOperatorsRewardsQuery = { __typename?: 'Query', allAccounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, operator?: { __typename?: 'Operator', operatorEpoch: { __typename?: 'OperatorEpochesConnection', aggregates?: { __typename?: 'OperatorEpochAggregates', sum?: { __typename?: 'OperatorEpochSumAggregates', amount: string, valueUsd: string } | null } | null } } | null }> } | null };

export type GetSpecificPoolSwapsDataQueryVariables = Exact<{
  date24HoursAgo: Scalars['Datetime']['input'];
  date48HoursAgo: Scalars['Datetime']['input'];
  baseAsset: ChainflipAsset;
  quoteAsset: ChainflipAsset;
}>;


export type GetSpecificPoolSwapsDataQuery = { __typename?: 'Query', currentDayAggregates?: { __typename?: 'PoolSwapsConnection', groupedAggregates?: Array<{ __typename?: 'PoolSwapAggregates', fromAssetToAsset?: Array<string> | null, sum?: { __typename?: 'PoolSwapSumAggregates', toValueUsd: string, liquidityFeeValueUsd: string } | null }> | null } | null, previousDayAggregates?: { __typename?: 'PoolSwapsConnection', groupedAggregates?: Array<{ __typename?: 'PoolSwapAggregates', fromAssetToAsset?: Array<string> | null, sum?: { __typename?: 'PoolSwapSumAggregates', toValueUsd: string, liquidityFeeValueUsd: string } | null }> | null } | null };

export type GetFailedDepositsQueryVariables = Exact<{
  filter?: InputMaybe<FailedDepositFilter>;
  first: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  orderBy?: InputMaybe<Array<FailedDepositsOrderBy> | FailedDepositsOrderBy>;
}>;


export type GetFailedDepositsQuery = { __typename?: 'Query', allFailedDeposits?: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', id: string, amount: string, reason: DepositFailedReason, depositAsset: ChainflipAsset, event: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string } }, swapChannel?: { __typename?: 'SwapChannel', issuedBlockId: number, channelId: string, chain: ChainflipChain, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, affiliates: { __typename?: 'SwapChannelBeneficiariesConnection', nodes: Array<{ __typename?: 'SwapChannelBeneficiary', brokerCommissionRateBps: number, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }> } } | null, liquidityChannel?: { __typename?: 'LiquidityDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null, accountCreationChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } } } | null, brokerChannel?: { __typename?: 'BrokerChannel', chain: ChainflipChain, channelId: string, broker: { __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } } } | null }> } | null };

export type GetFailedDepositReasonsQueryVariables = Exact<{
  filter?: InputMaybe<FailedDepositFilter>;
}>;


export type GetFailedDepositReasonsQuery = { __typename?: 'Query', allFailedDeposits?: { __typename?: 'FailedDepositsConnection', nodes: Array<{ __typename?: 'FailedDeposit', reason: DepositFailedReason, event: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string } } }> } | null };

export type GetFailedDepositBrokersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFailedDepositBrokersQuery = { __typename?: 'Query', allBrokers?: { __typename?: 'BrokersConnection', nodes: Array<{ __typename?: 'Broker', account: { __typename?: 'Account', idSs58: string, alias?: string | null } }> } | null };

export type GetSwapExecutionBlocksQueryVariables = Exact<{
  nativeIds?: InputMaybe<Array<Scalars['BigInt']['input']> | Scalars['BigInt']['input']>;
}>;


export type GetSwapExecutionBlocksQuery = { __typename?: 'Query', allSwaps?: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', nativeId: string, executedEvent?: { __typename?: 'Event', indexInBlock: number, block: { __typename?: 'Block', id: number } } | null }> } | null };

export type GetOraclePricesQueryVariables = Exact<{
  baseAssets?: InputMaybe<Array<PriceAsset> | PriceAsset>;
  minBlock: Scalars['Int']['input'];
  maxBlock: Scalars['Int']['input'];
}>;


export type GetOraclePricesQuery = { __typename?: 'Query', allOraclePriceTrackings?: { __typename?: 'OraclePriceTrackingsConnection', nodes: Array<{ __typename?: 'OraclePriceTracking', baseAsset: PriceAsset, price: number, priceValidFromBlock: number, priceValidToBlock?: number | null }> } | null };

export type GetFundingEventsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFundingEventsQuery = { __typename?: 'Query', events?: { __typename?: 'AccountFundingEventsConnection', totalCount: number, edges: Array<{ __typename?: 'AccountFundingEventsEdge', node: { __typename?: 'AccountFundingEvent', id: number, amount: string, valueUsd: string, type: FundingEventType, txHash?: string | null, rebalanceCounterparty?: { __typename?: 'Account', idSs58: string } | null, event: { __typename?: 'Event', indexInBlock: number, blockId: number, block: { __typename?: 'Block', timestamp: string } }, account: { __typename?: 'Account', idSs58: string, role: AccountRole, alias?: string | null }, swapRequest?: { __typename?: 'SwapRequest', nativeId: string } | null, accountChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } | null };

export type GetValidatorsByAccountIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValidatorsByAccountIdsQuery = { __typename?: 'Query', validators?: { __typename?: 'ValidatorsConnection', nodes: Array<{ __typename?: 'Validator', id: number }> } | null };

export type PaginatedPenaltiesByValidatorQueryQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type PaginatedPenaltiesByValidatorQueryQuery = { __typename?: 'Query', penalties?: { __typename?: 'PenaltiesConnection', pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PenaltiesEdge', node: { __typename?: 'Penalty', id: number, reason: string, amount: number, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, block: { __typename?: 'Block', id: number, timestamp: string } } }> } | null };

export type TotalValidatorRewardsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type TotalValidatorRewardsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', validator?: { __typename?: 'Validator', memberships: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string } | null } | null } } | null } | null };

export type GetAllEpochsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  validatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  operatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  withValidator?: InputMaybe<Scalars['Boolean']['input']>;
  withOperator?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllEpochsQuery = { __typename?: 'Query', epochs?: { __typename?: 'EpochesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null }, edges: Array<{ __typename?: 'EpochesEdge', node: { __typename?: 'Epoch', id: number, bond: string, totalBonded: string, maxAuthoritySetSize: number, startBlock: { __typename?: 'Block', id: number, hash: string, timestamp: string }, endBlock?: { __typename?: 'Block', id: number, hash: string, timestamp: string } | null, memberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, validatorMemberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, operatorEpochs: { __typename?: 'OperatorEpochesConnection', totalCount: number } } }> } | null };

export type GetEpochsByIdQueryVariables = Exact<{
  epochId: Scalars['Int']['input'];
  validatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  operatorIdSs58?: InputMaybe<Scalars['String']['input']>;
  withValidator?: InputMaybe<Scalars['Boolean']['input']>;
  withOperator?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetEpochsByIdQuery = { __typename?: 'Query', epoch?: { __typename?: 'Epoch', id: number, bond: string, totalBonded: string, maxAuthoritySetSize: number, startBlock: { __typename?: 'Block', id: number, hash: string, timestamp: string }, endBlock?: { __typename?: 'Block', id: number, hash: string, timestamp: string } | null, memberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, validatorMemberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, operatorEpochs: { __typename?: 'OperatorEpochesConnection', totalCount: number } } | null };

export type GetAuthorityMembershipsForEpochQueryVariables = Exact<{
  epochId: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAuthorityMembershipsForEpochQuery = { __typename?: 'Query', memberships?: { __typename?: 'AuthorityMembershipsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null }, edges: Array<{ __typename?: 'AuthorityMembershipsEdge', node: { __typename?: 'AuthorityMembership', id: number, bid: string, reward: string, rewardValueUsd: string, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', id: number, idSs58: string, alias?: string | null, fundingEvents: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', keys?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string, valueUsd: string } | null }> | null } } } } }> } | null };

export type GetOnlineAuthorityMemberInfoQueryVariables = Exact<{
  minEpochStartBlockId: Scalars['Int']['input'];
  groupBy: Array<AuthorityHeartbeatGroupBy> | AuthorityHeartbeatGroupBy;
}>;


export type GetOnlineAuthorityMemberInfoQuery = { __typename?: 'Query', epochs?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', epochId: number, startBlock: { __typename?: 'Block', timestamp: string }, endBlock?: { __typename?: 'Block', timestamp: string } | null, members: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, heartbeats: { __typename?: 'AuthorityHeartbeatsConnection', groupedAggregates?: Array<{ __typename?: 'AuthorityHeartbeatAggregates', periodStartUTC?: Array<string> | null, distinctCount?: { __typename?: 'AuthorityHeartbeatDistinctCountAggregates', validators?: string | null } | null }> | null } }> } | null };

export type AuthorityMembershipWithEpochFragment = { __typename?: 'AuthorityMembership', id: number, reward: string, epoch: { __typename?: 'Epoch', id: number, startBlockId: number, endBlockId?: number | null, bond: string, totalBonded: string, eventType: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', type?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null }> | null } } };

export type GetAuthorityMembershipsForValidatorQueryVariables = Exact<{
  validatorId?: InputMaybe<Scalars['Int']['input']>;
  accountId?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAuthorityMembershipsForValidatorQuery = { __typename?: 'Query', memberships?: { __typename?: 'AuthorityMembershipsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', startCursor?: any | null, hasPreviousPage: boolean, hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'AuthorityMembershipsEdge', node: { __typename?: 'AuthorityMembership', id: number, reward: string, epoch: { __typename?: 'Epoch', id: number, startBlockId: number, endBlockId?: number | null, bond: string, totalBonded: string, eventType: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', type?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null }> | null } } } }> } | null };

export type GetDelegatingSinceQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDelegatingSinceQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, activity: { __typename?: 'DelegationActivitiesConnection', aggregates?: { __typename?: 'DelegationActivityAggregates', max?: { __typename?: 'DelegationActivityMaxAggregates', timestamp?: string | null } | null } | null } }> } | null };

export type GetDelegationRewardsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetDelegationRewardsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, rewards: { __typename?: 'LatestDelegationRewardsConnection', nodes: Array<{ __typename?: 'LatestDelegationReward', amount: string, valueUsd: string }> } }> } | null };

export type GetDelegationPositionBoundariesQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetDelegationPositionBoundariesQuery = { __typename?: 'Query', boundaries?: { __typename?: 'DelegationActivitiesConnection', nodes: Array<{ __typename?: 'DelegationActivity', type: DelegationActivityType, timestamp: string }> } | null };

export type GetDelegationPositionRewardsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  since: Scalars['Datetime']['input'];
}>;


export type GetDelegationPositionRewardsQuery = { __typename?: 'Query', rewards?: { __typename?: 'DelegationActivitiesConnection', aggregates?: { __typename?: 'DelegationActivityAggregates', sum?: { __typename?: 'DelegationActivitySumAggregates', amount: string, valueUsd: string } | null } | null } | null };

export type OperatorApysQueryVariables = Exact<{ [key: string]: never; }>;


export type OperatorApysQuery = { __typename?: 'Query', allEpoches?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number, apys: { __typename?: 'OperatorEpochDelegationApiesConnection', nodes: Array<{ __typename?: 'OperatorEpochDelegationApy', apyBp: number, operator: { __typename?: 'Operator', account: { __typename?: 'Account', idSs58: string } } }> } }> } | null };

export type GetOperatorDelegationActivitiesQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOperatorDelegationActivitiesQuery = { __typename?: 'Query', allDelegationActivities?: { __typename?: 'DelegationActivitiesConnection', totalCount: number, nodes: Array<{ __typename?: 'DelegationActivity', id: number, type: DelegationActivityType, amount: string, valueUsd: string, timestamp: string }> } | null };

export type GetOperatorRewardsHistoryQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOperatorRewardsHistoryQuery = { __typename?: 'Query', allOperatorEpoches?: { __typename?: 'OperatorEpochesConnection', totalCount: number, nodes: Array<{ __typename?: 'OperatorEpoch', id: number, operatorRewardAmount: string, operatorRewardValueUsd: string, epoch: { __typename?: 'Epoch', id: number, endBlock?: { __typename?: 'Block', timestamp: string } | null } }> } | null };

export type GetValidatorRewardsHistoryQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetValidatorRewardsHistoryQuery = { __typename?: 'Query', allAuthorityMemberships?: { __typename?: 'AuthorityMembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuthorityMembership', id: number, reward: string, rewardValueUsd: string, epoch: { __typename?: 'Epoch', id: number, endBlock?: { __typename?: 'Block', timestamp: string } | null } }> } | null };

export type HistoricalValidatorsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type HistoricalValidatorsQuery = { __typename?: 'Query', links?: { __typename?: 'OperatorValidatorLinksConnection', nodes: Array<{ __typename?: 'OperatorValidatorLink', validator: { __typename?: 'Validator', account: { __typename?: 'Account', alias?: string | null, idSs58: string, role: AccountRole } } }> } | null };

export type ParticipantLatestApysQueryVariables = Exact<{
  role: NetworkParticipantRole;
  accounts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  first: Scalars['Int']['input'];
}>;


export type ParticipantLatestApysQuery = { __typename?: 'Query', allNetworkParticipantEarningsHourlies?: { __typename?: 'NetworkParticipantEarningsHourliesConnection', nodes: Array<{ __typename?: 'NetworkParticipantEarningsHourly', accountId: number, projectedApy6H?: string | null, projectedApy24H?: string | null, projectedApy72H?: string | null, projectedApy168H?: string | null, projectedApy720H?: string | null, account: { __typename?: 'Account', idSs58: string } }> } | null };

export type ParticipantApyRatiosQueryVariables = Exact<{
  role: NetworkParticipantRole;
  accounts: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  first: Scalars['Int']['input'];
}>;


export type ParticipantApyRatiosQuery = { __typename?: 'Query', allNetworkParticipantEarningsHourlies?: { __typename?: 'NetworkParticipantEarningsHourliesConnection', nodes: Array<{ __typename?: 'NetworkParticipantEarningsHourly', accountId: number, block: number, ratio: string }> } | null };

export type ParticipantDailyApysQueryVariables = Exact<{
  role: NetworkParticipantRole;
  startDate: Scalars['Date']['input'];
  endDate: Scalars['Date']['input'];
  minActiveHours: Scalars['Int']['input'];
}>;


export type ParticipantDailyApysQuery = { __typename?: 'Query', allNetworkParticipantEarningsDailies?: { __typename?: 'NetworkParticipantEarningsDailiesConnection', groupedAggregates?: Array<{ __typename?: 'NetworkParticipantEarningsDailyAggregates', keys?: Array<string> | null, max?: { __typename?: 'NetworkParticipantEarningsDailyMaxAggregates', projectedApy6H?: string | null, projectedApy24H?: string | null, projectedApy72H?: string | null, projectedApy168H?: string | null, projectedApy720H?: string | null } | null }> | null } | null };

export type ParticipantTodayApyQueryVariables = Exact<{
  role: NetworkParticipantRole;
  since: Scalars['Datetime']['input'];
}>;


export type ParticipantTodayApyQuery = { __typename?: 'Query', allNetworkParticipantEarningsHourlies?: { __typename?: 'NetworkParticipantEarningsHourliesConnection', aggregates?: { __typename?: 'NetworkParticipantEarningsHourlyAggregates', max?: { __typename?: 'NetworkParticipantEarningsHourlyMaxAggregates', projectedApy6H?: string | null, projectedApy24H?: string | null, projectedApy72H?: string | null, projectedApy168H?: string | null, projectedApy720H?: string | null } | null } | null } | null };

export type GetExtrinsicsAndEventsByBlockIdQueryVariables = Exact<{
  blockId: Scalars['Int']['input'];
}>;


export type GetExtrinsicsAndEventsByBlockIdQuery = { __typename?: 'Query', details: { __typename?: 'BlockDetails', extrinsics?: Array<{ __typename?: 'ExtrinsicInfo', callName?: string | null, callOrigin?: any | null, hash: string, indexInBlock: number, callArgs?: any | null }> | null, events?: Array<{ __typename?: 'EventInfo', indexInBlock: number, extrinsicHash?: string | null, name: string }> | null }, block?: { __typename?: 'Block', timestamp: string } | null };

export type ExtrinsicFragment = { __typename?: 'Extrinsic', id: string, fee?: string | null, hash: string, blockId: number, indexInBlock: number, signature?: string | null, success: boolean, tip?: string | null, account?: { __typename?: 'Account', id: number, idSs58: string, alias?: string | null } | null, block: { __typename?: 'Block', id: number, hash: string, timestamp: string }, metadata: { __typename?: 'Metadatum', id: number, name: string, label: string } };

export type GetExtrinsicsByAccountQueryVariables = Exact<{
  accountIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type GetExtrinsicsByAccountQuery = { __typename?: 'Query', extrinsics?: { __typename?: 'ExtrinsicsConnection', pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor?: any | null, hasNextPage: boolean, endCursor?: any | null }, edges: Array<{ __typename?: 'ExtrinsicsEdge', node: { __typename?: 'Extrinsic', id: string, fee?: string | null, hash: string, blockId: number, indexInBlock: number, signature?: string | null, success: boolean, tip?: string | null, account?: { __typename?: 'Account', id: number, idSs58: string, alias?: string | null } | null, block: { __typename?: 'Block', id: number, hash: string, timestamp: string }, metadata: { __typename?: 'Metadatum', id: number, name: string, label: string } } }> } | null };

export type AccountFundingEventFragment = { __typename?: 'AccountFundingEvent', id: number, amount: string, valueUsd: string, type: FundingEventType, txHash?: string | null, rebalanceCounterparty?: { __typename?: 'Account', idSs58: string } | null, event: { __typename?: 'Event', indexInBlock: number, blockId: number, block: { __typename?: 'Block', timestamp: string } }, account: { __typename?: 'Account', idSs58: string, role: AccountRole, alias?: string | null }, swapRequest?: { __typename?: 'SwapRequest', nativeId: string } | null, accountChannel?: { __typename?: 'AccountCreationDepositChannel', issuedBlockId: number, chain: ChainflipChain, channelId: string } | null };

export type EpochFragment = { __typename?: 'Epoch', id: number, bond: string, totalBonded: string, maxAuthoritySetSize: number, startBlock: { __typename?: 'Block', id: number, hash: string, timestamp: string }, endBlock?: { __typename?: 'Block', id: number, hash: string, timestamp: string } | null, memberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number } };

export type EpochParticipationFragment = { __typename?: 'Epoch', validatorMemberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number }, operatorEpochs: { __typename?: 'OperatorEpochesConnection', totalCount: number } };

export type AuthorityMembershipWithValidatorFragment = { __typename?: 'AuthorityMembership', id: number, bid: string, reward: string, rewardValueUsd: string, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', id: number, idSs58: string, alias?: string | null, fundingEvents: { __typename?: 'AccountFundingEventsConnection', groupedAggregates?: Array<{ __typename?: 'AccountFundingEventAggregates', keys?: Array<string> | null, sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string, valueUsd: string } | null }> | null } } } };

export type GetLiquidityBalanceChangeEventsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLiquidityBalanceChangeEventsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', lp?: { __typename?: 'LiquidityProvider', events: { __typename?: 'LiquidityBalanceEventsConnection', totalCount: number, edges: Array<{ __typename?: 'LiquidityBalanceEventsEdge', node: { __typename?: 'LiquidityBalanceEvent', eventId: string, amount: string, asset: ChainflipAsset, txRef?: string | null, valueUsd: string, effectiveBoostFeeBps?: number | null, block: { __typename?: 'Block', timestamp: string }, withdrawals: { __typename?: 'LiquidityWithdrawalsConnection', nodes: Array<{ __typename?: 'LiquidityWithdrawal', nativeEgressId: string, chain: ChainflipChain }> }, depositChannel?: { __typename?: 'LiquidityDepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number, maxBoostFeeBps: number } | null, accountCreationDepositChannel?: { __typename?: 'AccountCreationDepositChannel', chain: ChainflipChain, channelId: string, issuedBlockId: number, maxBoostFeeBps: number } | null, broadcast?: { __typename?: 'Broadcast', id: number, broadcastSuccessEventId?: string | null } | null } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, startCursor?: any | null, hasPreviousPage: boolean } } } | null } | null };

export type GetPoolTableDataQueryVariables = Exact<{
  date24HoursAgo: Scalars['Datetime']['input'];
  date48HoursAgo: Scalars['Datetime']['input'];
}>;


export type GetPoolTableDataQuery = { __typename?: 'Query', currentDayAggregates?: { __typename?: 'PoolSwapsConnection', groupedAggregates?: Array<{ __typename?: 'PoolSwapAggregates', fromAssetToAsset?: Array<string> | null, sum?: { __typename?: 'PoolSwapSumAggregates', toValueUsd: string } | null }> | null } | null, previousDayAggregates?: { __typename?: 'PoolSwapsConnection', groupedAggregates?: Array<{ __typename?: 'PoolSwapAggregates', fromAssetToAsset?: Array<string> | null, sum?: { __typename?: 'PoolSwapSumAggregates', toValueUsd: string } | null }> | null } | null };

export type PoolSwapFieldsFragment = { __typename?: 'Swap', id: number, nativeId: string, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, swapInputAmount: string, swapInputValueUsd: string, swapOutputAmount?: string | null, swapOutputValueUsd?: string | null, intermediateAmount?: string | null, intermediateValueUsd?: string | null, swapFeesBySwapId: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', amount: string, asset: ChainflipAsset, type: SwapFeeType }> } };

export type GetPoolLastPricesQueryVariables = Exact<{
  baseAsset: ChainflipAsset;
  latestSwapTimestamp: Scalars['Datetime']['input'];
  earliestSwapTimestamp: Scalars['Datetime']['input'];
}>;


export type GetPoolLastPricesQuery = { __typename?: 'Query', latestSwap?: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', id: number, nativeId: string, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, swapInputAmount: string, swapInputValueUsd: string, swapOutputAmount?: string | null, swapOutputValueUsd?: string | null, intermediateAmount?: string | null, intermediateValueUsd?: string | null, swapFeesBySwapId: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', amount: string, asset: ChainflipAsset, type: SwapFeeType }> } }> } | null, earliestSwap?: { __typename?: 'SwapsConnection', nodes: Array<{ __typename?: 'Swap', id: number, nativeId: string, sourceAsset: ChainflipAsset, destinationAsset: ChainflipAsset, swapInputAmount: string, swapInputValueUsd: string, swapOutputAmount?: string | null, swapOutputValueUsd?: string | null, intermediateAmount?: string | null, intermediateValueUsd?: string | null, swapFeesBySwapId: { __typename?: 'SwapFeesConnection', nodes: Array<{ __typename?: 'SwapFee', amount: string, asset: ChainflipAsset, type: SwapFeeType }> } }> } | null };

export type GetMarketDataQueryVariables = Exact<{
  asset: ChainflipAsset;
  numberOfDays: Scalars['Int']['input'];
}>;


export type GetMarketDataQuery = { __typename?: 'Query', marketData: { __typename?: 'MarketData', globalVolume?: number | null, candlesticks: Array<{ __typename?: 'CandlestickData', time: number, open: number, low: number, high: number, close: number } | { __typename?: 'WhitespaceData', time: number }>, volumes: Array<{ __typename?: 'HistogramData', value: number, time: number } | { __typename?: 'WhitespaceData', time: number }>, prices: Array<{ __typename?: 'LineData', time: number, value?: number | null }> } };

export type GetChainTrackingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChainTrackingQueryQuery = { __typename?: 'Query', allChainTrackings?: { __typename?: 'ChainTrackingsConnection', nodes: Array<{ __typename?: 'ChainTracking', chain: ChainflipChain, height: string }> } | null };

export type GetLatestEpochsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
}>;


export type GetLatestEpochsQuery = { __typename?: 'Query', latestEpoch?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number, bond: string, totalBonded: string, startBlock: { __typename?: 'Block', id: number, timestamp: string }, rotationEvents: { __typename?: 'RotationEventsConnection', nodes: Array<{ __typename?: 'RotationEvent', id: number, type: RotationEventType, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string, hash: string } } }> } }> } | null };

export type GetLatestBlocksQueryVariables = Exact<{
  limit?: Scalars['Int']['input'];
}>;


export type GetLatestBlocksQuery = { __typename?: 'Query', latestBlocks?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number, timestamp: string, validator?: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } | null }> } | null };

export type GetValidatorsTotalRewardsQueryVariables = Exact<{
  validators: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValidatorsTotalRewardsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, validator?: { __typename?: 'Validator', cfeVersionId: string, authority: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string } | null } | null } } | null }> } | null };

export type GetValidatorsAggregatedStatsQueryVariables = Exact<{
  validators: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetValidatorsAggregatedStatsQuery = { __typename?: 'Query', totalRewards?: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null } | null, totalSlashed?: { __typename?: 'AccountFundingEventsConnection', aggregates?: { __typename?: 'AccountFundingEventAggregates', sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null } | null } | null };

export type AuthorshipDataQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  validatorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startTime: Scalars['Datetime']['input'];
}>;


export type AuthorshipDataQuery = { __typename?: 'Query', lastBlock?: { __typename?: 'BlocksConnection', nodes: Array<{ __typename?: 'Block', id: number }> } | null, operatorEpochs?: { __typename?: 'OperatorEpochesConnection', nodes: Array<{ __typename?: 'OperatorEpoch', validators: { __typename?: 'OperatorEpochValidatorsConnection', totalCount: number }, epoch: { __typename?: 'Epoch', startBlockId: number, endBlockId?: number | null, memberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number } } }> } | null, authorshipPenalties?: { __typename?: 'PenaltiesConnection', totalCount: number } | null };

export type GetOperatorEpochsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOperatorEpochsQuery = { __typename?: 'Query', allOperatorEpoches?: { __typename?: 'OperatorEpochesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null }, nodes: Array<{ __typename?: 'OperatorEpoch', operatorRewardAmount: string, operatorRewardValueUsd: string, operatorLossAmount: string, operatorLossValueUsd: string, epoch: { __typename?: 'Epoch', id: number, bond: string, startBlockId: number, endBlockId?: number | null }, validators: { __typename?: 'OperatorEpochValidatorsConnection', numberOfNodes: number, nodes: Array<{ __typename?: 'OperatorEpochValidator', validatorId: number }> }, delegations: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string, losses: string, lossesValueUsd: string } | null } | null } }> } | null };

export type GetValidatorAuthorityMembershipsQueryVariables = Exact<{
  epochIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetValidatorAuthorityMembershipsQuery = { __typename?: 'Query', allAuthorityMemberships?: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', totalRewards: string, validator: { __typename?: 'Validator', id: number, accountByAccountId: { __typename?: 'Account', idSs58: string } }, epoch: { __typename?: 'Epoch', id: number, slashedEvents: { __typename?: 'AccountFundingEventsConnection', agg?: { __typename?: 'AccountFundingEventAggregates', sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null } | null } } }> } | null };

export type GetWhitelistBlacklistTimestampQueryVariables = Exact<{
  operatorId: Scalars['String']['input'];
  delegatorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type?: InputMaybe<OperatorActionType>;
}>;


export type GetWhitelistBlacklistTimestampQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, actions: { __typename?: 'OperatorActionsConnection', aggregates?: { __typename?: 'OperatorActionAggregates', max?: { __typename?: 'OperatorActionMaxAggregates', timestamp?: string | null } | null } | null } }> } | null };

export type GetEvmStateChainCallByTxHashQueryVariables = Exact<{
  txHash: Scalars['String']['input'];
}>;


export type GetEvmStateChainCallByTxHashQuery = { __typename?: 'Query', call?: { __typename?: 'EvmStateChainCall', success: boolean, error?: { __typename?: 'StateChainError', name: string, docs: string } | null } | null };

export type GetAuthorityCfeVersionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthorityCfeVersionsQuery = { __typename?: 'Query', epochs?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number, memberships: { __typename?: 'AuthorityMembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'AuthorityMembership', id: number, validator: { __typename?: 'Validator', id: number, cfeVersion: string } }> } }> } | null };

export type GetPenaltiesQueryVariables = Exact<{
  filter: PenaltyFilter;
  orderBy?: InputMaybe<Array<PenaltiesOrderBy> | PenaltiesOrderBy>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPenaltiesQuery = { __typename?: 'Query', penalties?: { __typename?: 'PenaltiesConnection', totalCount: number, edges: Array<{ __typename?: 'PenaltiesEdge', node: { __typename?: 'Penalty', id: number, reason: string, amount: number, validator: { __typename?: 'Validator', id: number, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }, block: { __typename?: 'Block', id: number, timestamp: string } } }> } | null };

export type GetDelegationActivityQueryVariables = Exact<{
  delegationIdSs58?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDelegationActivityQuery = { __typename?: 'Query', allDelegationActivities?: { __typename?: 'DelegationActivitiesConnection', totalCount: number, edges: Array<{ __typename?: 'DelegationActivitiesEdge', node: { __typename?: 'DelegationActivity', id: number, type: DelegationActivityType, amount: string, valueUsd: string, txHash?: string | null, event: { __typename?: 'Event', indexInBlock: number, blockId: number, block: { __typename?: 'Block', timestamp: string } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null } } | null };

export type CheckForActivityQueryVariables = Exact<{
  delegationIdSs58?: InputMaybe<Scalars['String']['input']>;
}>;


export type CheckForActivityQuery = { __typename?: 'Query', activity?: { __typename?: 'DelegationActivitiesConnection', totalCount: number } | null };

export type GetDelegationHistoryQueryVariables = Exact<{
  delegationIdSs58?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetDelegationHistoryQuery = { __typename?: 'Query', allOperatorEpochDelegations?: { __typename?: 'OperatorEpochDelegationsConnection', totalCount: number, edges: Array<{ __typename?: 'OperatorEpochDelegationsEdge', node: { __typename?: 'OperatorEpochDelegation', id: number, amount: string, valueUsd: string, rewards: string, rewardsValueUsd: string, delegator: { __typename?: 'Account', idSs58: string, alias?: string | null }, operatorEpoch: { __typename?: 'OperatorEpoch', epoch: { __typename?: 'Epoch', id: number, startBlock: { __typename?: 'Block', id: number, timestamp: string }, endBlock?: { __typename?: 'Block', id: number, timestamp: string } | null }, operator: { __typename?: 'Operator', account: { __typename?: 'Account', idSs58: string, alias?: string | null } } } } }>, pageInfo: { __typename?: 'PageInfo', endCursor?: any | null, hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: any | null } } | null };

export type GetEpochHistoryQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EpochFilter>;
}>;


export type GetEpochHistoryQuery = { __typename?: 'Query', epochs?: { __typename?: 'EpochesConnection', nodes: Array<{ __typename?: 'Epoch', id: number, bond: string, totalBonded: string, startBlock: { __typename?: 'Block', timestamp: string }, endBlock?: { __typename?: 'Block', timestamp: string } | null, validatorRewards: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null }, operatorEpochs: { __typename?: 'OperatorEpochesConnection', aggregates?: { __typename?: 'OperatorEpochAggregates', sum?: { __typename?: 'OperatorEpochSumAggregates', operatorRewardAmount: string, operatorRewardValueUsd: string } | null } | null, nodes: Array<{ __typename?: 'OperatorEpoch', delegatorRewards: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string } | null } | null } }> } }> } | null };

export type RedeemedEventFragment = { __typename?: 'AccountFundingEvent', amount: string, redeemedTxHash?: string | null, event: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string, id: number } }, account: { __typename?: 'Account', idSs58: string, alias?: string | null } };

export type EventWithBlockFragment = { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string, hash: string } };

export type EpochWithRotationFragment = { __typename?: 'Epoch', id: number, bond: string, totalBonded: string, startBlock: { __typename?: 'Block', id: number, timestamp: string }, rotationEvents: { __typename?: 'RotationEventsConnection', nodes: Array<{ __typename?: 'RotationEvent', id: number, type: RotationEventType, event: { __typename?: 'Event', id: string, indexInBlock: number, block: { __typename?: 'Block', id: number, timestamp: string, hash: string } } }> } };

export type GetOperatorTotalsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetOperatorTotalsQuery = { __typename?: 'Query', operator?: { __typename?: 'OperatorEpochesConnection', aggregates?: { __typename?: 'OperatorEpochAggregates', sum?: { __typename?: 'OperatorEpochSumAggregates', reward: string, rewardValueUsd: string, loss: string, lossValueUsd: string } | null } | null } | null, validators?: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string, loss: string, lossValueUsd: string } | null } | null } | null, delegators?: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', reward: string, rewardValueUsd: string, loss: string, lossValueUsd: string } | null } | null } | null };

export type GetOperatorEpochValidatorsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
  epochId: Scalars['Int']['input'];
}>;


export type GetOperatorEpochValidatorsQuery = { __typename?: 'Query', operatorEpochValidators?: { __typename?: 'OperatorEpochValidatorsConnection', nodes: Array<{ __typename?: 'OperatorEpochValidator', validator: { __typename?: 'Validator', account: { __typename?: 'Account', idSs58: string } } }> } | null };

export type GetOperatorEpochsHistoryQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetOperatorEpochsHistoryQuery = { __typename?: 'Query', operatorEpochs?: { __typename?: 'OperatorEpochesConnection', nodes: Array<{ __typename?: 'OperatorEpoch', epochId: number, operatorRewardAmount: string, operatorRewardValueUsd: string, operatorLossAmount: string, operatorLossValueUsd: string, stakedAmount: string, stakedValueUsd: string, epoch: { __typename?: 'Epoch', bond: string, startBlockId: number, endBlockId?: number | null }, validators: { __typename?: 'OperatorEpochValidatorsConnection', totalCount: number, nodes: Array<{ __typename?: 'OperatorEpochValidator', membership: { __typename?: 'AuthorityMembership', reward: string, rewardValueUsd: string, loss: string, lossValueUsd: string } }> }, delegations: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string, losses: string, lossesValueUsd: string } | null } | null } }> } | null };

export type GetOperatorDelegatorDetailsQueryVariables = Exact<{
  operatorIdSs58: Scalars['String']['input'];
  delegatorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetOperatorDelegatorDetailsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, delegations: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string } | null } | null }, delegatedSince: { __typename?: 'DelegationActivitiesConnection', nodes: Array<{ __typename?: 'DelegationActivity', timestamp: string }> } }> } | null };

export type GetOperatorListedAccountsQueryVariables = Exact<{
  operatorIdSs58: Scalars['String']['input'];
  accountIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  type: OperatorActionType;
  withRewards: Scalars['Boolean']['input'];
}>;


export type GetOperatorListedAccountsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, listedSince: { __typename?: 'OperatorActionsConnection', nodes: Array<{ __typename?: 'OperatorAction', timestamp: string }> }, delegations: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string } | null } | null } }> } | null };

export type GetAuthorityTotalRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthorityTotalRewardsQuery = { __typename?: 'Query', all?: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null } | null };

export type GetDelegationRewardsSinceDaysAgoQueryVariables = Exact<{
  delegationIdSs58: Scalars['String']['input'];
  startDate: Scalars['Datetime']['input'];
}>;


export type GetDelegationRewardsSinceDaysAgoQuery = { __typename?: 'Query', rewards?: { __typename?: 'DelegationActivitiesConnection', aggregates?: { __typename?: 'DelegationActivityAggregates', sum?: { __typename?: 'DelegationActivitySumAggregates', amount: string, valueUsd: string } | null } | null } | null };

export type GetNetworkTotalEverRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNetworkTotalEverRewardsQuery = { __typename?: 'Query', authority?: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null } | null, delegator?: { __typename?: 'OperatorEpochDelegationsConnection', aggregates?: { __typename?: 'OperatorEpochDelegationAggregates', sum?: { __typename?: 'OperatorEpochDelegationSumAggregates', rewards: string, rewardsValueUsd: string } | null } | null } | null, operator?: { __typename?: 'OperatorEpochesConnection', aggregates?: { __typename?: 'OperatorEpochAggregates', sum?: { __typename?: 'OperatorEpochSumAggregates', operatorRewardAmount: string, operatorRewardValueUsd: string } | null } | null } | null };

export type GetLatestAuthoritySetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestAuthoritySetQuery = { __typename?: 'Query', currentAuthoritySet?: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', epochId: number }> } | null };

export type GetFundedAccountIdsByFunderQueryVariables = Exact<{
  walletAddress: Scalars['String']['input'];
}>;


export type GetFundedAccountIdsByFunderQuery = { __typename?: 'Query', events?: { __typename?: 'AccountFundingEventsConnection', nodes: Array<{ __typename?: 'AccountFundingEvent', accountId: number, account: { __typename?: 'Account', idSs58: string } }> } | null };

export type GetRedemptionsByAccountIdsQueryVariables = Exact<{
  accountIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetRedemptionsByAccountIdsQuery = { __typename?: 'Query', events?: { __typename?: 'AccountFundingEventsConnection', nodes: Array<{ __typename?: 'AccountFundingEvent', amount: string, redeemedTxHash?: string | null, event: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string, id: number } }, account: { __typename?: 'Account', idSs58: string, alias?: string | null } }> } | null };

export type GetAccountsRewardsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
  epochId: Scalars['Int']['input'];
}>;


export type GetAccountsRewardsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, validator?: { __typename?: 'Validator', historicRewards: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string } | null } | null }, currentRewards: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string } | null } | null } } | null }> } | null };

export type GetAccountsSlashedQueryVariables = Exact<{
  idSs58s?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  epochId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAccountsSlashedQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, slashedEvents: { __typename?: 'AccountFundingEventsConnection', aggregates?: { __typename?: 'AccountFundingEventAggregates', sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null } | null }, currentEpochslashedEvents: { __typename?: 'AccountFundingEventsConnection', aggregates?: { __typename?: 'AccountFundingEventAggregates', sum?: { __typename?: 'AccountFundingEventSumAggregates', amount: string } | null } | null } }> } | null };

export type GetAllValidatorFundingDatesQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetAllValidatorFundingDatesQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, firstFunding: { __typename?: 'AccountFundingEventsConnection', nodes: Array<{ __typename?: 'AccountFundingEvent', event: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string, id: number } } }> }, latestFunding: { __typename?: 'AccountFundingEventsConnection', nodes: Array<{ __typename?: 'AccountFundingEvent', event: { __typename?: 'Event', block: { __typename?: 'Block', timestamp: string, id: number } } }> } }> } | null };

export type GetValidatorCfeVersionQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetValidatorCfeVersionQuery = { __typename?: 'Query', account?: { __typename?: 'Account', validator?: { __typename?: 'Validator', cfeVersionId: string } | null } | null };

export type GetValidatorProcessorIdsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetValidatorProcessorIdsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: number, validator?: { __typename?: 'Validator', id: number } | null } | null };

export type GetValidatorsListDetailsQueryVariables = Exact<{
  idSs58s: Array<Scalars['String']['input']> | Scalars['String']['input'];
  epochId: Scalars['Int']['input'];
}>;


export type GetValidatorsListDetailsQuery = { __typename?: 'Query', accounts?: { __typename?: 'AccountsConnection', nodes: Array<{ __typename?: 'Account', idSs58: string, validator?: { __typename?: 'Validator', cfeVersionId: string, authorityMemberships: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null }, currentEpochMembership: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', reward: string, rewardValueUsd: string }> } } | null }> } | null };

export type GetValidatorStatsQueryVariables = Exact<{
  idSs58: Scalars['String']['input'];
}>;


export type GetValidatorStatsQuery = { __typename?: 'Query', account?: { __typename?: 'Account', validator?: { __typename?: 'Validator', cfeVersionId: string, rewards: { __typename?: 'AuthorityMembershipsConnection', aggregates?: { __typename?: 'AuthorityMembershipAggregates', sum?: { __typename?: 'AuthorityMembershipSumAggregates', reward: string, rewardValueUsd: string } | null } | null }, latestMembership: { __typename?: 'AuthorityMembershipsConnection', nodes: Array<{ __typename?: 'AuthorityMembership', epochId: number }> } } | null } | null };

export const ChannelDepositInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"txRefs"},"name":{"kind":"Name","value":"transactionRefsByLiquidityDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]} as unknown as DocumentNode<ChannelDepositInfoFragment, unknown>;
export const FailedDepositInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FailedDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"refs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FailedDepositInfoFragment, unknown>;
export const LiquidityDepositChannelInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityDepositChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"txRefs"},"name":{"kind":"Name","value":"transactionRefsByLiquidityDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FailedDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"refs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiquidityDepositChannelInfoFragment, unknown>;
export const ChannelInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]} as unknown as DocumentNode<ChannelInfoFragment, unknown>;
export const BroadcastInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}}]} as unknown as DocumentNode<BroadcastInfoFragment, unknown>;
export const EgressInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}}]} as unknown as DocumentNode<EgressInfoFragment, unknown>;
export const AccountCreationDepositChannelOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<AccountCreationDepositChannelOverviewFragment, unknown>;
export const SwapRequestOverviewFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<SwapRequestOverviewFragment, unknown>;
export const SwapChannelInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsBySwapDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"beneficiaries"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"commissions"},"name":{"kind":"Name","value":"swapCommissionsBySwapChannelBeneficiaryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"asset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FailedDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"refs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SwapChannelInfoFragment, unknown>;
export const AccountCreationDepositChannelInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequests"},"name":{"kind":"Name","value":"swapRequestsByAccountCreationDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FailedDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"refs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"txRefs"},"name":{"kind":"Name","value":"transactionRefsByLiquidityDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]} as unknown as DocumentNode<AccountCreationDepositChannelInfoFragment, unknown>;
export const PenaltyFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Penalty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Penalty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<PenaltyFragment, unknown>;
export const BlockListBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<BlockListBlockFragment, unknown>;
export const BlockWithValidatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockWithValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"stateRoot"}},{"kind":"Field","name":{"kind":"Name","value":"parentHash"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<BlockWithValidatorFragment, unknown>;
export const EpochWithMembershipsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochWithMemberships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cfeVersion"},"name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"totalMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"slashedEvents"},"name":{"kind":"Name","value":"accountFundingEventsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ACCOUNT_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accountId"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<EpochWithMembershipsFragment, unknown>;
export const AccountWithPossibleValidatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountWithPossibleValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastHeartbeatBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"cfeVersion"},"name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"membership"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epochId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AccountWithPossibleValidatorFragment, unknown>;
export const EventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Event"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"metadatumByMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<EventFragment, unknown>;
export const IgnoredEgressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IgnoredEgress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IgnoredEgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"stateChainErrorByStateChainErrorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<IgnoredEgressFragment, unknown>;
export const SwapFeeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SwapFeeFragment, unknown>;
export const SwapRequestFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"oraclePriceDeltaBps"}},{"kind":"Field","name":{"kind":"Name","value":"oraclePriceDeltaExFeesBps"}},{"kind":"Field","alias":{"kind":"Name","value":"ignoredEgress"},"name":{"kind":"Name","value":"ignoredEgressByIgnoredEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IgnoredEgress"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ignoredRefundEgress"},"name":{"kind":"Name","value":"ignoredEgressByIgnoredRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IgnoredEgress"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"swapFeesBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapFee"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"networkFee"},"name":{"kind":"Name","value":"boostNetworkFeeSplitByBoostedSwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"retryCount"}},{"kind":"Field","name":{"kind":"Name","value":"swapAbortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"swapRescheduledReason"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventBySwapAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"scheduledEvent"},"name":{"kind":"Name","value":"eventBySwapScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedEvent"},"name":{"kind":"Name","value":"eventBySwapExecutedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"swapFeesBySwapId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapFee"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"creditedEvent"},"name":{"kind":"Name","value":"eventByCreditedOnChainEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundedEvent"},"name":{"kind":"Name","value":"eventByRefundedOnChainEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountFundingEvent"},"name":{"kind":"Name","value":"accountFundingEventBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IgnoredEgress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IgnoredEgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"stateChainErrorByStateChainErrorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]} as unknown as DocumentNode<SwapRequestFragment, unknown>;
export const LiquidityBalanceEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityBalanceEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityBalanceEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"txRef"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"withdrawals"},"name":{"kind":"Name","value":"liquidityWithdrawalsByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationDepositChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}}]}}]} as unknown as DocumentNode<LiquidityBalanceEventFragment, unknown>;
export const RefundAddressesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundAddresses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityProvider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bitcoinRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ethereumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"polkadotRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"arbitrumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"solanaRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"assethubRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tronRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bscRefundAddress"}}]}}]} as unknown as DocumentNode<RefundAddressesFragment, unknown>;
export const BlockEventsAndExtrinsicsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockEventsAndExtrinsics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlockDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callName"}},{"kind":"Field","name":{"kind":"Name","value":"callOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"callArgs"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"args"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}}]}}]}}]} as unknown as DocumentNode<BlockEventsAndExtrinsicsFragment, unknown>;
export const RecentPoolOrderEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RecentPoolOrderEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RecentPoolOrderEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"baseAmount"}},{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"quoteAmount"}},{"kind":"Field","name":{"kind":"Name","value":"maximumRate"}},{"kind":"Field","name":{"kind":"Name","value":"minimumRate"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}}]}}]}}]} as unknown as DocumentNode<RecentPoolOrderEventFragment, unknown>;
export const SearchFailedDepositFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchFailedDeposit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapChannel"},"name":{"kind":"Name","value":"swapChannelBySwapDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<SearchFailedDepositFragment, unknown>;
export const SearchSwapChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<SearchSwapChannelFragment, unknown>;
export const SearchLiquidityChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLiquidityChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<SearchLiquidityChannelFragment, unknown>;
export const SearchAccountCreationChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccountCreationChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<SearchAccountCreationChannelFragment, unknown>;
export const SearchAccountFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isTradingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SearchAccountFragment, unknown>;
export const OpenChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpenChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalBrokerCommissionBps"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapsRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OpenChannelFragment, unknown>;
export const BrokerSwapChannelFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrokerSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpenChannel"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpenChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalBrokerCommissionBps"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapsRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<BrokerSwapChannelFragment, unknown>;
export const IgnoredEgressInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IgnoredEgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IgnoredEgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"stateChainErrorByStateChainErrorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<IgnoredEgressInfoFragment, unknown>;
export const LiquidityWithdrawalInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityWithdrawalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityWithdrawal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"nativeEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRefs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]} as unknown as DocumentNode<LiquidityWithdrawalInfoFragment, unknown>;
export const AuthorityMembershipWithEpochFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorityMembershipWithEpoch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorityMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","alias":{"kind":"Name","value":"eventType"},"name":{"kind":"Name","value":"accountFundingEventsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorityMembershipWithEpochFragment, unknown>;
export const ExtrinsicFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Extrinsic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Extrinsic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountBySubmitterId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"metadatumByMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<ExtrinsicFragment, unknown>;
export const AccountFundingEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFundingEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFundingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","alias":{"kind":"Name","value":"rebalanceCounterparty"},"name":{"kind":"Name","value":"accountByRebalanceCounterpartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequest"},"name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<AccountFundingEventFragment, unknown>;
export const EpochFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Epoch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","name":{"kind":"Name","value":"maxAuthoritySetSize"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EpochFragment, unknown>;
export const EpochParticipationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochParticipation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validatorMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withValidator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"operatorEpochesByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<EpochParticipationFragment, unknown>;
export const AuthorityMembershipWithValidatorFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorityMembershipWithValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorityMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"fundingEvents"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthorityMembershipWithValidatorFragment, unknown>;
export const PoolSwapFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PoolSwapFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Swap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapFeesBySwapId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<PoolSwapFieldsFragment, unknown>;
export const RedeemedEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedeemedEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFundingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"redeemedTxHash"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]} as unknown as DocumentNode<RedeemedEventFragment, unknown>;
export const EventWithBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventWithBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]} as unknown as DocumentNode<EventWithBlockFragment, unknown>;
export const EpochWithRotationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochWithRotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rotationEvents"},"name":{"kind":"Name","value":"rotationEventsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventWithBlock"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventWithBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]} as unknown as DocumentNode<EpochWithRotationFragment, unknown>;
export const GetAccountTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountTypeQuery, GetAccountTypeQueryVariables>;
export const PaginatedPenaltiesQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paginatedPenaltiesQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startBlockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPenalties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startBlockId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Penalty"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Penalty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Penalty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<PaginatedPenaltiesQueryQuery, PaginatedPenaltiesQueryQueryVariables>;
export const GetTotalBlockCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTotalBlockCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestBlock"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totalCount"},"name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetTotalBlockCountQuery, GetTotalBlockCountQueryVariables>;
export const ArchiveInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArchiveInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"archiveInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lastArchivedBlock"}}]}}]}}]} as unknown as DocumentNode<ArchiveInfoQuery, ArchiveInfoQueryVariables>;
export const GetAllBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockListBlock"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllBlocksQuery, GetAllBlocksQueryVariables>;
export const GetBlockCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBlockCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startBlockHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endBlockHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBlockCounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startBlockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startBlockHeight"}}},{"kind":"Argument","name":{"kind":"Name","value":"endBlockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endBlockHeight"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicsCount"}},{"kind":"Field","name":{"kind":"Name","value":"eventsCount"}}]}}]}}]} as unknown as DocumentNode<GetBlockCountsQuery, GetBlockCountsQueryVariables>;
export const GetBlocksEventsAndExtrinsicsCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlocksEventsAndExtrinsicsCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startBlockHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endBlockHeight"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getBlocksDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"startBlockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startBlockHeight"}}},{"kind":"Argument","name":{"kind":"Name","value":"endBlockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endBlockHeight"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsicsCount"}},{"kind":"Field","name":{"kind":"Name","value":"eventsCount"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}}]}}]}}]}}]} as unknown as DocumentNode<GetBlocksEventsAndExtrinsicsCountQuery, GetBlocksEventsAndExtrinsicsCountQueryVariables>;
export const GetBlockByHashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlockByHash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockWithValidator"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eventsAndExtrinsics"},"name":{"kind":"Name","value":"getBlockDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockEventsAndExtrinsics"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastBlocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockWithValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"stateRoot"}},{"kind":"Field","name":{"kind":"Name","value":"parentHash"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockEventsAndExtrinsics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlockDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callName"}},{"kind":"Field","name":{"kind":"Name","value":"callOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"callArgs"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"args"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}}]}}]}}]} as unknown as DocumentNode<GetBlockByHashQuery, GetBlockByHashQueryVariables>;
export const GetBlockByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getBlockById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockWithValidator"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eventsAndExtrinsics"},"name":{"kind":"Name","value":"getBlockDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"blockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockEventsAndExtrinsics"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastBlocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockWithValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"stateRoot"}},{"kind":"Field","name":{"kind":"Name","value":"parentHash"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockEventsAndExtrinsics"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BlockDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callName"}},{"kind":"Field","name":{"kind":"Name","value":"callOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"callArgs"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"phase"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"args"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}}]}}]}}]} as unknown as DocumentNode<GetBlockByIdQuery, GetBlockByIdQueryVariables>;
export const GetBrokerAccountMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokerAccountMetaData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionStartDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"commissionEndDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"affiliates"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"AFFILIATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"submitters"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"SUBMITTER"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"beneficiary"},"name":{"kind":"Name","value":"swapRequestBeneficiariesByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requestedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionStartDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"commissionEndDate"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}}]}},{"kind":"Field","name":{"kind":"Name","value":"min"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventByRegistratonEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokerAccountMetaDataQuery, GetBrokerAccountMetaDataQueryVariables>;
export const GetBrokerFeeAndWithdrawalDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBrokerFeeAndWithdrawalData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BrokerFeeAndWithdrawalV2Filter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BrokerFeeAndWithdrawalV2SOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"feesAndWithdrawals"},"name":{"kind":"Name","value":"brokerFeeAndWithdrawalV2SByBrokerId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"brokerByAffiliatedWithBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"swapsBySwapExecutedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapRequest"},"name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBrokerFeeAndWithdrawalDataQuery, GetBrokerFeeAndWithdrawalDataQueryVariables>;
export const GetChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipChain"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByIssuedBlockIdAndChainAndChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannelChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByIssuedBlockIdAndChainAndChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiquidityDepositChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapChannel"},"name":{"kind":"Name","value":"swapChannelByIssuedBlockIdAndSourceChainAndChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"Argument","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}},{"kind":"Argument","name":{"kind":"Name","value":"sourceChain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapChannelInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FailedDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"refs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelDepositInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"txRefs"},"name":{"kind":"Name","value":"transactionRefsByLiquidityDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequests"},"name":{"kind":"Name","value":"swapRequestsByAccountCreationDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityDepositChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsBySwapDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FailedDepositInfo"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"beneficiaries"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"commissions"},"name":{"kind":"Name","value":"swapCommissionsBySwapChannelBeneficiaryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"asset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}}]}}]}}]}}]} as unknown as DocumentNode<GetChannelQuery, GetChannelQueryVariables>;
export const GetActiveAuthorityInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getActiveAuthorityInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpochWithMemberships"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lastBlock"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochWithMemberships"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"cfeVersion"},"name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"totalMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"slashedEvents"},"name":{"kind":"Name","value":"accountFundingEventsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ACCOUNT_ID"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accountId"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetActiveAuthorityInfoQuery, GetActiveAuthorityInfoQueryVariables>;
export const GetValidatorLatestBlockInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getValidatorLatestBlockInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountWithPossibleValidator"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountWithPossibleValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"boundRedeemAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastHeartbeatBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"cfeVersion"},"name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"membership"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epochId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorLatestBlockInfoQuery, GetValidatorLatestBlockInfoQueryVariables>;
export const GetEventsByBlockIdAndIndexDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventsByBlockIdAndIndex"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"index"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"allEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"indexInBlock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"metadatumByMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"chainspec"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"eventWithExtrinsicHash"},"name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"indexInBlock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"index"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"args"}}]}}]}}]} as unknown as DocumentNode<GetEventsByBlockIdAndIndexQuery, GetEventsByBlockIdAndIndexQueryVariables>;
export const GetExtrinsicSuccessMetadataIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetExtrinsicSuccessMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"allMetadata"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"System.ExtrinsicSuccess","block":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetExtrinsicSuccessMetadataIdQuery, GetExtrinsicSuccessMetadataIdQueryVariables>;
export const GetRecentEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRecentEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"excludeMetadataId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventsByBlockId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"metadataId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"excludeMetadataId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"metadatumByMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetRecentEventsQuery, GetRecentEventsQueryVariables>;
export const GetExtrinsicByHashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExtrinsicByHash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"extrinsic"},"name":{"kind":"Name","value":"getExtrinsic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callName"}},{"kind":"Field","name":{"kind":"Name","value":"callOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"callArgs"}}]}}]}}]} as unknown as DocumentNode<GetExtrinsicByHashQuery, GetExtrinsicByHashQueryVariables>;
export const GetLastLiquidityDepositDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLastLiquidityDeposit"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"allLiquidityDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"asset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLastLiquidityDepositQuery, GetLastLiquidityDepositQueryVariables>;
export const GetAllOpenLpDepositChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllOpenLpDepositChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ISSUED_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isExpired"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]} as unknown as DocumentNode<GetAllOpenLpDepositChannelsQuery, GetAllOpenLpDepositChannelsQueryVariables>;
export const GetLpAccountWithRefundAddressesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLpAccountWithRefundAddresses"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RefundAddresses"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RefundAddresses"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityProvider"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bitcoinRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ethereumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"polkadotRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"arbitrumRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"solanaRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"assethubRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"tronRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"bscRefundAddress"}}]}}]} as unknown as DocumentNode<GetLpAccountWithRefundAddressesQuery, GetLpAccountWithRefundAddressesQueryVariables>;
export const GetPoolAggregatesByDateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoolAggregatesByDate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startingTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endingTimestamp"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"poolSwaps"},"name":{"kind":"Name","value":"allPoolSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetSwappedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startingTimestamp"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endingTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FROM_ASSET"},{"kind":"EnumValue","value":"TO_ASSET"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fromAssetToAsset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPoolAggregatesByDateQuery, GetPoolAggregatesByDateQueryVariables>;
export const GetBurnInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBurnInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"historicalBurn"},"name":{"kind":"Name","value":"allBurns"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxTimestamp"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentBurn"},"name":{"kind":"Name","value":"allBurns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalAmount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetBurnInfoQuery, GetBurnInfoQueryVariables>;
export const GetStringSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetStringSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"swapFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequestFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"swapChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liquidityChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountCreationChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"allSwapRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"swapFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapChannels"},"name":{"kind":"Name","value":"allSwapChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"swapChannelFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchSwapChannel"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannels"},"name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liquidityChannelFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchLiquidityChannel"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannels"},"name":{"kind":"Name","value":"allAccountCreationDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountCreationChannelFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchAccountCreationChannel"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"hash"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"txRefs"},"name":{"kind":"Name","value":"allTransactionRefs"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ref"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swap"},"name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposit"},"name":{"kind":"Name","value":"failedDepositByFailedDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchFailedDeposit"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressesByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapRequests"},"name":{"kind":"Name","value":"swapRequestsByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundedSwapRequests"},"name":{"kind":"Name","value":"swapRequestsByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityWithdrawals"},"name":{"kind":"Name","value":"liquidityWithdrawalsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"failedDepositsByRefundBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchFailedDeposit"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpDeposit"},"name":{"kind":"Name","value":"liquidityDepositByLiquidityDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ALIAS_ASC"},{"kind":"EnumValue","value":"ID_SS58_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchAccount"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"extrinsic"},"name":{"kind":"Name","value":"getExtrinsic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"hash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"brokerVaultAddresses"},"name":{"kind":"Name","value":"allBrokerVaultAddresses"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"address"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalToInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLiquidityChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccountCreationChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchFailedDeposit"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDeposit"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapChannel"},"name":{"kind":"Name","value":"swapChannelBySwapDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccount"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Account"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isTradingStrategy"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetStringSearchResultsQuery, GetStringSearchResultsQueryVariables>;
export const GetIndexInBlockSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIndexInBlockSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"indexInBlock"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"getEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"indexInBlock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indexInBlock"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"extrinsic"},"name":{"kind":"Name","value":"getExtrinsic"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"block"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"height"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"indexInBlock"},"value":{"kind":"Variable","name":{"kind":"Name","value":"indexInBlock"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockHeight"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}}]} as unknown as DocumentNode<GetIndexInBlockSearchResultsQuery, GetIndexInBlockSearchResultsQueryVariables>;
export const GetNumericSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNumericSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"intValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bigIntValue"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"allSwapRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nativeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bigIntValue"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"blocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intValue"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"epochs"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"intValue"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetNumericSearchResultsQuery, GetNumericSearchResultsQueryVariables>;
export const GetChannelSearchResultsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChannelSearchResults"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipChain"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapChannels"},"name":{"kind":"Name","value":"allSwapChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"sourceChain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchSwapChannel"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpChannels"},"name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchLiquidityChannel"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannels"},"name":{"kind":"Name","value":"allAccountCreationDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"channelId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchAccountCreationChannel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLiquidityChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccountCreationChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<GetChannelSearchResultsQuery, GetChannelSearchResultsQueryVariables>;
export const GetSearchResultCountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSearchResultCounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"swapFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequestFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"swapChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liquidityChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountCreationChannelFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"brokerFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"liquidityProviderFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorFilter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"allSwapRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"swapFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapChannels"},"name":{"kind":"Name","value":"allSwapChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"swapChannelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannels"},"name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liquidityChannelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannels"},"name":{"kind":"Name","value":"allAccountCreationDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountCreationChannelFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"brokers"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"brokerFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityProviders"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"liquidityProviderFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operators"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetSearchResultCountsQuery, GetSearchResultCountsQueryVariables>;
export const GetSwapSearchResultsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapSearchResultsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequestFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSwapRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}}]}}]}}]} as unknown as DocumentNode<GetSwapSearchResultsPageQuery, GetSwapSearchResultsPageQueryVariables>;
export const GetSwapChannelSearchResultsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapChannelSearchResultsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSwapChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchSwapChannel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<GetSwapChannelSearchResultsPageQuery, GetSwapChannelSearchResultsPageQueryVariables>;
export const GetLiquidityChannelSearchResultsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLiquidityChannelSearchResultsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchLiquidityChannel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchLiquidityChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<GetLiquidityChannelSearchResultsPageQuery, GetLiquidityChannelSearchResultsPageQueryVariables>;
export const GetAccountCreationChannelSearchResultsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountCreationChannelSearchResultsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannelFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAccountCreationDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SearchAccountCreationChannel"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchAccountCreationChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]} as unknown as DocumentNode<GetAccountCreationChannelSearchResultsPageQuery, GetAccountCreationChannelSearchResultsPageQueryVariables>;
export const GetAccountSearchResultsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountSearchResultsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"ALIAS_ASC"},{"kind":"EnumValue","value":"ID_SS58_ASC"}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountSearchResultsPageQuery, GetAccountSearchResultsPageQueryVariables>;
export const GetSwapByNativeIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapByNativeId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nativeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapRequest"},"name":{"kind":"Name","value":"swapRequestByNativeId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nativeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nativeId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequest"}},{"kind":"Field","alias":{"kind":"Name","value":"beneficiaries"},"name":{"kind":"Name","value":"swapRequestBeneficiariesBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"TYPE_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"commissions"},"name":{"kind":"Name","value":"swapCommissionsBySwapRequestBeneficiaryId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"ASSET"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"asset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BroadcastInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Broadcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"broadcastRequestedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastAbortedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByBroadcastRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EgressInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Egress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"fallbackDestinationAddress"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"failedEvent"},"name":{"kind":"Name","value":"eventByFailedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BroadcastInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChannelInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"issuedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountCreationDepositChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"depositChainExpiryBlock"}},{"kind":"Field","name":{"kind":"Name","value":"refundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"lpAccount"},"name":{"kind":"Name","value":"accountByCreatedAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"issuedBlock"},"name":{"kind":"Name","value":"blockByIssuedBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequestOverview"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","name":{"kind":"Name","value":"depositValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"ignoredRefundEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"ccmGasBudget"}},{"kind":"Field","name":{"kind":"Name","value":"completedEventId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"fokMinPriceX128"}},{"kind":"Field","name":{"kind":"Name","value":"fokRetryDurationBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","name":{"kind":"Name","value":"dcaChunkIntervalBlocks"}},{"kind":"Field","name":{"kind":"Name","value":"requestedBlockTimestamp"}},{"kind":"Field","name":{"kind":"Name","value":"completedBlockTimestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"egress"},"name":{"kind":"Name","value":"egressByEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundEgress"},"name":{"kind":"Name","value":"egressByRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fallbackEgress"},"name":{"kind":"Name","value":"egressByFallbackEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EgressInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"channel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChannelInfo"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountCreationDepositChannelOverview"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"preDepositBlock"},"name":{"kind":"Name","value":"foreignChainTrackingByForeignChainPreDepositBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stateChainTimestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"requestedEvent"},"name":{"kind":"Name","value":"eventByRequestedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidationSwapInfo"},"name":{"kind":"Name","value":"liquidationSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loanId"}},{"kind":"Field","name":{"kind":"Name","value":"liquidationType"}},{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"outputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"abortedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"completedAtEventId"}},{"kind":"Field","name":{"kind":"Name","value":"abortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidAmount"}},{"kind":"Field","name":{"kind":"Name","value":"loanRepaidValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"collateralAddedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByAbortedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"completedEvent"},"name":{"kind":"Name","value":"eventByCompletedAtEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"borrower"},"name":{"kind":"Name","value":"accountByBorrowerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"loanRepaidEvent"},"name":{"kind":"Name","value":"eventByLoanRepaidEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"collateralAddedEvent"},"name":{"kind":"Name","value":"eventByCollateralAddedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"IgnoredEgress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IgnoredEgress"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"stateChainErrorByStateChainErrorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"docs"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapFee"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapFee"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SwapRequest"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapRequest"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapRequestOverview"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"fokMaxOraclePriceSlippageBps"}},{"kind":"Field","name":{"kind":"Name","value":"oraclePriceDeltaBps"}},{"kind":"Field","name":{"kind":"Name","value":"oraclePriceDeltaExFeesBps"}},{"kind":"Field","alias":{"kind":"Name","value":"ignoredEgress"},"name":{"kind":"Name","value":"ignoredEgressByIgnoredEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IgnoredEgress"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"ignoredRefundEgress"},"name":{"kind":"Name","value":"ignoredEgressByIgnoredRefundEgressId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"IgnoredEgress"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRef"},"name":{"kind":"Name","value":"transactionRefsBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"swapFeesBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapFee"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"networkFee"},"name":{"kind":"Name","value":"boostNetworkFeeSplitByBoostedSwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"NATIVE_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"EnumValue","value":"GAS"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"retryCount"}},{"kind":"Field","name":{"kind":"Name","value":"swapAbortedReason"}},{"kind":"Field","name":{"kind":"Name","value":"swapRescheduledReason"}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventBySwapAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"scheduledEvent"},"name":{"kind":"Name","value":"eventBySwapScheduledEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"executedEvent"},"name":{"kind":"Name","value":"eventBySwapExecutedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"fees"},"name":{"kind":"Name","value":"swapFeesBySwapId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SwapFee"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"onChainSwapInfo"},"name":{"kind":"Name","value":"onChainSwapInfoBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"outputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"refundAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"creditedEvent"},"name":{"kind":"Name","value":"eventByCreditedOnChainEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"refundedEvent"},"name":{"kind":"Name","value":"eventByRefundedOnChainEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountFundingEvent"},"name":{"kind":"Name","value":"accountFundingEventBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSwapByNativeIdQuery, GetSwapByNativeIdQueryVariables>;
export const GetOpenSwapChannelsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOpenSwapChannels"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channels"},"name":{"kind":"Name","value":"allSwapChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isExpired"},"value":{"kind":"BooleanValue","value":false}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ISSUED_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpenChannel"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpenChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalBrokerCommissionBps"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapsRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOpenSwapChannelsQuery, GetOpenSwapChannelsQueryVariables>;
export const GetSwapChannelsByBrokerIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapChannelsByBrokerId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channels"},"name":{"kind":"Name","value":"swapChannelsByBrokerId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ISSUED_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrokerSwapChannel"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpenChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalBrokerCommissionBps"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapsRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrokerSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpenChannel"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}}]}}]} as unknown as DocumentNode<GetSwapChannelsByBrokerIdQuery, GetSwapChannelsByBrokerIdQueryVariables>;
export const GetSwapChannelsByAffiliateBrokerIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapChannelsByAffiliateBrokerId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"beneficiaryChannels"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"DEPOSIT_CHANNEL_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"AFFILIATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"swapChannel"},"name":{"kind":"Name","value":"swapChannelByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BrokerSwapChannel"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"OpenChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"totalBrokerCommissionBps"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAddress"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationChain"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}},{"kind":"Field","name":{"kind":"Name","value":"fokRefundAddress"}},{"kind":"Field","name":{"kind":"Name","value":"dcaNumberOfChunks"}},{"kind":"Field","alias":{"kind":"Name","value":"issuedEvent"},"name":{"kind":"Name","value":"eventByIssuedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapsRequests"},"name":{"kind":"Name","value":"swapRequestsByDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"executedSwaps"},"name":{"kind":"Name","value":"swapsBySwapRequestId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BrokerSwapChannel"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SwapChannel"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OpenChannel"}},{"kind":"Field","name":{"kind":"Name","value":"isExpired"}},{"kind":"Field","name":{"kind":"Name","value":"openingFeePaid"}}]}}]} as unknown as DocumentNode<GetSwapChannelsByAffiliateBrokerIdQuery, GetSwapChannelsByAffiliateBrokerIdQueryVariables>;
export const GetFailedDepositByTxRefDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFailedDepositByTxRef"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"txRef"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"txRef"},"name":{"kind":"Name","value":"transactionRefByRef"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"ref"},"value":{"kind":"Variable","name":{"kind":"Name","value":"txRef"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"failedDeposit"},"name":{"kind":"Name","value":"failedDepositByFailedDepositId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]}}]} as unknown as DocumentNode<GetFailedDepositByTxRefQuery, GetFailedDepositByTxRefQueryVariables>;
export const GetFailedDepositBySwapDepositChannelIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFailedDepositBySwapDepositChannelId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"depositChannelId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"failedDeposits"},"name":{"kind":"Name","value":"allFailedDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapDepositChannelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"depositChannelId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}}]}}]}}]}}]} as unknown as DocumentNode<GetFailedDepositBySwapDepositChannelIdQuery, GetFailedDepositBySwapDepositChannelIdQueryVariables>;
export const GetLiquidityWithdrawalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLiquidityWithdrawal"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nativeEgressId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipChain"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"liquidityWithdrawal"},"name":{"kind":"Name","value":"liquidityWithdrawalByNativeEgressIdAndChain"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"nativeEgressId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nativeEgressId"}}},{"kind":"Argument","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiquidityWithdrawalInfo"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityWithdrawalInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityWithdrawal"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"feeUsd"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"nativeEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"withdrawalAddress"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByLiquidityProviderId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"transactionPayload"}},{"kind":"Field","alias":{"kind":"Name","value":"successEvent"},"name":{"kind":"Name","value":"eventByBroadcastSuccessEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"abortedEvent"},"name":{"kind":"Name","value":"eventByBroadcastAbortedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"transactionRefs"},"name":{"kind":"Name","value":"transactionRefsByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ref"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLiquidityWithdrawalQuery, GetLiquidityWithdrawalQueryVariables>;
export const LpDelegationActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LpDelegationActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<LpDelegationActivityQuery, LpDelegationActivityQueryVariables>;
export const AccountFundingEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccountFundingEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"allAccountFundingEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountFundingEvent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFundingEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFundingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","alias":{"kind":"Name","value":"rebalanceCounterparty"},"name":{"kind":"Name","value":"accountByRebalanceCounterpartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequest"},"name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<AccountFundingEventsQuery, AccountFundingEventsQueryVariables>;
export const LpDelegationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LpDelegationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOperatorEpochDelegations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"losses"}},{"kind":"Field","name":{"kind":"Name","value":"lossesValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpoch"},"name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<LpDelegationHistoryQuery, LpDelegationHistoryQueryVariables>;
export const GetDepositsForSpecificLiquidityDepositChannelDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDepositsForSpecificLiquidityDepositChannel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"chain"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipChain"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"channels"},"name":{"kind":"Name","value":"allLiquidityDepositChannels"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"channelId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"channelId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"chain"},"value":{"kind":"Variable","name":{"kind":"Name","value":"chain"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"issuedBlockId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"issuedBlockId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","alias":{"kind":"Name","value":"deposits"},"name":{"kind":"Name","value":"liquidityDepositsByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"depositAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"depositAddress"}}]}}]}}]}}]} as unknown as DocumentNode<GetDepositsForSpecificLiquidityDepositChannelQuery, GetDepositsForSpecificLiquidityDepositChannelQueryVariables>;
export const GetDelegatorsDailyRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegatorsDailyRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsDailies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DELEGATOR"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earnings"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegatorsDailyRewardsQuery, GetDelegatorsDailyRewardsQueryVariables>;
export const GetDelegatorsTotalRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegatorsTotalRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsDailies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DELEGATOR"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"earnings"}},{"kind":"Field","name":{"kind":"Name","value":"earningsValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegatorsTotalRewardsQuery, GetDelegatorsTotalRewardsQueryVariables>;
export const GetOperatorsRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorsRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operators"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operators"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"operatorEpoch"},"name":{"kind":"Name","value":"operatorEpochesByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"amount"},"name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"valueUsd"},"name":{"kind":"Name","value":"operatorRewardValueUsd"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorsRewardsQuery, GetOperatorsRewardsQueryVariables>;
export const GetSpecificPoolSwapsDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSpecificPoolSwapsData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"quoteAsset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentDayAggregates"},"name":{"kind":"Name","value":"allPoolSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetSwappedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Variable","name":{"kind":"Name","value":"quoteAsset"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"toAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Variable","name":{"kind":"Name","value":"quoteAsset"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FROM_ASSET"},{"kind":"EnumValue","value":"TO_ASSET"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fromAssetToAsset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousDayAggregates"},"name":{"kind":"Name","value":"allPoolSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetSwappedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"fromAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Variable","name":{"kind":"Name","value":"quoteAsset"}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"toAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Variable","name":{"kind":"Name","value":"quoteAsset"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FROM_ASSET"},{"kind":"EnumValue","value":"TO_ASSET"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fromAssetToAsset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"liquidityFeeValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSpecificPoolSwapsDataQuery, GetSpecificPoolSwapsDataQueryVariables>;
export const GetFailedDepositsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFailedDeposits"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDepositFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDepositsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allFailedDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"depositAsset"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapChannel"},"name":{"kind":"Name","value":"swapChannelBySwapDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"chain"},"name":{"kind":"Name","value":"sourceChain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"affiliates"},"name":{"kind":"Name","value":"swapChannelBeneficiariesByDepositChannelId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"AFFILIATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brokerCommissionRateBps"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"liquidityChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"brokerChannel"},"name":{"kind":"Name","value":"brokerChannelByBrokerChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","alias":{"kind":"Name","value":"broker"},"name":{"kind":"Name","value":"brokerByBrokerId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFailedDepositsQuery, GetFailedDepositsQueryVariables>;
export const GetFailedDepositReasonsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFailedDepositReasons"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"FailedDepositFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allFailedDeposits"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFailedDepositReasonsQuery, GetFailedDepositReasonsQueryVariables>;
export const GetFailedDepositBrokersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFailedDepositBrokers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allBrokers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapChannelsByBrokerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"failedDepositsBySwapDepositChannelIdExist"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"brokerChannelsByBrokerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"failedDepositsByBrokerChannelIdExist"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountCreationDepositChannelsByBrokerId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"some"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"failedDepositsByAccountCreationDepositChannelIdExist"},"value":{"kind":"BooleanValue","value":true}}]}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFailedDepositBrokersQuery, GetFailedDepositBrokersQueryVariables>;
export const GetSwapExecutionBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSwapExecutionBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"nativeIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BigInt"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"nativeId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"nativeIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","alias":{"kind":"Name","value":"executedEvent"},"name":{"kind":"Name","value":"eventBySwapExecutedEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetSwapExecutionBlocksQuery, GetSwapExecutionBlocksQueryVariables>;
export const GetOraclePricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOraclePrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriceAsset"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minBlock"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxBlock"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOraclePriceTrackings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"baseAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAssets"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"quoteAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"Usd"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priceValidFromBlock"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxBlock"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priceValidToBlock"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"isNull"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"priceValidToBlock"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minBlock"}}}]}}]}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"baseAsset"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"priceValidFromBlock"}},{"kind":"Field","name":{"kind":"Name","value":"priceValidToBlock"}}]}}]}}]}}]} as unknown as DocumentNode<GetOraclePricesQuery, GetOraclePricesQueryVariables>;
export const GetFundingEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getFundingEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"allAccountFundingEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccountFundingEvent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccountFundingEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFundingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","alias":{"kind":"Name","value":"rebalanceCounterparty"},"name":{"kind":"Name","value":"accountByRebalanceCounterpartyId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"swapRequest"},"name":{"kind":"Name","value":"swapRequestBySwapRequestId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}}]}}]}}]} as unknown as DocumentNode<GetFundingEventsQuery, GetFundingEventsQueryVariables>;
export const GetValidatorsByAccountIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getValidatorsByAccountIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorsByAccountIdsQuery, GetValidatorsByAccountIdsQueryVariables>;
export const PaginatedPenaltiesByValidatorQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"paginatedPenaltiesByValidatorQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"penalties"},"name":{"kind":"Name","value":"allPenalties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Penalty"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Penalty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Penalty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<PaginatedPenaltiesByValidatorQueryQuery, PaginatedPenaltiesByValidatorQueryQueryVariables>;
export const TotalValidatorRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TotalValidatorRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<TotalValidatorRewardsQuery, TotalValidatorRewardsQueryVariables>;
export const GetAllEpochsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAllEpochs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withValidator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withOperator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epochs"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Epoch"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpochParticipation"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Epoch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","name":{"kind":"Name","value":"maxAuthoritySetSize"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochParticipation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validatorMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withValidator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"operatorEpochesByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetAllEpochsQuery, GetAllEpochsQueryVariables>;
export const GetEpochsByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getEpochsById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withValidator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withOperator"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"defaultValue":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Epoch"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpochParticipation"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Epoch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","name":{"kind":"Name","value":"maxAuthoritySetSize"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochParticipation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validatorMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withValidator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"operatorEpochesByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withOperator"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetEpochsByIdQuery, GetEpochsByIdQueryVariables>;
export const GetAuthorityMembershipsForEpochDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthorityMembershipsForEpoch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorityMembershipWithValidator"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorityMembershipWithValidator"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorityMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bid"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","alias":{"kind":"Name","value":"fundingEvents"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}},{"kind":"Field","name":{"kind":"Name","value":"keys"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorityMembershipsForEpochQuery, GetAuthorityMembershipsForEpochQueryVariables>;
export const GetOnlineAuthorityMemberInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getOnlineAuthorityMemberInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minEpochStartBlockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorityHeartbeatGroupBy"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epochs"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"startBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minEpochStartBlockId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epochId"},"name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"members"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"heartbeats"},"name":{"kind":"Name","value":"authorityHeartbeatsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"periodStartUTC"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"distinctCount"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"validatorId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOnlineAuthorityMemberInfoQuery, GetOnlineAuthorityMemberInfoQueryVariables>;
export const GetAuthorityMembershipsForValidatorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAuthorityMembershipsForValidator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AuthorityMembershipWithEpoch"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AuthorityMembershipWithEpoch"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AuthorityMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","alias":{"kind":"Name","value":"eventType"},"name":{"kind":"Name","value":"accountFundingEventsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"EnumValue","value":"TYPE"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"type"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorityMembershipsForValidatorQuery, GetAuthorityMembershipsForValidatorQueryVariables>;
export const GetDelegatingSinceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegatingSince"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"activity"},"name":{"kind":"Name","value":"delegationActivitiesByDelegatorAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"DELEGATE"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegatingSinceQuery, GetDelegatingSinceQueryVariables>;
export const GetDelegationRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"rewards"},"name":{"kind":"Name","value":"latestDelegationRewardsByDelegatorAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegationRewardsQuery, GetDelegationRewardsQueryVariables>;
export const GetDelegationPositionBoundariesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationPositionBoundaries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"boundaries"},"name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DELEGATE"},{"kind":"EnumValue","value":"UNDELEGATE"}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_ASC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegationPositionBoundariesQuery, GetDelegationPositionBoundariesQueryVariables>;
export const GetDelegationPositionRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationPositionRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rewards"},"name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"REWARD"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegationPositionRewardsQuery, GetDelegationPositionRewardsQueryVariables>;
export const OperatorApysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OperatorApys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"apys"},"name":{"kind":"Name","value":"operatorEpochDelegationApiesByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"apyBp"}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OperatorApysQuery, OperatorApysQueryVariables>;
export const GetOperatorDelegationActivitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorDelegationActivities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetOperatorDelegationActivitiesQuery, GetOperatorDelegationActivitiesQueryVariables>;
export const GetOperatorRewardsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorRewardsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOperatorEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetOperatorRewardsHistoryQuery, GetOperatorRewardsHistoryQueryVariables>;
export const GetValidatorRewardsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorRewardsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetValidatorRewardsHistoryQuery, GetValidatorRewardsHistoryQueryVariables>;
export const HistoricalValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HistoricalValidators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"links"},"name":{"kind":"Name","value":"allOperatorValidatorLinks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alias"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<HistoricalValidatorsQuery, HistoricalValidatorsQueryVariables>;
export const ParticipantLatestApysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantLatestApys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkParticipantRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accounts"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsHourlies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accounts"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy720H"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantLatestApysQuery, ParticipantLatestApysQueryVariables>;
export const ParticipantApyRatiosDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantApyRatios"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkParticipantRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accounts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsHourlies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accounts"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"BLOCK_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","name":{"kind":"Name","value":"block"}},{"kind":"Field","name":{"kind":"Name","value":"ratio"}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantApyRatiosQuery, ParticipantApyRatiosQueryVariables>;
export const ParticipantDailyApysDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantDailyApys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkParticipantRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"minActiveHours"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsDailies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"activeHours"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"minActiveHours"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"day"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"DAY"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectedApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy720H"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantDailyApysQuery, ParticipantDailyApysQueryVariables>;
export const ParticipantTodayApyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ParticipantTodayApy"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"role"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"NetworkParticipantRole"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"since"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allNetworkParticipantEarningsHourlies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"role"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"since"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"projectedApy6H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy24H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy72H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy168H"}},{"kind":"Field","name":{"kind":"Name","value":"projectedApy720H"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ParticipantTodayApyQuery, ParticipantTodayApyQueryVariables>;
export const GetExtrinsicsAndEventsByBlockIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExtrinsicsAndEventsByBlockId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"details"},"name":{"kind":"Name","value":"getBlockDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"blockHeight"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"extrinsics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callName"}},{"kind":"Field","name":{"kind":"Name","value":"callOrigin"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"callArgs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"events"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"extrinsicHash"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockById"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"blockId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<GetExtrinsicsAndEventsByBlockIdQuery, GetExtrinsicsAndEventsByBlockIdQueryVariables>;
export const GetExtrinsicsByAccountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getExtrinsicsByAccount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"last"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"before"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Cursor"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"extrinsics"},"name":{"kind":"Name","value":"allExtrinsics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountBySubmitterId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"before"},"value":{"kind":"Variable","name":{"kind":"Name","value":"before"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"last"},"value":{"kind":"Variable","name":{"kind":"Name","value":"last"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Extrinsic"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Extrinsic"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Extrinsic"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fee"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"signature"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"tip"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountBySubmitterId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"metadata"},"name":{"kind":"Name","value":"metadatumByMetadataId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<GetExtrinsicsByAccountQuery, GetExtrinsicsByAccountQueryVariables>;
export const GetLiquidityBalanceChangeEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLiquidityBalanceChangeEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lp"},"name":{"kind":"Name","value":"liquidityProviderByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"liquidityBalanceEventsByLiquidityProviderId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LiquidityBalanceEvent"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LiquidityBalanceEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LiquidityBalanceEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"txRef"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"eventId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"withdrawals"},"name":{"kind":"Name","value":"liquidityWithdrawalsByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nativeEgressId"}},{"kind":"Field","name":{"kind":"Name","value":"chain"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"depositChannel"},"name":{"kind":"Name","value":"liquidityDepositChannelByLiquidityDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"accountCreationDepositChannel"},"name":{"kind":"Name","value":"accountCreationDepositChannelByAccountCreationDepositChannelId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"channelId"}},{"kind":"Field","name":{"kind":"Name","value":"issuedBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"maxBoostFeeBps"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"broadcast"},"name":{"kind":"Name","value":"broadcastByBroadcastId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"broadcastSuccessEventId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"effectiveBoostFeeBps"}}]}}]} as unknown as DocumentNode<GetLiquidityBalanceChangeEventsQuery, GetLiquidityBalanceChangeEventsQueryVariables>;
export const GetPoolTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoolTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentDayAggregates"},"name":{"kind":"Name","value":"allPoolSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetSwappedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FROM_ASSET"},{"kind":"EnumValue","value":"TO_ASSET"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fromAssetToAsset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"previousDayAggregates"},"name":{"kind":"Name","value":"allPoolSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"assetSwappedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date48HoursAgo"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"lessThan"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date24HoursAgo"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"groupedAggregates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FROM_ASSET"},{"kind":"EnumValue","value":"TO_ASSET"}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"fromAssetToAsset"},"name":{"kind":"Name","value":"keys"}},{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPoolTableDataQuery, GetPoolTableDataQueryVariables>;
export const GetPoolLastPricesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPoolLastPrices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"latestSwapTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"earliestSwapTimestamp"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestSwap"},"name":{"kind":"Name","value":"allSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"SWAP_EXECUTED_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"latestSwapTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapInputAmount"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapOutputAmount"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapOutputValueUsd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SWAP"},{"kind":"EnumValue","value":"PRINCIPAL"},{"kind":"EnumValue","value":"GAS"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"destinationAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PoolSwapFields"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"earliestSwap"},"name":{"kind":"Name","value":"allSwaps"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"SWAP_EXECUTED_EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"swapExecutedBlockTimestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"lessThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"earliestSwapTimestamp"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapInputAmount"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapOutputAmount"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"swapOutputValueUsd"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThan"},"value":{"kind":"StringValue","value":"0","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"SWAP"},{"kind":"EnumValue","value":"PRINCIPAL"},{"kind":"EnumValue","value":"GAS"}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"sourceAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"destinationAsset"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"baseAsset"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PoolSwapFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PoolSwapFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Swap"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"nativeId"}},{"kind":"Field","name":{"kind":"Name","value":"sourceAsset"}},{"kind":"Field","name":{"kind":"Name","value":"destinationAsset"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapInputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputAmount"}},{"kind":"Field","name":{"kind":"Name","value":"swapOutputValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateAmount"}},{"kind":"Field","name":{"kind":"Name","value":"intermediateValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"swapFeesBySwapId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<GetPoolLastPricesQuery, GetPoolLastPricesQueryVariables>;
export const GetMarketDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMarketData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"asset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ChainflipAsset"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDays"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"asset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"asset"}}},{"kind":"Argument","name":{"kind":"Name","value":"numberOfDays"},"value":{"kind":"Variable","name":{"kind":"Name","value":"numberOfDays"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"candlesticks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CandlestickData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"open"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"high"}},{"kind":"Field","name":{"kind":"Name","value":"close"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhitespaceData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"volumes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HistogramData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"time"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WhitespaceData"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"prices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"globalVolume"}}]}}]}}]} as unknown as DocumentNode<GetMarketDataQuery, GetMarketDataQueryVariables>;
export const GetChainTrackingQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetChainTrackingQuery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allChainTrackings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chain"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]} as unknown as DocumentNode<GetChainTrackingQueryQuery, GetChainTrackingQueryQueryVariables>;
export const GetLatestEpochsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestEpochs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestEpoch"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EpochWithRotation"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventWithBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Event"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"hash"}}]}},{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EpochWithRotation"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Epoch"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"rotationEvents"},"name":{"kind":"Name","value":"rotationEventsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventWithBlock"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestEpochsQuery, GetLatestEpochsQueryVariables>;
export const GetLatestBlocksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestBlocks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"defaultValue":{"kind":"IntValue","value":"10"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"latestBlocks"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockListBlock"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockListBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Block"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestBlocksQuery, GetLatestBlocksQueryVariables>;
export const GetValidatorsTotalRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorsTotalRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validators"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"VALIDATOR"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validators"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"authority"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"cfeVersionId"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorsTotalRewardsQuery, GetValidatorsTotalRewardsQueryVariables>;
export const GetValidatorsAggregatedStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorsAggregatedStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validators"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totalRewards"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validators"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"totalSlashed"},"name":{"kind":"Name","value":"allAccountFundingEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validators"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorsAggregatedStatsQuery, GetValidatorsAggregatedStatsQueryVariables>;
export const AuthorshipDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthorshipData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"validatorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"lastBlock"},"name":{"kind":"Name","value":"allBlocks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"allOperatorEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"2"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"operatorEpochValidatorsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"authorshipPenalties"},"name":{"kind":"Name","value":"allPenalties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"validatorIds"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"blockByBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startTime"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"reason"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"StringValue","value":"MissedAuthorshipSlot","block":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<AuthorshipDataQuery, AuthorshipDataQueryVariables>;
export const GetOperatorEpochsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorEpochs"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOperatorEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"operatorLossAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorLossValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"operatorEpochValidatorsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"numberOfNodes"},"name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"validatorId"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"operatorEpochDelegationsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"losses"}},{"kind":"Field","name":{"kind":"Name","value":"lossesValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorEpochsQuery, GetOperatorEpochsQueryVariables>;
export const GetValidatorAuthorityMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorAuthorityMemberships"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochByEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochIds"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByValidatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"totalRewards"},"name":{"kind":"Name","value":"reward"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"slashedEvents"},"name":{"kind":"Name","value":"accountFundingEventsByEpochId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"validatorByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"ids"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"agg"},"name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorAuthorityMembershipsQuery, GetValidatorAuthorityMembershipsQueryVariables>;
export const GetWhitelistBlacklistTimestampDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetWhitelistBlacklistTimestamp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegatorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OperatorActionType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegatorIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"actions"},"name":{"kind":"Name","value":"operatorActionsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorId"}}}]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetWhitelistBlacklistTimestampQuery, GetWhitelistBlacklistTimestampQueryVariables>;
export const GetEvmStateChainCallByTxHashDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEvmStateChainCallByTxHash"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"txHash"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"call"},"name":{"kind":"Name","value":"evmStateChainCallByTxHash"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"txHash"},"value":{"kind":"Variable","name":{"kind":"Name","value":"txHash"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","alias":{"kind":"Name","value":"error"},"name":{"kind":"Name","value":"stateChainErrorByStateChainErrorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"docs"}}]}}]}}]}}]} as unknown as DocumentNode<GetEvmStateChainCallByTxHashQuery, GetEvmStateChainCallByTxHashQueryVariables>;
export const GetAuthorityCfeVersionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthorityCfeVersions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epochs"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"memberships"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"cfeVersion"},"name":{"kind":"Name","value":"cfeVersionId"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorityCfeVersionsQuery, GetAuthorityCfeVersionsQueryVariables>;
export const GetPenaltiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPenalties"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PenaltyFilter"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PenaltiesOrderBy"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"penalties"},"name":{"kind":"Name","value":"allPenalties"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Penalty"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Penalty"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Penalty"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]} as unknown as DocumentNode<GetPenaltiesQuery, GetPenaltiesQueryVariables>;
export const GetDelegationActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"txHash"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"indexInBlock"}},{"kind":"Field","name":{"kind":"Name","value":"blockId"}},{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetDelegationActivityQuery, GetDelegationActivityQueryVariables>;
export const CheckForActivityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CheckForActivity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activity"},"name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<CheckForActivityQuery, CheckForActivityQueryVariables>;
export const GetDelegationHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allOperatorEpochDelegations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"delegator"},"name":{"kind":"Name","value":"accountByDelegatorAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpoch"},"name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"operatorByOperatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<GetDelegationHistoryQuery, GetDelegationHistoryQueryVariables>;
export const GetEpochHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEpochHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"EpochFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"epochs"},"name":{"kind":"Name","value":"allEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"totalBonded"}},{"kind":"Field","alias":{"kind":"Name","value":"startBlock"},"name":{"kind":"Name","value":"blockByStartBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"endBlock"},"name":{"kind":"Name","value":"blockByEndBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validatorRewards"},"name":{"kind":"Name","value":"authorityMembershipsByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"operatorEpochesByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardValueUsd"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"delegatorRewards"},"name":{"kind":"Name","value":"operatorEpochDelegationsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetEpochHistoryQuery, GetEpochHistoryQueryVariables>;
export const GetOperatorTotalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorTotals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"allOperatorEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reward"},"name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"rewardValueUsd"},"name":{"kind":"Name","value":"operatorRewardValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"loss"},"name":{"kind":"Name","value":"operatorLossAmount"}},{"kind":"Field","alias":{"kind":"Name","value":"lossValueUsd"},"name":{"kind":"Name","value":"operatorLossValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochValidatorByAuthorityMembershipId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"loss"}},{"kind":"Field","name":{"kind":"Name","value":"lossValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegators"},"name":{"kind":"Name","value":"allOperatorEpochDelegations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"reward"},"name":{"kind":"Name","value":"rewards"}},{"kind":"Field","alias":{"kind":"Name","value":"rewardValueUsd"},"name":{"kind":"Name","value":"rewardsValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"loss"},"name":{"kind":"Name","value":"losses"}},{"kind":"Field","alias":{"kind":"Name","value":"lossValueUsd"},"name":{"kind":"Name","value":"lossesValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorTotalsQuery, GetOperatorTotalsQueryVariables>;
export const GetOperatorEpochValidatorsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorEpochValidators"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochValidators"},"name":{"kind":"Name","value":"allOperatorEpochValidators"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorEpochValidatorsQuery, GetOperatorEpochValidatorsQueryVariables>;
export const GetOperatorEpochsHistoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorEpochsHistory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"operatorEpochs"},"name":{"kind":"Name","value":"allOperatorEpoches"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epochId"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"operatorLossAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorLossValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"stakedAmount"}},{"kind":"Field","name":{"kind":"Name","value":"stakedValueUsd"}},{"kind":"Field","alias":{"kind":"Name","value":"epoch"},"name":{"kind":"Name","value":"epochByEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bond"}},{"kind":"Field","name":{"kind":"Name","value":"startBlockId"}},{"kind":"Field","name":{"kind":"Name","value":"endBlockId"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"validators"},"name":{"kind":"Name","value":"operatorEpochValidatorsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"membership"},"name":{"kind":"Name","value":"authorityMembershipByAuthorityMembershipId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"loss"}},{"kind":"Field","name":{"kind":"Name","value":"lossValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"operatorEpochDelegationsByOperatorEpochId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}},{"kind":"Field","name":{"kind":"Name","value":"losses"}},{"kind":"Field","name":{"kind":"Name","value":"lossesValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorEpochsHistoryQuery, GetOperatorEpochsHistoryQueryVariables>;
export const GetOperatorDelegatorDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorDelegatorDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegatorIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegatorIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"operatorEpochDelegationsByDelegatorAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegatedSince"},"name":{"kind":"Name","value":"delegationActivitiesByDelegatorAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"DELEGATE"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorDelegatorDetailsQuery, GetOperatorDelegatorDetailsQueryVariables>;
export const GetOperatorListedAccountsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOperatorListedAccounts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OperatorActionType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"withRewards"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"listedSince"},"name":{"kind":"Name","value":"operatorActionsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EVENT_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegations"},"name":{"kind":"Name","value":"operatorEpochDelegationsByDelegatorAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorEpochByOperatorEpochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"operatorByOperatorId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"operatorIdSs58"}}}]}}]}}]}}]}}]}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"include"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"if"},"value":{"kind":"Variable","name":{"kind":"Name","value":"withRewards"}}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetOperatorListedAccountsQuery, GetOperatorListedAccountsQueryVariables>;
export const GetAuthorityTotalRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthorityTotalRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"all"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthorityTotalRewardsQuery, GetAuthorityTotalRewardsQueryVariables>;
export const GetDelegationRewardsSinceDaysAgoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDelegationRewardsSinceDaysAgo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Datetime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"rewards"},"name":{"kind":"Name","value":"allDelegationActivities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"accountByDelegatorAccountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"delegationIdSs58"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"REWARD"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"eventByEventId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"blockByBlockId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"timestamp"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"greaterThanOrEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}}]}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"valueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetDelegationRewardsSinceDaysAgoQuery, GetDelegationRewardsSinceDaysAgoQueryVariables>;
export const GetNetworkTotalEverRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetNetworkTotalEverRewards"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"authority"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"delegator"},"name":{"kind":"Name","value":"allOperatorEpochDelegations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rewards"}},{"kind":"Field","name":{"kind":"Name","value":"rewardsValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"operator"},"name":{"kind":"Name","value":"allOperatorEpoches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operatorRewardAmount"}},{"kind":"Field","name":{"kind":"Name","value":"operatorRewardValueUsd"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetNetworkTotalEverRewardsQuery, GetNetworkTotalEverRewardsQueryVariables>;
export const GetLatestAuthoritySetDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLatestAuthoritySet"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"currentAuthoritySet"},"name":{"kind":"Name","value":"allAuthorityMemberships"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epochId"}}]}}]}}]}}]} as unknown as DocumentNode<GetLatestAuthoritySetQuery, GetLatestAuthoritySetQueryVariables>;
export const GetFundedAccountIdsByFunderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFundedAccountIdsByFunder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"allAccountFundingEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"fundedFunder"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalToInsensitive"},"value":{"kind":"Variable","name":{"kind":"Name","value":"walletAddress"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"FUNDED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accountId"}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetFundedAccountIdsByFunderQuery, GetFundedAccountIdsByFunderQueryVariables>;
export const GetRedemptionsByAccountIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetRedemptionsByAccountIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"events"},"name":{"kind":"Name","value":"allAccountFundingEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"REDEEMED"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"accountId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accountIds"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RedeemedEvent"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RedeemedEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccountFundingEvent"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"redeemedTxHash"}},{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","name":{"kind":"Name","value":"alias"}}]}}]}}]} as unknown as DocumentNode<GetRedemptionsByAccountIdsQuery, GetRedemptionsByAccountIdsQueryVariables>;
export const GetAccountsRewardsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountsRewards"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"historicRewards"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"notEqualTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentRewards"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountsRewardsQuery, GetAccountsRewardsQueryVariables>;
export const GetAccountsSlashedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccountsSlashed"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"slashedEvents"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentEpochslashedEvents"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"EnumValue","value":"SLASHED"}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equalTo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAccountsSlashedQuery, GetAccountsSlashedQueryVariables>;
export const GetAllValidatorFundingDatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllValidatorFundingDates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"firstFunding"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_ASC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FUNDED"},{"kind":"EnumValue","value":"FUNDED_ON_CHAIN"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestFunding"},"name":{"kind":"Name","value":"accountFundingEventsByAccountId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"FUNDED"},{"kind":"EnumValue","value":"FUNDED_ON_CHAIN"}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"event"},"name":{"kind":"Name","value":"eventByEventId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"block"},"name":{"kind":"Name","value":"blockByBlockId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetAllValidatorFundingDatesQuery, GetAllValidatorFundingDatesQueryVariables>;
export const GetValidatorCfeVersionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorCfeVersion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfeVersionId"}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorCfeVersionQuery, GetValidatorCfeVersionQueryVariables>;
export const GetValidatorProcessorIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorProcessorIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorProcessorIdsQuery, GetValidatorProcessorIdsQueryVariables>;
export const GetValidatorsListDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorsListDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"accounts"},"name":{"kind":"Name","value":"allAccounts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"role"},"value":{"kind":"EnumValue","value":"VALIDATOR"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58s"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"idSs58"}},{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"authorityMemberships"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"currentEpochMembership"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"condition"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"epochId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"epochId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorsListDetailsQuery, GetValidatorsListDetailsQueryVariables>;
export const GetValidatorStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetValidatorStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"account"},"name":{"kind":"Name","value":"accountByIdSs58"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idSs58"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idSs58"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"validator"},"name":{"kind":"Name","value":"validatorByAccountId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cfeVersionId"}},{"kind":"Field","alias":{"kind":"Name","value":"rewards"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sum"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reward"}},{"kind":"Field","name":{"kind":"Name","value":"rewardValueUsd"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"latestMembership"},"name":{"kind":"Name","value":"authorityMembershipsByValidatorId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"EnumValue","value":"EPOCH_ID_DESC"}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"epochId"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetValidatorStatsQuery, GetValidatorStatsQueryVariables>;